(function() {
    const e = document.createElement("link").relList;
    if (e && e.supports && e.supports("modulepreload"))
        return;
    for (const o of document.querySelectorAll('link[rel="modulepreload"]'))
        a(o);
    new MutationObserver(o => {
        for (const l of o)
            if (l.type === "childList")
                for (const u of l.addedNodes)
                    u.tagName === "LINK" && u.rel === "modulepreload" && a(u)
    }
    ).observe(document, {
        childList: !0,
        subtree: !0
    });
    function r(o) {
        const l = {};
        return o.integrity && (l.integrity = o.integrity),
        o.referrerPolicy && (l.referrerPolicy = o.referrerPolicy),
        o.crossOrigin === "use-credentials" ? l.credentials = "include" : o.crossOrigin === "anonymous" ? l.credentials = "omit" : l.credentials = "same-origin",
        l
    }
    function a(o) {
        if (o.ep)
            return;
        o.ep = !0;
        const l = r(o);
        fetch(o.href, l)
    }
}
)();
function Ey(i) {
    return i && i.__esModule && Object.prototype.hasOwnProperty.call(i, "default") ? i.default : i
}
var Rl = {
    exports: {}
}
  , Tn = {}
  , Bl = {
    exports: {}
}
  , ge = {};
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var gm;
function Dy() {
    if (gm)
        return ge;
    gm = 1;
    var i = Symbol.for("react.element")
      , e = Symbol.for("react.portal")
      , r = Symbol.for("react.fragment")
      , a = Symbol.for("react.strict_mode")
      , o = Symbol.for("react.profiler")
      , l = Symbol.for("react.provider")
      , u = Symbol.for("react.context")
      , d = Symbol.for("react.forward_ref")
      , p = Symbol.for("react.suspense")
      , h = Symbol.for("react.memo")
      , g = Symbol.for("react.lazy")
      , v = Symbol.iterator;
    function y(I) {
        return I === null || typeof I != "object" ? null : (I = v && I[v] || I["@@iterator"],
        typeof I == "function" ? I : null)
    }
    var P = {
        isMounted: function() {
            return !1
        },
        enqueueForceUpdate: function() {},
        enqueueReplaceState: function() {},
        enqueueSetState: function() {}
    }
      , w = Object.assign
      , S = {};
    function z(I, U, fe) {
        this.props = I,
        this.context = U,
        this.refs = S,
        this.updater = fe || P
    }
    z.prototype.isReactComponent = {},
    z.prototype.setState = function(I, U) {
        if (typeof I != "object" && typeof I != "function" && I != null)
            throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
        this.updater.enqueueSetState(this, I, U, "setState")
    }
    ,
    z.prototype.forceUpdate = function(I) {
        this.updater.enqueueForceUpdate(this, I, "forceUpdate")
    }
    ;
    function C() {}
    C.prototype = z.prototype;
    function b(I, U, fe) {
        this.props = I,
        this.context = U,
        this.refs = S,
        this.updater = fe || P
    }
    var T = b.prototype = new C;
    T.constructor = b,
    w(T, z.prototype),
    T.isPureReactComponent = !0;
    var D = Array.isArray
      , M = Object.prototype.hasOwnProperty
      , B = {
        current: null
    }
      , _ = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
    };
    function F(I, U, fe) {
        var ve, ke = {}, xe = null, Se = null;
        if (U != null)
            for (ve in U.ref !== void 0 && (Se = U.ref),
            U.key !== void 0 && (xe = "" + U.key),
            U)
                M.call(U, ve) && !_.hasOwnProperty(ve) && (ke[ve] = U[ve]);
        var Pe = arguments.length - 2;
        if (Pe === 1)
            ke.children = fe;
        else if (1 < Pe) {
            for (var Ae = Array(Pe), mt = 0; mt < Pe; mt++)
                Ae[mt] = arguments[mt + 2];
            ke.children = Ae
        }
        if (I && I.defaultProps)
            for (ve in Pe = I.defaultProps,
            Pe)
                ke[ve] === void 0 && (ke[ve] = Pe[ve]);
        return {
            $$typeof: i,
            type: I,
            key: xe,
            ref: Se,
            props: ke,
            _owner: B.current
        }
    }
    function R(I, U) {
        return {
            $$typeof: i,
            type: I.type,
            key: U,
            ref: I.ref,
            props: I.props,
            _owner: I._owner
        }
    }
    function W(I) {
        return typeof I == "object" && I !== null && I.$$typeof === i
    }
    function K(I) {
        var U = {
            "=": "=0",
            ":": "=2"
        };
        return "$" + I.replace(/[=:]/g, function(fe) {
            return U[fe]
        })
    }
    var Q = /\/+/g;
    function se(I, U) {
        return typeof I == "object" && I !== null && I.key != null ? K("" + I.key) : U.toString(36)
    }
    function le(I, U, fe, ve, ke) {
        var xe = typeof I;
        (xe === "undefined" || xe === "boolean") && (I = null);
        var Se = !1;
        if (I === null)
            Se = !0;
        else
            switch (xe) {
            case "string":
            case "number":
                Se = !0;
                break;
            case "object":
                switch (I.$$typeof) {
                case i:
                case e:
                    Se = !0
                }
            }
        if (Se)
            return Se = I,
            ke = ke(Se),
            I = ve === "" ? "." + se(Se, 0) : ve,
            D(ke) ? (fe = "",
            I != null && (fe = I.replace(Q, "$&/") + "/"),
            le(ke, U, fe, "", function(mt) {
                return mt
            })) : ke != null && (W(ke) && (ke = R(ke, fe + (!ke.key || Se && Se.key === ke.key ? "" : ("" + ke.key).replace(Q, "$&/") + "/") + I)),
            U.push(ke)),
            1;
        if (Se = 0,
        ve = ve === "" ? "." : ve + ":",
        D(I))
            for (var Pe = 0; Pe < I.length; Pe++) {
                xe = I[Pe];
                var Ae = ve + se(xe, Pe);
                Se += le(xe, U, fe, Ae, ke)
            }
        else if (Ae = y(I),
        typeof Ae == "function")
            for (I = Ae.call(I),
            Pe = 0; !(xe = I.next()).done; )
                xe = xe.value,
                Ae = ve + se(xe, Pe++),
                Se += le(xe, U, fe, Ae, ke);
        else if (xe === "object")
            throw U = String(I),
            Error("Objects are not valid as a React child (found: " + (U === "[object Object]" ? "object with keys {" + Object.keys(I).join(", ") + "}" : U) + "). If you meant to render a collection of children, use an array instead.");
        return Se
    }
    function pe(I, U, fe) {
        if (I == null)
            return I;
        var ve = []
          , ke = 0;
        return le(I, ve, "", "", function(xe) {
            return U.call(fe, xe, ke++)
        }),
        ve
    }
    function ie(I) {
        if (I._status === -1) {
            var U = I._result;
            U = U(),
            U.then(function(fe) {
                (I._status === 0 || I._status === -1) && (I._status = 1,
                I._result = fe)
            }, function(fe) {
                (I._status === 0 || I._status === -1) && (I._status = 2,
                I._result = fe)
            }),
            I._status === -1 && (I._status = 0,
            I._result = U)
        }
        if (I._status === 1)
            return I._result.default;
        throw I._result
    }
    var ne = {
        current: null
    }
      , H = {
        transition: null
    }
      , X = {
        ReactCurrentDispatcher: ne,
        ReactCurrentBatchConfig: H,
        ReactCurrentOwner: B
    };
    function Z() {
        throw Error("act(...) is not supported in production builds of React.")
    }
    return ge.Children = {
        map: pe,
        forEach: function(I, U, fe) {
            pe(I, function() {
                U.apply(this, arguments)
            }, fe)
        },
        count: function(I) {
            var U = 0;
            return pe(I, function() {
                U++
            }),
            U
        },
        toArray: function(I) {
            return pe(I, function(U) {
                return U
            }) || []
        },
        only: function(I) {
            if (!W(I))
                throw Error("React.Children.only expected to receive a single React element child.");
            return I
        }
    },
    ge.Component = z,
    ge.Fragment = r,
    ge.Profiler = o,
    ge.PureComponent = b,
    ge.StrictMode = a,
    ge.Suspense = p,
    ge.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = X,
    ge.act = Z,
    ge.cloneElement = function(I, U, fe) {
        if (I == null)
            throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + I + ".");
        var ve = w({}, I.props)
          , ke = I.key
          , xe = I.ref
          , Se = I._owner;
        if (U != null) {
            if (U.ref !== void 0 && (xe = U.ref,
            Se = B.current),
            U.key !== void 0 && (ke = "" + U.key),
            I.type && I.type.defaultProps)
                var Pe = I.type.defaultProps;
            for (Ae in U)
                M.call(U, Ae) && !_.hasOwnProperty(Ae) && (ve[Ae] = U[Ae] === void 0 && Pe !== void 0 ? Pe[Ae] : U[Ae])
        }
        var Ae = arguments.length - 2;
        if (Ae === 1)
            ve.children = fe;
        else if (1 < Ae) {
            Pe = Array(Ae);
            for (var mt = 0; mt < Ae; mt++)
                Pe[mt] = arguments[mt + 2];
            ve.children = Pe
        }
        return {
            $$typeof: i,
            type: I.type,
            key: ke,
            ref: xe,
            props: ve,
            _owner: Se
        }
    }
    ,
    ge.createContext = function(I) {
        return I = {
            $$typeof: u,
            _currentValue: I,
            _currentValue2: I,
            _threadCount: 0,
            Provider: null,
            Consumer: null,
            _defaultValue: null,
            _globalName: null
        },
        I.Provider = {
            $$typeof: l,
            _context: I
        },
        I.Consumer = I
    }
    ,
    ge.createElement = F,
    ge.createFactory = function(I) {
        var U = F.bind(null, I);
        return U.type = I,
        U
    }
    ,
    ge.createRef = function() {
        return {
            current: null
        }
    }
    ,
    ge.forwardRef = function(I) {
        return {
            $$typeof: d,
            render: I
        }
    }
    ,
    ge.isValidElement = W,
    ge.lazy = function(I) {
        return {
            $$typeof: g,
            _payload: {
                _status: -1,
                _result: I
            },
            _init: ie
        }
    }
    ,
    ge.memo = function(I, U) {
        return {
            $$typeof: h,
            type: I,
            compare: U === void 0 ? null : U
        }
    }
    ,
    ge.startTransition = function(I) {
        var U = H.transition;
        H.transition = {};
        try {
            I()
        } finally {
            H.transition = U
        }
    }
    ,
    ge.unstable_act = Z,
    ge.useCallback = function(I, U) {
        return ne.current.useCallback(I, U)
    }
    ,
    ge.useContext = function(I) {
        return ne.current.useContext(I)
    }
    ,
    ge.useDebugValue = function() {}
    ,
    ge.useDeferredValue = function(I) {
        return ne.current.useDeferredValue(I)
    }
    ,
    ge.useEffect = function(I, U) {
        return ne.current.useEffect(I, U)
    }
    ,
    ge.useId = function() {
        return ne.current.useId()
    }
    ,
    ge.useImperativeHandle = function(I, U, fe) {
        return ne.current.useImperativeHandle(I, U, fe)
    }
    ,
    ge.useInsertionEffect = function(I, U) {
        return ne.current.useInsertionEffect(I, U)
    }
    ,
    ge.useLayoutEffect = function(I, U) {
        return ne.current.useLayoutEffect(I, U)
    }
    ,
    ge.useMemo = function(I, U) {
        return ne.current.useMemo(I, U)
    }
    ,
    ge.useReducer = function(I, U, fe) {
        return ne.current.useReducer(I, U, fe)
    }
    ,
    ge.useRef = function(I) {
        return ne.current.useRef(I)
    }
    ,
    ge.useState = function(I) {
        return ne.current.useState(I)
    }
    ,
    ge.useSyncExternalStore = function(I, U, fe) {
        return ne.current.useSyncExternalStore(I, U, fe)
    }
    ,
    ge.useTransition = function() {
        return ne.current.useTransition()
    }
    ,
    ge.version = "18.3.1",
    ge
}
var vm;
function Nc() {
    return vm || (vm = 1,
    Bl.exports = Dy()),
    Bl.exports
}
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ym;
function Iy() {
    if (ym)
        return Tn;
    ym = 1;
    var i = Nc()
      , e = Symbol.for("react.element")
      , r = Symbol.for("react.fragment")
      , a = Object.prototype.hasOwnProperty
      , o = i.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner
      , l = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
    };
    function u(d, p, h) {
        var g, v = {}, y = null, P = null;
        h !== void 0 && (y = "" + h),
        p.key !== void 0 && (y = "" + p.key),
        p.ref !== void 0 && (P = p.ref);
        for (g in p)
            a.call(p, g) && !l.hasOwnProperty(g) && (v[g] = p[g]);
        if (d && d.defaultProps)
            for (g in p = d.defaultProps,
            p)
                v[g] === void 0 && (v[g] = p[g]);
        return {
            $$typeof: e,
            type: d,
            key: y,
            ref: P,
            props: v,
            _owner: o.current
        }
    }
    return Tn.Fragment = r,
    Tn.jsx = u,
    Tn.jsxs = u,
    Tn
}
var km;
function My() {
    return km || (km = 1,
    Rl.exports = Iy()),
    Rl.exports
}
var x = My()
  , N = Nc();
const Me = Ey(N);
var ss = {}
  , Wl = {
    exports: {}
}
  , pt = {}
  , _l = {
    exports: {}
}
  , Ul = {};
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var xm;
function Vy() {
    return xm || (xm = 1,
    (function(i) {
        function e(H, X) {
            var Z = H.length;
            H.push(X);
            e: for (; 0 < Z; ) {
                var I = Z - 1 >>> 1
                  , U = H[I];
                if (0 < o(U, X))
                    H[I] = X,
                    H[Z] = U,
                    Z = I;
                else
                    break e
            }
        }
        function r(H) {
            return H.length === 0 ? null : H[0]
        }
        function a(H) {
            if (H.length === 0)
                return null;
            var X = H[0]
              , Z = H.pop();
            if (Z !== X) {
                H[0] = Z;
                e: for (var I = 0, U = H.length, fe = U >>> 1; I < fe; ) {
                    var ve = 2 * (I + 1) - 1
                      , ke = H[ve]
                      , xe = ve + 1
                      , Se = H[xe];
                    if (0 > o(ke, Z))
                        xe < U && 0 > o(Se, ke) ? (H[I] = Se,
                        H[xe] = Z,
                        I = xe) : (H[I] = ke,
                        H[ve] = Z,
                        I = ve);
                    else if (xe < U && 0 > o(Se, Z))
                        H[I] = Se,
                        H[xe] = Z,
                        I = xe;
                    else
                        break e
                }
            }
            return X
        }
        function o(H, X) {
            var Z = H.sortIndex - X.sortIndex;
            return Z !== 0 ? Z : H.id - X.id
        }
        if (typeof performance == "object" && typeof performance.now == "function") {
            var l = performance;
            i.unstable_now = function() {
                return l.now()
            }
        } else {
            var u = Date
              , d = u.now();
            i.unstable_now = function() {
                return u.now() - d
            }
        }
        var p = []
          , h = []
          , g = 1
          , v = null
          , y = 3
          , P = !1
          , w = !1
          , S = !1
          , z = typeof setTimeout == "function" ? setTimeout : null
          , C = typeof clearTimeout == "function" ? clearTimeout : null
          , b = typeof setImmediate < "u" ? setImmediate : null;
        typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
        function T(H) {
            for (var X = r(h); X !== null; ) {
                if (X.callback === null)
                    a(h);
                else if (X.startTime <= H)
                    a(h),
                    X.sortIndex = X.expirationTime,
                    e(p, X);
                else
                    break;
                X = r(h)
            }
        }
        function D(H) {
            if (S = !1,
            T(H),
            !w)
                if (r(p) !== null)
                    w = !0,
                    ie(M);
                else {
                    var X = r(h);
                    X !== null && ne(D, X.startTime - H)
                }
        }
        function M(H, X) {
            w = !1,
            S && (S = !1,
            C(F),
            F = -1),
            P = !0;
            var Z = y;
            try {
                for (T(X),
                v = r(p); v !== null && (!(v.expirationTime > X) || H && !K()); ) {
                    var I = v.callback;
                    if (typeof I == "function") {
                        v.callback = null,
                        y = v.priorityLevel;
                        var U = I(v.expirationTime <= X);
                        X = i.unstable_now(),
                        typeof U == "function" ? v.callback = U : v === r(p) && a(p),
                        T(X)
                    } else
                        a(p);
                    v = r(p)
                }
                if (v !== null)
                    var fe = !0;
                else {
                    var ve = r(h);
                    ve !== null && ne(D, ve.startTime - X),
                    fe = !1
                }
                return fe
            } finally {
                v = null,
                y = Z,
                P = !1
            }
        }
        var B = !1
          , _ = null
          , F = -1
          , R = 5
          , W = -1;
        function K() {
            return !(i.unstable_now() - W < R)
        }
        function Q() {
            if (_ !== null) {
                var H = i.unstable_now();
                W = H;
                var X = !0;
                try {
                    X = _(!0, H)
                } finally {
                    X ? se() : (B = !1,
                    _ = null)
                }
            } else
                B = !1
        }
        var se;
        if (typeof b == "function")
            se = function() {
                b(Q)
            }
            ;
        else if (typeof MessageChannel < "u") {
            var le = new MessageChannel
              , pe = le.port2;
            le.port1.onmessage = Q,
            se = function() {
                pe.postMessage(null)
            }
        } else
            se = function() {
                z(Q, 0)
            }
            ;
        function ie(H) {
            _ = H,
            B || (B = !0,
            se())
        }
        function ne(H, X) {
            F = z(function() {
                H(i.unstable_now())
            }, X)
        }
        i.unstable_IdlePriority = 5,
        i.unstable_ImmediatePriority = 1,
        i.unstable_LowPriority = 4,
        i.unstable_NormalPriority = 3,
        i.unstable_Profiling = null,
        i.unstable_UserBlockingPriority = 2,
        i.unstable_cancelCallback = function(H) {
            H.callback = null
        }
        ,
        i.unstable_continueExecution = function() {
            w || P || (w = !0,
            ie(M))
        }
        ,
        i.unstable_forceFrameRate = function(H) {
            0 > H || 125 < H ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : R = 0 < H ? Math.floor(1e3 / H) : 5
        }
        ,
        i.unstable_getCurrentPriorityLevel = function() {
            return y
        }
        ,
        i.unstable_getFirstCallbackNode = function() {
            return r(p)
        }
        ,
        i.unstable_next = function(H) {
            switch (y) {
            case 1:
            case 2:
            case 3:
                var X = 3;
                break;
            default:
                X = y
            }
            var Z = y;
            y = X;
            try {
                return H()
            } finally {
                y = Z
            }
        }
        ,
        i.unstable_pauseExecution = function() {}
        ,
        i.unstable_requestPaint = function() {}
        ,
        i.unstable_runWithPriority = function(H, X) {
            switch (H) {
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            default:
                H = 3
            }
            var Z = y;
            y = H;
            try {
                return X()
            } finally {
                y = Z
            }
        }
        ,
        i.unstable_scheduleCallback = function(H, X, Z) {
            var I = i.unstable_now();
            switch (typeof Z == "object" && Z !== null ? (Z = Z.delay,
            Z = typeof Z == "number" && 0 < Z ? I + Z : I) : Z = I,
            H) {
            case 1:
                var U = -1;
                break;
            case 2:
                U = 250;
                break;
            case 5:
                U = 1073741823;
                break;
            case 4:
                U = 1e4;
                break;
            default:
                U = 5e3
            }
            return U = Z + U,
            H = {
                id: g++,
                callback: X,
                priorityLevel: H,
                startTime: Z,
                expirationTime: U,
                sortIndex: -1
            },
            Z > I ? (H.sortIndex = Z,
            e(h, H),
            r(p) === null && H === r(h) && (S ? (C(F),
            F = -1) : S = !0,
            ne(D, Z - I))) : (H.sortIndex = U,
            e(p, H),
            w || P || (w = !0,
            ie(M))),
            H
        }
        ,
        i.unstable_shouldYield = K,
        i.unstable_wrapCallback = function(H) {
            var X = y;
            return function() {
                var Z = y;
                y = X;
                try {
                    return H.apply(this, arguments)
                } finally {
                    y = Z
                }
            }
        }
    }
    )(Ul)),
    Ul
}
var wm;
function Ly() {
    return wm || (wm = 1,
    _l.exports = Vy()),
    _l.exports
}
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Pm;
function Oy() {
    if (Pm)
        return pt;
    Pm = 1;
    var i = Nc()
      , e = Ly();
    function r(t) {
        for (var n = "https://reactjs.org/docs/error-decoder.html?invariant=" + t, s = 1; s < arguments.length; s++)
            n += "&args[]=" + encodeURIComponent(arguments[s]);
        return "Minified React error #" + t + "; visit " + n + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings."
    }
    var a = new Set
      , o = {};
    function l(t, n) {
        u(t, n),
        u(t + "Capture", n)
    }
    function u(t, n) {
        for (o[t] = n,
        t = 0; t < n.length; t++)
            a.add(n[t])
    }
    var d = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u")
      , p = Object.prototype.hasOwnProperty
      , h = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/
      , g = {}
      , v = {};
    function y(t) {
        return p.call(v, t) ? !0 : p.call(g, t) ? !1 : h.test(t) ? v[t] = !0 : (g[t] = !0,
        !1)
    }
    function P(t, n, s, c) {
        if (s !== null && s.type === 0)
            return !1;
        switch (typeof n) {
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            return c ? !1 : s !== null ? !s.acceptsBooleans : (t = t.toLowerCase().slice(0, 5),
            t !== "data-" && t !== "aria-");
        default:
            return !1
        }
    }
    function w(t, n, s, c) {
        if (n === null || typeof n > "u" || P(t, n, s, c))
            return !0;
        if (c)
            return !1;
        if (s !== null)
            switch (s.type) {
            case 3:
                return !n;
            case 4:
                return n === !1;
            case 5:
                return isNaN(n);
            case 6:
                return isNaN(n) || 1 > n
            }
        return !1
    }
    function S(t, n, s, c, m, f, k) {
        this.acceptsBooleans = n === 2 || n === 3 || n === 4,
        this.attributeName = c,
        this.attributeNamespace = m,
        this.mustUseProperty = s,
        this.propertyName = t,
        this.type = n,
        this.sanitizeURL = f,
        this.removeEmptyString = k
    }
    var z = {};
    "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(t) {
        z[t] = new S(t,0,!1,t,null,!1,!1)
    }),
    [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(t) {
        var n = t[0];
        z[n] = new S(n,1,!1,t[1],null,!1,!1)
    }),
    ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(t) {
        z[t] = new S(t,2,!1,t.toLowerCase(),null,!1,!1)
    }),
    ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(t) {
        z[t] = new S(t,2,!1,t,null,!1,!1)
    }),
    "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(t) {
        z[t] = new S(t,3,!1,t.toLowerCase(),null,!1,!1)
    }),
    ["checked", "multiple", "muted", "selected"].forEach(function(t) {
        z[t] = new S(t,3,!0,t,null,!1,!1)
    }),
    ["capture", "download"].forEach(function(t) {
        z[t] = new S(t,4,!1,t,null,!1,!1)
    }),
    ["cols", "rows", "size", "span"].forEach(function(t) {
        z[t] = new S(t,6,!1,t,null,!1,!1)
    }),
    ["rowSpan", "start"].forEach(function(t) {
        z[t] = new S(t,5,!1,t.toLowerCase(),null,!1,!1)
    });
    var C = /[\-:]([a-z])/g;
    function b(t) {
        return t[1].toUpperCase()
    }
    "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(t) {
        var n = t.replace(C, b);
        z[n] = new S(n,1,!1,t,null,!1,!1)
    }),
    "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(t) {
        var n = t.replace(C, b);
        z[n] = new S(n,1,!1,t,"http://www.w3.org/1999/xlink",!1,!1)
    }),
    ["xml:base", "xml:lang", "xml:space"].forEach(function(t) {
        var n = t.replace(C, b);
        z[n] = new S(n,1,!1,t,"http://www.w3.org/XML/1998/namespace",!1,!1)
    }),
    ["tabIndex", "crossOrigin"].forEach(function(t) {
        z[t] = new S(t,1,!1,t.toLowerCase(),null,!1,!1)
    }),
    z.xlinkHref = new S("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0,!1),
    ["src", "href", "action", "formAction"].forEach(function(t) {
        z[t] = new S(t,1,!1,t.toLowerCase(),null,!0,!0)
    });
    function T(t, n, s, c) {
        var m = z.hasOwnProperty(n) ? z[n] : null;
        (m !== null ? m.type !== 0 : c || !(2 < n.length) || n[0] !== "o" && n[0] !== "O" || n[1] !== "n" && n[1] !== "N") && (w(n, s, m, c) && (s = null),
        c || m === null ? y(n) && (s === null ? t.removeAttribute(n) : t.setAttribute(n, "" + s)) : m.mustUseProperty ? t[m.propertyName] = s === null ? m.type === 3 ? !1 : "" : s : (n = m.attributeName,
        c = m.attributeNamespace,
        s === null ? t.removeAttribute(n) : (m = m.type,
        s = m === 3 || m === 4 && s === !0 ? "" : "" + s,
        c ? t.setAttributeNS(c, n, s) : t.setAttribute(n, s))))
    }
    var D = i.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED
      , M = Symbol.for("react.element")
      , B = Symbol.for("react.portal")
      , _ = Symbol.for("react.fragment")
      , F = Symbol.for("react.strict_mode")
      , R = Symbol.for("react.profiler")
      , W = Symbol.for("react.provider")
      , K = Symbol.for("react.context")
      , Q = Symbol.for("react.forward_ref")
      , se = Symbol.for("react.suspense")
      , le = Symbol.for("react.suspense_list")
      , pe = Symbol.for("react.memo")
      , ie = Symbol.for("react.lazy")
      , ne = Symbol.for("react.offscreen")
      , H = Symbol.iterator;
    function X(t) {
        return t === null || typeof t != "object" ? null : (t = H && t[H] || t["@@iterator"],
        typeof t == "function" ? t : null)
    }
    var Z = Object.assign, I;
    function U(t) {
        if (I === void 0)
            try {
                throw Error()
            } catch (s) {
                var n = s.stack.trim().match(/\n( *(at )?)/);
                I = n && n[1] || ""
            }
        return `
` + I + t
    }
    var fe = !1;
    function ve(t, n) {
        if (!t || fe)
            return "";
        fe = !0;
        var s = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        try {
            if (n)
                if (n = function() {
                    throw Error()
                }
                ,
                Object.defineProperty(n.prototype, "props", {
                    set: function() {
                        throw Error()
                    }
                }),
                typeof Reflect == "object" && Reflect.construct) {
                    try {
                        Reflect.construct(n, [])
                    } catch (O) {
                        var c = O
                    }
                    Reflect.construct(t, [], n)
                } else {
                    try {
                        n.call()
                    } catch (O) {
                        c = O
                    }
                    t.call(n.prototype)
                }
            else {
                try {
                    throw Error()
                } catch (O) {
                    c = O
                }
                t()
            }
        } catch (O) {
            if (O && c && typeof O.stack == "string") {
                for (var m = O.stack.split(`
`), f = c.stack.split(`
`), k = m.length - 1, j = f.length - 1; 1 <= k && 0 <= j && m[k] !== f[j]; )
                    j--;
                for (; 1 <= k && 0 <= j; k--,
                j--)
                    if (m[k] !== f[j]) {
                        if (k !== 1 || j !== 1)
                            do
                                if (k--,
                                j--,
                                0 > j || m[k] !== f[j]) {
                                    var A = `
` + m[k].replace(" at new ", " at ");
                                    return t.displayName && A.includes("<anonymous>") && (A = A.replace("<anonymous>", t.displayName)),
                                    A
                                }
                            while (1 <= k && 0 <= j);
                        break
                    }
            }
        } finally {
            fe = !1,
            Error.prepareStackTrace = s
        }
        return (t = t ? t.displayName || t.name : "") ? U(t) : ""
    }
    function ke(t) {
        switch (t.tag) {
        case 5:
            return U(t.type);
        case 16:
            return U("Lazy");
        case 13:
            return U("Suspense");
        case 19:
            return U("SuspenseList");
        case 0:
        case 2:
        case 15:
            return t = ve(t.type, !1),
            t;
        case 11:
            return t = ve(t.type.render, !1),
            t;
        case 1:
            return t = ve(t.type, !0),
            t;
        default:
            return ""
        }
    }
    function xe(t) {
        if (t == null)
            return null;
        if (typeof t == "function")
            return t.displayName || t.name || null;
        if (typeof t == "string")
            return t;
        switch (t) {
        case _:
            return "Fragment";
        case B:
            return "Portal";
        case R:
            return "Profiler";
        case F:
            return "StrictMode";
        case se:
            return "Suspense";
        case le:
            return "SuspenseList"
        }
        if (typeof t == "object")
            switch (t.$$typeof) {
            case K:
                return (t.displayName || "Context") + ".Consumer";
            case W:
                return (t._context.displayName || "Context") + ".Provider";
            case Q:
                var n = t.render;
                return t = t.displayName,
                t || (t = n.displayName || n.name || "",
                t = t !== "" ? "ForwardRef(" + t + ")" : "ForwardRef"),
                t;
            case pe:
                return n = t.displayName || null,
                n !== null ? n : xe(t.type) || "Memo";
            case ie:
                n = t._payload,
                t = t._init;
                try {
                    return xe(t(n))
                } catch {}
            }
        return null
    }
    function Se(t) {
        var n = t.type;
        switch (t.tag) {
        case 24:
            return "Cache";
        case 9:
            return (n.displayName || "Context") + ".Consumer";
        case 10:
            return (n._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return t = n.render,
            t = t.displayName || t.name || "",
            n.displayName || (t !== "" ? "ForwardRef(" + t + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return n;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return xe(n);
        case 8:
            return n === F ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if (typeof n == "function")
                return n.displayName || n.name || null;
            if (typeof n == "string")
                return n
        }
        return null
    }
    function Pe(t) {
        switch (typeof t) {
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return t;
        case "object":
            return t;
        default:
            return ""
        }
    }
    function Ae(t) {
        var n = t.type;
        return (t = t.nodeName) && t.toLowerCase() === "input" && (n === "checkbox" || n === "radio")
    }
    function mt(t) {
        var n = Ae(t) ? "checked" : "value"
          , s = Object.getOwnPropertyDescriptor(t.constructor.prototype, n)
          , c = "" + t[n];
        if (!t.hasOwnProperty(n) && typeof s < "u" && typeof s.get == "function" && typeof s.set == "function") {
            var m = s.get
              , f = s.set;
            return Object.defineProperty(t, n, {
                configurable: !0,
                get: function() {
                    return m.call(this)
                },
                set: function(k) {
                    c = "" + k,
                    f.call(this, k)
                }
            }),
            Object.defineProperty(t, n, {
                enumerable: s.enumerable
            }),
            {
                getValue: function() {
                    return c
                },
                setValue: function(k) {
                    c = "" + k
                },
                stopTracking: function() {
                    t._valueTracker = null,
                    delete t[n]
                }
            }
        }
    }
    function Zn(t) {
        t._valueTracker || (t._valueTracker = mt(t))
    }
    function Pu(t) {
        if (!t)
            return !1;
        var n = t._valueTracker;
        if (!n)
            return !0;
        var s = n.getValue()
          , c = "";
        return t && (c = Ae(t) ? t.checked ? "true" : "false" : t.value),
        t = c,
        t !== s ? (n.setValue(t),
        !0) : !1
    }
    function Yn(t) {
        if (t = t || (typeof document < "u" ? document : void 0),
        typeof t > "u")
            return null;
        try {
            return t.activeElement || t.body
        } catch {
            return t.body
        }
    }
    function $s(t, n) {
        var s = n.checked;
        return Z({}, n, {
            defaultChecked: void 0,
            defaultValue: void 0,
            value: void 0,
            checked: s ?? t._wrapperState.initialChecked
        })
    }
    function bu(t, n) {
        var s = n.defaultValue == null ? "" : n.defaultValue
          , c = n.checked != null ? n.checked : n.defaultChecked;
        s = Pe(n.value != null ? n.value : s),
        t._wrapperState = {
            initialChecked: c,
            initialValue: s,
            controlled: n.type === "checkbox" || n.type === "radio" ? n.checked != null : n.value != null
        }
    }
    function Su(t, n) {
        n = n.checked,
        n != null && T(t, "checked", n, !1)
    }
    function Hs(t, n) {
        Su(t, n);
        var s = Pe(n.value)
          , c = n.type;
        if (s != null)
            c === "number" ? (s === 0 && t.value === "" || t.value != s) && (t.value = "" + s) : t.value !== "" + s && (t.value = "" + s);
        else if (c === "submit" || c === "reset") {
            t.removeAttribute("value");
            return
        }
        n.hasOwnProperty("value") ? Gs(t, n.type, s) : n.hasOwnProperty("defaultValue") && Gs(t, n.type, Pe(n.defaultValue)),
        n.checked == null && n.defaultChecked != null && (t.defaultChecked = !!n.defaultChecked)
    }
    function Tu(t, n, s) {
        if (n.hasOwnProperty("value") || n.hasOwnProperty("defaultValue")) {
            var c = n.type;
            if (!(c !== "submit" && c !== "reset" || n.value !== void 0 && n.value !== null))
                return;
            n = "" + t._wrapperState.initialValue,
            s || n === t.value || (t.value = n),
            t.defaultValue = n
        }
        s = t.name,
        s !== "" && (t.name = ""),
        t.defaultChecked = !!t._wrapperState.initialChecked,
        s !== "" && (t.name = s)
    }
    function Gs(t, n, s) {
        (n !== "number" || Yn(t.ownerDocument) !== t) && (s == null ? t.defaultValue = "" + t._wrapperState.initialValue : t.defaultValue !== "" + s && (t.defaultValue = "" + s))
    }
    var Rr = Array.isArray;
    function Ji(t, n, s, c) {
        if (t = t.options,
        n) {
            n = {};
            for (var m = 0; m < s.length; m++)
                n["$" + s[m]] = !0;
            for (s = 0; s < t.length; s++)
                m = n.hasOwnProperty("$" + t[s].value),
                t[s].selected !== m && (t[s].selected = m),
                m && c && (t[s].defaultSelected = !0)
        } else {
            for (s = "" + Pe(s),
            n = null,
            m = 0; m < t.length; m++) {
                if (t[m].value === s) {
                    t[m].selected = !0,
                    c && (t[m].defaultSelected = !0);
                    return
                }
                n !== null || t[m].disabled || (n = t[m])
            }
            n !== null && (n.selected = !0)
        }
    }
    function qs(t, n) {
        if (n.dangerouslySetInnerHTML != null)
            throw Error(r(91));
        return Z({}, n, {
            value: void 0,
            defaultValue: void 0,
            children: "" + t._wrapperState.initialValue
        })
    }
    function ju(t, n) {
        var s = n.value;
        if (s == null) {
            if (s = n.children,
            n = n.defaultValue,
            s != null) {
                if (n != null)
                    throw Error(r(92));
                if (Rr(s)) {
                    if (1 < s.length)
                        throw Error(r(93));
                    s = s[0]
                }
                n = s
            }
            n == null && (n = ""),
            s = n
        }
        t._wrapperState = {
            initialValue: Pe(s)
        }
    }
    function Cu(t, n) {
        var s = Pe(n.value)
          , c = Pe(n.defaultValue);
        s != null && (s = "" + s,
        s !== t.value && (t.value = s),
        n.defaultValue == null && t.defaultValue !== s && (t.defaultValue = s)),
        c != null && (t.defaultValue = "" + c)
    }
    function zu(t) {
        var n = t.textContent;
        n === t._wrapperState.initialValue && n !== "" && n !== null && (t.value = n)
    }
    function Au(t) {
        switch (t) {
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml"
        }
    }
    function Xs(t, n) {
        return t == null || t === "http://www.w3.org/1999/xhtml" ? Au(n) : t === "http://www.w3.org/2000/svg" && n === "foreignObject" ? "http://www.w3.org/1999/xhtml" : t
    }
    var Qn, Eu = (function(t) {
        return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(n, s, c, m) {
            MSApp.execUnsafeLocalFunction(function() {
                return t(n, s, c, m)
            })
        }
        : t
    }
    )(function(t, n) {
        if (t.namespaceURI !== "http://www.w3.org/2000/svg" || "innerHTML"in t)
            t.innerHTML = n;
        else {
            for (Qn = Qn || document.createElement("div"),
            Qn.innerHTML = "<svg>" + n.valueOf().toString() + "</svg>",
            n = Qn.firstChild; t.firstChild; )
                t.removeChild(t.firstChild);
            for (; n.firstChild; )
                t.appendChild(n.firstChild)
        }
    });
    function Br(t, n) {
        if (n) {
            var s = t.firstChild;
            if (s && s === t.lastChild && s.nodeType === 3) {
                s.nodeValue = n;
                return
            }
        }
        t.textContent = n
    }
    var Wr = {
        animationIterationCount: !0,
        aspectRatio: !0,
        borderImageOutset: !0,
        borderImageSlice: !0,
        borderImageWidth: !0,
        boxFlex: !0,
        boxFlexGroup: !0,
        boxOrdinalGroup: !0,
        columnCount: !0,
        columns: !0,
        flex: !0,
        flexGrow: !0,
        flexPositive: !0,
        flexShrink: !0,
        flexNegative: !0,
        flexOrder: !0,
        gridArea: !0,
        gridRow: !0,
        gridRowEnd: !0,
        gridRowSpan: !0,
        gridRowStart: !0,
        gridColumn: !0,
        gridColumnEnd: !0,
        gridColumnSpan: !0,
        gridColumnStart: !0,
        fontWeight: !0,
        lineClamp: !0,
        lineHeight: !0,
        opacity: !0,
        order: !0,
        orphans: !0,
        tabSize: !0,
        widows: !0,
        zIndex: !0,
        zoom: !0,
        fillOpacity: !0,
        floodOpacity: !0,
        stopOpacity: !0,
        strokeDasharray: !0,
        strokeDashoffset: !0,
        strokeMiterlimit: !0,
        strokeOpacity: !0,
        strokeWidth: !0
    }
      , V0 = ["Webkit", "ms", "Moz", "O"];
    Object.keys(Wr).forEach(function(t) {
        V0.forEach(function(n) {
            n = n + t.charAt(0).toUpperCase() + t.substring(1),
            Wr[n] = Wr[t]
        })
    });
    function Du(t, n, s) {
        return n == null || typeof n == "boolean" || n === "" ? "" : s || typeof n != "number" || n === 0 || Wr.hasOwnProperty(t) && Wr[t] ? ("" + n).trim() : n + "px"
    }
    function Iu(t, n) {
        t = t.style;
        for (var s in n)
            if (n.hasOwnProperty(s)) {
                var c = s.indexOf("--") === 0
                  , m = Du(s, n[s], c);
                s === "float" && (s = "cssFloat"),
                c ? t.setProperty(s, m) : t[s] = m
            }
    }
    var L0 = Z({
        menuitem: !0
    }, {
        area: !0,
        base: !0,
        br: !0,
        col: !0,
        embed: !0,
        hr: !0,
        img: !0,
        input: !0,
        keygen: !0,
        link: !0,
        meta: !0,
        param: !0,
        source: !0,
        track: !0,
        wbr: !0
    });
    function Zs(t, n) {
        if (n) {
            if (L0[t] && (n.children != null || n.dangerouslySetInnerHTML != null))
                throw Error(r(137, t));
            if (n.dangerouslySetInnerHTML != null) {
                if (n.children != null)
                    throw Error(r(60));
                if (typeof n.dangerouslySetInnerHTML != "object" || !("__html"in n.dangerouslySetInnerHTML))
                    throw Error(r(61))
            }
            if (n.style != null && typeof n.style != "object")
                throw Error(r(62))
        }
    }
    function Ys(t, n) {
        if (t.indexOf("-") === -1)
            return typeof n.is == "string";
        switch (t) {
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0
        }
    }
    var Qs = null;
    function Js(t) {
        return t = t.target || t.srcElement || window,
        t.correspondingUseElement && (t = t.correspondingUseElement),
        t.nodeType === 3 ? t.parentNode : t
    }
    var eo = null
      , er = null
      , tr = null;
    function Mu(t) {
        if (t = un(t)) {
            if (typeof eo != "function")
                throw Error(r(280));
            var n = t.stateNode;
            n && (n = wa(n),
            eo(t.stateNode, t.type, n))
        }
    }
    function Vu(t) {
        er ? tr ? tr.push(t) : tr = [t] : er = t
    }
    function Lu() {
        if (er) {
            var t = er
              , n = tr;
            if (tr = er = null,
            Mu(t),
            n)
                for (t = 0; t < n.length; t++)
                    Mu(n[t])
        }
    }
    function Ou(t, n) {
        return t(n)
    }
    function Nu() {}
    var to = !1;
    function Fu(t, n, s) {
        if (to)
            return t(n, s);
        to = !0;
        try {
            return Ou(t, n, s)
        } finally {
            to = !1,
            (er !== null || tr !== null) && (Nu(),
            Lu())
        }
    }
    function _r(t, n) {
        var s = t.stateNode;
        if (s === null)
            return null;
        var c = wa(s);
        if (c === null)
            return null;
        s = c[n];
        e: switch (n) {
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (c = !c.disabled) || (t = t.type,
            c = !(t === "button" || t === "input" || t === "select" || t === "textarea")),
            t = !c;
            break e;
        default:
            t = !1
        }
        if (t)
            return null;
        if (s && typeof s != "function")
            throw Error(r(231, n, typeof s));
        return s
    }
    var io = !1;
    if (d)
        try {
            var Ur = {};
            Object.defineProperty(Ur, "passive", {
                get: function() {
                    io = !0
                }
            }),
            window.addEventListener("test", Ur, Ur),
            window.removeEventListener("test", Ur, Ur)
        } catch {
            io = !1
        }
    function O0(t, n, s, c, m, f, k, j, A) {
        var O = Array.prototype.slice.call(arguments, 3);
        try {
            n.apply(s, O)
        } catch (G) {
            this.onError(G)
        }
    }
    var Kr = !1
      , Jn = null
      , ea = !1
      , ro = null
      , N0 = {
        onError: function(t) {
            Kr = !0,
            Jn = t
        }
    };
    function F0(t, n, s, c, m, f, k, j, A) {
        Kr = !1,
        Jn = null,
        O0.apply(N0, arguments)
    }
    function R0(t, n, s, c, m, f, k, j, A) {
        if (F0.apply(this, arguments),
        Kr) {
            if (Kr) {
                var O = Jn;
                Kr = !1,
                Jn = null
            } else
                throw Error(r(198));
            ea || (ea = !0,
            ro = O)
        }
    }
    function Di(t) {
        var n = t
          , s = t;
        if (t.alternate)
            for (; n.return; )
                n = n.return;
        else {
            t = n;
            do
                n = t,
                (n.flags & 4098) !== 0 && (s = n.return),
                t = n.return;
            while (t)
        }
        return n.tag === 3 ? s : null
    }
    function Ru(t) {
        if (t.tag === 13) {
            var n = t.memoizedState;
            if (n === null && (t = t.alternate,
            t !== null && (n = t.memoizedState)),
            n !== null)
                return n.dehydrated
        }
        return null
    }
    function Bu(t) {
        if (Di(t) !== t)
            throw Error(r(188))
    }
    function B0(t) {
        var n = t.alternate;
        if (!n) {
            if (n = Di(t),
            n === null)
                throw Error(r(188));
            return n !== t ? null : t
        }
        for (var s = t, c = n; ; ) {
            var m = s.return;
            if (m === null)
                break;
            var f = m.alternate;
            if (f === null) {
                if (c = m.return,
                c !== null) {
                    s = c;
                    continue
                }
                break
            }
            if (m.child === f.child) {
                for (f = m.child; f; ) {
                    if (f === s)
                        return Bu(m),
                        t;
                    if (f === c)
                        return Bu(m),
                        n;
                    f = f.sibling
                }
                throw Error(r(188))
            }
            if (s.return !== c.return)
                s = m,
                c = f;
            else {
                for (var k = !1, j = m.child; j; ) {
                    if (j === s) {
                        k = !0,
                        s = m,
                        c = f;
                        break
                    }
                    if (j === c) {
                        k = !0,
                        c = m,
                        s = f;
                        break
                    }
                    j = j.sibling
                }
                if (!k) {
                    for (j = f.child; j; ) {
                        if (j === s) {
                            k = !0,
                            s = f,
                            c = m;
                            break
                        }
                        if (j === c) {
                            k = !0,
                            c = f,
                            s = m;
                            break
                        }
                        j = j.sibling
                    }
                    if (!k)
                        throw Error(r(189))
                }
            }
            if (s.alternate !== c)
                throw Error(r(190))
        }
        if (s.tag !== 3)
            throw Error(r(188));
        return s.stateNode.current === s ? t : n
    }
    function Wu(t) {
        return t = B0(t),
        t !== null ? _u(t) : null
    }
    function _u(t) {
        if (t.tag === 5 || t.tag === 6)
            return t;
        for (t = t.child; t !== null; ) {
            var n = _u(t);
            if (n !== null)
                return n;
            t = t.sibling
        }
        return null
    }
    var Uu = e.unstable_scheduleCallback
      , Ku = e.unstable_cancelCallback
      , W0 = e.unstable_shouldYield
      , _0 = e.unstable_requestPaint
      , Ne = e.unstable_now
      , U0 = e.unstable_getCurrentPriorityLevel
      , no = e.unstable_ImmediatePriority
      , $u = e.unstable_UserBlockingPriority
      , ta = e.unstable_NormalPriority
      , K0 = e.unstable_LowPriority
      , Hu = e.unstable_IdlePriority
      , ia = null
      , Nt = null;
    function $0(t) {
        if (Nt && typeof Nt.onCommitFiberRoot == "function")
            try {
                Nt.onCommitFiberRoot(ia, t, void 0, (t.current.flags & 128) === 128)
            } catch {}
    }
    var At = Math.clz32 ? Math.clz32 : q0
      , H0 = Math.log
      , G0 = Math.LN2;
    function q0(t) {
        return t >>>= 0,
        t === 0 ? 32 : 31 - (H0(t) / G0 | 0) | 0
    }
    var ra = 64
      , na = 4194304;
    function $r(t) {
        switch (t & -t) {
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return t & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return t & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return t
        }
    }
    function aa(t, n) {
        var s = t.pendingLanes;
        if (s === 0)
            return 0;
        var c = 0
          , m = t.suspendedLanes
          , f = t.pingedLanes
          , k = s & 268435455;
        if (k !== 0) {
            var j = k & ~m;
            j !== 0 ? c = $r(j) : (f &= k,
            f !== 0 && (c = $r(f)))
        } else
            k = s & ~m,
            k !== 0 ? c = $r(k) : f !== 0 && (c = $r(f));
        if (c === 0)
            return 0;
        if (n !== 0 && n !== c && (n & m) === 0 && (m = c & -c,
        f = n & -n,
        m >= f || m === 16 && (f & 4194240) !== 0))
            return n;
        if ((c & 4) !== 0 && (c |= s & 16),
        n = t.entangledLanes,
        n !== 0)
            for (t = t.entanglements,
            n &= c; 0 < n; )
                s = 31 - At(n),
                m = 1 << s,
                c |= t[s],
                n &= ~m;
        return c
    }
    function X0(t, n) {
        switch (t) {
        case 1:
        case 2:
        case 4:
            return n + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return n + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1
        }
    }
    function Z0(t, n) {
        for (var s = t.suspendedLanes, c = t.pingedLanes, m = t.expirationTimes, f = t.pendingLanes; 0 < f; ) {
            var k = 31 - At(f)
              , j = 1 << k
              , A = m[k];
            A === -1 ? ((j & s) === 0 || (j & c) !== 0) && (m[k] = X0(j, n)) : A <= n && (t.expiredLanes |= j),
            f &= ~j
        }
    }
    function ao(t) {
        return t = t.pendingLanes & -1073741825,
        t !== 0 ? t : t & 1073741824 ? 1073741824 : 0
    }
    function Gu() {
        var t = ra;
        return ra <<= 1,
        (ra & 4194240) === 0 && (ra = 64),
        t
    }
    function so(t) {
        for (var n = [], s = 0; 31 > s; s++)
            n.push(t);
        return n
    }
    function Hr(t, n, s) {
        t.pendingLanes |= n,
        n !== 536870912 && (t.suspendedLanes = 0,
        t.pingedLanes = 0),
        t = t.eventTimes,
        n = 31 - At(n),
        t[n] = s
    }
    function Y0(t, n) {
        var s = t.pendingLanes & ~n;
        t.pendingLanes = n,
        t.suspendedLanes = 0,
        t.pingedLanes = 0,
        t.expiredLanes &= n,
        t.mutableReadLanes &= n,
        t.entangledLanes &= n,
        n = t.entanglements;
        var c = t.eventTimes;
        for (t = t.expirationTimes; 0 < s; ) {
            var m = 31 - At(s)
              , f = 1 << m;
            n[m] = 0,
            c[m] = -1,
            t[m] = -1,
            s &= ~f
        }
    }
    function oo(t, n) {
        var s = t.entangledLanes |= n;
        for (t = t.entanglements; s; ) {
            var c = 31 - At(s)
              , m = 1 << c;
            m & n | t[c] & n && (t[c] |= n),
            s &= ~m
        }
    }
    var be = 0;
    function qu(t) {
        return t &= -t,
        1 < t ? 4 < t ? (t & 268435455) !== 0 ? 16 : 536870912 : 4 : 1
    }
    var Xu, lo, Zu, Yu, Qu, co = !1, sa = [], ai = null, si = null, oi = null, Gr = new Map, qr = new Map, li = [], Q0 = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
    function Ju(t, n) {
        switch (t) {
        case "focusin":
        case "focusout":
            ai = null;
            break;
        case "dragenter":
        case "dragleave":
            si = null;
            break;
        case "mouseover":
        case "mouseout":
            oi = null;
            break;
        case "pointerover":
        case "pointerout":
            Gr.delete(n.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            qr.delete(n.pointerId)
        }
    }
    function Xr(t, n, s, c, m, f) {
        return t === null || t.nativeEvent !== f ? (t = {
            blockedOn: n,
            domEventName: s,
            eventSystemFlags: c,
            nativeEvent: f,
            targetContainers: [m]
        },
        n !== null && (n = un(n),
        n !== null && lo(n)),
        t) : (t.eventSystemFlags |= c,
        n = t.targetContainers,
        m !== null && n.indexOf(m) === -1 && n.push(m),
        t)
    }
    function J0(t, n, s, c, m) {
        switch (n) {
        case "focusin":
            return ai = Xr(ai, t, n, s, c, m),
            !0;
        case "dragenter":
            return si = Xr(si, t, n, s, c, m),
            !0;
        case "mouseover":
            return oi = Xr(oi, t, n, s, c, m),
            !0;
        case "pointerover":
            var f = m.pointerId;
            return Gr.set(f, Xr(Gr.get(f) || null, t, n, s, c, m)),
            !0;
        case "gotpointercapture":
            return f = m.pointerId,
            qr.set(f, Xr(qr.get(f) || null, t, n, s, c, m)),
            !0
        }
        return !1
    }
    function ed(t) {
        var n = Ii(t.target);
        if (n !== null) {
            var s = Di(n);
            if (s !== null) {
                if (n = s.tag,
                n === 13) {
                    if (n = Ru(s),
                    n !== null) {
                        t.blockedOn = n,
                        Qu(t.priority, function() {
                            Zu(s)
                        });
                        return
                    }
                } else if (n === 3 && s.stateNode.current.memoizedState.isDehydrated) {
                    t.blockedOn = s.tag === 3 ? s.stateNode.containerInfo : null;
                    return
                }
            }
        }
        t.blockedOn = null
    }
    function oa(t) {
        if (t.blockedOn !== null)
            return !1;
        for (var n = t.targetContainers; 0 < n.length; ) {
            var s = po(t.domEventName, t.eventSystemFlags, n[0], t.nativeEvent);
            if (s === null) {
                s = t.nativeEvent;
                var c = new s.constructor(s.type,s);
                Qs = c,
                s.target.dispatchEvent(c),
                Qs = null
            } else
                return n = un(s),
                n !== null && lo(n),
                t.blockedOn = s,
                !1;
            n.shift()
        }
        return !0
    }
    function td(t, n, s) {
        oa(t) && s.delete(n)
    }
    function ev() {
        co = !1,
        ai !== null && oa(ai) && (ai = null),
        si !== null && oa(si) && (si = null),
        oi !== null && oa(oi) && (oi = null),
        Gr.forEach(td),
        qr.forEach(td)
    }
    function Zr(t, n) {
        t.blockedOn === n && (t.blockedOn = null,
        co || (co = !0,
        e.unstable_scheduleCallback(e.unstable_NormalPriority, ev)))
    }
    function Yr(t) {
        function n(m) {
            return Zr(m, t)
        }
        if (0 < sa.length) {
            Zr(sa[0], t);
            for (var s = 1; s < sa.length; s++) {
                var c = sa[s];
                c.blockedOn === t && (c.blockedOn = null)
            }
        }
        for (ai !== null && Zr(ai, t),
        si !== null && Zr(si, t),
        oi !== null && Zr(oi, t),
        Gr.forEach(n),
        qr.forEach(n),
        s = 0; s < li.length; s++)
            c = li[s],
            c.blockedOn === t && (c.blockedOn = null);
        for (; 0 < li.length && (s = li[0],
        s.blockedOn === null); )
            ed(s),
            s.blockedOn === null && li.shift()
    }
    var ir = D.ReactCurrentBatchConfig
      , la = !0;
    function tv(t, n, s, c) {
        var m = be
          , f = ir.transition;
        ir.transition = null;
        try {
            be = 1,
            uo(t, n, s, c)
        } finally {
            be = m,
            ir.transition = f
        }
    }
    function iv(t, n, s, c) {
        var m = be
          , f = ir.transition;
        ir.transition = null;
        try {
            be = 4,
            uo(t, n, s, c)
        } finally {
            be = m,
            ir.transition = f
        }
    }
    function uo(t, n, s, c) {
        if (la) {
            var m = po(t, n, s, c);
            if (m === null)
                Ao(t, n, c, ca, s),
                Ju(t, c);
            else if (J0(m, t, n, s, c))
                c.stopPropagation();
            else if (Ju(t, c),
            n & 4 && -1 < Q0.indexOf(t)) {
                for (; m !== null; ) {
                    var f = un(m);
                    if (f !== null && Xu(f),
                    f = po(t, n, s, c),
                    f === null && Ao(t, n, c, ca, s),
                    f === m)
                        break;
                    m = f
                }
                m !== null && c.stopPropagation()
            } else
                Ao(t, n, c, null, s)
        }
    }
    var ca = null;
    function po(t, n, s, c) {
        if (ca = null,
        t = Js(c),
        t = Ii(t),
        t !== null)
            if (n = Di(t),
            n === null)
                t = null;
            else if (s = n.tag,
            s === 13) {
                if (t = Ru(n),
                t !== null)
                    return t;
                t = null
            } else if (s === 3) {
                if (n.stateNode.current.memoizedState.isDehydrated)
                    return n.tag === 3 ? n.stateNode.containerInfo : null;
                t = null
            } else
                n !== t && (t = null);
        return ca = t,
        null
    }
    function id(t) {
        switch (t) {
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch (U0()) {
            case no:
                return 1;
            case $u:
                return 4;
            case ta:
            case K0:
                return 16;
            case Hu:
                return 536870912;
            default:
                return 16
            }
        default:
            return 16
        }
    }
    var ci = null
      , mo = null
      , ua = null;
    function rd() {
        if (ua)
            return ua;
        var t, n = mo, s = n.length, c, m = "value"in ci ? ci.value : ci.textContent, f = m.length;
        for (t = 0; t < s && n[t] === m[t]; t++)
            ;
        var k = s - t;
        for (c = 1; c <= k && n[s - c] === m[f - c]; c++)
            ;
        return ua = m.slice(t, 1 < c ? 1 - c : void 0)
    }
    function da(t) {
        var n = t.keyCode;
        return "charCode"in t ? (t = t.charCode,
        t === 0 && n === 13 && (t = 13)) : t = n,
        t === 10 && (t = 13),
        32 <= t || t === 13 ? t : 0
    }
    function pa() {
        return !0
    }
    function nd() {
        return !1
    }
    function ht(t) {
        function n(s, c, m, f, k) {
            this._reactName = s,
            this._targetInst = m,
            this.type = c,
            this.nativeEvent = f,
            this.target = k,
            this.currentTarget = null;
            for (var j in t)
                t.hasOwnProperty(j) && (s = t[j],
                this[j] = s ? s(f) : f[j]);
            return this.isDefaultPrevented = (f.defaultPrevented != null ? f.defaultPrevented : f.returnValue === !1) ? pa : nd,
            this.isPropagationStopped = nd,
            this
        }
        return Z(n.prototype, {
            preventDefault: function() {
                this.defaultPrevented = !0;
                var s = this.nativeEvent;
                s && (s.preventDefault ? s.preventDefault() : typeof s.returnValue != "unknown" && (s.returnValue = !1),
                this.isDefaultPrevented = pa)
            },
            stopPropagation: function() {
                var s = this.nativeEvent;
                s && (s.stopPropagation ? s.stopPropagation() : typeof s.cancelBubble != "unknown" && (s.cancelBubble = !0),
                this.isPropagationStopped = pa)
            },
            persist: function() {},
            isPersistent: pa
        }),
        n
    }
    var rr = {
        eventPhase: 0,
        bubbles: 0,
        cancelable: 0,
        timeStamp: function(t) {
            return t.timeStamp || Date.now()
        },
        defaultPrevented: 0,
        isTrusted: 0
    }, ho = ht(rr), Qr = Z({}, rr, {
        view: 0,
        detail: 0
    }), rv = ht(Qr), fo, go, Jr, ma = Z({}, Qr, {
        screenX: 0,
        screenY: 0,
        clientX: 0,
        clientY: 0,
        pageX: 0,
        pageY: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        getModifierState: yo,
        button: 0,
        buttons: 0,
        relatedTarget: function(t) {
            return t.relatedTarget === void 0 ? t.fromElement === t.srcElement ? t.toElement : t.fromElement : t.relatedTarget
        },
        movementX: function(t) {
            return "movementX"in t ? t.movementX : (t !== Jr && (Jr && t.type === "mousemove" ? (fo = t.screenX - Jr.screenX,
            go = t.screenY - Jr.screenY) : go = fo = 0,
            Jr = t),
            fo)
        },
        movementY: function(t) {
            return "movementY"in t ? t.movementY : go
        }
    }), ad = ht(ma), nv = Z({}, ma, {
        dataTransfer: 0
    }), av = ht(nv), sv = Z({}, Qr, {
        relatedTarget: 0
    }), vo = ht(sv), ov = Z({}, rr, {
        animationName: 0,
        elapsedTime: 0,
        pseudoElement: 0
    }), lv = ht(ov), cv = Z({}, rr, {
        clipboardData: function(t) {
            return "clipboardData"in t ? t.clipboardData : window.clipboardData
        }
    }), uv = ht(cv), dv = Z({}, rr, {
        data: 0
    }), sd = ht(dv), pv = {
        Esc: "Escape",
        Spacebar: " ",
        Left: "ArrowLeft",
        Up: "ArrowUp",
        Right: "ArrowRight",
        Down: "ArrowDown",
        Del: "Delete",
        Win: "OS",
        Menu: "ContextMenu",
        Apps: "ContextMenu",
        Scroll: "ScrollLock",
        MozPrintableKey: "Unidentified"
    }, mv = {
        8: "Backspace",
        9: "Tab",
        12: "Clear",
        13: "Enter",
        16: "Shift",
        17: "Control",
        18: "Alt",
        19: "Pause",
        20: "CapsLock",
        27: "Escape",
        32: " ",
        33: "PageUp",
        34: "PageDown",
        35: "End",
        36: "Home",
        37: "ArrowLeft",
        38: "ArrowUp",
        39: "ArrowRight",
        40: "ArrowDown",
        45: "Insert",
        46: "Delete",
        112: "F1",
        113: "F2",
        114: "F3",
        115: "F4",
        116: "F5",
        117: "F6",
        118: "F7",
        119: "F8",
        120: "F9",
        121: "F10",
        122: "F11",
        123: "F12",
        144: "NumLock",
        145: "ScrollLock",
        224: "Meta"
    }, hv = {
        Alt: "altKey",
        Control: "ctrlKey",
        Meta: "metaKey",
        Shift: "shiftKey"
    };
    function fv(t) {
        var n = this.nativeEvent;
        return n.getModifierState ? n.getModifierState(t) : (t = hv[t]) ? !!n[t] : !1
    }
    function yo() {
        return fv
    }
    var gv = Z({}, Qr, {
        key: function(t) {
            if (t.key) {
                var n = pv[t.key] || t.key;
                if (n !== "Unidentified")
                    return n
            }
            return t.type === "keypress" ? (t = da(t),
            t === 13 ? "Enter" : String.fromCharCode(t)) : t.type === "keydown" || t.type === "keyup" ? mv[t.keyCode] || "Unidentified" : ""
        },
        code: 0,
        location: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        repeat: 0,
        locale: 0,
        getModifierState: yo,
        charCode: function(t) {
            return t.type === "keypress" ? da(t) : 0
        },
        keyCode: function(t) {
            return t.type === "keydown" || t.type === "keyup" ? t.keyCode : 0
        },
        which: function(t) {
            return t.type === "keypress" ? da(t) : t.type === "keydown" || t.type === "keyup" ? t.keyCode : 0
        }
    })
      , vv = ht(gv)
      , yv = Z({}, ma, {
        pointerId: 0,
        width: 0,
        height: 0,
        pressure: 0,
        tangentialPressure: 0,
        tiltX: 0,
        tiltY: 0,
        twist: 0,
        pointerType: 0,
        isPrimary: 0
    })
      , od = ht(yv)
      , kv = Z({}, Qr, {
        touches: 0,
        targetTouches: 0,
        changedTouches: 0,
        altKey: 0,
        metaKey: 0,
        ctrlKey: 0,
        shiftKey: 0,
        getModifierState: yo
    })
      , xv = ht(kv)
      , wv = Z({}, rr, {
        propertyName: 0,
        elapsedTime: 0,
        pseudoElement: 0
    })
      , Pv = ht(wv)
      , bv = Z({}, ma, {
        deltaX: function(t) {
            return "deltaX"in t ? t.deltaX : "wheelDeltaX"in t ? -t.wheelDeltaX : 0
        },
        deltaY: function(t) {
            return "deltaY"in t ? t.deltaY : "wheelDeltaY"in t ? -t.wheelDeltaY : "wheelDelta"in t ? -t.wheelDelta : 0
        },
        deltaZ: 0,
        deltaMode: 0
    })
      , Sv = ht(bv)
      , Tv = [9, 13, 27, 32]
      , ko = d && "CompositionEvent"in window
      , en = null;
    d && "documentMode"in document && (en = document.documentMode);
    var jv = d && "TextEvent"in window && !en
      , ld = d && (!ko || en && 8 < en && 11 >= en)
      , cd = " "
      , ud = !1;
    function dd(t, n) {
        switch (t) {
        case "keyup":
            return Tv.indexOf(n.keyCode) !== -1;
        case "keydown":
            return n.keyCode !== 229;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1
        }
    }
    function pd(t) {
        return t = t.detail,
        typeof t == "object" && "data"in t ? t.data : null
    }
    var nr = !1;
    function Cv(t, n) {
        switch (t) {
        case "compositionend":
            return pd(n);
        case "keypress":
            return n.which !== 32 ? null : (ud = !0,
            cd);
        case "textInput":
            return t = n.data,
            t === cd && ud ? null : t;
        default:
            return null
        }
    }
    function zv(t, n) {
        if (nr)
            return t === "compositionend" || !ko && dd(t, n) ? (t = rd(),
            ua = mo = ci = null,
            nr = !1,
            t) : null;
        switch (t) {
        case "paste":
            return null;
        case "keypress":
            if (!(n.ctrlKey || n.altKey || n.metaKey) || n.ctrlKey && n.altKey) {
                if (n.char && 1 < n.char.length)
                    return n.char;
                if (n.which)
                    return String.fromCharCode(n.which)
            }
            return null;
        case "compositionend":
            return ld && n.locale !== "ko" ? null : n.data;
        default:
            return null
        }
    }
    var Av = {
        color: !0,
        date: !0,
        datetime: !0,
        "datetime-local": !0,
        email: !0,
        month: !0,
        number: !0,
        password: !0,
        range: !0,
        search: !0,
        tel: !0,
        text: !0,
        time: !0,
        url: !0,
        week: !0
    };
    function md(t) {
        var n = t && t.nodeName && t.nodeName.toLowerCase();
        return n === "input" ? !!Av[t.type] : n === "textarea"
    }
    function hd(t, n, s, c) {
        Vu(c),
        n = ya(n, "onChange"),
        0 < n.length && (s = new ho("onChange","change",null,s,c),
        t.push({
            event: s,
            listeners: n
        }))
    }
    var tn = null
      , rn = null;
    function Ev(t) {
        Id(t, 0)
    }
    function ha(t) {
        var n = cr(t);
        if (Pu(n))
            return t
    }
    function Dv(t, n) {
        if (t === "change")
            return n
    }
    var fd = !1;
    if (d) {
        var xo;
        if (d) {
            var wo = "oninput"in document;
            if (!wo) {
                var gd = document.createElement("div");
                gd.setAttribute("oninput", "return;"),
                wo = typeof gd.oninput == "function"
            }
            xo = wo
        } else
            xo = !1;
        fd = xo && (!document.documentMode || 9 < document.documentMode)
    }
    function vd() {
        tn && (tn.detachEvent("onpropertychange", yd),
        rn = tn = null)
    }
    function yd(t) {
        if (t.propertyName === "value" && ha(rn)) {
            var n = [];
            hd(n, rn, t, Js(t)),
            Fu(Ev, n)
        }
    }
    function Iv(t, n, s) {
        t === "focusin" ? (vd(),
        tn = n,
        rn = s,
        tn.attachEvent("onpropertychange", yd)) : t === "focusout" && vd()
    }
    function Mv(t) {
        if (t === "selectionchange" || t === "keyup" || t === "keydown")
            return ha(rn)
    }
    function Vv(t, n) {
        if (t === "click")
            return ha(n)
    }
    function Lv(t, n) {
        if (t === "input" || t === "change")
            return ha(n)
    }
    function Ov(t, n) {
        return t === n && (t !== 0 || 1 / t === 1 / n) || t !== t && n !== n
    }
    var Et = typeof Object.is == "function" ? Object.is : Ov;
    function nn(t, n) {
        if (Et(t, n))
            return !0;
        if (typeof t != "object" || t === null || typeof n != "object" || n === null)
            return !1;
        var s = Object.keys(t)
          , c = Object.keys(n);
        if (s.length !== c.length)
            return !1;
        for (c = 0; c < s.length; c++) {
            var m = s[c];
            if (!p.call(n, m) || !Et(t[m], n[m]))
                return !1
        }
        return !0
    }
    function kd(t) {
        for (; t && t.firstChild; )
            t = t.firstChild;
        return t
    }
    function xd(t, n) {
        var s = kd(t);
        t = 0;
        for (var c; s; ) {
            if (s.nodeType === 3) {
                if (c = t + s.textContent.length,
                t <= n && c >= n)
                    return {
                        node: s,
                        offset: n - t
                    };
                t = c
            }
            e: {
                for (; s; ) {
                    if (s.nextSibling) {
                        s = s.nextSibling;
                        break e
                    }
                    s = s.parentNode
                }
                s = void 0
            }
            s = kd(s)
        }
    }
    function wd(t, n) {
        return t && n ? t === n ? !0 : t && t.nodeType === 3 ? !1 : n && n.nodeType === 3 ? wd(t, n.parentNode) : "contains"in t ? t.contains(n) : t.compareDocumentPosition ? !!(t.compareDocumentPosition(n) & 16) : !1 : !1
    }
    function Pd() {
        for (var t = window, n = Yn(); n instanceof t.HTMLIFrameElement; ) {
            try {
                var s = typeof n.contentWindow.location.href == "string"
            } catch {
                s = !1
            }
            if (s)
                t = n.contentWindow;
            else
                break;
            n = Yn(t.document)
        }
        return n
    }
    function Po(t) {
        var n = t && t.nodeName && t.nodeName.toLowerCase();
        return n && (n === "input" && (t.type === "text" || t.type === "search" || t.type === "tel" || t.type === "url" || t.type === "password") || n === "textarea" || t.contentEditable === "true")
    }
    function Nv(t) {
        var n = Pd()
          , s = t.focusedElem
          , c = t.selectionRange;
        if (n !== s && s && s.ownerDocument && wd(s.ownerDocument.documentElement, s)) {
            if (c !== null && Po(s)) {
                if (n = c.start,
                t = c.end,
                t === void 0 && (t = n),
                "selectionStart"in s)
                    s.selectionStart = n,
                    s.selectionEnd = Math.min(t, s.value.length);
                else if (t = (n = s.ownerDocument || document) && n.defaultView || window,
                t.getSelection) {
                    t = t.getSelection();
                    var m = s.textContent.length
                      , f = Math.min(c.start, m);
                    c = c.end === void 0 ? f : Math.min(c.end, m),
                    !t.extend && f > c && (m = c,
                    c = f,
                    f = m),
                    m = xd(s, f);
                    var k = xd(s, c);
                    m && k && (t.rangeCount !== 1 || t.anchorNode !== m.node || t.anchorOffset !== m.offset || t.focusNode !== k.node || t.focusOffset !== k.offset) && (n = n.createRange(),
                    n.setStart(m.node, m.offset),
                    t.removeAllRanges(),
                    f > c ? (t.addRange(n),
                    t.extend(k.node, k.offset)) : (n.setEnd(k.node, k.offset),
                    t.addRange(n)))
                }
            }
            for (n = [],
            t = s; t = t.parentNode; )
                t.nodeType === 1 && n.push({
                    element: t,
                    left: t.scrollLeft,
                    top: t.scrollTop
                });
            for (typeof s.focus == "function" && s.focus(),
            s = 0; s < n.length; s++)
                t = n[s],
                t.element.scrollLeft = t.left,
                t.element.scrollTop = t.top
        }
    }
    var Fv = d && "documentMode"in document && 11 >= document.documentMode
      , ar = null
      , bo = null
      , an = null
      , So = !1;
    function bd(t, n, s) {
        var c = s.window === s ? s.document : s.nodeType === 9 ? s : s.ownerDocument;
        So || ar == null || ar !== Yn(c) || (c = ar,
        "selectionStart"in c && Po(c) ? c = {
            start: c.selectionStart,
            end: c.selectionEnd
        } : (c = (c.ownerDocument && c.ownerDocument.defaultView || window).getSelection(),
        c = {
            anchorNode: c.anchorNode,
            anchorOffset: c.anchorOffset,
            focusNode: c.focusNode,
            focusOffset: c.focusOffset
        }),
        an && nn(an, c) || (an = c,
        c = ya(bo, "onSelect"),
        0 < c.length && (n = new ho("onSelect","select",null,n,s),
        t.push({
            event: n,
            listeners: c
        }),
        n.target = ar)))
    }
    function fa(t, n) {
        var s = {};
        return s[t.toLowerCase()] = n.toLowerCase(),
        s["Webkit" + t] = "webkit" + n,
        s["Moz" + t] = "moz" + n,
        s
    }
    var sr = {
        animationend: fa("Animation", "AnimationEnd"),
        animationiteration: fa("Animation", "AnimationIteration"),
        animationstart: fa("Animation", "AnimationStart"),
        transitionend: fa("Transition", "TransitionEnd")
    }
      , To = {}
      , Sd = {};
    d && (Sd = document.createElement("div").style,
    "AnimationEvent"in window || (delete sr.animationend.animation,
    delete sr.animationiteration.animation,
    delete sr.animationstart.animation),
    "TransitionEvent"in window || delete sr.transitionend.transition);
    function ga(t) {
        if (To[t])
            return To[t];
        if (!sr[t])
            return t;
        var n = sr[t], s;
        for (s in n)
            if (n.hasOwnProperty(s) && s in Sd)
                return To[t] = n[s];
        return t
    }
    var Td = ga("animationend")
      , jd = ga("animationiteration")
      , Cd = ga("animationstart")
      , zd = ga("transitionend")
      , Ad = new Map
      , Ed = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
    function ui(t, n) {
        Ad.set(t, n),
        l(n, [t])
    }
    for (var jo = 0; jo < Ed.length; jo++) {
        var Co = Ed[jo]
          , Rv = Co.toLowerCase()
          , Bv = Co[0].toUpperCase() + Co.slice(1);
        ui(Rv, "on" + Bv)
    }
    ui(Td, "onAnimationEnd"),
    ui(jd, "onAnimationIteration"),
    ui(Cd, "onAnimationStart"),
    ui("dblclick", "onDoubleClick"),
    ui("focusin", "onFocus"),
    ui("focusout", "onBlur"),
    ui(zd, "onTransitionEnd"),
    u("onMouseEnter", ["mouseout", "mouseover"]),
    u("onMouseLeave", ["mouseout", "mouseover"]),
    u("onPointerEnter", ["pointerout", "pointerover"]),
    u("onPointerLeave", ["pointerout", "pointerover"]),
    l("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" ")),
    l("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")),
    l("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]),
    l("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" ")),
    l("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" ")),
    l("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
    var sn = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" ")
      , Wv = new Set("cancel close invalid load scroll toggle".split(" ").concat(sn));
    function Dd(t, n, s) {
        var c = t.type || "unknown-event";
        t.currentTarget = s,
        R0(c, n, void 0, t),
        t.currentTarget = null
    }
    function Id(t, n) {
        n = (n & 4) !== 0;
        for (var s = 0; s < t.length; s++) {
            var c = t[s]
              , m = c.event;
            c = c.listeners;
            e: {
                var f = void 0;
                if (n)
                    for (var k = c.length - 1; 0 <= k; k--) {
                        var j = c[k]
                          , A = j.instance
                          , O = j.currentTarget;
                        if (j = j.listener,
                        A !== f && m.isPropagationStopped())
                            break e;
                        Dd(m, j, O),
                        f = A
                    }
                else
                    for (k = 0; k < c.length; k++) {
                        if (j = c[k],
                        A = j.instance,
                        O = j.currentTarget,
                        j = j.listener,
                        A !== f && m.isPropagationStopped())
                            break e;
                        Dd(m, j, O),
                        f = A
                    }
            }
        }
        if (ea)
            throw t = ro,
            ea = !1,
            ro = null,
            t
    }
    function je(t, n) {
        var s = n[Lo];
        s === void 0 && (s = n[Lo] = new Set);
        var c = t + "__bubble";
        s.has(c) || (Md(n, t, 2, !1),
        s.add(c))
    }
    function zo(t, n, s) {
        var c = 0;
        n && (c |= 4),
        Md(s, t, c, n)
    }
    var va = "_reactListening" + Math.random().toString(36).slice(2);
    function on(t) {
        if (!t[va]) {
            t[va] = !0,
            a.forEach(function(s) {
                s !== "selectionchange" && (Wv.has(s) || zo(s, !1, t),
                zo(s, !0, t))
            });
            var n = t.nodeType === 9 ? t : t.ownerDocument;
            n === null || n[va] || (n[va] = !0,
            zo("selectionchange", !1, n))
        }
    }
    function Md(t, n, s, c) {
        switch (id(n)) {
        case 1:
            var m = tv;
            break;
        case 4:
            m = iv;
            break;
        default:
            m = uo
        }
        s = m.bind(null, n, s, t),
        m = void 0,
        !io || n !== "touchstart" && n !== "touchmove" && n !== "wheel" || (m = !0),
        c ? m !== void 0 ? t.addEventListener(n, s, {
            capture: !0,
            passive: m
        }) : t.addEventListener(n, s, !0) : m !== void 0 ? t.addEventListener(n, s, {
            passive: m
        }) : t.addEventListener(n, s, !1)
    }
    function Ao(t, n, s, c, m) {
        var f = c;
        if ((n & 1) === 0 && (n & 2) === 0 && c !== null)
            e: for (; ; ) {
                if (c === null)
                    return;
                var k = c.tag;
                if (k === 3 || k === 4) {
                    var j = c.stateNode.containerInfo;
                    if (j === m || j.nodeType === 8 && j.parentNode === m)
                        break;
                    if (k === 4)
                        for (k = c.return; k !== null; ) {
                            var A = k.tag;
                            if ((A === 3 || A === 4) && (A = k.stateNode.containerInfo,
                            A === m || A.nodeType === 8 && A.parentNode === m))
                                return;
                            k = k.return
                        }
                    for (; j !== null; ) {
                        if (k = Ii(j),
                        k === null)
                            return;
                        if (A = k.tag,
                        A === 5 || A === 6) {
                            c = f = k;
                            continue e
                        }
                        j = j.parentNode
                    }
                }
                c = c.return
            }
        Fu(function() {
            var O = f
              , G = Js(s)
              , q = [];
            e: {
                var $ = Ad.get(t);
                if ($ !== void 0) {
                    var J = ho
                      , re = t;
                    switch (t) {
                    case "keypress":
                        if (da(s) === 0)
                            break e;
                    case "keydown":
                    case "keyup":
                        J = vv;
                        break;
                    case "focusin":
                        re = "focus",
                        J = vo;
                        break;
                    case "focusout":
                        re = "blur",
                        J = vo;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        J = vo;
                        break;
                    case "click":
                        if (s.button === 2)
                            break e;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        J = ad;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        J = av;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        J = xv;
                        break;
                    case Td:
                    case jd:
                    case Cd:
                        J = lv;
                        break;
                    case zd:
                        J = Pv;
                        break;
                    case "scroll":
                        J = rv;
                        break;
                    case "wheel":
                        J = Sv;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        J = uv;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        J = od
                    }
                    var ae = (n & 4) !== 0
                      , Fe = !ae && t === "scroll"
                      , V = ae ? $ !== null ? $ + "Capture" : null : $;
                    ae = [];
                    for (var E = O, L; E !== null; ) {
                        L = E;
                        var Y = L.stateNode;
                        if (L.tag === 5 && Y !== null && (L = Y,
                        V !== null && (Y = _r(E, V),
                        Y != null && ae.push(ln(E, Y, L)))),
                        Fe)
                            break;
                        E = E.return
                    }
                    0 < ae.length && ($ = new J($,re,null,s,G),
                    q.push({
                        event: $,
                        listeners: ae
                    }))
                }
            }
            if ((n & 7) === 0) {
                e: {
                    if ($ = t === "mouseover" || t === "pointerover",
                    J = t === "mouseout" || t === "pointerout",
                    $ && s !== Qs && (re = s.relatedTarget || s.fromElement) && (Ii(re) || re[Gt]))
                        break e;
                    if ((J || $) && ($ = G.window === G ? G : ($ = G.ownerDocument) ? $.defaultView || $.parentWindow : window,
                    J ? (re = s.relatedTarget || s.toElement,
                    J = O,
                    re = re ? Ii(re) : null,
                    re !== null && (Fe = Di(re),
                    re !== Fe || re.tag !== 5 && re.tag !== 6) && (re = null)) : (J = null,
                    re = O),
                    J !== re)) {
                        if (ae = ad,
                        Y = "onMouseLeave",
                        V = "onMouseEnter",
                        E = "mouse",
                        (t === "pointerout" || t === "pointerover") && (ae = od,
                        Y = "onPointerLeave",
                        V = "onPointerEnter",
                        E = "pointer"),
                        Fe = J == null ? $ : cr(J),
                        L = re == null ? $ : cr(re),
                        $ = new ae(Y,E + "leave",J,s,G),
                        $.target = Fe,
                        $.relatedTarget = L,
                        Y = null,
                        Ii(G) === O && (ae = new ae(V,E + "enter",re,s,G),
                        ae.target = L,
                        ae.relatedTarget = Fe,
                        Y = ae),
                        Fe = Y,
                        J && re)
                            t: {
                                for (ae = J,
                                V = re,
                                E = 0,
                                L = ae; L; L = or(L))
                                    E++;
                                for (L = 0,
                                Y = V; Y; Y = or(Y))
                                    L++;
                                for (; 0 < E - L; )
                                    ae = or(ae),
                                    E--;
                                for (; 0 < L - E; )
                                    V = or(V),
                                    L--;
                                for (; E--; ) {
                                    if (ae === V || V !== null && ae === V.alternate)
                                        break t;
                                    ae = or(ae),
                                    V = or(V)
                                }
                                ae = null
                            }
                        else
                            ae = null;
                        J !== null && Vd(q, $, J, ae, !1),
                        re !== null && Fe !== null && Vd(q, Fe, re, ae, !0)
                    }
                }
                e: {
                    if ($ = O ? cr(O) : window,
                    J = $.nodeName && $.nodeName.toLowerCase(),
                    J === "select" || J === "input" && $.type === "file")
                        var oe = Dv;
                    else if (md($))
                        if (fd)
                            oe = Lv;
                        else {
                            oe = Mv;
                            var ce = Iv
                        }
                    else
                        (J = $.nodeName) && J.toLowerCase() === "input" && ($.type === "checkbox" || $.type === "radio") && (oe = Vv);
                    if (oe && (oe = oe(t, O))) {
                        hd(q, oe, s, G);
                        break e
                    }
                    ce && ce(t, $, O),
                    t === "focusout" && (ce = $._wrapperState) && ce.controlled && $.type === "number" && Gs($, "number", $.value)
                }
                switch (ce = O ? cr(O) : window,
                t) {
                case "focusin":
                    (md(ce) || ce.contentEditable === "true") && (ar = ce,
                    bo = O,
                    an = null);
                    break;
                case "focusout":
                    an = bo = ar = null;
                    break;
                case "mousedown":
                    So = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    So = !1,
                    bd(q, s, G);
                    break;
                case "selectionchange":
                    if (Fv)
                        break;
                case "keydown":
                case "keyup":
                    bd(q, s, G)
                }
                var ue;
                if (ko)
                    e: {
                        switch (t) {
                        case "compositionstart":
                            var me = "onCompositionStart";
                            break e;
                        case "compositionend":
                            me = "onCompositionEnd";
                            break e;
                        case "compositionupdate":
                            me = "onCompositionUpdate";
                            break e
                        }
                        me = void 0
                    }
                else
                    nr ? dd(t, s) && (me = "onCompositionEnd") : t === "keydown" && s.keyCode === 229 && (me = "onCompositionStart");
                me && (ld && s.locale !== "ko" && (nr || me !== "onCompositionStart" ? me === "onCompositionEnd" && nr && (ue = rd()) : (ci = G,
                mo = "value"in ci ? ci.value : ci.textContent,
                nr = !0)),
                ce = ya(O, me),
                0 < ce.length && (me = new sd(me,t,null,s,G),
                q.push({
                    event: me,
                    listeners: ce
                }),
                ue ? me.data = ue : (ue = pd(s),
                ue !== null && (me.data = ue)))),
                (ue = jv ? Cv(t, s) : zv(t, s)) && (O = ya(O, "onBeforeInput"),
                0 < O.length && (G = new sd("onBeforeInput","beforeinput",null,s,G),
                q.push({
                    event: G,
                    listeners: O
                }),
                G.data = ue))
            }
            Id(q, n)
        })
    }
    function ln(t, n, s) {
        return {
            instance: t,
            listener: n,
            currentTarget: s
        }
    }
    function ya(t, n) {
        for (var s = n + "Capture", c = []; t !== null; ) {
            var m = t
              , f = m.stateNode;
            m.tag === 5 && f !== null && (m = f,
            f = _r(t, s),
            f != null && c.unshift(ln(t, f, m)),
            f = _r(t, n),
            f != null && c.push(ln(t, f, m))),
            t = t.return
        }
        return c
    }
    function or(t) {
        if (t === null)
            return null;
        do
            t = t.return;
        while (t && t.tag !== 5);
        return t || null
    }
    function Vd(t, n, s, c, m) {
        for (var f = n._reactName, k = []; s !== null && s !== c; ) {
            var j = s
              , A = j.alternate
              , O = j.stateNode;
            if (A !== null && A === c)
                break;
            j.tag === 5 && O !== null && (j = O,
            m ? (A = _r(s, f),
            A != null && k.unshift(ln(s, A, j))) : m || (A = _r(s, f),
            A != null && k.push(ln(s, A, j)))),
            s = s.return
        }
        k.length !== 0 && t.push({
            event: n,
            listeners: k
        })
    }
    var _v = /\r\n?/g
      , Uv = /\u0000|\uFFFD/g;
    function Ld(t) {
        return (typeof t == "string" ? t : "" + t).replace(_v, `
`).replace(Uv, "")
    }
    function ka(t, n, s) {
        if (n = Ld(n),
        Ld(t) !== n && s)
            throw Error(r(425))
    }
    function xa() {}
    var Eo = null
      , Do = null;
    function Io(t, n) {
        return t === "textarea" || t === "noscript" || typeof n.children == "string" || typeof n.children == "number" || typeof n.dangerouslySetInnerHTML == "object" && n.dangerouslySetInnerHTML !== null && n.dangerouslySetInnerHTML.__html != null
    }
    var Mo = typeof setTimeout == "function" ? setTimeout : void 0
      , Kv = typeof clearTimeout == "function" ? clearTimeout : void 0
      , Od = typeof Promise == "function" ? Promise : void 0
      , $v = typeof queueMicrotask == "function" ? queueMicrotask : typeof Od < "u" ? function(t) {
        return Od.resolve(null).then(t).catch(Hv)
    }
    : Mo;
    function Hv(t) {
        setTimeout(function() {
            throw t
        })
    }
    function Vo(t, n) {
        var s = n
          , c = 0;
        do {
            var m = s.nextSibling;
            if (t.removeChild(s),
            m && m.nodeType === 8)
                if (s = m.data,
                s === "/$") {
                    if (c === 0) {
                        t.removeChild(m),
                        Yr(n);
                        return
                    }
                    c--
                } else
                    s !== "$" && s !== "$?" && s !== "$!" || c++;
            s = m
        } while (s);
        Yr(n)
    }
    function di(t) {
        for (; t != null; t = t.nextSibling) {
            var n = t.nodeType;
            if (n === 1 || n === 3)
                break;
            if (n === 8) {
                if (n = t.data,
                n === "$" || n === "$!" || n === "$?")
                    break;
                if (n === "/$")
                    return null
            }
        }
        return t
    }
    function Nd(t) {
        t = t.previousSibling;
        for (var n = 0; t; ) {
            if (t.nodeType === 8) {
                var s = t.data;
                if (s === "$" || s === "$!" || s === "$?") {
                    if (n === 0)
                        return t;
                    n--
                } else
                    s === "/$" && n++
            }
            t = t.previousSibling
        }
        return null
    }
    var lr = Math.random().toString(36).slice(2)
      , Ft = "__reactFiber$" + lr
      , cn = "__reactProps$" + lr
      , Gt = "__reactContainer$" + lr
      , Lo = "__reactEvents$" + lr
      , Gv = "__reactListeners$" + lr
      , qv = "__reactHandles$" + lr;
    function Ii(t) {
        var n = t[Ft];
        if (n)
            return n;
        for (var s = t.parentNode; s; ) {
            if (n = s[Gt] || s[Ft]) {
                if (s = n.alternate,
                n.child !== null || s !== null && s.child !== null)
                    for (t = Nd(t); t !== null; ) {
                        if (s = t[Ft])
                            return s;
                        t = Nd(t)
                    }
                return n
            }
            t = s,
            s = t.parentNode
        }
        return null
    }
    function un(t) {
        return t = t[Ft] || t[Gt],
        !t || t.tag !== 5 && t.tag !== 6 && t.tag !== 13 && t.tag !== 3 ? null : t
    }
    function cr(t) {
        if (t.tag === 5 || t.tag === 6)
            return t.stateNode;
        throw Error(r(33))
    }
    function wa(t) {
        return t[cn] || null
    }
    var Oo = []
      , ur = -1;
    function pi(t) {
        return {
            current: t
        }
    }
    function Ce(t) {
        0 > ur || (t.current = Oo[ur],
        Oo[ur] = null,
        ur--)
    }
    function Te(t, n) {
        ur++,
        Oo[ur] = t.current,
        t.current = n
    }
    var mi = {}
      , Ye = pi(mi)
      , ot = pi(!1)
      , Mi = mi;
    function dr(t, n) {
        var s = t.type.contextTypes;
        if (!s)
            return mi;
        var c = t.stateNode;
        if (c && c.__reactInternalMemoizedUnmaskedChildContext === n)
            return c.__reactInternalMemoizedMaskedChildContext;
        var m = {}, f;
        for (f in s)
            m[f] = n[f];
        return c && (t = t.stateNode,
        t.__reactInternalMemoizedUnmaskedChildContext = n,
        t.__reactInternalMemoizedMaskedChildContext = m),
        m
    }
    function lt(t) {
        return t = t.childContextTypes,
        t != null
    }
    function Pa() {
        Ce(ot),
        Ce(Ye)
    }
    function Fd(t, n, s) {
        if (Ye.current !== mi)
            throw Error(r(168));
        Te(Ye, n),
        Te(ot, s)
    }
    function Rd(t, n, s) {
        var c = t.stateNode;
        if (n = n.childContextTypes,
        typeof c.getChildContext != "function")
            return s;
        c = c.getChildContext();
        for (var m in c)
            if (!(m in n))
                throw Error(r(108, Se(t) || "Unknown", m));
        return Z({}, s, c)
    }
    function ba(t) {
        return t = (t = t.stateNode) && t.__reactInternalMemoizedMergedChildContext || mi,
        Mi = Ye.current,
        Te(Ye, t),
        Te(ot, ot.current),
        !0
    }
    function Bd(t, n, s) {
        var c = t.stateNode;
        if (!c)
            throw Error(r(169));
        s ? (t = Rd(t, n, Mi),
        c.__reactInternalMemoizedMergedChildContext = t,
        Ce(ot),
        Ce(Ye),
        Te(Ye, t)) : Ce(ot),
        Te(ot, s)
    }
    var qt = null
      , Sa = !1
      , No = !1;
    function Wd(t) {
        qt === null ? qt = [t] : qt.push(t)
    }
    function Xv(t) {
        Sa = !0,
        Wd(t)
    }
    function hi() {
        if (!No && qt !== null) {
            No = !0;
            var t = 0
              , n = be;
            try {
                var s = qt;
                for (be = 1; t < s.length; t++) {
                    var c = s[t];
                    do
                        c = c(!0);
                    while (c !== null)
                }
                qt = null,
                Sa = !1
            } catch (m) {
                throw qt !== null && (qt = qt.slice(t + 1)),
                Uu(no, hi),
                m
            } finally {
                be = n,
                No = !1
            }
        }
        return null
    }
    var pr = []
      , mr = 0
      , Ta = null
      , ja = 0
      , wt = []
      , Pt = 0
      , Vi = null
      , Xt = 1
      , Zt = "";
    function Li(t, n) {
        pr[mr++] = ja,
        pr[mr++] = Ta,
        Ta = t,
        ja = n
    }
    function _d(t, n, s) {
        wt[Pt++] = Xt,
        wt[Pt++] = Zt,
        wt[Pt++] = Vi,
        Vi = t;
        var c = Xt;
        t = Zt;
        var m = 32 - At(c) - 1;
        c &= ~(1 << m),
        s += 1;
        var f = 32 - At(n) + m;
        if (30 < f) {
            var k = m - m % 5;
            f = (c & (1 << k) - 1).toString(32),
            c >>= k,
            m -= k,
            Xt = 1 << 32 - At(n) + m | s << m | c,
            Zt = f + t
        } else
            Xt = 1 << f | s << m | c,
            Zt = t
    }
    function Fo(t) {
        t.return !== null && (Li(t, 1),
        _d(t, 1, 0))
    }
    function Ro(t) {
        for (; t === Ta; )
            Ta = pr[--mr],
            pr[mr] = null,
            ja = pr[--mr],
            pr[mr] = null;
        for (; t === Vi; )
            Vi = wt[--Pt],
            wt[Pt] = null,
            Zt = wt[--Pt],
            wt[Pt] = null,
            Xt = wt[--Pt],
            wt[Pt] = null
    }
    var ft = null
      , gt = null
      , Ee = !1
      , Dt = null;
    function Ud(t, n) {
        var s = jt(5, null, null, 0);
        s.elementType = "DELETED",
        s.stateNode = n,
        s.return = t,
        n = t.deletions,
        n === null ? (t.deletions = [s],
        t.flags |= 16) : n.push(s)
    }
    function Kd(t, n) {
        switch (t.tag) {
        case 5:
            var s = t.type;
            return n = n.nodeType !== 1 || s.toLowerCase() !== n.nodeName.toLowerCase() ? null : n,
            n !== null ? (t.stateNode = n,
            ft = t,
            gt = di(n.firstChild),
            !0) : !1;
        case 6:
            return n = t.pendingProps === "" || n.nodeType !== 3 ? null : n,
            n !== null ? (t.stateNode = n,
            ft = t,
            gt = null,
            !0) : !1;
        case 13:
            return n = n.nodeType !== 8 ? null : n,
            n !== null ? (s = Vi !== null ? {
                id: Xt,
                overflow: Zt
            } : null,
            t.memoizedState = {
                dehydrated: n,
                treeContext: s,
                retryLane: 1073741824
            },
            s = jt(18, null, null, 0),
            s.stateNode = n,
            s.return = t,
            t.child = s,
            ft = t,
            gt = null,
            !0) : !1;
        default:
            return !1
        }
    }
    function Bo(t) {
        return (t.mode & 1) !== 0 && (t.flags & 128) === 0
    }
    function Wo(t) {
        if (Ee) {
            var n = gt;
            if (n) {
                var s = n;
                if (!Kd(t, n)) {
                    if (Bo(t))
                        throw Error(r(418));
                    n = di(s.nextSibling);
                    var c = ft;
                    n && Kd(t, n) ? Ud(c, s) : (t.flags = t.flags & -4097 | 2,
                    Ee = !1,
                    ft = t)
                }
            } else {
                if (Bo(t))
                    throw Error(r(418));
                t.flags = t.flags & -4097 | 2,
                Ee = !1,
                ft = t
            }
        }
    }
    function $d(t) {
        for (t = t.return; t !== null && t.tag !== 5 && t.tag !== 3 && t.tag !== 13; )
            t = t.return;
        ft = t
    }
    function Ca(t) {
        if (t !== ft)
            return !1;
        if (!Ee)
            return $d(t),
            Ee = !0,
            !1;
        var n;
        if ((n = t.tag !== 3) && !(n = t.tag !== 5) && (n = t.type,
        n = n !== "head" && n !== "body" && !Io(t.type, t.memoizedProps)),
        n && (n = gt)) {
            if (Bo(t))
                throw Hd(),
                Error(r(418));
            for (; n; )
                Ud(t, n),
                n = di(n.nextSibling)
        }
        if ($d(t),
        t.tag === 13) {
            if (t = t.memoizedState,
            t = t !== null ? t.dehydrated : null,
            !t)
                throw Error(r(317));
            e: {
                for (t = t.nextSibling,
                n = 0; t; ) {
                    if (t.nodeType === 8) {
                        var s = t.data;
                        if (s === "/$") {
                            if (n === 0) {
                                gt = di(t.nextSibling);
                                break e
                            }
                            n--
                        } else
                            s !== "$" && s !== "$!" && s !== "$?" || n++
                    }
                    t = t.nextSibling
                }
                gt = null
            }
        } else
            gt = ft ? di(t.stateNode.nextSibling) : null;
        return !0
    }
    function Hd() {
        for (var t = gt; t; )
            t = di(t.nextSibling)
    }
    function hr() {
        gt = ft = null,
        Ee = !1
    }
    function _o(t) {
        Dt === null ? Dt = [t] : Dt.push(t)
    }
    var Zv = D.ReactCurrentBatchConfig;
    function dn(t, n, s) {
        if (t = s.ref,
        t !== null && typeof t != "function" && typeof t != "object") {
            if (s._owner) {
                if (s = s._owner,
                s) {
                    if (s.tag !== 1)
                        throw Error(r(309));
                    var c = s.stateNode
                }
                if (!c)
                    throw Error(r(147, t));
                var m = c
                  , f = "" + t;
                return n !== null && n.ref !== null && typeof n.ref == "function" && n.ref._stringRef === f ? n.ref : (n = function(k) {
                    var j = m.refs;
                    k === null ? delete j[f] : j[f] = k
                }
                ,
                n._stringRef = f,
                n)
            }
            if (typeof t != "string")
                throw Error(r(284));
            if (!s._owner)
                throw Error(r(290, t))
        }
        return t
    }
    function za(t, n) {
        throw t = Object.prototype.toString.call(n),
        Error(r(31, t === "[object Object]" ? "object with keys {" + Object.keys(n).join(", ") + "}" : t))
    }
    function Gd(t) {
        var n = t._init;
        return n(t._payload)
    }
    function qd(t) {
        function n(V, E) {
            if (t) {
                var L = V.deletions;
                L === null ? (V.deletions = [E],
                V.flags |= 16) : L.push(E)
            }
        }
        function s(V, E) {
            if (!t)
                return null;
            for (; E !== null; )
                n(V, E),
                E = E.sibling;
            return null
        }
        function c(V, E) {
            for (V = new Map; E !== null; )
                E.key !== null ? V.set(E.key, E) : V.set(E.index, E),
                E = E.sibling;
            return V
        }
        function m(V, E) {
            return V = Pi(V, E),
            V.index = 0,
            V.sibling = null,
            V
        }
        function f(V, E, L) {
            return V.index = L,
            t ? (L = V.alternate,
            L !== null ? (L = L.index,
            L < E ? (V.flags |= 2,
            E) : L) : (V.flags |= 2,
            E)) : (V.flags |= 1048576,
            E)
        }
        function k(V) {
            return t && V.alternate === null && (V.flags |= 2),
            V
        }
        function j(V, E, L, Y) {
            return E === null || E.tag !== 6 ? (E = Ml(L, V.mode, Y),
            E.return = V,
            E) : (E = m(E, L),
            E.return = V,
            E)
        }
        function A(V, E, L, Y) {
            var oe = L.type;
            return oe === _ ? G(V, E, L.props.children, Y, L.key) : E !== null && (E.elementType === oe || typeof oe == "object" && oe !== null && oe.$$typeof === ie && Gd(oe) === E.type) ? (Y = m(E, L.props),
            Y.ref = dn(V, E, L),
            Y.return = V,
            Y) : (Y = Qa(L.type, L.key, L.props, null, V.mode, Y),
            Y.ref = dn(V, E, L),
            Y.return = V,
            Y)
        }
        function O(V, E, L, Y) {
            return E === null || E.tag !== 4 || E.stateNode.containerInfo !== L.containerInfo || E.stateNode.implementation !== L.implementation ? (E = Vl(L, V.mode, Y),
            E.return = V,
            E) : (E = m(E, L.children || []),
            E.return = V,
            E)
        }
        function G(V, E, L, Y, oe) {
            return E === null || E.tag !== 7 ? (E = Ui(L, V.mode, Y, oe),
            E.return = V,
            E) : (E = m(E, L),
            E.return = V,
            E)
        }
        function q(V, E, L) {
            if (typeof E == "string" && E !== "" || typeof E == "number")
                return E = Ml("" + E, V.mode, L),
                E.return = V,
                E;
            if (typeof E == "object" && E !== null) {
                switch (E.$$typeof) {
                case M:
                    return L = Qa(E.type, E.key, E.props, null, V.mode, L),
                    L.ref = dn(V, null, E),
                    L.return = V,
                    L;
                case B:
                    return E = Vl(E, V.mode, L),
                    E.return = V,
                    E;
                case ie:
                    var Y = E._init;
                    return q(V, Y(E._payload), L)
                }
                if (Rr(E) || X(E))
                    return E = Ui(E, V.mode, L, null),
                    E.return = V,
                    E;
                za(V, E)
            }
            return null
        }
        function $(V, E, L, Y) {
            var oe = E !== null ? E.key : null;
            if (typeof L == "string" && L !== "" || typeof L == "number")
                return oe !== null ? null : j(V, E, "" + L, Y);
            if (typeof L == "object" && L !== null) {
                switch (L.$$typeof) {
                case M:
                    return L.key === oe ? A(V, E, L, Y) : null;
                case B:
                    return L.key === oe ? O(V, E, L, Y) : null;
                case ie:
                    return oe = L._init,
                    $(V, E, oe(L._payload), Y)
                }
                if (Rr(L) || X(L))
                    return oe !== null ? null : G(V, E, L, Y, null);
                za(V, L)
            }
            return null
        }
        function J(V, E, L, Y, oe) {
            if (typeof Y == "string" && Y !== "" || typeof Y == "number")
                return V = V.get(L) || null,
                j(E, V, "" + Y, oe);
            if (typeof Y == "object" && Y !== null) {
                switch (Y.$$typeof) {
                case M:
                    return V = V.get(Y.key === null ? L : Y.key) || null,
                    A(E, V, Y, oe);
                case B:
                    return V = V.get(Y.key === null ? L : Y.key) || null,
                    O(E, V, Y, oe);
                case ie:
                    var ce = Y._init;
                    return J(V, E, L, ce(Y._payload), oe)
                }
                if (Rr(Y) || X(Y))
                    return V = V.get(L) || null,
                    G(E, V, Y, oe, null);
                za(E, Y)
            }
            return null
        }
        function re(V, E, L, Y) {
            for (var oe = null, ce = null, ue = E, me = E = 0, He = null; ue !== null && me < L.length; me++) {
                ue.index > me ? (He = ue,
                ue = null) : He = ue.sibling;
                var we = $(V, ue, L[me], Y);
                if (we === null) {
                    ue === null && (ue = He);
                    break
                }
                t && ue && we.alternate === null && n(V, ue),
                E = f(we, E, me),
                ce === null ? oe = we : ce.sibling = we,
                ce = we,
                ue = He
            }
            if (me === L.length)
                return s(V, ue),
                Ee && Li(V, me),
                oe;
            if (ue === null) {
                for (; me < L.length; me++)
                    ue = q(V, L[me], Y),
                    ue !== null && (E = f(ue, E, me),
                    ce === null ? oe = ue : ce.sibling = ue,
                    ce = ue);
                return Ee && Li(V, me),
                oe
            }
            for (ue = c(V, ue); me < L.length; me++)
                He = J(ue, V, me, L[me], Y),
                He !== null && (t && He.alternate !== null && ue.delete(He.key === null ? me : He.key),
                E = f(He, E, me),
                ce === null ? oe = He : ce.sibling = He,
                ce = He);
            return t && ue.forEach(function(bi) {
                return n(V, bi)
            }),
            Ee && Li(V, me),
            oe
        }
        function ae(V, E, L, Y) {
            var oe = X(L);
            if (typeof oe != "function")
                throw Error(r(150));
            if (L = oe.call(L),
            L == null)
                throw Error(r(151));
            for (var ce = oe = null, ue = E, me = E = 0, He = null, we = L.next(); ue !== null && !we.done; me++,
            we = L.next()) {
                ue.index > me ? (He = ue,
                ue = null) : He = ue.sibling;
                var bi = $(V, ue, we.value, Y);
                if (bi === null) {
                    ue === null && (ue = He);
                    break
                }
                t && ue && bi.alternate === null && n(V, ue),
                E = f(bi, E, me),
                ce === null ? oe = bi : ce.sibling = bi,
                ce = bi,
                ue = He
            }
            if (we.done)
                return s(V, ue),
                Ee && Li(V, me),
                oe;
            if (ue === null) {
                for (; !we.done; me++,
                we = L.next())
                    we = q(V, we.value, Y),
                    we !== null && (E = f(we, E, me),
                    ce === null ? oe = we : ce.sibling = we,
                    ce = we);
                return Ee && Li(V, me),
                oe
            }
            for (ue = c(V, ue); !we.done; me++,
            we = L.next())
                we = J(ue, V, me, we.value, Y),
                we !== null && (t && we.alternate !== null && ue.delete(we.key === null ? me : we.key),
                E = f(we, E, me),
                ce === null ? oe = we : ce.sibling = we,
                ce = we);
            return t && ue.forEach(function(Ay) {
                return n(V, Ay)
            }),
            Ee && Li(V, me),
            oe
        }
        function Fe(V, E, L, Y) {
            if (typeof L == "object" && L !== null && L.type === _ && L.key === null && (L = L.props.children),
            typeof L == "object" && L !== null) {
                switch (L.$$typeof) {
                case M:
                    e: {
                        for (var oe = L.key, ce = E; ce !== null; ) {
                            if (ce.key === oe) {
                                if (oe = L.type,
                                oe === _) {
                                    if (ce.tag === 7) {
                                        s(V, ce.sibling),
                                        E = m(ce, L.props.children),
                                        E.return = V,
                                        V = E;
                                        break e
                                    }
                                } else if (ce.elementType === oe || typeof oe == "object" && oe !== null && oe.$$typeof === ie && Gd(oe) === ce.type) {
                                    s(V, ce.sibling),
                                    E = m(ce, L.props),
                                    E.ref = dn(V, ce, L),
                                    E.return = V,
                                    V = E;
                                    break e
                                }
                                s(V, ce);
                                break
                            } else
                                n(V, ce);
                            ce = ce.sibling
                        }
                        L.type === _ ? (E = Ui(L.props.children, V.mode, Y, L.key),
                        E.return = V,
                        V = E) : (Y = Qa(L.type, L.key, L.props, null, V.mode, Y),
                        Y.ref = dn(V, E, L),
                        Y.return = V,
                        V = Y)
                    }
                    return k(V);
                case B:
                    e: {
                        for (ce = L.key; E !== null; ) {
                            if (E.key === ce)
                                if (E.tag === 4 && E.stateNode.containerInfo === L.containerInfo && E.stateNode.implementation === L.implementation) {
                                    s(V, E.sibling),
                                    E = m(E, L.children || []),
                                    E.return = V,
                                    V = E;
                                    break e
                                } else {
                                    s(V, E);
                                    break
                                }
                            else
                                n(V, E);
                            E = E.sibling
                        }
                        E = Vl(L, V.mode, Y),
                        E.return = V,
                        V = E
                    }
                    return k(V);
                case ie:
                    return ce = L._init,
                    Fe(V, E, ce(L._payload), Y)
                }
                if (Rr(L))
                    return re(V, E, L, Y);
                if (X(L))
                    return ae(V, E, L, Y);
                za(V, L)
            }
            return typeof L == "string" && L !== "" || typeof L == "number" ? (L = "" + L,
            E !== null && E.tag === 6 ? (s(V, E.sibling),
            E = m(E, L),
            E.return = V,
            V = E) : (s(V, E),
            E = Ml(L, V.mode, Y),
            E.return = V,
            V = E),
            k(V)) : s(V, E)
        }
        return Fe
    }
    var fr = qd(!0)
      , Xd = qd(!1)
      , Aa = pi(null)
      , Ea = null
      , gr = null
      , Uo = null;
    function Ko() {
        Uo = gr = Ea = null
    }
    function $o(t) {
        var n = Aa.current;
        Ce(Aa),
        t._currentValue = n
    }
    function Ho(t, n, s) {
        for (; t !== null; ) {
            var c = t.alternate;
            if ((t.childLanes & n) !== n ? (t.childLanes |= n,
            c !== null && (c.childLanes |= n)) : c !== null && (c.childLanes & n) !== n && (c.childLanes |= n),
            t === s)
                break;
            t = t.return
        }
    }
    function vr(t, n) {
        Ea = t,
        Uo = gr = null,
        t = t.dependencies,
        t !== null && t.firstContext !== null && ((t.lanes & n) !== 0 && (ct = !0),
        t.firstContext = null)
    }
    function bt(t) {
        var n = t._currentValue;
        if (Uo !== t)
            if (t = {
                context: t,
                memoizedValue: n,
                next: null
            },
            gr === null) {
                if (Ea === null)
                    throw Error(r(308));
                gr = t,
                Ea.dependencies = {
                    lanes: 0,
                    firstContext: t
                }
            } else
                gr = gr.next = t;
        return n
    }
    var Oi = null;
    function Go(t) {
        Oi === null ? Oi = [t] : Oi.push(t)
    }
    function Zd(t, n, s, c) {
        var m = n.interleaved;
        return m === null ? (s.next = s,
        Go(n)) : (s.next = m.next,
        m.next = s),
        n.interleaved = s,
        Yt(t, c)
    }
    function Yt(t, n) {
        t.lanes |= n;
        var s = t.alternate;
        for (s !== null && (s.lanes |= n),
        s = t,
        t = t.return; t !== null; )
            t.childLanes |= n,
            s = t.alternate,
            s !== null && (s.childLanes |= n),
            s = t,
            t = t.return;
        return s.tag === 3 ? s.stateNode : null
    }
    var fi = !1;
    function qo(t) {
        t.updateQueue = {
            baseState: t.memoizedState,
            firstBaseUpdate: null,
            lastBaseUpdate: null,
            shared: {
                pending: null,
                interleaved: null,
                lanes: 0
            },
            effects: null
        }
    }
    function Yd(t, n) {
        t = t.updateQueue,
        n.updateQueue === t && (n.updateQueue = {
            baseState: t.baseState,
            firstBaseUpdate: t.firstBaseUpdate,
            lastBaseUpdate: t.lastBaseUpdate,
            shared: t.shared,
            effects: t.effects
        })
    }
    function Qt(t, n) {
        return {
            eventTime: t,
            lane: n,
            tag: 0,
            payload: null,
            callback: null,
            next: null
        }
    }
    function gi(t, n, s) {
        var c = t.updateQueue;
        if (c === null)
            return null;
        if (c = c.shared,
        (ye & 2) !== 0) {
            var m = c.pending;
            return m === null ? n.next = n : (n.next = m.next,
            m.next = n),
            c.pending = n,
            Yt(t, s)
        }
        return m = c.interleaved,
        m === null ? (n.next = n,
        Go(c)) : (n.next = m.next,
        m.next = n),
        c.interleaved = n,
        Yt(t, s)
    }
    function Da(t, n, s) {
        if (n = n.updateQueue,
        n !== null && (n = n.shared,
        (s & 4194240) !== 0)) {
            var c = n.lanes;
            c &= t.pendingLanes,
            s |= c,
            n.lanes = s,
            oo(t, s)
        }
    }
    function Qd(t, n) {
        var s = t.updateQueue
          , c = t.alternate;
        if (c !== null && (c = c.updateQueue,
        s === c)) {
            var m = null
              , f = null;
            if (s = s.firstBaseUpdate,
            s !== null) {
                do {
                    var k = {
                        eventTime: s.eventTime,
                        lane: s.lane,
                        tag: s.tag,
                        payload: s.payload,
                        callback: s.callback,
                        next: null
                    };
                    f === null ? m = f = k : f = f.next = k,
                    s = s.next
                } while (s !== null);
                f === null ? m = f = n : f = f.next = n
            } else
                m = f = n;
            s = {
                baseState: c.baseState,
                firstBaseUpdate: m,
                lastBaseUpdate: f,
                shared: c.shared,
                effects: c.effects
            },
            t.updateQueue = s;
            return
        }
        t = s.lastBaseUpdate,
        t === null ? s.firstBaseUpdate = n : t.next = n,
        s.lastBaseUpdate = n
    }
    function Ia(t, n, s, c) {
        var m = t.updateQueue;
        fi = !1;
        var f = m.firstBaseUpdate
          , k = m.lastBaseUpdate
          , j = m.shared.pending;
        if (j !== null) {
            m.shared.pending = null;
            var A = j
              , O = A.next;
            A.next = null,
            k === null ? f = O : k.next = O,
            k = A;
            var G = t.alternate;
            G !== null && (G = G.updateQueue,
            j = G.lastBaseUpdate,
            j !== k && (j === null ? G.firstBaseUpdate = O : j.next = O,
            G.lastBaseUpdate = A))
        }
        if (f !== null) {
            var q = m.baseState;
            k = 0,
            G = O = A = null,
            j = f;
            do {
                var $ = j.lane
                  , J = j.eventTime;
                if ((c & $) === $) {
                    G !== null && (G = G.next = {
                        eventTime: J,
                        lane: 0,
                        tag: j.tag,
                        payload: j.payload,
                        callback: j.callback,
                        next: null
                    });
                    e: {
                        var re = t
                          , ae = j;
                        switch ($ = n,
                        J = s,
                        ae.tag) {
                        case 1:
                            if (re = ae.payload,
                            typeof re == "function") {
                                q = re.call(J, q, $);
                                break e
                            }
                            q = re;
                            break e;
                        case 3:
                            re.flags = re.flags & -65537 | 128;
                        case 0:
                            if (re = ae.payload,
                            $ = typeof re == "function" ? re.call(J, q, $) : re,
                            $ == null)
                                break e;
                            q = Z({}, q, $);
                            break e;
                        case 2:
                            fi = !0
                        }
                    }
                    j.callback !== null && j.lane !== 0 && (t.flags |= 64,
                    $ = m.effects,
                    $ === null ? m.effects = [j] : $.push(j))
                } else
                    J = {
                        eventTime: J,
                        lane: $,
                        tag: j.tag,
                        payload: j.payload,
                        callback: j.callback,
                        next: null
                    },
                    G === null ? (O = G = J,
                    A = q) : G = G.next = J,
                    k |= $;
                if (j = j.next,
                j === null) {
                    if (j = m.shared.pending,
                    j === null)
                        break;
                    $ = j,
                    j = $.next,
                    $.next = null,
                    m.lastBaseUpdate = $,
                    m.shared.pending = null
                }
            } while (!0);
            if (G === null && (A = q),
            m.baseState = A,
            m.firstBaseUpdate = O,
            m.lastBaseUpdate = G,
            n = m.shared.interleaved,
            n !== null) {
                m = n;
                do
                    k |= m.lane,
                    m = m.next;
                while (m !== n)
            } else
                f === null && (m.shared.lanes = 0);
            Ri |= k,
            t.lanes = k,
            t.memoizedState = q
        }
    }
    function Jd(t, n, s) {
        if (t = n.effects,
        n.effects = null,
        t !== null)
            for (n = 0; n < t.length; n++) {
                var c = t[n]
                  , m = c.callback;
                if (m !== null) {
                    if (c.callback = null,
                    c = s,
                    typeof m != "function")
                        throw Error(r(191, m));
                    m.call(c)
                }
            }
    }
    var pn = {}
      , Rt = pi(pn)
      , mn = pi(pn)
      , hn = pi(pn);
    function Ni(t) {
        if (t === pn)
            throw Error(r(174));
        return t
    }
    function Xo(t, n) {
        switch (Te(hn, n),
        Te(mn, t),
        Te(Rt, pn),
        t = n.nodeType,
        t) {
        case 9:
        case 11:
            n = (n = n.documentElement) ? n.namespaceURI : Xs(null, "");
            break;
        default:
            t = t === 8 ? n.parentNode : n,
            n = t.namespaceURI || null,
            t = t.tagName,
            n = Xs(n, t)
        }
        Ce(Rt),
        Te(Rt, n)
    }
    function yr() {
        Ce(Rt),
        Ce(mn),
        Ce(hn)
    }
    function ep(t) {
        Ni(hn.current);
        var n = Ni(Rt.current)
          , s = Xs(n, t.type);
        n !== s && (Te(mn, t),
        Te(Rt, s))
    }
    function Zo(t) {
        mn.current === t && (Ce(Rt),
        Ce(mn))
    }
    var De = pi(0);
    function Ma(t) {
        for (var n = t; n !== null; ) {
            if (n.tag === 13) {
                var s = n.memoizedState;
                if (s !== null && (s = s.dehydrated,
                s === null || s.data === "$?" || s.data === "$!"))
                    return n
            } else if (n.tag === 19 && n.memoizedProps.revealOrder !== void 0) {
                if ((n.flags & 128) !== 0)
                    return n
            } else if (n.child !== null) {
                n.child.return = n,
                n = n.child;
                continue
            }
            if (n === t)
                break;
            for (; n.sibling === null; ) {
                if (n.return === null || n.return === t)
                    return null;
                n = n.return
            }
            n.sibling.return = n.return,
            n = n.sibling
        }
        return null
    }
    var Yo = [];
    function Qo() {
        for (var t = 0; t < Yo.length; t++)
            Yo[t]._workInProgressVersionPrimary = null;
        Yo.length = 0
    }
    var Va = D.ReactCurrentDispatcher
      , Jo = D.ReactCurrentBatchConfig
      , Fi = 0
      , Ie = null
      , _e = null
      , Ke = null
      , La = !1
      , fn = !1
      , gn = 0
      , Yv = 0;
    function Qe() {
        throw Error(r(321))
    }
    function el(t, n) {
        if (n === null)
            return !1;
        for (var s = 0; s < n.length && s < t.length; s++)
            if (!Et(t[s], n[s]))
                return !1;
        return !0
    }
    function tl(t, n, s, c, m, f) {
        if (Fi = f,
        Ie = n,
        n.memoizedState = null,
        n.updateQueue = null,
        n.lanes = 0,
        Va.current = t === null || t.memoizedState === null ? ty : iy,
        t = s(c, m),
        fn) {
            f = 0;
            do {
                if (fn = !1,
                gn = 0,
                25 <= f)
                    throw Error(r(301));
                f += 1,
                Ke = _e = null,
                n.updateQueue = null,
                Va.current = ry,
                t = s(c, m)
            } while (fn)
        }
        if (Va.current = Fa,
        n = _e !== null && _e.next !== null,
        Fi = 0,
        Ke = _e = Ie = null,
        La = !1,
        n)
            throw Error(r(300));
        return t
    }
    function il() {
        var t = gn !== 0;
        return gn = 0,
        t
    }
    function Bt() {
        var t = {
            memoizedState: null,
            baseState: null,
            baseQueue: null,
            queue: null,
            next: null
        };
        return Ke === null ? Ie.memoizedState = Ke = t : Ke = Ke.next = t,
        Ke
    }
    function St() {
        if (_e === null) {
            var t = Ie.alternate;
            t = t !== null ? t.memoizedState : null
        } else
            t = _e.next;
        var n = Ke === null ? Ie.memoizedState : Ke.next;
        if (n !== null)
            Ke = n,
            _e = t;
        else {
            if (t === null)
                throw Error(r(310));
            _e = t,
            t = {
                memoizedState: _e.memoizedState,
                baseState: _e.baseState,
                baseQueue: _e.baseQueue,
                queue: _e.queue,
                next: null
            },
            Ke === null ? Ie.memoizedState = Ke = t : Ke = Ke.next = t
        }
        return Ke
    }
    function vn(t, n) {
        return typeof n == "function" ? n(t) : n
    }
    function rl(t) {
        var n = St()
          , s = n.queue;
        if (s === null)
            throw Error(r(311));
        s.lastRenderedReducer = t;
        var c = _e
          , m = c.baseQueue
          , f = s.pending;
        if (f !== null) {
            if (m !== null) {
                var k = m.next;
                m.next = f.next,
                f.next = k
            }
            c.baseQueue = m = f,
            s.pending = null
        }
        if (m !== null) {
            f = m.next,
            c = c.baseState;
            var j = k = null
              , A = null
              , O = f;
            do {
                var G = O.lane;
                if ((Fi & G) === G)
                    A !== null && (A = A.next = {
                        lane: 0,
                        action: O.action,
                        hasEagerState: O.hasEagerState,
                        eagerState: O.eagerState,
                        next: null
                    }),
                    c = O.hasEagerState ? O.eagerState : t(c, O.action);
                else {
                    var q = {
                        lane: G,
                        action: O.action,
                        hasEagerState: O.hasEagerState,
                        eagerState: O.eagerState,
                        next: null
                    };
                    A === null ? (j = A = q,
                    k = c) : A = A.next = q,
                    Ie.lanes |= G,
                    Ri |= G
                }
                O = O.next
            } while (O !== null && O !== f);
            A === null ? k = c : A.next = j,
            Et(c, n.memoizedState) || (ct = !0),
            n.memoizedState = c,
            n.baseState = k,
            n.baseQueue = A,
            s.lastRenderedState = c
        }
        if (t = s.interleaved,
        t !== null) {
            m = t;
            do
                f = m.lane,
                Ie.lanes |= f,
                Ri |= f,
                m = m.next;
            while (m !== t)
        } else
            m === null && (s.lanes = 0);
        return [n.memoizedState, s.dispatch]
    }
    function nl(t) {
        var n = St()
          , s = n.queue;
        if (s === null)
            throw Error(r(311));
        s.lastRenderedReducer = t;
        var c = s.dispatch
          , m = s.pending
          , f = n.memoizedState;
        if (m !== null) {
            s.pending = null;
            var k = m = m.next;
            do
                f = t(f, k.action),
                k = k.next;
            while (k !== m);
            Et(f, n.memoizedState) || (ct = !0),
            n.memoizedState = f,
            n.baseQueue === null && (n.baseState = f),
            s.lastRenderedState = f
        }
        return [f, c]
    }
    function tp() {}
    function ip(t, n) {
        var s = Ie
          , c = St()
          , m = n()
          , f = !Et(c.memoizedState, m);
        if (f && (c.memoizedState = m,
        ct = !0),
        c = c.queue,
        al(ap.bind(null, s, c, t), [t]),
        c.getSnapshot !== n || f || Ke !== null && Ke.memoizedState.tag & 1) {
            if (s.flags |= 2048,
            yn(9, np.bind(null, s, c, m, n), void 0, null),
            $e === null)
                throw Error(r(349));
            (Fi & 30) !== 0 || rp(s, n, m)
        }
        return m
    }
    function rp(t, n, s) {
        t.flags |= 16384,
        t = {
            getSnapshot: n,
            value: s
        },
        n = Ie.updateQueue,
        n === null ? (n = {
            lastEffect: null,
            stores: null
        },
        Ie.updateQueue = n,
        n.stores = [t]) : (s = n.stores,
        s === null ? n.stores = [t] : s.push(t))
    }
    function np(t, n, s, c) {
        n.value = s,
        n.getSnapshot = c,
        sp(n) && op(t)
    }
    function ap(t, n, s) {
        return s(function() {
            sp(n) && op(t)
        })
    }
    function sp(t) {
        var n = t.getSnapshot;
        t = t.value;
        try {
            var s = n();
            return !Et(t, s)
        } catch {
            return !0
        }
    }
    function op(t) {
        var n = Yt(t, 1);
        n !== null && Lt(n, t, 1, -1)
    }
    function lp(t) {
        var n = Bt();
        return typeof t == "function" && (t = t()),
        n.memoizedState = n.baseState = t,
        t = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: vn,
            lastRenderedState: t
        },
        n.queue = t,
        t = t.dispatch = ey.bind(null, Ie, t),
        [n.memoizedState, t]
    }
    function yn(t, n, s, c) {
        return t = {
            tag: t,
            create: n,
            destroy: s,
            deps: c,
            next: null
        },
        n = Ie.updateQueue,
        n === null ? (n = {
            lastEffect: null,
            stores: null
        },
        Ie.updateQueue = n,
        n.lastEffect = t.next = t) : (s = n.lastEffect,
        s === null ? n.lastEffect = t.next = t : (c = s.next,
        s.next = t,
        t.next = c,
        n.lastEffect = t)),
        t
    }
    function cp() {
        return St().memoizedState
    }
    function Oa(t, n, s, c) {
        var m = Bt();
        Ie.flags |= t,
        m.memoizedState = yn(1 | n, s, void 0, c === void 0 ? null : c)
    }
    function Na(t, n, s, c) {
        var m = St();
        c = c === void 0 ? null : c;
        var f = void 0;
        if (_e !== null) {
            var k = _e.memoizedState;
            if (f = k.destroy,
            c !== null && el(c, k.deps)) {
                m.memoizedState = yn(n, s, f, c);
                return
            }
        }
        Ie.flags |= t,
        m.memoizedState = yn(1 | n, s, f, c)
    }
    function up(t, n) {
        return Oa(8390656, 8, t, n)
    }
    function al(t, n) {
        return Na(2048, 8, t, n)
    }
    function dp(t, n) {
        return Na(4, 2, t, n)
    }
    function pp(t, n) {
        return Na(4, 4, t, n)
    }
    function mp(t, n) {
        if (typeof n == "function")
            return t = t(),
            n(t),
            function() {
                n(null)
            }
            ;
        if (n != null)
            return t = t(),
            n.current = t,
            function() {
                n.current = null
            }
    }
    function hp(t, n, s) {
        return s = s != null ? s.concat([t]) : null,
        Na(4, 4, mp.bind(null, n, t), s)
    }
    function sl() {}
    function fp(t, n) {
        var s = St();
        n = n === void 0 ? null : n;
        var c = s.memoizedState;
        return c !== null && n !== null && el(n, c[1]) ? c[0] : (s.memoizedState = [t, n],
        t)
    }
    function gp(t, n) {
        var s = St();
        n = n === void 0 ? null : n;
        var c = s.memoizedState;
        return c !== null && n !== null && el(n, c[1]) ? c[0] : (t = t(),
        s.memoizedState = [t, n],
        t)
    }
    function vp(t, n, s) {
        return (Fi & 21) === 0 ? (t.baseState && (t.baseState = !1,
        ct = !0),
        t.memoizedState = s) : (Et(s, n) || (s = Gu(),
        Ie.lanes |= s,
        Ri |= s,
        t.baseState = !0),
        n)
    }
    function Qv(t, n) {
        var s = be;
        be = s !== 0 && 4 > s ? s : 4,
        t(!0);
        var c = Jo.transition;
        Jo.transition = {};
        try {
            t(!1),
            n()
        } finally {
            be = s,
            Jo.transition = c
        }
    }
    function yp() {
        return St().memoizedState
    }
    function Jv(t, n, s) {
        var c = xi(t);
        if (s = {
            lane: c,
            action: s,
            hasEagerState: !1,
            eagerState: null,
            next: null
        },
        kp(t))
            xp(n, s);
        else if (s = Zd(t, n, s, c),
        s !== null) {
            var m = at();
            Lt(s, t, c, m),
            wp(s, n, c)
        }
    }
    function ey(t, n, s) {
        var c = xi(t)
          , m = {
            lane: c,
            action: s,
            hasEagerState: !1,
            eagerState: null,
            next: null
        };
        if (kp(t))
            xp(n, m);
        else {
            var f = t.alternate;
            if (t.lanes === 0 && (f === null || f.lanes === 0) && (f = n.lastRenderedReducer,
            f !== null))
                try {
                    var k = n.lastRenderedState
                      , j = f(k, s);
                    if (m.hasEagerState = !0,
                    m.eagerState = j,
                    Et(j, k)) {
                        var A = n.interleaved;
                        A === null ? (m.next = m,
                        Go(n)) : (m.next = A.next,
                        A.next = m),
                        n.interleaved = m;
                        return
                    }
                } catch {} finally {}
            s = Zd(t, n, m, c),
            s !== null && (m = at(),
            Lt(s, t, c, m),
            wp(s, n, c))
        }
    }
    function kp(t) {
        var n = t.alternate;
        return t === Ie || n !== null && n === Ie
    }
    function xp(t, n) {
        fn = La = !0;
        var s = t.pending;
        s === null ? n.next = n : (n.next = s.next,
        s.next = n),
        t.pending = n
    }
    function wp(t, n, s) {
        if ((s & 4194240) !== 0) {
            var c = n.lanes;
            c &= t.pendingLanes,
            s |= c,
            n.lanes = s,
            oo(t, s)
        }
    }
    var Fa = {
        readContext: bt,
        useCallback: Qe,
        useContext: Qe,
        useEffect: Qe,
        useImperativeHandle: Qe,
        useInsertionEffect: Qe,
        useLayoutEffect: Qe,
        useMemo: Qe,
        useReducer: Qe,
        useRef: Qe,
        useState: Qe,
        useDebugValue: Qe,
        useDeferredValue: Qe,
        useTransition: Qe,
        useMutableSource: Qe,
        useSyncExternalStore: Qe,
        useId: Qe,
        unstable_isNewReconciler: !1
    }
      , ty = {
        readContext: bt,
        useCallback: function(t, n) {
            return Bt().memoizedState = [t, n === void 0 ? null : n],
            t
        },
        useContext: bt,
        useEffect: up,
        useImperativeHandle: function(t, n, s) {
            return s = s != null ? s.concat([t]) : null,
            Oa(4194308, 4, mp.bind(null, n, t), s)
        },
        useLayoutEffect: function(t, n) {
            return Oa(4194308, 4, t, n)
        },
        useInsertionEffect: function(t, n) {
            return Oa(4, 2, t, n)
        },
        useMemo: function(t, n) {
            var s = Bt();
            return n = n === void 0 ? null : n,
            t = t(),
            s.memoizedState = [t, n],
            t
        },
        useReducer: function(t, n, s) {
            var c = Bt();
            return n = s !== void 0 ? s(n) : n,
            c.memoizedState = c.baseState = n,
            t = {
                pending: null,
                interleaved: null,
                lanes: 0,
                dispatch: null,
                lastRenderedReducer: t,
                lastRenderedState: n
            },
            c.queue = t,
            t = t.dispatch = Jv.bind(null, Ie, t),
            [c.memoizedState, t]
        },
        useRef: function(t) {
            var n = Bt();
            return t = {
                current: t
            },
            n.memoizedState = t
        },
        useState: lp,
        useDebugValue: sl,
        useDeferredValue: function(t) {
            return Bt().memoizedState = t
        },
        useTransition: function() {
            var t = lp(!1)
              , n = t[0];
            return t = Qv.bind(null, t[1]),
            Bt().memoizedState = t,
            [n, t]
        },
        useMutableSource: function() {},
        useSyncExternalStore: function(t, n, s) {
            var c = Ie
              , m = Bt();
            if (Ee) {
                if (s === void 0)
                    throw Error(r(407));
                s = s()
            } else {
                if (s = n(),
                $e === null)
                    throw Error(r(349));
                (Fi & 30) !== 0 || rp(c, n, s)
            }
            m.memoizedState = s;
            var f = {
                value: s,
                getSnapshot: n
            };
            return m.queue = f,
            up(ap.bind(null, c, f, t), [t]),
            c.flags |= 2048,
            yn(9, np.bind(null, c, f, s, n), void 0, null),
            s
        },
        useId: function() {
            var t = Bt()
              , n = $e.identifierPrefix;
            if (Ee) {
                var s = Zt
                  , c = Xt;
                s = (c & ~(1 << 32 - At(c) - 1)).toString(32) + s,
                n = ":" + n + "R" + s,
                s = gn++,
                0 < s && (n += "H" + s.toString(32)),
                n += ":"
            } else
                s = Yv++,
                n = ":" + n + "r" + s.toString(32) + ":";
            return t.memoizedState = n
        },
        unstable_isNewReconciler: !1
    }
      , iy = {
        readContext: bt,
        useCallback: fp,
        useContext: bt,
        useEffect: al,
        useImperativeHandle: hp,
        useInsertionEffect: dp,
        useLayoutEffect: pp,
        useMemo: gp,
        useReducer: rl,
        useRef: cp,
        useState: function() {
            return rl(vn)
        },
        useDebugValue: sl,
        useDeferredValue: function(t) {
            var n = St();
            return vp(n, _e.memoizedState, t)
        },
        useTransition: function() {
            var t = rl(vn)[0]
              , n = St().memoizedState;
            return [t, n]
        },
        useMutableSource: tp,
        useSyncExternalStore: ip,
        useId: yp,
        unstable_isNewReconciler: !1
    }
      , ry = {
        readContext: bt,
        useCallback: fp,
        useContext: bt,
        useEffect: al,
        useImperativeHandle: hp,
        useInsertionEffect: dp,
        useLayoutEffect: pp,
        useMemo: gp,
        useReducer: nl,
        useRef: cp,
        useState: function() {
            return nl(vn)
        },
        useDebugValue: sl,
        useDeferredValue: function(t) {
            var n = St();
            return _e === null ? n.memoizedState = t : vp(n, _e.memoizedState, t)
        },
        useTransition: function() {
            var t = nl(vn)[0]
              , n = St().memoizedState;
            return [t, n]
        },
        useMutableSource: tp,
        useSyncExternalStore: ip,
        useId: yp,
        unstable_isNewReconciler: !1
    };
    function It(t, n) {
        if (t && t.defaultProps) {
            n = Z({}, n),
            t = t.defaultProps;
            for (var s in t)
                n[s] === void 0 && (n[s] = t[s]);
            return n
        }
        return n
    }
    function ol(t, n, s, c) {
        n = t.memoizedState,
        s = s(c, n),
        s = s == null ? n : Z({}, n, s),
        t.memoizedState = s,
        t.lanes === 0 && (t.updateQueue.baseState = s)
    }
    var Ra = {
        isMounted: function(t) {
            return (t = t._reactInternals) ? Di(t) === t : !1
        },
        enqueueSetState: function(t, n, s) {
            t = t._reactInternals;
            var c = at()
              , m = xi(t)
              , f = Qt(c, m);
            f.payload = n,
            s != null && (f.callback = s),
            n = gi(t, f, m),
            n !== null && (Lt(n, t, m, c),
            Da(n, t, m))
        },
        enqueueReplaceState: function(t, n, s) {
            t = t._reactInternals;
            var c = at()
              , m = xi(t)
              , f = Qt(c, m);
            f.tag = 1,
            f.payload = n,
            s != null && (f.callback = s),
            n = gi(t, f, m),
            n !== null && (Lt(n, t, m, c),
            Da(n, t, m))
        },
        enqueueForceUpdate: function(t, n) {
            t = t._reactInternals;
            var s = at()
              , c = xi(t)
              , m = Qt(s, c);
            m.tag = 2,
            n != null && (m.callback = n),
            n = gi(t, m, c),
            n !== null && (Lt(n, t, c, s),
            Da(n, t, c))
        }
    };
    function Pp(t, n, s, c, m, f, k) {
        return t = t.stateNode,
        typeof t.shouldComponentUpdate == "function" ? t.shouldComponentUpdate(c, f, k) : n.prototype && n.prototype.isPureReactComponent ? !nn(s, c) || !nn(m, f) : !0
    }
    function bp(t, n, s) {
        var c = !1
          , m = mi
          , f = n.contextType;
        return typeof f == "object" && f !== null ? f = bt(f) : (m = lt(n) ? Mi : Ye.current,
        c = n.contextTypes,
        f = (c = c != null) ? dr(t, m) : mi),
        n = new n(s,f),
        t.memoizedState = n.state !== null && n.state !== void 0 ? n.state : null,
        n.updater = Ra,
        t.stateNode = n,
        n._reactInternals = t,
        c && (t = t.stateNode,
        t.__reactInternalMemoizedUnmaskedChildContext = m,
        t.__reactInternalMemoizedMaskedChildContext = f),
        n
    }
    function Sp(t, n, s, c) {
        t = n.state,
        typeof n.componentWillReceiveProps == "function" && n.componentWillReceiveProps(s, c),
        typeof n.UNSAFE_componentWillReceiveProps == "function" && n.UNSAFE_componentWillReceiveProps(s, c),
        n.state !== t && Ra.enqueueReplaceState(n, n.state, null)
    }
    function ll(t, n, s, c) {
        var m = t.stateNode;
        m.props = s,
        m.state = t.memoizedState,
        m.refs = {},
        qo(t);
        var f = n.contextType;
        typeof f == "object" && f !== null ? m.context = bt(f) : (f = lt(n) ? Mi : Ye.current,
        m.context = dr(t, f)),
        m.state = t.memoizedState,
        f = n.getDerivedStateFromProps,
        typeof f == "function" && (ol(t, n, f, s),
        m.state = t.memoizedState),
        typeof n.getDerivedStateFromProps == "function" || typeof m.getSnapshotBeforeUpdate == "function" || typeof m.UNSAFE_componentWillMount != "function" && typeof m.componentWillMount != "function" || (n = m.state,
        typeof m.componentWillMount == "function" && m.componentWillMount(),
        typeof m.UNSAFE_componentWillMount == "function" && m.UNSAFE_componentWillMount(),
        n !== m.state && Ra.enqueueReplaceState(m, m.state, null),
        Ia(t, s, m, c),
        m.state = t.memoizedState),
        typeof m.componentDidMount == "function" && (t.flags |= 4194308)
    }
    function kr(t, n) {
        try {
            var s = ""
              , c = n;
            do
                s += ke(c),
                c = c.return;
            while (c);
            var m = s
        } catch (f) {
            m = `
Error generating stack: ` + f.message + `
` + f.stack
        }
        return {
            value: t,
            source: n,
            stack: m,
            digest: null
        }
    }
    function cl(t, n, s) {
        return {
            value: t,
            source: null,
            stack: s ?? null,
            digest: n ?? null
        }
    }
    function ul(t, n) {
        try {
            console.error(n.value)
        } catch (s) {
            setTimeout(function() {
                throw s
            })
        }
    }
    var ny = typeof WeakMap == "function" ? WeakMap : Map;
    function Tp(t, n, s) {
        s = Qt(-1, s),
        s.tag = 3,
        s.payload = {
            element: null
        };
        var c = n.value;
        return s.callback = function() {
            Ha || (Ha = !0,
            Tl = c),
            ul(t, n)
        }
        ,
        s
    }
    function jp(t, n, s) {
        s = Qt(-1, s),
        s.tag = 3;
        var c = t.type.getDerivedStateFromError;
        if (typeof c == "function") {
            var m = n.value;
            s.payload = function() {
                return c(m)
            }
            ,
            s.callback = function() {
                ul(t, n)
            }
        }
        var f = t.stateNode;
        return f !== null && typeof f.componentDidCatch == "function" && (s.callback = function() {
            ul(t, n),
            typeof c != "function" && (yi === null ? yi = new Set([this]) : yi.add(this));
            var k = n.stack;
            this.componentDidCatch(n.value, {
                componentStack: k !== null ? k : ""
            })
        }
        ),
        s
    }
    function Cp(t, n, s) {
        var c = t.pingCache;
        if (c === null) {
            c = t.pingCache = new ny;
            var m = new Set;
            c.set(n, m)
        } else
            m = c.get(n),
            m === void 0 && (m = new Set,
            c.set(n, m));
        m.has(s) || (m.add(s),
        t = yy.bind(null, t, n, s),
        n.then(t, t))
    }
    function zp(t) {
        do {
            var n;
            if ((n = t.tag === 13) && (n = t.memoizedState,
            n = n !== null ? n.dehydrated !== null : !0),
            n)
                return t;
            t = t.return
        } while (t !== null);
        return null
    }
    function Ap(t, n, s, c, m) {
        return (t.mode & 1) === 0 ? (t === n ? t.flags |= 65536 : (t.flags |= 128,
        s.flags |= 131072,
        s.flags &= -52805,
        s.tag === 1 && (s.alternate === null ? s.tag = 17 : (n = Qt(-1, 1),
        n.tag = 2,
        gi(s, n, 1))),
        s.lanes |= 1),
        t) : (t.flags |= 65536,
        t.lanes = m,
        t)
    }
    var ay = D.ReactCurrentOwner
      , ct = !1;
    function nt(t, n, s, c) {
        n.child = t === null ? Xd(n, null, s, c) : fr(n, t.child, s, c)
    }
    function Ep(t, n, s, c, m) {
        s = s.render;
        var f = n.ref;
        return vr(n, m),
        c = tl(t, n, s, c, f, m),
        s = il(),
        t !== null && !ct ? (n.updateQueue = t.updateQueue,
        n.flags &= -2053,
        t.lanes &= ~m,
        Jt(t, n, m)) : (Ee && s && Fo(n),
        n.flags |= 1,
        nt(t, n, c, m),
        n.child)
    }
    function Dp(t, n, s, c, m) {
        if (t === null) {
            var f = s.type;
            return typeof f == "function" && !Il(f) && f.defaultProps === void 0 && s.compare === null && s.defaultProps === void 0 ? (n.tag = 15,
            n.type = f,
            Ip(t, n, f, c, m)) : (t = Qa(s.type, null, c, n, n.mode, m),
            t.ref = n.ref,
            t.return = n,
            n.child = t)
        }
        if (f = t.child,
        (t.lanes & m) === 0) {
            var k = f.memoizedProps;
            if (s = s.compare,
            s = s !== null ? s : nn,
            s(k, c) && t.ref === n.ref)
                return Jt(t, n, m)
        }
        return n.flags |= 1,
        t = Pi(f, c),
        t.ref = n.ref,
        t.return = n,
        n.child = t
    }
    function Ip(t, n, s, c, m) {
        if (t !== null) {
            var f = t.memoizedProps;
            if (nn(f, c) && t.ref === n.ref)
                if (ct = !1,
                n.pendingProps = c = f,
                (t.lanes & m) !== 0)
                    (t.flags & 131072) !== 0 && (ct = !0);
                else
                    return n.lanes = t.lanes,
                    Jt(t, n, m)
        }
        return dl(t, n, s, c, m)
    }
    function Mp(t, n, s) {
        var c = n.pendingProps
          , m = c.children
          , f = t !== null ? t.memoizedState : null;
        if (c.mode === "hidden")
            if ((n.mode & 1) === 0)
                n.memoizedState = {
                    baseLanes: 0,
                    cachePool: null,
                    transitions: null
                },
                Te(wr, vt),
                vt |= s;
            else {
                if ((s & 1073741824) === 0)
                    return t = f !== null ? f.baseLanes | s : s,
                    n.lanes = n.childLanes = 1073741824,
                    n.memoizedState = {
                        baseLanes: t,
                        cachePool: null,
                        transitions: null
                    },
                    n.updateQueue = null,
                    Te(wr, vt),
                    vt |= t,
                    null;
                n.memoizedState = {
                    baseLanes: 0,
                    cachePool: null,
                    transitions: null
                },
                c = f !== null ? f.baseLanes : s,
                Te(wr, vt),
                vt |= c
            }
        else
            f !== null ? (c = f.baseLanes | s,
            n.memoizedState = null) : c = s,
            Te(wr, vt),
            vt |= c;
        return nt(t, n, m, s),
        n.child
    }
    function Vp(t, n) {
        var s = n.ref;
        (t === null && s !== null || t !== null && t.ref !== s) && (n.flags |= 512,
        n.flags |= 2097152)
    }
    function dl(t, n, s, c, m) {
        var f = lt(s) ? Mi : Ye.current;
        return f = dr(n, f),
        vr(n, m),
        s = tl(t, n, s, c, f, m),
        c = il(),
        t !== null && !ct ? (n.updateQueue = t.updateQueue,
        n.flags &= -2053,
        t.lanes &= ~m,
        Jt(t, n, m)) : (Ee && c && Fo(n),
        n.flags |= 1,
        nt(t, n, s, m),
        n.child)
    }
    function Lp(t, n, s, c, m) {
        if (lt(s)) {
            var f = !0;
            ba(n)
        } else
            f = !1;
        if (vr(n, m),
        n.stateNode === null)
            Wa(t, n),
            bp(n, s, c),
            ll(n, s, c, m),
            c = !0;
        else if (t === null) {
            var k = n.stateNode
              , j = n.memoizedProps;
            k.props = j;
            var A = k.context
              , O = s.contextType;
            typeof O == "object" && O !== null ? O = bt(O) : (O = lt(s) ? Mi : Ye.current,
            O = dr(n, O));
            var G = s.getDerivedStateFromProps
              , q = typeof G == "function" || typeof k.getSnapshotBeforeUpdate == "function";
            q || typeof k.UNSAFE_componentWillReceiveProps != "function" && typeof k.componentWillReceiveProps != "function" || (j !== c || A !== O) && Sp(n, k, c, O),
            fi = !1;
            var $ = n.memoizedState;
            k.state = $,
            Ia(n, c, k, m),
            A = n.memoizedState,
            j !== c || $ !== A || ot.current || fi ? (typeof G == "function" && (ol(n, s, G, c),
            A = n.memoizedState),
            (j = fi || Pp(n, s, j, c, $, A, O)) ? (q || typeof k.UNSAFE_componentWillMount != "function" && typeof k.componentWillMount != "function" || (typeof k.componentWillMount == "function" && k.componentWillMount(),
            typeof k.UNSAFE_componentWillMount == "function" && k.UNSAFE_componentWillMount()),
            typeof k.componentDidMount == "function" && (n.flags |= 4194308)) : (typeof k.componentDidMount == "function" && (n.flags |= 4194308),
            n.memoizedProps = c,
            n.memoizedState = A),
            k.props = c,
            k.state = A,
            k.context = O,
            c = j) : (typeof k.componentDidMount == "function" && (n.flags |= 4194308),
            c = !1)
        } else {
            k = n.stateNode,
            Yd(t, n),
            j = n.memoizedProps,
            O = n.type === n.elementType ? j : It(n.type, j),
            k.props = O,
            q = n.pendingProps,
            $ = k.context,
            A = s.contextType,
            typeof A == "object" && A !== null ? A = bt(A) : (A = lt(s) ? Mi : Ye.current,
            A = dr(n, A));
            var J = s.getDerivedStateFromProps;
            (G = typeof J == "function" || typeof k.getSnapshotBeforeUpdate == "function") || typeof k.UNSAFE_componentWillReceiveProps != "function" && typeof k.componentWillReceiveProps != "function" || (j !== q || $ !== A) && Sp(n, k, c, A),
            fi = !1,
            $ = n.memoizedState,
            k.state = $,
            Ia(n, c, k, m);
            var re = n.memoizedState;
            j !== q || $ !== re || ot.current || fi ? (typeof J == "function" && (ol(n, s, J, c),
            re = n.memoizedState),
            (O = fi || Pp(n, s, O, c, $, re, A) || !1) ? (G || typeof k.UNSAFE_componentWillUpdate != "function" && typeof k.componentWillUpdate != "function" || (typeof k.componentWillUpdate == "function" && k.componentWillUpdate(c, re, A),
            typeof k.UNSAFE_componentWillUpdate == "function" && k.UNSAFE_componentWillUpdate(c, re, A)),
            typeof k.componentDidUpdate == "function" && (n.flags |= 4),
            typeof k.getSnapshotBeforeUpdate == "function" && (n.flags |= 1024)) : (typeof k.componentDidUpdate != "function" || j === t.memoizedProps && $ === t.memoizedState || (n.flags |= 4),
            typeof k.getSnapshotBeforeUpdate != "function" || j === t.memoizedProps && $ === t.memoizedState || (n.flags |= 1024),
            n.memoizedProps = c,
            n.memoizedState = re),
            k.props = c,
            k.state = re,
            k.context = A,
            c = O) : (typeof k.componentDidUpdate != "function" || j === t.memoizedProps && $ === t.memoizedState || (n.flags |= 4),
            typeof k.getSnapshotBeforeUpdate != "function" || j === t.memoizedProps && $ === t.memoizedState || (n.flags |= 1024),
            c = !1)
        }
        return pl(t, n, s, c, f, m)
    }
    function pl(t, n, s, c, m, f) {
        Vp(t, n);
        var k = (n.flags & 128) !== 0;
        if (!c && !k)
            return m && Bd(n, s, !1),
            Jt(t, n, f);
        c = n.stateNode,
        ay.current = n;
        var j = k && typeof s.getDerivedStateFromError != "function" ? null : c.render();
        return n.flags |= 1,
        t !== null && k ? (n.child = fr(n, t.child, null, f),
        n.child = fr(n, null, j, f)) : nt(t, n, j, f),
        n.memoizedState = c.state,
        m && Bd(n, s, !0),
        n.child
    }
    function Op(t) {
        var n = t.stateNode;
        n.pendingContext ? Fd(t, n.pendingContext, n.pendingContext !== n.context) : n.context && Fd(t, n.context, !1),
        Xo(t, n.containerInfo)
    }
    function Np(t, n, s, c, m) {
        return hr(),
        _o(m),
        n.flags |= 256,
        nt(t, n, s, c),
        n.child
    }
    var ml = {
        dehydrated: null,
        treeContext: null,
        retryLane: 0
    };
    function hl(t) {
        return {
            baseLanes: t,
            cachePool: null,
            transitions: null
        }
    }
    function Fp(t, n, s) {
        var c = n.pendingProps, m = De.current, f = !1, k = (n.flags & 128) !== 0, j;
        if ((j = k) || (j = t !== null && t.memoizedState === null ? !1 : (m & 2) !== 0),
        j ? (f = !0,
        n.flags &= -129) : (t === null || t.memoizedState !== null) && (m |= 1),
        Te(De, m & 1),
        t === null)
            return Wo(n),
            t = n.memoizedState,
            t !== null && (t = t.dehydrated,
            t !== null) ? ((n.mode & 1) === 0 ? n.lanes = 1 : t.data === "$!" ? n.lanes = 8 : n.lanes = 1073741824,
            null) : (k = c.children,
            t = c.fallback,
            f ? (c = n.mode,
            f = n.child,
            k = {
                mode: "hidden",
                children: k
            },
            (c & 1) === 0 && f !== null ? (f.childLanes = 0,
            f.pendingProps = k) : f = Ja(k, c, 0, null),
            t = Ui(t, c, s, null),
            f.return = n,
            t.return = n,
            f.sibling = t,
            n.child = f,
            n.child.memoizedState = hl(s),
            n.memoizedState = ml,
            t) : fl(n, k));
        if (m = t.memoizedState,
        m !== null && (j = m.dehydrated,
        j !== null))
            return sy(t, n, k, c, j, m, s);
        if (f) {
            f = c.fallback,
            k = n.mode,
            m = t.child,
            j = m.sibling;
            var A = {
                mode: "hidden",
                children: c.children
            };
            return (k & 1) === 0 && n.child !== m ? (c = n.child,
            c.childLanes = 0,
            c.pendingProps = A,
            n.deletions = null) : (c = Pi(m, A),
            c.subtreeFlags = m.subtreeFlags & 14680064),
            j !== null ? f = Pi(j, f) : (f = Ui(f, k, s, null),
            f.flags |= 2),
            f.return = n,
            c.return = n,
            c.sibling = f,
            n.child = c,
            c = f,
            f = n.child,
            k = t.child.memoizedState,
            k = k === null ? hl(s) : {
                baseLanes: k.baseLanes | s,
                cachePool: null,
                transitions: k.transitions
            },
            f.memoizedState = k,
            f.childLanes = t.childLanes & ~s,
            n.memoizedState = ml,
            c
        }
        return f = t.child,
        t = f.sibling,
        c = Pi(f, {
            mode: "visible",
            children: c.children
        }),
        (n.mode & 1) === 0 && (c.lanes = s),
        c.return = n,
        c.sibling = null,
        t !== null && (s = n.deletions,
        s === null ? (n.deletions = [t],
        n.flags |= 16) : s.push(t)),
        n.child = c,
        n.memoizedState = null,
        c
    }
    function fl(t, n) {
        return n = Ja({
            mode: "visible",
            children: n
        }, t.mode, 0, null),
        n.return = t,
        t.child = n
    }
    function Ba(t, n, s, c) {
        return c !== null && _o(c),
        fr(n, t.child, null, s),
        t = fl(n, n.pendingProps.children),
        t.flags |= 2,
        n.memoizedState = null,
        t
    }
    function sy(t, n, s, c, m, f, k) {
        if (s)
            return n.flags & 256 ? (n.flags &= -257,
            c = cl(Error(r(422))),
            Ba(t, n, k, c)) : n.memoizedState !== null ? (n.child = t.child,
            n.flags |= 128,
            null) : (f = c.fallback,
            m = n.mode,
            c = Ja({
                mode: "visible",
                children: c.children
            }, m, 0, null),
            f = Ui(f, m, k, null),
            f.flags |= 2,
            c.return = n,
            f.return = n,
            c.sibling = f,
            n.child = c,
            (n.mode & 1) !== 0 && fr(n, t.child, null, k),
            n.child.memoizedState = hl(k),
            n.memoizedState = ml,
            f);
        if ((n.mode & 1) === 0)
            return Ba(t, n, k, null);
        if (m.data === "$!") {
            if (c = m.nextSibling && m.nextSibling.dataset,
            c)
                var j = c.dgst;
            return c = j,
            f = Error(r(419)),
            c = cl(f, c, void 0),
            Ba(t, n, k, c)
        }
        if (j = (k & t.childLanes) !== 0,
        ct || j) {
            if (c = $e,
            c !== null) {
                switch (k & -k) {
                case 4:
                    m = 2;
                    break;
                case 16:
                    m = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    m = 32;
                    break;
                case 536870912:
                    m = 268435456;
                    break;
                default:
                    m = 0
                }
                m = (m & (c.suspendedLanes | k)) !== 0 ? 0 : m,
                m !== 0 && m !== f.retryLane && (f.retryLane = m,
                Yt(t, m),
                Lt(c, t, m, -1))
            }
            return Dl(),
            c = cl(Error(r(421))),
            Ba(t, n, k, c)
        }
        return m.data === "$?" ? (n.flags |= 128,
        n.child = t.child,
        n = ky.bind(null, t),
        m._reactRetry = n,
        null) : (t = f.treeContext,
        gt = di(m.nextSibling),
        ft = n,
        Ee = !0,
        Dt = null,
        t !== null && (wt[Pt++] = Xt,
        wt[Pt++] = Zt,
        wt[Pt++] = Vi,
        Xt = t.id,
        Zt = t.overflow,
        Vi = n),
        n = fl(n, c.children),
        n.flags |= 4096,
        n)
    }
    function Rp(t, n, s) {
        t.lanes |= n;
        var c = t.alternate;
        c !== null && (c.lanes |= n),
        Ho(t.return, n, s)
    }
    function gl(t, n, s, c, m) {
        var f = t.memoizedState;
        f === null ? t.memoizedState = {
            isBackwards: n,
            rendering: null,
            renderingStartTime: 0,
            last: c,
            tail: s,
            tailMode: m
        } : (f.isBackwards = n,
        f.rendering = null,
        f.renderingStartTime = 0,
        f.last = c,
        f.tail = s,
        f.tailMode = m)
    }
    function Bp(t, n, s) {
        var c = n.pendingProps
          , m = c.revealOrder
          , f = c.tail;
        if (nt(t, n, c.children, s),
        c = De.current,
        (c & 2) !== 0)
            c = c & 1 | 2,
            n.flags |= 128;
        else {
            if (t !== null && (t.flags & 128) !== 0)
                e: for (t = n.child; t !== null; ) {
                    if (t.tag === 13)
                        t.memoizedState !== null && Rp(t, s, n);
                    else if (t.tag === 19)
                        Rp(t, s, n);
                    else if (t.child !== null) {
                        t.child.return = t,
                        t = t.child;
                        continue
                    }
                    if (t === n)
                        break e;
                    for (; t.sibling === null; ) {
                        if (t.return === null || t.return === n)
                            break e;
                        t = t.return
                    }
                    t.sibling.return = t.return,
                    t = t.sibling
                }
            c &= 1
        }
        if (Te(De, c),
        (n.mode & 1) === 0)
            n.memoizedState = null;
        else
            switch (m) {
            case "forwards":
                for (s = n.child,
                m = null; s !== null; )
                    t = s.alternate,
                    t !== null && Ma(t) === null && (m = s),
                    s = s.sibling;
                s = m,
                s === null ? (m = n.child,
                n.child = null) : (m = s.sibling,
                s.sibling = null),
                gl(n, !1, m, s, f);
                break;
            case "backwards":
                for (s = null,
                m = n.child,
                n.child = null; m !== null; ) {
                    if (t = m.alternate,
                    t !== null && Ma(t) === null) {
                        n.child = m;
                        break
                    }
                    t = m.sibling,
                    m.sibling = s,
                    s = m,
                    m = t
                }
                gl(n, !0, s, null, f);
                break;
            case "together":
                gl(n, !1, null, null, void 0);
                break;
            default:
                n.memoizedState = null
            }
        return n.child
    }
    function Wa(t, n) {
        (n.mode & 1) === 0 && t !== null && (t.alternate = null,
        n.alternate = null,
        n.flags |= 2)
    }
    function Jt(t, n, s) {
        if (t !== null && (n.dependencies = t.dependencies),
        Ri |= n.lanes,
        (s & n.childLanes) === 0)
            return null;
        if (t !== null && n.child !== t.child)
            throw Error(r(153));
        if (n.child !== null) {
            for (t = n.child,
            s = Pi(t, t.pendingProps),
            n.child = s,
            s.return = n; t.sibling !== null; )
                t = t.sibling,
                s = s.sibling = Pi(t, t.pendingProps),
                s.return = n;
            s.sibling = null
        }
        return n.child
    }
    function oy(t, n, s) {
        switch (n.tag) {
        case 3:
            Op(n),
            hr();
            break;
        case 5:
            ep(n);
            break;
        case 1:
            lt(n.type) && ba(n);
            break;
        case 4:
            Xo(n, n.stateNode.containerInfo);
            break;
        case 10:
            var c = n.type._context
              , m = n.memoizedProps.value;
            Te(Aa, c._currentValue),
            c._currentValue = m;
            break;
        case 13:
            if (c = n.memoizedState,
            c !== null)
                return c.dehydrated !== null ? (Te(De, De.current & 1),
                n.flags |= 128,
                null) : (s & n.child.childLanes) !== 0 ? Fp(t, n, s) : (Te(De, De.current & 1),
                t = Jt(t, n, s),
                t !== null ? t.sibling : null);
            Te(De, De.current & 1);
            break;
        case 19:
            if (c = (s & n.childLanes) !== 0,
            (t.flags & 128) !== 0) {
                if (c)
                    return Bp(t, n, s);
                n.flags |= 128
            }
            if (m = n.memoizedState,
            m !== null && (m.rendering = null,
            m.tail = null,
            m.lastEffect = null),
            Te(De, De.current),
            c)
                break;
            return null;
        case 22:
        case 23:
            return n.lanes = 0,
            Mp(t, n, s)
        }
        return Jt(t, n, s)
    }
    var Wp, vl, _p, Up;
    Wp = function(t, n) {
        for (var s = n.child; s !== null; ) {
            if (s.tag === 5 || s.tag === 6)
                t.appendChild(s.stateNode);
            else if (s.tag !== 4 && s.child !== null) {
                s.child.return = s,
                s = s.child;
                continue
            }
            if (s === n)
                break;
            for (; s.sibling === null; ) {
                if (s.return === null || s.return === n)
                    return;
                s = s.return
            }
            s.sibling.return = s.return,
            s = s.sibling
        }
    }
    ,
    vl = function() {}
    ,
    _p = function(t, n, s, c) {
        var m = t.memoizedProps;
        if (m !== c) {
            t = n.stateNode,
            Ni(Rt.current);
            var f = null;
            switch (s) {
            case "input":
                m = $s(t, m),
                c = $s(t, c),
                f = [];
                break;
            case "select":
                m = Z({}, m, {
                    value: void 0
                }),
                c = Z({}, c, {
                    value: void 0
                }),
                f = [];
                break;
            case "textarea":
                m = qs(t, m),
                c = qs(t, c),
                f = [];
                break;
            default:
                typeof m.onClick != "function" && typeof c.onClick == "function" && (t.onclick = xa)
            }
            Zs(s, c);
            var k;
            s = null;
            for (O in m)
                if (!c.hasOwnProperty(O) && m.hasOwnProperty(O) && m[O] != null)
                    if (O === "style") {
                        var j = m[O];
                        for (k in j)
                            j.hasOwnProperty(k) && (s || (s = {}),
                            s[k] = "")
                    } else
                        O !== "dangerouslySetInnerHTML" && O !== "children" && O !== "suppressContentEditableWarning" && O !== "suppressHydrationWarning" && O !== "autoFocus" && (o.hasOwnProperty(O) ? f || (f = []) : (f = f || []).push(O, null));
            for (O in c) {
                var A = c[O];
                if (j = m != null ? m[O] : void 0,
                c.hasOwnProperty(O) && A !== j && (A != null || j != null))
                    if (O === "style")
                        if (j) {
                            for (k in j)
                                !j.hasOwnProperty(k) || A && A.hasOwnProperty(k) || (s || (s = {}),
                                s[k] = "");
                            for (k in A)
                                A.hasOwnProperty(k) && j[k] !== A[k] && (s || (s = {}),
                                s[k] = A[k])
                        } else
                            s || (f || (f = []),
                            f.push(O, s)),
                            s = A;
                    else
                        O === "dangerouslySetInnerHTML" ? (A = A ? A.__html : void 0,
                        j = j ? j.__html : void 0,
                        A != null && j !== A && (f = f || []).push(O, A)) : O === "children" ? typeof A != "string" && typeof A != "number" || (f = f || []).push(O, "" + A) : O !== "suppressContentEditableWarning" && O !== "suppressHydrationWarning" && (o.hasOwnProperty(O) ? (A != null && O === "onScroll" && je("scroll", t),
                        f || j === A || (f = [])) : (f = f || []).push(O, A))
            }
            s && (f = f || []).push("style", s);
            var O = f;
            (n.updateQueue = O) && (n.flags |= 4)
        }
    }
    ,
    Up = function(t, n, s, c) {
        s !== c && (n.flags |= 4)
    }
    ;
    function kn(t, n) {
        if (!Ee)
            switch (t.tailMode) {
            case "hidden":
                n = t.tail;
                for (var s = null; n !== null; )
                    n.alternate !== null && (s = n),
                    n = n.sibling;
                s === null ? t.tail = null : s.sibling = null;
                break;
            case "collapsed":
                s = t.tail;
                for (var c = null; s !== null; )
                    s.alternate !== null && (c = s),
                    s = s.sibling;
                c === null ? n || t.tail === null ? t.tail = null : t.tail.sibling = null : c.sibling = null
            }
    }
    function Je(t) {
        var n = t.alternate !== null && t.alternate.child === t.child
          , s = 0
          , c = 0;
        if (n)
            for (var m = t.child; m !== null; )
                s |= m.lanes | m.childLanes,
                c |= m.subtreeFlags & 14680064,
                c |= m.flags & 14680064,
                m.return = t,
                m = m.sibling;
        else
            for (m = t.child; m !== null; )
                s |= m.lanes | m.childLanes,
                c |= m.subtreeFlags,
                c |= m.flags,
                m.return = t,
                m = m.sibling;
        return t.subtreeFlags |= c,
        t.childLanes = s,
        n
    }
    function ly(t, n, s) {
        var c = n.pendingProps;
        switch (Ro(n),
        n.tag) {
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return Je(n),
            null;
        case 1:
            return lt(n.type) && Pa(),
            Je(n),
            null;
        case 3:
            return c = n.stateNode,
            yr(),
            Ce(ot),
            Ce(Ye),
            Qo(),
            c.pendingContext && (c.context = c.pendingContext,
            c.pendingContext = null),
            (t === null || t.child === null) && (Ca(n) ? n.flags |= 4 : t === null || t.memoizedState.isDehydrated && (n.flags & 256) === 0 || (n.flags |= 1024,
            Dt !== null && (zl(Dt),
            Dt = null))),
            vl(t, n),
            Je(n),
            null;
        case 5:
            Zo(n);
            var m = Ni(hn.current);
            if (s = n.type,
            t !== null && n.stateNode != null)
                _p(t, n, s, c, m),
                t.ref !== n.ref && (n.flags |= 512,
                n.flags |= 2097152);
            else {
                if (!c) {
                    if (n.stateNode === null)
                        throw Error(r(166));
                    return Je(n),
                    null
                }
                if (t = Ni(Rt.current),
                Ca(n)) {
                    c = n.stateNode,
                    s = n.type;
                    var f = n.memoizedProps;
                    switch (c[Ft] = n,
                    c[cn] = f,
                    t = (n.mode & 1) !== 0,
                    s) {
                    case "dialog":
                        je("cancel", c),
                        je("close", c);
                        break;
                    case "iframe":
                    case "object":
                    case "embed":
                        je("load", c);
                        break;
                    case "video":
                    case "audio":
                        for (m = 0; m < sn.length; m++)
                            je(sn[m], c);
                        break;
                    case "source":
                        je("error", c);
                        break;
                    case "img":
                    case "image":
                    case "link":
                        je("error", c),
                        je("load", c);
                        break;
                    case "details":
                        je("toggle", c);
                        break;
                    case "input":
                        bu(c, f),
                        je("invalid", c);
                        break;
                    case "select":
                        c._wrapperState = {
                            wasMultiple: !!f.multiple
                        },
                        je("invalid", c);
                        break;
                    case "textarea":
                        ju(c, f),
                        je("invalid", c)
                    }
                    Zs(s, f),
                    m = null;
                    for (var k in f)
                        if (f.hasOwnProperty(k)) {
                            var j = f[k];
                            k === "children" ? typeof j == "string" ? c.textContent !== j && (f.suppressHydrationWarning !== !0 && ka(c.textContent, j, t),
                            m = ["children", j]) : typeof j == "number" && c.textContent !== "" + j && (f.suppressHydrationWarning !== !0 && ka(c.textContent, j, t),
                            m = ["children", "" + j]) : o.hasOwnProperty(k) && j != null && k === "onScroll" && je("scroll", c)
                        }
                    switch (s) {
                    case "input":
                        Zn(c),
                        Tu(c, f, !0);
                        break;
                    case "textarea":
                        Zn(c),
                        zu(c);
                        break;
                    case "select":
                    case "option":
                        break;
                    default:
                        typeof f.onClick == "function" && (c.onclick = xa)
                    }
                    c = m,
                    n.updateQueue = c,
                    c !== null && (n.flags |= 4)
                } else {
                    k = m.nodeType === 9 ? m : m.ownerDocument,
                    t === "http://www.w3.org/1999/xhtml" && (t = Au(s)),
                    t === "http://www.w3.org/1999/xhtml" ? s === "script" ? (t = k.createElement("div"),
                    t.innerHTML = "<script><\/script>",
                    t = t.removeChild(t.firstChild)) : typeof c.is == "string" ? t = k.createElement(s, {
                        is: c.is
                    }) : (t = k.createElement(s),
                    s === "select" && (k = t,
                    c.multiple ? k.multiple = !0 : c.size && (k.size = c.size))) : t = k.createElementNS(t, s),
                    t[Ft] = n,
                    t[cn] = c,
                    Wp(t, n, !1, !1),
                    n.stateNode = t;
                    e: {
                        switch (k = Ys(s, c),
                        s) {
                        case "dialog":
                            je("cancel", t),
                            je("close", t),
                            m = c;
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            je("load", t),
                            m = c;
                            break;
                        case "video":
                        case "audio":
                            for (m = 0; m < sn.length; m++)
                                je(sn[m], t);
                            m = c;
                            break;
                        case "source":
                            je("error", t),
                            m = c;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            je("error", t),
                            je("load", t),
                            m = c;
                            break;
                        case "details":
                            je("toggle", t),
                            m = c;
                            break;
                        case "input":
                            bu(t, c),
                            m = $s(t, c),
                            je("invalid", t);
                            break;
                        case "option":
                            m = c;
                            break;
                        case "select":
                            t._wrapperState = {
                                wasMultiple: !!c.multiple
                            },
                            m = Z({}, c, {
                                value: void 0
                            }),
                            je("invalid", t);
                            break;
                        case "textarea":
                            ju(t, c),
                            m = qs(t, c),
                            je("invalid", t);
                            break;
                        default:
                            m = c
                        }
                        Zs(s, m),
                        j = m;
                        for (f in j)
                            if (j.hasOwnProperty(f)) {
                                var A = j[f];
                                f === "style" ? Iu(t, A) : f === "dangerouslySetInnerHTML" ? (A = A ? A.__html : void 0,
                                A != null && Eu(t, A)) : f === "children" ? typeof A == "string" ? (s !== "textarea" || A !== "") && Br(t, A) : typeof A == "number" && Br(t, "" + A) : f !== "suppressContentEditableWarning" && f !== "suppressHydrationWarning" && f !== "autoFocus" && (o.hasOwnProperty(f) ? A != null && f === "onScroll" && je("scroll", t) : A != null && T(t, f, A, k))
                            }
                        switch (s) {
                        case "input":
                            Zn(t),
                            Tu(t, c, !1);
                            break;
                        case "textarea":
                            Zn(t),
                            zu(t);
                            break;
                        case "option":
                            c.value != null && t.setAttribute("value", "" + Pe(c.value));
                            break;
                        case "select":
                            t.multiple = !!c.multiple,
                            f = c.value,
                            f != null ? Ji(t, !!c.multiple, f, !1) : c.defaultValue != null && Ji(t, !!c.multiple, c.defaultValue, !0);
                            break;
                        default:
                            typeof m.onClick == "function" && (t.onclick = xa)
                        }
                        switch (s) {
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            c = !!c.autoFocus;
                            break e;
                        case "img":
                            c = !0;
                            break e;
                        default:
                            c = !1
                        }
                    }
                    c && (n.flags |= 4)
                }
                n.ref !== null && (n.flags |= 512,
                n.flags |= 2097152)
            }
            return Je(n),
            null;
        case 6:
            if (t && n.stateNode != null)
                Up(t, n, t.memoizedProps, c);
            else {
                if (typeof c != "string" && n.stateNode === null)
                    throw Error(r(166));
                if (s = Ni(hn.current),
                Ni(Rt.current),
                Ca(n)) {
                    if (c = n.stateNode,
                    s = n.memoizedProps,
                    c[Ft] = n,
                    (f = c.nodeValue !== s) && (t = ft,
                    t !== null))
                        switch (t.tag) {
                        case 3:
                            ka(c.nodeValue, s, (t.mode & 1) !== 0);
                            break;
                        case 5:
                            t.memoizedProps.suppressHydrationWarning !== !0 && ka(c.nodeValue, s, (t.mode & 1) !== 0)
                        }
                    f && (n.flags |= 4)
                } else
                    c = (s.nodeType === 9 ? s : s.ownerDocument).createTextNode(c),
                    c[Ft] = n,
                    n.stateNode = c
            }
            return Je(n),
            null;
        case 13:
            if (Ce(De),
            c = n.memoizedState,
            t === null || t.memoizedState !== null && t.memoizedState.dehydrated !== null) {
                if (Ee && gt !== null && (n.mode & 1) !== 0 && (n.flags & 128) === 0)
                    Hd(),
                    hr(),
                    n.flags |= 98560,
                    f = !1;
                else if (f = Ca(n),
                c !== null && c.dehydrated !== null) {
                    if (t === null) {
                        if (!f)
                            throw Error(r(318));
                        if (f = n.memoizedState,
                        f = f !== null ? f.dehydrated : null,
                        !f)
                            throw Error(r(317));
                        f[Ft] = n
                    } else
                        hr(),
                        (n.flags & 128) === 0 && (n.memoizedState = null),
                        n.flags |= 4;
                    Je(n),
                    f = !1
                } else
                    Dt !== null && (zl(Dt),
                    Dt = null),
                    f = !0;
                if (!f)
                    return n.flags & 65536 ? n : null
            }
            return (n.flags & 128) !== 0 ? (n.lanes = s,
            n) : (c = c !== null,
            c !== (t !== null && t.memoizedState !== null) && c && (n.child.flags |= 8192,
            (n.mode & 1) !== 0 && (t === null || (De.current & 1) !== 0 ? Ue === 0 && (Ue = 3) : Dl())),
            n.updateQueue !== null && (n.flags |= 4),
            Je(n),
            null);
        case 4:
            return yr(),
            vl(t, n),
            t === null && on(n.stateNode.containerInfo),
            Je(n),
            null;
        case 10:
            return $o(n.type._context),
            Je(n),
            null;
        case 17:
            return lt(n.type) && Pa(),
            Je(n),
            null;
        case 19:
            if (Ce(De),
            f = n.memoizedState,
            f === null)
                return Je(n),
                null;
            if (c = (n.flags & 128) !== 0,
            k = f.rendering,
            k === null)
                if (c)
                    kn(f, !1);
                else {
                    if (Ue !== 0 || t !== null && (t.flags & 128) !== 0)
                        for (t = n.child; t !== null; ) {
                            if (k = Ma(t),
                            k !== null) {
                                for (n.flags |= 128,
                                kn(f, !1),
                                c = k.updateQueue,
                                c !== null && (n.updateQueue = c,
                                n.flags |= 4),
                                n.subtreeFlags = 0,
                                c = s,
                                s = n.child; s !== null; )
                                    f = s,
                                    t = c,
                                    f.flags &= 14680066,
                                    k = f.alternate,
                                    k === null ? (f.childLanes = 0,
                                    f.lanes = t,
                                    f.child = null,
                                    f.subtreeFlags = 0,
                                    f.memoizedProps = null,
                                    f.memoizedState = null,
                                    f.updateQueue = null,
                                    f.dependencies = null,
                                    f.stateNode = null) : (f.childLanes = k.childLanes,
                                    f.lanes = k.lanes,
                                    f.child = k.child,
                                    f.subtreeFlags = 0,
                                    f.deletions = null,
                                    f.memoizedProps = k.memoizedProps,
                                    f.memoizedState = k.memoizedState,
                                    f.updateQueue = k.updateQueue,
                                    f.type = k.type,
                                    t = k.dependencies,
                                    f.dependencies = t === null ? null : {
                                        lanes: t.lanes,
                                        firstContext: t.firstContext
                                    }),
                                    s = s.sibling;
                                return Te(De, De.current & 1 | 2),
                                n.child
                            }
                            t = t.sibling
                        }
                    f.tail !== null && Ne() > Pr && (n.flags |= 128,
                    c = !0,
                    kn(f, !1),
                    n.lanes = 4194304)
                }
            else {
                if (!c)
                    if (t = Ma(k),
                    t !== null) {
                        if (n.flags |= 128,
                        c = !0,
                        s = t.updateQueue,
                        s !== null && (n.updateQueue = s,
                        n.flags |= 4),
                        kn(f, !0),
                        f.tail === null && f.tailMode === "hidden" && !k.alternate && !Ee)
                            return Je(n),
                            null
                    } else
                        2 * Ne() - f.renderingStartTime > Pr && s !== 1073741824 && (n.flags |= 128,
                        c = !0,
                        kn(f, !1),
                        n.lanes = 4194304);
                f.isBackwards ? (k.sibling = n.child,
                n.child = k) : (s = f.last,
                s !== null ? s.sibling = k : n.child = k,
                f.last = k)
            }
            return f.tail !== null ? (n = f.tail,
            f.rendering = n,
            f.tail = n.sibling,
            f.renderingStartTime = Ne(),
            n.sibling = null,
            s = De.current,
            Te(De, c ? s & 1 | 2 : s & 1),
            n) : (Je(n),
            null);
        case 22:
        case 23:
            return El(),
            c = n.memoizedState !== null,
            t !== null && t.memoizedState !== null !== c && (n.flags |= 8192),
            c && (n.mode & 1) !== 0 ? (vt & 1073741824) !== 0 && (Je(n),
            n.subtreeFlags & 6 && (n.flags |= 8192)) : Je(n),
            null;
        case 24:
            return null;
        case 25:
            return null
        }
        throw Error(r(156, n.tag))
    }
    function cy(t, n) {
        switch (Ro(n),
        n.tag) {
        case 1:
            return lt(n.type) && Pa(),
            t = n.flags,
            t & 65536 ? (n.flags = t & -65537 | 128,
            n) : null;
        case 3:
            return yr(),
            Ce(ot),
            Ce(Ye),
            Qo(),
            t = n.flags,
            (t & 65536) !== 0 && (t & 128) === 0 ? (n.flags = t & -65537 | 128,
            n) : null;
        case 5:
            return Zo(n),
            null;
        case 13:
            if (Ce(De),
            t = n.memoizedState,
            t !== null && t.dehydrated !== null) {
                if (n.alternate === null)
                    throw Error(r(340));
                hr()
            }
            return t = n.flags,
            t & 65536 ? (n.flags = t & -65537 | 128,
            n) : null;
        case 19:
            return Ce(De),
            null;
        case 4:
            return yr(),
            null;
        case 10:
            return $o(n.type._context),
            null;
        case 22:
        case 23:
            return El(),
            null;
        case 24:
            return null;
        default:
            return null
        }
    }
    var _a = !1
      , et = !1
      , uy = typeof WeakSet == "function" ? WeakSet : Set
      , te = null;
    function xr(t, n) {
        var s = t.ref;
        if (s !== null)
            if (typeof s == "function")
                try {
                    s(null)
                } catch (c) {
                    Le(t, n, c)
                }
            else
                s.current = null
    }
    function yl(t, n, s) {
        try {
            s()
        } catch (c) {
            Le(t, n, c)
        }
    }
    var Kp = !1;
    function dy(t, n) {
        if (Eo = la,
        t = Pd(),
        Po(t)) {
            if ("selectionStart"in t)
                var s = {
                    start: t.selectionStart,
                    end: t.selectionEnd
                };
            else
                e: {
                    s = (s = t.ownerDocument) && s.defaultView || window;
                    var c = s.getSelection && s.getSelection();
                    if (c && c.rangeCount !== 0) {
                        s = c.anchorNode;
                        var m = c.anchorOffset
                          , f = c.focusNode;
                        c = c.focusOffset;
                        try {
                            s.nodeType,
                            f.nodeType
                        } catch {
                            s = null;
                            break e
                        }
                        var k = 0
                          , j = -1
                          , A = -1
                          , O = 0
                          , G = 0
                          , q = t
                          , $ = null;
                        t: for (; ; ) {
                            for (var J; q !== s || m !== 0 && q.nodeType !== 3 || (j = k + m),
                            q !== f || c !== 0 && q.nodeType !== 3 || (A = k + c),
                            q.nodeType === 3 && (k += q.nodeValue.length),
                            (J = q.firstChild) !== null; )
                                $ = q,
                                q = J;
                            for (; ; ) {
                                if (q === t)
                                    break t;
                                if ($ === s && ++O === m && (j = k),
                                $ === f && ++G === c && (A = k),
                                (J = q.nextSibling) !== null)
                                    break;
                                q = $,
                                $ = q.parentNode
                            }
                            q = J
                        }
                        s = j === -1 || A === -1 ? null : {
                            start: j,
                            end: A
                        }
                    } else
                        s = null
                }
            s = s || {
                start: 0,
                end: 0
            }
        } else
            s = null;
        for (Do = {
            focusedElem: t,
            selectionRange: s
        },
        la = !1,
        te = n; te !== null; )
            if (n = te,
            t = n.child,
            (n.subtreeFlags & 1028) !== 0 && t !== null)
                t.return = n,
                te = t;
            else
                for (; te !== null; ) {
                    n = te;
                    try {
                        var re = n.alternate;
                        if ((n.flags & 1024) !== 0)
                            switch (n.tag) {
                            case 0:
                            case 11:
                            case 15:
                                break;
                            case 1:
                                if (re !== null) {
                                    var ae = re.memoizedProps
                                      , Fe = re.memoizedState
                                      , V = n.stateNode
                                      , E = V.getSnapshotBeforeUpdate(n.elementType === n.type ? ae : It(n.type, ae), Fe);
                                    V.__reactInternalSnapshotBeforeUpdate = E
                                }
                                break;
                            case 3:
                                var L = n.stateNode.containerInfo;
                                L.nodeType === 1 ? L.textContent = "" : L.nodeType === 9 && L.documentElement && L.removeChild(L.documentElement);
                                break;
                            case 5:
                            case 6:
                            case 4:
                            case 17:
                                break;
                            default:
                                throw Error(r(163))
                            }
                    } catch (Y) {
                        Le(n, n.return, Y)
                    }
                    if (t = n.sibling,
                    t !== null) {
                        t.return = n.return,
                        te = t;
                        break
                    }
                    te = n.return
                }
        return re = Kp,
        Kp = !1,
        re
    }
    function xn(t, n, s) {
        var c = n.updateQueue;
        if (c = c !== null ? c.lastEffect : null,
        c !== null) {
            var m = c = c.next;
            do {
                if ((m.tag & t) === t) {
                    var f = m.destroy;
                    m.destroy = void 0,
                    f !== void 0 && yl(n, s, f)
                }
                m = m.next
            } while (m !== c)
        }
    }
    function Ua(t, n) {
        if (n = n.updateQueue,
        n = n !== null ? n.lastEffect : null,
        n !== null) {
            var s = n = n.next;
            do {
                if ((s.tag & t) === t) {
                    var c = s.create;
                    s.destroy = c()
                }
                s = s.next
            } while (s !== n)
        }
    }
    function kl(t) {
        var n = t.ref;
        if (n !== null) {
            var s = t.stateNode;
            switch (t.tag) {
            case 5:
                t = s;
                break;
            default:
                t = s
            }
            typeof n == "function" ? n(t) : n.current = t
        }
    }
    function $p(t) {
        var n = t.alternate;
        n !== null && (t.alternate = null,
        $p(n)),
        t.child = null,
        t.deletions = null,
        t.sibling = null,
        t.tag === 5 && (n = t.stateNode,
        n !== null && (delete n[Ft],
        delete n[cn],
        delete n[Lo],
        delete n[Gv],
        delete n[qv])),
        t.stateNode = null,
        t.return = null,
        t.dependencies = null,
        t.memoizedProps = null,
        t.memoizedState = null,
        t.pendingProps = null,
        t.stateNode = null,
        t.updateQueue = null
    }
    function Hp(t) {
        return t.tag === 5 || t.tag === 3 || t.tag === 4
    }
    function Gp(t) {
        e: for (; ; ) {
            for (; t.sibling === null; ) {
                if (t.return === null || Hp(t.return))
                    return null;
                t = t.return
            }
            for (t.sibling.return = t.return,
            t = t.sibling; t.tag !== 5 && t.tag !== 6 && t.tag !== 18; ) {
                if (t.flags & 2 || t.child === null || t.tag === 4)
                    continue e;
                t.child.return = t,
                t = t.child
            }
            if (!(t.flags & 2))
                return t.stateNode
        }
    }
    function xl(t, n, s) {
        var c = t.tag;
        if (c === 5 || c === 6)
            t = t.stateNode,
            n ? s.nodeType === 8 ? s.parentNode.insertBefore(t, n) : s.insertBefore(t, n) : (s.nodeType === 8 ? (n = s.parentNode,
            n.insertBefore(t, s)) : (n = s,
            n.appendChild(t)),
            s = s._reactRootContainer,
            s != null || n.onclick !== null || (n.onclick = xa));
        else if (c !== 4 && (t = t.child,
        t !== null))
            for (xl(t, n, s),
            t = t.sibling; t !== null; )
                xl(t, n, s),
                t = t.sibling
    }
    function wl(t, n, s) {
        var c = t.tag;
        if (c === 5 || c === 6)
            t = t.stateNode,
            n ? s.insertBefore(t, n) : s.appendChild(t);
        else if (c !== 4 && (t = t.child,
        t !== null))
            for (wl(t, n, s),
            t = t.sibling; t !== null; )
                wl(t, n, s),
                t = t.sibling
    }
    var qe = null
      , Mt = !1;
    function vi(t, n, s) {
        for (s = s.child; s !== null; )
            qp(t, n, s),
            s = s.sibling
    }
    function qp(t, n, s) {
        if (Nt && typeof Nt.onCommitFiberUnmount == "function")
            try {
                Nt.onCommitFiberUnmount(ia, s)
            } catch {}
        switch (s.tag) {
        case 5:
            et || xr(s, n);
        case 6:
            var c = qe
              , m = Mt;
            qe = null,
            vi(t, n, s),
            qe = c,
            Mt = m,
            qe !== null && (Mt ? (t = qe,
            s = s.stateNode,
            t.nodeType === 8 ? t.parentNode.removeChild(s) : t.removeChild(s)) : qe.removeChild(s.stateNode));
            break;
        case 18:
            qe !== null && (Mt ? (t = qe,
            s = s.stateNode,
            t.nodeType === 8 ? Vo(t.parentNode, s) : t.nodeType === 1 && Vo(t, s),
            Yr(t)) : Vo(qe, s.stateNode));
            break;
        case 4:
            c = qe,
            m = Mt,
            qe = s.stateNode.containerInfo,
            Mt = !0,
            vi(t, n, s),
            qe = c,
            Mt = m;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!et && (c = s.updateQueue,
            c !== null && (c = c.lastEffect,
            c !== null))) {
                m = c = c.next;
                do {
                    var f = m
                      , k = f.destroy;
                    f = f.tag,
                    k !== void 0 && ((f & 2) !== 0 || (f & 4) !== 0) && yl(s, n, k),
                    m = m.next
                } while (m !== c)
            }
            vi(t, n, s);
            break;
        case 1:
            if (!et && (xr(s, n),
            c = s.stateNode,
            typeof c.componentWillUnmount == "function"))
                try {
                    c.props = s.memoizedProps,
                    c.state = s.memoizedState,
                    c.componentWillUnmount()
                } catch (j) {
                    Le(s, n, j)
                }
            vi(t, n, s);
            break;
        case 21:
            vi(t, n, s);
            break;
        case 22:
            s.mode & 1 ? (et = (c = et) || s.memoizedState !== null,
            vi(t, n, s),
            et = c) : vi(t, n, s);
            break;
        default:
            vi(t, n, s)
        }
    }
    function Xp(t) {
        var n = t.updateQueue;
        if (n !== null) {
            t.updateQueue = null;
            var s = t.stateNode;
            s === null && (s = t.stateNode = new uy),
            n.forEach(function(c) {
                var m = xy.bind(null, t, c);
                s.has(c) || (s.add(c),
                c.then(m, m))
            })
        }
    }
    function Vt(t, n) {
        var s = n.deletions;
        if (s !== null)
            for (var c = 0; c < s.length; c++) {
                var m = s[c];
                try {
                    var f = t
                      , k = n
                      , j = k;
                    e: for (; j !== null; ) {
                        switch (j.tag) {
                        case 5:
                            qe = j.stateNode,
                            Mt = !1;
                            break e;
                        case 3:
                            qe = j.stateNode.containerInfo,
                            Mt = !0;
                            break e;
                        case 4:
                            qe = j.stateNode.containerInfo,
                            Mt = !0;
                            break e
                        }
                        j = j.return
                    }
                    if (qe === null)
                        throw Error(r(160));
                    qp(f, k, m),
                    qe = null,
                    Mt = !1;
                    var A = m.alternate;
                    A !== null && (A.return = null),
                    m.return = null
                } catch (O) {
                    Le(m, n, O)
                }
            }
        if (n.subtreeFlags & 12854)
            for (n = n.child; n !== null; )
                Zp(n, t),
                n = n.sibling
    }
    function Zp(t, n) {
        var s = t.alternate
          , c = t.flags;
        switch (t.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
            if (Vt(n, t),
            Wt(t),
            c & 4) {
                try {
                    xn(3, t, t.return),
                    Ua(3, t)
                } catch (ae) {
                    Le(t, t.return, ae)
                }
                try {
                    xn(5, t, t.return)
                } catch (ae) {
                    Le(t, t.return, ae)
                }
            }
            break;
        case 1:
            Vt(n, t),
            Wt(t),
            c & 512 && s !== null && xr(s, s.return);
            break;
        case 5:
            if (Vt(n, t),
            Wt(t),
            c & 512 && s !== null && xr(s, s.return),
            t.flags & 32) {
                var m = t.stateNode;
                try {
                    Br(m, "")
                } catch (ae) {
                    Le(t, t.return, ae)
                }
            }
            if (c & 4 && (m = t.stateNode,
            m != null)) {
                var f = t.memoizedProps
                  , k = s !== null ? s.memoizedProps : f
                  , j = t.type
                  , A = t.updateQueue;
                if (t.updateQueue = null,
                A !== null)
                    try {
                        j === "input" && f.type === "radio" && f.name != null && Su(m, f),
                        Ys(j, k);
                        var O = Ys(j, f);
                        for (k = 0; k < A.length; k += 2) {
                            var G = A[k]
                              , q = A[k + 1];
                            G === "style" ? Iu(m, q) : G === "dangerouslySetInnerHTML" ? Eu(m, q) : G === "children" ? Br(m, q) : T(m, G, q, O)
                        }
                        switch (j) {
                        case "input":
                            Hs(m, f);
                            break;
                        case "textarea":
                            Cu(m, f);
                            break;
                        case "select":
                            var $ = m._wrapperState.wasMultiple;
                            m._wrapperState.wasMultiple = !!f.multiple;
                            var J = f.value;
                            J != null ? Ji(m, !!f.multiple, J, !1) : $ !== !!f.multiple && (f.defaultValue != null ? Ji(m, !!f.multiple, f.defaultValue, !0) : Ji(m, !!f.multiple, f.multiple ? [] : "", !1))
                        }
                        m[cn] = f
                    } catch (ae) {
                        Le(t, t.return, ae)
                    }
            }
            break;
        case 6:
            if (Vt(n, t),
            Wt(t),
            c & 4) {
                if (t.stateNode === null)
                    throw Error(r(162));
                m = t.stateNode,
                f = t.memoizedProps;
                try {
                    m.nodeValue = f
                } catch (ae) {
                    Le(t, t.return, ae)
                }
            }
            break;
        case 3:
            if (Vt(n, t),
            Wt(t),
            c & 4 && s !== null && s.memoizedState.isDehydrated)
                try {
                    Yr(n.containerInfo)
                } catch (ae) {
                    Le(t, t.return, ae)
                }
            break;
        case 4:
            Vt(n, t),
            Wt(t);
            break;
        case 13:
            Vt(n, t),
            Wt(t),
            m = t.child,
            m.flags & 8192 && (f = m.memoizedState !== null,
            m.stateNode.isHidden = f,
            !f || m.alternate !== null && m.alternate.memoizedState !== null || (Sl = Ne())),
            c & 4 && Xp(t);
            break;
        case 22:
            if (G = s !== null && s.memoizedState !== null,
            t.mode & 1 ? (et = (O = et) || G,
            Vt(n, t),
            et = O) : Vt(n, t),
            Wt(t),
            c & 8192) {
                if (O = t.memoizedState !== null,
                (t.stateNode.isHidden = O) && !G && (t.mode & 1) !== 0)
                    for (te = t,
                    G = t.child; G !== null; ) {
                        for (q = te = G; te !== null; ) {
                            switch ($ = te,
                            J = $.child,
                            $.tag) {
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                xn(4, $, $.return);
                                break;
                            case 1:
                                xr($, $.return);
                                var re = $.stateNode;
                                if (typeof re.componentWillUnmount == "function") {
                                    c = $,
                                    s = $.return;
                                    try {
                                        n = c,
                                        re.props = n.memoizedProps,
                                        re.state = n.memoizedState,
                                        re.componentWillUnmount()
                                    } catch (ae) {
                                        Le(c, s, ae)
                                    }
                                }
                                break;
                            case 5:
                                xr($, $.return);
                                break;
                            case 22:
                                if ($.memoizedState !== null) {
                                    Jp(q);
                                    continue
                                }
                            }
                            J !== null ? (J.return = $,
                            te = J) : Jp(q)
                        }
                        G = G.sibling
                    }
                e: for (G = null,
                q = t; ; ) {
                    if (q.tag === 5) {
                        if (G === null) {
                            G = q;
                            try {
                                m = q.stateNode,
                                O ? (f = m.style,
                                typeof f.setProperty == "function" ? f.setProperty("display", "none", "important") : f.display = "none") : (j = q.stateNode,
                                A = q.memoizedProps.style,
                                k = A != null && A.hasOwnProperty("display") ? A.display : null,
                                j.style.display = Du("display", k))
                            } catch (ae) {
                                Le(t, t.return, ae)
                            }
                        }
                    } else if (q.tag === 6) {
                        if (G === null)
                            try {
                                q.stateNode.nodeValue = O ? "" : q.memoizedProps
                            } catch (ae) {
                                Le(t, t.return, ae)
                            }
                    } else if ((q.tag !== 22 && q.tag !== 23 || q.memoizedState === null || q === t) && q.child !== null) {
                        q.child.return = q,
                        q = q.child;
                        continue
                    }
                    if (q === t)
                        break e;
                    for (; q.sibling === null; ) {
                        if (q.return === null || q.return === t)
                            break e;
                        G === q && (G = null),
                        q = q.return
                    }
                    G === q && (G = null),
                    q.sibling.return = q.return,
                    q = q.sibling
                }
            }
            break;
        case 19:
            Vt(n, t),
            Wt(t),
            c & 4 && Xp(t);
            break;
        case 21:
            break;
        default:
            Vt(n, t),
            Wt(t)
        }
    }
    function Wt(t) {
        var n = t.flags;
        if (n & 2) {
            try {
                e: {
                    for (var s = t.return; s !== null; ) {
                        if (Hp(s)) {
                            var c = s;
                            break e
                        }
                        s = s.return
                    }
                    throw Error(r(160))
                }
                switch (c.tag) {
                case 5:
                    var m = c.stateNode;
                    c.flags & 32 && (Br(m, ""),
                    c.flags &= -33);
                    var f = Gp(t);
                    wl(t, f, m);
                    break;
                case 3:
                case 4:
                    var k = c.stateNode.containerInfo
                      , j = Gp(t);
                    xl(t, j, k);
                    break;
                default:
                    throw Error(r(161))
                }
            } catch (A) {
                Le(t, t.return, A)
            }
            t.flags &= -3
        }
        n & 4096 && (t.flags &= -4097)
    }
    function py(t, n, s) {
        te = t,
        Yp(t)
    }
    function Yp(t, n, s) {
        for (var c = (t.mode & 1) !== 0; te !== null; ) {
            var m = te
              , f = m.child;
            if (m.tag === 22 && c) {
                var k = m.memoizedState !== null || _a;
                if (!k) {
                    var j = m.alternate
                      , A = j !== null && j.memoizedState !== null || et;
                    j = _a;
                    var O = et;
                    if (_a = k,
                    (et = A) && !O)
                        for (te = m; te !== null; )
                            k = te,
                            A = k.child,
                            k.tag === 22 && k.memoizedState !== null ? em(m) : A !== null ? (A.return = k,
                            te = A) : em(m);
                    for (; f !== null; )
                        te = f,
                        Yp(f),
                        f = f.sibling;
                    te = m,
                    _a = j,
                    et = O
                }
                Qp(t)
            } else
                (m.subtreeFlags & 8772) !== 0 && f !== null ? (f.return = m,
                te = f) : Qp(t)
        }
    }
    function Qp(t) {
        for (; te !== null; ) {
            var n = te;
            if ((n.flags & 8772) !== 0) {
                var s = n.alternate;
                try {
                    if ((n.flags & 8772) !== 0)
                        switch (n.tag) {
                        case 0:
                        case 11:
                        case 15:
                            et || Ua(5, n);
                            break;
                        case 1:
                            var c = n.stateNode;
                            if (n.flags & 4 && !et)
                                if (s === null)
                                    c.componentDidMount();
                                else {
                                    var m = n.elementType === n.type ? s.memoizedProps : It(n.type, s.memoizedProps);
                                    c.componentDidUpdate(m, s.memoizedState, c.__reactInternalSnapshotBeforeUpdate)
                                }
                            var f = n.updateQueue;
                            f !== null && Jd(n, f, c);
                            break;
                        case 3:
                            var k = n.updateQueue;
                            if (k !== null) {
                                if (s = null,
                                n.child !== null)
                                    switch (n.child.tag) {
                                    case 5:
                                        s = n.child.stateNode;
                                        break;
                                    case 1:
                                        s = n.child.stateNode
                                    }
                                Jd(n, k, s)
                            }
                            break;
                        case 5:
                            var j = n.stateNode;
                            if (s === null && n.flags & 4) {
                                s = j;
                                var A = n.memoizedProps;
                                switch (n.type) {
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    A.autoFocus && s.focus();
                                    break;
                                case "img":
                                    A.src && (s.src = A.src)
                                }
                            }
                            break;
                        case 6:
                            break;
                        case 4:
                            break;
                        case 12:
                            break;
                        case 13:
                            if (n.memoizedState === null) {
                                var O = n.alternate;
                                if (O !== null) {
                                    var G = O.memoizedState;
                                    if (G !== null) {
                                        var q = G.dehydrated;
                                        q !== null && Yr(q)
                                    }
                                }
                            }
                            break;
                        case 19:
                        case 17:
                        case 21:
                        case 22:
                        case 23:
                        case 25:
                            break;
                        default:
                            throw Error(r(163))
                        }
                    et || n.flags & 512 && kl(n)
                } catch ($) {
                    Le(n, n.return, $)
                }
            }
            if (n === t) {
                te = null;
                break
            }
            if (s = n.sibling,
            s !== null) {
                s.return = n.return,
                te = s;
                break
            }
            te = n.return
        }
    }
    function Jp(t) {
        for (; te !== null; ) {
            var n = te;
            if (n === t) {
                te = null;
                break
            }
            var s = n.sibling;
            if (s !== null) {
                s.return = n.return,
                te = s;
                break
            }
            te = n.return
        }
    }
    function em(t) {
        for (; te !== null; ) {
            var n = te;
            try {
                switch (n.tag) {
                case 0:
                case 11:
                case 15:
                    var s = n.return;
                    try {
                        Ua(4, n)
                    } catch (A) {
                        Le(n, s, A)
                    }
                    break;
                case 1:
                    var c = n.stateNode;
                    if (typeof c.componentDidMount == "function") {
                        var m = n.return;
                        try {
                            c.componentDidMount()
                        } catch (A) {
                            Le(n, m, A)
                        }
                    }
                    var f = n.return;
                    try {
                        kl(n)
                    } catch (A) {
                        Le(n, f, A)
                    }
                    break;
                case 5:
                    var k = n.return;
                    try {
                        kl(n)
                    } catch (A) {
                        Le(n, k, A)
                    }
                }
            } catch (A) {
                Le(n, n.return, A)
            }
            if (n === t) {
                te = null;
                break
            }
            var j = n.sibling;
            if (j !== null) {
                j.return = n.return,
                te = j;
                break
            }
            te = n.return
        }
    }
    var my = Math.ceil
      , Ka = D.ReactCurrentDispatcher
      , Pl = D.ReactCurrentOwner
      , Tt = D.ReactCurrentBatchConfig
      , ye = 0
      , $e = null
      , Be = null
      , Xe = 0
      , vt = 0
      , wr = pi(0)
      , Ue = 0
      , wn = null
      , Ri = 0
      , $a = 0
      , bl = 0
      , Pn = null
      , ut = null
      , Sl = 0
      , Pr = 1 / 0
      , ei = null
      , Ha = !1
      , Tl = null
      , yi = null
      , Ga = !1
      , ki = null
      , qa = 0
      , bn = 0
      , jl = null
      , Xa = -1
      , Za = 0;
    function at() {
        return (ye & 6) !== 0 ? Ne() : Xa !== -1 ? Xa : Xa = Ne()
    }
    function xi(t) {
        return (t.mode & 1) === 0 ? 1 : (ye & 2) !== 0 && Xe !== 0 ? Xe & -Xe : Zv.transition !== null ? (Za === 0 && (Za = Gu()),
        Za) : (t = be,
        t !== 0 || (t = window.event,
        t = t === void 0 ? 16 : id(t.type)),
        t)
    }
    function Lt(t, n, s, c) {
        if (50 < bn)
            throw bn = 0,
            jl = null,
            Error(r(185));
        Hr(t, s, c),
        ((ye & 2) === 0 || t !== $e) && (t === $e && ((ye & 2) === 0 && ($a |= s),
        Ue === 4 && wi(t, Xe)),
        dt(t, c),
        s === 1 && ye === 0 && (n.mode & 1) === 0 && (Pr = Ne() + 500,
        Sa && hi()))
    }
    function dt(t, n) {
        var s = t.callbackNode;
        Z0(t, n);
        var c = aa(t, t === $e ? Xe : 0);
        if (c === 0)
            s !== null && Ku(s),
            t.callbackNode = null,
            t.callbackPriority = 0;
        else if (n = c & -c,
        t.callbackPriority !== n) {
            if (s != null && Ku(s),
            n === 1)
                t.tag === 0 ? Xv(im.bind(null, t)) : Wd(im.bind(null, t)),
                $v(function() {
                    (ye & 6) === 0 && hi()
                }),
                s = null;
            else {
                switch (qu(c)) {
                case 1:
                    s = no;
                    break;
                case 4:
                    s = $u;
                    break;
                case 16:
                    s = ta;
                    break;
                case 536870912:
                    s = Hu;
                    break;
                default:
                    s = ta
                }
                s = um(s, tm.bind(null, t))
            }
            t.callbackPriority = n,
            t.callbackNode = s
        }
    }
    function tm(t, n) {
        if (Xa = -1,
        Za = 0,
        (ye & 6) !== 0)
            throw Error(r(327));
        var s = t.callbackNode;
        if (br() && t.callbackNode !== s)
            return null;
        var c = aa(t, t === $e ? Xe : 0);
        if (c === 0)
            return null;
        if ((c & 30) !== 0 || (c & t.expiredLanes) !== 0 || n)
            n = Ya(t, c);
        else {
            n = c;
            var m = ye;
            ye |= 2;
            var f = nm();
            ($e !== t || Xe !== n) && (ei = null,
            Pr = Ne() + 500,
            Wi(t, n));
            do
                try {
                    gy();
                    break
                } catch (j) {
                    rm(t, j)
                }
            while (!0);
            Ko(),
            Ka.current = f,
            ye = m,
            Be !== null ? n = 0 : ($e = null,
            Xe = 0,
            n = Ue)
        }
        if (n !== 0) {
            if (n === 2 && (m = ao(t),
            m !== 0 && (c = m,
            n = Cl(t, m))),
            n === 1)
                throw s = wn,
                Wi(t, 0),
                wi(t, c),
                dt(t, Ne()),
                s;
            if (n === 6)
                wi(t, c);
            else {
                if (m = t.current.alternate,
                (c & 30) === 0 && !hy(m) && (n = Ya(t, c),
                n === 2 && (f = ao(t),
                f !== 0 && (c = f,
                n = Cl(t, f))),
                n === 1))
                    throw s = wn,
                    Wi(t, 0),
                    wi(t, c),
                    dt(t, Ne()),
                    s;
                switch (t.finishedWork = m,
                t.finishedLanes = c,
                n) {
                case 0:
                case 1:
                    throw Error(r(345));
                case 2:
                    _i(t, ut, ei);
                    break;
                case 3:
                    if (wi(t, c),
                    (c & 130023424) === c && (n = Sl + 500 - Ne(),
                    10 < n)) {
                        if (aa(t, 0) !== 0)
                            break;
                        if (m = t.suspendedLanes,
                        (m & c) !== c) {
                            at(),
                            t.pingedLanes |= t.suspendedLanes & m;
                            break
                        }
                        t.timeoutHandle = Mo(_i.bind(null, t, ut, ei), n);
                        break
                    }
                    _i(t, ut, ei);
                    break;
                case 4:
                    if (wi(t, c),
                    (c & 4194240) === c)
                        break;
                    for (n = t.eventTimes,
                    m = -1; 0 < c; ) {
                        var k = 31 - At(c);
                        f = 1 << k,
                        k = n[k],
                        k > m && (m = k),
                        c &= ~f
                    }
                    if (c = m,
                    c = Ne() - c,
                    c = (120 > c ? 120 : 480 > c ? 480 : 1080 > c ? 1080 : 1920 > c ? 1920 : 3e3 > c ? 3e3 : 4320 > c ? 4320 : 1960 * my(c / 1960)) - c,
                    10 < c) {
                        t.timeoutHandle = Mo(_i.bind(null, t, ut, ei), c);
                        break
                    }
                    _i(t, ut, ei);
                    break;
                case 5:
                    _i(t, ut, ei);
                    break;
                default:
                    throw Error(r(329))
                }
            }
        }
        return dt(t, Ne()),
        t.callbackNode === s ? tm.bind(null, t) : null
    }
    function Cl(t, n) {
        var s = Pn;
        return t.current.memoizedState.isDehydrated && (Wi(t, n).flags |= 256),
        t = Ya(t, n),
        t !== 2 && (n = ut,
        ut = s,
        n !== null && zl(n)),
        t
    }
    function zl(t) {
        ut === null ? ut = t : ut.push.apply(ut, t)
    }
    function hy(t) {
        for (var n = t; ; ) {
            if (n.flags & 16384) {
                var s = n.updateQueue;
                if (s !== null && (s = s.stores,
                s !== null))
                    for (var c = 0; c < s.length; c++) {
                        var m = s[c]
                          , f = m.getSnapshot;
                        m = m.value;
                        try {
                            if (!Et(f(), m))
                                return !1
                        } catch {
                            return !1
                        }
                    }
            }
            if (s = n.child,
            n.subtreeFlags & 16384 && s !== null)
                s.return = n,
                n = s;
            else {
                if (n === t)
                    break;
                for (; n.sibling === null; ) {
                    if (n.return === null || n.return === t)
                        return !0;
                    n = n.return
                }
                n.sibling.return = n.return,
                n = n.sibling
            }
        }
        return !0
    }
    function wi(t, n) {
        for (n &= ~bl,
        n &= ~$a,
        t.suspendedLanes |= n,
        t.pingedLanes &= ~n,
        t = t.expirationTimes; 0 < n; ) {
            var s = 31 - At(n)
              , c = 1 << s;
            t[s] = -1,
            n &= ~c
        }
    }
    function im(t) {
        if ((ye & 6) !== 0)
            throw Error(r(327));
        br();
        var n = aa(t, 0);
        if ((n & 1) === 0)
            return dt(t, Ne()),
            null;
        var s = Ya(t, n);
        if (t.tag !== 0 && s === 2) {
            var c = ao(t);
            c !== 0 && (n = c,
            s = Cl(t, c))
        }
        if (s === 1)
            throw s = wn,
            Wi(t, 0),
            wi(t, n),
            dt(t, Ne()),
            s;
        if (s === 6)
            throw Error(r(345));
        return t.finishedWork = t.current.alternate,
        t.finishedLanes = n,
        _i(t, ut, ei),
        dt(t, Ne()),
        null
    }
    function Al(t, n) {
        var s = ye;
        ye |= 1;
        try {
            return t(n)
        } finally {
            ye = s,
            ye === 0 && (Pr = Ne() + 500,
            Sa && hi())
        }
    }
    function Bi(t) {
        ki !== null && ki.tag === 0 && (ye & 6) === 0 && br();
        var n = ye;
        ye |= 1;
        var s = Tt.transition
          , c = be;
        try {
            if (Tt.transition = null,
            be = 1,
            t)
                return t()
        } finally {
            be = c,
            Tt.transition = s,
            ye = n,
            (ye & 6) === 0 && hi()
        }
    }
    function El() {
        vt = wr.current,
        Ce(wr)
    }
    function Wi(t, n) {
        t.finishedWork = null,
        t.finishedLanes = 0;
        var s = t.timeoutHandle;
        if (s !== -1 && (t.timeoutHandle = -1,
        Kv(s)),
        Be !== null)
            for (s = Be.return; s !== null; ) {
                var c = s;
                switch (Ro(c),
                c.tag) {
                case 1:
                    c = c.type.childContextTypes,
                    c != null && Pa();
                    break;
                case 3:
                    yr(),
                    Ce(ot),
                    Ce(Ye),
                    Qo();
                    break;
                case 5:
                    Zo(c);
                    break;
                case 4:
                    yr();
                    break;
                case 13:
                    Ce(De);
                    break;
                case 19:
                    Ce(De);
                    break;
                case 10:
                    $o(c.type._context);
                    break;
                case 22:
                case 23:
                    El()
                }
                s = s.return
            }
        if ($e = t,
        Be = t = Pi(t.current, null),
        Xe = vt = n,
        Ue = 0,
        wn = null,
        bl = $a = Ri = 0,
        ut = Pn = null,
        Oi !== null) {
            for (n = 0; n < Oi.length; n++)
                if (s = Oi[n],
                c = s.interleaved,
                c !== null) {
                    s.interleaved = null;
                    var m = c.next
                      , f = s.pending;
                    if (f !== null) {
                        var k = f.next;
                        f.next = m,
                        c.next = k
                    }
                    s.pending = c
                }
            Oi = null
        }
        return t
    }
    function rm(t, n) {
        do {
            var s = Be;
            try {
                if (Ko(),
                Va.current = Fa,
                La) {
                    for (var c = Ie.memoizedState; c !== null; ) {
                        var m = c.queue;
                        m !== null && (m.pending = null),
                        c = c.next
                    }
                    La = !1
                }
                if (Fi = 0,
                Ke = _e = Ie = null,
                fn = !1,
                gn = 0,
                Pl.current = null,
                s === null || s.return === null) {
                    Ue = 1,
                    wn = n,
                    Be = null;
                    break
                }
                e: {
                    var f = t
                      , k = s.return
                      , j = s
                      , A = n;
                    if (n = Xe,
                    j.flags |= 32768,
                    A !== null && typeof A == "object" && typeof A.then == "function") {
                        var O = A
                          , G = j
                          , q = G.tag;
                        if ((G.mode & 1) === 0 && (q === 0 || q === 11 || q === 15)) {
                            var $ = G.alternate;
                            $ ? (G.updateQueue = $.updateQueue,
                            G.memoizedState = $.memoizedState,
                            G.lanes = $.lanes) : (G.updateQueue = null,
                            G.memoizedState = null)
                        }
                        var J = zp(k);
                        if (J !== null) {
                            J.flags &= -257,
                            Ap(J, k, j, f, n),
                            J.mode & 1 && Cp(f, O, n),
                            n = J,
                            A = O;
                            var re = n.updateQueue;
                            if (re === null) {
                                var ae = new Set;
                                ae.add(A),
                                n.updateQueue = ae
                            } else
                                re.add(A);
                            break e
                        } else {
                            if ((n & 1) === 0) {
                                Cp(f, O, n),
                                Dl();
                                break e
                            }
                            A = Error(r(426))
                        }
                    } else if (Ee && j.mode & 1) {
                        var Fe = zp(k);
                        if (Fe !== null) {
                            (Fe.flags & 65536) === 0 && (Fe.flags |= 256),
                            Ap(Fe, k, j, f, n),
                            _o(kr(A, j));
                            break e
                        }
                    }
                    f = A = kr(A, j),
                    Ue !== 4 && (Ue = 2),
                    Pn === null ? Pn = [f] : Pn.push(f),
                    f = k;
                    do {
                        switch (f.tag) {
                        case 3:
                            f.flags |= 65536,
                            n &= -n,
                            f.lanes |= n;
                            var V = Tp(f, A, n);
                            Qd(f, V);
                            break e;
                        case 1:
                            j = A;
                            var E = f.type
                              , L = f.stateNode;
                            if ((f.flags & 128) === 0 && (typeof E.getDerivedStateFromError == "function" || L !== null && typeof L.componentDidCatch == "function" && (yi === null || !yi.has(L)))) {
                                f.flags |= 65536,
                                n &= -n,
                                f.lanes |= n;
                                var Y = jp(f, j, n);
                                Qd(f, Y);
                                break e
                            }
                        }
                        f = f.return
                    } while (f !== null)
                }
                sm(s)
            } catch (oe) {
                n = oe,
                Be === s && s !== null && (Be = s = s.return);
                continue
            }
            break
        } while (!0)
    }
    function nm() {
        var t = Ka.current;
        return Ka.current = Fa,
        t === null ? Fa : t
    }
    function Dl() {
        (Ue === 0 || Ue === 3 || Ue === 2) && (Ue = 4),
        $e === null || (Ri & 268435455) === 0 && ($a & 268435455) === 0 || wi($e, Xe)
    }
    function Ya(t, n) {
        var s = ye;
        ye |= 2;
        var c = nm();
        ($e !== t || Xe !== n) && (ei = null,
        Wi(t, n));
        do
            try {
                fy();
                break
            } catch (m) {
                rm(t, m)
            }
        while (!0);
        if (Ko(),
        ye = s,
        Ka.current = c,
        Be !== null)
            throw Error(r(261));
        return $e = null,
        Xe = 0,
        Ue
    }
    function fy() {
        for (; Be !== null; )
            am(Be)
    }
    function gy() {
        for (; Be !== null && !W0(); )
            am(Be)
    }
    function am(t) {
        var n = cm(t.alternate, t, vt);
        t.memoizedProps = t.pendingProps,
        n === null ? sm(t) : Be = n,
        Pl.current = null
    }
    function sm(t) {
        var n = t;
        do {
            var s = n.alternate;
            if (t = n.return,
            (n.flags & 32768) === 0) {
                if (s = ly(s, n, vt),
                s !== null) {
                    Be = s;
                    return
                }
            } else {
                if (s = cy(s, n),
                s !== null) {
                    s.flags &= 32767,
                    Be = s;
                    return
                }
                if (t !== null)
                    t.flags |= 32768,
                    t.subtreeFlags = 0,
                    t.deletions = null;
                else {
                    Ue = 6,
                    Be = null;
                    return
                }
            }
            if (n = n.sibling,
            n !== null) {
                Be = n;
                return
            }
            Be = n = t
        } while (n !== null);
        Ue === 0 && (Ue = 5)
    }
    function _i(t, n, s) {
        var c = be
          , m = Tt.transition;
        try {
            Tt.transition = null,
            be = 1,
            vy(t, n, s, c)
        } finally {
            Tt.transition = m,
            be = c
        }
        return null
    }
    function vy(t, n, s, c) {
        do
            br();
        while (ki !== null);
        if ((ye & 6) !== 0)
            throw Error(r(327));
        s = t.finishedWork;
        var m = t.finishedLanes;
        if (s === null)
            return null;
        if (t.finishedWork = null,
        t.finishedLanes = 0,
        s === t.current)
            throw Error(r(177));
        t.callbackNode = null,
        t.callbackPriority = 0;
        var f = s.lanes | s.childLanes;
        if (Y0(t, f),
        t === $e && (Be = $e = null,
        Xe = 0),
        (s.subtreeFlags & 2064) === 0 && (s.flags & 2064) === 0 || Ga || (Ga = !0,
        um(ta, function() {
            return br(),
            null
        })),
        f = (s.flags & 15990) !== 0,
        (s.subtreeFlags & 15990) !== 0 || f) {
            f = Tt.transition,
            Tt.transition = null;
            var k = be;
            be = 1;
            var j = ye;
            ye |= 4,
            Pl.current = null,
            dy(t, s),
            Zp(s, t),
            Nv(Do),
            la = !!Eo,
            Do = Eo = null,
            t.current = s,
            py(s),
            _0(),
            ye = j,
            be = k,
            Tt.transition = f
        } else
            t.current = s;
        if (Ga && (Ga = !1,
        ki = t,
        qa = m),
        f = t.pendingLanes,
        f === 0 && (yi = null),
        $0(s.stateNode),
        dt(t, Ne()),
        n !== null)
            for (c = t.onRecoverableError,
            s = 0; s < n.length; s++)
                m = n[s],
                c(m.value, {
                    componentStack: m.stack,
                    digest: m.digest
                });
        if (Ha)
            throw Ha = !1,
            t = Tl,
            Tl = null,
            t;
        return (qa & 1) !== 0 && t.tag !== 0 && br(),
        f = t.pendingLanes,
        (f & 1) !== 0 ? t === jl ? bn++ : (bn = 0,
        jl = t) : bn = 0,
        hi(),
        null
    }
    function br() {
        if (ki !== null) {
            var t = qu(qa)
              , n = Tt.transition
              , s = be;
            try {
                if (Tt.transition = null,
                be = 16 > t ? 16 : t,
                ki === null)
                    var c = !1;
                else {
                    if (t = ki,
                    ki = null,
                    qa = 0,
                    (ye & 6) !== 0)
                        throw Error(r(331));
                    var m = ye;
                    for (ye |= 4,
                    te = t.current; te !== null; ) {
                        var f = te
                          , k = f.child;
                        if ((te.flags & 16) !== 0) {
                            var j = f.deletions;
                            if (j !== null) {
                                for (var A = 0; A < j.length; A++) {
                                    var O = j[A];
                                    for (te = O; te !== null; ) {
                                        var G = te;
                                        switch (G.tag) {
                                        case 0:
                                        case 11:
                                        case 15:
                                            xn(8, G, f)
                                        }
                                        var q = G.child;
                                        if (q !== null)
                                            q.return = G,
                                            te = q;
                                        else
                                            for (; te !== null; ) {
                                                G = te;
                                                var $ = G.sibling
                                                  , J = G.return;
                                                if ($p(G),
                                                G === O) {
                                                    te = null;
                                                    break
                                                }
                                                if ($ !== null) {
                                                    $.return = J,
                                                    te = $;
                                                    break
                                                }
                                                te = J
                                            }
                                    }
                                }
                                var re = f.alternate;
                                if (re !== null) {
                                    var ae = re.child;
                                    if (ae !== null) {
                                        re.child = null;
                                        do {
                                            var Fe = ae.sibling;
                                            ae.sibling = null,
                                            ae = Fe
                                        } while (ae !== null)
                                    }
                                }
                                te = f
                            }
                        }
                        if ((f.subtreeFlags & 2064) !== 0 && k !== null)
                            k.return = f,
                            te = k;
                        else
                            e: for (; te !== null; ) {
                                if (f = te,
                                (f.flags & 2048) !== 0)
                                    switch (f.tag) {
                                    case 0:
                                    case 11:
                                    case 15:
                                        xn(9, f, f.return)
                                    }
                                var V = f.sibling;
                                if (V !== null) {
                                    V.return = f.return,
                                    te = V;
                                    break e
                                }
                                te = f.return
                            }
                    }
                    var E = t.current;
                    for (te = E; te !== null; ) {
                        k = te;
                        var L = k.child;
                        if ((k.subtreeFlags & 2064) !== 0 && L !== null)
                            L.return = k,
                            te = L;
                        else
                            e: for (k = E; te !== null; ) {
                                if (j = te,
                                (j.flags & 2048) !== 0)
                                    try {
                                        switch (j.tag) {
                                        case 0:
                                        case 11:
                                        case 15:
                                            Ua(9, j)
                                        }
                                    } catch (oe) {
                                        Le(j, j.return, oe)
                                    }
                                if (j === k) {
                                    te = null;
                                    break e
                                }
                                var Y = j.sibling;
                                if (Y !== null) {
                                    Y.return = j.return,
                                    te = Y;
                                    break e
                                }
                                te = j.return
                            }
                    }
                    if (ye = m,
                    hi(),
                    Nt && typeof Nt.onPostCommitFiberRoot == "function")
                        try {
                            Nt.onPostCommitFiberRoot(ia, t)
                        } catch {}
                    c = !0
                }
                return c
            } finally {
                be = s,
                Tt.transition = n
            }
        }
        return !1
    }
    function om(t, n, s) {
        n = kr(s, n),
        n = Tp(t, n, 1),
        t = gi(t, n, 1),
        n = at(),
        t !== null && (Hr(t, 1, n),
        dt(t, n))
    }
    function Le(t, n, s) {
        if (t.tag === 3)
            om(t, t, s);
        else
            for (; n !== null; ) {
                if (n.tag === 3) {
                    om(n, t, s);
                    break
                } else if (n.tag === 1) {
                    var c = n.stateNode;
                    if (typeof n.type.getDerivedStateFromError == "function" || typeof c.componentDidCatch == "function" && (yi === null || !yi.has(c))) {
                        t = kr(s, t),
                        t = jp(n, t, 1),
                        n = gi(n, t, 1),
                        t = at(),
                        n !== null && (Hr(n, 1, t),
                        dt(n, t));
                        break
                    }
                }
                n = n.return
            }
    }
    function yy(t, n, s) {
        var c = t.pingCache;
        c !== null && c.delete(n),
        n = at(),
        t.pingedLanes |= t.suspendedLanes & s,
        $e === t && (Xe & s) === s && (Ue === 4 || Ue === 3 && (Xe & 130023424) === Xe && 500 > Ne() - Sl ? Wi(t, 0) : bl |= s),
        dt(t, n)
    }
    function lm(t, n) {
        n === 0 && ((t.mode & 1) === 0 ? n = 1 : (n = na,
        na <<= 1,
        (na & 130023424) === 0 && (na = 4194304)));
        var s = at();
        t = Yt(t, n),
        t !== null && (Hr(t, n, s),
        dt(t, s))
    }
    function ky(t) {
        var n = t.memoizedState
          , s = 0;
        n !== null && (s = n.retryLane),
        lm(t, s)
    }
    function xy(t, n) {
        var s = 0;
        switch (t.tag) {
        case 13:
            var c = t.stateNode
              , m = t.memoizedState;
            m !== null && (s = m.retryLane);
            break;
        case 19:
            c = t.stateNode;
            break;
        default:
            throw Error(r(314))
        }
        c !== null && c.delete(n),
        lm(t, s)
    }
    var cm;
    cm = function(t, n, s) {
        if (t !== null)
            if (t.memoizedProps !== n.pendingProps || ot.current)
                ct = !0;
            else {
                if ((t.lanes & s) === 0 && (n.flags & 128) === 0)
                    return ct = !1,
                    oy(t, n, s);
                ct = (t.flags & 131072) !== 0
            }
        else
            ct = !1,
            Ee && (n.flags & 1048576) !== 0 && _d(n, ja, n.index);
        switch (n.lanes = 0,
        n.tag) {
        case 2:
            var c = n.type;
            Wa(t, n),
            t = n.pendingProps;
            var m = dr(n, Ye.current);
            vr(n, s),
            m = tl(null, n, c, t, m, s);
            var f = il();
            return n.flags |= 1,
            typeof m == "object" && m !== null && typeof m.render == "function" && m.$$typeof === void 0 ? (n.tag = 1,
            n.memoizedState = null,
            n.updateQueue = null,
            lt(c) ? (f = !0,
            ba(n)) : f = !1,
            n.memoizedState = m.state !== null && m.state !== void 0 ? m.state : null,
            qo(n),
            m.updater = Ra,
            n.stateNode = m,
            m._reactInternals = n,
            ll(n, c, t, s),
            n = pl(null, n, c, !0, f, s)) : (n.tag = 0,
            Ee && f && Fo(n),
            nt(null, n, m, s),
            n = n.child),
            n;
        case 16:
            c = n.elementType;
            e: {
                switch (Wa(t, n),
                t = n.pendingProps,
                m = c._init,
                c = m(c._payload),
                n.type = c,
                m = n.tag = Py(c),
                t = It(c, t),
                m) {
                case 0:
                    n = dl(null, n, c, t, s);
                    break e;
                case 1:
                    n = Lp(null, n, c, t, s);
                    break e;
                case 11:
                    n = Ep(null, n, c, t, s);
                    break e;
                case 14:
                    n = Dp(null, n, c, It(c.type, t), s);
                    break e
                }
                throw Error(r(306, c, ""))
            }
            return n;
        case 0:
            return c = n.type,
            m = n.pendingProps,
            m = n.elementType === c ? m : It(c, m),
            dl(t, n, c, m, s);
        case 1:
            return c = n.type,
            m = n.pendingProps,
            m = n.elementType === c ? m : It(c, m),
            Lp(t, n, c, m, s);
        case 3:
            e: {
                if (Op(n),
                t === null)
                    throw Error(r(387));
                c = n.pendingProps,
                f = n.memoizedState,
                m = f.element,
                Yd(t, n),
                Ia(n, c, null, s);
                var k = n.memoizedState;
                if (c = k.element,
                f.isDehydrated)
                    if (f = {
                        element: c,
                        isDehydrated: !1,
                        cache: k.cache,
                        pendingSuspenseBoundaries: k.pendingSuspenseBoundaries,
                        transitions: k.transitions
                    },
                    n.updateQueue.baseState = f,
                    n.memoizedState = f,
                    n.flags & 256) {
                        m = kr(Error(r(423)), n),
                        n = Np(t, n, c, s, m);
                        break e
                    } else if (c !== m) {
                        m = kr(Error(r(424)), n),
                        n = Np(t, n, c, s, m);
                        break e
                    } else
                        for (gt = di(n.stateNode.containerInfo.firstChild),
                        ft = n,
                        Ee = !0,
                        Dt = null,
                        s = Xd(n, null, c, s),
                        n.child = s; s; )
                            s.flags = s.flags & -3 | 4096,
                            s = s.sibling;
                else {
                    if (hr(),
                    c === m) {
                        n = Jt(t, n, s);
                        break e
                    }
                    nt(t, n, c, s)
                }
                n = n.child
            }
            return n;
        case 5:
            return ep(n),
            t === null && Wo(n),
            c = n.type,
            m = n.pendingProps,
            f = t !== null ? t.memoizedProps : null,
            k = m.children,
            Io(c, m) ? k = null : f !== null && Io(c, f) && (n.flags |= 32),
            Vp(t, n),
            nt(t, n, k, s),
            n.child;
        case 6:
            return t === null && Wo(n),
            null;
        case 13:
            return Fp(t, n, s);
        case 4:
            return Xo(n, n.stateNode.containerInfo),
            c = n.pendingProps,
            t === null ? n.child = fr(n, null, c, s) : nt(t, n, c, s),
            n.child;
        case 11:
            return c = n.type,
            m = n.pendingProps,
            m = n.elementType === c ? m : It(c, m),
            Ep(t, n, c, m, s);
        case 7:
            return nt(t, n, n.pendingProps, s),
            n.child;
        case 8:
            return nt(t, n, n.pendingProps.children, s),
            n.child;
        case 12:
            return nt(t, n, n.pendingProps.children, s),
            n.child;
        case 10:
            e: {
                if (c = n.type._context,
                m = n.pendingProps,
                f = n.memoizedProps,
                k = m.value,
                Te(Aa, c._currentValue),
                c._currentValue = k,
                f !== null)
                    if (Et(f.value, k)) {
                        if (f.children === m.children && !ot.current) {
                            n = Jt(t, n, s);
                            break e
                        }
                    } else
                        for (f = n.child,
                        f !== null && (f.return = n); f !== null; ) {
                            var j = f.dependencies;
                            if (j !== null) {
                                k = f.child;
                                for (var A = j.firstContext; A !== null; ) {
                                    if (A.context === c) {
                                        if (f.tag === 1) {
                                            A = Qt(-1, s & -s),
                                            A.tag = 2;
                                            var O = f.updateQueue;
                                            if (O !== null) {
                                                O = O.shared;
                                                var G = O.pending;
                                                G === null ? A.next = A : (A.next = G.next,
                                                G.next = A),
                                                O.pending = A
                                            }
                                        }
                                        f.lanes |= s,
                                        A = f.alternate,
                                        A !== null && (A.lanes |= s),
                                        Ho(f.return, s, n),
                                        j.lanes |= s;
                                        break
                                    }
                                    A = A.next
                                }
                            } else if (f.tag === 10)
                                k = f.type === n.type ? null : f.child;
                            else if (f.tag === 18) {
                                if (k = f.return,
                                k === null)
                                    throw Error(r(341));
                                k.lanes |= s,
                                j = k.alternate,
                                j !== null && (j.lanes |= s),
                                Ho(k, s, n),
                                k = f.sibling
                            } else
                                k = f.child;
                            if (k !== null)
                                k.return = f;
                            else
                                for (k = f; k !== null; ) {
                                    if (k === n) {
                                        k = null;
                                        break
                                    }
                                    if (f = k.sibling,
                                    f !== null) {
                                        f.return = k.return,
                                        k = f;
                                        break
                                    }
                                    k = k.return
                                }
                            f = k
                        }
                nt(t, n, m.children, s),
                n = n.child
            }
            return n;
        case 9:
            return m = n.type,
            c = n.pendingProps.children,
            vr(n, s),
            m = bt(m),
            c = c(m),
            n.flags |= 1,
            nt(t, n, c, s),
            n.child;
        case 14:
            return c = n.type,
            m = It(c, n.pendingProps),
            m = It(c.type, m),
            Dp(t, n, c, m, s);
        case 15:
            return Ip(t, n, n.type, n.pendingProps, s);
        case 17:
            return c = n.type,
            m = n.pendingProps,
            m = n.elementType === c ? m : It(c, m),
            Wa(t, n),
            n.tag = 1,
            lt(c) ? (t = !0,
            ba(n)) : t = !1,
            vr(n, s),
            bp(n, c, m),
            ll(n, c, m, s),
            pl(null, n, c, !0, t, s);
        case 19:
            return Bp(t, n, s);
        case 22:
            return Mp(t, n, s)
        }
        throw Error(r(156, n.tag))
    }
    ;
    function um(t, n) {
        return Uu(t, n)
    }
    function wy(t, n, s, c) {
        this.tag = t,
        this.key = s,
        this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null,
        this.index = 0,
        this.ref = null,
        this.pendingProps = n,
        this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null,
        this.mode = c,
        this.subtreeFlags = this.flags = 0,
        this.deletions = null,
        this.childLanes = this.lanes = 0,
        this.alternate = null
    }
    function jt(t, n, s, c) {
        return new wy(t,n,s,c)
    }
    function Il(t) {
        return t = t.prototype,
        !(!t || !t.isReactComponent)
    }
    function Py(t) {
        if (typeof t == "function")
            return Il(t) ? 1 : 0;
        if (t != null) {
            if (t = t.$$typeof,
            t === Q)
                return 11;
            if (t === pe)
                return 14
        }
        return 2
    }
    function Pi(t, n) {
        var s = t.alternate;
        return s === null ? (s = jt(t.tag, n, t.key, t.mode),
        s.elementType = t.elementType,
        s.type = t.type,
        s.stateNode = t.stateNode,
        s.alternate = t,
        t.alternate = s) : (s.pendingProps = n,
        s.type = t.type,
        s.flags = 0,
        s.subtreeFlags = 0,
        s.deletions = null),
        s.flags = t.flags & 14680064,
        s.childLanes = t.childLanes,
        s.lanes = t.lanes,
        s.child = t.child,
        s.memoizedProps = t.memoizedProps,
        s.memoizedState = t.memoizedState,
        s.updateQueue = t.updateQueue,
        n = t.dependencies,
        s.dependencies = n === null ? null : {
            lanes: n.lanes,
            firstContext: n.firstContext
        },
        s.sibling = t.sibling,
        s.index = t.index,
        s.ref = t.ref,
        s
    }
    function Qa(t, n, s, c, m, f) {
        var k = 2;
        if (c = t,
        typeof t == "function")
            Il(t) && (k = 1);
        else if (typeof t == "string")
            k = 5;
        else
            e: switch (t) {
            case _:
                return Ui(s.children, m, f, n);
            case F:
                k = 8,
                m |= 8;
                break;
            case R:
                return t = jt(12, s, n, m | 2),
                t.elementType = R,
                t.lanes = f,
                t;
            case se:
                return t = jt(13, s, n, m),
                t.elementType = se,
                t.lanes = f,
                t;
            case le:
                return t = jt(19, s, n, m),
                t.elementType = le,
                t.lanes = f,
                t;
            case ne:
                return Ja(s, m, f, n);
            default:
                if (typeof t == "object" && t !== null)
                    switch (t.$$typeof) {
                    case W:
                        k = 10;
                        break e;
                    case K:
                        k = 9;
                        break e;
                    case Q:
                        k = 11;
                        break e;
                    case pe:
                        k = 14;
                        break e;
                    case ie:
                        k = 16,
                        c = null;
                        break e
                    }
                throw Error(r(130, t == null ? t : typeof t, ""))
            }
        return n = jt(k, s, n, m),
        n.elementType = t,
        n.type = c,
        n.lanes = f,
        n
    }
    function Ui(t, n, s, c) {
        return t = jt(7, t, c, n),
        t.lanes = s,
        t
    }
    function Ja(t, n, s, c) {
        return t = jt(22, t, c, n),
        t.elementType = ne,
        t.lanes = s,
        t.stateNode = {
            isHidden: !1
        },
        t
    }
    function Ml(t, n, s) {
        return t = jt(6, t, null, n),
        t.lanes = s,
        t
    }
    function Vl(t, n, s) {
        return n = jt(4, t.children !== null ? t.children : [], t.key, n),
        n.lanes = s,
        n.stateNode = {
            containerInfo: t.containerInfo,
            pendingChildren: null,
            implementation: t.implementation
        },
        n
    }
    function by(t, n, s, c, m) {
        this.tag = n,
        this.containerInfo = t,
        this.finishedWork = this.pingCache = this.current = this.pendingChildren = null,
        this.timeoutHandle = -1,
        this.callbackNode = this.pendingContext = this.context = null,
        this.callbackPriority = 0,
        this.eventTimes = so(0),
        this.expirationTimes = so(-1),
        this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0,
        this.entanglements = so(0),
        this.identifierPrefix = c,
        this.onRecoverableError = m,
        this.mutableSourceEagerHydrationData = null
    }
    function Ll(t, n, s, c, m, f, k, j, A) {
        return t = new by(t,n,s,j,A),
        n === 1 ? (n = 1,
        f === !0 && (n |= 8)) : n = 0,
        f = jt(3, null, null, n),
        t.current = f,
        f.stateNode = t,
        f.memoizedState = {
            element: c,
            isDehydrated: s,
            cache: null,
            transitions: null,
            pendingSuspenseBoundaries: null
        },
        qo(f),
        t
    }
    function Sy(t, n, s) {
        var c = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
        return {
            $$typeof: B,
            key: c == null ? null : "" + c,
            children: t,
            containerInfo: n,
            implementation: s
        }
    }
    function dm(t) {
        if (!t)
            return mi;
        t = t._reactInternals;
        e: {
            if (Di(t) !== t || t.tag !== 1)
                throw Error(r(170));
            var n = t;
            do {
                switch (n.tag) {
                case 3:
                    n = n.stateNode.context;
                    break e;
                case 1:
                    if (lt(n.type)) {
                        n = n.stateNode.__reactInternalMemoizedMergedChildContext;
                        break e
                    }
                }
                n = n.return
            } while (n !== null);
            throw Error(r(171))
        }
        if (t.tag === 1) {
            var s = t.type;
            if (lt(s))
                return Rd(t, s, n)
        }
        return n
    }
    function pm(t, n, s, c, m, f, k, j, A) {
        return t = Ll(s, c, !0, t, m, f, k, j, A),
        t.context = dm(null),
        s = t.current,
        c = at(),
        m = xi(s),
        f = Qt(c, m),
        f.callback = n ?? null,
        gi(s, f, m),
        t.current.lanes = m,
        Hr(t, m, c),
        dt(t, c),
        t
    }
    function es(t, n, s, c) {
        var m = n.current
          , f = at()
          , k = xi(m);
        return s = dm(s),
        n.context === null ? n.context = s : n.pendingContext = s,
        n = Qt(f, k),
        n.payload = {
            element: t
        },
        c = c === void 0 ? null : c,
        c !== null && (n.callback = c),
        t = gi(m, n, k),
        t !== null && (Lt(t, m, k, f),
        Da(t, m, k)),
        k
    }
    function ts(t) {
        if (t = t.current,
        !t.child)
            return null;
        switch (t.child.tag) {
        case 5:
            return t.child.stateNode;
        default:
            return t.child.stateNode
        }
    }
    function mm(t, n) {
        if (t = t.memoizedState,
        t !== null && t.dehydrated !== null) {
            var s = t.retryLane;
            t.retryLane = s !== 0 && s < n ? s : n
        }
    }
    function Ol(t, n) {
        mm(t, n),
        (t = t.alternate) && mm(t, n)
    }
    function Ty() {
        return null
    }
    var hm = typeof reportError == "function" ? reportError : function(t) {
        console.error(t)
    }
    ;
    function Nl(t) {
        this._internalRoot = t
    }
    is.prototype.render = Nl.prototype.render = function(t) {
        var n = this._internalRoot;
        if (n === null)
            throw Error(r(409));
        es(t, n, null, null)
    }
    ,
    is.prototype.unmount = Nl.prototype.unmount = function() {
        var t = this._internalRoot;
        if (t !== null) {
            this._internalRoot = null;
            var n = t.containerInfo;
            Bi(function() {
                es(null, t, null, null)
            }),
            n[Gt] = null
        }
    }
    ;
    function is(t) {
        this._internalRoot = t
    }
    is.prototype.unstable_scheduleHydration = function(t) {
        if (t) {
            var n = Yu();
            t = {
                blockedOn: null,
                target: t,
                priority: n
            };
            for (var s = 0; s < li.length && n !== 0 && n < li[s].priority; s++)
                ;
            li.splice(s, 0, t),
            s === 0 && ed(t)
        }
    }
    ;
    function Fl(t) {
        return !(!t || t.nodeType !== 1 && t.nodeType !== 9 && t.nodeType !== 11)
    }
    function rs(t) {
        return !(!t || t.nodeType !== 1 && t.nodeType !== 9 && t.nodeType !== 11 && (t.nodeType !== 8 || t.nodeValue !== " react-mount-point-unstable "))
    }
    function fm() {}
    function jy(t, n, s, c, m) {
        if (m) {
            if (typeof c == "function") {
                var f = c;
                c = function() {
                    var O = ts(k);
                    f.call(O)
                }
            }
            var k = pm(n, c, t, 0, null, !1, !1, "", fm);
            return t._reactRootContainer = k,
            t[Gt] = k.current,
            on(t.nodeType === 8 ? t.parentNode : t),
            Bi(),
            k
        }
        for (; m = t.lastChild; )
            t.removeChild(m);
        if (typeof c == "function") {
            var j = c;
            c = function() {
                var O = ts(A);
                j.call(O)
            }
        }
        var A = Ll(t, 0, !1, null, null, !1, !1, "", fm);
        return t._reactRootContainer = A,
        t[Gt] = A.current,
        on(t.nodeType === 8 ? t.parentNode : t),
        Bi(function() {
            es(n, A, s, c)
        }),
        A
    }
    function ns(t, n, s, c, m) {
        var f = s._reactRootContainer;
        if (f) {
            var k = f;
            if (typeof m == "function") {
                var j = m;
                m = function() {
                    var A = ts(k);
                    j.call(A)
                }
            }
            es(n, k, t, m)
        } else
            k = jy(s, n, t, m, c);
        return ts(k)
    }
    Xu = function(t) {
        switch (t.tag) {
        case 3:
            var n = t.stateNode;
            if (n.current.memoizedState.isDehydrated) {
                var s = $r(n.pendingLanes);
                s !== 0 && (oo(n, s | 1),
                dt(n, Ne()),
                (ye & 6) === 0 && (Pr = Ne() + 500,
                hi()))
            }
            break;
        case 13:
            Bi(function() {
                var c = Yt(t, 1);
                if (c !== null) {
                    var m = at();
                    Lt(c, t, 1, m)
                }
            }),
            Ol(t, 1)
        }
    }
    ,
    lo = function(t) {
        if (t.tag === 13) {
            var n = Yt(t, 134217728);
            if (n !== null) {
                var s = at();
                Lt(n, t, 134217728, s)
            }
            Ol(t, 134217728)
        }
    }
    ,
    Zu = function(t) {
        if (t.tag === 13) {
            var n = xi(t)
              , s = Yt(t, n);
            if (s !== null) {
                var c = at();
                Lt(s, t, n, c)
            }
            Ol(t, n)
        }
    }
    ,
    Yu = function() {
        return be
    }
    ,
    Qu = function(t, n) {
        var s = be;
        try {
            return be = t,
            n()
        } finally {
            be = s
        }
    }
    ,
    eo = function(t, n, s) {
        switch (n) {
        case "input":
            if (Hs(t, s),
            n = s.name,
            s.type === "radio" && n != null) {
                for (s = t; s.parentNode; )
                    s = s.parentNode;
                for (s = s.querySelectorAll("input[name=" + JSON.stringify("" + n) + '][type="radio"]'),
                n = 0; n < s.length; n++) {
                    var c = s[n];
                    if (c !== t && c.form === t.form) {
                        var m = wa(c);
                        if (!m)
                            throw Error(r(90));
                        Pu(c),
                        Hs(c, m)
                    }
                }
            }
            break;
        case "textarea":
            Cu(t, s);
            break;
        case "select":
            n = s.value,
            n != null && Ji(t, !!s.multiple, n, !1)
        }
    }
    ,
    Ou = Al,
    Nu = Bi;
    var Cy = {
        usingClientEntryPoint: !1,
        Events: [un, cr, wa, Vu, Lu, Al]
    }
      , Sn = {
        findFiberByHostInstance: Ii,
        bundleType: 0,
        version: "18.3.1",
        rendererPackageName: "react-dom"
    }
      , zy = {
        bundleType: Sn.bundleType,
        version: Sn.version,
        rendererPackageName: Sn.rendererPackageName,
        rendererConfig: Sn.rendererConfig,
        overrideHookState: null,
        overrideHookStateDeletePath: null,
        overrideHookStateRenamePath: null,
        overrideProps: null,
        overridePropsDeletePath: null,
        overridePropsRenamePath: null,
        setErrorHandler: null,
        setSuspenseHandler: null,
        scheduleUpdate: null,
        currentDispatcherRef: D.ReactCurrentDispatcher,
        findHostInstanceByFiber: function(t) {
            return t = Wu(t),
            t === null ? null : t.stateNode
        },
        findFiberByHostInstance: Sn.findFiberByHostInstance || Ty,
        findHostInstancesForRefresh: null,
        scheduleRefresh: null,
        scheduleRoot: null,
        setRefreshHandler: null,
        getCurrentFiber: null,
        reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
    };
    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
        var as = __REACT_DEVTOOLS_GLOBAL_HOOK__;
        if (!as.isDisabled && as.supportsFiber)
            try {
                ia = as.inject(zy),
                Nt = as
            } catch {}
    }
    return pt.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Cy,
    pt.createPortal = function(t, n) {
        var s = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
        if (!Fl(n))
            throw Error(r(200));
        return Sy(t, n, null, s)
    }
    ,
    pt.createRoot = function(t, n) {
        if (!Fl(t))
            throw Error(r(299));
        var s = !1
          , c = ""
          , m = hm;
        return n != null && (n.unstable_strictMode === !0 && (s = !0),
        n.identifierPrefix !== void 0 && (c = n.identifierPrefix),
        n.onRecoverableError !== void 0 && (m = n.onRecoverableError)),
        n = Ll(t, 1, !1, null, null, s, !1, c, m),
        t[Gt] = n.current,
        on(t.nodeType === 8 ? t.parentNode : t),
        new Nl(n)
    }
    ,
    pt.findDOMNode = function(t) {
        if (t == null)
            return null;
        if (t.nodeType === 1)
            return t;
        var n = t._reactInternals;
        if (n === void 0)
            throw typeof t.render == "function" ? Error(r(188)) : (t = Object.keys(t).join(","),
            Error(r(268, t)));
        return t = Wu(n),
        t = t === null ? null : t.stateNode,
        t
    }
    ,
    pt.flushSync = function(t) {
        return Bi(t)
    }
    ,
    pt.hydrate = function(t, n, s) {
        if (!rs(n))
            throw Error(r(200));
        return ns(null, t, n, !0, s)
    }
    ,
    pt.hydrateRoot = function(t, n, s) {
        if (!Fl(t))
            throw Error(r(405));
        var c = s != null && s.hydratedSources || null
          , m = !1
          , f = ""
          , k = hm;
        if (s != null && (s.unstable_strictMode === !0 && (m = !0),
        s.identifierPrefix !== void 0 && (f = s.identifierPrefix),
        s.onRecoverableError !== void 0 && (k = s.onRecoverableError)),
        n = pm(n, null, t, 1, s ?? null, m, !1, f, k),
        t[Gt] = n.current,
        on(t),
        c)
            for (t = 0; t < c.length; t++)
                s = c[t],
                m = s._getVersion,
                m = m(s._source),
                n.mutableSourceEagerHydrationData == null ? n.mutableSourceEagerHydrationData = [s, m] : n.mutableSourceEagerHydrationData.push(s, m);
        return new is(n)
    }
    ,
    pt.render = function(t, n, s) {
        if (!rs(n))
            throw Error(r(200));
        return ns(null, t, n, !1, s)
    }
    ,
    pt.unmountComponentAtNode = function(t) {
        if (!rs(t))
            throw Error(r(40));
        return t._reactRootContainer ? (Bi(function() {
            ns(null, null, t, !1, function() {
                t._reactRootContainer = null,
                t[Gt] = null
            })
        }),
        !0) : !1
    }
    ,
    pt.unstable_batchedUpdates = Al,
    pt.unstable_renderSubtreeIntoContainer = function(t, n, s, c) {
        if (!rs(s))
            throw Error(r(200));
        if (t == null || t._reactInternals === void 0)
            throw Error(r(38));
        return ns(t, n, s, !1, c)
    }
    ,
    pt.version = "18.3.1-next-f1338f8080-20240426",
    pt
}
var bm;
function Ny() {
    if (bm)
        return Wl.exports;
    bm = 1;
    function i() {
        if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function"))
            try {
                __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(i)
            } catch (e) {
                console.error(e)
            }
    }
    return i(),
    Wl.exports = Oy(),
    Wl.exports
}
var Sm;
function Fy() {
    if (Sm)
        return ss;
    Sm = 1;
    var i = Ny();
    return ss.createRoot = i.createRoot,
    ss.hydrateRoot = i.hydrateRoot,
    ss
}
var Ry = Fy();
const By = (i, e, r, a) => {
    var l, u, d, p;
    const o = [r, {
        code: e,
        ...a || {}
    }];
    if ((u = (l = i == null ? void 0 : i.services) == null ? void 0 : l.logger) != null && u.forward)
        return i.services.logger.forward(o, "warn", "react-i18next::", !0);
    qi(o[0]) && (o[0] = `react-i18next:: ${o[0]}`),
    (p = (d = i == null ? void 0 : i.services) == null ? void 0 : d.logger) != null && p.warn ? i.services.logger.warn(...o) : console != null && console.warn && console.warn(...o)
}
  , Tm = {}
  , pc = (i, e, r, a) => {
    qi(r) && Tm[r] || (qi(r) && (Tm[r] = new Date),
    By(i, e, r, a))
}
  , Sf = (i, e) => () => {
    if (i.isInitialized)
        e();
    else {
        const r = () => {
            setTimeout( () => {
                i.off("initialized", r)
            }
            , 0),
            e()
        }
        ;
        i.on("initialized", r)
    }
}
  , mc = (i, e, r) => {
    i.loadNamespaces(e, Sf(i, r))
}
  , jm = (i, e, r, a) => {
    if (qi(r) && (r = [r]),
    i.options.preload && i.options.preload.indexOf(e) > -1)
        return mc(i, r, a);
    r.forEach(o => {
        i.options.ns.indexOf(o) < 0 && i.options.ns.push(o)
    }
    ),
    i.loadLanguages(e, Sf(i, a))
}
  , Wy = (i, e, r={}) => !e.languages || !e.languages.length ? (pc(e, "NO_LANGUAGES", "i18n.languages were undefined or empty", {
    languages: e.languages
}),
!0) : e.hasLoadedNamespace(i, {
    lng: r.lng,
    precheck: (a, o) => {
        if (r.bindI18n && r.bindI18n.indexOf("languageChanging") > -1 && a.services.backendConnector.backend && a.isLanguageChangingTo && !o(a.isLanguageChangingTo, i))
            return !1
    }
})
  , qi = i => typeof i == "string"
  , _y = i => typeof i == "object" && i !== null
  , Uy = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g
  , Ky = {
    "&amp;": "&",
    "&#38;": "&",
    "&lt;": "<",
    "&#60;": "<",
    "&gt;": ">",
    "&#62;": ">",
    "&apos;": "'",
    "&#39;": "'",
    "&quot;": '"',
    "&#34;": '"',
    "&nbsp;": " ",
    "&#160;": " ",
    "&copy;": "©",
    "&#169;": "©",
    "&reg;": "®",
    "&#174;": "®",
    "&hellip;": "…",
    "&#8230;": "…",
    "&#x2F;": "/",
    "&#47;": "/"
}
  , $y = i => Ky[i]
  , Hy = i => i.replace(Uy, $y);
let hc = {
    bindI18n: "languageChanged",
    bindI18nStore: "",
    transEmptyNodeValue: "",
    transSupportBasicHtmlNodes: !0,
    transWrapTextNodes: "",
    transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
    useSuspense: !0,
    unescape: Hy
};
const Gy = (i={}) => {
    hc = {
        ...hc,
        ...i
    }
}
  , qy = () => hc;
let Tf;
const Xy = i => {
    Tf = i
}
  , Zy = () => Tf
  , Yy = {
    type: "3rdParty",
    init(i) {
        Gy(i.options.react),
        Xy(i)
    }
}
  , Qy = N.createContext();
class Jy {
    constructor() {
        this.usedNamespaces = {}
    }
    addUsedNamespaces(e) {
        e.forEach(r => {
            this.usedNamespaces[r] || (this.usedNamespaces[r] = !0)
        }
        )
    }
    getUsedNamespaces() {
        return Object.keys(this.usedNamespaces)
    }
}
const e1 = (i, e) => {
    const r = N.useRef();
    return N.useEffect( () => {
        r.current = i
    }
    , [i, e]),
    r.current
}
  , jf = (i, e, r, a) => i.getFixedT(e, r, a)
  , t1 = (i, e, r, a) => N.useCallback(jf(i, e, r, a), [i, e, r, a])
  , We = (i, e={}) => {
    var D, M, B, _;
    const {i18n: r} = e
      , {i18n: a, defaultNS: o} = N.useContext(Qy) || {}
      , l = r || a || Zy();
    if (l && !l.reportNamespaces && (l.reportNamespaces = new Jy),
    !l) {
        pc(l, "NO_I18NEXT_INSTANCE", "useTranslation: You will need to pass in an i18next instance by using initReactI18next");
        const F = (W, K) => qi(K) ? K : _y(K) && qi(K.defaultValue) ? K.defaultValue : Array.isArray(W) ? W[W.length - 1] : W
          , R = [F, {}, !1];
        return R.t = F,
        R.i18n = {},
        R.ready = !1,
        R
    }
    (D = l.options.react) != null && D.wait && pc(l, "DEPRECATED_OPTION", "useTranslation: It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
    const u = {
        ...qy(),
        ...l.options.react,
        ...e
    }
      , {useSuspense: d, keyPrefix: p} = u;
    let h = o || ((M = l.options) == null ? void 0 : M.defaultNS);
    h = qi(h) ? [h] : h || ["translation"],
    (_ = (B = l.reportNamespaces).addUsedNamespaces) == null || _.call(B, h);
    const g = (l.isInitialized || l.initializedStoreOnce) && h.every(F => Wy(F, l, u))
      , v = t1(l, e.lng || null, u.nsMode === "fallback" ? h : h[0], p)
      , y = () => v
      , P = () => jf(l, e.lng || null, u.nsMode === "fallback" ? h : h[0], p)
      , [w,S] = N.useState(y);
    let z = h.join();
    e.lng && (z = `${e.lng}${z}`);
    const C = e1(z)
      , b = N.useRef(!0);
    N.useEffect( () => {
        const {bindI18n: F, bindI18nStore: R} = u;
        b.current = !0,
        !g && !d && (e.lng ? jm(l, e.lng, h, () => {
            b.current && S(P)
        }
        ) : mc(l, h, () => {
            b.current && S(P)
        }
        )),
        g && C && C !== z && b.current && S(P);
        const W = () => {
            b.current && S(P)
        }
        ;
        return F && (l == null || l.on(F, W)),
        R && (l == null || l.store.on(R, W)),
        () => {
            b.current = !1,
            l && F && (F == null || F.split(" ").forEach(K => l.off(K, W))),
            R && l && R.split(" ").forEach(K => l.store.off(K, W))
        }
    }
    , [l, z]),
    N.useEffect( () => {
        b.current && g && S(y)
    }
    , [l, p, g]);
    const T = [w, l, g];
    if (T.t = w,
    T.i18n = l,
    T.ready = g,
    g || !g && !d)
        return T;
    throw new Promise(F => {
        e.lng ? jm(l, e.lng, h, () => F()) : mc(l, h, () => F())
    }
    )
}
  , Cf = "/cdn/shop/t/1/assets/e4fVpnHH.svg"
  , i1 = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_8037_3569)'%3e%3cpath%20d='M8.81909%2012.4804C8.81909%2013.1704%209.32309%2013.7304%209.94209%2013.7304C10.5671%2013.7304%2011.0661%2013.1694%2011.0661%2012.4804C11.0781%2011.7934%2010.5661%2011.2314%209.94209%2011.2314C9.31109%2011.2314%208.81909%2011.7934%208.81909%2012.4814M12.9661%2012.4804C12.9661%2013.1704%2013.4721%2013.7304%2014.0901%2013.7304C14.7201%2013.7304%2015.2131%2013.1694%2015.2131%2012.4804C15.2261%2011.7934%2014.7141%2011.2314%2014.0901%2011.2314C13.4591%2011.2314%2012.9661%2011.7934%2012.9661%2012.4814'%20fill='%23F5F5F5'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M22%2012C22%2017.523%2017.523%2022%2012%2022C6.477%2022%202%2017.523%202%2012C2%206.477%206.477%202%2012%202C17.523%202%2022%206.477%2022%2012ZM13.774%207.28C14.6658%207.43049%2015.534%207.69779%2016.356%208.075H16.358C17.772%2010.139%2018.474%2012.475%2018.202%2015.164C17.2448%2015.8671%2016.1753%2016.4027%2015.039%2016.748C14.784%2016.4034%2014.5582%2016.0382%2014.364%2015.656C14.7353%2015.516%2015.0907%2015.3457%2015.43%2015.145C15.364%2015.0963%2015.2987%2015.0457%2015.234%2014.993L15.171%2014.943C13.139%2015.883%2010.91%2015.883%208.852%2014.943C8.76867%2015.0137%208.682%2015.081%208.592%2015.145C8.934%2015.347%209.287%2015.517%209.66%2015.655C9.46552%2016.0375%209.2394%2016.4031%208.984%2016.748C7.84767%2016.4027%206.77816%2015.8671%205.821%2015.164C5.601%2012.841%206.042%2010.486%207.677%208.075C8.49818%207.69557%209.36661%207.42818%2010.259%207.28C10.365%207.475%2010.499%207.74%2010.587%207.949C11.5353%207.81057%2012.4987%207.81057%2013.447%207.949C13.535%207.741%2013.66%207.475%2013.774%207.279'%20fill='%23F5F5F5'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_8037_3569'%3e%3crect%20width='24'%20height='24'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e"
  , r1 = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_8037_3579)'%3e%3cpath%20d='M22%2012.07C22%2017.083%2018.341%2021.249%2013.563%2022.01V14.98H15.899L16.336%2012.07H13.573V10.18C13.573%209.386%2013.957%208.602%2015.195%208.602H16.464V6.133C16.464%206.133%2015.312%205.94%2014.224%205.94C11.941%205.94%2010.437%207.335%2010.437%209.848V12.07H7.9V14.98H10.438V22.01C8.08122%2021.6229%205.93873%2020.4108%204.39308%2018.59C2.84743%2016.7692%201.99926%2014.4584%202%2012.07C2%206.509%206.48%202%2012.005%202C17.53%202%2022%206.509%2022%2012.07Z'%20fill='%23F5F5F5'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_8037_3579'%3e%3crect%20width='24'%20height='24'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e"
  , n1 = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_8037_3589)'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M12.0001%207.38184C11.3936%207.38184%2010.7931%207.50128%2010.2328%207.73336C9.67257%207.96544%209.16348%208.3056%208.73466%208.73442C8.30584%209.16324%207.96568%209.67232%207.7336%2010.2326C7.50153%2010.7929%207.38208%2011.3934%207.38208%2011.9998C7.38208%2012.6063%207.50153%2013.2068%207.7336%2013.7671C7.96568%2014.3273%208.30584%2014.8364%208.73466%2015.2653C9.16348%2015.6941%209.67257%2016.0342%2010.2328%2016.2663C10.7931%2016.4984%2011.3936%2016.6178%2012.0001%2016.6178C13.2248%2016.6178%2014.3995%2016.1313%2015.2655%2015.2653C16.1315%2014.3992%2016.6181%2013.2246%2016.6181%2011.9998C16.6181%2010.7751%2016.1315%209.60046%2015.2655%208.73442C14.3995%207.86837%2013.2248%207.38184%2012.0001%207.38184ZM12.0001%2015.0038C11.2038%2015.0028%2010.4404%2014.6859%209.87745%2014.1228C9.31448%2013.5596%208.99787%2012.7961%208.99708%2011.9998C8.99814%2011.2037%209.31487%2010.4405%209.87781%209.87756C10.4408%209.31462%2011.204%208.99789%2012.0001%208.99684C12.7964%208.99763%2013.5598%209.31424%2014.123%209.87721C14.6862%2010.4402%2015.003%2011.2035%2015.0041%2011.9998C15.0033%2012.7963%2014.6865%2013.5599%2014.1234%2014.1231C13.5602%2014.6863%2012.7965%2015.003%2012.0001%2015.0038Z'%20fill='%23F5F5F5'/%3e%3cpath%20d='M17.8841%207.19719C17.8841%207.33902%2017.8562%207.47945%2017.8019%207.61049C17.7476%207.74152%2017.6681%207.86058%2017.5678%207.96086C17.4675%208.06115%2017.3485%208.1407%2017.2174%208.19498C17.0864%208.24925%2016.9459%208.27719%2016.8041%208.27719C16.6623%208.27719%2016.5219%208.24925%2016.3908%208.19498C16.2598%208.1407%2016.1407%208.06115%2016.0404%207.96086C15.9402%207.86058%2015.8606%207.74152%2015.8063%207.61049C15.7521%207.47945%2015.7241%207.33902%2015.7241%207.19719C15.7241%206.91075%2015.8379%206.63605%2016.0404%206.43351C16.243%206.23097%2016.5177%206.11719%2016.8041%206.11719C17.0906%206.11719%2017.3653%206.23097%2017.5678%206.43351C17.7703%206.63605%2017.8841%206.91075%2017.8841%207.19719Z'%20fill='%23F5F5F5'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M12%203C9.552%203%209.254%203.01%208.287%203.051C7.33%203.103%206.672%203.247%206.107%203.473C5.50439%203.69582%204.95937%204.05086%204.512%204.512C4.05098%204.95908%203.69596%205.50375%203.473%206.106C3.247%206.672%203.103%207.33%203.051%208.286C3.011%209.255%203%209.553%203%2012C3%2014.447%203.01%2014.746%203.051%2015.713C3.093%2016.67%203.247%2017.328%203.473%2017.893C3.699%2018.49%204.008%2018.984%204.512%2019.488C5.016%2019.992%205.51%2020.301%206.106%2020.527C6.682%2020.753%207.33%2020.897%208.286%2020.949C9.243%2020.989%209.552%2021%2012%2021C14.448%2021%2014.746%2020.99%2015.713%2020.949C16.67%2020.907%2017.328%2020.753%2017.893%2020.527C18.4956%2020.3042%2019.0406%2019.9491%2019.488%2019.488C19.949%2019.0409%2020.304%2018.4963%2020.527%2017.894C20.753%2017.318%2020.897%2016.67%2020.949%2015.714C20.989%2014.757%2021%2014.448%2021%2012C21%209.552%2020.99%209.254%2020.949%208.287C20.907%207.33%2020.753%206.672%2020.527%206.107C20.3042%205.50439%2019.9491%204.95937%2019.488%204.512C19.0409%204.05098%2018.4963%203.69596%2017.894%203.473C17.318%203.247%2016.67%203.103%2015.714%203.051C14.745%203.011%2014.447%203%2012%203ZM12%204.625C14.407%204.625%2014.685%204.635%2015.641%204.677C16.515%204.717%2016.999%204.862%2017.307%204.985C17.729%205.15%2018.027%205.345%2018.347%205.654C18.665%205.973%2018.861%206.271%2019.015%206.693C19.138%207.011%2019.282%207.485%2019.323%208.359C19.365%209.305%2019.375%209.593%2019.375%2012C19.375%2014.407%2019.365%2014.685%2019.323%2015.641C19.283%2016.515%2019.138%2016.999%2019.015%2017.307C18.85%2017.729%2018.655%2018.027%2018.346%2018.347C18.0569%2018.6481%2017.701%2018.8769%2017.307%2019.015C16.989%2019.138%2016.515%2019.282%2015.641%2019.323C14.695%2019.365%2014.407%2019.375%2012%2019.375C9.593%2019.375%209.315%2019.365%208.359%2019.323C7.485%2019.283%207.001%2019.138%206.693%2019.015C6.30227%2018.8694%205.94754%2018.6412%205.653%2018.346C5.35189%2018.0569%205.12306%2017.701%204.985%2017.307C4.862%2016.989%204.718%2016.515%204.677%2015.641C4.635%2014.695%204.625%2014.407%204.625%2012C4.625%209.593%204.635%209.315%204.677%208.359C4.717%207.485%204.862%207.001%204.985%206.693C5.15%206.271%205.345%205.973%205.654%205.653C5.94312%205.35189%206.29905%205.12306%206.693%204.985C7.011%204.862%207.485%204.718%208.359%204.677C9.315%204.635%209.593%204.625%2012%204.625Z'%20fill='%23F5F5F5'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_8037_3589'%3e%3crect%20width='24'%20height='24'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e"
  , a1 = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M19%203C19.5304%203%2020.0391%203.21071%2020.4142%203.58579C20.7893%203.96086%2021%204.46957%2021%205V19C21%2019.5304%2020.7893%2020.0391%2020.4142%2020.4142C20.0391%2020.7893%2019.5304%2021%2019%2021H5C4.46957%2021%203.96086%2020.7893%203.58579%2020.4142C3.21071%2020.0391%203%2019.5304%203%2019V5C3%204.46957%203.21071%203.96086%203.58579%203.58579C3.96086%203.21071%204.46957%203%205%203H19ZM18.5%2018.5V13.2C18.5%2012.3354%2018.1565%2011.5062%2017.5452%2010.8948C16.9338%2010.2835%2016.1046%209.94%2015.24%209.94C14.39%209.94%2013.4%2010.46%2012.92%2011.24V10.13H10.13V18.5H12.92V13.57C12.92%2012.8%2013.54%2012.17%2014.31%2012.17C14.6813%2012.17%2015.0374%2012.3175%2015.2999%2012.5801C15.5625%2012.8426%2015.71%2013.1987%2015.71%2013.57V18.5H18.5ZM6.88%208.56C7.32556%208.56%207.75288%208.383%208.06794%208.06794C8.383%207.75288%208.56%207.32556%208.56%206.88C8.56%205.95%207.81%205.19%206.88%205.19C6.43178%205.19%206.00193%205.36805%205.68499%205.68499C5.36805%206.00193%205.19%206.43178%205.19%206.88C5.19%207.81%205.95%208.56%206.88%208.56ZM8.27%2018.5V10.13H5.5V18.5H8.27Z'%20fill='white'/%3e%3c/svg%3e"
  , s1 = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_8037_3585)'%3e%3cpath%20d='M9.71199%2011.9941C10.287%2011.9941%2010.756%2012.4631%2010.756%2013.0381C10.756%2013.6131%2010.287%2014.0831%209.71199%2014.0831C9.43492%2014.0829%209.16928%2013.9727%208.97336%2013.7768C8.77744%2013.5809%208.66726%2013.3152%208.66699%2013.0381C8.66699%2012.4631%209.13699%2011.9941%209.71199%2011.9941ZM12.003%2016.0221C12.685%2016.0221%2013.643%2015.8621%2014.091%2015.4141C14.1417%2015.3638%2014.2096%2015.3348%2014.281%2015.3329C14.3524%2015.331%2014.4218%2015.3565%2014.475%2015.4041C14.5002%2015.4292%2014.5203%2015.4591%2014.5339%2015.4919C14.5476%2015.5248%2014.5547%2015.56%2014.5547%2015.5956C14.5547%2015.6312%2014.5476%2015.6665%2014.5339%2015.6993C14.5203%2015.7322%2014.5002%2015.762%2014.475%2015.7871C13.761%2016.5011%2012.408%2016.5551%2012.003%2016.5551C11.598%2016.5551%2010.245%2016.5011%209.53099%2015.7981C9.5056%2015.773%209.48543%2015.7431%209.47167%2015.7102C9.45791%2015.6772%209.45082%2015.6419%209.45082%2015.6061C9.45082%2015.5704%209.45791%2015.5351%209.47167%2015.5021C9.48543%2015.4692%209.5056%2015.4393%209.53099%2015.4141C9.55609%2015.3889%209.58592%2015.3689%209.61879%2015.3552C9.65165%2015.3415%209.6869%2015.3345%209.72249%2015.3345C9.75809%2015.3345%209.79333%2015.3415%209.8262%2015.3552C9.85906%2015.3689%209.8889%2015.3889%209.91399%2015.4141C10.362%2015.8621%2011.321%2016.0221%2012.003%2016.0221ZM13.25%2013.0501C13.25%2012.4741%2013.718%2012.0051%2014.294%2012.0051C14.5696%2012.0093%2014.8327%2012.1206%2015.0276%2012.3155C15.2225%2012.5104%2015.3339%2012.7735%2015.338%2013.0491C15.338%2013.6251%2014.869%2014.0931%2014.294%2014.0931C14.0171%2014.0929%2013.7516%2013.9828%2013.5557%2013.7871C13.3598%2013.5914%2013.2495%2013.326%2013.249%2013.0491'%20fill='%23F5F5F5'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M12.0031%202.00977C6.48306%202.00977%202.00806%206.48477%202.00806%2012.0048C2.00806%2017.5248%206.48306%2021.9998%2012.0031%2021.9998C13.3158%2022.0004%2014.6158%2021.7423%2015.8288%2021.2403C17.0417%2020.7382%2018.1438%2020.002%2019.0721%2019.0738C20.0003%2018.1455%2020.7365%2017.0434%2021.2386%2015.8305C21.7406%2014.6175%2021.9987%2013.3175%2021.9981%2012.0048C21.9881%206.48477%2017.5231%202.00977%2012.0031%202.00977ZM17.8001%2013.3368C17.8211%2013.4758%2017.8321%2013.6248%2017.8321%2013.7738C17.8321%2016.0218%2015.2221%2017.8338%2012.0031%2017.8338C8.78406%2017.8338%206.17406%2016.0218%206.17406%2013.7738C6.17406%2013.6224%206.18472%2013.4768%206.20606%2013.3368C5.94831%2013.2227%205.7294%2013.0359%205.57613%2012.7993C5.42286%2012.5628%205.34187%2012.2866%205.34306%2012.0048C5.34346%2011.7186%205.42782%2011.4389%205.58569%2011.2002C5.74356%2010.9616%205.968%2010.7745%206.23118%2010.6621C6.49436%2010.5498%206.78472%2010.5172%207.06627%2010.5683C7.34781%2010.6195%207.60817%2010.7521%207.81506%2010.9498C8.82806%2010.2148%2010.2231%209.75677%2011.7791%209.71377C11.7791%209.69277%2012.5151%206.22877%2012.5151%206.22877C12.5151%206.16577%2012.5571%206.10177%2012.6101%206.06877C12.6392%206.04822%2012.6723%206.03388%2012.7072%206.02666C12.7421%206.01943%2012.7781%206.01947%2012.8131%206.02677L15.2321%206.54877C15.4021%206.20877%2015.7541%205.96277%2016.1591%205.96277C16.2963%205.96224%2016.4323%205.98888%2016.5592%206.04116C16.6861%206.09344%2016.8014%206.17032%2016.8985%206.26737C16.9955%206.36442%2017.0724%206.47972%2017.1247%206.60662C17.1769%206.73352%2017.2036%206.86952%2017.2031%207.00677C17.2037%207.1441%2017.1772%207.2802%2017.125%207.40722C17.0727%207.53424%2016.9959%207.64966%2016.8988%207.74681C16.8017%207.84397%2016.6864%207.92094%2016.5594%207.97328C16.4325%208.02562%2016.2964%208.0523%2016.1591%208.05177C15.892%208.05224%2015.6352%207.94931%2015.4424%207.76455C15.2497%207.57979%2015.1359%207.32756%2015.1251%207.06077L12.9511%206.59077L12.2911%209.71377C13.8251%209.76677%2015.2001%2010.2358%2016.1911%2010.9498C16.3957%2010.7484%2016.6554%2010.6122%2016.9373%2010.5584C17.2193%2010.5045%2017.5109%2010.5353%2017.7754%2010.647C18.0398%2010.7587%2018.2653%2010.9462%2018.4233%2011.1859C18.5812%2011.4256%2018.6647%2011.7067%2018.6631%2011.9938C18.6626%2012.2767%2018.5811%2012.5536%2018.4282%2012.7916C18.2752%2013.0296%2018.0572%2013.2188%2017.8001%2013.3368Z'%20fill='%23F5F5F5'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_8037_3585'%3e%3crect%20width='24'%20height='24'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e"
  , o1 = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_8037_3573)'%3e%3cpath%20d='M12%202C6.478%202%202%206.478%202%2011.99C2%2017.511%206.478%2022%2012%2022C17.522%2022%2022%2017.512%2022%2011.99C22%206.477%2017.522%202%2012%202ZM16.925%208.28C16.861%209.207%2015.145%2016.137%2015.145%2016.137C15.145%2016.137%2015.038%2016.542%2014.665%2016.552C14.5744%2016.5566%2014.4838%2016.5418%2014.3994%2016.5087C14.3149%2016.4756%2014.2384%2016.4249%2014.175%2016.36C13.78%2016.03%2012.885%2015.39%2012.043%2014.804C12.0097%2014.8385%2011.9739%2014.8706%2011.936%2014.9C11.744%2015.07%2011.456%2015.316%2011.147%2015.614C11.03%2015.721%2010.902%2015.838%2010.774%2015.966L10.764%2015.976C10.7034%2016.0371%2010.6389%2016.0942%2010.571%2016.147C10.156%2016.488%2010.113%2016.2%2010.113%2016.051L10.337%2013.61V13.589L10.347%2013.567C10.358%2013.535%2010.38%2013.524%2010.38%2013.524C10.38%2013.524%2014.74%209.644%2014.857%209.228C14.867%209.207%2014.836%209.185%2014.783%209.207C14.495%209.303%209.473%2012.48%208.919%2012.832C8.887%2012.852%208.791%2012.842%208.791%2012.842L6.35%2012.042C6.35%2012.042%206.062%2011.925%206.158%2011.659C6.179%2011.605%206.211%2011.552%206.328%2011.478C6.872%2011.094%2016.328%207.693%2016.328%207.693C16.328%207.693%2016.595%207.608%2016.755%207.661C16.829%207.693%2016.872%207.725%2016.915%207.831C16.925%207.874%2016.936%207.959%2016.936%208.055C16.936%208.109%2016.926%208.173%2016.926%208.279'%20fill='%23F5F5F5'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_8037_3573'%3e%3crect%20width='24'%20height='24'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e"
  , l1 = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_8037_3576)'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M15.5171%203C15.8141%205.554%2017.2401%207.077%2019.7181%207.24V10.112C18.2821%2010.252%2017.0231%209.782%2015.5601%208.897V14.27C15.5601%2021.096%208.11905%2023.23%205.12705%2018.337C3.20405%2015.188%204.38205%209.664%2010.5491%209.442V12.472C10.0791%2012.547%209.57705%2012.666%209.11805%2012.822C7.74605%2013.287%206.96805%2014.157%207.18405%2015.69C7.60005%2018.628%2012.9891%2019.497%2012.5411%2013.757V3.005H15.5171V3Z'%20fill='%23F5F5F5'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_8037_3576'%3e%3crect%20width='24'%20height='24'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e"
  , c1 = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_8037_3582)'%3e%3cpath%20d='M2.44102%203.29297L9.62362%2012.8971L2.39624%2020.7066H4.02305L10.3512%2013.8691L15.463%2020.7066H21.0001L13.4127%2010.5614L20.1401%203.29297H18.5133L12.6869%209.58941L7.97628%203.29297H2.44102ZM4.83273%204.49256H7.37742L18.6084%2019.507H16.0637L4.83273%204.49256Z'%20fill='%23F5F5F5'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_8037_3582'%3e%3crect%20width='24'%20height='24'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e"
  , u1 = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_8037_3597)'%3e%3cpath%20d='M22.5569%206.94713C22.3049%206.04913%2021.5599%205.33213%2020.6109%205.09313C18.8929%204.66113%2012.0089%204.66113%2012.0089%204.66113C12.0089%204.66113%205.11294%204.66113%203.39494%205.09313C2.44494%205.34313%201.71294%206.04913%201.44894%206.94713C0.991943%208.58413%200.991943%2011.9961%200.991943%2011.9961C0.991943%2011.9961%200.991943%2015.4081%201.44894%2017.0461C1.70094%2017.9551%202.44594%2018.6601%203.39494%2018.8991C5.11294%2019.3311%2011.9969%2019.3311%2011.9969%2019.3311C11.9969%2019.3311%2018.8809%2019.3311%2020.5989%2018.8991C21.5359%2018.6601%2022.2929%2017.9551%2022.5449%2017.0451C23.0019%2015.4081%2023.0019%2011.9961%2023.0019%2011.9961C23.0019%2011.9961%2023.0139%208.58513%2022.5569%206.94713ZM9.74994%2015.1001V8.90313L15.5049%2011.9961L9.74994%2015.1001Z'%20fill='%23F5F5F5'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_8037_3597'%3e%3crect%20width='24'%20height='24'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e"
  , d1 = "/cdn/shop/t/1/assets/fdf-DXRjENRb.svg"
  , p1 = [{
    icon: c1,
    name: "X",
    url: "https://x.com/tradingview/"
}, {
    icon: r1,
    name: "Facebook",
    url: "https://www.facebook.com/tradingview/"
}, {
    icon: u1,
    name: "YouTube",
    url: "https://www.youtube.com/@TradingView"
}, {
    icon: n1,
    name: "Instagram",
    url: "https://www.instagram.com/tradingview/"
}, {
    icon: a1,
    name: "LinkedIn",
    url: "https://www.linkedin.com/company/tradingview/"
}, {
    icon: o1,
    name: "Telegram",
    url: "https://t.me/tradingview/"
}, {
    icon: l1,
    name: "TikTok",
    url: "https://www.tiktok.com/@tradingview/"
}, {
    icon: s1,
    name: "Reddit",
    url: "https://www.reddit.com/r/TradingView/"
}, {
    icon: i1,
    name: "Discord",
    url: "https://discord.com/invite/tradingview-641192799211094016"
}]
  , os = {
    column1: [{
        title: "moreThanProduct",
        links: [{
            name: "supercharts",
            url: "https://www.tradingview.com/chart/"
        }]
    }, {
        title: "screeners",
        links: [{
            name: "stocks",
            url: "https://www.tradingview.com/screener/"
        }, {
            name: "etfs",
            url: "https://www.tradingview.com/etf-screener/"
        }, {
            name: "bonds",
            url: "https://www.tradingview.com/bond-screener/"
        }, {
            name: "cryptoCoins",
            url: "https://www.tradingview.com/crypto-coins-screener/"
        }, {
            name: "cexPairs",
            url: "https://www.tradingview.com/cex-screener/"
        }, {
            name: "dexPairs",
            url: "https://www.tradingview.com/dex-screener/"
        }, {
            name: "pine",
            url: "https://www.tradingview.com/pine-screener/"
        }]
    }, {
        title: "heatmaps",
        links: [{
            name: "stocks",
            url: "https://www.tradingview.com/heatmap/stock/"
        }, {
            name: "etfs",
            url: "https://www.tradingview.com/heatmap/etf/"
        }, {
            name: "crypto",
            url: "https://www.tradingview.com/heatmap/crypto/"
        }]
    }, {
        title: "calendars",
        links: [{
            name: "economic",
            url: "https://www.tradingview.com/economic-calendar/"
        }, {
            name: "earnings",
            url: "https://www.tradingview.com/earnings-calendar/"
        }, {
            name: "dividends",
            url: "https://www.tradingview.com/dividend-calendar/"
        }]
    }, {
        title: "moreProducts",
        links: [{
            name: "yieldCurves",
            url: "https://www.tradingview.com/yield-curves/"
        }, {
            name: "options",
            url: "https://www.tradingview.com/options/"
        }, {
            name: "newsFlow",
            url: "https://www.tradingview.com/news-flow/"
        }, {
            name: "pineScript",
            url: "https://www.tradingview.com/pine-script-docs/"
        }]
    }, {
        title: "apps",
        links: [{
            name: "mobile",
            url: "https://www.tradingview.com/mobile/"
        }, {
            name: "desktop",
            url: "https://www.tradingview.com/desktop/"
        }]
    }],
    column2: [{
        title: "toolsSubscriptions",
        links: [{
            name: "features",
            url: "https://www.tradingview.com/features/"
        }, {
            name: "pricing",
            url: "https://www.tradingview.com/pricing/?source=footer&feature=pricing"
        }, {
            name: "marketData",
            url: "https://www.tradingview.com/data-coverage/"
        }]
    }, {
        title: "trading",
        links: [{
            name: "overview",
            url: "https://www.tradingview.com/trading/"
        }, {
            name: "brokers",
            url: "https://www.tradingview.com/brokers/"
        }]
    }, {
        title: "specialOffers",
        links: [{
            name: "cmeGroupFutures",
            url: "https://www.tradingview.com/cme/"
        }, {
            name: "eurexFutures",
            url: "https://www.tradingview.com/eurex/"
        }, {
            name: "usStocksBundle",
            url: "https://www.tradingview.com/us-markets-bundle/"
        }]
    }, {
        title: "aboutCompany",
        links: [{
            name: "whoWeAre",
            url: "https://www.tradingview.com/about/"
        }, {
            name: "manifesto",
            url: "https://www.tradingview.com/manifesto/"
        }, {
            name: "athletes",
            url: "https://www.tradingview.com/athletes/"
        }, {
            name: "blog",
            url: "https://www.tradingview.com/blog/en/"
        }, {
            name: "careers",
            url: "https://www.tradingview.com/careers/"
        }, {
            name: "mediaKit",
            url: "https://www.tradingview.com/media-kit/"
        }]
    }, {
        title: "merch",
        links: [{
            name: "tradingViewStore",
            url: "https://tradingviewstore.com/"
        }, {
            name: "tarotCards",
            url: "https://www.tradingview.com/tarot-reading/"
        }, {
            name: "tradeTime",
            url: "https://www.tradingview.com/tradetime/"
        }]
    }, {
        title: "policiesSecurity",
        links: [{
            name: "termsOfUse",
            url: "https://www.tradingview.com/policies/"
        }, {
            name: "disclaimer",
            url: "https://www.tradingview.com/disclaimer/"
        }, {
            name: "privacyPolicy",
            url: "https://www.tradingview.com/privacy-policy/"
        }, {
            name: "cookiesPolicy",
            url: "https://www.tradingview.com/cookies-policy/"
        }, {
            name: "accessibilityStatement",
            url: "https://www.tradingview.com/accessibility/"
        }, {
            name: "securityVulnerability",
            url: "https://www.tradingview.com/bounty/"
        }, {
            name: "statusPage",
            url: "https://status.tradingview.com/"
        }]
    }],
    column3: [{
        title: "community",
        links: [{
            name: "socialNetwork",
            url: "https://www.tradingview.com/social-network/"
        }, {
            name: "wallOfLove",
            url: "https://www.tradingview.com/wall-of-love/"
        }, {
            name: "referFriend",
            url: "https://www.tradingview.com/share-your-love/?source=footer&feature=refer_friend"
        }, {
            name: "houseRules",
            url: "https://www.tradingview.com/house-rules/"
        }, {
            name: "moderators",
            url: "https://www.tradingview.com/moderators/"
        }]
    }, {
        title: "ideas",
        links: [{
            name: "trading",
            url: "https://www.tradingview.com/ideas/"
        }, {
            name: "education",
            url: "https://www.tradingview.com/ideas/?type=education"
        }, {
            name: "editorsPicks",
            url: "https://www.tradingview.com/ideas/editors-picks/"
        }]
    }, {
        title: "pineScript",
        links: [{
            name: "indicatorsStrategies",
            url: "https://www.tradingview.com/scripts/"
        }, {
            name: "wizards",
            url: "https://www.tradingview.com/pine-wizards/"
        }, {
            name: "freelancers",
            url: "https://www.tradingview.com/pine-script-freelancers/"
        }]
    }],
    column4: [{
        title: "businessSolutions",
        links: [{
            name: "widgets",
            url: "https://www.tradingview.com/widget/"
        }, {
            name: "chartingLibraries",
            url: "https://www.tradingview.com/free-charting-libraries/"
        }, {
            name: "lightweightCharts",
            url: "https://www.tradingview.com/lightweight-charts/"
        }, {
            name: "advancedCharts",
            url: "https://www.tradingview.com/advanced-charts/"
        }, {
            name: "tradingPlatform",
            url: "https://www.tradingview.com/trading-platform/"
        }]
    }, {
        title: "growthOpportunities",
        links: [{
            name: "advertising",
            url: "https://www.tradingview.com/advertising-info/"
        }, {
            name: "brokerageIntegration",
            url: "https://www.tradingview.com/brokerage-integration/"
        }, {
            name: "partnerProgram",
            url: "https://www.tradingview.com/partner-program/"
        }, {
            name: "educationProgram",
            url: "https://www.tradingview.com/students/"
        }]
    }]
}
  , zf = i => {
    const e = {
        en: {
            lookFirstThenLeap: "Look first / Then leap.",
            moreThanProduct: "More than a product",
            supercharts: "SuperCharts",
            screeners: "Screeners",
            stocks: "Stocks",
            etfs: "ETFs",
            bonds: "Bonds",
            cryptoCoins: "Crypto coins",
            cexPairs: "CEX pairs",
            dexPairs: "DEX pairs",
            pine: "Pine",
            heatmaps: "Heatmaps",
            crypto: "Crypto",
            calendars: "Calendars",
            economic: "Economic",
            earnings: "Earnings",
            dividends: "Dividends",
            moreProducts: "More products",
            yieldCurves: "Yield curves",
            options: "Options",
            newsFlow: "News Flow",
            pineScript: "Pine Script®",
            apps: "Apps",
            mobile: "Mobile",
            desktop: "Desktop",
            toolsSubscriptions: "Tools & subscriptions",
            features: "Features",
            pricing: "Pricing",
            marketData: "Market data",
            trading: "Trading",
            overview: "Overview",
            brokers: "Brokers",
            specialOffers: "Special offers",
            cmeGroupFutures: "CME Group futures",
            eurexFutures: "Eurex futures",
            usStocksBundle: "US stocks bundle",
            aboutCompany: "About company",
            whoWeAre: "Who we are",
            manifesto: "Manifesto",
            athletes: "Athletes",
            blog: "Blog",
            careers: "Careers",
            mediaKit: "Media kit",
            merch: "Merch",
            tradingViewStore: "TradingView store",
            tarotCards: "Tarot cards for traders",
            tradeTime: "The C63 TradeTime",
            policiesSecurity: "Policies & security",
            termsOfUse: "Terms of Use",
            disclaimer: "Disclaimer",
            privacyPolicy: "Privacy Policy",
            cookiesPolicy: "Cookies Policy",
            accessibilityStatement: "Accessibility Statement",
            securityVulnerability: "Security vulnerability",
            statusPage: "Status page",
            community: "Community",
            socialNetwork: "Social network",
            wallOfLove: "Wall of Love",
            referFriend: "Refer a friend",
            houseRules: "House Rules",
            moderators: "Moderators",
            ideas: "Ideas",
            education: "Education",
            editorsPicks: "Editors' picks",
            indicatorsStrategies: "Indicators & strategies",
            wizards: "Wizards",
            freelancers: "Freelancers",
            businessSolutions: "Business solutions",
            widgets: "Widgets",
            chartingLibraries: "Charting libraries",
            lightweightCharts: "Lightweight Charts™",
            advancedCharts: "Advanced Charts",
            tradingPlatform: "Trading Platform",
            growthOpportunities: "Growth opportunities",
            advertising: "Advertising",
            brokerageIntegration: "Brokerage integration",
            partnerProgram: "Partner program",
            educationProgram: "Education program",
            selectMarketData: "Select market data provided by",
            iceDataServices: "ICE Data services.",
            selectReferenceData: "Select reference data provided by FactSet. Copyright © 2025 FactSet Research Systems Inc.",
            copyright: "© 2025 TradingView, Inc."
        },
        pt: {
            lookFirstThenLeap: "Olhe primeiro / Depois salte.",
            moreThanProduct: "Mais do que um produto",
            supercharts: "SuperCharts",
            screeners: "Rastreadores",
            stocks: "Ações",
            etfs: "ETFs",
            bonds: "Títulos",
            cryptoCoins: "Moedas cripto",
            cexPairs: "Pares CEX",
            dexPairs: "Pares DEX",
            pine: "Pine",
            heatmaps: "Mapas de calor",
            crypto: "Cripto",
            calendars: "Calendários",
            economic: "Econômico",
            earnings: "Ganhos",
            dividends: "Dividendos",
            moreProducts: "Mais produtos",
            yieldCurves: "Curvas de rendimento",
            options: "Opções",
            newsFlow: "Fluxo de notícias",
            pineScript: "Pine Script®",
            apps: "Aplicativos",
            mobile: "Móvel",
            desktop: "Desktop",
            toolsSubscriptions: "Ferramentas e assinaturas",
            features: "Recursos",
            pricing: "Preços",
            marketData: "Dados de mercado",
            trading: "Negociação",
            overview: "Visão geral",
            brokers: "Corretoras",
            specialOffers: "Ofertas especiais",
            cmeGroupFutures: "Futuros do CME Group",
            eurexFutures: "Futuros da Eurex",
            usStocksBundle: "Pacote de ações dos EUA",
            aboutCompany: "Sobre a empresa",
            whoWeAre: "Quem somos",
            manifesto: "Manifesto",
            athletes: "Atletas",
            blog: "Blog",
            careers: "Carreiras",
            mediaKit: "Kit de mídia",
            merch: "Mercadorias",
            tradingViewStore: "Loja TradingView",
            tarotCards: "Cartas de tarô para traders",
            tradeTime: "O TradeTime C63",
            policiesSecurity: "Políticas e segurança",
            termsOfUse: "Termos de uso",
            disclaimer: "Isenção de responsabilidade",
            privacyPolicy: "Política de privacidade",
            cookiesPolicy: "Política de cookies",
            accessibilityStatement: "Declaração de acessibilidade",
            securityVulnerability: "Vulnerabilidade de segurança",
            statusPage: "Página de status",
            community: "Comunidade",
            socialNetwork: "Rede social",
            wallOfLove: "Muro do Amor",
            referFriend: "Indique um amigo",
            houseRules: "Regras da casa",
            moderators: "Moderadores",
            ideas: "Ideias",
            education: "Educação",
            editorsPicks: "Escolhas dos editores",
            indicatorsStrategies: "Indicadores e estratégias",
            wizards: "Magos",
            freelancers: "Freelancers",
            businessSolutions: "Soluções de negócios",
            widgets: "Widgets",
            chartingLibraries: "Bibliotecas de gráficos",
            lightweightCharts: "Gráficos Leves™",
            advancedCharts: "Gráficos avançados",
            tradingPlatform: "Plataforma de negociação",
            growthOpportunities: "Oportunidades de crescimento",
            advertising: "Publicidade",
            brokerageIntegration: "Integração de corretora",
            partnerProgram: "Programa de parceiros",
            educationProgram: "Programa educacional",
            selectMarketData: "Selecione dados de mercado fornecidos por",
            iceDataServices: "Serviços de dados ICE.",
            selectReferenceData: "Selecione dados de referência fornecidos por FactSet. Copyright © 2025 FactSet Research Systems Inc.",
            copyright: "© 2025 TradingView, Inc."
        },
        ru: {
            lookFirstThenLeap: "Сначала посмотри, потом прыгай.",
            moreThanProduct: "Больше, чем продукт",
            supercharts: "СуперГрафики",
            screeners: "Скринеры",
            stocks: "Акции",
            etfs: "ETF",
            bonds: "Облигации",
            cryptoCoins: "Криптовалюты",
            cexPairs: "Пары CEX",
            dexPairs: "Пары DEX",
            pine: "Pine",
            heatmaps: "Тепловые карты",
            crypto: "Крипто",
            calendars: "Календари",
            economic: "Экономический",
            earnings: "Доходы",
            dividends: "Дивиденды",
            moreProducts: "Другие продукты",
            yieldCurves: "Кривые доходности",
            options: "Опционы",
            newsFlow: "Поток новостей",
            pineScript: "Pine Script®",
            apps: "Приложения",
            mobile: "Мобильное приложение",
            desktop: "Настольное приложение",
            toolsSubscriptions: "Инструменты и подписки",
            features: "Функции",
            pricing: "Цены",
            marketData: "Рыночные данные",
            trading: "Торговля",
            overview: "Обзор",
            brokers: "Брокеры",
            specialOffers: "Специальные предложения",
            cmeGroupFutures: "Фьючерсы CME Group",
            eurexFutures: "Фьючерсы Eurex",
            usStocksBundle: "Пакет акций США",
            aboutCompany: "О компании",
            whoWeAre: "Кто мы",
            manifesto: "Манифест",
            athletes: "Атлеты",
            blog: "Блог",
            careers: "Карьера",
            mediaKit: "Медиа-кит",
            merch: "Мерч",
            tradingViewStore: "Магазин TradingView",
            tarotCards: "Карты Таро для трейдеров",
            tradeTime: "C63 TradeTime",
            policiesSecurity: "Политики и безопасность",
            termsOfUse: "Условия использования",
            disclaimer: "Отказ от ответственности",
            privacyPolicy: "Политика конфиденциальности",
            cookiesPolicy: "Политика использования cookies",
            accessibilityStatement: "Заявление о доступности",
            securityVulnerability: "Уязвимость безопасности",
            statusPage: "Страница статуса",
            community: "Сообщество",
            socialNetwork: "Социальная сеть",
            wallOfLove: "Стена любви",
            referFriend: "Пригласи друга",
            houseRules: "Правила дома",
            moderators: "Модераторы",
            ideas: "Идеи",
            education: "Обучение",
            editorsPicks: "Выбор редакции",
            indicatorsStrategies: "Индикаторы и стратегии",
            wizards: "Мастера",
            freelancers: "Фрилансеры",
            businessSolutions: "Бизнес-решения",
            widgets: "Виджеты",
            chartingLibraries: "Библиотеки графиков",
            lightweightCharts: "Lightweight Charts™",
            advancedCharts: "Продвинутые графики",
            tradingPlatform: "Торговая платформа",
            growthOpportunities: "Возможности роста",
            advertising: "Реклама",
            brokerageIntegration: "Интеграция с брокерами",
            partnerProgram: "Партнерская программа",
            educationProgram: "Образовательная программа",
            selectMarketData: "Выберите рыночные данные, предоставленные",
            iceDataServices: "ICE Data Services.",
            selectReferenceData: "Выберите справочные данные, предоставленные FactSet. Copyright © 2025 FactSet Research Systems Inc.",
            copyright: "© 2025 TradingView, Inc."
        },
        es: {
            lookFirstThenLeap: "Mira primero / Luego salta.",
            moreThanProduct: "Más que un producto",
            supercharts: "SuperCharts",
            screeners: "Filtros",
            stocks: "Acciones",
            etfs: "ETFs",
            bonds: "Bonos",
            cryptoCoins: "Criptomonedas",
            cexPairs: "Pares CEX",
            dexPairs: "Pares DEX",
            pine: "Pine",
            heatmaps: "Mapas de calor",
            crypto: "Cripto",
            calendars: "Calendarios",
            economic: "Económico",
            earnings: "Ganancias",
            dividends: "Dividendos",
            moreProducts: "Más productos",
            yieldCurves: "Curvas de rendimiento",
            options: "Opciones",
            newsFlow: "Flujo de noticias",
            pineScript: "Pine Script®",
            apps: "Aplicaciones",
            mobile: "Móvil",
            desktop: "Escritorio",
            toolsSubscriptions: "Herramientas y suscripciones",
            features: "Características",
            pricing: "Precios",
            marketData: "Datos de mercado",
            trading: "Trading",
            overview: "Visión general",
            brokers: "Brokers",
            specialOffers: "Ofertas especiales",
            cmeGroupFutures: "Futuros CME Group",
            eurexFutures: "Futuros Eurex",
            usStocksBundle: "Paquete de acciones de EE. UU.",
            aboutCompany: "Sobre la empresa",
            whoWeAre: "Quiénes somos",
            manifesto: "Manifiesto",
            athletes: "Atletas",
            blog: "Blog",
            careers: "Carreras",
            mediaKit: "Kit de medios",
            merch: "Mercancía",
            tradingViewStore: "Tienda TradingView",
            tarotCards: "Cartas de tarot para traders",
            tradeTime: "El C63 TradeTime",
            policiesSecurity: "Políticas y seguridad",
            termsOfUse: "Términos de uso",
            disclaimer: "Descargo de responsabilidad",
            privacyPolicy: "Política de privacidad",
            cookiesPolicy: "Política de cookies",
            accessibilityStatement: "Declaración de accesibilidad",
            securityVulnerability: "Vulnerabilidad de seguridad",
            statusPage: "Página de estado",
            community: "Comunidad",
            socialNetwork: "Red social",
            wallOfLove: "Muro del amor",
            referFriend: "Recomendar a un amigo",
            houseRules: "Reglas de la casa",
            moderators: "Moderadores",
            ideas: "Ideas",
            education: "Educación",
            editorsPicks: "Selecciones de editores",
            indicatorsStrategies: "Indicadores y estrategias",
            wizards: "Magos",
            freelancers: "Freelancers",
            businessSolutions: "Soluciones empresariales",
            widgets: "Widgets",
            chartingLibraries: "Bibliotecas de gráficos",
            lightweightCharts: "Gráficos ligeros™",
            advancedCharts: "Gráficos avanzados",
            tradingPlatform: "Plataforma de trading",
            growthOpportunities: "Oportunidades de crecimiento",
            advertising: "Publicidad",
            brokerageIntegration: "Integración de corredores",
            partnerProgram: "Programa de socios",
            educationProgram: "Programa de educación",
            selectMarketData: "Datos de mercado seleccionados proporcionados por",
            iceDataServices: "Servicios de datos ICE.",
            selectReferenceData: "Datos de referencia seleccionados proporcionados por FactSet. Copyright © 2025 FactSet Research Systems Inc.",
            copyright: "© 2025 TradingView, Inc."
        },
        vi: {
            lookFirstThenLeap: "Nhìn trước / Rồi nhảy.",
            moreThanProduct: "Hơn một sản phẩm",
            supercharts: "SuperCharts",
            screeners: "Bộ lọc",
            stocks: "Cổ phiếu",
            etfs: "ETFs",
            bonds: "Trái phiếu",
            cryptoCoins: "Tiền điện tử",
            cexPairs: "Cặp CEX",
            dexPairs: "Cặp DEX",
            pine: "Pine",
            heatmaps: "Bản đồ nhiệt",
            crypto: "Tiền điện tử",
            calendars: "Lịch",
            economic: "Kinh tế",
            earnings: "Thu nhập",
            dividends: "Cổ tức",
            moreProducts: "Thêm sản phẩm",
            yieldCurves: "Đường cong lợi suất",
            options: "Tùy chọn",
            newsFlow: "Dòng tin tức",
            pineScript: "Pine Script®",
            apps: "Ứng dụng",
            mobile: "Di động",
            desktop: "Máy tính",
            toolsSubscriptions: "Công cụ & đăng ký",
            features: "Tính năng",
            pricing: "Giá cả",
            marketData: "Dữ liệu thị trường",
            trading: "Giao dịch",
            overview: "Tổng quan",
            brokers: "Môi giới",
            specialOffers: "Ưu đãi đặc biệt",
            cmeGroupFutures: "Hợp đồng tương lai CME Group",
            eurexFutures: "Hợp đồng tương lai Eurex",
            usStocksBundle: "Gói cổ phiếu Mỹ",
            aboutCompany: "Về công ty",
            whoWeAre: "Chúng tôi là ai",
            manifesto: "Tuyên ngôn",
            athletes: "Vận động viên",
            blog: "Blog",
            careers: "Sự nghiệp",
            mediaKit: "Bộ công cụ truyền thông",
            merch: "Hàng hóa",
            tradingViewStore: "Cửa hàng TradingView",
            tarotCards: "Lá bài tarot cho trader",
            tradeTime: "Thời gian giao dịch C63",
            policiesSecurity: "Chính sách & bảo mật",
            termsOfUse: "Điều khoản sử dụng",
            disclaimer: "Tuyên bố từ chối",
            privacyPolicy: "Chính sách bảo mật",
            cookiesPolicy: "Chính sách cookie",
            accessibilityStatement: "Tuyên bố về khả năng tiếp cận",
            securityVulnerability: "Lỗ hổng bảo mật",
            statusPage: "Trang trạng thái",
            community: "Cộng đồng",
            socialNetwork: "Mạng xã hội",
            wallOfLove: "Bức tường tình yêu",
            referFriend: "Giới thiệu bạn bè",
            houseRules: "Quy tắc của nhà",
            moderators: "Điều phối viên",
            ideas: "Ý tưởng",
            education: "Giáo dục",
            editorsPicks: "Lựa chọn của biên tập viên",
            indicatorsStrategies: "Chỉ báo & chiến lược",
            wizards: "Phù thủy",
            freelancers: "Freelancer",
            businessSolutions: "Giải pháp kinh doanh",
            widgets: "Widgets",
            chartingLibraries: "Thư viện biểu đồ",
            lightweightCharts: "Biểu đồ nhẹ™",
            advancedCharts: "Biểu đồ nâng cao",
            tradingPlatform: "Nền tảng giao dịch",
            growthOpportunities: "Cơ hội phát triển",
            advertising: "Quảng cáo",
            brokerageIntegration: "Tích hợp môi giới",
            partnerProgram: "Chương trình đối tác",
            educationProgram: "Chương trình giáo dục",
            selectMarketData: "Dữ liệu thị trường chọn lọc được cung cấp bởi",
            iceDataServices: "Dịch vụ dữ liệu ICE.",
            selectReferenceData: "Dữ liệu tham chiếu chọn lọc được cung cấp bởi FactSet. Bản quyền © 2025 FactSet Research Systems Inc.",
            copyright: "© 2025 TradingView, Inc."
        },
        th: {
            lookFirstThenLeap: "มองก่อน / แล้วกระโดด",
            moreThanProduct: "มากกว่าผลิตภัณฑ์",
            supercharts: "SuperCharts",
            screeners: "ตัวกรอง",
            stocks: "หุ้น",
            etfs: "ETFs",
            bonds: "พันธบัตร",
            cryptoCoins: "คริปโตเคอร์เรนซี",
            cexPairs: "คู่ CEX",
            dexPairs: "คู่ DEX",
            pine: "Pine",
            heatmaps: "แผนที่ความร้อน",
            crypto: "คริปโต",
            calendars: "ปฏิทิน",
            economic: "เศรษฐกิจ",
            earnings: "รายได้",
            dividends: "เงินปันผล",
            moreProducts: "ผลิตภัณฑ์เพิ่มเติม",
            yieldCurves: "เส้นโค้งผลตอบแทน",
            options: "ตัวเลือก",
            newsFlow: "กระแสข่าว",
            pineScript: "Pine Script®",
            apps: "แอป",
            mobile: "มือถือ",
            desktop: "เดสก์ท็อป",
            toolsSubscriptions: "เครื่องมือและการสมัครสมาชิก",
            features: "คุณสมบัติ",
            pricing: "ราคา",
            marketData: "ข้อมูลตลาด",
            trading: "การซื้อขาย",
            overview: "ภาพรวม",
            brokers: "โบรกเกอร์",
            specialOffers: "ข้อเสนอพิเศษ",
            cmeGroupFutures: "ฟิวเจอร์ส CME Group",
            eurexFutures: "ฟิวเจอร์ส Eurex",
            usStocksBundle: "ชุดหุ้นสหรัฐ",
            aboutCompany: "เกี่ยวกับบริษัท",
            whoWeAre: "เราคือใคร",
            manifesto: "แถลงการณ์",
            athletes: "นักกีฬา",
            blog: "บล็อก",
            careers: "อาชีพ",
            mediaKit: "ชุดสื่อ",
            merch: "สินค้า",
            tradingViewStore: "ร้านค้า TradingView",
            tarotCards: "ไพ่ทาโรต์สำหรับเทรดเดอร์",
            tradeTime: "เวลาเทรด C63",
            policiesSecurity: "นโยบายและความปลอดภัย",
            termsOfUse: "ข้อกำหนดการใช้งาน",
            disclaimer: "คำปฏิเสธความรับผิด",
            privacyPolicy: "นโยบายความเป็นส่วนตัว",
            cookiesPolicy: "นโยบายคุกกี้",
            accessibilityStatement: "แถลงการณ์การเข้าถึง",
            securityVulnerability: "ช่องโหว่ความปลอดภัย",
            statusPage: "หน้าสถานะ",
            community: "ชุมชน",
            socialNetwork: "โซเชียลเน็ตเวิร์ก",
            wallOfLove: "กำแพงแห่งความรัก",
            referFriend: "แนะนำเพื่อน",
            houseRules: "กฎของบ้าน",
            moderators: "ผู้ดูแล",
            ideas: "ไอเดีย",
            education: "การศึกษา",
            editorsPicks: "การเลือกของบรรณาธิการ",
            indicatorsStrategies: "ตัวชี้วัดและกลยุทธ์",
            wizards: "พ่อมด",
            freelancers: "ฟรีแลนซ์",
            businessSolutions: "โซลูชันธุรกิจ",
            widgets: "วิดเจ็ต",
            chartingLibraries: "ไลบรารีชาร์ต",
            lightweightCharts: "ชาร์ตน้ำหนักเบา™",
            advancedCharts: "ชาร์ตขั้นสูง",
            tradingPlatform: "แพลตฟอร์มการซื้อขาย",
            growthOpportunities: "โอกาสการเติบโต",
            advertising: "การโฆษณา",
            brokerageIntegration: "การผสานรวมโบรกเกอร์",
            partnerProgram: "โปรแกรมพันธมิตร",
            educationProgram: "โปรแกรมการศึกษา",
            selectMarketData: "ข้อมูลตลาดที่เลือกโดย",
            iceDataServices: "บริการข้อมูล ICE.",
            selectReferenceData: "ข้อมูลอ้างอิงที่เลือกโดย FactSet. ลิขสิทธิ์ © 2025 FactSet Research Systems Inc.",
            copyright: "© 2025 TradingView, Inc."
        },
        ja: {
            lookFirstThenLeap: "まず見る / それから跳ぶ。",
            moreThanProduct: "製品以上のもの",
            screeners: "スクリーナー",
            supercharts: "SuperCharts",
            stocks: "株式",
            etfs: "ETF",
            bonds: "債券",
            cryptoCoins: "暗号通貨",
            cexPairs: "CEXペア",
            dexPairs: "DEXペア",
            pine: "Pine",
            heatmaps: "ヒートマップ",
            crypto: "暗号",
            calendars: "カレンダー",
            economic: "経済",
            earnings: "収益",
            dividends: "配当",
            moreProducts: "その他の製品",
            yieldCurves: "利回り曲線",
            options: "オプション",
            newsFlow: "ニュースフロー",
            pineScript: "Pine Script®",
            apps: "アプリ",
            mobile: "モバイル",
            desktop: "デスクトップ",
            toolsSubscriptions: "ツールとサブスクリプション",
            features: "機能",
            pricing: "価格",
            marketData: "市場データ",
            trading: "取引",
            overview: "概要",
            brokers: "ブローカー",
            specialOffers: "特別オファー",
            cmeGroupFutures: "CMEグループ先物",
            eurexFutures: "Eurex先物",
            usStocksBundle: "米国株バンドル",
            aboutCompany: "会社概要",
            whoWeAre: "私たちは誰か",
            manifesto: "マニフェスト",
            athletes: "アスリート",
            blog: "ブログ",
            careers: "キャリア",
            mediaKit: "メディアキット",
            merch: "マーチ",
            tradingViewStore: "TradingViewストア",
            tarotCards: "トレーダー向けタロットカード",
            tradeTime: "C63トレードタイム",
            policiesSecurity: "ポリシーとセキュリティ",
            termsOfUse: "利用規約",
            disclaimer: "免責事項",
            privacyPolicy: "プライバシーポリシー",
            cookiesPolicy: "クッキーポリシー",
            accessibilityStatement: "アクセシビリティ声明",
            securityVulnerability: "セキュリティ脆弱性",
            statusPage: "ステータスページ",
            community: "コミュニティ",
            socialNetwork: "ソーシャルネットワーク",
            wallOfLove: "ラブの壁",
            referFriend: "友達を招待",
            houseRules: "ハウスルール",
            moderators: "モデレーター",
            ideas: "アイデア",
            education: "教育",
            editorsPicks: "編集者の選択",
            indicatorsStrategies: "インジケーターと戦略",
            wizards: "ウィザード",
            freelancers: "フリーランス",
            businessSolutions: "ビジネスソリューション",
            widgets: "ウィジェット",
            chartingLibraries: "チャートライブラリ",
            lightweightCharts: "ライトウェイトチャート™",
            advancedCharts: "高度なチャート",
            tradingPlatform: "取引プラットフォーム",
            growthOpportunities: "成長の機会",
            advertising: "広告",
            brokerageIntegration: "ブローカー統合",
            partnerProgram: "パートナープログラム",
            educationProgram: "教育プログラム",
            selectMarketData: "選択された市場データを提供する",
            iceDataServices: "ICEデータサービス。",
            selectReferenceData: "FactSetが提供する選択された参照データ。© 2025 FactSet Research Systems Inc.著作権。",
            copyright: "© 2025 TradingView, Inc."
        },
        ko: {
            lookFirstThenLeap: "먼저 보기 / 그 다음 뛰기.",
            moreThanProduct: "제품 이상의 가치",
            screeners: "스크리너",
            supercharts: "SuperCharts",
            stocks: "주식",
            etfs: "ETF",
            bonds: "채권",
            cryptoCoins: "암호화폐",
            cexPairs: "CEX 쌍",
            dexPairs: "DEX 쌍",
            pine: "Pine",
            heatmaps: "히트맵",
            crypto: "암호",
            calendars: "달력",
            economic: "경제",
            earnings: "수익",
            dividends: "배당금",
            moreProducts: "추가 제품",
            yieldCurves: "수익률 곡선",
            options: "옵션",
            newsFlow: "뉴스 흐름",
            pineScript: "Pine Script®",
            apps: "앱",
            mobile: "모바일",
            desktop: "데스크톱",
            toolsSubscriptions: "도구 및 구독",
            features: "기능",
            pricing: "가격",
            marketData: "시장 데이터",
            trading: "거래",
            overview: "개요",
            brokers: "브로커",
            specialOffers: "특별 제안",
            cmeGroupFutures: "CME 그룹 선물",
            eurexFutures: "Eurex 선물",
            usStocksBundle: "미국 주식 번들",
            aboutCompany: "회사 소개",
            whoWeAre: "우리는 누구인가",
            manifesto: "선언문",
            athletes: "운동선수",
            blog: "블로그",
            careers: "경력",
            mediaKit: "미디어 키트",
            merch: "상품",
            tradingViewStore: "TradingView 스토어",
            tarotCards: "트레이더용 타로 카드",
            tradeTime: "C63 트레이드 타임",
            policiesSecurity: "정책 및 보안",
            termsOfUse: "이용 약관",
            disclaimer: "면책 조항",
            privacyPolicy: "개인정보 보호정책",
            cookiesPolicy: "쿠키 정책",
            accessibilityStatement: "접근성 선언",
            securityVulnerability: "보안 취약점",
            statusPage: "상태 페이지",
            community: "커뮤니티",
            socialNetwork: "소셜 네트워크",
            wallOfLove: "러브의 벽",
            referFriend: "친구 추천",
            houseRules: "하우스 규칙",
            moderators: "관리자",
            ideas: "아이디어",
            education: "교육",
            editorsPicks: "편집자 추천",
            indicatorsStrategies: "지표 및 전략",
            wizards: "마법사",
            freelancers: "프리랜서",
            businessSolutions: "비즈니스 솔루션",
            widgets: "위젯",
            chartingLibraries: "차트 라이브러리",
            lightweightCharts: "경량 차트™",
            advancedCharts: "고급 차트",
            tradingPlatform: "거래 플랫폼",
            growthOpportunities: "성장 기회",
            advertising: "광고",
            brokerageIntegration: "브로커 통합",
            partnerProgram: "파트너 프로그램",
            educationProgram: "교육 프로그램",
            selectMarketData: "선택된 시장 데이터 제공",
            iceDataServices: "ICE 데이터 서비스.",
            selectReferenceData: "FactSet이 제공하는 선택된 참조 데이터. © 2025 FactSet Research Systems Inc. 저작권.",
            copyright: "© 2025 TradingView, Inc."
        },
        "zh-TW": {
            lookFirstThenLeap: "先看 / 然後跳。",
            moreThanProduct: "不僅是產品",
            screeners: "篩選器",
            supercharts: "SuperCharts",
            stocks: "股票",
            etfs: "ETF",
            bonds: "債券",
            cryptoCoins: "加密貨幣",
            cexPairs: "CEX 對",
            dexPairs: "DEX 對",
            pine: "Pine",
            heatmaps: "熱圖",
            crypto: "加密",
            calendars: "日曆",
            economic: "經濟",
            earnings: "收益",
            dividends: "股息",
            moreProducts: "更多產品",
            yieldCurves: "收益率曲線",
            options: "期權",
            newsFlow: "新聞流",
            pineScript: "Pine Script®",
            apps: "應用",
            mobile: "手機",
            desktop: "桌面",
            toolsSubscriptions: "工具與訂閱",
            features: "功能",
            pricing: "定價",
            marketData: "市場數據",
            trading: "交易",
            overview: "概覽",
            brokers: "經紀",
            specialOffers: "特別優惠",
            cmeGroupFutures: "CME Group 期貨",
            eurexFutures: "Eurex 期貨",
            usStocksBundle: "美國股票套裝",
            aboutCompany: "關於公司",
            whoWeAre: "我們是誰",
            manifesto: "宣言",
            athletes: "運動員",
            blog: "部落格",
            careers: "職涯",
            mediaKit: "媒體套件",
            merch: "商品",
            tradingViewStore: "TradingView 商店",
            tarotCards: "交易者塔羅牌",
            tradeTime: "C63 交易時間",
            policiesSecurity: "政策與安全",
            termsOfUse: "使用條款",
            disclaimer: "免責聲明",
            privacyPolicy: "隱私政策",
            cookiesPolicy: "Cookie 政策",
            accessibilityStatement: "無障礙聲明",
            securityVulnerability: "安全漏洞",
            statusPage: "狀態頁面",
            community: "社群",
            socialNetwork: "社交網絡",
            wallOfLove: "愛之牆",
            referFriend: "推薦朋友",
            houseRules: "房屋規則",
            moderators: "版主",
            ideas: "創意",
            education: "教育",
            editorsPicks: "編輯精選",
            indicatorsStrategies: "指標與策略",
            wizards: "巫師",
            freelancers: "自由工作者",
            businessSolutions: "商業解決方案",
            widgets: "小工具",
            chartingLibraries: "圖表庫",
            lightweightCharts: "輕量圖表™",
            advancedCharts: "高級圖表",
            tradingPlatform: "交易平台",
            growthOpportunities: "成長機會",
            advertising: "廣告",
            brokerageIntegration: "經紀整合",
            partnerProgram: "合作夥伴計劃",
            educationProgram: "教育計劃",
            selectMarketData: "選定市場數據由",
            iceDataServices: "ICE 數據服務提供。",
            selectReferenceData: "選定參考數據由 FactSet 提供。© 2025 FactSet Research Systems Inc. 版權所有。",
            copyright: "© 2025 TradingView, Inc."
        },
        ar: {
            lookFirstThenLeap: "انظر أولاً / ثم اقفز.",
            moreThanProduct: "أكثر من منتج",
            screeners: "المرشحات",
            supercharts: "SuperCharts",
            stocks: "الأسهم",
            etfs: "الصناديق المتداولة",
            bonds: "السندات",
            cryptoCoins: "العملات الرقمية",
            cexPairs: "أزواج CEX",
            dexPairs: "أزواج DEX",
            pine: "Pine",
            heatmaps: "خرائط الحرارة",
            crypto: "الكريبتو",
            calendars: "التقويمات",
            economic: "اقتصادي",
            earnings: "الأرباح",
            dividends: "الأرباح المدفوعة",
            moreProducts: "مزيد من المنتجات",
            yieldCurves: "منحنيات العائد",
            options: "الخيارات",
            newsFlow: "تدفق الأخبار",
            pineScript: "Pine Script®",
            apps: "التطبيقات",
            mobile: "الجوال",
            desktop: "سطح المكتب",
            toolsSubscriptions: "الأدوات والاشتراكات",
            features: "الميزات",
            pricing: "الأسعار",
            marketData: "بيانات السوق",
            trading: "التداول",
            overview: "نظرة عامة",
            brokers: "الوسطاء",
            specialOffers: "عروض خاصة",
            cmeGroupFutures: "عقود CME Group الآجلة",
            eurexFutures: "عقود Eurex الآجلة",
            usStocksBundle: "حزمة أسهم الولايات المتحدة",
            aboutCompany: "حول الشركة",
            whoWeAre: "من نحن",
            manifesto: "بيان",
            athletes: "الرياضيون",
            blog: "المدونة",
            careers: "الوظائف",
            mediaKit: "حزمة الإعلام",
            merch: "البضائع",
            tradingViewStore: "متجر TradingView",
            tarotCards: "بطاقات الطاروت للتجار",
            tradeTime: "وقت التداول C63",
            policiesSecurity: "السياسات والأمان",
            termsOfUse: "شروط الاستخدام",
            disclaimer: "إخلاء مسؤولية",
            privacyPolicy: "سياسة الخصوصية",
            cookiesPolicy: "سياسة الكوكيز",
            accessibilityStatement: "بيان الوصولية",
            securityVulnerability: "الثغرة الأمنية",
            statusPage: "صفحة الحالة",
            community: "المجتمع",
            socialNetwork: "الشبكة الاجتماعية",
            wallOfLove: "جدار الحب",
            referFriend: "إحالة صديق",
            houseRules: "قواعد المنزل",
            moderators: "المشرفون",
            ideas: "أفكار",
            education: "التعليم",
            editorsPicks: "اختيارات المحررين",
            indicatorsStrategies: "المؤشرات والاستراتيجيات",
            wizards: "السحرة",
            freelancers: "العاملون الحرون",
            businessSolutions: "حلول الأعمال",
            widgets: "الودجات",
            chartingLibraries: "مكتبات الرسوم البيانية",
            lightweightCharts: "الرسوم البيانية الخفيفة™",
            advancedCharts: "الرسوم البيانية المتقدمة",
            tradingPlatform: "منصة التداول",
            growthOpportunities: "فرص النمو",
            advertising: "الإعلان",
            brokerageIntegration: "تكامل الوساطة",
            partnerProgram: "برنامج الشركاء",
            educationProgram: "برنامج التعليم",
            selectMarketData: "بيانات السوق المختارة مقدمة من",
            iceDataServices: "خدمات بيانات ICE.",
            selectReferenceData: "بيانات المرجعية المختارة مقدمة من FactSet. © 2025 FactSet Research Systems Inc. حقوق الطبع والنشر.",
            copyright: "© 2025 TradingView, Inc."
        },
        bn: {
            lookFirstThenLeap: "প্রথমে দেখুন / তারপর লাফান।",
            moreThanProduct: "একটি পণ্যের চেয়ে বেশি",
            screeners: "স্ক্রিনার",
            supercharts: "SuperCharts",
            stocks: "শেয়ার",
            etfs: "ETFs",
            bonds: "বন্ড",
            cryptoCoins: "ক্রিপ্টোকারেন্সি",
            cexPairs: "CEX জোড়া",
            dexPairs: "DEX জোড়া",
            pine: "Pine",
            heatmaps: "হিটম্যাপ",
            crypto: "ক্রিপ্টো",
            calendars: "ক্যালেন্ডার",
            economic: "অর্থনৈতিক",
            earnings: "আয়",
            dividends: "লাভঞ্জন",
            moreProducts: "আরও পণ্য",
            yieldCurves: "যিল্ড কার্ভ",
            options: "অপশন",
            newsFlow: "নিউজ ফ্লো",
            pineScript: "Pine Script®",
            apps: "অ্যাপস",
            mobile: "মোবাইল",
            desktop: "ডেস্কটপ",
            toolsSubscriptions: "টুলস এবং সাবস্ক্রিপশন",
            features: "বৈশিষ্ট্য",
            pricing: "মূল্য",
            marketData: "বাজার ডেটা",
            trading: "ট্রেডিং",
            overview: "ওভারভিউ",
            brokers: "ব্রোকার",
            specialOffers: "বিশেষ অফার",
            cmeGroupFutures: "CME গ্রুপ ফিউচার",
            eurexFutures: "Eurex ফিউচার",
            usStocksBundle: "মার্কিন শেয়ার বান্ডিল",
            aboutCompany: "কোম্পানি সম্পর্কে",
            whoWeAre: "আমরা কে",
            manifesto: "ম্যানিফেস্টো",
            athletes: "এথলিট",
            blog: "ব্লগ",
            careers: "ক্যারিয়ার",
            mediaKit: "মিডিয়া কিট",
            merch: "মার্চ",
            tradingViewStore: "ট্রেডিংভিউ স্টোর",
            tarotCards: "ট্রেডারদের জন্য ট্যারট কার্ড",
            tradeTime: "C63 ট্রেড টাইম",
            policiesSecurity: "নীতি এবং নিরাপত্তা",
            termsOfUse: "ব্যবহারের শর্তাবলী",
            disclaimer: "দায়িত্ব নিরসন",
            privacyPolicy: "গোপনীয়তা নীতি",
            cookiesPolicy: "কুকিজ নীতি",
            accessibilityStatement: "প্রবেশযোগ্যতা বিবৃতি",
            securityVulnerability: "নিরাপত্তা দুর্বলতা",
            statusPage: "স্ট্যাটাস পেজ",
            community: "সম্প্রদায়",
            socialNetwork: "সোশ্যাল নেটওয়ার্ক",
            wallOfLove: "লাভের দেওয়াল",
            referFriend: "বন্ধু রেফার করুন",
            houseRules: "হাউস রুলস",
            moderators: "মডারেটর",
            ideas: "ধারণা",
            education: "শিক্ষা",
            editorsPicks: "সম্পাদকের পছন্দ",
            indicatorsStrategies: "সূচক ও কৌশল",
            wizards: "জাদুকর",
            freelancers: "ফ্রিল্যান্সার",
            businessSolutions: "ব্যবসা সমাধান",
            widgets: "উইজেট",
            chartingLibraries: "চার্টিং লাইব্রেরি",
            lightweightCharts: "হালকা চার্ট™",
            advancedCharts: "উন্নত চার্ট",
            tradingPlatform: "ট্রেডিং প্ল্যাটফর্ম",
            growthOpportunities: "বৃদ্ধির সুযোগ",
            advertising: "বিজ্ঞাপন",
            brokerageIntegration: "ব্রোকারেজ ইন্টিগ্রেশন",
            partnerProgram: "পার্টনার প্রোগ্রাম",
            educationProgram: "শিক্ষা প্রোগ্রাম",
            selectMarketData: "নির্বাচিত বাজার ডেটা সরবরাহ করে",
            iceDataServices: "ICE ডেটা সার্ভিসেস.",
            selectReferenceData: "নির্বাচিত রেফারেন্স ডেটা সরবরাহ করে FactSet. কপিরাইট © 2025 FactSet Research Systems Inc.",
            copyright: "© 2025 TradingView, Inc."
        },
        id: {
            lookFirstThenLeap: "Lihat dulu / Kemudian loncat.",
            moreThanProduct: "Lebih dari sebuah produk",
            screeners: "Penyaring",
            supercharts: "SuperCharts",
            stocks: "Saham",
            etfs: "ETF",
            bonds: "Obligasi",
            cryptoCoins: "Kripto",
            cexPairs: "Pasangan CEX",
            dexPairs: "Pasangan DEX",
            pine: "Pine",
            heatmaps: "Peta Panas",
            crypto: "Kripto",
            calendars: "Kalender",
            economic: "Ekonomi",
            earnings: "Pendapatan",
            dividends: "Dividen",
            moreProducts: "Produk lainnya",
            yieldCurves: "Kurva Hasil",
            options: "Opsi",
            newsFlow: "Aliran Berita",
            pineScript: "Pine Script®",
            apps: "Aplikasi",
            mobile: "Ponsel",
            desktop: "Desktop",
            toolsSubscriptions: "Alat & Langganan",
            features: "Fitur",
            pricing: "Harga",
            marketData: "Data Pasar",
            trading: "Perdagangan",
            overview: "Gambaran Umum",
            brokers: "Broker",
            specialOffers: "Penawaran Khusus",
            cmeGroupFutures: "Futures CME Group",
            eurexFutures: "Futures Eurex",
            usStocksBundle: "Bundel Saham AS",
            aboutCompany: "Tentang Perusahaan",
            whoWeAre: "Kami Siapa",
            manifesto: "Manifesto",
            athletes: "Atlet",
            blog: "Blog",
            careers: "Karir",
            mediaKit: "Kit Media",
            merch: "Merchandise",
            tradingViewStore: "Toko TradingView",
            tarotCards: "Kartu Tarot untuk Trader",
            tradeTime: "Waktu Perdagangan C63",
            policiesSecurity: "Kebijakan & Keamanan",
            termsOfUse: "Syarat Penggunaan",
            disclaimer: "Penyangkalan",
            privacyPolicy: "Kebijakan Privasi",
            cookiesPolicy: "Kebijakan Kuki",
            accessibilityStatement: "Pernyataan Aksesibilitas",
            securityVulnerability: "Kerentanan Keamanan",
            statusPage: "Halaman Status",
            community: "Komunitas",
            socialNetwork: "Jaringan Sosial",
            wallOfLove: "Dinding Cinta",
            referFriend: "Ajukan Teman",
            houseRules: "Aturan Rumah",
            moderators: "Moderator",
            ideas: "Ide",
            education: "Pendidikan",
            editorsPicks: "Pilihan Editor",
            indicatorsStrategies: "Indikator & Strategi",
            wizards: "Penyihir",
            freelancers: "Pekerja Lepas",
            businessSolutions: "Solusi Bisnis",
            widgets: "Widget",
            chartingLibraries: "Pustaka Grafik",
            lightweightCharts: "Grafik Ringan™",
            advancedCharts: "Grafik Lanjutan",
            tradingPlatform: "Platform Perdagangan",
            growthOpportunities: "Peluang Pertumbuhan",
            advertising: "Iklan",
            brokerageIntegration: "Integrasi Broker",
            partnerProgram: "Program Mitra",
            educationProgram: "Program Pendidikan",
            selectMarketData: "Data pasar yang dipilih disediakan oleh",
            iceDataServices: "Layanan Data ICE.",
            selectReferenceData: "Data referensi yang dipilih disediakan oleh FactSet. Hak Cipta © 2025 FactSet Research Systems Inc.",
            copyright: "© 2025 TradingView, Inc."
        },
        ka: {
            lookFirstThenLeap: "ჯერ ნახე / შემდეგ გადაიხედე.",
            moreThanProduct: "მეტია, ვიდრე პროდუქტი",
            screeners: "ფილტრები",
            supercharts: "SuperCharts",
            stocks: "აქციები",
            etfs: "ETF-ები",
            bonds: " облиგაციები",
            cryptoCoins: "კრიპტოვალუტები",
            cexPairs: "CEX წყვილები",
            dexPairs: "DEX წყვილები",
            pine: "Pine",
            heatmaps: "ჰიტმაპები",
            crypto: "კრიპტო",
            calendars: "კალენდრები",
            economic: "ეკონომიკური",
            earnings: "შემოსავალი",
            dividends: "დივიდენდები",
            moreProducts: "დამატებითი პროდუქტები",
            yieldCurves: "მოგების კურვები",
            options: "ოპციები",
            newsFlow: "სიახლეების ნაკადი",
            pineScript: "Pine Script®",
            apps: "აპები",
            mobile: "მობილური",
            desktop: "დესკტოპი",
            toolsSubscriptions: "ხელსაწყოები და გამოწერები",
            features: "ფუნქციები",
            pricing: "ფასები",
            marketData: "ბაზრის მონაცემები",
            trading: "ვაჭრობა",
            overview: "მიმოხილვა",
            brokers: "ბროკერები",
            specialOffers: "სპეციალური შეთავაზებები",
            cmeGroupFutures: "CME ჯგუფის ფიუჩერსები",
            eurexFutures: "Eurex ფიუჩერსები",
            usStocksBundle: "აშშ-ის აქციების პაკეტი",
            aboutCompany: "კომპანიის შესახებ",
            whoWeAre: "ვინ ვართ ჩვენ",
            manifesto: "მანიფესტო",
            athletes: "სპორტსმენები",
            blog: "ბლოგი",
            careers: "კარიერა",
            mediaKit: "მედია კომპლექტი",
            merch: "მერჩი",
            tradingViewStore: "TradingView მაღაზია",
            tarotCards: "ტრეიდერებისთვის ტარო კარტები",
            tradeTime: "C63 ვაჭრობის დრო",
            policiesSecurity: "პოლიტიკა და უსაფრთხოება",
            termsOfUse: "გამოყენების პირობები",
            disclaimer: "განაცხადის უარყოფა",
            privacyPolicy: "კონფიდენციალურობის პოლიტიკა",
            cookiesPolicy: "ქუქიზის პოლიტიკა",
            accessibilityStatement: "ხელმისაწვდომობის განცხადება",
            securityVulnerability: "უსაფრთხოების მ vulnerability",
            statusPage: "სტატუსის გვერდი",
            community: "საზოგადოება",
            socialNetwork: "სოციალური ქსელი",
            wallOfLove: "სიყვარულის კედელი",
            referFriend: "მეგობრის რეკომენდაცია",
            houseRules: "სახლის წესები",
            moderators: "მოდერატორები",
            ideas: "იდეები",
            education: "განათლება",
            editorsPicks: "რედაქტორის არჩევანი",
            indicatorsStrategies: "ინდიკატორები და სტრატეგიები",
            wizards: "მაგები",
            freelancers: "ფრილანსერები",
            businessSolutions: "ბიზნეს გადაწყვეტილებები",
            widgets: "ვიჯეტები",
            chartingLibraries: "ჩარტინგ ბიბლიოთეკები",
            lightweightCharts: "მსუბუქი ჩარტები™",
            advancedCharts: "დაწინაურებული ჩარტები",
            tradingPlatform: "ვაჭრობის პლატფორმა",
            growthOpportunities: "ზრდის შესაძლებლობები",
            advertising: "რეკლამა",
            brokerageIntegration: "ბროკერაჟის ინტეგრაცია",
            partnerProgram: "პარტნიორის პროგრამა",
            educationProgram: "განათლების პროგრამა",
            selectMarketData: "არჩეული ბაზრის მონაცემები მიეწოდება",
            iceDataServices: "ICE მონაცემების მომსახურება.",
            selectReferenceData: "არჩეული რეფერენსის მონაცემები მიეწოდება FactSet-ის მიერ. © 2025 FactSet Research Systems Inc. კოპირაითი.",
            copyright: "© 2025 TradingView, Inc."
        },
        mn: {
            lookFirstThenLeap: "Эхлээд харах / Дараа нь гишгэх.",
            moreThanProduct: "Бүтээгдэхүүнээс илүү",
            screeners: "Шүүлтүүр",
            supercharts: "SuperCharts",
            stocks: "Хувьцаа",
            etfs: "ETF",
            bonds: "Бонд",
            cryptoCoins: "Крипто валют",
            cexPairs: "CEX хослол",
            dexPairs: "DEX хослол",
            pine: "Pine",
            heatmaps: "Халуун газрын зураг",
            crypto: "Крипто",
            calendars: "Календарь",
            economic: "Эдийн засаг",
            earnings: "Орлого",
            dividends: "Дивиденд",
            moreProducts: "Бусад бүтээгдэхүүн",
            yieldCurves: "Өгөөжийн муруй",
            options: "Сонголт",
            newsFlow: "Мэдээний урсгал",
            pineScript: "Pine Script®",
            apps: "Апп",
            mobile: "Мобайл",
            desktop: "Дэсктоп",
            toolsSubscriptions: "Тоног төхөөрөмж ба захиалга",
            features: "Онцлог",
            pricing: "Үнэ",
            marketData: " зах зээлийн мэдээлэл",
            trading: "Арилжаа",
            overview: "Ерөнхий тойм",
            brokers: "Брокер",
            specialOffers: "Тусгай санал",
            cmeGroupFutures: "CME Группийн ирээдүйн гэрээ",
            eurexFutures: "Eurex ирээдүйн гэрээ",
            usStocksBundle: "АНУ-ын хувьцааны багц",
            aboutCompany: "Компанийн тухай",
            whoWeAre: "Бид хэн бэ",
            manifesto: "Манифест",
            athletes: "Атлет",
            blog: "Блог",
            careers: "Карьер",
            mediaKit: "Медиа кит",
            merch: "Мерч",
            tradingViewStore: "TradingView дэлгүүр",
            tarotCards: "Трейдерүүдийн таарот карт",
            tradeTime: "C63 арилжааны цаг",
            policiesSecurity: "Бодлого ба аюулгүй байдал",
            termsOfUse: "Хэрэглээний нөхцөл",
            disclaimer: "Татгалзах",
            privacyPolicy: "Нууцлалын бодлого",
            cookiesPolicy: "Күүкийн бодлого",
            accessibilityStatement: "Хүртээмжтэй байдлын мэдэгдэл",
            securityVulnerability: "Аюулгүй байдлын эмзэг байдал",
            statusPage: "Төлөв байдлын хуудас",
            community: "Олон нийт",
            socialNetwork: "Социал сүлжээ",
            wallOfLove: "Хайрын хан",
            referFriend: "Найздаа зөвлөх",
            houseRules: "Гэрийн дүрэм",
            moderators: "Модератор",
            ideas: "Санаа",
            education: "Боловсрол",
            editorsPicks: "Засварлагчийн сонголт",
            indicatorsStrategies: "Үзүүлэлт ба стратеги",
            wizards: "Галын эзэн",
            freelancers: "Фрилансер",
            businessSolutions: "Бизнесийн шийдэл",
            widgets: "Вигет",
            chartingLibraries: "График номын сан",
            lightweightCharts: "Хөнгөн график™",
            advancedCharts: "Дэвшилтэт график",
            tradingPlatform: "Арилжааны платформ",
            growthOpportunities: "Өсөлтийн боломж",
            advertising: "Сурталчилгаа",
            brokerageIntegration: "Брокерийн интеграци",
            partnerProgram: "Партнерын хөтөлбөр",
            educationProgram: "Боловсролын хөтөлбөр",
            selectMarketData: "Сонгосон зах зээлийн мэдээлэлд",
            iceDataServices: "ICE Дата Сервис.",
            selectReferenceData: "Сонгосон түүхэн мэдээлэл FactSet-аас. © 2025 FactSet Research Systems Inc. Зохиогчийн эрх.",
            copyright: "© 2025 TradingView, Inc."
        },
        tr: {
            lookFirstThenLeap: "Önce bak / Sonra atla.",
            moreThanProduct: "Sadece bir ürün değil",
            screeners: "Filtreler",
            supercharts: "SuperCharts",
            stocks: "Hisse senetleri",
            etfs: "ETF'ler",
            bonds: "Tahviller",
            cryptoCoins: "Kripto paralar",
            cexPairs: "CEX çiftleri",
            dexPairs: "DEX çiftleri",
            pine: "Pine",
            heatmaps: "Isı haritaları",
            crypto: "Kripto",
            calendars: "Takvimler",
            economic: "Ekonomik",
            earnings: "Kazançlar",
            dividends: "Temettüler",
            moreProducts: "Diğer ürünler",
            yieldCurves: "Getiri eğrileri",
            options: "Seçenekler",
            newsFlow: "Haber akışı",
            pineScript: "Pine Script®",
            apps: "Uygulamalar",
            mobile: "Mobil",
            desktop: "Masaüstü",
            toolsSubscriptions: "Araçlar ve abonelikler",
            features: "Özellikler",
            pricing: "Fiyatlandırma",
            marketData: "Pazar verileri",
            trading: "Ticaret",
            overview: "Genel bakış",
            brokers: "Aracılar",
            specialOffers: "Özel teklifler",
            cmeGroupFutures: "CME Group vadeli işlemleri",
            eurexFutures: "Eurex vadeli işlemleri",
            usStocksBundle: "ABD hisse senedi paketi",
            aboutCompany: "Şirket hakkında",
            whoWeAre: "Biz kimiz",
            manifesto: "Manifesto",
            athletes: "Atletler",
            blog: "Blog",
            careers: "Kariyer",
            mediaKit: "Medya kiti",
            merch: "Merch",
            tradingViewStore: "TradingView mağazası",
            tarotCards: "Traderlar için tarot kartları",
            tradeTime: "C63 TradeTime",
            policiesSecurity: "Politikalar ve güvenlik",
            termsOfUse: "Kullanım şartları",
            disclaimer: "Feragatname",
            privacyPolicy: "Gizlilik politikası",
            cookiesPolicy: "Çerez politikası",
            accessibilityStatement: "Erişilebilirlik beyanı",
            securityVulnerability: "Güvenlik açığı",
            statusPage: "Durum sayfası",
            community: "Topluluk",
            socialNetwork: "Sosyal ağ",
            wallOfLove: "Aşk duvarı",
            referFriend: "Arkadaşını davet et",
            houseRules: "Ev kuralları",
            moderators: "Moderatörler",
            ideas: "Fikirler",
            education: "Eğitim",
            editorsPicks: "Editörün seçimleri",
            indicatorsStrategies: "Göstergeler ve stratejiler",
            wizards: "Büyücüler",
            freelancers: "Serbest çalışanlar",
            businessSolutions: "İş çözümleri",
            widgets: "Widget'lar",
            chartingLibraries: "Grafik kütüphaneleri",
            lightweightCharts: "Hafif grafikler™",
            advancedCharts: "Gelişmiş grafikler",
            tradingPlatform: "Ticaret platformu",
            growthOpportunities: "Büyüme fırsatları",
            advertising: "Reklam",
            brokerageIntegration: "Aracı entegrasyonu",
            partnerProgram: "Ortaklık programı",
            educationProgram: "Eğitim programı",
            selectMarketData: "Seçili piyasa verileri",
            iceDataServices: "ICE Veri Hizmetleri tarafından sağlanır.",
            selectReferenceData: "Seçili referans veriler FactSet tarafından sağlanır. © 2025 FactSet Research Systems Inc. Telif hakkı.",
            copyright: "© 2025 TradingView, Inc."
        },
        fr: {
            lookFirstThenLeap: "Regarde d'abord / Puis saute.",
            moreThanProduct: "Plus qu'un produit",
            screeners: "Filtres",
            supercharts: "SuperCharts",
            stocks: "Actions",
            etfs: "ETF",
            bonds: "Obligations",
            cryptoCoins: "Cryptomonnaies",
            cexPairs: "Paires CEX",
            dexPairs: "Paires DEX",
            pine: "Pine",
            heatmaps: "Cartes thermiques",
            crypto: "Crypto",
            calendars: "Calendriers",
            economic: "Économique",
            earnings: "Revenus",
            dividends: "Dividendes",
            moreProducts: "Plus de produits",
            yieldCurves: "Courbes de rendement",
            options: "Options",
            newsFlow: "Flux d'actualités",
            pineScript: "Pine Script®",
            apps: "Applications",
            mobile: "Mobile",
            desktop: "Bureau",
            toolsSubscriptions: "Outils et abonnements",
            features: "Fonctionnalités",
            pricing: "Tarification",
            marketData: "Données de marché",
            trading: "Trading",
            overview: "Aperçu",
            brokers: "Courtiers",
            specialOffers: "Offres spéciales",
            cmeGroupFutures: "Futures CME Group",
            eurexFutures: "Futures Eurex",
            usStocksBundle: "Pack d'actions US",
            aboutCompany: "À propos de l'entreprise",
            whoWeAre: "Qui sommes-nous",
            manifesto: "Manifeste",
            athletes: "Athlètes",
            blog: "Blog",
            careers: "Carrières",
            mediaKit: "Kit média",
            merch: "Marchandises",
            tradingViewStore: "Boutique TradingView",
            tarotCards: "Cartes de tarot pour traders",
            tradeTime: "Heure de trading C63",
            policiesSecurity: "Politiques et sécurité",
            termsOfUse: "Conditions d'utilisation",
            disclaimer: "Avertissement",
            privacyPolicy: "Politique de confidentialité",
            cookiesPolicy: "Politique des cookies",
            accessibilityStatement: "Déclaration d'accessibilité",
            securityVulnerability: "Vulnérabilité de sécurité",
            statusPage: "Page de statut",
            community: "Communauté",
            socialNetwork: "Réseau social",
            wallOfLove: "Mur de l'amour",
            referFriend: "Recommander un ami",
            houseRules: "Règles de la maison",
            moderators: "Modérateurs",
            ideas: "Idées",
            education: "Éducation",
            editorsPicks: "Choix des éditeurs",
            indicatorsStrategies: "Indicateurs et stratégies",
            wizards: "Magiciens",
            freelancers: "Indépendants",
            businessSolutions: "Solutions d'entreprise",
            widgets: "Widgets",
            chartingLibraries: "Bibliothèques de graphiques",
            lightweightCharts: "Graphiques légers™",
            advancedCharts: "Graphiques avancés",
            tradingPlatform: "Plateforme de trading",
            growthOpportunities: "Opportunités de croissance",
            advertising: "Publicité",
            brokerageIntegration: "Intégration de courtage",
            partnerProgram: "Programme de partenariat",
            educationProgram: "Programme d'éducation",
            selectMarketData: "Données de marché sélectionnées fournies par",
            iceDataServices: "Services de données ICE.",
            selectReferenceData: "Données de référence sélectionnées fournies par FactSet. Copyright © 2025 FactSet Research Systems Inc.",
            copyright: "© 2025 TradingView, Inc."
        },
        de: {
            lookFirstThenLeap: "Zuerst schauen / Dann springen.",
            moreThanProduct: "Mehr als ein Produkt",
            screeners: "Filter",
            supercharts: "SuperCharts",
            stocks: "Aktien",
            etfs: "ETFs",
            bonds: "Anleihen",
            cryptoCoins: "Kryptowährungen",
            cexPairs: "CEX-Paare",
            dexPairs: "DEX-Paare",
            pine: "Pine",
            heatmaps: "Heatmaps",
            crypto: "Krypto",
            calendars: "Kalender",
            economic: "Wirtschaftlich",
            earnings: "Erträge",
            dividends: "Dividenden",
            moreProducts: "Weitere Produkte",
            yieldCurves: "Renditekurven",
            options: "Optionen",
            newsFlow: "Nachrichtenfluss",
            pineScript: "Pine Script®",
            apps: "Apps",
            mobile: "Mobil",
            desktop: "Desktop",
            toolsSubscriptions: "Werkzeuge & Abonnements",
            features: "Funktionen",
            pricing: "Preise",
            marketData: "Marktdaten",
            trading: "Handel",
            overview: "Übersicht",
            brokers: "Broker",
            specialOffers: "Spezialangebote",
            cmeGroupFutures: "CME Group Futures",
            eurexFutures: "Eurex Futures",
            usStocksBundle: "US-Aktienpaket",
            aboutCompany: "Über das Unternehmen",
            whoWeAre: "Wer wir sind",
            manifesto: "Manifest",
            athletes: "Athleten",
            blog: "Blog",
            careers: "Karrieren",
            mediaKit: "Medienkit",
            merch: "Merch",
            tradingViewStore: "TradingView Store",
            tarotCards: "Tarotkarten für Trader",
            tradeTime: "C63 Handelszeit",
            policiesSecurity: "Richtlinien & Sicherheit",
            termsOfUse: "Nutzungsbedingungen",
            disclaimer: "Haftungsausschluss",
            privacyPolicy: "Datenschutzrichtlinie",
            cookiesPolicy: "Cookie-Richtlinie",
            accessibilityStatement: "Barrierefreiheitserklärung",
            securityVulnerability: "Sicherheitslücke",
            statusPage: "Statusseite",
            community: "Community",
            socialNetwork: "Soziales Netzwerk",
            wallOfLove: "Wand der Liebe",
            referFriend: "Einen Freund empfehlen",
            houseRules: "Hausregeln",
            moderators: "Moderatoren",
            ideas: "Ideen",
            education: "Bildung",
            editorsPicks: "Editor-Auswahl",
            indicatorsStrategies: "Indikatoren & Strategien",
            wizards: "Zauberer",
            freelancers: "Freiberufler",
            businessSolutions: "Geschäftslösungen",
            widgets: "Widgets",
            chartingLibraries: "Charting-Bibliotheken",
            lightweightCharts: "Leichte Charts™",
            advancedCharts: "Erweiterte Charts",
            tradingPlatform: "Platforma de tranzacționare",
            growthOpportunities: "Oportunități de creștere",
            advertising: "Publicitate",
            brokerageIntegration: "Integrarea brokerului",
            partnerProgram: "Program de parteneriat",
            educationProgram: "Program educațional",
            selectMarketData: "Datele de piață selectate furnizate de",
            iceDataServices: "ICE Data Services.",
            selectReferenceData: "Datele de referință selectate furnizate de FactSet. © 2025 FactSet Research Systems Inc. Drepturi de autor.",
            copyright: "© 2025 TradingView, Inc."
        },
        sq: {
            lookFirstThenLeap: "Shiko së pari / Pastaj hidhu.",
            moreThanProduct: "Më shumë se një produkt",
            screeners: "Filtrues",
            supercharts: "SuperCharts",
            stocks: "Aksione",
            etfs: "ETF-të",
            bonds: "Obligacione",
            cryptoCoins: "Kriptovaluta",
            cexPairs: "Çifte CEX",
            dexPairs: "Çifte DEX",
            pine: "Pine",
            heatmaps: "Harta termike",
            crypto: "Kripto",
            calendars: "Kalendare",
            economic: "Ekonomik",
            earnings: "Të ardhura",
            dividends: "Dividendë",
            moreProducts: "Më shumë produkte",
            yieldCurves: "Kurbat e rendimentit",
            options: "Opsione",
            newsFlow: "Rrjedha e lajmeve",
            pineScript: "Pine Script®",
            apps: "Aplikacione",
            mobile: "Celular",
            desktop: "Desktop",
            toolsSubscriptions: "Mjete & abomente",
            features: "Karakteristika",
            pricing: "Çmime",
            marketData: "Të dhënat e tregut",
            trading: "Tregtim",
            overview: "Përmbledhje",
            brokers: "Ndërmjetës",
            specialOffers: "Oferta speciale",
            cmeGroupFutures: "Kontratat e ardhshme CME Group",
            eurexFutures: "Kontratat e ardhshme Eurex",
            usStocksBundle: "Paketa e aksioneve amerikane",
            aboutCompany: "Rreth kompanisë",
            whoWeAre: "Kush jemi ne",
            manifesto: "Manifesti",
            athletes: "Atletë",
            blog: "Blog",
            careers: "Karriera",
            mediaKit: "Kit media",
            merch: "Mallra",
            tradingViewStore: "Dyqan TradingView",
            tarotCards: "Karta taroti për tregtarë",
            tradeTime: "Koha e tregtimit C63",
            policiesSecurity: "Politika & siguria",
            termsOfUse: "Kushtet e përdorimit",
            disclaimer: "Mohim përgjegjësie",
            privacyPolicy: "Politika e privatësisë",
            cookiesPolicy: "Politika e cookies",
            accessibilityStatement: "Deklarata e aksesueshmërisë",
            securityVulnerability: "Dobësia e sigurisë",
            statusPage: "Faqe statusi",
            community: "Komunitet",
            socialNetwork: "Rrjet social",
            wallOfLove: "Muri i dashurisë",
            referFriend: "Refero një mik",
            houseRules: "Rregullat e shtëpisë",
            moderators: "Moderatorë",
            ideas: "Ide",
            education: "Arsim",
            editorsPicks: "Zgjedhjet e redaktorëve",
            indicatorsStrategies: "Tregues & strategji",
            wizards: "Magjistarë",
            freelancers: "Freelancerë",
            businessSolutions: "Zgjidhje biznesi",
            widgets: "Widget",
            chartingLibraries: "Biblioteka grafikësh",
            lightweightCharts: "Grafiqe të lehta™",
            advancedCharts: "Grafiqe të avancuara",
            tradingPlatform: "Platforma e tregtimit",
            growthOpportunities: "Mundësi rritjeje",
            advertising: "Reklamim",
            brokerageIntegration: "Integrimi i ndërmjetësit",
            partnerProgram: "Program partnerësh",
            educationProgram: "Program arsimi",
            selectMarketData: "Të dhënat e përzgjedhura të tregut ofrohen nga",
            iceDataServices: "Shërbimet e të dhënave ICE.",
            selectReferenceData: "Të dhënat e referencës së përzgjedhur ofrohen nga FactSet. © 2025 FactSet Research Systems Inc. E drejta e autorit.",
            copyright: "© 2025 TradingView, Inc."
        },
        bs: {
            lookFirstThenLeap: "Prvo pogledaj / Onda skoči.",
            moreThanProduct: "Više od proizvoda",
            screeners: "Filteri",
            supercharts: "SuperCharts",
            stocks: "Dionice",
            etfs: "ETF-ovi",
            bonds: "Obveznice",
            cryptoCoins: "Kriptovalute",
            cexPairs: "CEX parovi",
            dexPairs: "DEX parovi",
            pine: "Pine",
            heatmaps: "Toplinske mape",
            crypto: "Kripto",
            calendars: "Kalendari",
            economic: "Ekonomski",
            earnings: "Prihodi",
            dividends: "Dividende",
            moreProducts: "Više proizvoda",
            yieldCurves: "Krivulje prinosa",
            options: "Opcije",
            newsFlow: "Tok vijesti",
            pineScript: "Pine Script®",
            apps: "Aplikacije",
            mobile: "Mobilni",
            desktop: "Desktop",
            toolsSubscriptions: "Alati i pretplate",
            features: "Funkcije",
            pricing: "Cijene",
            marketData: "Tržišni podaci",
            trading: "Trgovanje",
            overview: "Pregled",
            brokers: "Brokeri",
            specialOffers: "Specijalne ponude",
            cmeGroupFutures: "CME Group futures",
            eurexFutures: "Eurex futures",
            usStocksBundle: "Paket US dionica",
            aboutCompany: "O kompaniji",
            whoWeAre: "Ko smo mi",
            manifesto: "Manifesto",
            athletes: "Sportaši",
            blog: "Blog",
            careers: "Karijere",
            mediaKit: "Media kit",
            merch: "Roba",
            tradingViewStore: "TradingView trgovina",
            tarotCards: "Tarot karte za tradere",
            tradeTime: "C63 vrijeme trgovanja",
            policiesSecurity: "Politike i sigurnost",
            termsOfUse: "Uslovi korištenja",
            disclaimer: "Odricanje odgovornosti",
            privacyPolicy: "Politika privatnosti",
            cookiesPolicy: "Politika kolačića",
            accessibilityStatement: "Izjava o pristupačnosti",
            securityVulnerability: "Sigurnosna ranjivost",
            statusPage: "Status stranica",
            community: "Zajednica",
            socialNetwork: "Društvena mreža",
            wallOfLove: "Zid ljubavi",
            referFriend: "Preporuči prijatelja",
            houseRules: "Kućna pravila",
            moderators: "Moderatori",
            ideas: "Ideje",
            education: "Obrazovanje",
            editorsPicks: "Izbor urednika",
            indicatorsStrategies: "Indikatori i strategije",
            wizards: "Čarobnjaci",
            freelancers: "Freelanceri",
            businessSolutions: "Poslovna rješenja",
            widgets: "Widgeti",
            chartingLibraries: "Grafičke biblioteke",
            lightweightCharts: "Lagani grafici™",
            advancedCharts: "Napredni grafici",
            tradingPlatform: "Platforma za trgovanje",
            growthOpportunities: "Mogućnosti rasta",
            advertising: "Oglašavanje",
            brokerageIntegration: "Broker integracija",
            partnerProgram: "Partner program",
            educationProgram: "Obrazovni program",
            selectMarketData: "Odabrani tržišni podaci osigurani od",
            iceDataServices: "ICE Data Services.",
            selectReferenceData: "Odabrani referentni podaci osigurani od FactSet-a. © 2025 FactSet Research Systems Inc. Autorska prava.",
            copyright: "© 2025 TradingView, Inc."
        },
        bg: {
            lookFirstThenLeap: "Първо погледни / След това скочи.",
            moreThanProduct: "Повече от продукт",
            screeners: "Филтри",
            supercharts: "SuperCharts",
            stocks: "Акции",
            etfs: "ETF-та",
            bonds: "Облигации",
            cryptoCoins: "Криптовалути",
            cexPairs: "CEX двойки",
            dexPairs: "DEX двойки",
            pine: "Pine",
            heatmaps: "Топлинни карти",
            crypto: "Крипто",
            calendars: "Календари",
            economic: "Икономически",
            earnings: "Печалби",
            dividends: "Дивиденти",
            moreProducts: "Още продукти",
            yieldCurves: "Криви на доходността",
            options: "Опции",
            newsFlow: "Поток от новини",
            pineScript: "Pine Script®",
            apps: "Приложения",
            mobile: "Мобилен",
            desktop: "Десктоп",
            toolsSubscriptions: "Инструменти и абонаменти",
            features: "Функции",
            pricing: "Цени",
            marketData: "Пазарни данни",
            trading: "Търговия",
            overview: "Преглед",
            brokers: "Брокери",
            specialOffers: "Специални оферти",
            cmeGroupFutures: "CME Group фючърси",
            eurexFutures: "Eurex фючърси",
            usStocksBundle: "Пакет американски акции",
            aboutCompany: "За компанията",
            whoWeAre: "Кои сме ние",
            manifesto: "Манифест",
            athletes: "Спортисти",
            blog: "Блог",
            careers: "Кариери",
            mediaKit: "Медиен комплект",
            merch: "Стоки",
            tradingViewStore: "TradingView магазин",
            tarotCards: "Таро карти за търговци",
            tradeTime: "C63 време за търговия",
            policiesSecurity: "Политики и сигурност",
            termsOfUse: "Условия за използване",
            disclaimer: "Отказ от отговорност",
            privacyPolicy: "Политика за поверителност",
            cookiesPolicy: "Политика за бисквитки",
            accessibilityStatement: "Декларация за достъпност",
            securityVulnerability: "Уязвимост в сигурността",
            statusPage: "Страница със статус",
            community: "Общност",
            socialNetwork: "Социална мрежа",
            wallOfLove: "Стена на любовта",
            referFriend: "Препоръчай приятел",
            houseRules: "Правила на къщата",
            moderators: "Модератори",
            ideas: "Идеи",
            education: "Образование",
            editorsPicks: "Избор на редакторите",
            indicatorsStrategies: "Индикатори и стратегии",
            wizards: "Магьосници",
            freelancers: "Фрилансъри",
            businessSolutions: "Бизнес решения",
            widgets: "Уиджети",
            chartingLibraries: "Библиотеки за графики",
            lightweightCharts: "Леки графики™",
            advancedCharts: "Разширени графики",
            tradingPlatform: "Търговска платформа",
            growthOpportunities: "Възможности за растеж",
            advertising: "Реклама",
            brokerageIntegration: "Интеграция с брокери",
            partnerProgram: "Партньорска програма",
            educationProgram: "Образователна програма",
            selectMarketData: "Избраните пазарни данни се предоставят от",
            iceDataServices: "ICE Data Services.",
            selectReferenceData: "Избраните референтни данни се предоставят от FactSet. © 2025 FactSet Research Systems Inc. Авторски права.",
            copyright: "© 2025 TradingView, Inc."
        },
        hr: {
            lookFirstThenLeap: "Prvo pogledaj / Zatim skoči.",
            moreThanProduct: "Više od proizvoda",
            screeners: "Filteri",
            supercharts: "SuperCharts",
            stocks: "Dionice",
            etfs: "ETF-ovi",
            bonds: "Obveznice",
            cryptoCoins: "Kriptovalute",
            cexPairs: "CEX parovi",
            dexPairs: "DEX parovi",
            pine: "Pine",
            heatmaps: "Toplinske karte",
            crypto: "Kripto",
            calendars: "Kalendari",
            economic: "Ekonomski",
            earnings: "Prihodi",
            dividends: "Dividende",
            moreProducts: "Više proizvoda",
            yieldCurves: "Krivulje prinosa",
            options: "Opcije",
            newsFlow: "Tok vijesti",
            pineScript: "Pine Script®",
            apps: "Aplikacije",
            mobile: "Mobilni",
            desktop: "Desktop",
            toolsSubscriptions: "Alati i pretplate",
            features: "Značajke",
            pricing: "Cijene",
            marketData: "Tržišni podaci",
            trading: "Trgovanje",
            overview: "Pregled",
            brokers: "Brokeri",
            specialOffers: "Posebne ponude",
            cmeGroupFutures: "CME Group terminsko trgovanje",
            eurexFutures: "Eurex terminsko trgovanje",
            usStocksBundle: "Paket američkih dionica",
            aboutCompany: "O tvrtki",
            whoWeAre: "Tko smo mi",
            manifesto: "Manifest",
            athletes: "Sportaši",
            blog: "Blog",
            careers: "Karijere",
            mediaKit: "Medijski komplet",
            merch: "Roba",
            tradingViewStore: "TradingView trgovina",
            tarotCards: "Tarot karte za trgovce",
            tradeTime: "C63 vrijeme trgovanja",
            policiesSecurity: "Pravila i sigurnost",
            termsOfUse: "Uvjeti korištenja",
            disclaimer: "Odricanje odgovornosti",
            privacyPolicy: "Pravila privatnosti",
            cookiesPolicy: "Pravila o kolačićima",
            accessibilityStatement: "Izjava o dostupnosti",
            securityVulnerability: "Sigurnosna ranjivost",
            statusPage: "Stranica statusa",
            community: "Zajednica",
            socialNetwork: "Društvena mreža",
            wallOfLove: "Zid ljubavi",
            referFriend: "Preporuči prijatelja",
            houseRules: "Kućna pravila",
            moderators: "Moderatori",
            ideas: "Ideje",
            education: "Obrazovanje",
            editorsPicks: "Odabir urednika",
            indicatorsStrategies: "Pokazatelji i strategije",
            wizards: "Čarobnjaci",
            freelancers: "Freelanceri",
            businessSolutions: "Poslovna rješenja",
            widgets: "Widgeti",
            chartingLibraries: "Biblioteke grafikona",
            lightweightCharts: "Lagani grafikoni™",
            advancedCharts: "Napredni grafikoni",
            tradingPlatform: "Platforma za trgovanje",
            growthOpportunities: "Prilike za rast",
            advertising: "Oglašavanje",
            brokerageIntegration: "Integracija s brokerima",
            partnerProgram: "Partnerski program",
            educationProgram: "Obrazovni program",
            selectMarketData: "Odabrani tržišni podaci pruženi od",
            iceDataServices: "ICE Data Services.",
            selectReferenceData: "Odabrani referentni podaci pruženi od FactSet-a. © 2025 FactSet Research Systems Inc. Autorska prava.",
            copyright: "© 2025 TradingView, Inc."
        },
        xk: {
            lookFirstThenLeap: "Shiko së pari / Pastaj hidhu. | Prvo pogledaj / Zatim skoči.",
            moreThanProduct: "Më shumë se një produkt | Više od proizvoda",
            screeners: "Filtrues | Filteri",
            supercharts: "SuperCharts",
            stocks: "Aksione | Dionice",
            etfs: "ETF-të | ETF-ovi",
            bonds: "Obligacione | Obveznice",
            cryptoCoins: "Kriptovaluta | Kriptovalute",
            cexPairs: "Çifte CEX | CEX parovi",
            dexPairs: "Çifte DEX | DEX parovi",
            pine: "Pine",
            heatmaps: "Harta termike | Toplinske karte",
            crypto: "Kripto",
            calendars: "Kalendare | Kalendari",
            economic: "Ekonomik | Ekonomski",
            earnings: "Të ardhura | Prihodi",
            dividends: "Dividendë | Dividende",
            moreProducts: "Më shumë produkte | Više proizvoda",
            yieldCurves: "Kurbat e rendimentit | Krivulje prinosa",
            options: "Opsione | Opcije",
            newsFlow: "Rrjedha e lajmeve | Tok vijesti",
            pineScript: "Pine Script®",
            apps: "Aplikacione | Aplikacije",
            mobile: "Celular | Mobilni",
            desktop: "Desktop",
            toolsSubscriptions: "Mjete & abomente | Alati i pretplate",
            features: "Karakteristika | Značajke",
            pricing: "Çmime | Cijene",
            marketData: "Të dhënat e tregut | Tržišni podaci",
            trading: "Tregtim | Trgovanje",
            overview: "Përmbledhje | Pregled",
            brokers: "Ndërmjetës | Brokeri",
            specialOffers: "Oferta speciale | Posebne ponude",
            cmeGroupFutures: "Kontratat e ardhshme CME Group | CME Group terminsko trgovanje",
            eurexFutures: "Kontratat e ardhshme Eurex | Eurex terminsko trgovanje",
            usStocksBundle: "Paketa e aksioneve amerikane | Paket američkih dionica",
            aboutCompany: "Rreth kompanisë | O tvrtki",
            whoWeAre: "Kush jemi ne | Tko smo mi",
            manifesto: "Manifesti | Manifest",
            athletes: "Atletë | Sportaši",
            blog: "Blog",
            careers: "Karriera | Karijere",
            mediaKit: "Kit media | Medijski komplet",
            merch: "Mallra | Roba",
            tradingViewStore: "Dyqan TradingView | TradingView trgovina",
            tarotCards: "Karta taroti për tregtarë | Tarot karte za trgovce",
            tradeTime: "Koha e tregtimit C63 | C63 vrijeme trgovanja",
            policiesSecurity: "Politika & siguria | Pravila i sigurnost",
            termsOfUse: "Kushtet e përdorimit | Uvjeti korištenja",
            disclaimer: "Mohim përgjegjësie | Odricanje odgovornosti",
            privacyPolicy: "Politika e privatësisë | Pravila privatnosti",
            cookiesPolicy: "Politika e cookies | Pravila o kolačićima",
            accessibilityStatement: "Deklarata e aksesueshmërisë | Izjava o dostupnosti",
            securityVulnerability: "Dobësia e sigurisë | Sigurnosna ranjivost",
            statusPage: "Faqe statusi | Stranica statusa",
            community: "Komunitet | Zajednica",
            socialNetwork: "Rrjet social | Društvena mreža",
            wallOfLove: "Muri i dashurisë | Zid ljubavi",
            referFriend: "Refero një mik | Preporuči prijatelja",
            houseRules: "Rregullat e shtëpisë | Kućna pravila",
            moderators: "Moderatorë | Moderatori",
            ideas: "Ide | Ideje",
            education: "Arsim | Obrazovanje",
            editorsPicks: "Zgjedhjet e redaktorëve | Odabir urednika",
            indicatorsStrategies: "Tregues & strategji | Pokazatelji i strategije",
            wizards: "Magjistarë | Čarobnjaci",
            freelancers: "Freelancerë | Freelanceri",
            businessSolutions: "Zgjidhje biznesi | Poslovna rješenja",
            widgets: "Widget | Widgeti",
            chartingLibraries: "Biblioteka grafikësh | Biblioteke grafikona",
            lightweightCharts: "Grafiqe të lehta™ | Lagani grafikoni™",
            advancedCharts: "Grafiqe të avancuara | Napredni grafikoni",
            tradingPlatform: "Platforma e tregtimit | Platforma za trgovanje",
            growthOpportunities: "Mundësi rritjeje | Prilike za rast",
            advertising: "Reklamim | Oglašavanje",
            brokerageIntegration: "Integrimi i ndërmjetësit | Integracija s brokerima",
            partnerProgram: "Program partnerësh | Partnerski program",
            educationProgram: "Program arsimi | Obrazovni program",
            selectMarketData: "Të dhënat e përzgjedhura të tregut ofrohen nga | Odabrani tržišni podaci pruženi od",
            iceDataServices: "ICE Data Services.",
            selectReferenceData: "Të dhënat e referencës së përzgjedhur ofrohen nga FactSet | Odabrani referentni podaci pruženi od FactSet-a. © 2025 FactSet Research Systems Inc.",
            copyright: "© 2025 TradingView, Inc."
        },
        me: {
            lookFirstThenLeap: "Прво погледај / Затим скочи.",
            moreThanProduct: "Више од производа",
            screeners: "Филтери",
            supercharts: "SuperCharts",
            stocks: "Дионице",
            etfs: "ETF-ови",
            bonds: "Обвезнице",
            cryptoCoins: "Криптовалуте",
            cexPairs: "CEX парови",
            dexPairs: "DEX парови",
            pine: "Pine",
            heatmaps: "Топлинске мапе",
            crypto: "Крипто",
            calendars: "Календари",
            economic: "Економски",
            earnings: "Приходи",
            dividends: "Дивиденде",
            moreProducts: "Више производа",
            yieldCurves: "Кривуље приноса",
            options: "Опције",
            newsFlow: "Ток вијести",
            pineScript: "Pine Script®",
            apps: "Апликације",
            mobile: "Мобилни",
            desktop: "Desktop",
            toolsSubscriptions: "Алати и претплате",
            features: "Функције",
            pricing: "Цијене",
            marketData: "Тржишни подаци",
            trading: "Трговање",
            overview: "Преглед",
            brokers: "Брокери",
            specialOffers: "Специјалне понуде",
            cmeGroupFutures: "CME Group futures",
            eurexFutures: "Eurex futures",
            usStocksBundle: "Пакет US дионица",
            aboutCompany: "О компанији",
            whoWeAre: "Ко смо ми",
            manifesto: "Манифесто",
            athletes: "Спорташи",
            blog: "Блог",
            careers: "Каријере",
            mediaKit: "Медиа кит",
            merch: "Роба",
            tradingViewStore: "TradingView трговина",
            tarotCards: "Таро карте за трејдере",
            tradeTime: "C63 вријеме трговања",
            policiesSecurity: "Политике и сигурност",
            termsOfUse: "Услови коришћења",
            disclaimer: "Одрицање одговорности",
            privacyPolicy: "Политика приватности",
            cookiesPolicy: "Политика колачића",
            accessibilityStatement: "Изјава о приступачности",
            securityVulnerability: "Сигурносна рањивост",
            statusPage: "Статус страница",
            community: "Заједница",
            socialNetwork: "Друштвена мрежа",
            wallOfLove: "Зид љубави",
            referFriend: "Препоруци пријатеља",
            houseRules: "Кућна правила",
            moderators: "Модератори",
            ideas: "Идеје",
            education: "Образовање",
            editorsPicks: "Избор уредника",
            indicatorsStrategies: "Индикатори и стратегије",
            wizards: "Чаробњаци",
            freelancers: "Фрилансери",
            businessSolutions: "Пословна рјешења",
            widgets: "Виџети",
            chartingLibraries: "Графичке библиотеке",
            lightweightCharts: "Лагани графици™",
            advancedCharts: "Напредни графици",
            tradingPlatform: "Платформа за трговање",
            growthOpportunities: "Могућности раста",
            advertising: "Оглашавање",
            brokerageIntegration: "Брокер интеграција",
            partnerProgram: "Партнер програм",
            educationProgram: "Образовни програм",
            selectMarketData: "Одабрани тржишни подаци обезбијеђени од",
            iceDataServices: "ICE Data Services.",
            selectReferenceData: "Одабрани референтни подаци обезбијеђени од FactSet-а. © 2025 FactSet Research Systems Inc. Ауторска права.",
            copyright: "© 2025 TradingView, Inc."
        },
        mk: {
            lookFirstThenLeap: "Прво погледај / Потоа скокни.",
            moreThanProduct: "Повеќе од производ",
            screeners: "Филтри",
            supercharts: "SuperCharts",
            stocks: "Акции",
            etfs: "ETF-иња",
            bonds: "Обврзници",
            cryptoCoins: "Криптовалути",
            cexPairs: "CEX парови",
            dexPairs: "DEX парови",
            pine: "Pine",
            heatmaps: "Топлински карти",
            crypto: "Крипто",
            calendars: "Календари",
            economic: "Економски",
            earnings: "Приходи",
            dividends: "Дивиденди",
            moreProducts: "Повеќе производи",
            yieldCurves: "Криви на приносот",
            options: "Опции",
            newsFlow: "Тек на вести",
            pineScript: "Pine Script®",
            apps: "Апликации",
            mobile: "Мобилен",
            desktop: "Десктоп",
            toolsSubscriptions: "Алатки и претплати",
            features: "Функции",
            pricing: "Цени",
            marketData: "Пазарни податоци",
            trading: "Тргување",
            overview: "Преглед",
            brokers: "Брокери",
            specialOffers: "Специјални понуди",
            cmeGroupFutures: "CME Group фјучерси",
            eurexFutures: "Eurex фјучерси",
            usStocksBundle: "Пакет американски акции",
            aboutCompany: "За компанијата",
            whoWeAre: "Кои сме ние",
            manifesto: "Манифест",
            athletes: "Спортисти",
            blog: "Блог",
            careers: "Кариери",
            mediaKit: "Медиумски комплет",
            merch: "Стока",
            tradingViewStore: "TradingView продавница",
            tarotCards: "Таро карти за трговци",
            tradeTime: "C63 време за тргување",
            policiesSecurity: "Политики и безбедност",
            termsOfUse: "Услови за користење",
            disclaimer: "Одрекување одговорност",
            privacyPolicy: "Политика за приватност",
            cookiesPolicy: "Политика за колачиња",
            accessibilityStatement: "Изјава за пристапност",
            securityVulnerability: "Безбедносна ранливост",
            statusPage: "Страница за статус",
            community: "Заедница",
            socialNetwork: "Социјална мрежа",
            wallOfLove: "Ѕид на љубовта",
            referFriend: "Препорачај пријател",
            houseRules: "Правила на куќата",
            moderators: "Модератори",
            ideas: "Идеи",
            education: "Образование",
            editorsPicks: "Избор на уредниците",
            indicatorsStrategies: "Индикатори и стратегии",
            wizards: "Волшебници",
            freelancers: "Фрилансери",
            businessSolutions: "Бизнис решенија",
            widgets: "Виџети",
            chartingLibraries: "Библиотеки за графикони",
            lightweightCharts: "Лесни графикони™",
            advancedCharts: "Напредни графикони",
            tradingPlatform: "Платформа за тргување",
            growthOpportunities: "Можности за раст",
            advertising: "Реклами",
            brokerageIntegration: "Интеграција на брокер",
            partnerProgram: "Партнерска програма",
            educationProgram: "Образовна програма",
            selectMarketData: "Одбраните пазарни податоци се обезбедени од",
            iceDataServices: "ICE Data Services.",
            selectReferenceData: "Одбраните референтни податоци се обезбедени од FactSet. © 2025 FactSet Research Systems Inc. Авторски права.",
            copyright: "© 2025 TradingView, Inc."
        },
        ro: {
            lookFirstThenLeap: "Privește mai întâi / Apoi sari.",
            moreThanProduct: "Mai mult decât un produs",
            screeners: "Filtre",
            supercharts: "SuperCharts",
            stocks: "Acțiuni",
            etfs: "ETF-uri",
            bonds: "Obligațiuni",
            cryptoCoins: "Criptomonede",
            cexPairs: "Perechi CEX",
            dexPairs: "Perechi DEX",
            pine: "Pine",
            heatmaps: "Hărți termice",
            crypto: "Cripto",
            calendars: "Calendare",
            economic: "Economic",
            earnings: "Venituri",
            dividends: "Dividende",
            moreProducts: "Mai multe produse",
            yieldCurves: "Curbe de randament",
            options: "Opțiuni",
            newsFlow: "Flux de știri",
            pineScript: "Pine Script®",
            apps: "Aplicații",
            mobile: "Mobil",
            desktop: "Desktop",
            toolsSubscriptions: "Instrumente și abonamente",
            features: "Caracteristici",
            pricing: "Prețuri",
            marketData: "Date de piață",
            trading: "Tranzacționare",
            overview: "Prezentare generală",
            brokers: "Brokeri",
            specialOffers: "Oferte speciale",
            cmeGroupFutures: "Futures CME Group",
            eurexFutures: "Futures Eurex",
            usStocksBundle: "Pachet acțiuni SUA",
            aboutCompany: "Despre companie",
            whoWeAre: "Cine suntem",
            manifesto: "Manifest",
            athletes: "Atleți",
            blog: "Blog",
            careers: "Cariere",
            mediaKit: "Kit media",
            merch: "Marfă",
            tradingViewStore: "Magazin TradingView",
            tarotCards: "Cărți tarot pentru traderi",
            tradeTime: "Timpul de tranzacționare C63",
            policiesSecurity: "Politici și securitate",
            termsOfUse: "Termeni de utilizare",
            disclaimer: "Descărcare de responsabilitate",
            privacyPolicy: "Politica de confidențialitate",
            cookiesPolicy: "Politica de cookie-uri",
            accessibilityStatement: "Declarația de accesibilitate",
            securityVulnerability: "Vulnerabilitate de securitate",
            statusPage: "Pagina de stare",
            community: "Comunitate",
            socialNetwork: "Rețea socială",
            wallOfLove: "Zidul dragostei",
            referFriend: "Recomandă un prieten",
            houseRules: "Regulile casei",
            moderators: "Moderatori",
            ideas: "Idei",
            education: "Educație",
            editorsPicks: "Selecțiile editorilor",
            indicatorsStrategies: "Indicatori și strategii",
            wizards: "Vrăjitori",
            freelancers: "Freelanceri",
            businessSolutions: "Soluții de afaceri",
            widgets: "Widget-uri",
            chartingLibraries: "Biblioteci de grafice",
            lightweightCharts: "Grafice ușoare™",
            advancedCharts: "Grafice avansate",
            tradingPlatform: "Handelsplattform",
            growthOpportunities: "Wachstumschancen",
            advertising: "Werbung",
            brokerageIntegration: "Broker-Integration",
            partnerProgram: "Partnerprogramm",
            educationProgram: "Bildungsprogramm",
            selectMarketData: "Ausgewählte Marktdaten bereitgestellt von",
            iceDataServices: "ICE-Datendienste.",
            selectReferenceData: "Ausgewählte Referenzdaten bereitgestellt von FactSet. Copyright © 2025 FactSet Research Systems Inc.",
            copyright: "© 2025 TradingView, Inc."
        },
        sr: {
            lookFirstThenLeap: "Прво погледај / Затим скочи.",
            moreThanProduct: "Више од производа",
            screeners: "Филтери",
            supercharts: "SuperCharts",
            stocks: "Акције",
            etfs: "ETF-ови",
            bonds: "Обвезнице",
            cryptoCoins: "Криптовалуте",
            cexPairs: "CEX парови",
            dexPairs: "DEX парови",
            pine: "Pine",
            heatmaps: "Топлотне мапе",
            crypto: "Крипто",
            calendars: "Календари",
            economic: "Економски",
            earnings: "Приходи",
            dividends: "Дивиденде",
            moreProducts: "Више производа",
            yieldCurves: "Криве приноса",
            options: "Опције",
            newsFlow: "Ток вести",
            pineScript: "Pine Script®",
            apps: "Апликације",
            mobile: "Мобилни",
            desktop: "Десктоп",
            toolsSubscriptions: "Алати и претплате",
            features: "Функције",
            pricing: "Цене",
            marketData: "Тржишни подаци",
            trading: "Трговање",
            overview: "Преглед",
            brokers: "Брокери",
            specialOffers: "Специјалне понуде",
            cmeGroupFutures: "CME Group фјучерси",
            eurexFutures: "Eurex фјучерси",
            usStocksBundle: "Пакет америчких акција",
            aboutCompany: "О компанији",
            whoWeAre: "Ко смо ми",
            manifesto: "Манифест",
            athletes: "Спортисти",
            blog: "Блог",
            careers: "Каријере",
            mediaKit: "Медија кит",
            merch: "Роба",
            tradingViewStore: "TradingView продавница",
            tarotCards: "Таро карте за трејдере",
            tradeTime: "C63 време трговања",
            policiesSecurity: "Политике и безбедност",
            termsOfUse: "Услови коришћења",
            disclaimer: "Одрицање одговорности",
            privacyPolicy: "Политика приватности",
            cookiesPolicy: "Политика колачића",
            accessibilityStatement: "Изјава о приступачности",
            securityVulnerability: "Безбедносна рањивост",
            statusPage: "Страница статуса",
            community: "Заједница",
            socialNetwork: "Друштвена мрежа",
            wallOfLove: "Зид љубави",
            referFriend: "Препоручи пријатеља",
            houseRules: "Правила куће",
            moderators: "Модератори",
            ideas: "Идеје",
            education: "Образовање",
            editorsPicks: "Избор уредника",
            indicatorsStrategies: "Индикатори и стратегије",
            wizards: "Чаробњаци",
            freelancers: "Фрилансери",
            businessSolutions: "Пословна решења",
            widgets: "Виџети",
            chartingLibraries: "Библиотеке графикона",
            lightweightCharts: "Лагани графици™",
            advancedCharts: "Напредни графици",
            tradingPlatform: "Платформа за трговање",
            growthOpportunities: "Могућности раста",
            advertising: "Оглашавање",
            brokerageIntegration: "Интеграција брокера",
            partnerProgram: "Партнерски програм",
            educationProgram: "Образовни програм",
            selectMarketData: "Одабрани тржишни подаци обезбеђени од",
            iceDataServices: "ICE Data Services.",
            selectReferenceData: "Одабрани референтни подаци обезбеђени од FactSet-а. © 2025 FactSet Research Systems Inc. Ауторска права.",
            copyright: "© 2025 TradingView, Inc."
        },
        sl: {
            lookFirstThenLeap: "Najprej poglej / Potem skoči.",
            moreThanProduct: "Več kot produkt",
            screeners: "Filtri",
            supercharts: "SuperCharts",
            stocks: "Delnice",
            etfs: "ETF-ji",
            bonds: "Obveznice",
            cryptoCoins: "Kriptovalute",
            cexPairs: "CEX pari",
            dexPairs: "DEX pari",
            pine: "Pine",
            heatmaps: "Toplotne karte",
            crypto: "Kripto",
            calendars: "Koledarji",
            economic: "Ekonomski",
            earnings: "Zaslužki",
            dividends: "Dividende",
            moreProducts: "Več izdelkov",
            yieldCurves: "Krivulje donosnosti",
            options: "Opcije",
            newsFlow: "Tok novic",
            pineScript: "Pine Script®",
            apps: "Aplikacije",
            mobile: "Mobilno",
            desktop: "Namizje",
            toolsSubscriptions: "Orodja in naročnine",
            features: "Funkcije",
            pricing: "Cene",
            marketData: "Tržni podatki",
            trading: "Trgovanje",
            overview: "Pregled",
            brokers: "Posredniki",
            specialOffers: "Posebne ponudbe",
            cmeGroupFutures: "CME Group terminski posli",
            eurexFutures: "Eurex terminski posli",
            usStocksBundle: "Paket ameriških delnic",
            aboutCompany: "O podjetju",
            whoWeAre: "Kdo smo",
            manifesto: "Manifest",
            athletes: "Športniki",
            blog: "Blog",
            careers: "Kariere",
            mediaKit: "Medijski komplet",
            merch: "Trgovina",
            tradingViewStore: "TradingView trgovina",
            tarotCards: "Tarot karte za trgovce",
            tradeTime: "C63 čas trgovanja",
            policiesSecurity: "Politike in varnost",
            termsOfUse: "Pogoji uporabe",
            disclaimer: "Zavrnitev odgovornosti",
            privacyPolicy: "Pravilnik o zasebnosti",
            cookiesPolicy: "Pravilnik o piškotkih",
            accessibilityStatement: "Izjava o dostopnosti",
            securityVulnerability: "Varnostna ranljivost",
            statusPage: "Stran stanja",
            community: "Skupnost",
            socialNetwork: "Socialno omrežje",
            wallOfLove: "Stena ljubezni",
            referFriend: "Priporoči prijatelja",
            houseRules: "Hišna pravila",
            moderators: "Moderatorji",
            ideas: "Ideje",
            education: "Izobraževanje",
            editorsPicks: "Izbor urednikov",
            indicatorsStrategies: "Kazalniki in strategije",
            wizards: "Čarovniki",
            freelancers: "Samostojni izvajalci",
            businessSolutions: "Poslovne rešitve",
            widgets: "Pripomočki",
            chartingLibraries: "Knjižnice grafov",
            lightweightCharts: "Lahki grafi™",
            advancedCharts: "Napredni grafi",
            tradingPlatform: "Platforma za trgovanje",
            growthOpportunities: "Priložnosti za rast",
            advertising: "Oglaševanje",
            brokerageIntegration: "Integracija posrednika",
            partnerProgram: "Partnerski program",
            educationProgram: "Izobraževalni program",
            selectMarketData: "Izbrani tržni podatki zagotovljeni s strani",
            iceDataServices: "ICE Data Services.",
            selectReferenceData: "Izbrani referenčni podatki zagotovljeni s strani FactSet. © 2025 FactSet Research Systems Inc. Avtorske pravice.",
            copyright: "© 2025 TradingView, Inc."
        },
        sk: {
            lookFirstThenLeap: "Najprv sa pozri / Potom skoč.",
            moreThanProduct: "Viac ako produkt",
            screeners: "Filtre",
            supercharts: "SuperCharts",
            stocks: "Akcie",
            etfs: "ETF",
            bonds: "Dlhopisy",
            cryptoCoins: "Kryptomeny",
            cexPairs: "CEX páry",
            dexPairs: "DEX páry",
            pine: "Pine",
            heatmaps: "Tepelné mapy",
            crypto: "Krypto",
            calendars: "Kalendáre",
            economic: "Ekonomický",
            earnings: "Výnosy",
            dividends: "Dividendy",
            moreProducts: "Viac produktov",
            yieldCurves: "Krivky výnosov",
            options: "Opcie",
            newsFlow: "Tok správ",
            pineScript: "Pine Script®",
            apps: "Aplikácie",
            mobile: "Mobilný",
            desktop: "Desktop",
            toolsSubscriptions: "Nástroje a predplatné",
            features: "Funkcie",
            pricing: "Ceny",
            marketData: "Trhové údaje",
            trading: "Obchodovanie",
            overview: "Prehľad",
            brokers: "Brokeri",
            specialOffers: "Špeciálne ponuky",
            cmeGroupFutures: "CME Group futures",
            eurexFutures: "Eurex futures",
            usStocksBundle: "Balík amerických akcií",
            aboutCompany: "O spoločnosti",
            whoWeAre: "Kto sme",
            manifesto: "Manifest",
            athletes: "Športovci",
            blog: "Blog",
            careers: "Kariéry",
            mediaKit: "Mediálny balík",
            merch: "Tovar",
            tradingViewStore: "TradingView obchod",
            tarotCards: "Tarotové karty pre obchodníkov",
            tradeTime: "C63 čas obchodovania",
            policiesSecurity: "Politiky a bezpečnosť",
            termsOfUse: "Podmienky používania",
            disclaimer: "Vylúčenie zodpovednosti",
            privacyPolicy: "Zásady ochrany súkromia",
            cookiesPolicy: "Zásady súborov cookie",
            accessibilityStatement: "Vyhlásenie o prístupnosti",
            securityVulnerability: "Bezpečnostná zraniteľnosť",
            statusPage: "Stránka stavu",
            community: "Komunita",
            socialNetwork: "Sociálna sieť",
            wallOfLove: "Stena lásky",
            referFriend: "Odporúčte priateľa",
            houseRules: "Domáce pravidlá",
            moderators: "Moderátori",
            ideas: "Nápady",
            education: "Vzdelávanie",
            editorsPicks: "Výber redaktorov",
            indicatorsStrategies: "Indikátory a stratégie",
            wizards: "Čarodejníci",
            freelancers: "Freelanceri",
            businessSolutions: "Obchodné riešenia",
            widgets: "Widgety",
            chartingLibraries: "Knižnice grafov",
            lightweightCharts: "Ľahké grafy™",
            advancedCharts: "Pokročilé grafy",
            tradingPlatform: "Obchodná platforma",
            growthOpportunities: "Príležitosti rastu",
            advertising: "Reklama",
            brokerageIntegration: "Integrácia makléra",
            partnerProgram: "Partnerský program",
            educationProgram: "Vzdelávací program",
            selectMarketData: "Vybrané trhové údaje poskytované",
            iceDataServices: "ICE Data Services.",
            selectReferenceData: "Vybrané referenčné údaje poskytované FactSet. © 2025 FactSet Research Systems Inc. Autorské práva.",
            copyright: "© 2025 TradingView, Inc."
        },
        md: {
            lookFirstThenLeap: "Privește mai întâi / Apoi sari.",
            moreThanProduct: "Mai mult decât un produs",
            screeners: "Filtre",
            supercharts: "SuperCharts",
            stocks: "Acțiuni",
            etfs: "ETF-uri",
            bonds: "Obligațiuni",
            cryptoCoins: "Criptomonede",
            cexPairs: "Perechi CEX",
            dexPairs: "Perechi DEX",
            pine: "Pine",
            heatmaps: "Hărți termice",
            crypto: "Cripto",
            calendars: "Calendare",
            economic: "Economic",
            earnings: "Venituri",
            dividends: "Dividende",
            moreProducts: "Mai multe produse",
            yieldCurves: "Curbe de randament",
            options: "Opțiuni",
            newsFlow: "Flux de știri",
            pineScript: "Pine Script®",
            apps: "Aplicații",
            mobile: "Mobil",
            desktop: "Desktop",
            toolsSubscriptions: "Instrumente și abonamente",
            features: "Caracteristici",
            pricing: "Prețuri",
            marketData: "Date de piață",
            trading: "Tranzacționare",
            overview: "Prezentare generală",
            brokers: "Brokeri",
            specialOffers: "Oferte speciale",
            cmeGroupFutures: "Futures CME Group",
            eurexFutures: "Futures Eurex",
            usStocksBundle: "Pachet acțiuni SUA",
            aboutCompany: "Despre companie",
            whoWeAre: "Cine suntem",
            manifesto: "Manifest",
            athletes: "Atleți",
            blog: "Blog",
            careers: "Cariere",
            mediaKit: "Kit media",
            merch: "Marfă",
            tradingViewStore: "Magazin TradingView",
            tarotCards: "Cărți tarot pentru traderi",
            tradeTime: "Timpul de tranzacționare C63",
            policiesSecurity: "Politici și securitate",
            termsOfUse: "Termeni de utilizare",
            disclaimer: "Descărcare de responsabilitate",
            privacyPolicy: "Politica de confidențialitate",
            cookiesPolicy: "Politica de cookie-uri",
            accessibilityStatement: "Declarația de accesibilitate",
            securityVulnerability: "Vulnerabilitate de securitate",
            statusPage: "Pagina de stare",
            community: "Comunitate",
            socialNetwork: "Rețea socială",
            wallOfLove: "Zidul dragostei",
            referFriend: "Recomandă un prieten",
            houseRules: "Regulile casei",
            moderators: "Moderatori",
            ideas: "Idei",
            education: "Educație",
            editorsPicks: "Selecțiile editorilor",
            indicatorsStrategies: "Indicatori și strategii",
            wizards: "Vrăjitori",
            freelancers: "Freelanceri",
            businessSolutions: "Soluții de afaceri",
            widgets: "Widget-uri",
            chartingLibraries: "Biblioteci de grafice",
            lightweightCharts: "Grafice ușoare™",
            advancedCharts: "Grafice avansate",
            tradingPlatform: "Platforma de tranzacționare",
            growthOpportunities: "Oportunități de creștere",
            advertising: "Publicitate",
            brokerageIntegration: "Integrarea brokerului",
            partnerProgram: "Program de parteneriat",
            educationProgram: "Program educațional",
            selectMarketData: "Datele de piață selectate furnizate de",
            iceDataServices: "ICE Data Services.",
            selectReferenceData: "Datele de referință selectate furnizate de FactSet. © 2025 FactSet Research Systems Inc. Drepturi de autor.",
            copyright: "© 2025 TradingView, Inc."
        },
        by: {
            lookFirstThenLeap: "Спачатку паглядзі / Потым скачы.",
            moreThanProduct: "Больш чым прадукт",
            screeners: "Фільтры",
            supercharts: "SuperCharts",
            stocks: "Акцыі",
            etfs: "ETF-ы",
            bonds: "Аблігацыі",
            cryptoCoins: "Крыптавалюты",
            cexPairs: "CEX пары",
            dexPairs: "DEX пары",
            pine: "Pine",
            heatmaps: "Цеплавыя карты",
            crypto: "Крыпта",
            calendars: "Календары",
            economic: "Эканамічны",
            earnings: "Прыбыткі",
            dividends: "Дывідэнды",
            moreProducts: "Больш прадуктаў",
            yieldCurves: "Крывыя даходнасці",
            options: "Опцыі",
            newsFlow: "Паток навін",
            pineScript: "Pine Script®",
            apps: "Прыкладанні",
            mobile: "Мабільны",
            desktop: "Настольны",
            toolsSubscriptions: "Інструменты і падпіскі",
            features: "Функцыі",
            pricing: "Цэны",
            marketData: "Рыначныя даныя",
            trading: "Гандлёвая дзейнасць",
            overview: "Агляд",
            brokers: "Брокеры",
            specialOffers: "Спецыяльныя прапановы",
            cmeGroupFutures: "CME Group ф'ючэрсы",
            eurexFutures: "Eurex ф'ючэрсы",
            usStocksBundle: "Пакет амерыканскіх акцый",
            aboutCompany: "Пра кампанію",
            whoWeAre: "Хто мы",
            manifesto: "Маніфест",
            athletes: "Спартсмены",
            blog: "Блог",
            careers: "Кар'ера",
            mediaKit: "Медыя-кіт",
            merch: "Тавары",
            tradingViewStore: "Крама TradingView",
            tarotCards: "Карты Тара для трэйдэраў",
            tradeTime: "C63 час гандлю",
            policiesSecurity: "Палітыка і бяспека",
            termsOfUse: "Умовы выкарыстання",
            disclaimer: "Адмова ад адказнасці",
            privacyPolicy: "Палітыка прыватнасці",
            cookiesPolicy: "Палітыка файлаў cookie",
            accessibilityStatement: "Заява пра даступнасць",
            securityVulnerability: "Уразлівасць бяспекі",
            statusPage: "Старонка статусу",
            community: "Супольнасць",
            socialNetwork: "Сацыяльная сетка",
            wallOfLove: "Сцяна любові",
            referFriend: "Параіць сябра",
            houseRules: "Правілы дома",
            moderators: "Мадэратары",
            ideas: "Ідэі",
            education: "Адукацыя",
            editorsPicks: "Выбар рэдактараў",
            indicatorsStrategies: "Індыкатары і стратэгіі",
            wizards: "Чараўнікі",
            freelancers: "Фрылансеры",
            businessSolutions: "Бізнес-рашэнні",
            widgets: "Віджэты",
            chartingLibraries: "Бібліятэкі дыяграм",
            lightweightCharts: "Лёгкія дыяграмы™",
            advancedCharts: "Пашыраныя дыяграмы",
            tradingPlatform: "Гандлёвая платформа",
            growthOpportunities: "Магчымасці росту",
            advertising: "Рэклама",
            brokerageIntegration: "Інтэграцыя брокера",
            partnerProgram: "Партнёрская праграма",
            educationProgram: "Адукацыйная праграма",
            selectMarketData: "Выбраныя рыначныя даныя, прадстаўленыя",
            iceDataServices: "ICE Data Services.",
            selectReferenceData: "Выбраныя даведачныя даныя, прадстаўленыя FactSet. © 2025 FactSet Research Systems Inc. Аўтарскія правы.",
            copyright: "© 2025 TradingView, Inc."
        }
    };
    return e[i] || e.en
}
  , m1 = () => {
    const {i18n: i} = We()
      , e = i.language
      , r = zf(e);
    return x.jsx("footer", {
        className: "bg-[#FFFFFF] py-4 sm:py-6 md:py-8",
        children: x.jsxs("div", {
            className: "max-w-[1376px] w-full mx-auto flex flex-col gap-4 sm:gap-6 px-3 sm:px-4 md:px-6 lg:px-8",
            children: [x.jsxs("div", {
                className: "flex flex-col xl:flex-row items-start gap-6 sm:gap-8 lg:gap-12 relative",
                children: [x.jsxs("div", {
                    className: "w-full xl:max-w-[354px] xl:w-[354px] flex flex-col gap-4 sm:gap-6 lg:gap-8 relative z-10",
                    children: [x.jsxs("div", {
                        className: "flex flex-col gap-2",
                        children: [x.jsx("img", {
                            src: Cf,
                            className: "max-w-[140px] sm:max-w-[160px] md:max-w-[187px] invert",
                            alt: "TradingView"
                        }), x.jsx("span", {
                            className: "text-[#0D1013] text-[12px] sm:text-[14px] leading-[14px] sm:leading-[16px]",
                            children: r.lookFirstThenLeap
                        })]
                    }), x.jsx("div", {
                        className: "w-full max-w-[280px] sm:max-w-[320px] md:max-w-[200px] grid grid-cols-5 gap-2 sm:gap-3 md:gap-5",
                        children: p1.map( (a, o) => x.jsx("a", {
                            href: a.url,
                            target: "_blank",
                            rel: "nofollow",
                            className: "w-6 h-6 sm:w-7 sm:h-7 md:w-8 md:h-8 flex items-center justify-center hover:opacity-70 transition-opacity duration-200",
                            "aria-label": `TradingView on ${a.name}`,
                            children: x.jsx("img", {
                                src: a.icon,
                                alt: a.name,
                                className: "w-full h-full object-contain invert"
                            })
                        }, o))
                    }), x.jsxs("div", {
                        className: "flex flex-col gap-1 sm:gap-2",
                        children: [x.jsxs("p", {
                            className: "text-[#4D4F53] text-[10px] sm:text-[12px] leading-[16px] sm:leading-[20px]",
                            children: [r.selectMarketData, " ", x.jsx("a", {
                                href: "https://www.theice.com/market-data",
                                target: "_blank",
                                rel: "nofollow",
                                className: "text-[#326FF3] hover:underline",
                                children: r.iceDataServices
                            })]
                        }), x.jsx("p", {
                            className: "text-[#4D4F53] text-[10px] sm:text-[12px] leading-[16px] sm:leading-[20px]",
                            children: r.selectReferenceData
                        }), x.jsx("p", {
                            className: "text-[#4D4F53] text-[10px] sm:text-[12px] leading-[16px] sm:leading-[20px]",
                            children: r.copyright
                        })]
                    })]
                }), x.jsxs("div", {
                    className: "w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 lg:gap-6 xl:gap-8 relative z-10",
                    children: [x.jsx(ls, {
                        sections: os.column1
                    }), x.jsx(ls, {
                        sections: os.column2
                    }), x.jsx(ls, {
                        sections: os.column3
                    }), x.jsx(ls, {
                        sections: os.column4
                    })]
                })]
            }), x.jsx("div", {
                className: "w-full flex justify-center",
                children: x.jsx("img", {
                    src: d1,
                    alt: "",
                    className: "w-full"
                })
            })]
        })
    })
}
  , ls = ({sections: i}) => {
    const {i18n: e} = We()
      , r = e.language
      , a = zf(r);
    return x.jsx("div", {
        className: "flex flex-col gap-3 sm:gap-4",
        children: i.map( (o, l) => x.jsxs("div", {
            className: "mb-2 sm:mb-0",
            children: [x.jsx("h3", {
                className: "text-[#858C93] text-[10px] sm:text-[12px] leading-[120%] sm:leading-[130%] uppercase tracking-wide mb-2 sm:mb-3 font-medium",
                children: a[o.title]
            }), x.jsx("ul", {
                className: "flex flex-col gap-0.5 sm:gap-1",
                children: o.links.map( (u, d) => x.jsx("li", {
                    children: x.jsx("a", {
                        href: u.url,
                        target: u.url.includes("tradingview.com") ? "_self" : "_blank",
                        rel: u.url.includes("tradingview.com") ? void 0 : "nofollow",
                        className: "block py-0.5 sm:py-1 text-[12px] sm:text-[14px] text-[#0D1013] hover:bg-[#0D1013]/10 hover:text-[#0D1013] w-fit px-1 sm:px-2 rounded-md transition-all duration-200 -ml-1 sm:-ml-2",
                        children: a[u.name]
                    })
                }, d))
            })]
        }, l))
    })
}
  , Fc = N.createContext({});
function Rc(i) {
    const e = N.useRef(null);
    return e.current === null && (e.current = i()),
    e.current
}
const Fs = N.createContext(null)
  , Bc = N.createContext({
    transformPagePoint: i => i,
    isStatic: !1,
    reducedMotion: "never"
});
class h1 extends N.Component {
    getSnapshotBeforeUpdate(e) {
        const r = this.props.childRef.current;
        if (r && e.isPresent && !this.props.isPresent) {
            const a = this.props.sizeRef.current;
            a.height = r.offsetHeight || 0,
            a.width = r.offsetWidth || 0,
            a.top = r.offsetTop,
            a.left = r.offsetLeft
        }
        return null
    }
    componentDidUpdate() {}
    render() {
        return this.props.children
    }
}
function f1({children: i, isPresent: e}) {
    const r = N.useId()
      , a = N.useRef(null)
      , o = N.useRef({
        width: 0,
        height: 0,
        top: 0,
        left: 0
    })
      , {nonce: l} = N.useContext(Bc);
    return N.useInsertionEffect( () => {
        const {width: u, height: d, top: p, left: h} = o.current;
        if (e || !a.current || !u || !d)
            return;
        a.current.dataset.motionPopId = r;
        const g = document.createElement("style");
        return l && (g.nonce = l),
        document.head.appendChild(g),
        g.sheet && g.sheet.insertRule(`
          [data-motion-pop-id="${r}"] {
            position: absolute !important;
            width: ${u}px !important;
            height: ${d}px !important;
            top: ${p}px !important;
            left: ${h}px !important;
          }
        `),
        () => {
            document.head.removeChild(g)
        }
    }
    , [e]),
    x.jsx(h1, {
        isPresent: e,
        childRef: a,
        sizeRef: o,
        children: N.cloneElement(i, {
            ref: a
        })
    })
}
const g1 = ({children: i, initial: e, isPresent: r, onExitComplete: a, custom: o, presenceAffectsLayout: l, mode: u}) => {
    const d = Rc(v1)
      , p = N.useId()
      , h = N.useCallback(v => {
        d.set(v, !0);
        for (const y of d.values())
            if (!y)
                return;
        a && a()
    }
    , [d, a])
      , g = N.useMemo( () => ({
        id: p,
        initial: e,
        isPresent: r,
        custom: o,
        onExitComplete: h,
        register: v => (d.set(v, !1),
        () => d.delete(v))
    }), l ? [Math.random(), h] : [r, h]);
    return N.useMemo( () => {
        d.forEach( (v, y) => d.set(y, !1))
    }
    , [r]),
    N.useEffect( () => {
        !r && !d.size && a && a()
    }
    , [r]),
    u === "popLayout" && (i = x.jsx(f1, {
        isPresent: r,
        children: i
    })),
    x.jsx(Fs.Provider, {
        value: g,
        children: i
    })
}
;
function v1() {
    return new Map
}
function Af(i=!0) {
    const e = N.useContext(Fs);
    if (e === null)
        return [!0, null];
    const {isPresent: r, onExitComplete: a, register: o} = e
      , l = N.useId();
    N.useEffect( () => {
        i && o(l)
    }
    , [i]);
    const u = N.useCallback( () => i && a && a(l), [l, a, i]);
    return !r && a ? [!1, u] : [!0]
}
const cs = i => i.key || "";
function Cm(i) {
    const e = [];
    return N.Children.forEach(i, r => {
        N.isValidElement(r) && e.push(r)
    }
    ),
    e
}
const Wc = typeof window < "u"
  , Ef = Wc ? N.useLayoutEffect : N.useEffect
  , Ti = ({children: i, custom: e, initial: r=!0, onExitComplete: a, presenceAffectsLayout: o=!0, mode: l="sync", propagate: u=!1}) => {
    const [d,p] = Af(u)
      , h = N.useMemo( () => Cm(i), [i])
      , g = u && !d ? [] : h.map(cs)
      , v = N.useRef(!0)
      , y = N.useRef(h)
      , P = Rc( () => new Map)
      , [w,S] = N.useState(h)
      , [z,C] = N.useState(h);
    Ef( () => {
        v.current = !1,
        y.current = h;
        for (let D = 0; D < z.length; D++) {
            const M = cs(z[D]);
            g.includes(M) ? P.delete(M) : P.get(M) !== !0 && P.set(M, !1)
        }
    }
    , [z, g.length, g.join("-")]);
    const b = [];
    if (h !== w) {
        let D = [...h];
        for (let M = 0; M < z.length; M++) {
            const B = z[M]
              , _ = cs(B);
            g.includes(_) || (D.splice(M, 0, B),
            b.push(B))
        }
        l === "wait" && b.length && (D = b),
        C(Cm(D)),
        S(h);
        return
    }
    const {forceRender: T} = N.useContext(Fc);
    return x.jsx(x.Fragment, {
        children: z.map(D => {
            const M = cs(D)
              , B = u && !d ? !1 : h === z || g.includes(M)
              , _ = () => {
                if (P.has(M))
                    P.set(M, !0);
                else
                    return;
                let F = !0;
                P.forEach(R => {
                    R || (F = !1)
                }
                ),
                F && (T == null || T(),
                C(y.current),
                u && (p == null || p()),
                a && a())
            }
            ;
            return x.jsx(g1, {
                isPresent: B,
                initial: !v.current || r ? void 0 : !1,
                custom: B ? void 0 : e,
                presenceAffectsLayout: o,
                mode: l,
                onExitComplete: B ? void 0 : _,
                children: D
            }, M)
        }
        )
    })
}
  , kt = i => i;
let Df = kt;
function _c(i) {
    let e;
    return () => (e === void 0 && (e = i()),
    e)
}
const Vr = (i, e, r) => {
    const a = e - i;
    return a === 0 ? 1 : (r - i) / a
}
  , ii = i => i * 1e3
  , ri = i => i / 1e3
  , y1 = {
    useManualTiming: !1
};
function k1(i) {
    let e = new Set
      , r = new Set
      , a = !1
      , o = !1;
    const l = new WeakSet;
    let u = {
        delta: 0,
        timestamp: 0,
        isProcessing: !1
    };
    function d(h) {
        l.has(h) && (p.schedule(h),
        i()),
        h(u)
    }
    const p = {
        schedule: (h, g=!1, v=!1) => {
            const P = v && a ? e : r;
            return g && l.add(h),
            P.has(h) || P.add(h),
            h
        }
        ,
        cancel: h => {
            r.delete(h),
            l.delete(h)
        }
        ,
        process: h => {
            if (u = h,
            a) {
                o = !0;
                return
            }
            a = !0,
            [e,r] = [r, e],
            e.forEach(d),
            e.clear(),
            a = !1,
            o && (o = !1,
            p.process(h))
        }
    };
    return p
}
const us = ["read", "resolveKeyframes", "update", "preRender", "render", "postRender"]
  , x1 = 40;
function If(i, e) {
    let r = !1
      , a = !0;
    const o = {
        delta: 0,
        timestamp: 0,
        isProcessing: !1
    }
      , l = () => r = !0
      , u = us.reduce( (C, b) => (C[b] = k1(l),
    C), {})
      , {read: d, resolveKeyframes: p, update: h, preRender: g, render: v, postRender: y} = u
      , P = () => {
        const C = performance.now();
        r = !1,
        o.delta = a ? 1e3 / 60 : Math.max(Math.min(C - o.timestamp, x1), 1),
        o.timestamp = C,
        o.isProcessing = !0,
        d.process(o),
        p.process(o),
        h.process(o),
        g.process(o),
        v.process(o),
        y.process(o),
        o.isProcessing = !1,
        r && e && (a = !1,
        i(P))
    }
      , w = () => {
        r = !0,
        a = !0,
        o.isProcessing || i(P)
    }
    ;
    return {
        schedule: us.reduce( (C, b) => {
            const T = u[b];
            return C[b] = (D, M=!1, B=!1) => (r || w(),
            T.schedule(D, M, B)),
            C
        }
        , {}),
        cancel: C => {
            for (let b = 0; b < us.length; b++)
                u[us[b]].cancel(C)
        }
        ,
        state: o,
        steps: u
    }
}
const {schedule: ze, cancel: zi, state: Ze, steps: Kl} = If(typeof requestAnimationFrame < "u" ? requestAnimationFrame : kt, !0)
  , Mf = N.createContext({
    strict: !1
})
  , zm = {
    animation: ["animate", "variants", "whileHover", "whileTap", "exit", "whileInView", "whileFocus", "whileDrag"],
    exit: ["exit"],
    drag: ["drag", "dragControls"],
    focus: ["whileFocus"],
    hover: ["whileHover", "onHoverStart", "onHoverEnd"],
    tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
    pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
    inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
    layout: ["layout", "layoutId"]
}
  , Lr = {};
for (const i in zm)
    Lr[i] = {
        isEnabled: e => zm[i].some(r => !!e[r])
    };
function w1(i) {
    for (const e in i)
        Lr[e] = {
            ...Lr[e],
            ...i[e]
        }
}
const P1 = new Set(["animate", "exit", "variants", "initial", "style", "values", "variants", "transition", "transformTemplate", "custom", "inherit", "onBeforeLayoutMeasure", "onAnimationStart", "onAnimationComplete", "onUpdate", "onDragStart", "onDrag", "onDragEnd", "onMeasureDragConstraints", "onDirectionLock", "onDragTransitionEnd", "_dragX", "_dragY", "onHoverStart", "onHoverEnd", "onViewportEnter", "onViewportLeave", "globalTapTarget", "ignoreStrict", "viewport"]);
function ws(i) {
    return i.startsWith("while") || i.startsWith("drag") && i !== "draggable" || i.startsWith("layout") || i.startsWith("onTap") || i.startsWith("onPan") || i.startsWith("onLayout") || P1.has(i)
}
let Vf = i => !ws(i);
function b1(i) {
    i && (Vf = e => e.startsWith("on") ? !ws(e) : i(e))
}
try {
    b1(require("@emotion/is-prop-valid").default)
} catch {}
function S1(i, e, r) {
    const a = {};
    for (const o in i)
        o === "values" && typeof i.values == "object" || (Vf(o) || r === !0 && ws(o) || !e && !ws(o) || i.draggable && o.startsWith("onDrag")) && (a[o] = i[o]);
    return a
}
function T1(i) {
    if (typeof Proxy > "u")
        return i;
    const e = new Map
      , r = (...a) => i(...a);
    return new Proxy(r,{
        get: (a, o) => o === "create" ? i : (e.has(o) || e.set(o, i(o)),
        e.get(o))
    })
}
const Rs = N.createContext({});
function Fn(i) {
    return typeof i == "string" || Array.isArray(i)
}
function Bs(i) {
    return i !== null && typeof i == "object" && typeof i.start == "function"
}
const Uc = ["animate", "whileInView", "whileFocus", "whileHover", "whileTap", "whileDrag", "exit"]
  , Kc = ["initial", ...Uc];
function Ws(i) {
    return Bs(i.animate) || Kc.some(e => Fn(i[e]))
}
function Lf(i) {
    return !!(Ws(i) || i.variants)
}
function j1(i, e) {
    if (Ws(i)) {
        const {initial: r, animate: a} = i;
        return {
            initial: r === !1 || Fn(r) ? r : void 0,
            animate: Fn(a) ? a : void 0
        }
    }
    return i.inherit !== !1 ? e : {}
}
function C1(i) {
    const {initial: e, animate: r} = j1(i, N.useContext(Rs));
    return N.useMemo( () => ({
        initial: e,
        animate: r
    }), [Am(e), Am(r)])
}
function Am(i) {
    return Array.isArray(i) ? i.join(" ") : i
}
const z1 = Symbol.for("motionComponentSymbol");
function zr(i) {
    return i && typeof i == "object" && Object.prototype.hasOwnProperty.call(i, "current")
}
function A1(i, e, r) {
    return N.useCallback(a => {
        a && i.onMount && i.onMount(a),
        e && (a ? e.mount(a) : e.unmount()),
        r && (typeof r == "function" ? r(a) : zr(r) && (r.current = a))
    }
    , [e])
}
const $c = i => i.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase()
  , E1 = "framerAppearId"
  , Of = "data-" + $c(E1)
  , {schedule: Hc} = If(queueMicrotask, !1)
  , Nf = N.createContext({});
function D1(i, e, r, a, o) {
    var l, u;
    const {visualElement: d} = N.useContext(Rs)
      , p = N.useContext(Mf)
      , h = N.useContext(Fs)
      , g = N.useContext(Bc).reducedMotion
      , v = N.useRef(null);
    a = a || p.renderer,
    !v.current && a && (v.current = a(i, {
        visualState: e,
        parent: d,
        props: r,
        presenceContext: h,
        blockInitialAnimation: h ? h.initial === !1 : !1,
        reducedMotionConfig: g
    }));
    const y = v.current
      , P = N.useContext(Nf);
    y && !y.projection && o && (y.type === "html" || y.type === "svg") && I1(v.current, r, o, P);
    const w = N.useRef(!1);
    N.useInsertionEffect( () => {
        y && w.current && y.update(r, h)
    }
    );
    const S = r[Of]
      , z = N.useRef(!!S && !(!((l = window.MotionHandoffIsComplete) === null || l === void 0) && l.call(window, S)) && ((u = window.MotionHasOptimisedAnimation) === null || u === void 0 ? void 0 : u.call(window, S)));
    return Ef( () => {
        y && (w.current = !0,
        window.MotionIsMounted = !0,
        y.updateFeatures(),
        Hc.render(y.render),
        z.current && y.animationState && y.animationState.animateChanges())
    }
    ),
    N.useEffect( () => {
        y && (!z.current && y.animationState && y.animationState.animateChanges(),
        z.current && (queueMicrotask( () => {
            var C;
            (C = window.MotionHandoffMarkAsComplete) === null || C === void 0 || C.call(window, S)
        }
        ),
        z.current = !1))
    }
    ),
    y
}
function I1(i, e, r, a) {
    const {layoutId: o, layout: l, drag: u, dragConstraints: d, layoutScroll: p, layoutRoot: h} = e;
    i.projection = new r(i.latestValues,e["data-framer-portal-id"] ? void 0 : Ff(i.parent)),
    i.projection.setOptions({
        layoutId: o,
        layout: l,
        alwaysMeasureLayout: !!u || d && zr(d),
        visualElement: i,
        animationType: typeof l == "string" ? l : "both",
        initialPromotionConfig: a,
        layoutScroll: p,
        layoutRoot: h
    })
}
function Ff(i) {
    if (i)
        return i.options.allowProjection !== !1 ? i.projection : Ff(i.parent)
}
function M1({preloadedFeatures: i, createVisualElement: e, useRender: r, useVisualState: a, Component: o}) {
    var l, u;
    i && w1(i);
    function d(h, g) {
        let v;
        const y = {
            ...N.useContext(Bc),
            ...h,
            layoutId: V1(h)
        }
          , {isStatic: P} = y
          , w = C1(h)
          , S = a(h, P);
        if (!P && Wc) {
            L1();
            const z = O1(y);
            v = z.MeasureLayout,
            w.visualElement = D1(o, S, y, e, z.ProjectionNode)
        }
        return x.jsxs(Rs.Provider, {
            value: w,
            children: [v && w.visualElement ? x.jsx(v, {
                visualElement: w.visualElement,
                ...y
            }) : null, r(o, h, A1(S, w.visualElement, g), S, P, w.visualElement)]
        })
    }
    d.displayName = `motion.${typeof o == "string" ? o : `create(${(u = (l = o.displayName) !== null && l !== void 0 ? l : o.name) !== null && u !== void 0 ? u : ""})`}`;
    const p = N.forwardRef(d);
    return p[z1] = o,
    p
}
function V1({layoutId: i}) {
    const e = N.useContext(Fc).id;
    return e && i !== void 0 ? e + "-" + i : i
}
function L1(i, e) {
    N.useContext(Mf).strict
}
function O1(i) {
    const {drag: e, layout: r} = Lr;
    if (!e && !r)
        return {};
    const a = {
        ...e,
        ...r
    };
    return {
        MeasureLayout: e != null && e.isEnabled(i) || r != null && r.isEnabled(i) ? a.MeasureLayout : void 0,
        ProjectionNode: a.ProjectionNode
    }
}
const N1 = ["animate", "circle", "defs", "desc", "ellipse", "g", "image", "line", "filter", "marker", "mask", "metadata", "path", "pattern", "polygon", "polyline", "rect", "stop", "switch", "symbol", "svg", "text", "tspan", "use", "view"];
function Gc(i) {
    return typeof i != "string" || i.includes("-") ? !1 : !!(N1.indexOf(i) > -1 || /[A-Z]/u.test(i))
}
function Em(i) {
    const e = [{}, {}];
    return i == null || i.values.forEach( (r, a) => {
        e[0][a] = r.get(),
        e[1][a] = r.getVelocity()
    }
    ),
    e
}
function qc(i, e, r, a) {
    if (typeof e == "function") {
        const [o,l] = Em(a);
        e = e(r !== void 0 ? r : i.custom, o, l)
    }
    if (typeof e == "string" && (e = i.variants && i.variants[e]),
    typeof e == "function") {
        const [o,l] = Em(a);
        e = e(r !== void 0 ? r : i.custom, o, l)
    }
    return e
}
const fc = i => Array.isArray(i)
  , F1 = i => !!(i && typeof i == "object" && i.mix && i.toValue)
  , R1 = i => fc(i) ? i[i.length - 1] || 0 : i
  , it = i => !!(i && i.getVelocity);
function vs(i) {
    const e = it(i) ? i.get() : i;
    return F1(e) ? e.toValue() : e
}
function B1({scrapeMotionValuesFromProps: i, createRenderState: e, onUpdate: r}, a, o, l) {
    const u = {
        latestValues: W1(a, o, l, i),
        renderState: e()
    };
    return r && (u.onMount = d => r({
        props: a,
        current: d,
        ...u
    }),
    u.onUpdate = d => r(d)),
    u
}
const Rf = i => (e, r) => {
    const a = N.useContext(Rs)
      , o = N.useContext(Fs)
      , l = () => B1(i, e, a, o);
    return r ? l() : Rc(l)
}
;
function W1(i, e, r, a) {
    const o = {}
      , l = a(i, {});
    for (const y in l)
        o[y] = vs(l[y]);
    let {initial: u, animate: d} = i;
    const p = Ws(i)
      , h = Lf(i);
    e && h && !p && i.inherit !== !1 && (u === void 0 && (u = e.initial),
    d === void 0 && (d = e.animate));
    let g = r ? r.initial === !1 : !1;
    g = g || u === !1;
    const v = g ? d : u;
    if (v && typeof v != "boolean" && !Bs(v)) {
        const y = Array.isArray(v) ? v : [v];
        for (let P = 0; P < y.length; P++) {
            const w = qc(i, y[P]);
            if (w) {
                const {transitionEnd: S, transition: z, ...C} = w;
                for (const b in C) {
                    let T = C[b];
                    if (Array.isArray(T)) {
                        const D = g ? T.length - 1 : 0;
                        T = T[D]
                    }
                    T !== null && (o[b] = T)
                }
                for (const b in S)
                    o[b] = S[b]
            }
        }
    }
    return o
}
const Nr = ["transformPerspective", "x", "y", "z", "translateX", "translateY", "translateZ", "scale", "scaleX", "scaleY", "rotate", "rotateX", "rotateY", "rotateZ", "skew", "skewX", "skewY"]
  , Yi = new Set(Nr)
  , Bf = i => e => typeof e == "string" && e.startsWith(i)
  , Wf = Bf("--")
  , _1 = Bf("var(--")
  , Xc = i => _1(i) ? U1.test(i.split("/*")[0].trim()) : !1
  , U1 = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu
  , _f = (i, e) => e && typeof i == "number" ? e.transform(i) : i
  , ni = (i, e, r) => r > e ? e : r < i ? i : r
  , Fr = {
    test: i => typeof i == "number",
    parse: parseFloat,
    transform: i => i
}
  , Rn = {
    ...Fr,
    transform: i => ni(0, 1, i)
}
  , ds = {
    ...Fr,
    default: 1
}
  , $n = i => ({
    test: e => typeof e == "string" && e.endsWith(i) && e.split(" ").length === 1,
    parse: parseFloat,
    transform: e => `${e}${i}`
})
  , Si = $n("deg")
  , Kt = $n("%")
  , de = $n("px")
  , K1 = $n("vh")
  , $1 = $n("vw")
  , Dm = {
    ...Kt,
    parse: i => Kt.parse(i) / 100,
    transform: i => Kt.transform(i * 100)
}
  , H1 = {
    borderWidth: de,
    borderTopWidth: de,
    borderRightWidth: de,
    borderBottomWidth: de,
    borderLeftWidth: de,
    borderRadius: de,
    radius: de,
    borderTopLeftRadius: de,
    borderTopRightRadius: de,
    borderBottomRightRadius: de,
    borderBottomLeftRadius: de,
    width: de,
    maxWidth: de,
    height: de,
    maxHeight: de,
    top: de,
    right: de,
    bottom: de,
    left: de,
    padding: de,
    paddingTop: de,
    paddingRight: de,
    paddingBottom: de,
    paddingLeft: de,
    margin: de,
    marginTop: de,
    marginRight: de,
    marginBottom: de,
    marginLeft: de,
    backgroundPositionX: de,
    backgroundPositionY: de
}
  , G1 = {
    rotate: Si,
    rotateX: Si,
    rotateY: Si,
    rotateZ: Si,
    scale: ds,
    scaleX: ds,
    scaleY: ds,
    scaleZ: ds,
    skew: Si,
    skewX: Si,
    skewY: Si,
    distance: de,
    translateX: de,
    translateY: de,
    translateZ: de,
    x: de,
    y: de,
    z: de,
    perspective: de,
    transformPerspective: de,
    opacity: Rn,
    originX: Dm,
    originY: Dm,
    originZ: de
}
  , Im = {
    ...Fr,
    transform: Math.round
}
  , Zc = {
    ...H1,
    ...G1,
    zIndex: Im,
    size: de,
    fillOpacity: Rn,
    strokeOpacity: Rn,
    numOctaves: Im
}
  , q1 = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
}
  , X1 = Nr.length;
function Z1(i, e, r) {
    let a = ""
      , o = !0;
    for (let l = 0; l < X1; l++) {
        const u = Nr[l]
          , d = i[u];
        if (d === void 0)
            continue;
        let p = !0;
        if (typeof d == "number" ? p = d === (u.startsWith("scale") ? 1 : 0) : p = parseFloat(d) === 0,
        !p || r) {
            const h = _f(d, Zc[u]);
            if (!p) {
                o = !1;
                const g = q1[u] || u;
                a += `${g}(${h}) `
            }
            r && (e[u] = h)
        }
    }
    return a = a.trim(),
    r ? a = r(e, o ? "" : a) : o && (a = "none"),
    a
}
function Yc(i, e, r) {
    const {style: a, vars: o, transformOrigin: l} = i;
    let u = !1
      , d = !1;
    for (const p in e) {
        const h = e[p];
        if (Yi.has(p)) {
            u = !0;
            continue
        } else if (Wf(p)) {
            o[p] = h;
            continue
        } else {
            const g = _f(h, Zc[p]);
            p.startsWith("origin") ? (d = !0,
            l[p] = g) : a[p] = g
        }
    }
    if (e.transform || (u || r ? a.transform = Z1(e, i.transform, r) : a.transform && (a.transform = "none")),
    d) {
        const {originX: p="50%", originY: h="50%", originZ: g=0} = l;
        a.transformOrigin = `${p} ${h} ${g}`
    }
}
const Y1 = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
}
  , Q1 = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
function J1(i, e, r=1, a=0, o=!0) {
    i.pathLength = 1;
    const l = o ? Y1 : Q1;
    i[l.offset] = de.transform(-a);
    const u = de.transform(e)
      , d = de.transform(r);
    i[l.array] = `${u} ${d}`
}
function Mm(i, e, r) {
    return typeof i == "string" ? i : de.transform(e + r * i)
}
function ek(i, e, r) {
    const a = Mm(e, i.x, i.width)
      , o = Mm(r, i.y, i.height);
    return `${a} ${o}`
}
function Qc(i, {attrX: e, attrY: r, attrScale: a, originX: o, originY: l, pathLength: u, pathSpacing: d=1, pathOffset: p=0, ...h}, g, v) {
    if (Yc(i, h, v),
    g) {
        i.style.viewBox && (i.attrs.viewBox = i.style.viewBox);
        return
    }
    i.attrs = i.style,
    i.style = {};
    const {attrs: y, style: P, dimensions: w} = i;
    y.transform && (w && (P.transform = y.transform),
    delete y.transform),
    w && (o !== void 0 || l !== void 0 || P.transform) && (P.transformOrigin = ek(w, o !== void 0 ? o : .5, l !== void 0 ? l : .5)),
    e !== void 0 && (y.x = e),
    r !== void 0 && (y.y = r),
    a !== void 0 && (y.scale = a),
    u !== void 0 && J1(y, u, d, p, !1)
}
const Jc = () => ({
    style: {},
    transform: {},
    transformOrigin: {},
    vars: {}
})
  , Uf = () => ({
    ...Jc(),
    attrs: {}
})
  , eu = i => typeof i == "string" && i.toLowerCase() === "svg";
function Kf(i, {style: e, vars: r}, a, o) {
    Object.assign(i.style, e, o && o.getProjectionStyles(a));
    for (const l in r)
        i.style.setProperty(l, r[l])
}
const $f = new Set(["baseFrequency", "diffuseConstant", "kernelMatrix", "kernelUnitLength", "keySplines", "keyTimes", "limitingConeAngle", "markerHeight", "markerWidth", "numOctaves", "targetX", "targetY", "surfaceScale", "specularConstant", "specularExponent", "stdDeviation", "tableValues", "viewBox", "gradientTransform", "pathLength", "startOffset", "textLength", "lengthAdjust"]);
function Hf(i, e, r, a) {
    Kf(i, e, void 0, a);
    for (const o in e.attrs)
        i.setAttribute($f.has(o) ? o : $c(o), e.attrs[o])
}
const Ps = {};
function tk(i) {
    Object.assign(Ps, i)
}
function Gf(i, {layout: e, layoutId: r}) {
    return Yi.has(i) || i.startsWith("origin") || (e || r !== void 0) && (!!Ps[i] || i === "opacity")
}
function tu(i, e, r) {
    var a;
    const {style: o} = i
      , l = {};
    for (const u in o)
        (it(o[u]) || e.style && it(e.style[u]) || Gf(u, i) || ((a = r == null ? void 0 : r.getValue(u)) === null || a === void 0 ? void 0 : a.liveStyle) !== void 0) && (l[u] = o[u]);
    return l
}
function qf(i, e, r) {
    const a = tu(i, e, r);
    for (const o in i)
        if (it(i[o]) || it(e[o])) {
            const l = Nr.indexOf(o) !== -1 ? "attr" + o.charAt(0).toUpperCase() + o.substring(1) : o;
            a[l] = i[o]
        }
    return a
}
function ik(i, e) {
    try {
        e.dimensions = typeof i.getBBox == "function" ? i.getBBox() : i.getBoundingClientRect()
    } catch {
        e.dimensions = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        }
    }
}
const Vm = ["x", "y", "width", "height", "cx", "cy", "r"]
  , rk = {
    useVisualState: Rf({
        scrapeMotionValuesFromProps: qf,
        createRenderState: Uf,
        onUpdate: ({props: i, prevProps: e, current: r, renderState: a, latestValues: o}) => {
            if (!r)
                return;
            let l = !!i.drag;
            if (!l) {
                for (const d in o)
                    if (Yi.has(d)) {
                        l = !0;
                        break
                    }
            }
            if (!l)
                return;
            let u = !e;
            if (e)
                for (let d = 0; d < Vm.length; d++) {
                    const p = Vm[d];
                    i[p] !== e[p] && (u = !0)
                }
            u && ze.read( () => {
                ik(r, a),
                ze.render( () => {
                    Qc(a, o, eu(r.tagName), i.transformTemplate),
                    Hf(r, a)
                }
                )
            }
            )
        }
    })
}
  , nk = {
    useVisualState: Rf({
        scrapeMotionValuesFromProps: tu,
        createRenderState: Jc
    })
};
function Xf(i, e, r) {
    for (const a in e)
        !it(e[a]) && !Gf(a, r) && (i[a] = e[a])
}
function ak({transformTemplate: i}, e) {
    return N.useMemo( () => {
        const r = Jc();
        return Yc(r, e, i),
        Object.assign({}, r.vars, r.style)
    }
    , [e])
}
function sk(i, e) {
    const r = i.style || {}
      , a = {};
    return Xf(a, r, i),
    Object.assign(a, ak(i, e)),
    a
}
function ok(i, e) {
    const r = {}
      , a = sk(i, e);
    return i.drag && i.dragListener !== !1 && (r.draggable = !1,
    a.userSelect = a.WebkitUserSelect = a.WebkitTouchCallout = "none",
    a.touchAction = i.drag === !0 ? "none" : `pan-${i.drag === "x" ? "y" : "x"}`),
    i.tabIndex === void 0 && (i.onTap || i.onTapStart || i.whileTap) && (r.tabIndex = 0),
    r.style = a,
    r
}
function lk(i, e, r, a) {
    const o = N.useMemo( () => {
        const l = Uf();
        return Qc(l, e, eu(a), i.transformTemplate),
        {
            ...l.attrs,
            style: {
                ...l.style
            }
        }
    }
    , [e]);
    if (i.style) {
        const l = {};
        Xf(l, i.style, i),
        o.style = {
            ...l,
            ...o.style
        }
    }
    return o
}
function ck(i=!1) {
    return (r, a, o, {latestValues: l}, u) => {
        const p = (Gc(r) ? lk : ok)(a, l, u, r)
          , h = S1(a, typeof r == "string", i)
          , g = r !== N.Fragment ? {
            ...h,
            ...p,
            ref: o
        } : {}
          , {children: v} = a
          , y = N.useMemo( () => it(v) ? v.get() : v, [v]);
        return N.createElement(r, {
            ...g,
            children: y
        })
    }
}
function uk(i, e) {
    return function(a, {forwardMotionProps: o}={
        forwardMotionProps: !1
    }) {
        const u = {
            ...Gc(a) ? rk : nk,
            preloadedFeatures: i,
            useRender: ck(o),
            createVisualElement: e,
            Component: a
        };
        return M1(u)
    }
}
function Zf(i, e) {
    if (!Array.isArray(e))
        return !1;
    const r = e.length;
    if (r !== i.length)
        return !1;
    for (let a = 0; a < r; a++)
        if (e[a] !== i[a])
            return !1;
    return !0
}
function _s(i, e, r) {
    const a = i.getProps();
    return qc(a, e, r !== void 0 ? r : a.custom, i)
}
const dk = _c( () => window.ScrollTimeline !== void 0);
class pk {
    constructor(e) {
        this.stop = () => this.runAll("stop"),
        this.animations = e.filter(Boolean)
    }
    get finished() {
        return Promise.all(this.animations.map(e => "finished"in e ? e.finished : e))
    }
    getAll(e) {
        return this.animations[0][e]
    }
    setAll(e, r) {
        for (let a = 0; a < this.animations.length; a++)
            this.animations[a][e] = r
    }
    attachTimeline(e, r) {
        const a = this.animations.map(o => {
            if (dk() && o.attachTimeline)
                return o.attachTimeline(e);
            if (typeof r == "function")
                return r(o)
        }
        );
        return () => {
            a.forEach( (o, l) => {
                o && o(),
                this.animations[l].stop()
            }
            )
        }
    }
    get time() {
        return this.getAll("time")
    }
    set time(e) {
        this.setAll("time", e)
    }
    get speed() {
        return this.getAll("speed")
    }
    set speed(e) {
        this.setAll("speed", e)
    }
    get startTime() {
        return this.getAll("startTime")
    }
    get duration() {
        let e = 0;
        for (let r = 0; r < this.animations.length; r++)
            e = Math.max(e, this.animations[r].duration);
        return e
    }
    runAll(e) {
        this.animations.forEach(r => r[e]())
    }
    flatten() {
        this.runAll("flatten")
    }
    play() {
        this.runAll("play")
    }
    pause() {
        this.runAll("pause")
    }
    cancel() {
        this.runAll("cancel")
    }
    complete() {
        this.runAll("complete")
    }
}
class mk extends pk {
    then(e, r) {
        return Promise.all(this.animations).then(e).catch(r)
    }
}
function iu(i, e) {
    return i ? i[e] || i.default || i : void 0
}
const gc = 2e4;
function Yf(i) {
    let e = 0;
    const r = 50;
    let a = i.next(e);
    for (; !a.done && e < gc; )
        e += r,
        a = i.next(e);
    return e >= gc ? 1 / 0 : e
}
function ru(i) {
    return typeof i == "function"
}
function Lm(i, e) {
    i.timeline = e,
    i.onfinish = null
}
const nu = i => Array.isArray(i) && typeof i[0] == "number"
  , hk = {
    linearEasing: void 0
};
function fk(i, e) {
    const r = _c(i);
    return () => {
        var a;
        return (a = hk[e]) !== null && a !== void 0 ? a : r()
    }
}
const bs = fk( () => {
    try {
        document.createElement("div").animate({
            opacity: 0
        }, {
            easing: "linear(0, 1)"
        })
    } catch {
        return !1
    }
    return !0
}
, "linearEasing")
  , Qf = (i, e, r=10) => {
    let a = "";
    const o = Math.max(Math.round(e / r), 2);
    for (let l = 0; l < o; l++)
        a += i(Vr(0, o - 1, l)) + ", ";
    return `linear(${a.substring(0, a.length - 2)})`
}
;
function Jf(i) {
    return !!(typeof i == "function" && bs() || !i || typeof i == "string" && (i in vc || bs()) || nu(i) || Array.isArray(i) && i.every(Jf))
}
const An = ([i,e,r,a]) => `cubic-bezier(${i}, ${e}, ${r}, ${a})`
  , vc = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: An([0, .65, .55, 1]),
    circOut: An([.55, 0, 1, .45]),
    backIn: An([.31, .01, .66, -.59]),
    backOut: An([.33, 1.53, .69, .99])
};
function eg(i, e) {
    if (i)
        return typeof i == "function" && bs() ? Qf(i, e) : nu(i) ? An(i) : Array.isArray(i) ? i.map(r => eg(r, e) || vc.easeOut) : vc[i]
}
const Ot = {
    x: !1,
    y: !1
};
function tg() {
    return Ot.x || Ot.y
}
function ig(i, e, r) {
    var a;
    if (i instanceof Element)
        return [i];
    if (typeof i == "string") {
        let o = document;
        const l = (a = void 0) !== null && a !== void 0 ? a : o.querySelectorAll(i);
        return l ? Array.from(l) : []
    }
    return Array.from(i)
}
function rg(i, e) {
    const r = ig(i)
      , a = new AbortController
      , o = {
        passive: !0,
        ...e,
        signal: a.signal
    };
    return [r, o, () => a.abort()]
}
function Om(i) {
    return e => {
        e.pointerType === "touch" || tg() || i(e)
    }
}
function gk(i, e, r={}) {
    const [a,o,l] = rg(i, r)
      , u = Om(d => {
        const {target: p} = d
          , h = e(d);
        if (typeof h != "function" || !p)
            return;
        const g = Om(v => {
            h(v),
            p.removeEventListener("pointerleave", g)
        }
        );
        p.addEventListener("pointerleave", g, o)
    }
    );
    return a.forEach(d => {
        d.addEventListener("pointerenter", u, o)
    }
    ),
    l
}
const ng = (i, e) => e ? i === e ? !0 : ng(i, e.parentElement) : !1
  , au = i => i.pointerType === "mouse" ? typeof i.button != "number" || i.button <= 0 : i.isPrimary !== !1
  , vk = new Set(["BUTTON", "INPUT", "SELECT", "TEXTAREA", "A"]);
function yk(i) {
    return vk.has(i.tagName) || i.tabIndex !== -1
}
const En = new WeakSet;
function Nm(i) {
    return e => {
        e.key === "Enter" && i(e)
    }
}
function $l(i, e) {
    i.dispatchEvent(new PointerEvent("pointer" + e,{
        isPrimary: !0,
        bubbles: !0
    }))
}
const kk = (i, e) => {
    const r = i.currentTarget;
    if (!r)
        return;
    const a = Nm( () => {
        if (En.has(r))
            return;
        $l(r, "down");
        const o = Nm( () => {
            $l(r, "up")
        }
        )
          , l = () => $l(r, "cancel");
        r.addEventListener("keyup", o, e),
        r.addEventListener("blur", l, e)
    }
    );
    r.addEventListener("keydown", a, e),
    r.addEventListener("blur", () => r.removeEventListener("keydown", a), e)
}
;
function Fm(i) {
    return au(i) && !tg()
}
function xk(i, e, r={}) {
    const [a,o,l] = rg(i, r)
      , u = d => {
        const p = d.currentTarget;
        if (!Fm(d) || En.has(p))
            return;
        En.add(p);
        const h = e(d)
          , g = (P, w) => {
            window.removeEventListener("pointerup", v),
            window.removeEventListener("pointercancel", y),
            !(!Fm(P) || !En.has(p)) && (En.delete(p),
            typeof h == "function" && h(P, {
                success: w
            }))
        }
          , v = P => {
            g(P, r.useGlobalTarget || ng(p, P.target))
        }
          , y = P => {
            g(P, !1)
        }
        ;
        window.addEventListener("pointerup", v, o),
        window.addEventListener("pointercancel", y, o)
    }
    ;
    return a.forEach(d => {
        !yk(d) && d.getAttribute("tabindex") === null && (d.tabIndex = 0),
        (r.useGlobalTarget ? window : d).addEventListener("pointerdown", u, o),
        d.addEventListener("focus", h => kk(h, o), o)
    }
    ),
    l
}
function wk(i) {
    return i === "x" || i === "y" ? Ot[i] ? null : (Ot[i] = !0,
    () => {
        Ot[i] = !1
    }
    ) : Ot.x || Ot.y ? null : (Ot.x = Ot.y = !0,
    () => {
        Ot.x = Ot.y = !1
    }
    )
}
const ag = new Set(["width", "height", "top", "left", "right", "bottom", ...Nr]);
let ys;
function Pk() {
    ys = void 0
}
const $t = {
    now: () => (ys === void 0 && $t.set(Ze.isProcessing || y1.useManualTiming ? Ze.timestamp : performance.now()),
    ys),
    set: i => {
        ys = i,
        queueMicrotask(Pk)
    }
};
function su(i, e) {
    i.indexOf(e) === -1 && i.push(e)
}
function ou(i, e) {
    const r = i.indexOf(e);
    r > -1 && i.splice(r, 1)
}
class lu {
    constructor() {
        this.subscriptions = []
    }
    add(e) {
        return su(this.subscriptions, e),
        () => ou(this.subscriptions, e)
    }
    notify(e, r, a) {
        const o = this.subscriptions.length;
        if (o)
            if (o === 1)
                this.subscriptions[0](e, r, a);
            else
                for (let l = 0; l < o; l++) {
                    const u = this.subscriptions[l];
                    u && u(e, r, a)
                }
    }
    getSize() {
        return this.subscriptions.length
    }
    clear() {
        this.subscriptions.length = 0
    }
}
function sg(i, e) {
    return e ? i * (1e3 / e) : 0
}
const Rm = 30
  , bk = i => !isNaN(parseFloat(i));
class Sk {
    constructor(e, r={}) {
        this.version = "11.18.2",
        this.canTrackVelocity = null,
        this.events = {},
        this.updateAndNotify = (a, o=!0) => {
            const l = $t.now();
            this.updatedAt !== l && this.setPrevFrameValue(),
            this.prev = this.current,
            this.setCurrent(a),
            this.current !== this.prev && this.events.change && this.events.change.notify(this.current),
            o && this.events.renderRequest && this.events.renderRequest.notify(this.current)
        }
        ,
        this.hasAnimated = !1,
        this.setCurrent(e),
        this.owner = r.owner
    }
    setCurrent(e) {
        this.current = e,
        this.updatedAt = $t.now(),
        this.canTrackVelocity === null && e !== void 0 && (this.canTrackVelocity = bk(this.current))
    }
    setPrevFrameValue(e=this.current) {
        this.prevFrameValue = e,
        this.prevUpdatedAt = this.updatedAt
    }
    onChange(e) {
        return this.on("change", e)
    }
    on(e, r) {
        this.events[e] || (this.events[e] = new lu);
        const a = this.events[e].add(r);
        return e === "change" ? () => {
            a(),
            ze.read( () => {
                this.events.change.getSize() || this.stop()
            }
            )
        }
        : a
    }
    clearListeners() {
        for (const e in this.events)
            this.events[e].clear()
    }
    attach(e, r) {
        this.passiveEffect = e,
        this.stopPassiveEffect = r
    }
    set(e, r=!0) {
        !r || !this.passiveEffect ? this.updateAndNotify(e, r) : this.passiveEffect(e, this.updateAndNotify)
    }
    setWithVelocity(e, r, a) {
        this.set(r),
        this.prev = void 0,
        this.prevFrameValue = e,
        this.prevUpdatedAt = this.updatedAt - a
    }
    jump(e, r=!0) {
        this.updateAndNotify(e),
        this.prev = e,
        this.prevUpdatedAt = this.prevFrameValue = void 0,
        r && this.stop(),
        this.stopPassiveEffect && this.stopPassiveEffect()
    }
    get() {
        return this.current
    }
    getPrevious() {
        return this.prev
    }
    getVelocity() {
        const e = $t.now();
        if (!this.canTrackVelocity || this.prevFrameValue === void 0 || e - this.updatedAt > Rm)
            return 0;
        const r = Math.min(this.updatedAt - this.prevUpdatedAt, Rm);
        return sg(parseFloat(this.current) - parseFloat(this.prevFrameValue), r)
    }
    start(e) {
        return this.stop(),
        new Promise(r => {
            this.hasAnimated = !0,
            this.animation = e(r),
            this.events.animationStart && this.events.animationStart.notify()
        }
        ).then( () => {
            this.events.animationComplete && this.events.animationComplete.notify(),
            this.clearAnimation()
        }
        )
    }
    stop() {
        this.animation && (this.animation.stop(),
        this.events.animationCancel && this.events.animationCancel.notify()),
        this.clearAnimation()
    }
    isAnimating() {
        return !!this.animation
    }
    clearAnimation() {
        delete this.animation
    }
    destroy() {
        this.clearListeners(),
        this.stop(),
        this.stopPassiveEffect && this.stopPassiveEffect()
    }
}
function Bn(i, e) {
    return new Sk(i,e)
}
function Tk(i, e, r) {
    i.hasValue(e) ? i.getValue(e).set(r) : i.addValue(e, Bn(r))
}
function jk(i, e) {
    const r = _s(i, e);
    let {transitionEnd: a={}, transition: o={}, ...l} = r || {};
    l = {
        ...l,
        ...a
    };
    for (const u in l) {
        const d = R1(l[u]);
        Tk(i, u, d)
    }
}
function Ck(i) {
    return !!(it(i) && i.add)
}
function yc(i, e) {
    const r = i.getValue("willChange");
    if (Ck(r))
        return r.add(e)
}
function og(i) {
    return i.props[Of]
}
const lg = (i, e, r) => (((1 - 3 * r + 3 * e) * i + (3 * r - 6 * e)) * i + 3 * e) * i
  , zk = 1e-7
  , Ak = 12;
function Ek(i, e, r, a, o) {
    let l, u, d = 0;
    do
        u = e + (r - e) / 2,
        l = lg(u, a, o) - i,
        l > 0 ? r = u : e = u;
    while (Math.abs(l) > zk && ++d < Ak);
    return u
}
function Hn(i, e, r, a) {
    if (i === e && r === a)
        return kt;
    const o = l => Ek(l, 0, 1, i, r);
    return l => l === 0 || l === 1 ? l : lg(o(l), e, a)
}
const cg = i => e => e <= .5 ? i(2 * e) / 2 : (2 - i(2 * (1 - e))) / 2
  , ug = i => e => 1 - i(1 - e)
  , dg = Hn(.33, 1.53, .69, .99)
  , cu = ug(dg)
  , pg = cg(cu)
  , mg = i => (i *= 2) < 1 ? .5 * cu(i) : .5 * (2 - Math.pow(2, -10 * (i - 1)))
  , uu = i => 1 - Math.sin(Math.acos(i))
  , hg = ug(uu)
  , fg = cg(uu)
  , gg = i => /^0[^.\s]+$/u.test(i);
function Dk(i) {
    return typeof i == "number" ? i === 0 : i !== null ? i === "none" || i === "0" || gg(i) : !0
}
const In = i => Math.round(i * 1e5) / 1e5
  , du = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
function Ik(i) {
    return i == null
}
const Mk = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu
  , pu = (i, e) => r => !!(typeof r == "string" && Mk.test(r) && r.startsWith(i) || e && !Ik(r) && Object.prototype.hasOwnProperty.call(r, e))
  , vg = (i, e, r) => a => {
    if (typeof a != "string")
        return a;
    const [o,l,u,d] = a.match(du);
    return {
        [i]: parseFloat(o),
        [e]: parseFloat(l),
        [r]: parseFloat(u),
        alpha: d !== void 0 ? parseFloat(d) : 1
    }
}
  , Vk = i => ni(0, 255, i)
  , Hl = {
    ...Fr,
    transform: i => Math.round(Vk(i))
}
  , Gi = {
    test: pu("rgb", "red"),
    parse: vg("red", "green", "blue"),
    transform: ({red: i, green: e, blue: r, alpha: a=1}) => "rgba(" + Hl.transform(i) + ", " + Hl.transform(e) + ", " + Hl.transform(r) + ", " + In(Rn.transform(a)) + ")"
};
function Lk(i) {
    let e = ""
      , r = ""
      , a = ""
      , o = "";
    return i.length > 5 ? (e = i.substring(1, 3),
    r = i.substring(3, 5),
    a = i.substring(5, 7),
    o = i.substring(7, 9)) : (e = i.substring(1, 2),
    r = i.substring(2, 3),
    a = i.substring(3, 4),
    o = i.substring(4, 5),
    e += e,
    r += r,
    a += a,
    o += o),
    {
        red: parseInt(e, 16),
        green: parseInt(r, 16),
        blue: parseInt(a, 16),
        alpha: o ? parseInt(o, 16) / 255 : 1
    }
}
const kc = {
    test: pu("#"),
    parse: Lk,
    transform: Gi.transform
}
  , Ar = {
    test: pu("hsl", "hue"),
    parse: vg("hue", "saturation", "lightness"),
    transform: ({hue: i, saturation: e, lightness: r, alpha: a=1}) => "hsla(" + Math.round(i) + ", " + Kt.transform(In(e)) + ", " + Kt.transform(In(r)) + ", " + In(Rn.transform(a)) + ")"
}
  , tt = {
    test: i => Gi.test(i) || kc.test(i) || Ar.test(i),
    parse: i => Gi.test(i) ? Gi.parse(i) : Ar.test(i) ? Ar.parse(i) : kc.parse(i),
    transform: i => typeof i == "string" ? i : i.hasOwnProperty("red") ? Gi.transform(i) : Ar.transform(i)
}
  , Ok = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
function Nk(i) {
    var e, r;
    return isNaN(i) && typeof i == "string" && (((e = i.match(du)) === null || e === void 0 ? void 0 : e.length) || 0) + (((r = i.match(Ok)) === null || r === void 0 ? void 0 : r.length) || 0) > 0
}
const yg = "number"
  , kg = "color"
  , Fk = "var"
  , Rk = "var("
  , Bm = "${}"
  , Bk = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function Wn(i) {
    const e = i.toString()
      , r = []
      , a = {
        color: [],
        number: [],
        var: []
    }
      , o = [];
    let l = 0;
    const d = e.replace(Bk, p => (tt.test(p) ? (a.color.push(l),
    o.push(kg),
    r.push(tt.parse(p))) : p.startsWith(Rk) ? (a.var.push(l),
    o.push(Fk),
    r.push(p)) : (a.number.push(l),
    o.push(yg),
    r.push(parseFloat(p))),
    ++l,
    Bm)).split(Bm);
    return {
        values: r,
        split: d,
        indexes: a,
        types: o
    }
}
function xg(i) {
    return Wn(i).values
}
function wg(i) {
    const {split: e, types: r} = Wn(i)
      , a = e.length;
    return o => {
        let l = "";
        for (let u = 0; u < a; u++)
            if (l += e[u],
            o[u] !== void 0) {
                const d = r[u];
                d === yg ? l += In(o[u]) : d === kg ? l += tt.transform(o[u]) : l += o[u]
            }
        return l
    }
}
const Wk = i => typeof i == "number" ? 0 : i;
function _k(i) {
    const e = xg(i);
    return wg(i)(e.map(Wk))
}
const Ai = {
    test: Nk,
    parse: xg,
    createTransformer: wg,
    getAnimatableNone: _k
}
  , Uk = new Set(["brightness", "contrast", "saturate", "opacity"]);
function Kk(i) {
    const [e,r] = i.slice(0, -1).split("(");
    if (e === "drop-shadow")
        return i;
    const [a] = r.match(du) || [];
    if (!a)
        return i;
    const o = r.replace(a, "");
    let l = Uk.has(e) ? 1 : 0;
    return a !== r && (l *= 100),
    e + "(" + l + o + ")"
}
const $k = /\b([a-z-]*)\(.*?\)/gu
  , xc = {
    ...Ai,
    getAnimatableNone: i => {
        const e = i.match($k);
        return e ? e.map(Kk).join(" ") : i
    }
}
  , Hk = {
    ...Zc,
    color: tt,
    backgroundColor: tt,
    outlineColor: tt,
    fill: tt,
    stroke: tt,
    borderColor: tt,
    borderTopColor: tt,
    borderRightColor: tt,
    borderBottomColor: tt,
    borderLeftColor: tt,
    filter: xc,
    WebkitFilter: xc
}
  , mu = i => Hk[i];
function Pg(i, e) {
    let r = mu(i);
    return r !== xc && (r = Ai),
    r.getAnimatableNone ? r.getAnimatableNone(e) : void 0
}
const Gk = new Set(["auto", "none", "0"]);
function qk(i, e, r) {
    let a = 0, o;
    for (; a < i.length && !o; ) {
        const l = i[a];
        typeof l == "string" && !Gk.has(l) && Wn(l).values.length && (o = i[a]),
        a++
    }
    if (o && r)
        for (const l of e)
            i[l] = Pg(r, o)
}
const Wm = i => i === Fr || i === de
  , _m = (i, e) => parseFloat(i.split(", ")[e])
  , Um = (i, e) => (r, {transform: a}) => {
    if (a === "none" || !a)
        return 0;
    const o = a.match(/^matrix3d\((.+)\)$/u);
    if (o)
        return _m(o[1], e);
    {
        const l = a.match(/^matrix\((.+)\)$/u);
        return l ? _m(l[1], i) : 0
    }
}
  , Xk = new Set(["x", "y", "z"])
  , Zk = Nr.filter(i => !Xk.has(i));
function Yk(i) {
    const e = [];
    return Zk.forEach(r => {
        const a = i.getValue(r);
        a !== void 0 && (e.push([r, a.get()]),
        a.set(r.startsWith("scale") ? 1 : 0))
    }
    ),
    e
}
const Or = {
    width: ({x: i}, {paddingLeft: e="0", paddingRight: r="0"}) => i.max - i.min - parseFloat(e) - parseFloat(r),
    height: ({y: i}, {paddingTop: e="0", paddingBottom: r="0"}) => i.max - i.min - parseFloat(e) - parseFloat(r),
    top: (i, {top: e}) => parseFloat(e),
    left: (i, {left: e}) => parseFloat(e),
    bottom: ({y: i}, {top: e}) => parseFloat(e) + (i.max - i.min),
    right: ({x: i}, {left: e}) => parseFloat(e) + (i.max - i.min),
    x: Um(4, 13),
    y: Um(5, 14)
};
Or.translateX = Or.x;
Or.translateY = Or.y;
const Xi = new Set;
let wc = !1
  , Pc = !1;
function bg() {
    if (Pc) {
        const i = Array.from(Xi).filter(a => a.needsMeasurement)
          , e = new Set(i.map(a => a.element))
          , r = new Map;
        e.forEach(a => {
            const o = Yk(a);
            o.length && (r.set(a, o),
            a.render())
        }
        ),
        i.forEach(a => a.measureInitialState()),
        e.forEach(a => {
            a.render();
            const o = r.get(a);
            o && o.forEach( ([l,u]) => {
                var d;
                (d = a.getValue(l)) === null || d === void 0 || d.set(u)
            }
            )
        }
        ),
        i.forEach(a => a.measureEndState()),
        i.forEach(a => {
            a.suspendedScrollY !== void 0 && window.scrollTo(0, a.suspendedScrollY)
        }
        )
    }
    Pc = !1,
    wc = !1,
    Xi.forEach(i => i.complete()),
    Xi.clear()
}
function Sg() {
    Xi.forEach(i => {
        i.readKeyframes(),
        i.needsMeasurement && (Pc = !0)
    }
    )
}
function Qk() {
    Sg(),
    bg()
}
class hu {
    constructor(e, r, a, o, l, u=!1) {
        this.isComplete = !1,
        this.isAsync = !1,
        this.needsMeasurement = !1,
        this.isScheduled = !1,
        this.unresolvedKeyframes = [...e],
        this.onComplete = r,
        this.name = a,
        this.motionValue = o,
        this.element = l,
        this.isAsync = u
    }
    scheduleResolve() {
        this.isScheduled = !0,
        this.isAsync ? (Xi.add(this),
        wc || (wc = !0,
        ze.read(Sg),
        ze.resolveKeyframes(bg))) : (this.readKeyframes(),
        this.complete())
    }
    readKeyframes() {
        const {unresolvedKeyframes: e, name: r, element: a, motionValue: o} = this;
        for (let l = 0; l < e.length; l++)
            if (e[l] === null)
                if (l === 0) {
                    const u = o == null ? void 0 : o.get()
                      , d = e[e.length - 1];
                    if (u !== void 0)
                        e[0] = u;
                    else if (a && r) {
                        const p = a.readValue(r, d);
                        p != null && (e[0] = p)
                    }
                    e[0] === void 0 && (e[0] = d),
                    o && u === void 0 && o.set(e[0])
                } else
                    e[l] = e[l - 1]
    }
    setFinalKeyframe() {}
    measureInitialState() {}
    renderEndStyles() {}
    measureEndState() {}
    complete() {
        this.isComplete = !0,
        this.onComplete(this.unresolvedKeyframes, this.finalKeyframe),
        Xi.delete(this)
    }
    cancel() {
        this.isComplete || (this.isScheduled = !1,
        Xi.delete(this))
    }
    resume() {
        this.isComplete || this.scheduleResolve()
    }
}
const Tg = i => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(i)
  , Jk = /^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u;
function ex(i) {
    const e = Jk.exec(i);
    if (!e)
        return [, ];
    const [,r,a,o] = e;
    return [`--${r ?? a}`, o]
}
function jg(i, e, r=1) {
    const [a,o] = ex(i);
    if (!a)
        return;
    const l = window.getComputedStyle(e).getPropertyValue(a);
    if (l) {
        const u = l.trim();
        return Tg(u) ? parseFloat(u) : u
    }
    return Xc(o) ? jg(o, e, r + 1) : o
}
const Cg = i => e => e.test(i)
  , tx = {
    test: i => i === "auto",
    parse: i => i
}
  , zg = [Fr, de, Kt, Si, $1, K1, tx]
  , Km = i => zg.find(Cg(i));
class Ag extends hu {
    constructor(e, r, a, o, l) {
        super(e, r, a, o, l, !0)
    }
    readKeyframes() {
        const {unresolvedKeyframes: e, element: r, name: a} = this;
        if (!r || !r.current)
            return;
        super.readKeyframes();
        for (let p = 0; p < e.length; p++) {
            let h = e[p];
            if (typeof h == "string" && (h = h.trim(),
            Xc(h))) {
                const g = jg(h, r.current);
                g !== void 0 && (e[p] = g),
                p === e.length - 1 && (this.finalKeyframe = h)
            }
        }
        if (this.resolveNoneKeyframes(),
        !ag.has(a) || e.length !== 2)
            return;
        const [o,l] = e
          , u = Km(o)
          , d = Km(l);
        if (u !== d)
            if (Wm(u) && Wm(d))
                for (let p = 0; p < e.length; p++) {
                    const h = e[p];
                    typeof h == "string" && (e[p] = parseFloat(h))
                }
            else
                this.needsMeasurement = !0
    }
    resolveNoneKeyframes() {
        const {unresolvedKeyframes: e, name: r} = this
          , a = [];
        for (let o = 0; o < e.length; o++)
            Dk(e[o]) && a.push(o);
        a.length && qk(e, a, r)
    }
    measureInitialState() {
        const {element: e, unresolvedKeyframes: r, name: a} = this;
        if (!e || !e.current)
            return;
        a === "height" && (this.suspendedScrollY = window.pageYOffset),
        this.measuredOrigin = Or[a](e.measureViewportBox(), window.getComputedStyle(e.current)),
        r[0] = this.measuredOrigin;
        const o = r[r.length - 1];
        o !== void 0 && e.getValue(a, o).jump(o, !1)
    }
    measureEndState() {
        var e;
        const {element: r, name: a, unresolvedKeyframes: o} = this;
        if (!r || !r.current)
            return;
        const l = r.getValue(a);
        l && l.jump(this.measuredOrigin, !1);
        const u = o.length - 1
          , d = o[u];
        o[u] = Or[a](r.measureViewportBox(), window.getComputedStyle(r.current)),
        d !== null && this.finalKeyframe === void 0 && (this.finalKeyframe = d),
        !((e = this.removedTransforms) === null || e === void 0) && e.length && this.removedTransforms.forEach( ([p,h]) => {
            r.getValue(p).set(h)
        }
        ),
        this.resolveNoneKeyframes()
    }
}
const $m = (i, e) => e === "zIndex" ? !1 : !!(typeof i == "number" || Array.isArray(i) || typeof i == "string" && (Ai.test(i) || i === "0") && !i.startsWith("url("));
function ix(i) {
    const e = i[0];
    if (i.length === 1)
        return !0;
    for (let r = 0; r < i.length; r++)
        if (i[r] !== e)
            return !0
}
function rx(i, e, r, a) {
    const o = i[0];
    if (o === null)
        return !1;
    if (e === "display" || e === "visibility")
        return !0;
    const l = i[i.length - 1]
      , u = $m(o, e)
      , d = $m(l, e);
    return !u || !d ? !1 : ix(i) || (r === "spring" || ru(r)) && a
}
const nx = i => i !== null;
function Us(i, {repeat: e, repeatType: r="loop"}, a) {
    const o = i.filter(nx)
      , l = e && r !== "loop" && e % 2 === 1 ? 0 : o.length - 1;
    return !l || a === void 0 ? o[l] : a
}
const ax = 40;
class Eg {
    constructor({autoplay: e=!0, delay: r=0, type: a="keyframes", repeat: o=0, repeatDelay: l=0, repeatType: u="loop", ...d}) {
        this.isStopped = !1,
        this.hasAttemptedResolve = !1,
        this.createdAt = $t.now(),
        this.options = {
            autoplay: e,
            delay: r,
            type: a,
            repeat: o,
            repeatDelay: l,
            repeatType: u,
            ...d
        },
        this.updateFinishedPromise()
    }
    calcStartTime() {
        return this.resolvedAt ? this.resolvedAt - this.createdAt > ax ? this.resolvedAt : this.createdAt : this.createdAt
    }
    get resolved() {
        return !this._resolved && !this.hasAttemptedResolve && Qk(),
        this._resolved
    }
    onKeyframesResolved(e, r) {
        this.resolvedAt = $t.now(),
        this.hasAttemptedResolve = !0;
        const {name: a, type: o, velocity: l, delay: u, onComplete: d, onUpdate: p, isGenerator: h} = this.options;
        if (!h && !rx(e, a, o, l))
            if (u)
                this.options.duration = 0;
            else {
                p && p(Us(e, this.options, r)),
                d && d(),
                this.resolveFinishedPromise();
                return
            }
        const g = this.initPlayback(e, r);
        g !== !1 && (this._resolved = {
            keyframes: e,
            finalKeyframe: r,
            ...g
        },
        this.onPostResolved())
    }
    onPostResolved() {}
    then(e, r) {
        return this.currentFinishedPromise.then(e, r)
    }
    flatten() {
        this.options.type = "keyframes",
        this.options.ease = "linear"
    }
    updateFinishedPromise() {
        this.currentFinishedPromise = new Promise(e => {
            this.resolveFinishedPromise = e
        }
        )
    }
}
const Ve = (i, e, r) => i + (e - i) * r;
function Gl(i, e, r) {
    return r < 0 && (r += 1),
    r > 1 && (r -= 1),
    r < 1 / 6 ? i + (e - i) * 6 * r : r < 1 / 2 ? e : r < 2 / 3 ? i + (e - i) * (2 / 3 - r) * 6 : i
}
function sx({hue: i, saturation: e, lightness: r, alpha: a}) {
    i /= 360,
    e /= 100,
    r /= 100;
    let o = 0
      , l = 0
      , u = 0;
    if (!e)
        o = l = u = r;
    else {
        const d = r < .5 ? r * (1 + e) : r + e - r * e
          , p = 2 * r - d;
        o = Gl(p, d, i + 1 / 3),
        l = Gl(p, d, i),
        u = Gl(p, d, i - 1 / 3)
    }
    return {
        red: Math.round(o * 255),
        green: Math.round(l * 255),
        blue: Math.round(u * 255),
        alpha: a
    }
}
function Ss(i, e) {
    return r => r > 0 ? e : i
}
const ql = (i, e, r) => {
    const a = i * i
      , o = r * (e * e - a) + a;
    return o < 0 ? 0 : Math.sqrt(o)
}
  , ox = [kc, Gi, Ar]
  , lx = i => ox.find(e => e.test(i));
function Hm(i) {
    const e = lx(i);
    if (!e)
        return !1;
    let r = e.parse(i);
    return e === Ar && (r = sx(r)),
    r
}
const Gm = (i, e) => {
    const r = Hm(i)
      , a = Hm(e);
    if (!r || !a)
        return Ss(i, e);
    const o = {
        ...r
    };
    return l => (o.red = ql(r.red, a.red, l),
    o.green = ql(r.green, a.green, l),
    o.blue = ql(r.blue, a.blue, l),
    o.alpha = Ve(r.alpha, a.alpha, l),
    Gi.transform(o))
}
  , cx = (i, e) => r => e(i(r))
  , Gn = (...i) => i.reduce(cx)
  , bc = new Set(["none", "hidden"]);
function ux(i, e) {
    return bc.has(i) ? r => r <= 0 ? i : e : r => r >= 1 ? e : i
}
function dx(i, e) {
    return r => Ve(i, e, r)
}
function fu(i) {
    return typeof i == "number" ? dx : typeof i == "string" ? Xc(i) ? Ss : tt.test(i) ? Gm : hx : Array.isArray(i) ? Dg : typeof i == "object" ? tt.test(i) ? Gm : px : Ss
}
function Dg(i, e) {
    const r = [...i]
      , a = r.length
      , o = i.map( (l, u) => fu(l)(l, e[u]));
    return l => {
        for (let u = 0; u < a; u++)
            r[u] = o[u](l);
        return r
    }
}
function px(i, e) {
    const r = {
        ...i,
        ...e
    }
      , a = {};
    for (const o in r)
        i[o] !== void 0 && e[o] !== void 0 && (a[o] = fu(i[o])(i[o], e[o]));
    return o => {
        for (const l in a)
            r[l] = a[l](o);
        return r
    }
}
function mx(i, e) {
    var r;
    const a = []
      , o = {
        color: 0,
        var: 0,
        number: 0
    };
    for (let l = 0; l < e.values.length; l++) {
        const u = e.types[l]
          , d = i.indexes[u][o[u]]
          , p = (r = i.values[d]) !== null && r !== void 0 ? r : 0;
        a[l] = p,
        o[u]++
    }
    return a
}
const hx = (i, e) => {
    const r = Ai.createTransformer(e)
      , a = Wn(i)
      , o = Wn(e);
    return a.indexes.var.length === o.indexes.var.length && a.indexes.color.length === o.indexes.color.length && a.indexes.number.length >= o.indexes.number.length ? bc.has(i) && !o.values.length || bc.has(e) && !a.values.length ? ux(i, e) : Gn(Dg(mx(a, o), o.values), r) : Ss(i, e)
}
;
function Ig(i, e, r) {
    return typeof i == "number" && typeof e == "number" && typeof r == "number" ? Ve(i, e, r) : fu(i)(i, e)
}
const fx = 5;
function Mg(i, e, r) {
    const a = Math.max(e - fx, 0);
    return sg(r - i(a), e - a)
}
const Oe = {
    stiffness: 100,
    damping: 10,
    mass: 1,
    velocity: 0,
    duration: 800,
    bounce: .3,
    visualDuration: .3,
    restSpeed: {
        granular: .01,
        default: 2
    },
    restDelta: {
        granular: .005,
        default: .5
    },
    minDuration: .01,
    maxDuration: 10,
    minDamping: .05,
    maxDamping: 1
}
  , Xl = .001;
function gx({duration: i=Oe.duration, bounce: e=Oe.bounce, velocity: r=Oe.velocity, mass: a=Oe.mass}) {
    let o, l, u = 1 - e;
    u = ni(Oe.minDamping, Oe.maxDamping, u),
    i = ni(Oe.minDuration, Oe.maxDuration, ri(i)),
    u < 1 ? (o = h => {
        const g = h * u
          , v = g * i
          , y = g - r
          , P = Sc(h, u)
          , w = Math.exp(-v);
        return Xl - y / P * w
    }
    ,
    l = h => {
        const v = h * u * i
          , y = v * r + r
          , P = Math.pow(u, 2) * Math.pow(h, 2) * i
          , w = Math.exp(-v)
          , S = Sc(Math.pow(h, 2), u);
        return (-o(h) + Xl > 0 ? -1 : 1) * ((y - P) * w) / S
    }
    ) : (o = h => {
        const g = Math.exp(-h * i)
          , v = (h - r) * i + 1;
        return -Xl + g * v
    }
    ,
    l = h => {
        const g = Math.exp(-h * i)
          , v = (r - h) * (i * i);
        return g * v
    }
    );
    const d = 5 / i
      , p = yx(o, l, d);
    if (i = ii(i),
    isNaN(p))
        return {
            stiffness: Oe.stiffness,
            damping: Oe.damping,
            duration: i
        };
    {
        const h = Math.pow(p, 2) * a;
        return {
            stiffness: h,
            damping: u * 2 * Math.sqrt(a * h),
            duration: i
        }
    }
}
const vx = 12;
function yx(i, e, r) {
    let a = r;
    for (let o = 1; o < vx; o++)
        a = a - i(a) / e(a);
    return a
}
function Sc(i, e) {
    return i * Math.sqrt(1 - e * e)
}
const kx = ["duration", "bounce"]
  , xx = ["stiffness", "damping", "mass"];
function qm(i, e) {
    return e.some(r => i[r] !== void 0)
}
function wx(i) {
    let e = {
        velocity: Oe.velocity,
        stiffness: Oe.stiffness,
        damping: Oe.damping,
        mass: Oe.mass,
        isResolvedFromDuration: !1,
        ...i
    };
    if (!qm(i, xx) && qm(i, kx))
        if (i.visualDuration) {
            const r = i.visualDuration
              , a = 2 * Math.PI / (r * 1.2)
              , o = a * a
              , l = 2 * ni(.05, 1, 1 - (i.bounce || 0)) * Math.sqrt(o);
            e = {
                ...e,
                mass: Oe.mass,
                stiffness: o,
                damping: l
            }
        } else {
            const r = gx(i);
            e = {
                ...e,
                ...r,
                mass: Oe.mass
            },
            e.isResolvedFromDuration = !0
        }
    return e
}
function Vg(i=Oe.visualDuration, e=Oe.bounce) {
    const r = typeof i != "object" ? {
        visualDuration: i,
        keyframes: [0, 1],
        bounce: e
    } : i;
    let {restSpeed: a, restDelta: o} = r;
    const l = r.keyframes[0]
      , u = r.keyframes[r.keyframes.length - 1]
      , d = {
        done: !1,
        value: l
    }
      , {stiffness: p, damping: h, mass: g, duration: v, velocity: y, isResolvedFromDuration: P} = wx({
        ...r,
        velocity: -ri(r.velocity || 0)
    })
      , w = y || 0
      , S = h / (2 * Math.sqrt(p * g))
      , z = u - l
      , C = ri(Math.sqrt(p / g))
      , b = Math.abs(z) < 5;
    a || (a = b ? Oe.restSpeed.granular : Oe.restSpeed.default),
    o || (o = b ? Oe.restDelta.granular : Oe.restDelta.default);
    let T;
    if (S < 1) {
        const M = Sc(C, S);
        T = B => {
            const _ = Math.exp(-S * C * B);
            return u - _ * ((w + S * C * z) / M * Math.sin(M * B) + z * Math.cos(M * B))
        }
    } else if (S === 1)
        T = M => u - Math.exp(-C * M) * (z + (w + C * z) * M);
    else {
        const M = C * Math.sqrt(S * S - 1);
        T = B => {
            const _ = Math.exp(-S * C * B)
              , F = Math.min(M * B, 300);
            return u - _ * ((w + S * C * z) * Math.sinh(F) + M * z * Math.cosh(F)) / M
        }
    }
    const D = {
        calculatedDuration: P && v || null,
        next: M => {
            const B = T(M);
            if (P)
                d.done = M >= v;
            else {
                let _ = 0;
                S < 1 && (_ = M === 0 ? ii(w) : Mg(T, M, B));
                const F = Math.abs(_) <= a
                  , R = Math.abs(u - B) <= o;
                d.done = F && R
            }
            return d.value = d.done ? u : B,
            d
        }
        ,
        toString: () => {
            const M = Math.min(Yf(D), gc)
              , B = Qf(_ => D.next(M * _).value, M, 30);
            return M + "ms " + B
        }
    };
    return D
}
function Xm({keyframes: i, velocity: e=0, power: r=.8, timeConstant: a=325, bounceDamping: o=10, bounceStiffness: l=500, modifyTarget: u, min: d, max: p, restDelta: h=.5, restSpeed: g}) {
    const v = i[0]
      , y = {
        done: !1,
        value: v
    }
      , P = F => d !== void 0 && F < d || p !== void 0 && F > p
      , w = F => d === void 0 ? p : p === void 0 || Math.abs(d - F) < Math.abs(p - F) ? d : p;
    let S = r * e;
    const z = v + S
      , C = u === void 0 ? z : u(z);
    C !== z && (S = C - v);
    const b = F => -S * Math.exp(-F / a)
      , T = F => C + b(F)
      , D = F => {
        const R = b(F)
          , W = T(F);
        y.done = Math.abs(R) <= h,
        y.value = y.done ? C : W
    }
    ;
    let M, B;
    const _ = F => {
        P(y.value) && (M = F,
        B = Vg({
            keyframes: [y.value, w(y.value)],
            velocity: Mg(T, F, y.value),
            damping: o,
            stiffness: l,
            restDelta: h,
            restSpeed: g
        }))
    }
    ;
    return _(0),
    {
        calculatedDuration: null,
        next: F => {
            let R = !1;
            return !B && M === void 0 && (R = !0,
            D(F),
            _(F)),
            M !== void 0 && F >= M ? B.next(F - M) : (!R && D(F),
            y)
        }
    }
}
const Px = Hn(.42, 0, 1, 1)
  , bx = Hn(0, 0, .58, 1)
  , Lg = Hn(.42, 0, .58, 1)
  , Sx = i => Array.isArray(i) && typeof i[0] != "number"
  , Tx = {
    linear: kt,
    easeIn: Px,
    easeInOut: Lg,
    easeOut: bx,
    circIn: uu,
    circInOut: fg,
    circOut: hg,
    backIn: cu,
    backInOut: pg,
    backOut: dg,
    anticipate: mg
}
  , Zm = i => {
    if (nu(i)) {
        Df(i.length === 4);
        const [e,r,a,o] = i;
        return Hn(e, r, a, o)
    } else if (typeof i == "string")
        return Tx[i];
    return i
}
;
function jx(i, e, r) {
    const a = []
      , o = r || Ig
      , l = i.length - 1;
    for (let u = 0; u < l; u++) {
        let d = o(i[u], i[u + 1]);
        if (e) {
            const p = Array.isArray(e) ? e[u] || kt : e;
            d = Gn(p, d)
        }
        a.push(d)
    }
    return a
}
function Cx(i, e, {clamp: r=!0, ease: a, mixer: o}={}) {
    const l = i.length;
    if (Df(l === e.length),
    l === 1)
        return () => e[0];
    if (l === 2 && e[0] === e[1])
        return () => e[1];
    const u = i[0] === i[1];
    i[0] > i[l - 1] && (i = [...i].reverse(),
    e = [...e].reverse());
    const d = jx(e, a, o)
      , p = d.length
      , h = g => {
        if (u && g < i[0])
            return e[0];
        let v = 0;
        if (p > 1)
            for (; v < i.length - 2 && !(g < i[v + 1]); v++)
                ;
        const y = Vr(i[v], i[v + 1], g);
        return d[v](y)
    }
    ;
    return r ? g => h(ni(i[0], i[l - 1], g)) : h
}
function zx(i, e) {
    const r = i[i.length - 1];
    for (let a = 1; a <= e; a++) {
        const o = Vr(0, e, a);
        i.push(Ve(r, 1, o))
    }
}
function Ax(i) {
    const e = [0];
    return zx(e, i.length - 1),
    e
}
function Ex(i, e) {
    return i.map(r => r * e)
}
function Dx(i, e) {
    return i.map( () => e || Lg).splice(0, i.length - 1)
}
function Ts({duration: i=300, keyframes: e, times: r, ease: a="easeInOut"}) {
    const o = Sx(a) ? a.map(Zm) : Zm(a)
      , l = {
        done: !1,
        value: e[0]
    }
      , u = Ex(r && r.length === e.length ? r : Ax(e), i)
      , d = Cx(u, e, {
        ease: Array.isArray(o) ? o : Dx(e, o)
    });
    return {
        calculatedDuration: i,
        next: p => (l.value = d(p),
        l.done = p >= i,
        l)
    }
}
const Ix = i => {
    const e = ({timestamp: r}) => i(r);
    return {
        start: () => ze.update(e, !0),
        stop: () => zi(e),
        now: () => Ze.isProcessing ? Ze.timestamp : $t.now()
    }
}
  , Mx = {
    decay: Xm,
    inertia: Xm,
    tween: Ts,
    keyframes: Ts,
    spring: Vg
}
  , Vx = i => i / 100;
class gu extends Eg {
    constructor(e) {
        super(e),
        this.holdTime = null,
        this.cancelTime = null,
        this.currentTime = 0,
        this.playbackSpeed = 1,
        this.pendingPlayState = "running",
        this.startTime = null,
        this.state = "idle",
        this.stop = () => {
            if (this.resolver.cancel(),
            this.isStopped = !0,
            this.state === "idle")
                return;
            this.teardown();
            const {onStop: p} = this.options;
            p && p()
        }
        ;
        const {name: r, motionValue: a, element: o, keyframes: l} = this.options
          , u = (o == null ? void 0 : o.KeyframeResolver) || hu
          , d = (p, h) => this.onKeyframesResolved(p, h);
        this.resolver = new u(l,d,r,a,o),
        this.resolver.scheduleResolve()
    }
    flatten() {
        super.flatten(),
        this._resolved && Object.assign(this._resolved, this.initPlayback(this._resolved.keyframes))
    }
    initPlayback(e) {
        const {type: r="keyframes", repeat: a=0, repeatDelay: o=0, repeatType: l, velocity: u=0} = this.options
          , d = ru(r) ? r : Mx[r] || Ts;
        let p, h;
        d !== Ts && typeof e[0] != "number" && (p = Gn(Vx, Ig(e[0], e[1])),
        e = [0, 100]);
        const g = d({
            ...this.options,
            keyframes: e
        });
        l === "mirror" && (h = d({
            ...this.options,
            keyframes: [...e].reverse(),
            velocity: -u
        })),
        g.calculatedDuration === null && (g.calculatedDuration = Yf(g));
        const {calculatedDuration: v} = g
          , y = v + o
          , P = y * (a + 1) - o;
        return {
            generator: g,
            mirroredGenerator: h,
            mapPercentToKeyframes: p,
            calculatedDuration: v,
            resolvedDuration: y,
            totalDuration: P
        }
    }
    onPostResolved() {
        const {autoplay: e=!0} = this.options;
        this.play(),
        this.pendingPlayState === "paused" || !e ? this.pause() : this.state = this.pendingPlayState
    }
    tick(e, r=!1) {
        const {resolved: a} = this;
        if (!a) {
            const {keyframes: F} = this.options;
            return {
                done: !0,
                value: F[F.length - 1]
            }
        }
        const {finalKeyframe: o, generator: l, mirroredGenerator: u, mapPercentToKeyframes: d, keyframes: p, calculatedDuration: h, totalDuration: g, resolvedDuration: v} = a;
        if (this.startTime === null)
            return l.next(0);
        const {delay: y, repeat: P, repeatType: w, repeatDelay: S, onUpdate: z} = this.options;
        this.speed > 0 ? this.startTime = Math.min(this.startTime, e) : this.speed < 0 && (this.startTime = Math.min(e - g / this.speed, this.startTime)),
        r ? this.currentTime = e : this.holdTime !== null ? this.currentTime = this.holdTime : this.currentTime = Math.round(e - this.startTime) * this.speed;
        const C = this.currentTime - y * (this.speed >= 0 ? 1 : -1)
          , b = this.speed >= 0 ? C < 0 : C > g;
        this.currentTime = Math.max(C, 0),
        this.state === "finished" && this.holdTime === null && (this.currentTime = g);
        let T = this.currentTime
          , D = l;
        if (P) {
            const F = Math.min(this.currentTime, g) / v;
            let R = Math.floor(F)
              , W = F % 1;
            !W && F >= 1 && (W = 1),
            W === 1 && R--,
            R = Math.min(R, P + 1),
            !!(R % 2) && (w === "reverse" ? (W = 1 - W,
            S && (W -= S / v)) : w === "mirror" && (D = u)),
            T = ni(0, 1, W) * v
        }
        const M = b ? {
            done: !1,
            value: p[0]
        } : D.next(T);
        d && (M.value = d(M.value));
        let {done: B} = M;
        !b && h !== null && (B = this.speed >= 0 ? this.currentTime >= g : this.currentTime <= 0);
        const _ = this.holdTime === null && (this.state === "finished" || this.state === "running" && B);
        return _ && o !== void 0 && (M.value = Us(p, this.options, o)),
        z && z(M.value),
        _ && this.finish(),
        M
    }
    get duration() {
        const {resolved: e} = this;
        return e ? ri(e.calculatedDuration) : 0
    }
    get time() {
        return ri(this.currentTime)
    }
    set time(e) {
        e = ii(e),
        this.currentTime = e,
        this.holdTime !== null || this.speed === 0 ? this.holdTime = e : this.driver && (this.startTime = this.driver.now() - e / this.speed)
    }
    get speed() {
        return this.playbackSpeed
    }
    set speed(e) {
        const r = this.playbackSpeed !== e;
        this.playbackSpeed = e,
        r && (this.time = ri(this.currentTime))
    }
    play() {
        if (this.resolver.isScheduled || this.resolver.resume(),
        !this._resolved) {
            this.pendingPlayState = "running";
            return
        }
        if (this.isStopped)
            return;
        const {driver: e=Ix, onPlay: r, startTime: a} = this.options;
        this.driver || (this.driver = e(l => this.tick(l))),
        r && r();
        const o = this.driver.now();
        this.holdTime !== null ? this.startTime = o - this.holdTime : this.startTime ? this.state === "finished" && (this.startTime = o) : this.startTime = a ?? this.calcStartTime(),
        this.state === "finished" && this.updateFinishedPromise(),
        this.cancelTime = this.startTime,
        this.holdTime = null,
        this.state = "running",
        this.driver.start()
    }
    pause() {
        var e;
        if (!this._resolved) {
            this.pendingPlayState = "paused";
            return
        }
        this.state = "paused",
        this.holdTime = (e = this.currentTime) !== null && e !== void 0 ? e : 0
    }
    complete() {
        this.state !== "running" && this.play(),
        this.pendingPlayState = this.state = "finished",
        this.holdTime = null
    }
    finish() {
        this.teardown(),
        this.state = "finished";
        const {onComplete: e} = this.options;
        e && e()
    }
    cancel() {
        this.cancelTime !== null && this.tick(this.cancelTime),
        this.teardown(),
        this.updateFinishedPromise()
    }
    teardown() {
        this.state = "idle",
        this.stopDriver(),
        this.resolveFinishedPromise(),
        this.updateFinishedPromise(),
        this.startTime = this.cancelTime = null,
        this.resolver.cancel()
    }
    stopDriver() {
        this.driver && (this.driver.stop(),
        this.driver = void 0)
    }
    sample(e) {
        return this.startTime = 0,
        this.tick(e, !0)
    }
}
const Lx = new Set(["opacity", "clipPath", "filter", "transform"]);
function Ox(i, e, r, {delay: a=0, duration: o=300, repeat: l=0, repeatType: u="loop", ease: d="easeInOut", times: p}={}) {
    const h = {
        [e]: r
    };
    p && (h.offset = p);
    const g = eg(d, o);
    return Array.isArray(g) && (h.easing = g),
    i.animate(h, {
        delay: a,
        duration: o,
        easing: Array.isArray(g) ? "linear" : g,
        fill: "both",
        iterations: l + 1,
        direction: u === "reverse" ? "alternate" : "normal"
    })
}
const Nx = _c( () => Object.hasOwnProperty.call(Element.prototype, "animate"))
  , js = 10
  , Fx = 2e4;
function Rx(i) {
    return ru(i.type) || i.type === "spring" || !Jf(i.ease)
}
function Bx(i, e) {
    const r = new gu({
        ...e,
        keyframes: i,
        repeat: 0,
        delay: 0,
        isGenerator: !0
    });
    let a = {
        done: !1,
        value: i[0]
    };
    const o = [];
    let l = 0;
    for (; !a.done && l < Fx; )
        a = r.sample(l),
        o.push(a.value),
        l += js;
    return {
        times: void 0,
        keyframes: o,
        duration: l - js,
        ease: "linear"
    }
}
const Og = {
    anticipate: mg,
    backInOut: pg,
    circInOut: fg
};
function Wx(i) {
    return i in Og
}
class Ym extends Eg {
    constructor(e) {
        super(e);
        const {name: r, motionValue: a, element: o, keyframes: l} = this.options;
        this.resolver = new Ag(l, (u, d) => this.onKeyframesResolved(u, d),r,a,o),
        this.resolver.scheduleResolve()
    }
    initPlayback(e, r) {
        let {duration: a=300, times: o, ease: l, type: u, motionValue: d, name: p, startTime: h} = this.options;
        if (!d.owner || !d.owner.current)
            return !1;
        if (typeof l == "string" && bs() && Wx(l) && (l = Og[l]),
        Rx(this.options)) {
            const {onComplete: v, onUpdate: y, motionValue: P, element: w, ...S} = this.options
              , z = Bx(e, S);
            e = z.keyframes,
            e.length === 1 && (e[1] = e[0]),
            a = z.duration,
            o = z.times,
            l = z.ease,
            u = "keyframes"
        }
        const g = Ox(d.owner.current, p, e, {
            ...this.options,
            duration: a,
            times: o,
            ease: l
        });
        return g.startTime = h ?? this.calcStartTime(),
        this.pendingTimeline ? (Lm(g, this.pendingTimeline),
        this.pendingTimeline = void 0) : g.onfinish = () => {
            const {onComplete: v} = this.options;
            d.set(Us(e, this.options, r)),
            v && v(),
            this.cancel(),
            this.resolveFinishedPromise()
        }
        ,
        {
            animation: g,
            duration: a,
            times: o,
            type: u,
            ease: l,
            keyframes: e
        }
    }
    get duration() {
        const {resolved: e} = this;
        if (!e)
            return 0;
        const {duration: r} = e;
        return ri(r)
    }
    get time() {
        const {resolved: e} = this;
        if (!e)
            return 0;
        const {animation: r} = e;
        return ri(r.currentTime || 0)
    }
    set time(e) {
        const {resolved: r} = this;
        if (!r)
            return;
        const {animation: a} = r;
        a.currentTime = ii(e)
    }
    get speed() {
        const {resolved: e} = this;
        if (!e)
            return 1;
        const {animation: r} = e;
        return r.playbackRate
    }
    set speed(e) {
        const {resolved: r} = this;
        if (!r)
            return;
        const {animation: a} = r;
        a.playbackRate = e
    }
    get state() {
        const {resolved: e} = this;
        if (!e)
            return "idle";
        const {animation: r} = e;
        return r.playState
    }
    get startTime() {
        const {resolved: e} = this;
        if (!e)
            return null;
        const {animation: r} = e;
        return r.startTime
    }
    attachTimeline(e) {
        if (!this._resolved)
            this.pendingTimeline = e;
        else {
            const {resolved: r} = this;
            if (!r)
                return kt;
            const {animation: a} = r;
            Lm(a, e)
        }
        return kt
    }
    play() {
        if (this.isStopped)
            return;
        const {resolved: e} = this;
        if (!e)
            return;
        const {animation: r} = e;
        r.playState === "finished" && this.updateFinishedPromise(),
        r.play()
    }
    pause() {
        const {resolved: e} = this;
        if (!e)
            return;
        const {animation: r} = e;
        r.pause()
    }
    stop() {
        if (this.resolver.cancel(),
        this.isStopped = !0,
        this.state === "idle")
            return;
        this.resolveFinishedPromise(),
        this.updateFinishedPromise();
        const {resolved: e} = this;
        if (!e)
            return;
        const {animation: r, keyframes: a, duration: o, type: l, ease: u, times: d} = e;
        if (r.playState === "idle" || r.playState === "finished")
            return;
        if (this.time) {
            const {motionValue: h, onUpdate: g, onComplete: v, element: y, ...P} = this.options
              , w = new gu({
                ...P,
                keyframes: a,
                duration: o,
                type: l,
                ease: u,
                times: d,
                isGenerator: !0
            })
              , S = ii(this.time);
            h.setWithVelocity(w.sample(S - js).value, w.sample(S).value, js)
        }
        const {onStop: p} = this.options;
        p && p(),
        this.cancel()
    }
    complete() {
        const {resolved: e} = this;
        e && e.animation.finish()
    }
    cancel() {
        const {resolved: e} = this;
        e && e.animation.cancel()
    }
    static supports(e) {
        const {motionValue: r, name: a, repeatDelay: o, repeatType: l, damping: u, type: d} = e;
        if (!r || !r.owner || !(r.owner.current instanceof HTMLElement))
            return !1;
        const {onUpdate: p, transformTemplate: h} = r.owner.getProps();
        return Nx() && a && Lx.has(a) && !p && !h && !o && l !== "mirror" && u !== 0 && d !== "inertia"
    }
}
const _x = {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
}
  , Ux = i => ({
    type: "spring",
    stiffness: 550,
    damping: i === 0 ? 2 * Math.sqrt(550) : 30,
    restSpeed: 10
})
  , Kx = {
    type: "keyframes",
    duration: .8
}
  , $x = {
    type: "keyframes",
    ease: [.25, .1, .35, 1],
    duration: .3
}
  , Hx = (i, {keyframes: e}) => e.length > 2 ? Kx : Yi.has(i) ? i.startsWith("scale") ? Ux(e[1]) : _x : $x;
function Gx({when: i, delay: e, delayChildren: r, staggerChildren: a, staggerDirection: o, repeat: l, repeatType: u, repeatDelay: d, from: p, elapsed: h, ...g}) {
    return !!Object.keys(g).length
}
const vu = (i, e, r, a={}, o, l) => u => {
    const d = iu(a, i) || {}
      , p = d.delay || a.delay || 0;
    let {elapsed: h=0} = a;
    h = h - ii(p);
    let g = {
        keyframes: Array.isArray(r) ? r : [null, r],
        ease: "easeOut",
        velocity: e.getVelocity(),
        ...d,
        delay: -h,
        onUpdate: y => {
            e.set(y),
            d.onUpdate && d.onUpdate(y)
        }
        ,
        onComplete: () => {
            u(),
            d.onComplete && d.onComplete()
        }
        ,
        name: i,
        motionValue: e,
        element: l ? void 0 : o
    };
    Gx(d) || (g = {
        ...g,
        ...Hx(i, g)
    }),
    g.duration && (g.duration = ii(g.duration)),
    g.repeatDelay && (g.repeatDelay = ii(g.repeatDelay)),
    g.from !== void 0 && (g.keyframes[0] = g.from);
    let v = !1;
    if ((g.type === !1 || g.duration === 0 && !g.repeatDelay) && (g.duration = 0,
    g.delay === 0 && (v = !0)),
    v && !l && e.get() !== void 0) {
        const y = Us(g.keyframes, d);
        if (y !== void 0)
            return ze.update( () => {
                g.onUpdate(y),
                g.onComplete()
            }
            ),
            new mk([])
    }
    return !l && Ym.supports(g) ? new Ym(g) : new gu(g)
}
;
function qx({protectedKeys: i, needsAnimating: e}, r) {
    const a = i.hasOwnProperty(r) && e[r] !== !0;
    return e[r] = !1,
    a
}
function Ng(i, e, {delay: r=0, transitionOverride: a, type: o}={}) {
    var l;
    let {transition: u=i.getDefaultTransition(), transitionEnd: d, ...p} = e;
    a && (u = a);
    const h = []
      , g = o && i.animationState && i.animationState.getState()[o];
    for (const v in p) {
        const y = i.getValue(v, (l = i.latestValues[v]) !== null && l !== void 0 ? l : null)
          , P = p[v];
        if (P === void 0 || g && qx(g, v))
            continue;
        const w = {
            delay: r,
            ...iu(u || {}, v)
        };
        let S = !1;
        if (window.MotionHandoffAnimation) {
            const C = og(i);
            if (C) {
                const b = window.MotionHandoffAnimation(C, v, ze);
                b !== null && (w.startTime = b,
                S = !0)
            }
        }
        yc(i, v),
        y.start(vu(v, y, P, i.shouldReduceMotion && ag.has(v) ? {
            type: !1
        } : w, i, S));
        const z = y.animation;
        z && h.push(z)
    }
    return d && Promise.all(h).then( () => {
        ze.update( () => {
            d && jk(i, d)
        }
        )
    }
    ),
    h
}
function Tc(i, e, r={}) {
    var a;
    const o = _s(i, e, r.type === "exit" ? (a = i.presenceContext) === null || a === void 0 ? void 0 : a.custom : void 0);
    let {transition: l=i.getDefaultTransition() || {}} = o || {};
    r.transitionOverride && (l = r.transitionOverride);
    const u = o ? () => Promise.all(Ng(i, o, r)) : () => Promise.resolve()
      , d = i.variantChildren && i.variantChildren.size ? (h=0) => {
        const {delayChildren: g=0, staggerChildren: v, staggerDirection: y} = l;
        return Xx(i, e, g + h, v, y, r)
    }
    : () => Promise.resolve()
      , {when: p} = l;
    if (p) {
        const [h,g] = p === "beforeChildren" ? [u, d] : [d, u];
        return h().then( () => g())
    } else
        return Promise.all([u(), d(r.delay)])
}
function Xx(i, e, r=0, a=0, o=1, l) {
    const u = []
      , d = (i.variantChildren.size - 1) * a
      , p = o === 1 ? (h=0) => h * a : (h=0) => d - h * a;
    return Array.from(i.variantChildren).sort(Zx).forEach( (h, g) => {
        h.notify("AnimationStart", e),
        u.push(Tc(h, e, {
            ...l,
            delay: r + p(g)
        }).then( () => h.notify("AnimationComplete", e)))
    }
    ),
    Promise.all(u)
}
function Zx(i, e) {
    return i.sortNodePosition(e)
}
function Yx(i, e, r={}) {
    i.notify("AnimationStart", e);
    let a;
    if (Array.isArray(e)) {
        const o = e.map(l => Tc(i, l, r));
        a = Promise.all(o)
    } else if (typeof e == "string")
        a = Tc(i, e, r);
    else {
        const o = typeof e == "function" ? _s(i, e, r.custom) : e;
        a = Promise.all(Ng(i, o, r))
    }
    return a.then( () => {
        i.notify("AnimationComplete", e)
    }
    )
}
const Qx = Kc.length;
function Fg(i) {
    if (!i)
        return;
    if (!i.isControllingVariants) {
        const r = i.parent ? Fg(i.parent) || {} : {};
        return i.props.initial !== void 0 && (r.initial = i.props.initial),
        r
    }
    const e = {};
    for (let r = 0; r < Qx; r++) {
        const a = Kc[r]
          , o = i.props[a];
        (Fn(o) || o === !1) && (e[a] = o)
    }
    return e
}
const Jx = [...Uc].reverse()
  , e2 = Uc.length;
function t2(i) {
    return e => Promise.all(e.map( ({animation: r, options: a}) => Yx(i, r, a)))
}
function i2(i) {
    let e = t2(i)
      , r = Qm()
      , a = !0;
    const o = p => (h, g) => {
        var v;
        const y = _s(i, g, p === "exit" ? (v = i.presenceContext) === null || v === void 0 ? void 0 : v.custom : void 0);
        if (y) {
            const {transition: P, transitionEnd: w, ...S} = y;
            h = {
                ...h,
                ...S,
                ...w
            }
        }
        return h
    }
    ;
    function l(p) {
        e = p(i)
    }
    function u(p) {
        const {props: h} = i
          , g = Fg(i.parent) || {}
          , v = []
          , y = new Set;
        let P = {}
          , w = 1 / 0;
        for (let z = 0; z < e2; z++) {
            const C = Jx[z]
              , b = r[C]
              , T = h[C] !== void 0 ? h[C] : g[C]
              , D = Fn(T)
              , M = C === p ? b.isActive : null;
            M === !1 && (w = z);
            let B = T === g[C] && T !== h[C] && D;
            if (B && a && i.manuallyAnimateOnMount && (B = !1),
            b.protectedKeys = {
                ...P
            },
            !b.isActive && M === null || !T && !b.prevProp || Bs(T) || typeof T == "boolean")
                continue;
            const _ = r2(b.prevProp, T);
            let F = _ || C === p && b.isActive && !B && D || z > w && D
              , R = !1;
            const W = Array.isArray(T) ? T : [T];
            let K = W.reduce(o(C), {});
            M === !1 && (K = {});
            const {prevResolvedValues: Q={}} = b
              , se = {
                ...Q,
                ...K
            }
              , le = ne => {
                F = !0,
                y.has(ne) && (R = !0,
                y.delete(ne)),
                b.needsAnimating[ne] = !0;
                const H = i.getValue(ne);
                H && (H.liveStyle = !1)
            }
            ;
            for (const ne in se) {
                const H = K[ne]
                  , X = Q[ne];
                if (P.hasOwnProperty(ne))
                    continue;
                let Z = !1;
                fc(H) && fc(X) ? Z = !Zf(H, X) : Z = H !== X,
                Z ? H != null ? le(ne) : y.add(ne) : H !== void 0 && y.has(ne) ? le(ne) : b.protectedKeys[ne] = !0
            }
            b.prevProp = T,
            b.prevResolvedValues = K,
            b.isActive && (P = {
                ...P,
                ...K
            }),
            a && i.blockInitialAnimation && (F = !1),
            F && (!(B && _) || R) && v.push(...W.map(ne => ({
                animation: ne,
                options: {
                    type: C
                }
            })))
        }
        if (y.size) {
            const z = {};
            y.forEach(C => {
                const b = i.getBaseTarget(C)
                  , T = i.getValue(C);
                T && (T.liveStyle = !0),
                z[C] = b ?? null
            }
            ),
            v.push({
                animation: z
            })
        }
        let S = !!v.length;
        return a && (h.initial === !1 || h.initial === h.animate) && !i.manuallyAnimateOnMount && (S = !1),
        a = !1,
        S ? e(v) : Promise.resolve()
    }
    function d(p, h) {
        var g;
        if (r[p].isActive === h)
            return Promise.resolve();
        (g = i.variantChildren) === null || g === void 0 || g.forEach(y => {
            var P;
            return (P = y.animationState) === null || P === void 0 ? void 0 : P.setActive(p, h)
        }
        ),
        r[p].isActive = h;
        const v = u(p);
        for (const y in r)
            r[y].protectedKeys = {};
        return v
    }
    return {
        animateChanges: u,
        setActive: d,
        setAnimateFunction: l,
        getState: () => r,
        reset: () => {
            r = Qm(),
            a = !0
        }
    }
}
function r2(i, e) {
    return typeof e == "string" ? e !== i : Array.isArray(e) ? !Zf(e, i) : !1
}
function Ki(i=!1) {
    return {
        isActive: i,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {}
    }
}
function Qm() {
    return {
        animate: Ki(!0),
        whileInView: Ki(),
        whileHover: Ki(),
        whileTap: Ki(),
        whileDrag: Ki(),
        whileFocus: Ki(),
        exit: Ki()
    }
}
class Ei {
    constructor(e) {
        this.isMounted = !1,
        this.node = e
    }
    update() {}
}
class n2 extends Ei {
    constructor(e) {
        super(e),
        e.animationState || (e.animationState = i2(e))
    }
    updateAnimationControlsSubscription() {
        const {animate: e} = this.node.getProps();
        Bs(e) && (this.unmountControls = e.subscribe(this.node))
    }
    mount() {
        this.updateAnimationControlsSubscription()
    }
    update() {
        const {animate: e} = this.node.getProps()
          , {animate: r} = this.node.prevProps || {};
        e !== r && this.updateAnimationControlsSubscription()
    }
    unmount() {
        var e;
        this.node.animationState.reset(),
        (e = this.unmountControls) === null || e === void 0 || e.call(this)
    }
}
let a2 = 0;
class s2 extends Ei {
    constructor() {
        super(...arguments),
        this.id = a2++
    }
    update() {
        if (!this.node.presenceContext)
            return;
        const {isPresent: e, onExitComplete: r} = this.node.presenceContext
          , {isPresent: a} = this.node.prevPresenceContext || {};
        if (!this.node.animationState || e === a)
            return;
        const o = this.node.animationState.setActive("exit", !e);
        r && !e && o.then( () => r(this.id))
    }
    mount() {
        const {register: e} = this.node.presenceContext || {};
        e && (this.unmount = e(this.id))
    }
    unmount() {}
}
const o2 = {
    animation: {
        Feature: n2
    },
    exit: {
        Feature: s2
    }
};
function _n(i, e, r, a={
    passive: !0
}) {
    return i.addEventListener(e, r, a),
    () => i.removeEventListener(e, r)
}
function qn(i) {
    return {
        point: {
            x: i.pageX,
            y: i.pageY
        }
    }
}
const l2 = i => e => au(e) && i(e, qn(e));
function Mn(i, e, r, a) {
    return _n(i, e, l2(r), a)
}
const Jm = (i, e) => Math.abs(i - e);
function c2(i, e) {
    const r = Jm(i.x, e.x)
      , a = Jm(i.y, e.y);
    return Math.sqrt(r ** 2 + a ** 2)
}
class Rg {
    constructor(e, r, {transformPagePoint: a, contextWindow: o, dragSnapToOrigin: l=!1}={}) {
        if (this.startEvent = null,
        this.lastMoveEvent = null,
        this.lastMoveEventInfo = null,
        this.handlers = {},
        this.contextWindow = window,
        this.updatePoint = () => {
            if (!(this.lastMoveEvent && this.lastMoveEventInfo))
                return;
            const v = Yl(this.lastMoveEventInfo, this.history)
              , y = this.startEvent !== null
              , P = c2(v.offset, {
                x: 0,
                y: 0
            }) >= 3;
            if (!y && !P)
                return;
            const {point: w} = v
              , {timestamp: S} = Ze;
            this.history.push({
                ...w,
                timestamp: S
            });
            const {onStart: z, onMove: C} = this.handlers;
            y || (z && z(this.lastMoveEvent, v),
            this.startEvent = this.lastMoveEvent),
            C && C(this.lastMoveEvent, v)
        }
        ,
        this.handlePointerMove = (v, y) => {
            this.lastMoveEvent = v,
            this.lastMoveEventInfo = Zl(y, this.transformPagePoint),
            ze.update(this.updatePoint, !0)
        }
        ,
        this.handlePointerUp = (v, y) => {
            this.end();
            const {onEnd: P, onSessionEnd: w, resumeAnimation: S} = this.handlers;
            if (this.dragSnapToOrigin && S && S(),
            !(this.lastMoveEvent && this.lastMoveEventInfo))
                return;
            const z = Yl(v.type === "pointercancel" ? this.lastMoveEventInfo : Zl(y, this.transformPagePoint), this.history);
            this.startEvent && P && P(v, z),
            w && w(v, z)
        }
        ,
        !au(e))
            return;
        this.dragSnapToOrigin = l,
        this.handlers = r,
        this.transformPagePoint = a,
        this.contextWindow = o || window;
        const u = qn(e)
          , d = Zl(u, this.transformPagePoint)
          , {point: p} = d
          , {timestamp: h} = Ze;
        this.history = [{
            ...p,
            timestamp: h
        }];
        const {onSessionStart: g} = r;
        g && g(e, Yl(d, this.history)),
        this.removeListeners = Gn(Mn(this.contextWindow, "pointermove", this.handlePointerMove), Mn(this.contextWindow, "pointerup", this.handlePointerUp), Mn(this.contextWindow, "pointercancel", this.handlePointerUp))
    }
    updateHandlers(e) {
        this.handlers = e
    }
    end() {
        this.removeListeners && this.removeListeners(),
        zi(this.updatePoint)
    }
}
function Zl(i, e) {
    return e ? {
        point: e(i.point)
    } : i
}
function eh(i, e) {
    return {
        x: i.x - e.x,
        y: i.y - e.y
    }
}
function Yl({point: i}, e) {
    return {
        point: i,
        delta: eh(i, Bg(e)),
        offset: eh(i, u2(e)),
        velocity: d2(e, .1)
    }
}
function u2(i) {
    return i[0]
}
function Bg(i) {
    return i[i.length - 1]
}
function d2(i, e) {
    if (i.length < 2)
        return {
            x: 0,
            y: 0
        };
    let r = i.length - 1
      , a = null;
    const o = Bg(i);
    for (; r >= 0 && (a = i[r],
    !(o.timestamp - a.timestamp > ii(e))); )
        r--;
    if (!a)
        return {
            x: 0,
            y: 0
        };
    const l = ri(o.timestamp - a.timestamp);
    if (l === 0)
        return {
            x: 0,
            y: 0
        };
    const u = {
        x: (o.x - a.x) / l,
        y: (o.y - a.y) / l
    };
    return u.x === 1 / 0 && (u.x = 0),
    u.y === 1 / 0 && (u.y = 0),
    u
}
const Wg = 1e-4
  , p2 = 1 - Wg
  , m2 = 1 + Wg
  , _g = .01
  , h2 = 0 - _g
  , f2 = 0 + _g;
function xt(i) {
    return i.max - i.min
}
function g2(i, e, r) {
    return Math.abs(i - e) <= r
}
function th(i, e, r, a=.5) {
    i.origin = a,
    i.originPoint = Ve(e.min, e.max, i.origin),
    i.scale = xt(r) / xt(e),
    i.translate = Ve(r.min, r.max, i.origin) - i.originPoint,
    (i.scale >= p2 && i.scale <= m2 || isNaN(i.scale)) && (i.scale = 1),
    (i.translate >= h2 && i.translate <= f2 || isNaN(i.translate)) && (i.translate = 0)
}
function Vn(i, e, r, a) {
    th(i.x, e.x, r.x, a ? a.originX : void 0),
    th(i.y, e.y, r.y, a ? a.originY : void 0)
}
function ih(i, e, r) {
    i.min = r.min + e.min,
    i.max = i.min + xt(e)
}
function v2(i, e, r) {
    ih(i.x, e.x, r.x),
    ih(i.y, e.y, r.y)
}
function rh(i, e, r) {
    i.min = e.min - r.min,
    i.max = i.min + xt(e)
}
function Ln(i, e, r) {
    rh(i.x, e.x, r.x),
    rh(i.y, e.y, r.y)
}
function y2(i, {min: e, max: r}, a) {
    return e !== void 0 && i < e ? i = a ? Ve(e, i, a.min) : Math.max(i, e) : r !== void 0 && i > r && (i = a ? Ve(r, i, a.max) : Math.min(i, r)),
    i
}
function nh(i, e, r) {
    return {
        min: e !== void 0 ? i.min + e : void 0,
        max: r !== void 0 ? i.max + r - (i.max - i.min) : void 0
    }
}
function k2(i, {top: e, left: r, bottom: a, right: o}) {
    return {
        x: nh(i.x, r, o),
        y: nh(i.y, e, a)
    }
}
function ah(i, e) {
    let r = e.min - i.min
      , a = e.max - i.max;
    return e.max - e.min < i.max - i.min && ([r,a] = [a, r]),
    {
        min: r,
        max: a
    }
}
function x2(i, e) {
    return {
        x: ah(i.x, e.x),
        y: ah(i.y, e.y)
    }
}
function w2(i, e) {
    let r = .5;
    const a = xt(i)
      , o = xt(e);
    return o > a ? r = Vr(e.min, e.max - a, i.min) : a > o && (r = Vr(i.min, i.max - o, e.min)),
    ni(0, 1, r)
}
function P2(i, e) {
    const r = {};
    return e.min !== void 0 && (r.min = e.min - i.min),
    e.max !== void 0 && (r.max = e.max - i.min),
    r
}
const jc = .35;
function b2(i=jc) {
    return i === !1 ? i = 0 : i === !0 && (i = jc),
    {
        x: sh(i, "left", "right"),
        y: sh(i, "top", "bottom")
    }
}
function sh(i, e, r) {
    return {
        min: oh(i, e),
        max: oh(i, r)
    }
}
function oh(i, e) {
    return typeof i == "number" ? i : i[e] || 0
}
const lh = () => ({
    translate: 0,
    scale: 1,
    origin: 0,
    originPoint: 0
})
  , Er = () => ({
    x: lh(),
    y: lh()
})
  , ch = () => ({
    min: 0,
    max: 0
})
  , Re = () => ({
    x: ch(),
    y: ch()
});
function zt(i) {
    return [i("x"), i("y")]
}
function Ug({top: i, left: e, right: r, bottom: a}) {
    return {
        x: {
            min: e,
            max: r
        },
        y: {
            min: i,
            max: a
        }
    }
}
function S2({x: i, y: e}) {
    return {
        top: e.min,
        right: i.max,
        bottom: e.max,
        left: i.min
    }
}
function T2(i, e) {
    if (!e)
        return i;
    const r = e({
        x: i.left,
        y: i.top
    })
      , a = e({
        x: i.right,
        y: i.bottom
    });
    return {
        top: r.y,
        left: r.x,
        bottom: a.y,
        right: a.x
    }
}
function Ql(i) {
    return i === void 0 || i === 1
}
function Cc({scale: i, scaleX: e, scaleY: r}) {
    return !Ql(i) || !Ql(e) || !Ql(r)
}
function $i(i) {
    return Cc(i) || Kg(i) || i.z || i.rotate || i.rotateX || i.rotateY || i.skewX || i.skewY
}
function Kg(i) {
    return uh(i.x) || uh(i.y)
}
function uh(i) {
    return i && i !== "0%"
}
function Cs(i, e, r) {
    const a = i - r
      , o = e * a;
    return r + o
}
function dh(i, e, r, a, o) {
    return o !== void 0 && (i = Cs(i, o, a)),
    Cs(i, r, a) + e
}
function zc(i, e=0, r=1, a, o) {
    i.min = dh(i.min, e, r, a, o),
    i.max = dh(i.max, e, r, a, o)
}
function $g(i, {x: e, y: r}) {
    zc(i.x, e.translate, e.scale, e.originPoint),
    zc(i.y, r.translate, r.scale, r.originPoint)
}
const ph = .999999999999
  , mh = 1.0000000000001;
function j2(i, e, r, a=!1) {
    const o = r.length;
    if (!o)
        return;
    e.x = e.y = 1;
    let l, u;
    for (let d = 0; d < o; d++) {
        l = r[d],
        u = l.projectionDelta;
        const {visualElement: p} = l.options;
        p && p.props.style && p.props.style.display === "contents" || (a && l.options.layoutScroll && l.scroll && l !== l.root && Ir(i, {
            x: -l.scroll.offset.x,
            y: -l.scroll.offset.y
        }),
        u && (e.x *= u.x.scale,
        e.y *= u.y.scale,
        $g(i, u)),
        a && $i(l.latestValues) && Ir(i, l.latestValues))
    }
    e.x < mh && e.x > ph && (e.x = 1),
    e.y < mh && e.y > ph && (e.y = 1)
}
function Dr(i, e) {
    i.min = i.min + e,
    i.max = i.max + e
}
function hh(i, e, r, a, o=.5) {
    const l = Ve(i.min, i.max, o);
    zc(i, e, r, l, a)
}
function Ir(i, e) {
    hh(i.x, e.x, e.scaleX, e.scale, e.originX),
    hh(i.y, e.y, e.scaleY, e.scale, e.originY)
}
function Hg(i, e) {
    return Ug(T2(i.getBoundingClientRect(), e))
}
function C2(i, e, r) {
    const a = Hg(i, r)
      , {scroll: o} = e;
    return o && (Dr(a.x, o.offset.x),
    Dr(a.y, o.offset.y)),
    a
}
const Gg = ({current: i}) => i ? i.ownerDocument.defaultView : null
  , z2 = new WeakMap;
class A2 {
    constructor(e) {
        this.openDragLock = null,
        this.isDragging = !1,
        this.currentDirection = null,
        this.originPoint = {
            x: 0,
            y: 0
        },
        this.constraints = !1,
        this.hasMutatedConstraints = !1,
        this.elastic = Re(),
        this.visualElement = e
    }
    start(e, {snapToCursor: r=!1}={}) {
        const {presenceContext: a} = this.visualElement;
        if (a && a.isPresent === !1)
            return;
        const o = g => {
            const {dragSnapToOrigin: v} = this.getProps();
            v ? this.pauseAnimation() : this.stopAnimation(),
            r && this.snapToCursor(qn(g).point)
        }
          , l = (g, v) => {
            const {drag: y, dragPropagation: P, onDragStart: w} = this.getProps();
            if (y && !P && (this.openDragLock && this.openDragLock(),
            this.openDragLock = wk(y),
            !this.openDragLock))
                return;
            this.isDragging = !0,
            this.currentDirection = null,
            this.resolveConstraints(),
            this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !0,
            this.visualElement.projection.target = void 0),
            zt(z => {
                let C = this.getAxisMotionValue(z).get() || 0;
                if (Kt.test(C)) {
                    const {projection: b} = this.visualElement;
                    if (b && b.layout) {
                        const T = b.layout.layoutBox[z];
                        T && (C = xt(T) * (parseFloat(C) / 100))
                    }
                }
                this.originPoint[z] = C
            }
            ),
            w && ze.postRender( () => w(g, v)),
            yc(this.visualElement, "transform");
            const {animationState: S} = this.visualElement;
            S && S.setActive("whileDrag", !0)
        }
          , u = (g, v) => {
            const {dragPropagation: y, dragDirectionLock: P, onDirectionLock: w, onDrag: S} = this.getProps();
            if (!y && !this.openDragLock)
                return;
            const {offset: z} = v;
            if (P && this.currentDirection === null) {
                this.currentDirection = E2(z),
                this.currentDirection !== null && w && w(this.currentDirection);
                return
            }
            this.updateAxis("x", v.point, z),
            this.updateAxis("y", v.point, z),
            this.visualElement.render(),
            S && S(g, v)
        }
          , d = (g, v) => this.stop(g, v)
          , p = () => zt(g => {
            var v;
            return this.getAnimationState(g) === "paused" && ((v = this.getAxisMotionValue(g).animation) === null || v === void 0 ? void 0 : v.play())
        }
        )
          , {dragSnapToOrigin: h} = this.getProps();
        this.panSession = new Rg(e,{
            onSessionStart: o,
            onStart: l,
            onMove: u,
            onSessionEnd: d,
            resumeAnimation: p
        },{
            transformPagePoint: this.visualElement.getTransformPagePoint(),
            dragSnapToOrigin: h,
            contextWindow: Gg(this.visualElement)
        })
    }
    stop(e, r) {
        const a = this.isDragging;
        if (this.cancel(),
        !a)
            return;
        const {velocity: o} = r;
        this.startAnimation(o);
        const {onDragEnd: l} = this.getProps();
        l && ze.postRender( () => l(e, r))
    }
    cancel() {
        this.isDragging = !1;
        const {projection: e, animationState: r} = this.visualElement;
        e && (e.isAnimationBlocked = !1),
        this.panSession && this.panSession.end(),
        this.panSession = void 0;
        const {dragPropagation: a} = this.getProps();
        !a && this.openDragLock && (this.openDragLock(),
        this.openDragLock = null),
        r && r.setActive("whileDrag", !1)
    }
    updateAxis(e, r, a) {
        const {drag: o} = this.getProps();
        if (!a || !ps(e, o, this.currentDirection))
            return;
        const l = this.getAxisMotionValue(e);
        let u = this.originPoint[e] + a[e];
        this.constraints && this.constraints[e] && (u = y2(u, this.constraints[e], this.elastic[e])),
        l.set(u)
    }
    resolveConstraints() {
        var e;
        const {dragConstraints: r, dragElastic: a} = this.getProps()
          , o = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(!1) : (e = this.visualElement.projection) === null || e === void 0 ? void 0 : e.layout
          , l = this.constraints;
        r && zr(r) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : r && o ? this.constraints = k2(o.layoutBox, r) : this.constraints = !1,
        this.elastic = b2(a),
        l !== this.constraints && o && this.constraints && !this.hasMutatedConstraints && zt(u => {
            this.constraints !== !1 && this.getAxisMotionValue(u) && (this.constraints[u] = P2(o.layoutBox[u], this.constraints[u]))
        }
        )
    }
    resolveRefConstraints() {
        const {dragConstraints: e, onMeasureDragConstraints: r} = this.getProps();
        if (!e || !zr(e))
            return !1;
        const a = e.current
          , {projection: o} = this.visualElement;
        if (!o || !o.layout)
            return !1;
        const l = C2(a, o.root, this.visualElement.getTransformPagePoint());
        let u = x2(o.layout.layoutBox, l);
        if (r) {
            const d = r(S2(u));
            this.hasMutatedConstraints = !!d,
            d && (u = Ug(d))
        }
        return u
    }
    startAnimation(e) {
        const {drag: r, dragMomentum: a, dragElastic: o, dragTransition: l, dragSnapToOrigin: u, onDragTransitionEnd: d} = this.getProps()
          , p = this.constraints || {}
          , h = zt(g => {
            if (!ps(g, r, this.currentDirection))
                return;
            let v = p && p[g] || {};
            u && (v = {
                min: 0,
                max: 0
            });
            const y = o ? 200 : 1e6
              , P = o ? 40 : 1e7
              , w = {
                type: "inertia",
                velocity: a ? e[g] : 0,
                bounceStiffness: y,
                bounceDamping: P,
                timeConstant: 750,
                restDelta: 1,
                restSpeed: 10,
                ...l,
                ...v
            };
            return this.startAxisValueAnimation(g, w)
        }
        );
        return Promise.all(h).then(d)
    }
    startAxisValueAnimation(e, r) {
        const a = this.getAxisMotionValue(e);
        return yc(this.visualElement, e),
        a.start(vu(e, a, 0, r, this.visualElement, !1))
    }
    stopAnimation() {
        zt(e => this.getAxisMotionValue(e).stop())
    }
    pauseAnimation() {
        zt(e => {
            var r;
            return (r = this.getAxisMotionValue(e).animation) === null || r === void 0 ? void 0 : r.pause()
        }
        )
    }
    getAnimationState(e) {
        var r;
        return (r = this.getAxisMotionValue(e).animation) === null || r === void 0 ? void 0 : r.state
    }
    getAxisMotionValue(e) {
        const r = `_drag${e.toUpperCase()}`
          , a = this.visualElement.getProps()
          , o = a[r];
        return o || this.visualElement.getValue(e, (a.initial ? a.initial[e] : void 0) || 0)
    }
    snapToCursor(e) {
        zt(r => {
            const {drag: a} = this.getProps();
            if (!ps(r, a, this.currentDirection))
                return;
            const {projection: o} = this.visualElement
              , l = this.getAxisMotionValue(r);
            if (o && o.layout) {
                const {min: u, max: d} = o.layout.layoutBox[r];
                l.set(e[r] - Ve(u, d, .5))
            }
        }
        )
    }
    scalePositionWithinConstraints() {
        if (!this.visualElement.current)
            return;
        const {drag: e, dragConstraints: r} = this.getProps()
          , {projection: a} = this.visualElement;
        if (!zr(r) || !a || !this.constraints)
            return;
        this.stopAnimation();
        const o = {
            x: 0,
            y: 0
        };
        zt(u => {
            const d = this.getAxisMotionValue(u);
            if (d && this.constraints !== !1) {
                const p = d.get();
                o[u] = w2({
                    min: p,
                    max: p
                }, this.constraints[u])
            }
        }
        );
        const {transformTemplate: l} = this.visualElement.getProps();
        this.visualElement.current.style.transform = l ? l({}, "") : "none",
        a.root && a.root.updateScroll(),
        a.updateLayout(),
        this.resolveConstraints(),
        zt(u => {
            if (!ps(u, e, null))
                return;
            const d = this.getAxisMotionValue(u)
              , {min: p, max: h} = this.constraints[u];
            d.set(Ve(p, h, o[u]))
        }
        )
    }
    addListeners() {
        if (!this.visualElement.current)
            return;
        z2.set(this.visualElement, this);
        const e = this.visualElement.current
          , r = Mn(e, "pointerdown", p => {
            const {drag: h, dragListener: g=!0} = this.getProps();
            h && g && this.start(p)
        }
        )
          , a = () => {
            const {dragConstraints: p} = this.getProps();
            zr(p) && p.current && (this.constraints = this.resolveRefConstraints())
        }
          , {projection: o} = this.visualElement
          , l = o.addEventListener("measure", a);
        o && !o.layout && (o.root && o.root.updateScroll(),
        o.updateLayout()),
        ze.read(a);
        const u = _n(window, "resize", () => this.scalePositionWithinConstraints())
          , d = o.addEventListener("didUpdate", ( ({delta: p, hasLayoutChanged: h}) => {
            this.isDragging && h && (zt(g => {
                const v = this.getAxisMotionValue(g);
                v && (this.originPoint[g] += p[g].translate,
                v.set(v.get() + p[g].translate))
            }
            ),
            this.visualElement.render())
        }
        ));
        return () => {
            u(),
            r(),
            l(),
            d && d()
        }
    }
    getProps() {
        const e = this.visualElement.getProps()
          , {drag: r=!1, dragDirectionLock: a=!1, dragPropagation: o=!1, dragConstraints: l=!1, dragElastic: u=jc, dragMomentum: d=!0} = e;
        return {
            ...e,
            drag: r,
            dragDirectionLock: a,
            dragPropagation: o,
            dragConstraints: l,
            dragElastic: u,
            dragMomentum: d
        }
    }
}
function ps(i, e, r) {
    return (e === !0 || e === i) && (r === null || r === i)
}
function E2(i, e=10) {
    let r = null;
    return Math.abs(i.y) > e ? r = "y" : Math.abs(i.x) > e && (r = "x"),
    r
}
class D2 extends Ei {
    constructor(e) {
        super(e),
        this.removeGroupControls = kt,
        this.removeListeners = kt,
        this.controls = new A2(e)
    }
    mount() {
        const {dragControls: e} = this.node.getProps();
        e && (this.removeGroupControls = e.subscribe(this.controls)),
        this.removeListeners = this.controls.addListeners() || kt
    }
    unmount() {
        this.removeGroupControls(),
        this.removeListeners()
    }
}
const fh = i => (e, r) => {
    i && ze.postRender( () => i(e, r))
}
;
class I2 extends Ei {
    constructor() {
        super(...arguments),
        this.removePointerDownListener = kt
    }
    onPointerDown(e) {
        this.session = new Rg(e,this.createPanHandlers(),{
            transformPagePoint: this.node.getTransformPagePoint(),
            contextWindow: Gg(this.node)
        })
    }
    createPanHandlers() {
        const {onPanSessionStart: e, onPanStart: r, onPan: a, onPanEnd: o} = this.node.getProps();
        return {
            onSessionStart: fh(e),
            onStart: fh(r),
            onMove: a,
            onEnd: (l, u) => {
                delete this.session,
                o && ze.postRender( () => o(l, u))
            }
        }
    }
    mount() {
        this.removePointerDownListener = Mn(this.node.current, "pointerdown", e => this.onPointerDown(e))
    }
    update() {
        this.session && this.session.updateHandlers(this.createPanHandlers())
    }
    unmount() {
        this.removePointerDownListener(),
        this.session && this.session.end()
    }
}
const ks = {
    hasAnimatedSinceResize: !0,
    hasEverUpdated: !1
};
function gh(i, e) {
    return e.max === e.min ? 0 : i / (e.max - e.min) * 100
}
const jn = {
    correct: (i, e) => {
        if (!e.target)
            return i;
        if (typeof i == "string")
            if (de.test(i))
                i = parseFloat(i);
            else
                return i;
        const r = gh(i, e.target.x)
          , a = gh(i, e.target.y);
        return `${r}% ${a}%`
    }
}
  , M2 = {
    correct: (i, {treeScale: e, projectionDelta: r}) => {
        const a = i
          , o = Ai.parse(i);
        if (o.length > 5)
            return a;
        const l = Ai.createTransformer(i)
          , u = typeof o[0] != "number" ? 1 : 0
          , d = r.x.scale * e.x
          , p = r.y.scale * e.y;
        o[0 + u] /= d,
        o[1 + u] /= p;
        const h = Ve(d, p, .5);
        return typeof o[2 + u] == "number" && (o[2 + u] /= h),
        typeof o[3 + u] == "number" && (o[3 + u] /= h),
        l(o)
    }
};
class V2 extends N.Component {
    componentDidMount() {
        const {visualElement: e, layoutGroup: r, switchLayoutGroup: a, layoutId: o} = this.props
          , {projection: l} = e;
        tk(L2),
        l && (r.group && r.group.add(l),
        a && a.register && o && a.register(l),
        l.root.didUpdate(),
        l.addEventListener("animationComplete", () => {
            this.safeToRemove()
        }
        ),
        l.setOptions({
            ...l.options,
            onExitComplete: () => this.safeToRemove()
        })),
        ks.hasEverUpdated = !0
    }
    getSnapshotBeforeUpdate(e) {
        const {layoutDependency: r, visualElement: a, drag: o, isPresent: l} = this.props
          , u = a.projection;
        return u && (u.isPresent = l,
        o || e.layoutDependency !== r || r === void 0 ? u.willUpdate() : this.safeToRemove(),
        e.isPresent !== l && (l ? u.promote() : u.relegate() || ze.postRender( () => {
            const d = u.getStack();
            (!d || !d.members.length) && this.safeToRemove()
        }
        ))),
        null
    }
    componentDidUpdate() {
        const {projection: e} = this.props.visualElement;
        e && (e.root.didUpdate(),
        Hc.postRender( () => {
            !e.currentAnimation && e.isLead() && this.safeToRemove()
        }
        ))
    }
    componentWillUnmount() {
        const {visualElement: e, layoutGroup: r, switchLayoutGroup: a} = this.props
          , {projection: o} = e;
        o && (o.scheduleCheckAfterUnmount(),
        r && r.group && r.group.remove(o),
        a && a.deregister && a.deregister(o))
    }
    safeToRemove() {
        const {safeToRemove: e} = this.props;
        e && e()
    }
    render() {
        return null
    }
}
function qg(i) {
    const [e,r] = Af()
      , a = N.useContext(Fc);
    return x.jsx(V2, {
        ...i,
        layoutGroup: a,
        switchLayoutGroup: N.useContext(Nf),
        isPresent: e,
        safeToRemove: r
    })
}
const L2 = {
    borderRadius: {
        ...jn,
        applyTo: ["borderTopLeftRadius", "borderTopRightRadius", "borderBottomLeftRadius", "borderBottomRightRadius"]
    },
    borderTopLeftRadius: jn,
    borderTopRightRadius: jn,
    borderBottomLeftRadius: jn,
    borderBottomRightRadius: jn,
    boxShadow: M2
};
function O2(i, e, r) {
    const a = it(i) ? i : Bn(i);
    return a.start(vu("", a, e, r)),
    a.animation
}
function N2(i) {
    return i instanceof SVGElement && i.tagName !== "svg"
}
const F2 = (i, e) => i.depth - e.depth;
class R2 {
    constructor() {
        this.children = [],
        this.isDirty = !1
    }
    add(e) {
        su(this.children, e),
        this.isDirty = !0
    }
    remove(e) {
        ou(this.children, e),
        this.isDirty = !0
    }
    forEach(e) {
        this.isDirty && this.children.sort(F2),
        this.isDirty = !1,
        this.children.forEach(e)
    }
}
function B2(i, e) {
    const r = $t.now()
      , a = ({timestamp: o}) => {
        const l = o - r;
        l >= e && (zi(a),
        i(l - e))
    }
    ;
    return ze.read(a, !0),
    () => zi(a)
}
const Xg = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"]
  , W2 = Xg.length
  , vh = i => typeof i == "string" ? parseFloat(i) : i
  , yh = i => typeof i == "number" || de.test(i);
function _2(i, e, r, a, o, l) {
    o ? (i.opacity = Ve(0, r.opacity !== void 0 ? r.opacity : 1, U2(a)),
    i.opacityExit = Ve(e.opacity !== void 0 ? e.opacity : 1, 0, K2(a))) : l && (i.opacity = Ve(e.opacity !== void 0 ? e.opacity : 1, r.opacity !== void 0 ? r.opacity : 1, a));
    for (let u = 0; u < W2; u++) {
        const d = `border${Xg[u]}Radius`;
        let p = kh(e, d)
          , h = kh(r, d);
        if (p === void 0 && h === void 0)
            continue;
        p || (p = 0),
        h || (h = 0),
        p === 0 || h === 0 || yh(p) === yh(h) ? (i[d] = Math.max(Ve(vh(p), vh(h), a), 0),
        (Kt.test(h) || Kt.test(p)) && (i[d] += "%")) : i[d] = h
    }
    (e.rotate || r.rotate) && (i.rotate = Ve(e.rotate || 0, r.rotate || 0, a))
}
function kh(i, e) {
    return i[e] !== void 0 ? i[e] : i.borderRadius
}
const U2 = Zg(0, .5, hg)
  , K2 = Zg(.5, .95, kt);
function Zg(i, e, r) {
    return a => a < i ? 0 : a > e ? 1 : r(Vr(i, e, a))
}
function xh(i, e) {
    i.min = e.min,
    i.max = e.max
}
function Ct(i, e) {
    xh(i.x, e.x),
    xh(i.y, e.y)
}
function wh(i, e) {
    i.translate = e.translate,
    i.scale = e.scale,
    i.originPoint = e.originPoint,
    i.origin = e.origin
}
function Ph(i, e, r, a, o) {
    return i -= e,
    i = Cs(i, 1 / r, a),
    o !== void 0 && (i = Cs(i, 1 / o, a)),
    i
}
function $2(i, e=0, r=1, a=.5, o, l=i, u=i) {
    if (Kt.test(e) && (e = parseFloat(e),
    e = Ve(u.min, u.max, e / 100) - u.min),
    typeof e != "number")
        return;
    let d = Ve(l.min, l.max, a);
    i === l && (d -= e),
    i.min = Ph(i.min, e, r, d, o),
    i.max = Ph(i.max, e, r, d, o)
}
function bh(i, e, [r,a,o], l, u) {
    $2(i, e[r], e[a], e[o], e.scale, l, u)
}
const H2 = ["x", "scaleX", "originX"]
  , G2 = ["y", "scaleY", "originY"];
function Sh(i, e, r, a) {
    bh(i.x, e, H2, r ? r.x : void 0, a ? a.x : void 0),
    bh(i.y, e, G2, r ? r.y : void 0, a ? a.y : void 0)
}
function Th(i) {
    return i.translate === 0 && i.scale === 1
}
function Yg(i) {
    return Th(i.x) && Th(i.y)
}
function jh(i, e) {
    return i.min === e.min && i.max === e.max
}
function q2(i, e) {
    return jh(i.x, e.x) && jh(i.y, e.y)
}
function Ch(i, e) {
    return Math.round(i.min) === Math.round(e.min) && Math.round(i.max) === Math.round(e.max)
}
function Qg(i, e) {
    return Ch(i.x, e.x) && Ch(i.y, e.y)
}
function zh(i) {
    return xt(i.x) / xt(i.y)
}
function Ah(i, e) {
    return i.translate === e.translate && i.scale === e.scale && i.originPoint === e.originPoint
}
class X2 {
    constructor() {
        this.members = []
    }
    add(e) {
        su(this.members, e),
        e.scheduleRender()
    }
    remove(e) {
        if (ou(this.members, e),
        e === this.prevLead && (this.prevLead = void 0),
        e === this.lead) {
            const r = this.members[this.members.length - 1];
            r && this.promote(r)
        }
    }
    relegate(e) {
        const r = this.members.findIndex(o => e === o);
        if (r === 0)
            return !1;
        let a;
        for (let o = r; o >= 0; o--) {
            const l = this.members[o];
            if (l.isPresent !== !1) {
                a = l;
                break
            }
        }
        return a ? (this.promote(a),
        !0) : !1
    }
    promote(e, r) {
        const a = this.lead;
        if (e !== a && (this.prevLead = a,
        this.lead = e,
        e.show(),
        a)) {
            a.instance && a.scheduleRender(),
            e.scheduleRender(),
            e.resumeFrom = a,
            r && (e.resumeFrom.preserveOpacity = !0),
            a.snapshot && (e.snapshot = a.snapshot,
            e.snapshot.latestValues = a.animationValues || a.latestValues),
            e.root && e.root.isUpdating && (e.isLayoutDirty = !0);
            const {crossfade: o} = e.options;
            o === !1 && a.hide()
        }
    }
    exitAnimationComplete() {
        this.members.forEach(e => {
            const {options: r, resumingFrom: a} = e;
            r.onExitComplete && r.onExitComplete(),
            a && a.options.onExitComplete && a.options.onExitComplete()
        }
        )
    }
    scheduleRender() {
        this.members.forEach(e => {
            e.instance && e.scheduleRender(!1)
        }
        )
    }
    removeLeadSnapshot() {
        this.lead && this.lead.snapshot && (this.lead.snapshot = void 0)
    }
}
function Z2(i, e, r) {
    let a = "";
    const o = i.x.translate / e.x
      , l = i.y.translate / e.y
      , u = (r == null ? void 0 : r.z) || 0;
    if ((o || l || u) && (a = `translate3d(${o}px, ${l}px, ${u}px) `),
    (e.x !== 1 || e.y !== 1) && (a += `scale(${1 / e.x}, ${1 / e.y}) `),
    r) {
        const {transformPerspective: h, rotate: g, rotateX: v, rotateY: y, skewX: P, skewY: w} = r;
        h && (a = `perspective(${h}px) ${a}`),
        g && (a += `rotate(${g}deg) `),
        v && (a += `rotateX(${v}deg) `),
        y && (a += `rotateY(${y}deg) `),
        P && (a += `skewX(${P}deg) `),
        w && (a += `skewY(${w}deg) `)
    }
    const d = i.x.scale * e.x
      , p = i.y.scale * e.y;
    return (d !== 1 || p !== 1) && (a += `scale(${d}, ${p})`),
    a || "none"
}
const Hi = {
    type: "projectionFrame",
    totalNodes: 0,
    resolvedTargetDeltas: 0,
    recalculatedProjection: 0
}
  , Dn = typeof window < "u" && window.MotionDebug !== void 0
  , Jl = ["", "X", "Y", "Z"]
  , Y2 = {
    visibility: "hidden"
}
  , Eh = 1e3;
let Q2 = 0;
function ec(i, e, r, a) {
    const {latestValues: o} = e;
    o[i] && (r[i] = o[i],
    e.setStaticValue(i, 0),
    a && (a[i] = 0))
}
function Jg(i) {
    if (i.hasCheckedOptimisedAppear = !0,
    i.root === i)
        return;
    const {visualElement: e} = i.options;
    if (!e)
        return;
    const r = og(e);
    if (window.MotionHasOptimisedAnimation(r, "transform")) {
        const {layout: o, layoutId: l} = i.options;
        window.MotionCancelOptimisedAnimation(r, "transform", ze, !(o || l))
    }
    const {parent: a} = i;
    a && !a.hasCheckedOptimisedAppear && Jg(a)
}
function e0({attachResizeListener: i, defaultParent: e, measureScroll: r, checkIsScrollRoot: a, resetTransform: o}) {
    return class {
        constructor(u={}, d=e == null ? void 0 : e()) {
            this.id = Q2++,
            this.animationId = 0,
            this.children = new Set,
            this.options = {},
            this.isTreeAnimating = !1,
            this.isAnimationBlocked = !1,
            this.isLayoutDirty = !1,
            this.isProjectionDirty = !1,
            this.isSharedProjectionDirty = !1,
            this.isTransformDirty = !1,
            this.updateManuallyBlocked = !1,
            this.updateBlockedByResize = !1,
            this.isUpdating = !1,
            this.isSVG = !1,
            this.needsReset = !1,
            this.shouldResetTransform = !1,
            this.hasCheckedOptimisedAppear = !1,
            this.treeScale = {
                x: 1,
                y: 1
            },
            this.eventHandlers = new Map,
            this.hasTreeAnimated = !1,
            this.updateScheduled = !1,
            this.scheduleUpdate = () => this.update(),
            this.projectionUpdateScheduled = !1,
            this.checkUpdateFailed = () => {
                this.isUpdating && (this.isUpdating = !1,
                this.clearAllSnapshots())
            }
            ,
            this.updateProjection = () => {
                this.projectionUpdateScheduled = !1,
                Dn && (Hi.totalNodes = Hi.resolvedTargetDeltas = Hi.recalculatedProjection = 0),
                this.nodes.forEach(tw),
                this.nodes.forEach(sw),
                this.nodes.forEach(ow),
                this.nodes.forEach(iw),
                Dn && window.MotionDebug.record(Hi)
            }
            ,
            this.resolvedRelativeTargetAt = 0,
            this.hasProjected = !1,
            this.isVisible = !0,
            this.animationProgress = 0,
            this.sharedNodes = new Map,
            this.latestValues = u,
            this.root = d ? d.root || d : this,
            this.path = d ? [...d.path, d] : [],
            this.parent = d,
            this.depth = d ? d.depth + 1 : 0;
            for (let p = 0; p < this.path.length; p++)
                this.path[p].shouldResetTransform = !0;
            this.root === this && (this.nodes = new R2)
        }
        addEventListener(u, d) {
            return this.eventHandlers.has(u) || this.eventHandlers.set(u, new lu),
            this.eventHandlers.get(u).add(d)
        }
        notifyListeners(u, ...d) {
            const p = this.eventHandlers.get(u);
            p && p.notify(...d)
        }
        hasListeners(u) {
            return this.eventHandlers.has(u)
        }
        mount(u, d=this.root.hasTreeAnimated) {
            if (this.instance)
                return;
            this.isSVG = N2(u),
            this.instance = u;
            const {layoutId: p, layout: h, visualElement: g} = this.options;
            if (g && !g.current && g.mount(u),
            this.root.nodes.add(this),
            this.parent && this.parent.children.add(this),
            d && (h || p) && (this.isLayoutDirty = !0),
            i) {
                let v;
                const y = () => this.root.updateBlockedByResize = !1;
                i(u, () => {
                    this.root.updateBlockedByResize = !0,
                    v && v(),
                    v = B2(y, 250),
                    ks.hasAnimatedSinceResize && (ks.hasAnimatedSinceResize = !1,
                    this.nodes.forEach(Ih))
                }
                )
            }
            p && this.root.registerSharedNode(p, this),
            this.options.animate !== !1 && g && (p || h) && this.addEventListener("didUpdate", ({delta: v, hasLayoutChanged: y, hasRelativeTargetChanged: P, layout: w}) => {
                if (this.isTreeAnimationBlocked()) {
                    this.target = void 0,
                    this.relativeTarget = void 0;
                    return
                }
                const S = this.options.transition || g.getDefaultTransition() || pw
                  , {onLayoutAnimationStart: z, onLayoutAnimationComplete: C} = g.getProps()
                  , b = !this.targetLayout || !Qg(this.targetLayout, w) || P
                  , T = !y && P;
                if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || T || y && (b || !this.currentAnimation)) {
                    this.resumeFrom && (this.resumingFrom = this.resumeFrom,
                    this.resumingFrom.resumingFrom = void 0),
                    this.setAnimationOrigin(v, T);
                    const D = {
                        ...iu(S, "layout"),
                        onPlay: z,
                        onComplete: C
                    };
                    (g.shouldReduceMotion || this.options.layoutRoot) && (D.delay = 0,
                    D.type = !1),
                    this.startAnimation(D)
                } else
                    y || Ih(this),
                    this.isLead() && this.options.onExitComplete && this.options.onExitComplete();
                this.targetLayout = w
            }
            )
        }
        unmount() {
            this.options.layoutId && this.willUpdate(),
            this.root.nodes.remove(this);
            const u = this.getStack();
            u && u.remove(this),
            this.parent && this.parent.children.delete(this),
            this.instance = void 0,
            zi(this.updateProjection)
        }
        blockUpdate() {
            this.updateManuallyBlocked = !0
        }
        unblockUpdate() {
            this.updateManuallyBlocked = !1
        }
        isUpdateBlocked() {
            return this.updateManuallyBlocked || this.updateBlockedByResize
        }
        isTreeAnimationBlocked() {
            return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || !1
        }
        startUpdate() {
            this.isUpdateBlocked() || (this.isUpdating = !0,
            this.nodes && this.nodes.forEach(lw),
            this.animationId++)
        }
        getTransformTemplate() {
            const {visualElement: u} = this.options;
            return u && u.getProps().transformTemplate
        }
        willUpdate(u=!0) {
            if (this.root.hasTreeAnimated = !0,
            this.root.isUpdateBlocked()) {
                this.options.onExitComplete && this.options.onExitComplete();
                return
            }
            if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear && Jg(this),
            !this.root.isUpdating && this.root.startUpdate(),
            this.isLayoutDirty)
                return;
            this.isLayoutDirty = !0;
            for (let g = 0; g < this.path.length; g++) {
                const v = this.path[g];
                v.shouldResetTransform = !0,
                v.updateScroll("snapshot"),
                v.options.layoutRoot && v.willUpdate(!1)
            }
            const {layoutId: d, layout: p} = this.options;
            if (d === void 0 && !p)
                return;
            const h = this.getTransformTemplate();
            this.prevTransformTemplateValue = h ? h(this.latestValues, "") : void 0,
            this.updateSnapshot(),
            u && this.notifyListeners("willUpdate")
        }
        update() {
            if (this.updateScheduled = !1,
            this.isUpdateBlocked()) {
                this.unblockUpdate(),
                this.clearAllSnapshots(),
                this.nodes.forEach(Dh);
                return
            }
            this.isUpdating || this.nodes.forEach(nw),
            this.isUpdating = !1,
            this.nodes.forEach(aw),
            this.nodes.forEach(J2),
            this.nodes.forEach(ew),
            this.clearAllSnapshots();
            const d = $t.now();
            Ze.delta = ni(0, 1e3 / 60, d - Ze.timestamp),
            Ze.timestamp = d,
            Ze.isProcessing = !0,
            Kl.update.process(Ze),
            Kl.preRender.process(Ze),
            Kl.render.process(Ze),
            Ze.isProcessing = !1
        }
        didUpdate() {
            this.updateScheduled || (this.updateScheduled = !0,
            Hc.read(this.scheduleUpdate))
        }
        clearAllSnapshots() {
            this.nodes.forEach(rw),
            this.sharedNodes.forEach(cw)
        }
        scheduleUpdateProjection() {
            this.projectionUpdateScheduled || (this.projectionUpdateScheduled = !0,
            ze.preRender(this.updateProjection, !1, !0))
        }
        scheduleCheckAfterUnmount() {
            ze.postRender( () => {
                this.isLayoutDirty ? this.root.didUpdate() : this.root.checkUpdateFailed()
            }
            )
        }
        updateSnapshot() {
            this.snapshot || !this.instance || (this.snapshot = this.measure())
        }
        updateLayout() {
            if (!this.instance || (this.updateScroll(),
            !(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))
                return;
            if (this.resumeFrom && !this.resumeFrom.instance)
                for (let p = 0; p < this.path.length; p++)
                    this.path[p].updateScroll();
            const u = this.layout;
            this.layout = this.measure(!1),
            this.layoutCorrected = Re(),
            this.isLayoutDirty = !1,
            this.projectionDelta = void 0,
            this.notifyListeners("measure", this.layout.layoutBox);
            const {visualElement: d} = this.options;
            d && d.notify("LayoutMeasure", this.layout.layoutBox, u ? u.layoutBox : void 0)
        }
        updateScroll(u="measure") {
            let d = !!(this.options.layoutScroll && this.instance);
            if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === u && (d = !1),
            d) {
                const p = a(this.instance);
                this.scroll = {
                    animationId: this.root.animationId,
                    phase: u,
                    isRoot: p,
                    offset: r(this.instance),
                    wasRoot: this.scroll ? this.scroll.isRoot : p
                }
            }
        }
        resetTransform() {
            if (!o)
                return;
            const u = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout
              , d = this.projectionDelta && !Yg(this.projectionDelta)
              , p = this.getTransformTemplate()
              , h = p ? p(this.latestValues, "") : void 0
              , g = h !== this.prevTransformTemplateValue;
            u && (d || $i(this.latestValues) || g) && (o(this.instance, h),
            this.shouldResetTransform = !1,
            this.scheduleRender())
        }
        measure(u=!0) {
            const d = this.measurePageBox();
            let p = this.removeElementScroll(d);
            return u && (p = this.removeTransform(p)),
            mw(p),
            {
                animationId: this.root.animationId,
                measuredBox: d,
                layoutBox: p,
                latestValues: {},
                source: this.id
            }
        }
        measurePageBox() {
            var u;
            const {visualElement: d} = this.options;
            if (!d)
                return Re();
            const p = d.measureViewportBox();
            if (!(((u = this.scroll) === null || u === void 0 ? void 0 : u.wasRoot) || this.path.some(hw))) {
                const {scroll: g} = this.root;
                g && (Dr(p.x, g.offset.x),
                Dr(p.y, g.offset.y))
            }
            return p
        }
        removeElementScroll(u) {
            var d;
            const p = Re();
            if (Ct(p, u),
            !((d = this.scroll) === null || d === void 0) && d.wasRoot)
                return p;
            for (let h = 0; h < this.path.length; h++) {
                const g = this.path[h]
                  , {scroll: v, options: y} = g;
                g !== this.root && v && y.layoutScroll && (v.wasRoot && Ct(p, u),
                Dr(p.x, v.offset.x),
                Dr(p.y, v.offset.y))
            }
            return p
        }
        applyTransform(u, d=!1) {
            const p = Re();
            Ct(p, u);
            for (let h = 0; h < this.path.length; h++) {
                const g = this.path[h];
                !d && g.options.layoutScroll && g.scroll && g !== g.root && Ir(p, {
                    x: -g.scroll.offset.x,
                    y: -g.scroll.offset.y
                }),
                $i(g.latestValues) && Ir(p, g.latestValues)
            }
            return $i(this.latestValues) && Ir(p, this.latestValues),
            p
        }
        removeTransform(u) {
            const d = Re();
            Ct(d, u);
            for (let p = 0; p < this.path.length; p++) {
                const h = this.path[p];
                if (!h.instance || !$i(h.latestValues))
                    continue;
                Cc(h.latestValues) && h.updateSnapshot();
                const g = Re()
                  , v = h.measurePageBox();
                Ct(g, v),
                Sh(d, h.latestValues, h.snapshot ? h.snapshot.layoutBox : void 0, g)
            }
            return $i(this.latestValues) && Sh(d, this.latestValues),
            d
        }
        setTargetDelta(u) {
            this.targetDelta = u,
            this.root.scheduleUpdateProjection(),
            this.isProjectionDirty = !0
        }
        setOptions(u) {
            this.options = {
                ...this.options,
                ...u,
                crossfade: u.crossfade !== void 0 ? u.crossfade : !0
            }
        }
        clearMeasurements() {
            this.scroll = void 0,
            this.layout = void 0,
            this.snapshot = void 0,
            this.prevTransformTemplateValue = void 0,
            this.targetDelta = void 0,
            this.target = void 0,
            this.isLayoutDirty = !1
        }
        forceRelativeParentToResolveTarget() {
            this.relativeParent && this.relativeParent.resolvedRelativeTargetAt !== Ze.timestamp && this.relativeParent.resolveTargetDelta(!0)
        }
        resolveTargetDelta(u=!1) {
            var d;
            const p = this.getLead();
            this.isProjectionDirty || (this.isProjectionDirty = p.isProjectionDirty),
            this.isTransformDirty || (this.isTransformDirty = p.isTransformDirty),
            this.isSharedProjectionDirty || (this.isSharedProjectionDirty = p.isSharedProjectionDirty);
            const h = !!this.resumingFrom || this !== p;
            if (!(u || h && this.isSharedProjectionDirty || this.isProjectionDirty || !((d = this.parent) === null || d === void 0) && d.isProjectionDirty || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize))
                return;
            const {layout: v, layoutId: y} = this.options;
            if (!(!this.layout || !(v || y))) {
                if (this.resolvedRelativeTargetAt = Ze.timestamp,
                !this.targetDelta && !this.relativeTarget) {
                    const P = this.getClosestProjectingParent();
                    P && P.layout && this.animationProgress !== 1 ? (this.relativeParent = P,
                    this.forceRelativeParentToResolveTarget(),
                    this.relativeTarget = Re(),
                    this.relativeTargetOrigin = Re(),
                    Ln(this.relativeTargetOrigin, this.layout.layoutBox, P.layout.layoutBox),
                    Ct(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0
                }
                if (!(!this.relativeTarget && !this.targetDelta)) {
                    if (this.target || (this.target = Re(),
                    this.targetWithTransforms = Re()),
                    this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target ? (this.forceRelativeParentToResolveTarget(),
                    v2(this.target, this.relativeTarget, this.relativeParent.target)) : this.targetDelta ? (this.resumingFrom ? this.target = this.applyTransform(this.layout.layoutBox) : Ct(this.target, this.layout.layoutBox),
                    $g(this.target, this.targetDelta)) : Ct(this.target, this.layout.layoutBox),
                    this.attemptToResolveRelativeTarget) {
                        this.attemptToResolveRelativeTarget = !1;
                        const P = this.getClosestProjectingParent();
                        P && !!P.resumingFrom == !!this.resumingFrom && !P.options.layoutScroll && P.target && this.animationProgress !== 1 ? (this.relativeParent = P,
                        this.forceRelativeParentToResolveTarget(),
                        this.relativeTarget = Re(),
                        this.relativeTargetOrigin = Re(),
                        Ln(this.relativeTargetOrigin, this.target, P.target),
                        Ct(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0
                    }
                    Dn && Hi.resolvedTargetDeltas++
                }
            }
        }
        getClosestProjectingParent() {
            if (!(!this.parent || Cc(this.parent.latestValues) || Kg(this.parent.latestValues)))
                return this.parent.isProjecting() ? this.parent : this.parent.getClosestProjectingParent()
        }
        isProjecting() {
            return !!((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout)
        }
        calcProjection() {
            var u;
            const d = this.getLead()
              , p = !!this.resumingFrom || this !== d;
            let h = !0;
            if ((this.isProjectionDirty || !((u = this.parent) === null || u === void 0) && u.isProjectionDirty) && (h = !1),
            p && (this.isSharedProjectionDirty || this.isTransformDirty) && (h = !1),
            this.resolvedRelativeTargetAt === Ze.timestamp && (h = !1),
            h)
                return;
            const {layout: g, layoutId: v} = this.options;
            if (this.isTreeAnimating = !!(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation),
            this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0),
            !this.layout || !(g || v))
                return;
            Ct(this.layoutCorrected, this.layout.layoutBox);
            const y = this.treeScale.x
              , P = this.treeScale.y;
            j2(this.layoutCorrected, this.treeScale, this.path, p),
            d.layout && !d.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1) && (d.target = d.layout.layoutBox,
            d.targetWithTransforms = Re());
            const {target: w} = d;
            if (!w) {
                this.prevProjectionDelta && (this.createProjectionDeltas(),
                this.scheduleRender());
                return
            }
            !this.projectionDelta || !this.prevProjectionDelta ? this.createProjectionDeltas() : (wh(this.prevProjectionDelta.x, this.projectionDelta.x),
            wh(this.prevProjectionDelta.y, this.projectionDelta.y)),
            Vn(this.projectionDelta, this.layoutCorrected, w, this.latestValues),
            (this.treeScale.x !== y || this.treeScale.y !== P || !Ah(this.projectionDelta.x, this.prevProjectionDelta.x) || !Ah(this.projectionDelta.y, this.prevProjectionDelta.y)) && (this.hasProjected = !0,
            this.scheduleRender(),
            this.notifyListeners("projectionUpdate", w)),
            Dn && Hi.recalculatedProjection++
        }
        hide() {
            this.isVisible = !1
        }
        show() {
            this.isVisible = !0
        }
        scheduleRender(u=!0) {
            var d;
            if ((d = this.options.visualElement) === null || d === void 0 || d.scheduleRender(),
            u) {
                const p = this.getStack();
                p && p.scheduleRender()
            }
            this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0)
        }
        createProjectionDeltas() {
            this.prevProjectionDelta = Er(),
            this.projectionDelta = Er(),
            this.projectionDeltaWithTransform = Er()
        }
        setAnimationOrigin(u, d=!1) {
            const p = this.snapshot
              , h = p ? p.latestValues : {}
              , g = {
                ...this.latestValues
            }
              , v = Er();
            (!this.relativeParent || !this.relativeParent.options.layoutRoot) && (this.relativeTarget = this.relativeTargetOrigin = void 0),
            this.attemptToResolveRelativeTarget = !d;
            const y = Re()
              , P = p ? p.source : void 0
              , w = this.layout ? this.layout.source : void 0
              , S = P !== w
              , z = this.getStack()
              , C = !z || z.members.length <= 1
              , b = !!(S && !C && this.options.crossfade === !0 && !this.path.some(dw));
            this.animationProgress = 0;
            let T;
            this.mixTargetDelta = D => {
                const M = D / 1e3;
                Mh(v.x, u.x, M),
                Mh(v.y, u.y, M),
                this.setTargetDelta(v),
                this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout && (Ln(y, this.layout.layoutBox, this.relativeParent.layout.layoutBox),
                uw(this.relativeTarget, this.relativeTargetOrigin, y, M),
                T && q2(this.relativeTarget, T) && (this.isProjectionDirty = !1),
                T || (T = Re()),
                Ct(T, this.relativeTarget)),
                S && (this.animationValues = g,
                _2(g, h, this.latestValues, M, b, C)),
                this.root.scheduleUpdateProjection(),
                this.scheduleRender(),
                this.animationProgress = M
            }
            ,
            this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0)
        }
        startAnimation(u) {
            this.notifyListeners("animationStart"),
            this.currentAnimation && this.currentAnimation.stop(),
            this.resumingFrom && this.resumingFrom.currentAnimation && this.resumingFrom.currentAnimation.stop(),
            this.pendingAnimation && (zi(this.pendingAnimation),
            this.pendingAnimation = void 0),
            this.pendingAnimation = ze.update( () => {
                ks.hasAnimatedSinceResize = !0,
                this.currentAnimation = O2(0, Eh, {
                    ...u,
                    onUpdate: d => {
                        this.mixTargetDelta(d),
                        u.onUpdate && u.onUpdate(d)
                    }
                    ,
                    onComplete: () => {
                        u.onComplete && u.onComplete(),
                        this.completeAnimation()
                    }
                }),
                this.resumingFrom && (this.resumingFrom.currentAnimation = this.currentAnimation),
                this.pendingAnimation = void 0
            }
            )
        }
        completeAnimation() {
            this.resumingFrom && (this.resumingFrom.currentAnimation = void 0,
            this.resumingFrom.preserveOpacity = void 0);
            const u = this.getStack();
            u && u.exitAnimationComplete(),
            this.resumingFrom = this.currentAnimation = this.animationValues = void 0,
            this.notifyListeners("animationComplete")
        }
        finishAnimation() {
            this.currentAnimation && (this.mixTargetDelta && this.mixTargetDelta(Eh),
            this.currentAnimation.stop()),
            this.completeAnimation()
        }
        applyTransformsToTarget() {
            const u = this.getLead();
            let {targetWithTransforms: d, target: p, layout: h, latestValues: g} = u;
            if (!(!d || !p || !h)) {
                if (this !== u && this.layout && h && t0(this.options.animationType, this.layout.layoutBox, h.layoutBox)) {
                    p = this.target || Re();
                    const v = xt(this.layout.layoutBox.x);
                    p.x.min = u.target.x.min,
                    p.x.max = p.x.min + v;
                    const y = xt(this.layout.layoutBox.y);
                    p.y.min = u.target.y.min,
                    p.y.max = p.y.min + y
                }
                Ct(d, p),
                Ir(d, g),
                Vn(this.projectionDeltaWithTransform, this.layoutCorrected, d, g)
            }
        }
        registerSharedNode(u, d) {
            this.sharedNodes.has(u) || this.sharedNodes.set(u, new X2),
            this.sharedNodes.get(u).add(d);
            const h = d.options.initialPromotionConfig;
            d.promote({
                transition: h ? h.transition : void 0,
                preserveFollowOpacity: h && h.shouldPreserveFollowOpacity ? h.shouldPreserveFollowOpacity(d) : void 0
            })
        }
        isLead() {
            const u = this.getStack();
            return u ? u.lead === this : !0
        }
        getLead() {
            var u;
            const {layoutId: d} = this.options;
            return d ? ((u = this.getStack()) === null || u === void 0 ? void 0 : u.lead) || this : this
        }
        getPrevLead() {
            var u;
            const {layoutId: d} = this.options;
            return d ? (u = this.getStack()) === null || u === void 0 ? void 0 : u.prevLead : void 0
        }
        getStack() {
            const {layoutId: u} = this.options;
            if (u)
                return this.root.sharedNodes.get(u)
        }
        promote({needsReset: u, transition: d, preserveFollowOpacity: p}={}) {
            const h = this.getStack();
            h && h.promote(this, p),
            u && (this.projectionDelta = void 0,
            this.needsReset = !0),
            d && this.setOptions({
                transition: d
            })
        }
        relegate() {
            const u = this.getStack();
            return u ? u.relegate(this) : !1
        }
        resetSkewAndRotation() {
            const {visualElement: u} = this.options;
            if (!u)
                return;
            let d = !1;
            const {latestValues: p} = u;
            if ((p.z || p.rotate || p.rotateX || p.rotateY || p.rotateZ || p.skewX || p.skewY) && (d = !0),
            !d)
                return;
            const h = {};
            p.z && ec("z", u, h, this.animationValues);
            for (let g = 0; g < Jl.length; g++)
                ec(`rotate${Jl[g]}`, u, h, this.animationValues),
                ec(`skew${Jl[g]}`, u, h, this.animationValues);
            u.render();
            for (const g in h)
                u.setStaticValue(g, h[g]),
                this.animationValues && (this.animationValues[g] = h[g]);
            u.scheduleRender()
        }
        getProjectionStyles(u) {
            var d, p;
            if (!this.instance || this.isSVG)
                return;
            if (!this.isVisible)
                return Y2;
            const h = {
                visibility: ""
            }
              , g = this.getTransformTemplate();
            if (this.needsReset)
                return this.needsReset = !1,
                h.opacity = "",
                h.pointerEvents = vs(u == null ? void 0 : u.pointerEvents) || "",
                h.transform = g ? g(this.latestValues, "") : "none",
                h;
            const v = this.getLead();
            if (!this.projectionDelta || !this.layout || !v.target) {
                const S = {};
                return this.options.layoutId && (S.opacity = this.latestValues.opacity !== void 0 ? this.latestValues.opacity : 1,
                S.pointerEvents = vs(u == null ? void 0 : u.pointerEvents) || ""),
                this.hasProjected && !$i(this.latestValues) && (S.transform = g ? g({}, "") : "none",
                this.hasProjected = !1),
                S
            }
            const y = v.animationValues || v.latestValues;
            this.applyTransformsToTarget(),
            h.transform = Z2(this.projectionDeltaWithTransform, this.treeScale, y),
            g && (h.transform = g(y, h.transform));
            const {x: P, y: w} = this.projectionDelta;
            h.transformOrigin = `${P.origin * 100}% ${w.origin * 100}% 0`,
            v.animationValues ? h.opacity = v === this ? (p = (d = y.opacity) !== null && d !== void 0 ? d : this.latestValues.opacity) !== null && p !== void 0 ? p : 1 : this.preserveOpacity ? this.latestValues.opacity : y.opacityExit : h.opacity = v === this ? y.opacity !== void 0 ? y.opacity : "" : y.opacityExit !== void 0 ? y.opacityExit : 0;
            for (const S in Ps) {
                if (y[S] === void 0)
                    continue;
                const {correct: z, applyTo: C} = Ps[S]
                  , b = h.transform === "none" ? y[S] : z(y[S], v);
                if (C) {
                    const T = C.length;
                    for (let D = 0; D < T; D++)
                        h[C[D]] = b
                } else
                    h[S] = b
            }
            return this.options.layoutId && (h.pointerEvents = v === this ? vs(u == null ? void 0 : u.pointerEvents) || "" : "none"),
            h
        }
        clearSnapshot() {
            this.resumeFrom = this.snapshot = void 0
        }
        resetTree() {
            this.root.nodes.forEach(u => {
                var d;
                return (d = u.currentAnimation) === null || d === void 0 ? void 0 : d.stop()
            }
            ),
            this.root.nodes.forEach(Dh),
            this.root.sharedNodes.clear()
        }
    }
}
function J2(i) {
    i.updateLayout()
}
function ew(i) {
    var e;
    const r = ((e = i.resumeFrom) === null || e === void 0 ? void 0 : e.snapshot) || i.snapshot;
    if (i.isLead() && i.layout && r && i.hasListeners("didUpdate")) {
        const {layoutBox: a, measuredBox: o} = i.layout
          , {animationType: l} = i.options
          , u = r.source !== i.layout.source;
        l === "size" ? zt(v => {
            const y = u ? r.measuredBox[v] : r.layoutBox[v]
              , P = xt(y);
            y.min = a[v].min,
            y.max = y.min + P
        }
        ) : t0(l, r.layoutBox, a) && zt(v => {
            const y = u ? r.measuredBox[v] : r.layoutBox[v]
              , P = xt(a[v]);
            y.max = y.min + P,
            i.relativeTarget && !i.currentAnimation && (i.isProjectionDirty = !0,
            i.relativeTarget[v].max = i.relativeTarget[v].min + P)
        }
        );
        const d = Er();
        Vn(d, a, r.layoutBox);
        const p = Er();
        u ? Vn(p, i.applyTransform(o, !0), r.measuredBox) : Vn(p, a, r.layoutBox);
        const h = !Yg(d);
        let g = !1;
        if (!i.resumeFrom) {
            const v = i.getClosestProjectingParent();
            if (v && !v.resumeFrom) {
                const {snapshot: y, layout: P} = v;
                if (y && P) {
                    const w = Re();
                    Ln(w, r.layoutBox, y.layoutBox);
                    const S = Re();
                    Ln(S, a, P.layoutBox),
                    Qg(w, S) || (g = !0),
                    v.options.layoutRoot && (i.relativeTarget = S,
                    i.relativeTargetOrigin = w,
                    i.relativeParent = v)
                }
            }
        }
        i.notifyListeners("didUpdate", {
            layout: a,
            snapshot: r,
            delta: p,
            layoutDelta: d,
            hasLayoutChanged: h,
            hasRelativeTargetChanged: g
        })
    } else if (i.isLead()) {
        const {onExitComplete: a} = i.options;
        a && a()
    }
    i.options.transition = void 0
}
function tw(i) {
    Dn && Hi.totalNodes++,
    i.parent && (i.isProjecting() || (i.isProjectionDirty = i.parent.isProjectionDirty),
    i.isSharedProjectionDirty || (i.isSharedProjectionDirty = !!(i.isProjectionDirty || i.parent.isProjectionDirty || i.parent.isSharedProjectionDirty)),
    i.isTransformDirty || (i.isTransformDirty = i.parent.isTransformDirty))
}
function iw(i) {
    i.isProjectionDirty = i.isSharedProjectionDirty = i.isTransformDirty = !1
}
function rw(i) {
    i.clearSnapshot()
}
function Dh(i) {
    i.clearMeasurements()
}
function nw(i) {
    i.isLayoutDirty = !1
}
function aw(i) {
    const {visualElement: e} = i.options;
    e && e.getProps().onBeforeLayoutMeasure && e.notify("BeforeLayoutMeasure"),
    i.resetTransform()
}
function Ih(i) {
    i.finishAnimation(),
    i.targetDelta = i.relativeTarget = i.target = void 0,
    i.isProjectionDirty = !0
}
function sw(i) {
    i.resolveTargetDelta()
}
function ow(i) {
    i.calcProjection()
}
function lw(i) {
    i.resetSkewAndRotation()
}
function cw(i) {
    i.removeLeadSnapshot()
}
function Mh(i, e, r) {
    i.translate = Ve(e.translate, 0, r),
    i.scale = Ve(e.scale, 1, r),
    i.origin = e.origin,
    i.originPoint = e.originPoint
}
function Vh(i, e, r, a) {
    i.min = Ve(e.min, r.min, a),
    i.max = Ve(e.max, r.max, a)
}
function uw(i, e, r, a) {
    Vh(i.x, e.x, r.x, a),
    Vh(i.y, e.y, r.y, a)
}
function dw(i) {
    return i.animationValues && i.animationValues.opacityExit !== void 0
}
const pw = {
    duration: .45,
    ease: [.4, 0, .1, 1]
}
  , Lh = i => typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(i)
  , Oh = Lh("applewebkit/") && !Lh("chrome/") ? Math.round : kt;
function Nh(i) {
    i.min = Oh(i.min),
    i.max = Oh(i.max)
}
function mw(i) {
    Nh(i.x),
    Nh(i.y)
}
function t0(i, e, r) {
    return i === "position" || i === "preserve-aspect" && !g2(zh(e), zh(r), .2)
}
function hw(i) {
    var e;
    return i !== i.root && ((e = i.scroll) === null || e === void 0 ? void 0 : e.wasRoot)
}
const fw = e0({
    attachResizeListener: (i, e) => _n(i, "resize", e),
    measureScroll: () => ({
        x: document.documentElement.scrollLeft || document.body.scrollLeft,
        y: document.documentElement.scrollTop || document.body.scrollTop
    }),
    checkIsScrollRoot: () => !0
})
  , tc = {
    current: void 0
}
  , i0 = e0({
    measureScroll: i => ({
        x: i.scrollLeft,
        y: i.scrollTop
    }),
    defaultParent: () => {
        if (!tc.current) {
            const i = new fw({});
            i.mount(window),
            i.setOptions({
                layoutScroll: !0
            }),
            tc.current = i
        }
        return tc.current
    }
    ,
    resetTransform: (i, e) => {
        i.style.transform = e !== void 0 ? e : "none"
    }
    ,
    checkIsScrollRoot: i => window.getComputedStyle(i).position === "fixed"
})
  , gw = {
    pan: {
        Feature: I2
    },
    drag: {
        Feature: D2,
        ProjectionNode: i0,
        MeasureLayout: qg
    }
};
function Fh(i, e, r) {
    const {props: a} = i;
    i.animationState && a.whileHover && i.animationState.setActive("whileHover", r === "Start");
    const o = "onHover" + r
      , l = a[o];
    l && ze.postRender( () => l(e, qn(e)))
}
class vw extends Ei {
    mount() {
        const {current: e} = this.node;
        e && (this.unmount = gk(e, r => (Fh(this.node, r, "Start"),
        a => Fh(this.node, a, "End"))))
    }
    unmount() {}
}
class yw extends Ei {
    constructor() {
        super(...arguments),
        this.isActive = !1
    }
    onFocus() {
        let e = !1;
        try {
            e = this.node.current.matches(":focus-visible")
        } catch {
            e = !0
        }
        !e || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !0),
        this.isActive = !0)
    }
    onBlur() {
        !this.isActive || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !1),
        this.isActive = !1)
    }
    mount() {
        this.unmount = Gn(_n(this.node.current, "focus", () => this.onFocus()), _n(this.node.current, "blur", () => this.onBlur()))
    }
    unmount() {}
}
function Rh(i, e, r) {
    const {props: a} = i;
    i.animationState && a.whileTap && i.animationState.setActive("whileTap", r === "Start");
    const o = "onTap" + (r === "End" ? "" : r)
      , l = a[o];
    l && ze.postRender( () => l(e, qn(e)))
}
class kw extends Ei {
    mount() {
        const {current: e} = this.node;
        e && (this.unmount = xk(e, r => (Rh(this.node, r, "Start"),
        (a, {success: o}) => Rh(this.node, a, o ? "End" : "Cancel")), {
            useGlobalTarget: this.node.props.globalTapTarget
        }))
    }
    unmount() {}
}
const Ac = new WeakMap
  , ic = new WeakMap
  , xw = i => {
    const e = Ac.get(i.target);
    e && e(i)
}
  , ww = i => {
    i.forEach(xw)
}
;
function Pw({root: i, ...e}) {
    const r = i || document;
    ic.has(r) || ic.set(r, {});
    const a = ic.get(r)
      , o = JSON.stringify(e);
    return a[o] || (a[o] = new IntersectionObserver(ww,{
        root: i,
        ...e
    })),
    a[o]
}
function bw(i, e, r) {
    const a = Pw(e);
    return Ac.set(i, r),
    a.observe(i),
    () => {
        Ac.delete(i),
        a.unobserve(i)
    }
}
const Sw = {
    some: 0,
    all: 1
};
class Tw extends Ei {
    constructor() {
        super(...arguments),
        this.hasEnteredView = !1,
        this.isInView = !1
    }
    startObserver() {
        this.unmount();
        const {viewport: e={}} = this.node.getProps()
          , {root: r, margin: a, amount: o="some", once: l} = e
          , u = {
            root: r ? r.current : void 0,
            rootMargin: a,
            threshold: typeof o == "number" ? o : Sw[o]
        }
          , d = p => {
            const {isIntersecting: h} = p;
            if (this.isInView === h || (this.isInView = h,
            l && !h && this.hasEnteredView))
                return;
            h && (this.hasEnteredView = !0),
            this.node.animationState && this.node.animationState.setActive("whileInView", h);
            const {onViewportEnter: g, onViewportLeave: v} = this.node.getProps()
              , y = h ? g : v;
            y && y(p)
        }
        ;
        return bw(this.node.current, u, d)
    }
    mount() {
        this.startObserver()
    }
    update() {
        if (typeof IntersectionObserver > "u")
            return;
        const {props: e, prevProps: r} = this.node;
        ["amount", "margin", "root"].some(jw(e, r)) && this.startObserver()
    }
    unmount() {}
}
function jw({viewport: i={}}, {viewport: e={}}={}) {
    return r => i[r] !== e[r]
}
const Cw = {
    inView: {
        Feature: Tw
    },
    tap: {
        Feature: kw
    },
    focus: {
        Feature: yw
    },
    hover: {
        Feature: vw
    }
}
  , zw = {
    layout: {
        ProjectionNode: i0,
        MeasureLayout: qg
    }
}
  , Ec = {
    current: null
}
  , r0 = {
    current: !1
};
function Aw() {
    if (r0.current = !0,
    !!Wc)
        if (window.matchMedia) {
            const i = window.matchMedia("(prefers-reduced-motion)")
              , e = () => Ec.current = i.matches;
            i.addListener(e),
            e()
        } else
            Ec.current = !1
}
const Ew = [...zg, tt, Ai]
  , Dw = i => Ew.find(Cg(i))
  , Bh = new WeakMap;
function Iw(i, e, r) {
    for (const a in e) {
        const o = e[a]
          , l = r[a];
        if (it(o))
            i.addValue(a, o);
        else if (it(l))
            i.addValue(a, Bn(o, {
                owner: i
            }));
        else if (l !== o)
            if (i.hasValue(a)) {
                const u = i.getValue(a);
                u.liveStyle === !0 ? u.jump(o) : u.hasAnimated || u.set(o)
            } else {
                const u = i.getStaticValue(a);
                i.addValue(a, Bn(u !== void 0 ? u : o, {
                    owner: i
                }))
            }
    }
    for (const a in r)
        e[a] === void 0 && i.removeValue(a);
    return e
}
const Wh = ["AnimationStart", "AnimationComplete", "Update", "BeforeLayoutMeasure", "LayoutMeasure", "LayoutAnimationStart", "LayoutAnimationComplete"];
class Mw {
    scrapeMotionValuesFromProps(e, r, a) {
        return {}
    }
    constructor({parent: e, props: r, presenceContext: a, reducedMotionConfig: o, blockInitialAnimation: l, visualState: u}, d={}) {
        this.current = null,
        this.children = new Set,
        this.isVariantNode = !1,
        this.isControllingVariants = !1,
        this.shouldReduceMotion = null,
        this.values = new Map,
        this.KeyframeResolver = hu,
        this.features = {},
        this.valueSubscriptions = new Map,
        this.prevMotionValues = {},
        this.events = {},
        this.propEventSubscriptions = {},
        this.notifyUpdate = () => this.notify("Update", this.latestValues),
        this.render = () => {
            this.current && (this.triggerBuild(),
            this.renderInstance(this.current, this.renderState, this.props.style, this.projection))
        }
        ,
        this.renderScheduledAt = 0,
        this.scheduleRender = () => {
            const P = $t.now();
            this.renderScheduledAt < P && (this.renderScheduledAt = P,
            ze.render(this.render, !1, !0))
        }
        ;
        const {latestValues: p, renderState: h, onUpdate: g} = u;
        this.onUpdate = g,
        this.latestValues = p,
        this.baseTarget = {
            ...p
        },
        this.initialValues = r.initial ? {
            ...p
        } : {},
        this.renderState = h,
        this.parent = e,
        this.props = r,
        this.presenceContext = a,
        this.depth = e ? e.depth + 1 : 0,
        this.reducedMotionConfig = o,
        this.options = d,
        this.blockInitialAnimation = !!l,
        this.isControllingVariants = Ws(r),
        this.isVariantNode = Lf(r),
        this.isVariantNode && (this.variantChildren = new Set),
        this.manuallyAnimateOnMount = !!(e && e.current);
        const {willChange: v, ...y} = this.scrapeMotionValuesFromProps(r, {}, this);
        for (const P in y) {
            const w = y[P];
            p[P] !== void 0 && it(w) && w.set(p[P], !1)
        }
    }
    mount(e) {
        this.current = e,
        Bh.set(e, this),
        this.projection && !this.projection.instance && this.projection.mount(e),
        this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)),
        this.values.forEach( (r, a) => this.bindToMotionValue(a, r)),
        r0.current || Aw(),
        this.shouldReduceMotion = this.reducedMotionConfig === "never" ? !1 : this.reducedMotionConfig === "always" ? !0 : Ec.current,
        this.parent && this.parent.children.add(this),
        this.update(this.props, this.presenceContext)
    }
    unmount() {
        Bh.delete(this.current),
        this.projection && this.projection.unmount(),
        zi(this.notifyUpdate),
        zi(this.render),
        this.valueSubscriptions.forEach(e => e()),
        this.valueSubscriptions.clear(),
        this.removeFromVariantTree && this.removeFromVariantTree(),
        this.parent && this.parent.children.delete(this);
        for (const e in this.events)
            this.events[e].clear();
        for (const e in this.features) {
            const r = this.features[e];
            r && (r.unmount(),
            r.isMounted = !1)
        }
        this.current = null
    }
    bindToMotionValue(e, r) {
        this.valueSubscriptions.has(e) && this.valueSubscriptions.get(e)();
        const a = Yi.has(e)
          , o = r.on("change", d => {
            this.latestValues[e] = d,
            this.props.onUpdate && ze.preRender(this.notifyUpdate),
            a && this.projection && (this.projection.isTransformDirty = !0)
        }
        )
          , l = r.on("renderRequest", this.scheduleRender);
        let u;
        window.MotionCheckAppearSync && (u = window.MotionCheckAppearSync(this, e, r)),
        this.valueSubscriptions.set(e, () => {
            o(),
            l(),
            u && u(),
            r.owner && r.stop()
        }
        )
    }
    sortNodePosition(e) {
        return !this.current || !this.sortInstanceNodePosition || this.type !== e.type ? 0 : this.sortInstanceNodePosition(this.current, e.current)
    }
    updateFeatures() {
        let e = "animation";
        for (e in Lr) {
            const r = Lr[e];
            if (!r)
                continue;
            const {isEnabled: a, Feature: o} = r;
            if (!this.features[e] && o && a(this.props) && (this.features[e] = new o(this)),
            this.features[e]) {
                const l = this.features[e];
                l.isMounted ? l.update() : (l.mount(),
                l.isMounted = !0)
            }
        }
    }
    triggerBuild() {
        this.build(this.renderState, this.latestValues, this.props)
    }
    measureViewportBox() {
        return this.current ? this.measureInstanceViewportBox(this.current, this.props) : Re()
    }
    getStaticValue(e) {
        return this.latestValues[e]
    }
    setStaticValue(e, r) {
        this.latestValues[e] = r
    }
    update(e, r) {
        (e.transformTemplate || this.props.transformTemplate) && this.scheduleRender(),
        this.prevProps = this.props,
        this.props = e,
        this.prevPresenceContext = this.presenceContext,
        this.presenceContext = r;
        for (let a = 0; a < Wh.length; a++) {
            const o = Wh[a];
            this.propEventSubscriptions[o] && (this.propEventSubscriptions[o](),
            delete this.propEventSubscriptions[o]);
            const l = "on" + o
              , u = e[l];
            u && (this.propEventSubscriptions[o] = this.on(o, u))
        }
        this.prevMotionValues = Iw(this, this.scrapeMotionValuesFromProps(e, this.prevProps, this), this.prevMotionValues),
        this.handleChildMotionValue && this.handleChildMotionValue(),
        this.onUpdate && this.onUpdate(this)
    }
    getProps() {
        return this.props
    }
    getVariant(e) {
        return this.props.variants ? this.props.variants[e] : void 0
    }
    getDefaultTransition() {
        return this.props.transition
    }
    getTransformPagePoint() {
        return this.props.transformPagePoint
    }
    getClosestVariantNode() {
        return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0
    }
    addVariantChild(e) {
        const r = this.getClosestVariantNode();
        if (r)
            return r.variantChildren && r.variantChildren.add(e),
            () => r.variantChildren.delete(e)
    }
    addValue(e, r) {
        const a = this.values.get(e);
        r !== a && (a && this.removeValue(e),
        this.bindToMotionValue(e, r),
        this.values.set(e, r),
        this.latestValues[e] = r.get())
    }
    removeValue(e) {
        this.values.delete(e);
        const r = this.valueSubscriptions.get(e);
        r && (r(),
        this.valueSubscriptions.delete(e)),
        delete this.latestValues[e],
        this.removeValueFromRenderState(e, this.renderState)
    }
    hasValue(e) {
        return this.values.has(e)
    }
    getValue(e, r) {
        if (this.props.values && this.props.values[e])
            return this.props.values[e];
        let a = this.values.get(e);
        return a === void 0 && r !== void 0 && (a = Bn(r === null ? void 0 : r, {
            owner: this
        }),
        this.addValue(e, a)),
        a
    }
    readValue(e, r) {
        var a;
        let o = this.latestValues[e] !== void 0 || !this.current ? this.latestValues[e] : (a = this.getBaseTargetFromProps(this.props, e)) !== null && a !== void 0 ? a : this.readValueFromInstance(this.current, e, this.options);
        return o != null && (typeof o == "string" && (Tg(o) || gg(o)) ? o = parseFloat(o) : !Dw(o) && Ai.test(r) && (o = Pg(e, r)),
        this.setBaseTarget(e, it(o) ? o.get() : o)),
        it(o) ? o.get() : o
    }
    setBaseTarget(e, r) {
        this.baseTarget[e] = r
    }
    getBaseTarget(e) {
        var r;
        const {initial: a} = this.props;
        let o;
        if (typeof a == "string" || typeof a == "object") {
            const u = qc(this.props, a, (r = this.presenceContext) === null || r === void 0 ? void 0 : r.custom);
            u && (o = u[e])
        }
        if (a && o !== void 0)
            return o;
        const l = this.getBaseTargetFromProps(this.props, e);
        return l !== void 0 && !it(l) ? l : this.initialValues[e] !== void 0 && o === void 0 ? void 0 : this.baseTarget[e]
    }
    on(e, r) {
        return this.events[e] || (this.events[e] = new lu),
        this.events[e].add(r)
    }
    notify(e, ...r) {
        this.events[e] && this.events[e].notify(...r)
    }
}
class n0 extends Mw {
    constructor() {
        super(...arguments),
        this.KeyframeResolver = Ag
    }
    sortInstanceNodePosition(e, r) {
        return e.compareDocumentPosition(r) & 2 ? 1 : -1
    }
    getBaseTargetFromProps(e, r) {
        return e.style ? e.style[r] : void 0
    }
    removeValueFromRenderState(e, {vars: r, style: a}) {
        delete r[e],
        delete a[e]
    }
    handleChildMotionValue() {
        this.childSubscription && (this.childSubscription(),
        delete this.childSubscription);
        const {children: e} = this.props;
        it(e) && (this.childSubscription = e.on("change", r => {
            this.current && (this.current.textContent = `${r}`)
        }
        ))
    }
}
function Vw(i) {
    return window.getComputedStyle(i)
}
class Lw extends n0 {
    constructor() {
        super(...arguments),
        this.type = "html",
        this.renderInstance = Kf
    }
    readValueFromInstance(e, r) {
        if (Yi.has(r)) {
            const a = mu(r);
            return a && a.default || 0
        } else {
            const a = Vw(e)
              , o = (Wf(r) ? a.getPropertyValue(r) : a[r]) || 0;
            return typeof o == "string" ? o.trim() : o
        }
    }
    measureInstanceViewportBox(e, {transformPagePoint: r}) {
        return Hg(e, r)
    }
    build(e, r, a) {
        Yc(e, r, a.transformTemplate)
    }
    scrapeMotionValuesFromProps(e, r, a) {
        return tu(e, r, a)
    }
}
class Ow extends n0 {
    constructor() {
        super(...arguments),
        this.type = "svg",
        this.isSVGTag = !1,
        this.measureInstanceViewportBox = Re
    }
    getBaseTargetFromProps(e, r) {
        return e[r]
    }
    readValueFromInstance(e, r) {
        if (Yi.has(r)) {
            const a = mu(r);
            return a && a.default || 0
        }
        return r = $f.has(r) ? r : $c(r),
        e.getAttribute(r)
    }
    scrapeMotionValuesFromProps(e, r, a) {
        return qf(e, r, a)
    }
    build(e, r, a) {
        Qc(e, r, this.isSVGTag, a.transformTemplate)
    }
    renderInstance(e, r, a, o) {
        Hf(e, r, a, o)
    }
    mount(e) {
        this.isSVGTag = eu(e.tagName),
        super.mount(e)
    }
}
const Nw = (i, e) => Gc(i) ? new Ow(e) : new Lw(e,{
    allowProjection: i !== N.Fragment
})
  , Fw = uk({
    ...o2,
    ...Cw,
    ...gw,
    ...zw
}, Nw)
  , ee = T1(Fw)
  , Rw = {
    some: 0,
    all: 1
};
function Bw(i, e, {root: r, margin: a, amount: o="some"}={}) {
    const l = ig(i)
      , u = new WeakMap
      , d = h => {
        h.forEach(g => {
            const v = u.get(g.target);
            if (g.isIntersecting !== !!v)
                if (g.isIntersecting) {
                    const y = e(g);
                    typeof y == "function" ? u.set(g.target, y) : p.unobserve(g.target)
                } else
                    typeof v == "function" && (v(g),
                    u.delete(g.target))
        }
        )
    }
      , p = new IntersectionObserver(d,{
        root: r,
        rootMargin: a,
        threshold: typeof o == "number" ? o : Rw[o]
    });
    return l.forEach(h => p.observe(h)),
    () => p.disconnect()
}
function Ht(i, {root: e, margin: r, amount: a, once: o=!1}={}) {
    const [l,u] = N.useState(!1);
    return N.useEffect( () => {
        if (!i.current || o && l)
            return;
        const d = () => (u(!0),
        o ? void 0 : () => u(!1))
          , p = {
            root: e && e.current || void 0,
            margin: r,
            amount: a
        };
        return Bw(i.current, d, p)
    }
    , [e, i, r, o, a]),
    l
}
const _h = i => {
    let e;
    const r = new Set
      , a = (h, g) => {
        const v = typeof h == "function" ? h(e) : h;
        if (!Object.is(v, e)) {
            const y = e;
            e = g ?? (typeof v != "object" || v === null) ? v : Object.assign({}, e, v),
            r.forEach(P => P(e, y))
        }
    }
      , o = () => e
      , d = {
        setState: a,
        getState: o,
        getInitialState: () => p,
        subscribe: h => (r.add(h),
        () => r.delete(h))
    }
      , p = e = i(a, o, d);
    return d
}
  , Ww = (i => i ? _h(i) : _h)
  , _w = i => i;
function Uw(i, e=_w) {
    const r = Me.useSyncExternalStore(i.subscribe, Me.useCallback( () => e(i.getState()), [i, e]), Me.useCallback( () => e(i.getInitialState()), [i, e]));
    return Me.useDebugValue(r),
    r
}
const Uh = i => {
    const e = Ww(i)
      , r = a => Uw(e, a);
    return Object.assign(r, e),
    r
}
  , a0 = (i => i ? Uh(i) : Uh)
  , yu = a0(i => ({
    isOpen: !1,
    openModal: () => i({
        isOpen: !0
    }),
    closeModal: () => i({
        isOpen: !1
    })
}))
  , Kw = () => {
    try {
        const i = navigator.platform
          , e = navigator.userAgent;
        return i.includes("Win") && !/Windows NT (5|6)\.\d/gi.test(e)
    } catch {
        return !1
    }
}
  , $w = i => {
    const e = {
        en: {
            downloadForWindows: "Download for Windows",
            unsupportedSystem: "Unsupported System"
        },
        ru: {
            downloadForWindows: "Скачать для Windows",
            unsupportedSystem: "Неподдерживаемая система"
        },
        es: {
            downloadForWindows: "Descargar para Windows",
            unsupportedSystem: "Sistema no compatible"
        },
        vi: {
            downloadForWindows: "Tải xuống cho Windows",
            unsupportedSystem: "Hệ thống không được hỗ trợ"
        },
        th: {
            downloadForWindows: "ดาวน์โหลดสำหรับ Windows",
            unsupportedSystem: "ระบบไม่ได้รับการสนับสนุน"
        },
        ja: {
            downloadForWindows: "Windows用ダウンロード",
            unsupportedSystem: "サポートされていないシステム"
        },
        ko: {
            downloadForWindows: "Windows용 다운로드",
            unsupportedSystem: "지원되지 않는 시스템"
        },
        "zh-TW": {
            downloadForWindows: "為Windows下載",
            unsupportedSystem: "不受支援的系統"
        },
        ar: {
            downloadForWindows: "تحميل لنظام ويندوز",
            unsupportedSystem: "نظام غير مدعوم"
        },
        bn: {
            downloadForWindows: "Windows-এর জন্য ডাউনলোড",
            unsupportedSystem: "অসমর্থিত সিস্টেম"
        },
        id: {
            downloadForWindows: "Unduh untuk Windows",
            unsupportedSystem: "Sistem Tidak Didukung"
        },
        ka: {
            downloadForWindows: "Windows-ისთვის ჩამოტვირთვა",
            unsupportedSystem: "მხარდაჭერილი სისტემა არაა"
        },
        mn: {
            downloadForWindows: "Windows-д татаж авах",
            unsupportedSystem: "Дэмжихгүй систем"
        },
        tr: {
            downloadForWindows: "Windows için İndir",
            unsupportedSystem: "Desteklenmeyen Sistem"
        },
        pt: {
            downloadForWindows: "Baixar para Windows",
            unsupportedSystem: "Sistema Não Suportado"
        }
    };
    return e[i] || e.en
}
  , Un = ({label: i, className: e=""}) => {
    const {i18n: r} = We()
      , a = r.language
      , o = $w(a)
      , [l,u] = N.useState(null)
      , {openModal: d} = yu()
      , [p,h] = N.useState(!1);
    N.useEffect( () => {
        u(Kw())
    }
    , []);
    const g = () => {
        var v;
        l !== !1 && ((v = window.HANDLE_DOWNLOAD) == null || v.call(window),
        d())
    }
    ;
    return x.jsxs("button", {
        onClick: g,
        disabled: l === !1,
        onMouseEnter: () => h(!0),
        onMouseLeave: () => h(!1),
        className: `
        relative w-full flex px-4 items-center justify-center 
        rounded-lg overflow-hidden min-w-fit transition-all duration-300
        py-2 sm:py-3 md:py-4
        text-[#F4F4F4] font-semibold 
        text-[16px] sm:text-[18px] md:text-[20px] 
        leading-[20px] sm:leading-[22px] md:leading-[24px]
        ${l === !1 ? "cursor-not-allowed opacity-50" : ""}
        ${p && l !== !1 ? "transform scale-[1.02] shadow-lg" : ""}
        ${e}
      `,
        children: [x.jsx("div", {
            className: `
          absolute inset-0 bg-gradient-to-r 
          ${l === !1 ? "from-gray-500 via-gray-600 to-gray-700" : "from-blue-500 via-purple-600 to-pink-600"}
        `
        }), l !== !1 && x.jsx("div", {
            className: `
            absolute inset-0 bg-gradient-to-r from-blue-400 via-purple-500 to-pink-500
            transition-opacity duration-300 ease-in-out
            ${p ? "opacity-100" : "opacity-0"}
          `,
            style: {
                filter: "brightness(1.2)",
                mixBlendMode: "soft-light"
            }
        }), l !== !1 && x.jsx("div", {
            className: `
            absolute inset-0 bg-gradient-to-r from-transparent via-white to-transparent
            transition-transform duration-500 ease-in-out opacity-20
            ${p ? "translate-x-full" : "-translate-x-full"}
          `,
            style: {
                width: "50%",
                transform: p ? "translateX(200%)" : "translateX(-200%)"
            }
        }), x.jsx("span", {
            className: "relative z-10",
            children: l === !1 ? o.unsupportedSystem : i || o.downloadForWindows
        })]
    })
}
;
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hw = i => i.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase()
  , s0 = (...i) => i.filter( (e, r, a) => !!e && e.trim() !== "" && a.indexOf(e) === r).join(" ").trim();
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var Gw = {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qw = N.forwardRef( ({color: i="currentColor", size: e=24, strokeWidth: r=2, absoluteStrokeWidth: a, className: o="", children: l, iconNode: u, ...d}, p) => N.createElement("svg", {
    ref: p,
    ...Gw,
    width: e,
    height: e,
    stroke: i,
    strokeWidth: a ? Number(r) * 24 / Number(e) : r,
    className: s0("lucide", o),
    ...d
}, [...u.map( ([h,g]) => N.createElement(h, g)), ...Array.isArray(l) ? l : [l]]));
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xn = (i, e) => {
    const r = N.forwardRef( ({className: a, ...o}, l) => N.createElement(qw, {
        ref: l,
        iconNode: e,
        className: s0(`lucide-${Hw(i)}`, a),
        ...o
    }));
    return r.displayName = `${i}`,
    r
}
;
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xw = [["path", {
    d: "m6 9 6 6 6-6",
    key: "qrunsl"
}]]
  , Zw = Xn("ChevronDown", Xw);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Yw = [["circle", {
    cx: "12",
    cy: "12",
    r: "10",
    key: "1mglay"
}], ["path", {
    d: "M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20",
    key: "13o1zl"
}], ["path", {
    d: "M2 12h20",
    key: "9i4pu4"
}]]
  , Dc = Xn("Globe", Yw);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qw = [["path", {
    d: "M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z",
    key: "m3kijz"
}], ["path", {
    d: "m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z",
    key: "1fmvmk"
}], ["path", {
    d: "M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0",
    key: "1f8sc4"
}], ["path", {
    d: "M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5",
    key: "qeys4"
}]]
  , Jw = Xn("Rocket", Qw);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eP = [["circle", {
    cx: "11",
    cy: "11",
    r: "8",
    key: "4ej97u"
}], ["path", {
    d: "m21 21-4.3-4.3",
    key: "1qie3q"
}]]
  , tP = Xn("Search", eP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iP = [["path", {
    d: "M18 6 6 18",
    key: "1bl5f8"
}], ["path", {
    d: "m6 6 12 12",
    key: "d8bk6v"
}]]
  , rP = Xn("X", iP)
  , o0 = a0(i => ({
    isOpen: !1,
    openModal: () => i({
        isOpen: !0
    }),
    closeModal: () => i({
        isOpen: !1
    })
}))
  , Kh = [{
    code: "en",
    label: "English",
    flag: "🇺🇸"
}, {
    code: "es",
    label: "Español",
    flag: "🇪🇸"
}, {
    code: "ru",
    label: "Русский",
    flag: "🇷🇺"
}, {
    code: "zh-TW",
    label: "繁體中文",
    flag: "🇹🇼"
}, {
    code: "ja",
    label: "日本語",
    flag: "🇯🇵"
}, {
    code: "ko",
    label: "한국어",
    flag: "🇰🇷"
}, {
    code: "sq",
    label: "Shqip",
    flag: "🇦🇱",
    country: "Albania"
}, {
    code: "bs",
    label: "Bosanski",
    flag: "🇧🇦",
    country: "Bosnia and Herzegovina"
}, {
    code: "bg",
    label: "Български",
    flag: "🇧🇬",
    country: "Bulgaria"
}, {
    code: "hr",
    label: "Hrvatski",
    flag: "🇭🇷",
    country: "Croatia"
}, {
    code: "xk",
    label: "Shqip/Srpski",
    flag: "🇽🇰",
    country: "Kosovo"
}, {
    code: "me",
    label: "Црногорски",
    flag: "🇲🇪",
    country: "Montenegro"
}, {
    code: "mk",
    label: "Македонски",
    flag: "🇲🇰",
    country: "North Macedonia"
}, {
    code: "ro",
    label: "Română",
    flag: "🇷🇴",
    country: "Romania"
}, {
    code: "sr",
    label: "Српски",
    flag: "🇷🇸",
    country: "Serbia"
}, {
    code: "sl",
    label: "Slovenščina",
    flag: "🇸🇮",
    country: "Slovenia"
}, {
    code: "sk",
    label: "Slovenčina",
    flag: "🇸🇰",
    country: "Slovakia"
}, {
    code: "md",
    label: "Română",
    flag: "🇲🇩",
    country: "Moldova"
}, {
    code: "ka",
    label: "ქართული",
    flag: "🇬🇪",
    country: "Georgia"
}, {
    code: "by",
    label: "Беларуская",
    flag: "🇧🇾",
    country: "Belarus"
}, {
    code: "ar",
    label: "العربية",
    flag: "🇸🇦"
}, {
    code: "th",
    label: "ไทย",
    flag: "🇹🇭"
}, {
    code: "vi",
    label: "Tiếng Việt",
    flag: "🇻🇳"
}, {
    code: "bn",
    label: "বাংলা",
    flag: "🇧🇩"
}, {
    code: "mn",
    label: "Монгол",
    flag: "🇲🇳"
}, {
    code: "tr",
    label: "Türkçe",
    flag: "🇹🇷"
}, {
    code: "id",
    label: "Bahasa Indonesia",
    flag: "🇮🇩"
}, {
    code: "pt",
    label: "Português",
    flag: "🇵🇹"
}]
  , nP = () => {
    const {i18n: i} = We()
      , {openModal: e} = o0()
      , r = Kh.find(a => a.code === i.language) || Kh[0];
    return x.jsxs("button", {
        onClick: e,
        className: `flex items-center gap-2 px-3 py-2 text-[#D9DFE6] hover:text-white
                 transition-colors duration-300 rounded-lg hover:bg-white/5`,
        children: [x.jsx(Dc, {
            size: 20
        }), x.jsx("span", {
            className: "hidden sm:inline",
            children: r.label
        }), x.jsx(Zw, {
            size: 16
        })]
    })
}
  , $h = ({href: i, children: e, onClick: r, isMobile: a=!1}) => x.jsxs(ee.a, {
    href: i,
    onClick: r,
    className: `relative text-[#D9DFE6] font-medium text-base 
              ${a ? "py-4 px-6" : "py-2 px-4"}
              transition-colors duration-300 hover:text-white
              group inline-block`,
    whileHover: {
        scale: 1.05
    },
    whileTap: {
        scale: .95
    },
    children: [e, x.jsx("span", {
        className: `absolute bottom-0 left-1/2 -translate-x-1/2 
                 w-0 h-0.5 bg-gradient-to-r from-blue-500 via-purple-600 to-pink-600
                 opacity-0 group-hover:w-1/2 group-hover:opacity-100 
                 transition-all duration-300`
    })]
})
  , aP = ({isOpen: i, onClick: e, classname: r}) => x.jsxs("div", {
    className: `w-6 h-5 relative ${r}`,
    onClick: e,
    children: [x.jsx("span", {
        className: `absolute w-full h-0.5 bg-white rounded-full transform transition-all duration-300 ease-in-out ${i ? "rotate-45 top-2" : "rotate-0 top-0"}`
    }), x.jsx("span", {
        className: `absolute w-full h-0.5 bg-white rounded-full top-2 transition-all duration-300 ease-in-out ${i ? "opacity-0" : "opacity-100"}`
    }), x.jsx("span", {
        className: `absolute w-full h-0.5 bg-white rounded-full transform transition-all duration-300 ease-in-out ${i ? "-rotate-45 top-2" : "rotate-0 top-4"}`
    })]
})
  , sP = {
    closed: {
        opacity: 0,
        y: "-100%",
        transition: {
            duration: .4,
            ease: [.4, 0, .2, 1],
            when: "afterChildren",
            staggerChildren: .1
        }
    },
    open: {
        opacity: 1,
        y: 0,
        transition: {
            duration: .4,
            ease: [.4, 0, .2, 1],
            when: "beforeChildren",
            staggerChildren: .1
        }
    }
}
  , Hh = {
    closed: {
        opacity: 0,
        y: -20,
        transition: {
            duration: .2,
            ease: "easeInOut"
        }
    },
    open: {
        opacity: 1,
        y: 0,
        transition: {
            duration: .3,
            ease: "easeOut"
        }
    }
}
  , oP = i => {
    const e = {
        en: {
            home: "Home",
            Benefits: "Benefits",
            Offers: "Offers",
            Promo: "Promo",
            Reviews: "Reviews",
            download: "Download"
        },
        pt: {
            home: "Início",
            Benefits: "Benefícios",
            Offers: "Ofertas",
            Promo: "Promoção",
            Reviews: "Avaliações",
            download: "Baixar"
        },
        es: {
            home: "Inicio",
            Benefits: "Beneficios",
            Offers: "Ofertas",
            Promo: "Promoción",
            Reviews: "Reseñas",
            download: "Descargar"
        },
        vi: {
            home: "Trang Chủ",
            Benefits: "Lợi Ích",
            Offers: "Ưu Đãi",
            Promo: "Khuyến Mãi",
            Reviews: "Đánh Giá",
            download: "Tải Xuống"
        },
        th: {
            home: "หน้าแรก",
            Benefits: "ประโยชน์",
            Offers: "ข้อเสนอ",
            Promo: "โปรโมชั่น",
            Reviews: "รีวิว",
            download: "ดาวน์โหลด"
        },
        ja: {
            home: "ホーム",
            Benefits: "利点",
            Offers: "オファー",
            Promo: "プロモーション",
            Reviews: "レビュー",
            download: "ダウンロード"
        },
        ko: {
            home: "홈",
            Benefits: "이점",
            Offers: "제안",
            Promo: "프로모션",
            Reviews: "리뷰",
            download: "다운로드"
        },
        "zh-TW": {
            home: "首頁",
            Benefits: "好處",
            Offers: "優惠",
            Promo: "促銷",
            Reviews: "評論",
            download: "下載"
        },
        ar: {
            home: "الرئيسية",
            Benefits: "الفوائد",
            Offers: "العروض",
            Promo: "الترويج",
            Reviews: "التقييمات",
            download: "تحميل"
        },
        bn: {
            home: "হোম",
            Benefits: "লাভ",
            Offers: "অফার",
            Promo: "প্রচার",
            Reviews: "রিভিউ",
            download: "ডাউনলোড"
        },
        id: {
            home: "Beranda",
            Benefits: "Manfaat",
            Offers: "Penawaran",
            Promo: "Promosi",
            Reviews: "Ulasan",
            download: "Unduh"
        },
        ka: {
            home: "მთავარი",
            Benefits: "სარგებელი",
            Offers: "შეთავაზებები",
            Promo: "პრომო",
            Reviews: "მიმოხილვები",
            download: "ჩამოტვირთვა"
        },
        mn: {
            home: "Нүүр",
            Benefits: "Ашиг тус",
            Offers: "Санал болгох",
            Promo: "Сурталчилгаа",
            Reviews: "Үнэлгээ",
            download: "Татаж авах"
        },
        tr: {
            home: "Ana Sayfa",
            Benefits: "Faydalar",
            Offers: "Teklifler",
            Promo: "Promosyon",
            Reviews: "Yorumlar",
            download: "İndir"
        },
        ru: {
            home: "Главная",
            Benefits: "Преимущества",
            Offers: "Предложения",
            Promo: "Промо",
            Reviews: "Отзывы",
            download: "Скачать"
        },
        sq: {
            home: "Kreu",
            Benefits: "Përfitimet",
            Offers: "Ofertat",
            Promo: "Promovimi",
            Reviews: "Recensionet",
            download: "Shkarkoni"
        },
        bs: {
            home: "Početna",
            Benefits: "Prednosti",
            Offers: "Ponude",
            Promo: "Promocija",
            Reviews: "Recenzije",
            download: "Preuzmi"
        },
        bg: {
            home: "Начало",
            Benefits: "Предимства",
            Offers: "Оферти",
            Promo: "Промо",
            Reviews: "Отзиви",
            download: "Изтегли"
        },
        hr: {
            home: "Početna",
            Benefits: "Prednosti",
            Offers: "Ponude",
            Promo: "Promocija",
            Reviews: "Recenzije",
            download: "Preuzmi"
        },
        xk: {
            home: "Kreu / Почетна",
            Benefits: "Përfitimet / Предности",
            Offers: "Ofertat / Понуде",
            Promo: "Promovimi / Промоција",
            Reviews: "Recensionet / Рецензије",
            download: "Shkarkoni / Преузми"
        },
        me: {
            home: "Почетна",
            Benefits: "Предности",
            Offers: "Понуде",
            Promo: "Промоција",
            Reviews: "Рецензије",
            download: "Преузми"
        },
        mk: {
            home: "Почетна",
            Benefits: "Предности",
            Offers: "Понуди",
            Promo: "Промо",
            Reviews: "Рецензии",
            download: "Преземи"
        },
        ro: {
            home: "Acasă",
            Benefits: "Beneficii",
            Offers: "Oferte",
            Promo: "Promoție",
            Reviews: "Recenzii",
            download: "Descarcă"
        },
        sr: {
            home: "Почетна",
            Benefits: "Предности",
            Offers: "Понуде",
            Promo: "Промоција",
            Reviews: "Рецензије",
            download: "Преузми"
        },
        sl: {
            home: "Domov",
            Benefits: "Prednosti",
            Offers: "Ponudbe",
            Promo: "Promocija",
            Reviews: "Ocene",
            download: "Prenesi"
        },
        sk: {
            home: "Domov",
            Benefits: "Výhody",
            Offers: "Ponuky",
            Promo: "Promocia",
            Reviews: "Recenzie",
            download: "Stiahnuť"
        },
        md: {
            home: "Acasă",
            Benefits: "Beneficii",
            Offers: "Oferte",
            Promo: "Promoție",
            Reviews: "Recenzii",
            download: "Descarcă"
        },
        by: {
            home: "Галоўная",
            Benefits: "Перавагі",
            Offers: "Прапановы",
            Promo: "Прома",
            Reviews: "Водгукі",
            download: "Спампаваць"
        }
    };
    return e[i] || e.en
}
  , lP = () => {
    const [i,e] = N.useState(!1)
      , [r,a] = N.useState(!1)
      , {i18n: o} = We()
      , l = o.language
      , u = oP(l);
    N.useEffect( () => {
        const p = () => {
            a(window.scrollY > 0)
        }
        ;
        return window.addEventListener("scroll", p),
        () => window.removeEventListener("scroll", p)
    }
    , []);
    const d = [{
        href: "#",
        label: u.home
    }, {
        href: "#benefits",
        label: u.Benefits
    }, {
        href: "#offers",
        label: u.Offers
    }, {
        href: "#promo",
        label: u.Promo
    }, {
        href: "#reviews",
        label: u.Reviews
    }];
    return x.jsxs("header", {
        className: `sticky top-0 left-0 right-0 z-50 
                transition-all duration-300
                ${r ? "bg-black/95 backdrop-blur-md" : "bg-transparent"}`,
        children: [x.jsxs("div", {
            className: "max-w-[1376px] mx-auto flex items-center justify-between py-4 px-4 sm:py-5 sm:px-8",
            children: [x.jsxs("div", {
                className: "flex items-center gap-8",
                children: [x.jsx("img", {
                    src: Cf,
                    alt: "Logo",
                    className: "w-auto h-8"
                }), x.jsx("nav", {
                    className: "hidden lg:flex flex-wrap items-center gap-2",
                    children: d.map(p => x.jsx($h, {
                        href: p.href,
                        children: p.label
                    }, p.label))
                })]
            }), x.jsxs("div", {
                className: "flex items-center gap-4 md:max-w-fit md:w-full relative z-20",
                children: [x.jsx(nP, {}), x.jsx(Un, {
                    label: u.download,
                    className: "max-w-[150px] hidden sm:flex !text-[15px] !leading-[16px]"
                }), " ", x.jsx(aP, {
                    isOpen: i,
                    classname: "sm:hidden",
                    onClick: () => e(!i)
                })]
            })]
        }), x.jsx(Ti, {
            mode: "wait",
            children: i && x.jsx(ee.div, {
                initial: {
                    opacity: 0,
                    y: -20
                },
                animate: {
                    opacity: 1,
                    y: 0
                },
                exit: {
                    opacity: 0,
                    y: -20
                },
                transition: {
                    duration: .2
                },
                className: `absolute top-full left-0 right-0 bg-black/95 backdrop-blur-lg lg:hidden
                      border-t border-gray-800 shadow-xl`,
                children: x.jsxs(ee.nav, {
                    className: "flex flex-col w-full max-w-[1376px] mx-auto py-4",
                    variants: sP,
                    children: [d.map( (p, h) => x.jsx(ee.div, {
                        variants: Hh,
                        custom: h,
                        className: "w-full",
                        children: x.jsx($h, {
                            href: p.href,
                            onClick: () => e(!1),
                            isMobile: !0,
                            children: p.label
                        })
                    }, p.label)), x.jsx(ee.div, {
                        variants: Hh,
                        className: "px-6 pt-4 border-t border-gray-800 mt-4",
                        children: x.jsx(Un, {
                            label: u.download,
                            className: "w-full sm:hidden"
                        })
                    })]
                })
            })
        })]
    })
}
  , cP = "/cdn/shop/t/1/assets/step1-DX1xRWUQ.webp"
  , uP = "/cdn/shop/t/1/assets/step2-C349pY7l.webp"
  , dP = "/cdn/shop/t/1/assets/step3---SBRZnH.webp"
  , Gh = {
    en: {
        step: "step",
        back: "Back",
        next: "Next",
        done: "Done",
        openInstaller: {
            title: "Open the Installer",
            description: "After downloading the app, open the installer from your browser's downloads section (usually located in the upper right corner of your screen)."
        },
        acceptPermissions: {
            title: 'Click "Yes" to Accept Permissions',
            description: 'A prompt will appear asking for permission to install the app. Click the "Yes" button to grant the necessary permissions and proceed with the installation.'
        },
        waitInstallation: {
            title: "Wait for Installation to Complete",
            description: "Once you've accepted the permissions, the installation will begin. Wait for the process to complete, and you'll be ready to start using the app."
        }
    },
    ru: {
        step: "шаг",
        back: "Назад",
        next: "Далее",
        done: "Готово",
        openInstaller: {
            title: "Откройте установщик",
            description: "После загрузки приложения откройте установщик из раздела загрузок вашего браузера (обычно находится в правом верхнем углу экрана)."
        },
        acceptPermissions: {
            title: "Нажмите «Да», чтобы принять разрешения",
            description: "Появится запрос на разрешение установки приложения. Нажмите кнопку «Да», чтобы предоставить необходимые разрешения и продолжить установку."
        },
        waitInstallation: {
            title: "Дождитесь завершения установки",
            description: "После принятия разрешений начнется установка. Дождитесь завершения процесса, и вы будете готовы начать использовать приложение."
        }
    },
    es: {
        step: "paso",
        back: "Atrás",
        next: "Siguiente",
        done: "Listo",
        openInstaller: {
            title: "Abrir el Instalador",
            description: "Después de descargar la aplicación, abre el instalador desde la sección de descargas de tu navegador (generalmente ubicada en la esquina superior derecha de tu pantalla)."
        },
        acceptPermissions: {
            title: 'Haz clic en "Sí" para Aceptar los Permisos',
            description: 'Aparecerá un mensaje solicitando permiso para instalar la aplicación. Haz clic en el botón "Sí" para otorgar los permisos necesarios y continuar con la instalación.'
        },
        waitInstallation: {
            title: "Espera a que se Complete la Instalación",
            description: "Una vez que hayas aceptado los permisos, comenzará la instalación. Espera a que el proceso se complete y estarás listo para comenzar a usar la aplicación."
        }
    },
    vi: {
        step: "bước",
        back: "Quay lại",
        next: "Tiếp theo",
        done: "Hoàn tất",
        openInstaller: {
            title: "Mở Trình Cài Đặt",
            description: "Sau khi tải xuống ứng dụng, mở trình cài đặt từ phần tải xuống của trình duyệt (thường nằm ở góc trên bên phải màn hình của bạn)."
        },
        acceptPermissions: {
            title: 'Nhấp "Có" để Chấp Nhận Quyền',
            description: 'Một thông báo sẽ xuất hiện yêu cầu quyền cài đặt ứng dụng. Nhấp vào nút "Có" để cấp quyền cần thiết và tiếp tục cài đặt.'
        },
        waitInstallation: {
            title: "Chờ Cài Đặt Hoàn Tất",
            description: "Sau khi bạn đã chấp nhận quyền, quá trình cài đặt sẽ bắt đầu. Chờ cho quá trình hoàn tất, và bạn sẽ sẵn sàng để bắt đầu sử dụng ứng dụng."
        }
    },
    th: {
        step: "ขั้นตอน",
        back: "ย้อนกลับ",
        next: "ถัดไป",
        done: "เสร็จสิ้น",
        openInstaller: {
            title: "เปิดตัวติดตั้ง",
            description: "หลังจากดาวน์โหลดแอพ ให้เปิดตัวติดตั้งจากส่วนดาวน์โหลดของเบราว์เซอร์ (มักอยู่ที่มุมขวาบนของหน้าจอ)"
        },
        acceptPermissions: {
            title: 'คลิก "ใช่" เพื่อยอมรับสิทธิ์',
            description: 'จะมีข้อความปรากฏขึ้นขอสิทธิ์ในการติดตั้งแอพ คลิกปุ่ม "ใช่" เพื่อให้สิทธิ์ที่จำเป็นและดำเนินการติดตั้งต่อ'
        },
        waitInstallation: {
            title: "รอการติดตั้งเสร็จสมบูรณ์",
            description: "เมื่อคุณยอมรับสิทธิ์แล้ว การติดตั้งจะเริ่มขึ้น รอให้กระบวนการเสร็จสมบูรณ์ และคุณจะพร้อมเริ่มใช้งานแอพ"
        }
    },
    ja: {
        step: "ステップ",
        back: "戻る",
        next: "次へ",
        done: "完了",
        openInstaller: {
            title: "インストーラーを開く",
            description: "アプリをダウンロードした後、ブラウザのダウンロードセクション（通常は画面の右上にあります）からインストーラーを開きます。"
        },
        acceptPermissions: {
            title: "「はい」をクリックして権限を許可",
            description: "アプリのインストール許可を求めるプロンプトが表示されます。「はい」ボタンをクリックして必要な権限を付与し、インストールを続行します。"
        },
        waitInstallation: {
            title: "インストール完了まで待機",
            description: "権限を許可すると、インストールが開始されます。プロセスが完了するまで待ち、その後アプリを使い始めることができます。"
        }
    },
    ko: {
        step: "단계",
        back: "뒤로",
        next: "다음",
        done: "완료",
        openInstaller: {
            title: "설치 프로그램 열기",
            description: "앱을 다운로드한 후, 브라우저의 다운로드 섹션(일반적으로 화면 오른쪽 상단에 위치)에서 설치 프로그램을 엽니다."
        },
        acceptPermissions: {
            title: '"예"를 클릭하여 권한 수락',
            description: '앱 설치 권한을 요청하는 프롬프트가 나타납니다. "예" 버튼을 클릭하여 필요한 권한을 부여하고 설치를 진행합니다.'
        },
        waitInstallation: {
            title: "설치 완료 대기",
            description: "권한을 수락하면 설치가 시작됩니다. 프로세스가 완료될 때까지 기다리면 앱을 사용할 준비가 됩니다."
        }
    },
    "zh-TW": {
        step: "步驟",
        back: "返回",
        next: "下一步",
        done: "完成",
        openInstaller: {
            title: "開啟安裝程式",
            description: "下載應用程式後，從瀏覽器的下載區域開啟安裝程式（通常位於螢幕右上角）。"
        },
        acceptPermissions: {
            title: "點擊「是」接受權限",
            description: "系統會顯示提示要求安裝應用程式的權限。點擊「是」按鈕授予必要權限並繼續安裝。"
        },
        waitInstallation: {
            title: "等待安裝完成",
            description: "接受權限後，安裝將開始。等待程序完成，然後您就可以開始使用應用程式了。"
        }
    },
    ar: {
        step: "خطوة",
        back: "رجوع",
        next: "التالي",
        done: "تم",
        openInstaller: {
            title: "فتح المثبت",
            description: "بعد تنزيل التطبيق، افتح المثبت من قسم التنزيلات في متصفحك (عادةً ما يكون في الزاوية العلوية اليمنى من شاشتك)."
        },
        acceptPermissions: {
            title: 'انقر على "نعم" لقبول الأذونات',
            description: 'سيظهر مربع حوار يطلب إذنًا لتثبيت التطبيق. انقر على زر "نعم" لمنح الأذونات اللازمة والمتابعة مع التثبيت.'
        },
        waitInstallation: {
            title: "انتظر اكتمال التثبيت",
            description: "بمجرد قبول الأذونات، سيبدأ التثبيت. انتظر حتى تكتمل العملية، وستكون جاهزًا لبدء استخدام التطبيق."
        }
    },
    bn: {
        step: "ধাপ",
        back: "পিছনে",
        next: "পরবর্তী",
        done: "সম্পন্ন",
        openInstaller: {
            title: "ইনস্টলার খুলুন",
            description: "অ্যাপ ডাউনলোড করার পর, আপনার ব্রাউজারের ডাউনলোড সেকশন থেকে ইনস্টলার খুলুন (সাধারণত আপনার স্ক্রিনের উপরের ডান কোণে অবস্থিত)।"
        },
        acceptPermissions: {
            title: 'অনুমতি দিতে "হ্যাঁ" ক্লিক করুন',
            description: 'অ্যাপ ইনস্টল করার অনুমতি চাইতে একটি প্রম্পট দেখা যাবে। প্রয়োজনীয় অনুমতি দিতে এবং ইনস্টলেশন চালিয়ে যেতে "হ্যাঁ" বোতামে ক্লিক করুন।'
        },
        waitInstallation: {
            title: "ইনস্টলেশন শেষ হওয়ার জন্য অপেক্ষা করুন",
            description: "অনুমতি দেওয়ার পর, ইনস্টলেশন শুরু হবে। প্রক্রিয়াটি শেষ হওয়ার জন্য অপেক্ষা করুন, এবং আপনি অ্যাপ ব্যবহার শুরু করতে প্রস্তুত হবেন।"
        }
    },
    id: {
        step: "langkah",
        back: "Kembali",
        next: "Lanjut",
        done: "Selesai",
        openInstaller: {
            title: "Buka Installer",
            description: "Setelah mengunduh aplikasi, buka installer dari bagian unduhan browser Anda (biasanya terletak di pojok kanan atas layar Anda)."
        },
        acceptPermissions: {
            title: 'Klik "Ya" untuk Menerima Izin',
            description: 'Akan muncul prompt meminta izin untuk menginstal aplikasi. Klik tombol "Ya" untuk memberikan izin yang diperlukan dan lanjutkan dengan instalasi.'
        },
        waitInstallation: {
            title: "Tunggu Instalasi Selesai",
            description: "Setelah Anda menerima izin, instalasi akan dimulai. Tunggu proses selesai, dan Anda akan siap untuk mulai menggunakan aplikasi."
        }
    },
    ka: {
        step: "ნაბიჯი",
        back: "უკან",
        next: "შემდეგი",
        done: "დასრულება",
        openInstaller: {
            title: "გახსენით ინსტალერი",
            description: "აპლიკაციის ჩამოტვირთვის შემდეგ, გახსენით ინსტალერი თქვენი ბრაუზერის ჩამოტვირთვების განყოფილებიდან (ჩვეულებრივ მდებარეობს ეკრანის ზედა მარჯვენა კუთხეში)."
        },
        acceptPermissions: {
            title: 'დააჭირეთ "დიახ"-ს ნებართვების მისაღებად',
            description: 'გამოჩნდება მოთხოვნა აპლიკაციის დაყენების ნებართვისთვის. დააჭირეთ ღილაკს "დიახ" საჭირო ნებართვების მისაცემად და ინსტალაციის გასაგრძელებლად.'
        },
        waitInstallation: {
            title: "დაელოდეთ ინსტალაციის დასრულებას",
            description: "ნებართვების მიღების შემდეგ დაიწყება ინსტალაცია. დაელოდეთ პროცესის დასრულებას და შემდეგ შეგეძლებათ აპლიკაციის გამოყენების დაწყება."
        }
    },
    mn: {
        step: "алхам",
        back: "Буцах",
        next: "Дараах",
        done: "Дууссан",
        openInstaller: {
            title: "Суулгагчийг нээх",
            description: "Аппыг татаж авсны дараа, хөтчийн татаж авсан хэсгээс суулгагчийг нээнэ (ихэвчлэн дэлгэцийн баруун дээд өнцөгт байрладаг)."
        },
        acceptPermissions: {
            title: 'Зөвшөөрөл өгөхийн тулд "Тийм" дээр дарна уу',
            description: 'Апп суулгах зөвшөөрөл асуух цонх гарч ирнэ. Шаардлагатай зөвшөөрлүүдийг өгч, суулгалтыг үргэлжлүүлэхийн тулд "Тийм" товчийг дарна уу.'
        },
        waitInstallation: {
            title: "Суулгалт дуусахыг хүлээнэ үү",
            description: "Зөвшөөрлүүдийг хүлээн зөвшөөрсний дараа суулгалт эхэлнэ. Процесс дуусахыг хүлээж, дараа нь та аппыг ашиглаж эхлэх боломжтой болно."
        }
    },
    tr: {
        step: "adım",
        back: "Geri",
        next: "İleri",
        done: "Tamam",
        openInstaller: {
            title: "Yükleyiciyi Açın",
            description: "Uygulamayı indirdikten sonra, tarayıcınızın indirilenler bölümünden yükleyiciyi açın (genellikle ekranınızın sağ üst köşesinde bulunur)."
        },
        acceptPermissions: {
            title: 'İzinleri Kabul Etmek için "Evet"e Tıklayın',
            description: 'Uygulamayı yüklemek için izin isteyen bir pencere açılacak. Gerekli izinleri vermek ve yüklemeye devam etmek için "Evet" düğmesine tıklayın.'
        },
        waitInstallation: {
            title: "Yüklemenin Tamamlanmasını Bekleyin",
            description: "İzinleri kabul ettikten sonra yükleme başlayacak. İşlemin tamamlanmasını bekleyin ve uygulamayı kullanmaya başlamaya hazır olacaksınız."
        }
    },
    sq: {
        step: "hapi",
        back: "Prapa",
        next: "Përpara",
        done: "Përfunduar",
        openInstaller: {
            title: "Hap Instaluesi",
            description: "Pasi të keni shkarkuar aplikacionin, hapni instaluesin nga seksioni i shkarkimeve të shfletuesit tuaj (zakonisht ndodhet në këndin e sipërm djathtas të ekranit tuaj)."
        },
        acceptPermissions: {
            title: 'Klikoni "Po" për të Pranuar Lejet',
            description: 'Do të shfaqet një kërkesë që kërkon leje për të instaluar aplikacionin. Klikoni butonin "Po" për të dhënë lejet e nevojshme dhe vazhdoni me instalimin.'
        },
        waitInstallation: {
            title: "Prisni që Instalimi të Përfundojë",
            description: "Pasi të keni pranuar lejet, instalimi do të fillojë. Prisni që procesi të përfundojë dhe do të jeni gati për të filluar përdorimin e aplikacionit."
        }
    },
    bs: {
        step: "korak",
        back: "Nazad",
        next: "Dalje",
        done: "Gotovo",
        openInstaller: {
            title: "Otvorite Installer",
            description: "Nakon preuzimanja aplikacije, otvorite installer iz odjeljka za preuzimanja vašeg preglednika (obično se nalazi u gornjem desnom uglu vašeg ekrana)."
        },
        acceptPermissions: {
            title: 'Kliknite "Da" da Prihvatite Dozvole',
            description: 'Pojavit će se upozorenje koje traži dozvolu za instaliranje aplikacije. Kliknite na dugme "Da" da odobriti potrebne dozvole i nastavite s instalacijom.'
        },
        waitInstallation: {
            title: "Čekajte da se Instalacija Završi",
            description: "Nakon što prihvatite dozvole, instalacija će početi. Čekajte da se proces završi i bit ćete spremni za početak korištenja aplikacije."
        }
    },
    bg: {
        step: "стъпка",
        back: "Назад",
        next: "Напред",
        done: "Готово",
        openInstaller: {
            title: "Отворете Инсталатора",
            description: "След като изтеглите приложението, отворете инсталатора от раздела за изтегляния на вашия браузър (обикновено се намира в горния десен ъгъл на екрана ви)."
        },
        acceptPermissions: {
            title: 'Кликнете "Да", за да Приемете Разрешенията',
            description: 'Ще се появи подкана, която иска разрешение за инсталиране на приложението. Кликнете върху бутона "Да", за да дадете необходимите разрешения и продължите с инсталацията.'
        },
        waitInstallation: {
            title: "Изчакайте Инсталацията да Завърши",
            description: "След като приемете разрешенията, инсталацията ще започне. Изчакайте процесът да завърши и ще бъдете готови да започнете да използвате приложението."
        }
    },
    hr: {
        step: "korak",
        back: "Natrag",
        next: "Dalje",
        done: "Gotovo",
        openInstaller: {
            title: "Otvorite Installer",
            description: "Nakon preuzimanja aplikacije, otvorite installer iz odjeljka za preuzimanja vašeg preglednika (obično se nalazi u gornjem desnom kutu vašeg zaslona)."
        },
        acceptPermissions: {
            title: 'Kliknite "Da" za Prihvaćanje Dozvola',
            description: 'Pojavit će se upit koji traži dozvolu za instaliranje aplikacije. Kliknite gumb "Da" da biste odobrili potrebne dozvole i nastavili s instalacijom.'
        },
        waitInstallation: {
            title: "Pričekajte da se Instalacija Završi",
            description: "Nakon što prihvatite dozvole, instalacija će početi. Pričekajte da se proces završi i bit ćete spremni za početak korištenja aplikacije."
        }
    },
    xk: {
        step: "hapi | korak",
        back: "Prapa | Nazad",
        next: "Përpara | Dalje",
        done: "Përfunduar | Gotovo",
        openInstaller: {
            title: "Hap Instaluesi | Otvorite Installer",
            description: "Pasi të keni shkarkuar aplikacionin, hapni instaluesin nga seksioni i shkarkimeve të shfletuesit tuaj (zakonisht ndodhet në këndin e sipërm djathtas të ekranit tuaj). | Nakon preuzimanja aplikacije, otvorite installer iz odjeljka za preuzimanja vašeg preglednika (obično se nalazi u gornjem desnom uglu vašeg ekrana)."
        },
        acceptPermissions: {
            title: 'Klikoni "Po" për të Pranuar Lejet | Kliknite "Da" da Prihvatite Dozvole',
            description: 'Do të shfaqet një kërkesë që kërkon leje për të instaluar aplikacionin. Klikoni butonin "Po" për të dhënë lejet e nevojshme dhe vazhdoni me instalimin. | Pojavit će se upozorenje koje traži dozvolu za instaliranje aplikacije. Kliknite na dugme "Da" da odobriti potrebne dozvole i nastavite s instalacijom.'
        },
        waitInstallation: {
            title: "Prisni që Instalimi të Përfundojë | Čekajte da se Instalacija Završi",
            description: "Pasi të keni pranuar lejet, instalimi do të fillojë. Prisni që procesi të përfundojë dhe do të jeni gati për të filluar përdorimin e aplikacionit. | Nakon što prihvatite dozvole, instalacija će početi. Čekajte da se proces završi i bit ćete spremni za početak korištenja aplikacije."
        }
    },
    me: {
        step: "корак",
        back: "Назад",
        next: "Даље",
        done: "Готово",
        openInstaller: {
            title: "Отворите Installer",
            description: "Након преузимања апликације, отворите installer из одјељка за преузимања вашег прегледника (обично се налази у горњем десном углу вашег екрана)."
        },
        acceptPermissions: {
            title: 'Кликните "Да" да Прихватите Дозволе',
            description: 'Појавиће се упозорење које тражи дозволу за инсталирање апликације. Кликните на дугме "Да" да одобрите потребне дозволе и наставите са инсталацијом.'
        },
        waitInstallation: {
            title: "Чекајте да се Инсталација Заврши",
            description: "Након што прихватите дозволе, инсталација ће почети. Чекајте да се процес заврши и бићете спремни за почетак коришћења апликације."
        }
    },
    mk: {
        step: "чекор",
        back: "Назад",
        next: "Напред",
        done: "Готово",
        openInstaller: {
            title: "Отворете го Инсталерот",
            description: "Откако ќе ја преземете апликацијата, отворете го инсталерот од делот за преземања на вашиот прелистувач (обично се наоѓа во горниот десен агол на вашиот екран)."
        },
        acceptPermissions: {
            title: 'Кликнете "Да" за да ги Прифатите Дозволите',
            description: 'Ќе се појави прашање кое бара дозвола за инсталирање на апликацијата. Кликнете на копчето "Да" за да ги одобрите потребните дозволи и продолжете со инсталацијата.'
        },
        waitInstallation: {
            title: "Чекајте да се Заврши Инсталацијата",
            description: "Откако ќе ги прифатите дозволите, инсталацијата ќе почне. Чекајте да се заврши процесот и ќе бидете спремни да почнете да ја користите апликацијата."
        }
    },
    ro: {
        step: "pasul",
        back: "Înapoi",
        next: "Următorul",
        done: "Terminat",
        openInstaller: {
            title: "Deschideți Instalatorul",
            description: "După descărcarea aplicației, deschideți instalatorul din secțiunea de descărcări a browserului dvs. (de obicei situată în colțul din dreapta sus al ecranului)."
        },
        acceptPermissions: {
            title: 'Faceți clic pe "Da" pentru a Accepta Permisiunile',
            description: 'Va apărea o solicitare care cere permisiunea de a instala aplicația. Faceți clic pe butonul "Da" pentru a acorda permisiunile necesare și continuați cu instalarea.'
        },
        waitInstallation: {
            title: "Așteptați ca Instalarea să se Finalizeze",
            description: "După ce ați acceptat permisiunile, instalarea va începe. Așteptați ca procesul să se finalizeze și veți fi gata să începeți să utilizați aplicația."
        }
    },
    sr: {
        step: "корак",
        back: "Назад",
        next: "Даље",
        done: "Готово",
        openInstaller: {
            title: "Отворите Инсталер",
            description: "Након преузимања апликације, отворите инсталер из одељка за преузимања вашег прегледника (обично се налази у горњем десном углу вашег екрана)."
        },
        acceptPermissions: {
            title: 'Кликните "Да" да Прихватите Дозволе',
            description: 'Појавиће се упит који тражи дозволу за инсталирање апликације. Кликните на дугме "Да" да одобрите потребне дозволе и наставите са инсталацијом.'
        },
        waitInstallation: {
            title: "Сачекајте да се Инсталација Заврши",
            description: "Након што прихватите дозволе, инсталација ће почети. Сачекајте да се процес заврши и бићете спремни да почнете да користите апликацију."
        }
    },
    sl: {
        step: "korak",
        back: "Nazaj",
        next: "Naprej",
        done: "Končano",
        openInstaller: {
            title: "Odprite Namestitveni Program",
            description: "Po prenosu aplikacije odprite namestitveni program iz odseka za prenose vašega brskalnika (običajno se nahaja v zgornjem desnem kotu zaslona)."
        },
        acceptPermissions: {
            title: 'Kliknite "Da" za Sprejem Dovoljenj',
            description: 'Prikazal se bo poziv, ki zahteva dovoljenje za namestitev aplikacije. Kliknite gumb "Da", da podelite potrebna dovoljenja in nadaljujete z namestitvijo.'
        },
        waitInstallation: {
            title: "Počakajte na Dokončanje Namestitve",
            description: "Ko sprejmete dovoljenja, se bo namestitev začela. Počakajte, da se postopek konča, nato boste pripravljeni za začetek uporabe aplikacije."
        }
    },
    sk: {
        step: "krok",
        back: "Späť",
        next: "Ďalej",
        done: "Hotovo",
        openInstaller: {
            title: "Otvorte Inštalátor",
            description: "Po stiahnutí aplikácie otvorte inštalátor z časti stiahnutých súborov vášho prehliadača (zvyčajne sa nachádza v pravom hornom rohu obrazovky)."
        },
        acceptPermissions: {
            title: 'Kliknite na "Áno" pre Prijatie Povolení',
            description: 'Zobrazí sa výzva požadujúca povolenie na inštaláciu aplikácie. Kliknite na tlačidlo "Áno" na udelenie potrebných povolení a pokračovanie v inštalácii.'
        },
        waitInstallation: {
            title: "Počkajte na Dokončenie Inštalácie",
            description: "Po prijatí povolení sa inštalácia začne. Počkajte na dokončenie procesu a budete pripravení začať používať aplikáciu."
        }
    },
    md: {
        step: "pasul",
        back: "Înapoi",
        next: "Următorul",
        done: "Terminat",
        openInstaller: {
            title: "Deschideți Instalatorul",
            description: "După descărcarea aplicației, deschideți instalatorul din secțiunea de descărcări a browserului dvs. (de obicei situată în colțul din dreapta sus al ecranului)."
        },
        acceptPermissions: {
            title: 'Faceți clic pe "Da" pentru a Accepta Permisiunile',
            description: 'Va apărea o solicitare care cere permisiunea de a instala aplicația. Faceți clic pe butonul "Da" pentru a acorda permisiunile necesare și continuați cu instalarea.'
        },
        waitInstallation: {
            title: "Așteptați ca Instalarea să se Finalizeze",
            description: "După ce ați acceptat permisiunile, instalarea va începe. Așteptați ca procesul să se finalizeze și veți fi gata să începeți să utilizați aplicația."
        }
    },
    by: {
        step: "крок",
        back: "Назад",
        next: "Далей",
        done: "Гатова",
        openInstaller: {
            title: "Адкрыйце Ўстаноўшчык",
            description: "Пасля спампоўкі прыкладання адкрыйце ўстаноўшчык з раздзела спампоўкі вашага браўзера (звычайна знаходзіцца ў верхнім правым куце вашага экрана)."
        },
        acceptPermissions: {
            title: 'Пстрыкніце "Так", каб Прыняць Дазволы',
            description: `З'явіцца запыт, які патрабуе дазвол на ўстаноўку прыкладання. Пстрыкніце кнопку "Так", каб даць неабходныя дазволы і працягнуць устаноўку.`
        },
        waitInstallation: {
            title: "Пачакайце Завяршэння Устаноўкі",
            description: "Пасля прыняцця дазволаў устаноўка пачнецца. Пачакайце завяршэння працэсу, і вы будзеце гатовы пачаць выкарыстоўваць прыкладанне."
        }
    },
    pt: {
        step: "passo",
        back: "Voltar",
        next: "Próximo",
        done: "Concluído",
        openInstaller: {
            title: "Abrir o Instalador",
            description: "Após baixar o aplicativo, abra o instalador na seção de downloads do seu navegador (geralmente localizado no canto superior direito da tela)."
        },
        acceptPermissions: {
            title: 'Clique em "Sim" para Aceitar as Permissões',
            description: 'Um prompt aparecerá solicitando permissão para instalar o aplicativo. Clique no botão "Sim" para conceder as permissões necessárias e prosseguir com a instalação.'
        },
        waitInstallation: {
            title: "Aguarde a Conclusão da Instalação",
            description: "Após aceitar as permissões, a instalação será iniciada. Aguarde a conclusão do processo e você estará pronto para começar a usar o aplicativo."
        }
    }
}
  , qh = {
    hidden: {
        opacity: 0,
        transition: {
            duration: .2,
            ease: [.4, 0, .2, 1]
        }
    },
    visible: {
        opacity: 1,
        transition: {
            duration: .2,
            ease: [.4, 0, .2, 1]
        }
    },
    exit: {
        opacity: 0,
        transition: {
            duration: .2,
            ease: [.4, 0, .2, 1]
        }
    }
}
  , pP = {
    hidden: {
        scale: .9,
        opacity: 0,
        transition: {
            duration: .1
        }
    },
    visible: {
        scale: 1,
        opacity: 1,
        transition: {
            duration: .2
        }
    },
    exit: {
        scale: .9,
        opacity: 0,
        transition: {
            duration: .1
        }
    }
}
  , mP = () => {
    const [i,e] = N.useState(1)
      , {isOpen: r, closeModal: a} = yu()
      , {i18n: o} = We()
      , l = [cP, uP, dP]
      , u = Gh[o.language] || Gh.en
      , d = [{
        title: u.openInstaller.title,
        description: u.openInstaller.description
    }, {
        title: u.acceptPermissions.title,
        description: u.acceptPermissions.description
    }, {
        title: u.waitInstallation.title,
        description: u.waitInstallation.description
    }]
      , p = () => {
        i < 3 ? e(i + 1) : (a(),
        e(1))
    }
      , h = {
        type: "spring",
        stiffness: 300,
        damping: 30,
        mass: 1
    }
      , g = () => x.jsxs(ee.div, {
        className: "flex gap-3 pt-4 sm:pt-6",
        initial: {
            opacity: 0,
            y: 20
        },
        animate: {
            opacity: 1,
            y: 0
        },
        transition: {
            delay: .2,
            ...h
        },
        children: [x.jsx(Ti, {
            children: i > 1 && x.jsx(ee.button, {
                initial: {
                    opacity: 0,
                    width: 0
                },
                animate: {
                    opacity: 1,
                    width: "100px"
                },
                exit: {
                    opacity: 0,
                    width: 0
                },
                transition: {
                    ...h,
                    duration: .3
                },
                onClick: () => e(i - 1),
                whileHover: {
                    scale: 1.02,
                    backgroundColor: "rgba(255, 255, 255, 1)"
                },
                whileTap: {
                    scale: .98
                },
                className: "py-3 sm:py-4 text-white font-medium text-sm sm:text-base leading-5 sm:leading-6 border border-white rounded-[8px] max-w-[100px] transition-colors duration-300 hover:text-black",
                children: u.back
            })
        }), x.jsx(ee.button, {
            onClick: p,
            whileHover: {
                scale: 1.02,
                boxShadow: "0 10px 25px rgba(147, 51, 234, 0.3)"
            },
            whileTap: {
                scale: .98
            },
            transition: {
                type: "spring",
                stiffness: 400,
                damping: 25
            },
            className: "flex-1 relative rounded-[8px] bg-gradient-to-r from-blue-500 via-purple-600 to-pink-600 py-3 sm:py-4 text-white font-medium text-sm sm:text-base leading-5 sm:leading-6",
            children: x.jsx(Ti, {
                mode: "wait",
                children: x.jsx(ee.span, {
                    initial: {
                        opacity: 0,
                        y: 10
                    },
                    animate: {
                        opacity: 1,
                        y: 0
                    },
                    exit: {
                        opacity: 0,
                        y: -10
                    },
                    transition: {
                        duration: .2
                    },
                    className: "relative z-10 block",
                    children: i === 3 ? u.done : u.next
                }, i === 3 ? "done" : "next")
            })
        })]
    });
    return x.jsx(Ti, {
        children: r && x.jsxs(ee.div, {
            initial: "hidden",
            animate: "visible",
            exit: "exit",
            variants: qh,
            className: "fixed inset-0 z-[100] flex items-center justify-center px-4",
            children: [x.jsx(ee.div, {
                initial: "hidden",
                animate: "visible",
                exit: "exit",
                variants: qh,
                className: "absolute inset-0 bg-black bg-opacity-50 backdrop-blur-sm",
                onClick: a
            }), x.jsxs(ee.div, {
                initial: "hidden",
                animate: "visible",
                exit: "exit",
                variants: pP,
                className: "relative bg-[#060606] p-4 sm:p-6 rounded-2xl w-full max-w-[512px]",
                children: [x.jsx("div", {
                    className: "flex items-center justify-center py-2 sm:py-4 gap-1",
                    children: [1, 2, 3].map( (v, y) => x.jsxs(x.Fragment, {
                        children: [x.jsxs("div", {
                            className: `py-1 w-full rounded-md font-medium text-sm sm:text-base leading-6 text-center ${i >= v ? "text-[#5A9BF4]" : "text-gray-500"}`,
                            children: [v, " ", u.step]
                        }, `step-${v}`), y < 2 && x.jsx(ee.div, {
                            className: "max-w-[100px] w-full h-0.5 bg-gray-800",
                            initial: !1,
                            animate: {
                                backgroundColor: i > v ? "#5A9BF4" : "#374151"
                            },
                            transition: {
                                duration: .6,
                                type: "spring",
                                stiffness: 150,
                                damping: 20,
                                mass: .8
                            }
                        }, `divider-${v}`)]
                    }))
                }), x.jsx("div", {
                    className: "rounded-[8px] sm:h-[250px] overflow-hidden relative",
                    children: x.jsx(Ti, {
                        mode: "wait",
                        children: x.jsx(ee.img, {
                            initial: {
                                opacity: 0,
                                x: 20,
                                scale: .95
                            },
                            animate: {
                                opacity: 1,
                                x: 0,
                                scale: 1
                            },
                            exit: {
                                opacity: 0,
                                x: -20,
                                scale: .95
                            },
                            transition: {
                                ...h,
                                duration: .4
                            },
                            src: l[i - 1],
                            alt: d[i - 1].title,
                            className: "w-full h-auto"
                        }, i)
                    })
                }), x.jsxs("div", {
                    className: "flex flex-col text-left gap-4 mt-4",
                    children: [x.jsx(Ti, {
                        mode: "wait",
                        children: x.jsx(ee.h3, {
                            initial: {
                                opacity: 0,
                                y: 10
                            },
                            animate: {
                                opacity: 1,
                                y: 0
                            },
                            exit: {
                                opacity: 0,
                                y: -10
                            },
                            transition: {
                                ...h,
                                duration: .25
                            },
                            className: "text-gray-200 font-medium text-xl leading-6",
                            children: d[i - 1].title
                        }, `title-${i}`)
                    }), x.jsx(Ti, {
                        mode: "wait",
                        children: x.jsx(ee.p, {
                            initial: {
                                opacity: 0,
                                y: 15
                            },
                            animate: {
                                opacity: 1,
                                y: 0
                            },
                            exit: {
                                opacity: 0,
                                y: -15
                            },
                            transition: {
                                ...h,
                                duration: .3,
                                delay: .1
                            },
                            className: "text-gray-500 font-medium text-base sm:text-lg leading-6",
                            children: d[i - 1].description
                        }, `text-${i}`)
                    })]
                }), x.jsx(g, {})]
            })]
        })
    })
}
  , ji = {
    popular: [{
        code: "en",
        label: "English",
        flag: "🇺🇸"
    }, {
        code: "es",
        label: "Español",
        flag: "🇪🇸"
    }, {
        code: "pt",
        label: "Português",
        flag: "🇵🇹"
    }, {
        code: "ru",
        label: "Русский",
        flag: "🇷🇺"
    }, {
        code: "zh-TW",
        label: "繁體中文",
        flag: "🇹🇼"
    }, {
        code: "ja",
        label: "日本語",
        flag: "🇯🇵"
    }, {
        code: "ko",
        label: "한국어",
        flag: "🇰🇷"
    }],
    balkan: [{
        code: "sq",
        label: "Shqip",
        flag: "🇦🇱",
        country: "Albania"
    }, {
        code: "bs",
        label: "Bosanski",
        flag: "🇧🇦",
        country: "Bosnia and Herzegovina"
    }, {
        code: "bg",
        label: "Български",
        flag: "🇧🇬",
        country: "Bulgaria"
    }, {
        code: "hr",
        label: "Hrvatski",
        flag: "🇭🇷",
        country: "Croatia"
    }, {
        code: "xk",
        label: "Shqip/Srpski",
        flag: "🇽🇰",
        country: "Kosovo"
    }, {
        code: "me",
        label: "Црногорски",
        flag: "🇲🇪",
        country: "Montenegro"
    }, {
        code: "mk",
        label: "Македонски",
        flag: "🇲🇰",
        country: "North Macedonia"
    }, {
        code: "ro",
        label: "Română",
        flag: "🇷🇴",
        country: "Romania"
    }, {
        code: "sr",
        label: "Српски",
        flag: "🇷🇸",
        country: "Serbia"
    }, {
        code: "sl",
        label: "Slovenščina",
        flag: "🇸🇮",
        country: "Slovenia"
    }],
    asian: [{
        code: "ar",
        label: "العربية",
        flag: "🇸🇦"
    }, {
        code: "th",
        label: "ไทย",
        flag: "🇹🇭"
    }, {
        code: "vi",
        label: "Tiếng Việt",
        flag: "🇻🇳"
    }, {
        code: "bn",
        label: "বাংলা",
        flag: "🇧🇩"
    }, {
        code: "mn",
        label: "Монгол",
        flag: "🇲🇳"
    }, {
        code: "tr",
        label: "Türkçe",
        flag: "🇹🇷"
    }, {
        code: "id",
        label: "Bahasa Indonesia",
        flag: "🇮🇩"
    }],
    other: [{
        code: "sk",
        label: "Slovenčina",
        flag: "🇸🇰",
        country: "Slovakia"
    }, {
        code: "md",
        label: "Română",
        flag: "🇲🇩",
        country: "Moldova"
    }, {
        code: "ka",
        label: "ქართული",
        flag: "🇬🇪",
        country: "Georgia"
    }, {
        code: "by",
        label: "Беларуская",
        flag: "🇧🇾",
        country: "Belarus"
    }]
}
  , rc = [...ji.popular, ...ji.balkan, ...ji.asian, ...ji.other]
  , hP = () => {
    const [i,e] = N.useState("")
      , {i18n: r} = We()
      , {isOpen: a, closeModal: o} = o0()
      , l = N.useRef(null)
      , u = {
        en: {
            chooseLanguage: "Choose Language",
            searchPlaceholder: "Search languages...",
            popularLanguages: "Popular Languages",
            balkanPeninsula: "Balkan Peninsula",
            asianLanguages: "Asian Languages",
            searchResults: "Search Results",
            noLanguagesFound: "No languages found matching"
        },
        es: {
            chooseLanguage: "Elegir Idioma",
            searchPlaceholder: "Buscar idiomas...",
            popularLanguages: "Idiomas Populares",
            balkanPeninsula: "Península Balcánica",
            asianLanguages: "Idiomas Asiáticos",
            searchResults: "Resultados de Búsqueda",
            noLanguagesFound: "No se encontraron idiomas que coincidan con"
        },
        ru: {
            chooseLanguage: "Выберите Язык",
            searchPlaceholder: "Поиск языков...",
            popularLanguages: "Популярные Языки",
            balkanPeninsula: "Балканский Полуостров",
            asianLanguages: "Азиатские Языки",
            searchResults: "Результаты Поиска",
            noLanguagesFound: "Языки не найдены по запросу"
        },
        "zh-TW": {
            chooseLanguage: "選擇語言",
            searchPlaceholder: "搜尋語言...",
            popularLanguages: "熱門語言",
            balkanPeninsula: "巴爾幹半島",
            asianLanguages: "亞洲語言",
            searchResults: "搜尋結果",
            noLanguagesFound: "找不到符合條件的語言"
        },
        ja: {
            chooseLanguage: "言語を選択",
            searchPlaceholder: "言語を検索...",
            popularLanguages: "人気の言語",
            balkanPeninsula: "バルカン半島",
            asianLanguages: "アジアの言語",
            searchResults: "検索結果",
            noLanguagesFound: "一致する言語が見つかりません"
        },
        ko: {
            chooseLanguage: "언어 선택",
            searchPlaceholder: "언어 검색...",
            popularLanguages: "인기 언어",
            balkanPeninsula: "발칸 반도",
            asianLanguages: "아시아 언어",
            searchResults: "검색 결과",
            noLanguagesFound: "일치하는 언어를 찾을 수 없습니다"
        },
        sq: {
            chooseLanguage: "Zgjidhni Gjuhën",
            searchPlaceholder: "Kërkoni gjuhë...",
            popularLanguages: "Gjuhët Populları",
            balkanPeninsula: "Gadishulli Ballkanik",
            asianLanguages: "Gjuhët Aziatike",
            searchResults: "Rezultatet e Kërkimit",
            noLanguagesFound: "Nuk u gjetën gjuhë që përputhen me"
        },
        bs: {
            chooseLanguage: "Odaberite Jezik",
            searchPlaceholder: "Pretražite jezike...",
            popularLanguages: "Popularni Jezici",
            balkanPeninsula: "Balkansko Poluostrvo",
            asianLanguages: "Azijski Jezici",
            searchResults: "Rezultati Pretrage",
            noLanguagesFound: "Nisu pronađeni jezici koji se podudaraju sa"
        },
        bg: {
            chooseLanguage: "Изберете Език",
            searchPlaceholder: "Търсете езици...",
            popularLanguages: "Популярни Езици",
            balkanPeninsula: "Балкански Полуостров",
            asianLanguages: "Азиатски Езици",
            searchResults: "Резултати от Търсенето",
            noLanguagesFound: "Не са намерени езици, съответстващи на"
        },
        hr: {
            chooseLanguage: "Odaberite Jezik",
            searchPlaceholder: "Pretražite jezike...",
            popularLanguages: "Popularni Jezici",
            balkanPeninsula: "Balkanski Poluotok",
            asianLanguages: "Azijski Jezici",
            searchResults: "Rezultati Pretrage",
            noLanguagesFound: "Nisu pronađeni jezici koji se podudaraju s"
        },
        sr: {
            chooseLanguage: "Изаберите Језик",
            searchPlaceholder: "Претражите језике...",
            popularLanguages: "Популарни Језици",
            balkanPeninsula: "Балканско Полуострво",
            asianLanguages: "Азијски Језици",
            searchResults: "Резултати Претраге",
            noLanguagesFound: "Нису пронађени језици који се подударају са"
        },
        sl: {
            chooseLanguage: "Izberite Jezik",
            searchPlaceholder: "Iskanje jezikov...",
            popularLanguages: "Priljubljeni Jeziki",
            balkanPeninsula: "Balkanski Polotok",
            asianLanguages: "Azijski Jeziki",
            searchResults: "Rezultati Iskanja",
            noLanguagesFound: "Ni bilo najdenih jezikov, ki se ujemajo z"
        },
        sk: {
            chooseLanguage: "Vyberte Jazyk",
            searchPlaceholder: "Hľadať jazyky...",
            popularLanguages: "Obľúbené Jazyky",
            balkanPeninsula: "Balkánsky Polostrov",
            asianLanguages: "Ázijské Jazyky",
            searchResults: "Výsledky Vyhľadávania",
            noLanguagesFound: "Nenašli sa žiadne jazyky zodpovedajúce"
        },
        ro: {
            chooseLanguage: "Alegeți Limba",
            searchPlaceholder: "Căutați limbi...",
            popularLanguages: "Limbi Populare",
            balkanPeninsula: "Peninsula Balcanică",
            asianLanguages: "Limbi Asiatice",
            searchResults: "Rezultate Căutare",
            noLanguagesFound: "Nu s-au găsit limbi care să se potrivească cu"
        },
        mk: {
            chooseLanguage: "Изберете Јазик",
            searchPlaceholder: "Пребарувајте јазици...",
            popularLanguages: "Популарни Јазици",
            balkanPeninsula: "Балкански Полуостров",
            asianLanguages: "Азиски Јазици",
            searchResults: "Резултати од Пребарувањето",
            noLanguagesFound: "Не се пронајдени јазици што се совпаѓаат со"
        },
        by: {
            chooseLanguage: "Выберыце Мову",
            searchPlaceholder: "Шукаць мовы...",
            popularLanguages: "Папулярныя Мовы",
            balkanPeninsula: "Балканскі Паўвостраў",
            asianLanguages: "Азіяцкія Мовы",
            searchResults: "Вынікі Пошуку",
            noLanguagesFound: "Не знойдзена моў, якія адпавядаюць"
        },
        pt: {
            chooseLanguage: "Escolha o Idioma",
            searchPlaceholder: "Pesquisar idiomas...",
            popularLanguages: "Idiomas Populares",
            balkanPeninsula: "Península dos Bálcãs",
            asianLanguages: "Idiomas Asiáticos",
            searchResults: "Resultados da Pesquisa",
            noLanguagesFound: "Nenhum idioma encontrado correspondente a"
        }
    }
      , d = u[r.language] || u.en;
    rc.find(v => v.code === r.language) || rc[0];
    const p = i ? rc.filter(v => v.label.toLowerCase().includes(i.toLowerCase()) || v.code.toLowerCase().includes(i.toLowerCase()) || v.country && v.country.toLowerCase().includes(i.toLowerCase())) : null;
    N.useEffect( () => {
        const v = P => {
            l.current && !l.current.contains(P.target) && (o(),
            e(""))
        }
          , y = P => {
            P.key === "Escape" && (o(),
            e(""))
        }
        ;
        return a && (document.addEventListener("mousedown", v),
        document.addEventListener("keydown", y),
        document.body.style.overflow = "hidden"),
        () => {
            document.removeEventListener("mousedown", v),
            document.removeEventListener("keydown", y),
            document.body.style.overflow = "unset"
        }
    }
    , [a]);
    const h = v => {
        r.changeLanguage(v),
        o(),
        e("")
    }
      , g = (v, y) => x.jsxs("div", {
        className: "mb-6",
        children: [x.jsx("h3", {
            className: "text-sm font-semibold text-gray-400 mb-3 px-1 uppercase tracking-wider",
            children: v
        }), x.jsx("div", {
            className: "grid grid-cols-1 sm:grid-cols-2 gap-2",
            children: y.map(P => x.jsxs(ee.button, {
                onClick: () => h(P.code),
                whileHover: {
                    scale: 1.02
                },
                whileTap: {
                    scale: .98
                },
                className: `flex items-center gap-3 p-3 rounded-xl text-left transition-all duration-200
                       border border-transparent hover:border-blue-500/30
                       ${P.code === r.language ? "bg-gradient-to-r from-blue-600/20 to-purple-600/20 border-blue-500/50 text-white" : "text-[#D9DFE6] hover:bg-white/5"}`,
                children: [x.jsx("span", {
                    className: "text-lg",
                    children: P.flag
                }), x.jsxs("div", {
                    className: "flex-1 min-w-0",
                    children: [x.jsx("div", {
                        className: "font-medium truncate",
                        children: P.label
                    }), P.country && x.jsx("div", {
                        className: "text-xs text-gray-400 truncate",
                        children: P.country
                    })]
                }), P.code === r.language && x.jsx("div", {
                    className: "w-2 h-2 bg-blue-500 rounded-full flex-shrink-0"
                })]
            }, P.code))
        })]
    });
    return x.jsx(x.Fragment, {
        children: x.jsx(Ti, {
            children: a && x.jsx(ee.div, {
                initial: {
                    opacity: 0
                },
                animate: {
                    opacity: 1
                },
                exit: {
                    opacity: 0
                },
                className: "fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4",
                children: x.jsxs(ee.div, {
                    ref: l,
                    initial: {
                        opacity: 0,
                        scale: .95,
                        y: 20
                    },
                    animate: {
                        opacity: 1,
                        scale: 1,
                        y: 0
                    },
                    exit: {
                        opacity: 0,
                        scale: .95,
                        y: 20
                    },
                    transition: {
                        duration: .2
                    },
                    className: `bg-black/95 backdrop-blur-lg border border-gray-800 rounded-2xl 
                         shadow-2xl w-full max-w-4xl max-h-[80vh] overflow-hidden`,
                    children: [x.jsxs("div", {
                        className: "flex items-center justify-between p-6 border-b border-gray-800",
                        children: [x.jsxs("div", {
                            className: "flex items-center gap-3",
                            children: [x.jsx(Dc, {
                                size: 24,
                                className: "text-blue-500"
                            }), x.jsx("h2", {
                                className: "text-xl font-semibold text-white",
                                children: d.chooseLanguage
                            })]
                        }), x.jsx("button", {
                            onClick: () => {
                                o(),
                                e("")
                            }
                            ,
                            className: `p-2 text-gray-400 hover:text-white hover:bg-white/10 
                           rounded-lg transition-colors duration-200`,
                            children: x.jsx(rP, {
                                size: 20
                            })
                        })]
                    }), x.jsx("div", {
                        className: "p-6 pb-0",
                        children: x.jsxs("div", {
                            className: "relative",
                            children: [x.jsx(tP, {
                                size: 20,
                                className: "absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
                            }), x.jsx("input", {
                                type: "text",
                                placeholder: d.searchPlaceholder,
                                value: i,
                                onChange: v => e(v.target.value),
                                className: `w-full pl-10 pr-4 py-3 bg-gray-900/50 border border-gray-700 
                             rounded-xl text-white placeholder-gray-400 focus:outline-none 
                             focus:border-blue-500 transition-colors duration-200`
                            })]
                        })
                    }), x.jsxs("div", {
                        className: "p-6 overflow-y-auto max-h-[calc(80vh-200px)]",
                        children: [p ? x.jsxs("div", {
                            children: [x.jsxs("h3", {
                                className: "text-sm font-semibold text-gray-400 mb-3 px-1 uppercase tracking-wider",
                                children: [d.searchResults, " (", p.length, ")"]
                            }), x.jsx("div", {
                                className: "grid grid-cols-1 sm:grid-cols-2 gap-2",
                                children: p.map(v => x.jsxs(ee.button, {
                                    onClick: () => h(v.code),
                                    whileHover: {
                                        scale: 1.02
                                    },
                                    whileTap: {
                                        scale: .98
                                    },
                                    className: `flex items-center gap-3 p-3 rounded-xl text-left transition-all duration-200
                                     border border-transparent hover:border-blue-500/30
                                     ${v.code === r.language ? "bg-gradient-to-r from-blue-600/20 to-purple-600/20 border-blue-500/50 text-white" : "text-[#D9DFE6] hover:bg-white/5"}`,
                                    children: [x.jsx("span", {
                                        className: "text-lg",
                                        children: v.flag
                                    }), x.jsxs("div", {
                                        className: "flex-1 min-w-0",
                                        children: [x.jsx("div", {
                                            className: "font-medium truncate",
                                            children: v.label
                                        }), v.country && x.jsx("div", {
                                            className: "text-xs text-gray-400 truncate",
                                            children: v.country
                                        })]
                                    }), v.code === r.language && x.jsx("div", {
                                        className: "w-2 h-2 bg-blue-500 rounded-full flex-shrink-0"
                                    })]
                                }, v.code))
                            })]
                        }) : x.jsxs("div", {
                            className: "space-y-8",
                            children: [g(d.popularLanguages, ji.popular), g(d.balkanPeninsula, ji.balkan), g(d.asianLanguages, ji.asian), g("Other Languages", ji.other)]
                        }), p && p.length === 0 && x.jsxs("div", {
                            className: "text-center py-8 text-gray-400",
                            children: [x.jsx(Dc, {
                                size: 48,
                                className: "mx-auto mb-4 opacity-50"
                            }), x.jsxs("p", {
                                children: [d.noLanguagesFound, ' "', i, '"']
                            })]
                        })]
                    })]
                })
            })
        })
    })
}
  , fP = ({children: i}) => x.jsxs("div", {
    className: "min-h-screen flex flex-col ",
    children: [x.jsx(lP, {}), x.jsx("main", {
        className: "overflow-hidden",
        children: i
    }), x.jsx(m1, {}), x.jsx(mP, {}), x.jsx(hP, {})]
})
  , gP = "/cdn/shop/t/1/assets/card-D-eUqvcG.webp"
  , vP = "/cdn/shop/t/1/assets/card1-D4Yak_2H.webp"
  , Xh = ({title: i, description: e, features: r, image: a, breakLine: o}) => {
    const l = N.useRef(null)
      , u = Ht(l, {
        once: !0,
        margin: "-100px"
    });
    return x.jsx(ee.div, {
        ref: l,
        initial: {
            opacity: 0,
            y: 20
        },
        animate: u ? {
            opacity: 1,
            y: 0
        } : {
            opacity: 0,
            y: 20
        },
        transition: {
            duration: .5
        },
        className: "bg-[#FFFFFF] border border-[#D0D3D7] rounded-[20px] md:rounded-[32px] p-4 sm:p-6 md:p-8 flex flex-col gap-4 w-full",
        children: x.jsxs("div", {
            className: "flex flex-col gap-4 w-full h-full",
            children: [x.jsx("h2", {
                className: "text-[#0D1013] font-bold uppercase text-[32px] sm:text-[42px] md:text-[52px] leading-tight md:leading-[64px]",
                children: i === "Bar Replay" ? x.jsxs(x.Fragment, {
                    children: [x.jsx("span", {
                        className: "block",
                        children: "Bar"
                    }), x.jsx("span", {
                        className: "block",
                        children: "Replay"
                    })]
                }) : i
            }), x.jsx("p", {
                className: "text-[#3B4046] text-[16px] md:text-[18px] leading-tight md:leading-[24px]",
                children: e
            }), x.jsx(ee.div, {
                className: "w-full flex flex-col gap-3 md:gap-4",
                variants: {
                    hidden: {
                        opacity: 0
                    },
                    show: {
                        opacity: 1,
                        transition: {
                            staggerChildren: .1
                        }
                    }
                },
                initial: "hidden",
                animate: u ? "show" : "hidden",
                children: r.map( (d, p) => x.jsxs(ee.div, {
                    className: "flex items-center gap-2",
                    variants: {
                        hidden: {
                            opacity: 0,
                            x: -20
                        },
                        show: {
                            opacity: 1,
                            x: 0
                        }
                    },
                    children: [x.jsx(xP, {}), x.jsx("span", {
                        className: "text-[#121619] text-[16px] md:text-[18px] leading-tight md:leading-[24px]",
                        children: d
                    })]
                }, p))
            }), x.jsx(ee.img, {
                src: a,
                alt: "",
                className: "w-full rounded-lg !mt-auto",
                initial: {
                    opacity: 0,
                    scale: .95
                },
                animate: u ? {
                    opacity: 1,
                    scale: 1
                } : {
                    opacity: 0,
                    scale: .95
                },
                transition: {
                    duration: .5,
                    delay: .2
                }
            })]
        })
    })
}
  , yP = i => {
    const e = {
        en: {
            chartsPerTab: "Technical Analysis, Done Right",
            barReplay: "Bar Replay",
            "Our platform comes with hundreds of built-in indicators and strategies, the most popular drawing tools and concepts for in-depth market analysis covering": "Our platform comes with hundreds of built-in indicators and strategies, the most popular drawing tools and concepts for in-depth market analysis covering",
            "400+ built-in indicators and strategies": "400+ built-in indicators and strategies",
            "100,000+ public indicators": "100,000+ public indicators",
            "110+ smart drawing tools": "110+ smart drawing tools",
            "Volume Profile indicators": "Volume Profile indicators",
            "Candlestick patterns recognition": "Candlestick patterns recognition",
            "Multi-timeframe analysis": "Multi-timeframe analysis",
            "Auto Chart Patterns": "Auto Chart Patterns",
            "Watch how pricing data unfolded historically. Rewind markets and review at a speed and resolution you desire.": "Watch how pricing data unfolded historically. Rewind markets and review at a speed and resolution you desire.",
            "Simulated trading on historical data": "Simulated trading on historical data",
            "4 replay speeds": "4 replay speeds",
            "Autoplay and step-by-step mode": "Autoplay and step-by-step mode",
            "You can also apply drawing objects and indicators": "You can also apply drawing objects and indicators",
            "Synchronized multi-chart replay": "Synchronized multi-chart replay",
            "Trading on historical data": "Trading on historical data",
            "In-depth historical data by the minute and by the second": "In-depth historical data by the minute and by the second"
        },
        pt: {
            chartsPerTab: "Análise Técnica, Feita Corretamente",
            barReplay: "Reprodução de Barras",
            "Our platform comes with hundreds of built-in indicators and strategies, the most popular drawing tools and concepts for in-depth market analysis covering": "Nossa plataforma vem com centenas de indicadores e estratégias integrados, as ferramentas de desenho mais populares e conceitos para análise de mercado aprofundada",
            "400+ built-in indicators and strategies": "400+ indicadores e estratégias integrados",
            "100,000+ public indicators": "100,000+ indicadores públicos",
            "110+ smart drawing tools": "110+ ferramentas de desenho inteligentes",
            "Volume Profile indicators": "Indicadores de Perfil de Volume",
            "Candlestick patterns recognition": "Reconhecimento de Padrões de Velas",
            "Multi-timeframe analysis": "Análise de Múltiplos Timeframes",
            "Auto Chart Patterns": "Padrões de Gráficos Automáticos",
            "Watch how pricing data unfolded historically. Rewind markets and review at a speed and resolution you desire.": "Observe como os dados de preços se desenrolaram historicamente. Retroceda os mercados e revise na velocidade e resolução que desejar.",
            "Simulated trading on historical data": "Negociação simulada em dados históricos",
            "4 replay speeds": "4 velocidades de reprodução",
            "Autoplay and step-by-step mode": "Modo de reprodução automática e passo a passo",
            "You can also apply drawing objects and indicators": "Você também pode aplicar objetos de desenho e indicadores",
            "Synchronized multi-chart replay": "Reprodução sincronizada de múltiplos gráficos",
            "Trading on historical data": "Negociação em dados históricos",
            "In-depth historical data by the minute and by the second": "Dados históricos detalhados por minuto e por segundo"
        },
        ru: {
            chartsPerTab: "Технический анализ, выполненный правильно",
            barReplay: "Воспроизведение баров",
            "Our platform comes with hundreds of built-in indicators and strategies, the most popular drawing tools and concepts for in-depth market analysis covering": "Наша платформа включает сотни встроенных индикаторов и стратегий, самые популярные инструменты рисования и концепции для глубокого анализа рынка, охватывающие",
            "400+ built-in indicators and strategies": "400+ встроенных индикаторов и стратегий",
            "100,000+ public indicators": "100,000+ публичных индикаторов",
            "110+ smart drawing tools": "110+ интеллектуальных инструментов рисования",
            "Volume Profile indicators": "Индикаторы профиля объема",
            "Candlestick patterns recognition": "Распознавание свечных моделей",
            "Multi-timeframe analysis": "Анализ на нескольких таймфреймах",
            "Auto Chart Patterns": "Автоматическое распознавание графических моделей",
            "Watch how pricing data unfolded historically. Rewind markets and review at a speed and resolution you desire.": "Наблюдайте, как исторические данные о ценах развивались во времени. Перематывайте рынки и просматривайте с нужной скоростью и разрешением.",
            "Simulated trading on historical data": "Симуляция торговли на исторических данных",
            "4 replay speeds": "4 скорости воспроизведения",
            "Autoplay and step-by-step mode": "Режимы автопроигрывания и пошагового воспроизведения",
            "You can also apply drawing objects and indicators": "Вы также можете применять объекты рисования и индикаторы",
            "Synchronized multi-chart replay": "Синхронизированное воспроизведение на нескольких графиках",
            "Trading on historical data": "Торговля на исторических данных",
            "In-depth historical data by the minute and by the second": "Глубокие исторические данные по минутам и секундам"
        },
        es: {
            chartsPerTab: "Análisis Técnico, Hecho Bien",
            barReplay: "Reproducción de Barras",
            "Our platform comes with hundreds of built-in indicators and strategies, the most popular drawing tools and concepts for in-depth market analysis covering": "Nuestra plataforma viene con cientos de indicadores y estrategias integrados, las herramientas de dibujo más populares y conceptos para un análisis de mercado profundo",
            "400+ built-in indicators and strategies": "400+ indicadores y estrategias integrados",
            "100,000+ public indicators": "100,000+ indicadores públicos",
            "110+ smart drawing tools": "110+ herramientas de dibujo inteligentes",
            "Volume Profile indicators": "Indicadores de perfil de volumen",
            "Candlestick patterns recognition": "Reconocimiento de patrones de velas",
            "Multi-timeframe analysis": "Análisis de múltiples marcos temporales",
            "Auto Chart Patterns": "Patrones de gráficos automáticos",
            "Watch how pricing data unfolded historically. Rewind markets and review at a speed and resolution you desire.": "Observa cómo se desarrollaron los datos de precios históricamente. Rebobina los mercados y revisa a la velocidad y resolución que desees.",
            "Simulated trading on historical data": "Trading simulado en datos históricos",
            "4 replay speeds": "4 velocidades de reproducción",
            "Autoplay and step-by-step mode": "Modo de reproducción automática y paso a paso",
            "You can also apply drawing objects and indicators": "También puedes aplicar objetos de dibujo e indicadores",
            "Synchronized multi-chart replay": "Reproducción sincronizada de múltiples gráficos",
            "Trading on historical data": "Trading en datos históricos",
            "In-depth historical data by the minute and by the second": "Datos históricos detallados por minuto y por segundo"
        },
        vi: {
            chartsPerTab: "Phân Tích Kỹ Thuật, Làm Đúng",
            barReplay: "Phát Lại Thanh",
            "Our platform comes with hundreds of built-in indicators and strategies, the most popular drawing tools and concepts for in-depth market analysis covering": "Nền tảng của chúng tôi đi kèm với hàng trăm chỉ báo và chiến lược tích hợp, các công cụ vẽ và khái niệm phổ biến nhất để phân tích thị trường sâu sắc",
            "400+ built-in indicators and strategies": "400+ chỉ báo và chiến lược tích hợp",
            "100,000+ public indicators": "100,000+ chỉ báo công khai",
            "110+ smart drawing tools": "110+ công cụ vẽ thông minh",
            "Volume Profile indicators": "Chỉ báo hồ sơ khối lượng",
            "Candlestick patterns recognition": "Nhận diện mẫu nến",
            "Multi-timeframe analysis": "Phân tích đa khung thời gian",
            "Auto Chart Patterns": "Mẫu biểu đồ tự động",
            "Watch how pricing data unfolded historically. Rewind markets and review at a speed and resolution you desire.": "Xem cách dữ liệu giá cả diễn ra theo lịch sử. Quay lại thị trường và xem lại với tốc độ và độ phân giải bạn mong muốn.",
            "Simulated trading on historical data": "Giao dịch mô phỏng trên dữ liệu lịch sử",
            "4 replay speeds": "4 tốc độ phát lại",
            "Autoplay and step-by-step mode": "Chế độ tự động và từng bước",
            "You can also apply drawing objects and indicators": "Bạn cũng có thể áp dụng các đối tượng vẽ và chỉ báo",
            "Synchronized multi-chart replay": "Phát lại đồng bộ đa biểu đồ",
            "Trading on historical data": "Giao dịch trên dữ liệu lịch sử",
            "In-depth historical data by the minute and by the second": "Dữ liệu lịch sử chi tiết theo phút và giây"
        },
        th: {
            chartsPerTab: "การวิเคราะห์ทางเทคนิคที่ทำได้ดี",
            barReplay: "การเล่นแถบซ้ำ",
            "Our platform comes with hundreds of built-in indicators and strategies, the most popular drawing tools and concepts for in-depth market analysis covering": "แพลตฟอร์มของเรามาพร้อมกับตัวชี้วัดและกลยุทธ์ในตัวหลายร้อยรายการ เครื่องมือวาดภาพและแนวคิดยอดนิยมที่สุดสำหรับการวิเคราะห์ตลาดอย่างลึกซึ้ง",
            "400+ built-in indicators and strategies": "400+ ตัวชี้วัดและกลยุทธ์ในตัว",
            "100,000+ public indicators": "100,000+ ตัวชี้วัดสาธารณะ",
            "110+ smart drawing tools": "110+ เครื่องมือวาดภาพอัจฉริยะ",
            "Volume Profile indicators": "ตัวชี้วัดโปรไฟล์ปริมาณ",
            "Candlestick patterns recognition": "การรู้จำแพทเทิร์นแท่งเทียน",
            "Multi-timeframe analysis": "การวิเคราะห์หลายกรอบเวลา",
            "Auto Chart Patterns": "แพทเทิร์นกราฟอัตโนมัติ",
            "Watch how pricing data unfolded historically. Rewind markets and review at a speed and resolution you desire.": "ดูว่าข้อมูลราคาเปิดเผยออกมาอย่างไรในอดีต ย้อนตลาดและตรวจสอบที่ความเร็วและความละเอียดที่คุณต้องการ",
            "Simulated trading on historical data": "การซื้อขายจำลองบนข้อมูลประวัติ",
            "4 replay speeds": "4 ความเร็วในการเล่นซ้ำ",
            "Autoplay and step-by-step mode": "โหมดเล่นอัตโนมัติและทีละขั้นตอน",
            "You can also apply drawing objects and indicators": "คุณสามารถใช้ประยุกต์วัตถุวาดและตัวชี้วัดได้",
            "Synchronized multi-chart replay": "การเล่นซ้ำแบบซิงโครไนซ์หลายกราฟ",
            "Trading on historical data": "การซื้อขายบนข้อมูลประวัติ",
            "In-depth historical data by the minute and by the second": "ข้อมูลประวัติลึกซึ้งตามนาทีและวินาที"
        },
        ja: {
            chartsPerTab: "テクニカル分析、正しく行う",
            barReplay: "バー再生",
            "Our platform comes with hundreds of built-in indicators and strategies, the most popular drawing tools and concepts for in-depth market analysis covering": "当社のプラットフォームには、数百の組み込みインジケーターと戦略、最も人気のある描画ツールと概念が含まれ、市場分析を深くカバーします",
            "400+ built-in indicators and strategies": "400以上の組み込みインジケーターと戦略",
            "100,000+ public indicators": "100,000以上の公開インジケーター",
            "110+ smart drawing tools": "110以上のスマート描画ツール",
            "Volume Profile indicators": "出来高プロファイルインジケーター",
            "Candlestick patterns recognition": "ローソク足パターンの認識",
            "Multi-timeframe analysis": "マルチタイムフレーム分析",
            "Auto Chart Patterns": "自動チャートパターン",
            "Watch how pricing data unfolded historically. Rewind markets and review at a speed and resolution you desire.": "価格データの歴史的な展開を観察。市場を巻き戻し、希望する速度と解像度で確認。",
            "Simulated trading on historical data": "過去データのシミュレート取引",
            "4 replay speeds": "4つの再生速度",
            "Autoplay and step-by-step mode": "オートプレイとステップごとのモード",
            "You can also apply drawing objects and indicators": "描画オブジェクトとインジケーターも適用可能",
            "Synchronized multi-chart replay": "同期マルチチャート再生",
            "Trading on historical data": "過去データの取引",
            "In-depth historical data by the minute and by the second": "分単位および秒単位の詳細な過去データ"
        },
        ko: {
            chartsPerTab: "기술 분석, 제대로 수행",
            barReplay: "바 재생",
            "Our platform comes with hundreds of built-in indicators and strategies, the most popular drawing tools and concepts for in-depth market analysis covering": "우리 플랫폼은 수백 개의 내장 지표와 전략, 시장 분석을 깊이 있게 다루기 위한 가장 인기 있는 드로잉 도구와 개념을 제공합니다",
            "400+ built-in indicators and strategies": "400개 이상의 내장 지표와 전략",
            "100,000+ public indicators": "100,000개 이상의 공개 지표",
            "110+ smart drawing tools": "110개 이상의 스마트 드로잉 도구",
            "Volume Profile indicators": "거래량 프로필 지표",
            "Candlestick patterns recognition": "캔들스틱 패턴 인식",
            "Multi-timeframe analysis": "다중 시간 프레임 분석",
            "Auto Chart Patterns": "자동 차트 패턴",
            "Watch how pricing data unfolded historically. Rewind markets and review at a speed and resolution you desire.": "가격 데이터가 역사적으로 어떻게 전개되었는지 확인하세요. 시장을 되감아 원하는 속도와 해상도로 검토하세요.",
            "Simulated trading on historical data": "과거 데이터로 시뮬레이션 거래",
            "4 replay speeds": "4가지 재생 속도",
            "Autoplay and step-by-step mode": "자동 재생 및 단계별 모드",
            "You can also apply drawing objects and indicators": "드로잉 객체와 지표도 적용 가능",
            "Synchronized multi-chart replay": "동기화된 다중 차트 재생",
            "Trading on historical data": "과거 데이터로 거래",
            "In-depth historical data by the minute and by the second": "분 단위 및 초 단위의 심층 과거 데이터"
        },
        "zh-TW": {
            chartsPerTab: "技術分析，做到最好",
            barReplay: "柱重播",
            "Our platform comes with hundreds of built-in indicators and strategies, the most popular drawing tools and concepts for in-depth market analysis covering": "我們的平台搭載數百個內建指標和策略，最受歡迎的繪圖工具和概念，用於深入市場分析",
            "400+ built-in indicators and strategies": "400+ 內建指標和策略",
            "100,000+ public indicators": "100,000+ 公開指標",
            "110+ smart drawing tools": "110+ 智能繪圖工具",
            "Volume Profile indicators": "成交量剖面指標",
            "Candlestick patterns recognition": "K線圖模式識別",
            "Multi-timeframe analysis": "多時間框架分析",
            "Auto Chart Patterns": "自動圖表模式",
            "Watch how pricing data unfolded historically. Rewind markets and review at a speed and resolution you desire.": "觀看價格數據如何歷史性地展開。回顧市場並以您想要的速度和解析度檢視。",
            "Simulated trading on historical data": "基於歷史數據的模擬交易",
            "4 replay speeds": "4種重播速度",
            "Autoplay and step-by-step mode": "自動播放和逐步模式",
            "You can also apply drawing objects and indicators": "您還可以應用繪圖對象和指標",
            "Synchronized multi-chart replay": "同步多圖表重播",
            "Trading on historical data": "基於歷史數據的交易",
            "In-depth historical data by the minute and by the second": "分鐘和秒級的深入歷史數據"
        },
        ar: {
            chartsPerTab: "التحليل التقني، تم تنفيذه بشكل صحيح",
            barReplay: "إعادة تشغيل الشريط",
            "Our platform comes with hundreds of built-in indicators and strategies, the most popular drawing tools and concepts for in-depth market analysis covering": "منصتنا تأتي مع مئات المؤشرات والاستراتيجيات المدمجة، وأدوات الرسم الأكثر شيوعًا ومفاهيم لتحليل السوق العميق",
            "400+ built-in indicators and strategies": "400+ مؤشر واستراتيجية مدمجة",
            "100,000+ public indicators": "100,000+ مؤشر عام",
            "110+ smart drawing tools": "110+ أدوات رسم ذكية",
            "Volume Profile indicators": "مؤشرات ملف الحجم",
            "Candlestick patterns recognition": "التعرف على أنماط الشموع",
            "Multi-timeframe analysis": "تحليل متعدد الإطار الزمني",
            "Auto Chart Patterns": "أنماط الرسوم البيانية التلقائية",
            "Watch how pricing data unfolded historically. Rewind markets and review at a speed and resolution you desire.": "شاهد كيف تطورت بيانات الأسعار تاريخيًا. راجع الأسواق واستعرضها بسرعة ودقة ترغب بها.",
            "Simulated trading on historical data": "التداول المحاكاة على البيانات التاريخية",
            "4 replay speeds": "4 سرعات لإعادة التشغيل",
            "Autoplay and step-by-step mode": "وضع التشغيل التلقائي وخطوة بخطوة",
            "You can also apply drawing objects and indicators": "يمكنك أيضًا تطبيق الكائنات والمؤشرات",
            "Synchronized multi-chart replay": "إعادة تشغيل متعدد الرسوم البيانية المتزامنة",
            "Trading on historical data": "التداول على البيانات التاريخية",
            "In-depth historical data by the minute and by the second": "بيانات تاريخية مفصلة بالدقيقة والثانية"
        },
        bn: {
            chartsPerTab: "তকনিক্যাল বিশ্লেষণ, সঠিকভাবে সম্পন্ন",
            barReplay: "বার পুনর্বার চালানো",
            "Our platform comes with hundreds of built-in indicators and strategies, the most popular drawing tools and concepts for in-depth market analysis covering": "আমাদের প্ল্যাটফর্মে শতাধিক বিল্ট-ইন ইন্ডিকেটর এবং কৌশল, সবচেয়ে জনপ্রিয় ড্রয়িং টুল এবং গভীর বাজার বিশ্লেষণের জন্য ধারণা রয়েছে",
            "400+ built-in indicators and strategies": "400+ বিল্ট-ইন ইন্ডিকেটর এবং কৌশল",
            "100,000+ public indicators": "100,000+ পাবলিক ইন্ডিকেটর",
            "110+ smart drawing tools": "110+ স্মার্ট ড্রয়িং টুল",
            "Volume Profile indicators": "ভলিউম প্রোফাইল ইন্ডিকেটর",
            "Candlestick patterns recognition": "ক্যান্ডলস্টিক প্যাটার্ন সনাক্তকরণ",
            "Multi-timeframe analysis": "মাল্টি-টাইমফ্রেম বিশ্লেষণ",
            "Auto Chart Patterns": "অটো চার্ট প্যাটার্ন",
            "Watch how pricing data unfolded historically. Rewind markets and review at a speed and resolution you desire.": "দামের ডেটা ঐতিহাসিকভাবে কীভাবে প্রকাশিত হয়েছে তা দেখুন। বাজার পিছিয়ে নিয়ে আপনার wished স্পিড এবং রেজোলিউশনে পর্যালোচনা করুন।",
            "Simulated trading on historical data": "ইতিহাসিক ডেটার উপর সিমুলেটেড ট্রেডিং",
            "4 replay speeds": "4 পুনর্বার চালানোর গতি",
            "Autoplay and step-by-step mode": "অটোপ্লে এবং ধাপে ধাপে মোড",
            "You can also apply drawing objects and indicators": "আপনি ড্রয়িং অবজেক্ট এবং ইন্ডিকেটর প্রয়োগ করতে পারেন",
            "Synchronized multi-chart replay": "সিঙ্ক্রোনাইজড মাল্টি-চার্ট পুনর্বার চালানো",
            "Trading on historical data": "ইতিহাসিক ডেটার উপর ট্রেডিং",
            "In-depth historical data by the minute and by the second": "মিনিট এবং সেকেন্ড অনুযায়ী গভীর ইতিহাসিক ডেটা"
        },
        id: {
            chartsPerTab: "Analisis Teknis, Dilakukan dengan Benar",
            barReplay: "Putar Ulang Batang",
            "Our platform comes with hundreds of built-in indicators and strategies, the most popular drawing tools and concepts for in-depth market analysis covering": "Platform kami dilengkapi dengan ratusan indikator dan strategi bawaan, alat menggambar terpopuler dan konsep untuk analisis pasar mendalam",
            "400+ built-in indicators and strategies": "400+ indikator dan strategi bawaan",
            "100,000+ public indicators": "100,000+ indikator publik",
            "110+ smart drawing tools": "110+ alat menggambar cerdas",
            "Volume Profile indicators": "Indikator Profil Volume",
            "Candlestick patterns recognition": "Pengenalan pola candlestick",
            "Multi-timeframe analysis": "Analisis multi-timeframe",
            "Auto Chart Patterns": "Pola Grafik Otomatis",
            "Watch how pricing data unfolded historically. Rewind markets and review at a speed and resolution you desire.": "Lihat bagaimana data harga terungkap secara historis. Putar ulang pasar dan tinjau dengan kecepatan dan resolusi yang Anda inginkan.",
            "Simulated trading on historical data": "Perdagangan simulasi pada data historis",
            "4 replay speeds": "4 kecepatan putar ulang",
            "Autoplay and step-by-step mode": "Mode putar otomatis dan langkah demi langkah",
            "You can also apply drawing objects and indicators": "Anda juga dapat menerapkan objek menggambar dan indikator",
            "Synchronized multi-chart replay": "Putar ulang multi-grafik yang disinkronkan",
            "Trading on historical data": "Perdagangan pada data historis",
            "In-depth historical data by the minute and by the second": "Data historis mendalam per menit dan per detik"
        },
        ka: {
            chartsPerTab: "ტექნიკური ანალიზი, სწორად განხორციელებული",
            barReplay: "ზოლის ხელახალი დაკვრა",
            "Our platform comes with hundreds of built-in indicators and strategies, the most popular drawing tools and concepts for in-depth market analysis covering": "ჩვენი პლატფორმა მოიცავს ასობით ჩაშენებულ ინდიკატორსა და სტრატეგიას, ყველაზე პოპულარულ ხატვის ინსტრუმენტებსა და კონცეფციებს ღრმა ბაზრის ანალიზისთვის",
            "400+ built-in indicators and strategies": "400+-ზე მეტი ჩაშენებული ინდიკატორი და სტრატეგია",
            "100,000+ public indicators": "100,000-ზე მეტი საჯარო ინდიკატორი",
            "110+ smart drawing tools": "110-ზე მეტი ჭკვიანი ხატვის ინსტრუმენტი",
            "Volume Profile indicators": "მოცულობის პროფილის ინდიკატორები",
            "Candlestick patterns recognition": "სანთლის ფიგურების ამოცნობა",
            "Multi-timeframe analysis": "მრავალფრეიმული ანალიზი",
            "Auto Chart Patterns": "ავტომატური ჩარტის ფიგურები",
            "Watch how pricing data unfolded historically. Rewind markets and review at a speed and resolution you desire.": "იხილეთ, თუ როგორ განვითარდა ფასის მონაცემები ისტორიულად. გაანულეთ ბაზრები და გადახედეთ სასურველ სიჩქარესა და გარჩევადობას.",
            "Simulated trading on historical data": "ისტორიული მონაცემების სიმულაციური ვაჭრობა",
            "4 replay speeds": "4 ხელახალი დაკვრის სიჩქარე",
            "Autoplay and step-by-step mode": "ავტომატური დაკვრა და ნაბიჯ-ნაბიჯ რეჟიმი",
            "You can also apply drawing objects and indicators": "თქვენ ასევე შეგიძლიათ გამოიყენოთ ხატვის ობიექტები და ინდიკატორები",
            "Synchronized multi-chart replay": "სინქრონიზებული მრავალჩარტის ხელახალი დაკვრა",
            "Trading on historical data": "ვაჭრობა ისტორიულ მონაცემებზე",
            "In-depth historical data by the minute and by the second": "ღრმა ისტორიული მონაცემები წუთებისა და წამების მიხედვით"
        },
        mn: {
            chartsPerTab: "Техникийн шинжилгээ, зөв гүйцэтгэсэн",
            barReplay: "Баганын дахин тоглуулалт",
            "Our platform comes with hundreds of built-in indicators and strategies, the most popular drawing tools and concepts for in-depth market analysis covering": "Манай платформ нь хэдэн зуун баригдсан индикатор, стратеги, хамгийн алдартай зургийн хэрэгсэл, гүнзгий зах зээлийн шинжилгээ хийхэд зориулсан концепцуудтай ирнэ",
            "400+ built-in indicators and strategies": "400+ баригдсан индикатор ба стратеги",
            "100,000+ public indicators": "100,000+ нийтийн индикатор",
            "110+ smart drawing tools": "110+ ухаантай зургийн хэрэгсэл",
            "Volume Profile indicators": "Бүрэлдэхүүн хэмжээний профайлын индикатор",
            "Candlestick patterns recognition": "Кэндлстик загварыг таниулах",
            "Multi-timeframe analysis": "Олон цагийн хүрээний шинжилгээ",
            "Auto Chart Patterns": "Автомат график загвар",
            "Watch how pricing data unfolded historically. Rewind markets and review at a speed and resolution you desire.": "Үнийн өгөгдөл түүхэн дээр хэрхэн хөгжсөнийг үзээрэй. Зах зээлийг буцааж, та хүссэн хурд, тогтоцтойгоор дахин хянаарай.",
            "Simulated trading on historical data": "Түүхэн өгөгдлөөр хиймэл худалдаа",
            "4 replay speeds": "4 дахин тоглуулах хурд",
            "Autoplay and step-by-step mode": "Автомат тоглуулалт ба алхам алхмаар горим",
            "You can also apply drawing objects and indicators": "Та зургийн объектууд болон индикаторыг хэрэглэж болно",
            "Synchronized multi-chart replay": "Уялдуулсан олон график дахин тоглуулалт",
            "Trading on historical data": "Түүхэн өгөгдлөөр худалдаа",
            "In-depth historical data by the minute and by the second": "Минут, секунд тутмын гүнзгий түүхэн өгөгдөл"
        },
        tr: {
            chartsPerTab: "Teknik Analiz, Doğru Yapılmış",
            barReplay: "Çubuk Tekrarı",
            "Our platform comes with hundreds of built-in indicators and strategies, the most popular drawing tools and concepts for in-depth market analysis covering": "Platformumuz, yüzlerce yerleşik gösterge ve strateji, en popüler çizim araçları ve derinlemesine piyasa analizi için kavramlarla birlikte gelir",
            "400+ built-in indicators and strategies": "400+ yerleşik gösterge ve strateji",
            "100,000+ public indicators": "100,000+ halka açık gösterge",
            "110+ smart drawing tools": "110+ akıllı çizim aracı",
            "Volume Profile indicators": "Hacim Profili göstergeleri",
            "Candlestick patterns recognition": "Mum formasyonları tanıma",
            "Multi-timeframe analysis": "Çoklu zaman çerçevesi analizi",
            "Auto Chart Patterns": "Otomatik Grafik Desenleri",
            "Watch how pricing data unfolded historically. Rewind markets and review at a speed and resolution you desire.": "Fiyat verilerinin tarihsel olarak nasıl geliştiğini izleyin. Piyasaları geri sarın ve istediğiniz hızda ve çözünürlükte gözden geçirin.",
            "Simulated trading on historical data": "Tarihsel verilerle simülasyon ticareti",
            "4 replay speeds": "4 tekrar hızı",
            "Autoplay and step-by-step mode": "Otomatik oynatma ve adım adım mod",
            "You can also apply drawing objects and indicators": "Çizim nesneleri ve göstergeleri de uygulayabilirsiniz",
            "Synchronized multi-chart replay": "Eşzamanlı çoklu grafik tekrar",
            "Trading on historical data": "Tarihsel verilerle ticaret",
            "In-depth historical data by the minute and by the second": "Dakika ve saniye bazında ayrıntılı tarihsel veriler"
        },
        sq: {
            chartsPerTab: "Analizë Teknike, e Bërë Drejt",
            barReplay: "Përsëritja e Brezit",
            "Our platform comes with hundreds of built-in indicators and strategies, the most popular drawing tools and concepts for in-depth market analysis covering": "Platforma jonë vjen me qindra indikatorë dhe strategji të integruar, mjetet e vizatimit më të popullarizuara dhe konceptet për analizë të thellë të tregut",
            "400+ built-in indicators and strategies": "400+ indikatorë dhe strategji të integruar",
            "100,000+ public indicators": "100,000+ indikatorë publikë",
            "110+ smart drawing tools": "110+ mjete të zgjuara vizatimi",
            "Volume Profile indicators": "Indikatorët e Profilit të Vëllimit",
            "Candlestick patterns recognition": "Njohja e modeleve të qirive",
            "Multi-timeframe analysis": "Analizë shumë-kornizë kohore",
            "Auto Chart Patterns": "Modelet Automatike të Grafikut",
            "Watch how pricing data unfolded historically. Rewind markets and review at a speed and resolution you desire.": "Shikoni se si të dhënat e çmimeve u zhvilluan historikisht. Ktheni tregun prapa dhe rishikoni me shpejtësinë dhe rezolucionin që dëshironi.",
            "Simulated trading on historical data": "Tregtim i simuluar në të dhëna historike",
            "4 replay speeds": "4 shpejtësi përsëritje",
            "Autoplay and step-by-step mode": "Modaliteti i luajtjes automatike dhe hap pas hapi",
            "You can also apply drawing objects and indicators": "Mund të aplikoni gjithashtu objekte vizatimi dhe indikatorë",
            "Synchronized multi-chart replay": "Përsëritje shumë-grafik e sinkronizuar",
            "Trading on historical data": "Tregtim në të dhëna historike",
            "In-depth historical data by the minute and by the second": "Të dhëna historike të thella sipas minutave dhe sekondave"
        },
        bs: {
            chartsPerTab: "Tehnička Analiza, Urađena Kako Treba",
            barReplay: "Ponavljanje Traka",
            "Our platform comes with hundreds of built-in indicators and strategies, the most popular drawing tools and concepts for in-depth market analysis covering": "Naša platforma dolazi sa stotinama ugrađenih indikatora i strategija, najpopularnijim alatima za crtanje i konceptima za duboku analizu tržišta",
            "400+ built-in indicators and strategies": "400+ ugrađenih indikatora i strategija",
            "100,000+ public indicators": "100,000+ javnih indikatora",
            "110+ smart drawing tools": "110+ pametnih alata za crtanje",
            "Volume Profile indicators": "Indikatori profila volumena",
            "Candlestick patterns recognition": "Prepoznavanje uzoraka svijeća",
            "Multi-timeframe analysis": "Analiza više vremenskih okvira",
            "Auto Chart Patterns": "Automatski uzorci grafika",
            "Watch how pricing data unfolded historically. Rewind markets and review at a speed and resolution you desire.": "Pogledajte kako su se podaci o cijenama povijesno razvijali. Premotajte tržišta i pregledajte brzinom i rezolucijom koju želite.",
            "Simulated trading on historical data": "Simulirano trgovanje na povijesnim podacima",
            "4 replay speeds": "4 brzine ponavljanja",
            "Autoplay and step-by-step mode": "Automatsko puštanje i korak-po-korak mod",
            "You can also apply drawing objects and indicators": "Također možete primijeniti objekte crtanja i indikatore",
            "Synchronized multi-chart replay": "Sinhronizirano ponavljanje više grafika",
            "Trading on historical data": "Trgovanje na povijesnim podacima",
            "In-depth historical data by the minute and by the second": "Duboki povijesni podaci po minutama i sekundama"
        },
        bg: {
            chartsPerTab: "Технически Анализ, Направен Правилно",
            barReplay: "Повторно Възпроизвеждане на Лентата",
            "Our platform comes with hundreds of built-in indicators and strategies, the most popular drawing tools and concepts for in-depth market analysis covering": "Нашата платформа идва с стотици вградени индикатори и стратегии, най-популярните инструменти за рисуване и концепции за задълбочен пазарен анализ",
            "400+ built-in indicators and strategies": "400+ вградени индикатори и стратегии",
            "100,000+ public indicators": "100,000+ публични индикатори",
            "110+ smart drawing tools": "110+ интелигентни инструменти за рисуване",
            "Volume Profile indicators": "Индикатори за профил на обема",
            "Candlestick patterns recognition": "Разпознаване на модели на свещи",
            "Multi-timeframe analysis": "Анализ на множество времеви рамки",
            "Auto Chart Patterns": "Автоматични модели на графики",
            "Watch how pricing data unfolded historically. Rewind markets and review at a speed and resolution you desire.": "Наблюдавайте как ценовите данни се развиха исторически. Превъртете пазарите назад и прегледайте със скорост и резолюция, които желаете.",
            "Simulated trading on historical data": "Симулирана търговия с исторически данни",
            "4 replay speeds": "4 скорости на повторно възпроизвеждане",
            "Autoplay and step-by-step mode": "Автоматично възпроизвеждане и стъпка по стъпка режим",
            "You can also apply drawing objects and indicators": "Можете също да приложите обекти за рисуване и индикатори",
            "Synchronized multi-chart replay": "Синхронизирано повторно възпроизвеждане на множество графики",
            "Trading on historical data": "Търговия с исторически данни",
            "In-depth historical data by the minute and by the second": "Задълбочени исторически данни по минути и секунди"
        },
        hr: {
            chartsPerTab: "Tehnička Analiza, Napravljena Kako Treba",
            barReplay: "Ponavljanje Traka",
            "Our platform comes with hundreds of built-in indicators and strategies, the most popular drawing tools and concepts for in-depth market analysis covering": "Naša platforma dolazi sa stotinama ugrađenih indikatora i strategija, najpopularnijim alatima za crtanje i konceptima za duboku analizu tržišta",
            "400+ built-in indicators and strategies": "400+ ugrađenih indikatora i strategija",
            "100,000+ public indicators": "100,000+ javnih indikatora",
            "110+ smart drawing tools": "110+ pametnih alata za crtanje",
            "Volume Profile indicators": "Indikatori profila volumena",
            "Candlestick patterns recognition": "Prepoznavanje uzoraka svijeća",
            "Multi-timeframe analysis": "Analiza više vremenskih okvira",
            "Auto Chart Patterns": "Automatski uzorci grafikona",
            "Watch how pricing data unfolded historically. Rewind markets and review at a speed and resolution you desire.": "Pogledajte kako su se podaci o cijenama povijesno razvijali. Premotajte tržišta i pregledajte brzinom i rezolucijom koju želite.",
            "Simulated trading on historical data": "Simulirano trgovanje na povijesnim podacima",
            "4 replay speeds": "4 brzine ponavljanja",
            "Autoplay and step-by-step mode": "Automatsko reprodukcija i korak-po-korak način",
            "You can also apply drawing objects and indicators": "Također možete primijeniti objekte crtanja i indikatore",
            "Synchronized multi-chart replay": "Sinhronizirano ponavljanje više grafikona",
            "Trading on historical data": "Trgovanje na povijesnim podacima",
            "In-depth historical data by the minute and by the second": "Duboki povijesni podaci po minutama i sekundama"
        },
        xk: {
            chartsPerTab: "Analizë Teknike, e Bërë Drejt / Tehnička Analiza, Urađena Kako Treba",
            barReplay: "Përsëritja e Brezit / Ponavljanje Traka",
            "Our platform comes with hundreds of built-in indicators and strategies, the most popular drawing tools and concepts for in-depth market analysis covering": "Platforma jonë vjen me qindra indikatorë dhe strategji të integruar, mjetet e vizatimit më të popullarizuara për analizë të thellë të tregut / Naša platforma dolazi sa stotinama ugrađenih indikatora i strategija za duboku analizu tržišta",
            "400+ built-in indicators and strategies": "400+ indikatorë dhe strategji të integruar / 400+ ugrađenih indikatora i strategija",
            "100,000+ public indicators": "100,000+ indikatorë publikë / 100,000+ javnih indikatora",
            "110+ smart drawing tools": "110+ mjete të zgjuara vizatimi / 110+ pametnih alata za crtanje",
            "Volume Profile indicators": "Indikatorët e Profilit të Vëllimit / Indikatori profila volumena",
            "Candlestick patterns recognition": "Njohja e modeleve të qirive / Prepoznavanje uzoraka svijeća",
            "Multi-timeframe analysis": "Analizë shumë-kornizë kohore / Analiza više vremenskih okvira",
            "Auto Chart Patterns": "Modelet Automatike të Grafikut / Automatski uzorci grafika",
            "Watch how pricing data unfolded historically. Rewind markets and review at a speed and resolution you desire.": "Shikoni se si të dhënat e çmimeve u zhvilluan historikisht. Ktheni tregun prapa dhe rishikoni me shpejtësinë që dëshironi. / Pogledajte kako su se podaci o cijenama povijesno razvijali. Premotajte tržišta brzinom koju želite.",
            "Simulated trading on historical data": "Tregtim i simuluar në të dhëna historike / Simulirano trgovanje na povijesnim podacima",
            "4 replay speeds": "4 shpejtësi përsëritje / 4 brzine ponavljanja",
            "Autoplay and step-by-step mode": "Modaliteti automatik dhe hap pas hapi / Automatsko puštanje i korak-po-korak",
            "You can also apply drawing objects and indicators": "Mund të aplikoni objekte vizatimi dhe indikatorë / Možete primijeniti objekte crtanja i indikatore",
            "Synchronized multi-chart replay": "Përsëritje shumë-grafik e sinkronizuar / Sinhronizirano ponavljanje više grafika",
            "Trading on historical data": "Tregtim në të dhëna historike / Trgovanje na povijesnim podacima",
            "In-depth historical data by the minute and by the second": "Të dhëna historike të thella sipas minutave dhe sekondave / Duboki povijesni podaci po minutama i sekundama"
        },
        me: {
            chartsPerTab: "Техничка Анализа, Урађена Како Треба",
            barReplay: "Понављање Траке",
            "Our platform comes with hundreds of built-in indicators and strategies, the most popular drawing tools and concepts for in-depth market analysis covering": "Наша платформа долази са стотинама уграђених индикатора и стратегија, најпопуларнијим алатима за цртање и концептима за дубоку анализу тржишта",
            "400+ built-in indicators and strategies": "400+ уграђених индикатора и стратегија",
            "100,000+ public indicators": "100,000+ јавних индикатора",
            "110+ smart drawing tools": "110+ паметних алата за цртање",
            "Volume Profile indicators": "Индикатори профила волумена",
            "Candlestick patterns recognition": "Препознавање узорака свијећа",
            "Multi-timeframe analysis": "Анализа више временских оквира",
            "Auto Chart Patterns": "Аутоматски узорци графика",
            "Watch how pricing data unfolded historically. Rewind markets and review at a speed and resolution you desire.": "Погледајте како су се подаци о цијенама историјски развијали. Премотајте тржишта и прегледајте брзином и резолуцијом коју желите.",
            "Simulated trading on historical data": "Симулирано трговање на историјским подацима",
            "4 replay speeds": "4 брзине понављања",
            "Autoplay and step-by-step mode": "Аутоматско пуштање и корак-по-корак мод",
            "You can also apply drawing objects and indicators": "Такође можете примијенити објекте цртања и индикаторе",
            "Synchronized multi-chart replay": "Синхронизовано понављање више графика",
            "Trading on historical data": "Трговање на историјским подацима",
            "In-depth historical data by the minute and by the second": "Дубоки историјски подаци по минутама и секундама"
        },
        mk: {
            chartsPerTab: "Техничка Анализа, Направена Како Треба",
            barReplay: "Повторно Репродуцирање на Лентата",
            "Our platform comes with hundreds of built-in indicators and strategies, the most popular drawing tools and concepts for in-depth market analysis covering": "Нашата платформа доаѓа со стотици вградени индикатори и стратегии, најпопуларните алатки за цртање и концепти за длабока анализа на пазарот",
            "400+ built-in indicators and strategies": "400+ вградени индикатори и стратегии",
            "100,000+ public indicators": "100,000+ јавни индикатори",
            "110+ smart drawing tools": "110+ паметни алатки за цртање",
            "Volume Profile indicators": "Индикатори за профил на волумен",
            "Candlestick patterns recognition": "Препознавање на шеми на свеќи",
            "Multi-timeframe analysis": "Анализа на повеќе временски рамки",
            "Auto Chart Patterns": "Автоматски шеми на графикони",
            "Watch how pricing data unfolded historically. Rewind markets and review at a speed and resolution you desire.": "Гледајте како се развивале податоците за цените историски. Вратете ги пазарите назад и прегледајте со брзина и резолуција што ја сакате.",
            "Simulated trading on historical data": "Симулирано тргување со историски податоци",
            "4 replay speeds": "4 брзини на повторно репродуцирање",
            "Autoplay and step-by-step mode": "Автоматско репродуцирање и чекор-по-чекор режим",
            "You can also apply drawing objects and indicators": "Исто така можете да примените објекти за цртање и индикатори",
            "Synchronized multi-chart replay": "Синхронизирано повторно репродуцирање на повеќе графикони",
            "Trading on historical data": "Тргување со историски податоци",
            "In-depth historical data by the minute and by the second": "Длабоки историски податоци по минути и секунди"
        },
        ro: {
            chartsPerTab: "Analiză Tehnică, Făcută Corect",
            barReplay: "Reluarea Barelor",
            "Our platform comes with hundreds of built-in indicators and strategies, the most popular drawing tools and concepts for in-depth market analysis covering": "Platforma noastră vine cu sute de indicatori și strategii integrate, cele mai populare instrumente de desenare și concepte pentru analiza aprofundată a pieței",
            "400+ built-in indicators and strategies": "400+ indicatori și strategii integrate",
            "100,000+ public indicators": "100,000+ indicatori publici",
            "110+ smart drawing tools": "110+ instrumente inteligente de desenare",
            "Volume Profile indicators": "Indicatori de profil volum",
            "Candlestick patterns recognition": "Recunoașterea modelelor de lumânări",
            "Multi-timeframe analysis": "Analiza pe multiple intervale de timp",
            "Auto Chart Patterns": "Modele automate de grafice",
            "Watch how pricing data unfolded historically. Rewind markets and review at a speed and resolution you desire.": "Urmăriți cum s-au desfășurat datele de preț în mod istoric. Derulați piețele înapoi și revizuiți cu viteza și rezoluția dorite.",
            "Simulated trading on historical data": "Tranzacționare simulată pe date istorice",
            "4 replay speeds": "4 viteze de reluare",
            "Autoplay and step-by-step mode": "Mod autoplay și pas cu pas",
            "You can also apply drawing objects and indicators": "Puteți aplica și obiecte de desenare și indicatori",
            "Synchronized multi-chart replay": "Reluare sincronizată pe mai multe grafice",
            "Trading on historical data": "Tranzacționare pe date istorice",
            "In-depth historical data by the minute and by the second": "Date istorice detaliate pe minute și secunde"
        },
        sr: {
            chartsPerTab: "Техничка Анализа, Урађена Како Треба",
            barReplay: "Понављање Траке",
            "Our platform comes with hundreds of built-in indicators and strategies, the most popular drawing tools and concepts for in-depth market analysis covering": "Наша платформа долази са стотинама уграђених индикатора и стратегија, најпопуларнијим алатима за цртање и концептима за дубоку анализу тржишта",
            "400+ built-in indicators and strategies": "400+ уграђених индикатора и стратегија",
            "100,000+ public indicators": "100,000+ јавних индикатора",
            "110+ smart drawing tools": "110+ паметних алата за цртање",
            "Volume Profile indicators": "Индикатори профила волумена",
            "Candlestick patterns recognition": "Препознавање узорака свећа",
            "Multi-timeframe analysis": "Анализа више временских оквира",
            "Auto Chart Patterns": "Аутоматски узорци графикона",
            "Watch how pricing data unfolded historically. Rewind markets and review at a speed and resolution you desire.": "Погледајте како су се подаци о ценама историјски развијали. Премотајте тржишта и прегледајте брзином и резолуцијом коју желите.",
            "Simulated trading on historical data": "Симулирано трговање на историјским подацима",
            "4 replay speeds": "4 брзине понављања",
            "Autoplay and step-by-step mode": "Аутоматско пуштање и корак-по-корак режим",
            "You can also apply drawing objects and indicators": "Такође можете применити објекте цртања и индикаторе",
            "Synchronized multi-chart replay": "Синхронизовано понављање више графикона",
            "Trading on historical data": "Трговање на историјским подацима",
            "In-depth historical data by the minute and by the second": "Дубоки историјски подаци по минутима и секундама"
        },
        sl: {
            chartsPerTab: "Tehnična Analiza, Pravilno Narejena",
            barReplay: "Ponavljanje Palice",
            "Our platform comes with hundreds of built-in indicators and strategies, the most popular drawing tools and concepts for in-depth market analysis covering": "Naša platforma prihaja s stotinami vgrajenih kazalnikov in strategij, najpriljubljenejšimi orodji za risanje in koncepti za poglobljeno analizo trga",
            "400+ built-in indicators and strategies": "400+ vgrajenih kazalnikov in strategij",
            "100,000+ public indicators": "100,000+ javnih kazalnikov",
            "110+ smart drawing tools": "110+ pametnih orodij za risanje",
            "Volume Profile indicators": "Kazalniki profila volumna",
            "Candlestick patterns recognition": "Prepoznavanje vzorcev sveč",
            "Multi-timeframe analysis": "Analiza več časovnih okvirjev",
            "Auto Chart Patterns": "Avtomatski vzorci grafov",
            "Watch how pricing data unfolded historically. Rewind markets and review at a speed and resolution you desire.": "Poglejte, kako so se cenovni podatki zgodovinsko razvijali. Previjte trge nazaj in preglejte s hitrostjo in ločljivostjo, ki jo želite.",
            "Simulated trading on historical data": "Simulirano trgovanje z zgodovinskimi podatki",
            "4 replay speeds": "4 hitrosti ponavljanja",
            "Autoplay and step-by-step mode": "Samodejno predvajanje in korak za korakom način",
            "You can also apply drawing objects and indicators": "Uporabite lahko tudi predmete za risanje in kazalnike",
            "Synchronized multi-chart replay": "Sinhronizirano ponavljanje več grafov",
            "Trading on historical data": "Trgovanje z zgodovinskimi podatki",
            "In-depth historical data by the minute and by the second": "Poglobljeni zgodovinski podatki po minutah in sekundah"
        },
        sk: {
            chartsPerTab: "Technická Analýza, Správne Urobená",
            barReplay: "Prehrávanie Stĺpcov",
            "Our platform comes with hundreds of built-in indicators and strategies, the most popular drawing tools and concepts for in-depth market analysis covering": "Naša platforma prichádza so stovkami vstavaných indikátorov a stratégií, najobľúbenejšími nástrojmi na kreslenie a konceptmi pre hĺbkovú analýzu trhu",
            "400+ built-in indicators and strategies": "400+ vstavaných indikátorov a stratégií",
            "100,000+ public indicators": "100,000+ verejných indikátorov",
            "110+ smart drawing tools": "110+ inteligentných nástrojov na kreslenie",
            "Volume Profile indicators": "Indikátory profilu objemu",
            "Candlestick patterns recognition": "Rozpoznávanie vzorcov sviečok",
            "Multi-timeframe analysis": "Analýza viacerých časových rámcov",
            "Auto Chart Patterns": "Automatické vzorce grafov",
            "Watch how pricing data unfolded historically. Rewind markets and review at a speed and resolution you desire.": "Sledujte, ako sa cenové údaje historicky vyvíjali. Pretoč trhy dozadu a skontroluj rýchlosťou a rozlíšením, ktoré si želáš.",
            "Simulated trading on historical data": "Simulované obchodovanie s historickými údajmi",
            "4 replay speeds": "4 rýchlosti prehrávania",
            "Autoplay and step-by-step mode": "Automatické prehrávanie a krok za krokom režim",
            "You can also apply drawing objects and indicators": "Môžete tiež aplikovať objekty na kreslenie a indikátory",
            "Synchronized multi-chart replay": "Synchronizované prehrávanie viacerých grafov",
            "Trading on historical data": "Obchodovanie s historickými údajmi",
            "In-depth historical data by the minute and by the second": "Hĺbkové historické údaje po minútach a sekundách"
        },
        md: {
            chartsPerTab: "Analiză Tehnică, Făcută Corect",
            barReplay: "Reluarea Barelor",
            "Our platform comes with hundreds of built-in indicators and strategies, the most popular drawing tools and concepts for in-depth market analysis covering": "Platforma noastră vine cu sute de indicatori și strategii integrate, cele mai populare instrumente de desenare și concepte pentru analiza aprofundată a pieței",
            "400+ built-in indicators and strategies": "400+ indicatori și strategii integrate",
            "100,000+ public indicators": "100,000+ indicatori publici",
            "110+ smart drawing tools": "110+ instrumente inteligente de desenare",
            "Volume Profile indicators": "Indicatori de profil volum",
            "Candlestick patterns recognition": "Recunoașterea modelelor de lumânări",
            "Multi-timeframe analysis": "Analiza pe multiple intervale de timp",
            "Auto Chart Patterns": "Modele automate de grafice",
            "Watch how pricing data unfolded historically. Rewind markets and review at a speed and resolution you desire.": "Urmăriți cum s-au desfășurat datele de preț în mod istoric. Derulați piețele înapoi și revizuiți cu viteza și rezoluția dorite.",
            "Simulated trading on historical data": "Tranzacționare simulată pe date istorice",
            "4 replay speeds": "4 viteze de reluare",
            "Autoplay and step-by-step mode": "Mod autoplay și pas cu pas",
            "You can also apply drawing objects and indicators": "Puteți aplica și obiecte de desenare și indicatori",
            "Synchronized multi-chart replay": "Reluare sincronizată pe mai multe grafice",
            "Trading on historical data": "Tranzacționare pe date istorice",
            "In-depth historical data by the minute and by the second": "Date istorice detaliate pe minute și secunde"
        },
        ge: {
            chartsPerTab: "ტექნიკური ანალიზი, სწორად შესრულებული",
            barReplay: "ზოლების განმეორება",
            "Our platform comes with hundreds of built-in indicators and strategies, the most popular drawing tools and concepts for in-depth market analysis covering": "ჩვენი პლატფორმა მოიცავს ასობით ჩაშენებულ ინდიკატორსა და სტრატეგიას, ყველაზე პოპულარულ ხატვის ინსტრუმენტებსა და კონცეფციებს ღრმა ბაზრის ანალიზისთვის",
            "400+ built-in indicators and strategies": "400+-ზე მეტი ჩაშენებული ინდიკატორი და სტრატეგია",
            "100,000+ public indicators": "100,000+-ზე მეტი საჯარო ინდიკატორი",
            "110+ smart drawing tools": "110+-ზე მეტი ჭკვიანი ხატვის ინსტრუმენტი",
            "Volume Profile indicators": "მოცულობის პროფილის ინდიკატორები",
            "Candlestick patterns recognition": "სანთლის ფიგურების ამოცნობა",
            "Multi-timeframe analysis": "მრავალფრეიმული ანალიზი",
            "Auto Chart Patterns": "ავტომატური ჩარტის ფიგურები",
            "Watch how pricing data unfolded historically. Rewind markets and review at a speed and resolution you desire.": "იხილეთ, თუ როგორ განვითარდა ფასის მონაცემები ისტორიულად. გაანულეთ ბაზრები და განხილეთ სასურველ სიჩქარესა და გარჩევადობას.",
            "Simulated trading on historical data": "ისტორიული მონაცემების სიმულაციური ვაჭრობა",
            "4 replay speeds": "4 განმეორების სიჩქარე",
            "Autoplay and step-by-step mode": "ავტომატური დაკვრა და ნაბიჯ-ნაბიჯ რეჟიმი",
            "You can also apply drawing objects and indicators": "ასევე შეგიძლიათ გამოიყენოთ ხატვის ობიექტები და ინდიკატორები",
            "Synchronized multi-chart replay": "სინქრონიზებული მრავალჩარტის განმეორება",
            "Trading on historical data": "ვაჭრობა ისტორიულ მონაცემებზე",
            "In-depth historical data by the minute and by the second": "ღრმა ისტორიული მონაცემები წუთებისა და წამების მიხედვით"
        },
        by: {
            chartsPerTab: "Тэхнічны Аналіз, Зроблены Правільна",
            barReplay: "Паўтор Палоскі",
            "Our platform comes with hundreds of built-in indicators and strategies, the most popular drawing tools and concepts for in-depth market analysis covering": "Наша платформа паставляецца з сотнямі ўбудаваных індыкатараў і стратэгій, самымі папулярнымі інструментамі малявання і канцэпцыямі для глыбокага аналізу рынку",
            "400+ built-in indicators and strategies": "400+ убудаваных індыкатараў і стратэгій",
            "100,000+ public indicators": "100,000+ публічных індыкатараў",
            "110+ smart drawing tools": "110+ разумных інструментаў малявання",
            "Volume Profile indicators": "Індыкатары профілю аб'ёму",
            "Candlestick patterns recognition": "Распазнаванне шаблонаў свечак",
            "Multi-timeframe analysis": "Аналіз некалькіх часавых рамак",
            "Auto Chart Patterns": "Аўтаматычныя шаблоны дыяграм",
            "Watch how pricing data unfolded historically. Rewind markets and review at a speed and resolution you desire.": "Паглядзіце, як гістарычна разгортваліся даныя аб цэнах. Перамотайце рынкі і агледзьце з хуткасцю і дазволам, якія вы жадаеце.",
            "Simulated trading on historical data": "Сімуляваная гандаль на гістарычных данных",
            "4 replay speeds": "4 хуткасці паўтору",
            "Autoplay and step-by-step mode": "Аўтаматычнае прайграванне і пакрокавы рэжым",
            "You can also apply drawing objects and indicators": "Вы таксама можаце прымяніць аб'екты малявання і індыкатары",
            "Synchronized multi-chart replay": "Сінхранізаваны паўтор некалькіх дыяграм",
            "Trading on historical data": "Гандаль на гістарычных данных",
            "In-depth historical data by the minute and by the second": "Глыбокія гістарычныя даныя па хвілінах і секундах"
        }
    };
    return e[i] || e.en
}
  , kP = () => {
    const {i18n: i} = We()
      , e = i.language
      , r = yP(e)
      , a = N.useRef(null);
    Ht(a, {
        once: !0,
        margin: "-100px"
    });
    const o = {
        title: r.chartsPerTab,
        description: r["Our platform comes with hundreds of built-in indicators and strategies, the most popular drawing tools and concepts for in-depth market analysis covering"],
        features: [r["400+ built-in indicators and strategies"], r["100,000+ public indicators"], r["110+ smart drawing tools"], r["Volume Profile indicators"], r["Candlestick patterns recognition"], r["Multi-timeframe analysis"], r["Auto Chart Patterns"]]
    }
      , l = {
        title: r.barReplay,
        description: r["Watch how pricing data unfolded historically. Rewind markets and review at a speed and resolution you desire."],
        features: [r["Simulated trading on historical data"], r["4 replay speeds"], r["Autoplay and step-by-step mode"], r["You can also apply drawing objects and indicators"], r["Synchronized multi-chart replay"], r["Trading on historical data"], r["In-depth historical data by the minute and by the second"]]
    };
    return x.jsxs("section", {
        ref: a,
        id: "offers",
        className: "w-full mx-auto flex flex-col lg:flex-row gap-4 py-8 max-w-[1376px] mt-4 px-4 lg:px-0",
        children: [x.jsx(Xh, {
            title: o.title,
            description: o.description,
            features: o.features,
            image: gP,
            breakLine: !1
        }), x.jsx(Xh, {
            title: l.title,
            description: l.description,
            features: l.features,
            image: vP,
            breakLine: !0
        })]
    })
}
  , xP = () => x.jsx("svg", {
    width: "28",
    height: "28",
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "w-5 h-5 md:w-7 md:h-7",
    children: x.jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M23.707 9.70692C23.8892 9.51832 23.99 9.26571 23.9877 9.00352C23.9854 8.74132 23.8803 8.49051 23.6949 8.3051C23.5095 8.11969 23.2586 8.01452 22.9964 8.01224C22.7342 8.00997 22.4816 8.11076 22.293 8.29292L12 18.5859L7.70704 14.2929C7.51844 14.1108 7.26584 14.01 7.00364 14.0122C6.74144 14.0145 6.49063 14.1197 6.30522 14.3051C6.11981 14.4905 6.01465 14.7413 6.01237 15.0035C6.01009 15.2657 6.11088 15.5183 6.29304 15.7069L11.293 20.7069L12 21.4139L12.707 20.7069L23.707 9.70692Z",
        fill: "#787B86"
    })
})
  , wP = "data:image/webp;base64,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"
  , Zh = {
    en: {
        title1: "JOIN 90 MILLION",
        title2: "TRADERS AND INVESTORS",
        description: "Harness the power of the world's most popular financial analysis platform.",
        installNow: "Install now"
    },
    pt: {
        title1: "JUNTE-SE A 90 MILHÕES",
        title2: "DE TRADERS E INVESTIDORES",
        description: "Aproveite o poder da plataforma de análise financeira mais popular do mundo.",
        installNow: "Instalar agora"
    },
    es: {
        title1: "ÚNETE A 90 MILLONES",
        title2: "DE TRADERS E INVERSORES",
        description: "Aprovecha el poder de la plataforma de análisis financiero más popular del mundo.",
        installNow: "Instalar ahora"
    },
    vi: {
        title1: "THAM GIA CÙNG 90 TRIỆU",
        title2: "NHÀ GIAO DỊCH VÀ NHÀ ĐẦU TƯ",
        description: "Khai thác sức mạnh của nền tảng phân tích tài chính phổ biến nhất thế giới.",
        installNow: "Cài đặt ngay"
    },
    th: {
        title1: "เข้าร่วมกับ 90 ล้าน",
        title2: "เทรดเดอร์และนักลงทุน",
        description: "ใช้ประโยชน์จากพลังของแพลตฟอร์มวิเคราะห์การเงินที่ได้รับความนิยมมากที่สุดในโลก",
        installNow: "ติดตั้งเดี๋ยวนี้"
    },
    ja: {
        title1: "9,000万人の",
        title2: "トレーダーと投資家に参加",
        description: "世界で最も人気のある金融分析プラットフォームのパワーを活用しましょう。",
        installNow: "今すぐインストール"
    },
    ko: {
        title1: "9천만 명의",
        title2: "트레이더와 투자자와 함께하세요",
        description: "세계에서 가장 인기 있는 금융 분석 플랫폼의 힘을 활용하세요.",
        installNow: "지금 설치하기"
    },
    "zh-TW": {
        title1: "加入9000萬",
        title2: "交易者和投資者",
        description: "運用全球最受歡迎的金融分析平台的強大功能。",
        installNow: "立即安裝"
    },
    ar: {
        title1: "انضم إلى 90 مليون",
        title2: "متداول ومستثمر",
        description: "استفد من قوة منصة التحليل المالي الأكثر شعبية في العالم.",
        installNow: "تثبيت الآن"
    },
    bn: {
        title1: "৯০ মিলিয়ন",
        title2: "ট্রেডার এবং বিনিয়োগকারীদের সাথে যোগ দিন",
        description: "বিশ্বের সবচেয়ে জনপ্রিয় আর্থিক বিশ্লেষণ প্ল্যাটফর্মের শক্তি কাজে লাগান।",
        installNow: "এখনই ইনস্টল করুন"
    },
    id: {
        title1: "BERGABUNG DENGAN 90 JUTA",
        title2: "TRADER DAN INVESTOR",
        description: "Manfaatkan kekuatan platform analisis keuangan paling populer di dunia.",
        installNow: "Instal sekarang"
    },
    ka: {
        title1: "შეუერთდით 90 მილიონ",
        title2: "ტრეიდერს და ინვესტორს",
        description: "გამოიყენეთ მსოფლიოს ყველაზე პოპულარული ფინანსური ანალიზის პლატფორმის ძალა.",
        installNow: "დაინსტალირება"
    },
    mn: {
        title1: "90 САЯ",
        title2: "АРИЛЖААЧИД, ХӨРӨНГӨ ОРУУЛАГЧИДТАЙ НЭГДЭЭРЭЙ",
        description: "Дэлхийн хамгийн алдартай санхүүгийн шинжилгээний платформын хүчийг ашиглаарай.",
        installNow: "Одоо суулгах"
    },
    tr: {
        title1: "90 MİLYON",
        title2: "TRADER VE YATIRIMCIYA KATILIN",
        description: "Dünyanın en popüler finansal analiz platformunun gücünden yararlanın.",
        installNow: "Şimdi yükle"
    },
    ru: {
        title1: "ПРИСОЕДИНЯЙТЕСЬ К 90 МИЛЛИОНАМ",
        title2: "ТРЕЙДЕРОВ И ИНВЕСТОРОВ",
        description: "Используйте мощь самой популярной в мире платформы финансового анализа.",
        installNow: "Установить сейчас"
    },
    sq: {
        title1: "BASHKOHU ME 90 MILIONË",
        title2: "TREGTARË DHE INVESTITORË",
        description: "Shfrytëzoni fuqinë e platformës së analizës financiare më të popullarizuar në botë.",
        installNow: "Instalo tani"
    },
    bs: {
        title1: "PRIDRUŽITE SE SA 90 MILIONA",
        title2: "TRGOVACA I INVESTITORA",
        description: "Iskoristite snagu najpopularnije platforme za finansijsku analizu na svijetu.",
        installNow: "Instaliraj sada"
    },
    bg: {
        title1: "ПРИСЪЕДИНЕТЕ СЕ КЪМ 90 МИЛИОНА",
        title2: "ТЪРГОВЦИ И ИНВЕСТИТОРИ",
        description: "Използвайте силата на най-популярната в света платформа за финансов анализ.",
        installNow: "Инсталирай сега"
    },
    hr: {
        title1: "PRIDRUŽITE SE SA 90 MILIJUNA",
        title2: "TRGOVACA I INVESTITORA",
        description: "Iskoristite snagu najpopularnije platforme za financijsku analizu na svijetu.",
        installNow: "Instaliraj sada"
    },
    xk: {
        title1: "BASHKOHU ME 90 MILIONË / PRIDRUŽITE SE SA 90 MILIONA",
        title2: "TREGTARË DHE INVESTITORË / TRGOVACA I INVESTITORA",
        description: "Shfrytëzoni fuqinë e platformës së analizës financiare më të popullarizuar në botë. / Iskoristite snagu najpopularnije platforme za finansijsku analizu na svijetu.",
        installNow: "Instalo tani / Instaliraj sada"
    },
    me: {
        title1: "ПРИДРУЖИТЕ СЕ СА 90 МИЛИОНА",
        title2: "ТРГОВАЦА И ИНВЕСТИТОРА",
        description: "Искористите снагу најпопуларније платформе за финансијску анализу на свијету.",
        installNow: "Инсталирај сада"
    },
    mk: {
        title1: "ПРИКЛУЧЕТЕ СЕ КОН 90 МИЛИОНИ",
        title2: "ТРГОВЦИ И ИНВЕСТИТОРИ",
        description: "Искористете ја силата на најпопуларната платформа за финансиска анализа во светот.",
        installNow: "Инсталирај сега"
    },
    ro: {
        title1: "ALĂTURĂ-TE LA 90 DE MILIOANE",
        title2: "DE TRADERI ȘI INVESTITORI",
        description: "Valorifică puterea celei mai populare platforme de analiză financiară din lume.",
        installNow: "Instalează acum"
    },
    sr: {
        title1: "ПРИДРУЖИТЕ СЕ СА 90 МИЛИОНА",
        title2: "ТРГОВАЦА И ИНВЕСТИТОРА",
        description: "Искористите снагу најпопуларније платформе за финансијску анализу на свету.",
        installNow: "Инсталирај сада"
    },
    sl: {
        title1: "PRIDRUŽITE SE 90 MILIJONOM",
        title2: "TRGOVCEV IN VLAGATELJEV",
        description: "Izkoristite moč najbolj priljubljene platforme za finančno analizo na svetu.",
        installNow: "Namesti zdaj"
    },
    sk: {
        title1: "PRIPOJTE SA K 90 MILIÓNOM",
        title2: "OBCHODNÍKOV A INVESTOROV",
        description: "Využite silu najobľúbenejšej platformy pre finančnú analýzu na svete.",
        installNow: "Nainštalovať teraz"
    },
    md: {
        title1: "ALĂTURĂ-TE LA 90 DE MILIOANE",
        title2: "DE TRADERI ȘI INVESTITORI",
        description: "Valorifică puterea celei mai populare platforme de analiză financiară din lume.",
        installNow: "Instalează acum"
    },
    ge: {
        title1: "შეუერთდით 90 მილიონ",
        title2: "ტრეიდერს და ინვესტორს",
        description: "გამოიყენეთ მსოფლიოს ყველაზე პოპულარული ფინანსური ანალიზის პლატფორმის ძალა.",
        installNow: "დააინსტალირეთ ახლა"
    },
    by: {
        title1: "ДАЛУЧЫЦЕСЯ ДА 90 МІЛЬЁНАЎ",
        title2: "ТРЭЙДЭРАЎ І ІНВЕСТАРАЎ",
        description: "Выкарыстоўвайце сілу самай папулярнай у свеце платформы фінансавага аналізу.",
        installNow: "Усталяваць зараз"
    }
}
  , PP = () => {
    const {i18n: i} = We()
      , e = i.language
      , r = Zh[e] || Zh.en;
    return x.jsxs("section", {
        className: `min-h-[400px] sm:min-h-[480px] md:min-h-[560px] 
                      relative flex flex-col gap-4 sm:gap-6 md:gap-8 
                      items-center justify-center
                      px-4 sm:px-6 md:px-8`,
        children: [x.jsxs(ee.div, {
            className: `p-4 relative z-10 flex flex-col items-center text-center justify-center 
                   gap-3 sm:gap-4 md:gap-6 
                   max-w-[90%] sm:max-w-[80%] md:max-w-[70%]`,
            initial: {
                opacity: 0,
                y: 20
            },
            animate: {
                opacity: 1,
                y: 0
            },
            transition: {
                duration: .6
            },
            children: [x.jsxs(ee.h2, {
                className: `text-[#0D1013] uppercase font-bold 
                     text-[32px] sm:text-[48px] md:text-[64px] 
                     leading-tight sm:leading-tight md:leading-[64px]
                     tracking-tight`,
                initial: {
                    opacity: 0,
                    y: 20
                },
                animate: {
                    opacity: 1,
                    y: 0
                },
                transition: {
                    duration: .6,
                    delay: .2
                },
                children: [x.jsx("span", {
                    className: "block",
                    children: r.title1
                }), x.jsx("span", {
                    className: "block",
                    children: r.title2
                })]
            }), x.jsx(ee.p, {
                className: `text-[#3B4046] font-bold 
                     text-[18px] sm:text-[22px] md:text-[28px] 
                     leading-snug sm:leading-normal md:leading-[40px]`,
                initial: {
                    opacity: 0,
                    y: 20
                },
                animate: {
                    opacity: 1,
                    y: 0
                },
                transition: {
                    duration: .6,
                    delay: .3
                },
                children: r.description
            })]
        }), x.jsx(ee.div, {
            className: "w-full max-w-[280px] sm:max-w-[300px] md:max-w-[320px] relative z-10",
            initial: {
                opacity: 0,
                y: 20
            },
            animate: {
                opacity: 1,
                y: 0
            },
            transition: {
                duration: .6,
                delay: .4
            },
            children: x.jsx(Un, {
                label: r.installNow,
                className: "w-full"
            })
        }), x.jsx("div", {
            className: "absolute inset-0 overflow-hidden",
            children: x.jsx(ee.img, {
                src: wP,
                className: "absolute top-0 left-0 w-full h-full",
                alt: "",
                initial: {
                    opacity: 0,
                    scale: 1.1
                },
                animate: {
                    opacity: 1,
                    scale: 1
                },
                transition: {
                    duration: .8
                }
            })
        })]
    })
}
  , bP = "/cdn/shop/t/1/assets/card1-Dt8SYU-S.png"
  , SP = "/cdn/shop/t/1/assets/card2-ep1hhl__.png"
  , TP = "/cdn/shop/t/1/assets/card3-ByzoqNMa.png"
  , jP = "/cdn/shop/t/1/assets/card4-BNybu67n.png"
  , CP = "/cdn/shop/t/1/assets/card5-CDKoVC78.png"
  , zP = "/cdn/shop/t/1/assets/card6-NCULFrcu.png"
  , AP = "/cdn/shop/t/1/assets/card7-BwsRTy0f.png"
  , EP = "/cdn/shop/t/1/assets/card8-CsE_qImb.png"
  , DP = "/cdn/shop/t/1/assets/card9-DQ1V_ux0.png"
  , IP = "/cdn/shop/t/1/assets/card10-BED51rVw.png"
  , MP = "/cdn/shop/t/1/assets/card11-vIMz393q.png"
  , VP = "/cdn/shop/t/1/assets/card12-H9cfDOMv.png";
function Yh(i) {
    return i !== null && typeof i == "object" && "constructor"in i && i.constructor === Object
}
function ku(i, e) {
    i === void 0 && (i = {}),
    e === void 0 && (e = {});
    const r = ["__proto__", "constructor", "prototype"];
    Object.keys(e).filter(a => r.indexOf(a) < 0).forEach(a => {
        typeof i[a] > "u" ? i[a] = e[a] : Yh(e[a]) && Yh(i[a]) && Object.keys(e[a]).length > 0 && ku(i[a], e[a])
    }
    )
}
const l0 = {
    body: {},
    addEventListener() {},
    removeEventListener() {},
    activeElement: {
        blur() {},
        nodeName: ""
    },
    querySelector() {
        return null
    },
    querySelectorAll() {
        return []
    },
    getElementById() {
        return null
    },
    createEvent() {
        return {
            initEvent() {}
        }
    },
    createElement() {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute() {},
            getElementsByTagName() {
                return []
            }
        }
    },
    createElementNS() {
        return {}
    },
    importNode() {
        return null
    },
    location: {
        hash: "",
        host: "",
        hostname: "",
        href: "",
        origin: "",
        pathname: "",
        protocol: "",
        search: ""
    }
};
function Qi() {
    const i = typeof document < "u" ? document : {};
    return ku(i, l0),
    i
}
const LP = {
    document: l0,
    navigator: {
        userAgent: ""
    },
    location: {
        hash: "",
        host: "",
        hostname: "",
        href: "",
        origin: "",
        pathname: "",
        protocol: "",
        search: ""
    },
    history: {
        replaceState() {},
        pushState() {},
        go() {},
        back() {}
    },
    CustomEvent: function() {
        return this
    },
    addEventListener() {},
    removeEventListener() {},
    getComputedStyle() {
        return {
            getPropertyValue() {
                return ""
            }
        }
    },
    Image() {},
    Date() {},
    screen: {},
    setTimeout() {},
    clearTimeout() {},
    matchMedia() {
        return {}
    },
    requestAnimationFrame(i) {
        return typeof setTimeout > "u" ? (i(),
        null) : setTimeout(i, 0)
    },
    cancelAnimationFrame(i) {
        typeof setTimeout > "u" || clearTimeout(i)
    }
};
function st() {
    const i = typeof window < "u" ? window : {};
    return ku(i, LP),
    i
}
function OP(i) {
    return i === void 0 && (i = ""),
    i.trim().split(" ").filter(e => !!e.trim())
}
function NP(i) {
    const e = i;
    Object.keys(e).forEach(r => {
        try {
            e[r] = null
        } catch {}
        try {
            delete e[r]
        } catch {}
    }
    )
}
function c0(i, e) {
    return e === void 0 && (e = 0),
    setTimeout(i, e)
}
function zs() {
    return Date.now()
}
function FP(i) {
    const e = st();
    let r;
    return e.getComputedStyle && (r = e.getComputedStyle(i, null)),
    !r && i.currentStyle && (r = i.currentStyle),
    r || (r = i.style),
    r
}
function RP(i, e) {
    e === void 0 && (e = "x");
    const r = st();
    let a, o, l;
    const u = FP(i);
    return r.WebKitCSSMatrix ? (o = u.transform || u.webkitTransform,
    o.split(",").length > 6 && (o = o.split(", ").map(d => d.replace(",", ".")).join(", ")),
    l = new r.WebKitCSSMatrix(o === "none" ? "" : o)) : (l = u.MozTransform || u.OTransform || u.MsTransform || u.msTransform || u.transform || u.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,"),
    a = l.toString().split(",")),
    e === "x" && (r.WebKitCSSMatrix ? o = l.m41 : a.length === 16 ? o = parseFloat(a[12]) : o = parseFloat(a[4])),
    e === "y" && (r.WebKitCSSMatrix ? o = l.m42 : a.length === 16 ? o = parseFloat(a[13]) : o = parseFloat(a[5])),
    o || 0
}
function ms(i) {
    return typeof i == "object" && i !== null && i.constructor && Object.prototype.toString.call(i).slice(8, -1) === "Object"
}
function BP(i) {
    return typeof window < "u" && typeof window.HTMLElement < "u" ? i instanceof HTMLElement : i && (i.nodeType === 1 || i.nodeType === 11)
}
function yt() {
    const i = Object(arguments.length <= 0 ? void 0 : arguments[0])
      , e = ["__proto__", "constructor", "prototype"];
    for (let r = 1; r < arguments.length; r += 1) {
        const a = r < 0 || arguments.length <= r ? void 0 : arguments[r];
        if (a != null && !BP(a)) {
            const o = Object.keys(Object(a)).filter(l => e.indexOf(l) < 0);
            for (let l = 0, u = o.length; l < u; l += 1) {
                const d = o[l]
                  , p = Object.getOwnPropertyDescriptor(a, d);
                p !== void 0 && p.enumerable && (ms(i[d]) && ms(a[d]) ? a[d].__swiper__ ? i[d] = a[d] : yt(i[d], a[d]) : !ms(i[d]) && ms(a[d]) ? (i[d] = {},
                a[d].__swiper__ ? i[d] = a[d] : yt(i[d], a[d])) : i[d] = a[d])
            }
        }
    }
    return i
}
function hs(i, e, r) {
    i.style.setProperty(e, r)
}
function u0(i) {
    let {swiper: e, targetPosition: r, side: a} = i;
    const o = st()
      , l = -e.translate;
    let u = null, d;
    const p = e.params.speed;
    e.wrapperEl.style.scrollSnapType = "none",
    o.cancelAnimationFrame(e.cssModeFrameID);
    const h = r > l ? "next" : "prev"
      , g = (y, P) => h === "next" && y >= P || h === "prev" && y <= P
      , v = () => {
        d = new Date().getTime(),
        u === null && (u = d);
        const y = Math.max(Math.min((d - u) / p, 1), 0)
          , P = .5 - Math.cos(y * Math.PI) / 2;
        let w = l + P * (r - l);
        if (g(w, r) && (w = r),
        e.wrapperEl.scrollTo({
            [a]: w
        }),
        g(w, r)) {
            e.wrapperEl.style.overflow = "hidden",
            e.wrapperEl.style.scrollSnapType = "",
            setTimeout( () => {
                e.wrapperEl.style.overflow = "",
                e.wrapperEl.scrollTo({
                    [a]: w
                })
            }
            ),
            o.cancelAnimationFrame(e.cssModeFrameID);
            return
        }
        e.cssModeFrameID = o.requestAnimationFrame(v)
    }
    ;
    v()
}
function _t(i, e) {
    e === void 0 && (e = "");
    const r = st()
      , a = [...i.children];
    return r.HTMLSlotElement && i instanceof HTMLSlotElement && a.push(...i.assignedElements()),
    e ? a.filter(o => o.matches(e)) : a
}
function WP(i, e) {
    const r = [e];
    for (; r.length > 0; ) {
        const a = r.shift();
        if (i === a)
            return !0;
        r.push(...a.children, ...a.shadowRoot ? a.shadowRoot.children : [], ...a.assignedElements ? a.assignedElements() : [])
    }
}
function _P(i, e) {
    const r = st();
    let a = e.contains(i);
    return !a && r.HTMLSlotElement && e instanceof HTMLSlotElement && (a = [...e.assignedElements()].includes(i),
    a || (a = WP(i, e))),
    a
}
function As(i) {
    try {
        console.warn(i);
        return
    } catch {}
}
function Es(i, e) {
    e === void 0 && (e = []);
    const r = document.createElement(i);
    return r.classList.add(...Array.isArray(e) ? e : OP(e)),
    r
}
function UP(i, e) {
    const r = [];
    for (; i.previousElementSibling; ) {
        const a = i.previousElementSibling;
        e ? a.matches(e) && r.push(a) : r.push(a),
        i = a
    }
    return r
}
function KP(i, e) {
    const r = [];
    for (; i.nextElementSibling; ) {
        const a = i.nextElementSibling;
        e ? a.matches(e) && r.push(a) : r.push(a),
        i = a
    }
    return r
}
function Ci(i, e) {
    return st().getComputedStyle(i, null).getPropertyValue(e)
}
function Ds(i) {
    let e = i, r;
    if (e) {
        for (r = 0; (e = e.previousSibling) !== null; )
            e.nodeType === 1 && (r += 1);
        return r
    }
}
function d0(i, e) {
    const r = [];
    let a = i.parentElement;
    for (; a; )
        e ? a.matches(e) && r.push(a) : r.push(a),
        a = a.parentElement;
    return r
}
function Ic(i, e, r) {
    const a = st();
    return i[e === "width" ? "offsetWidth" : "offsetHeight"] + parseFloat(a.getComputedStyle(i, null).getPropertyValue(e === "width" ? "margin-right" : "margin-top")) + parseFloat(a.getComputedStyle(i, null).getPropertyValue(e === "width" ? "margin-left" : "margin-bottom"))
}
function Ge(i) {
    return (Array.isArray(i) ? i : [i]).filter(e => !!e)
}
function Is(i, e) {
    e === void 0 && (e = ""),
    typeof trustedTypes < "u" ? i.innerHTML = trustedTypes.createPolicy("html", {
        createHTML: r => r
    }).createHTML(e) : i.innerHTML = e
}
let nc;
function $P() {
    const i = st()
      , e = Qi();
    return {
        smoothScroll: e.documentElement && e.documentElement.style && "scrollBehavior"in e.documentElement.style,
        touch: !!("ontouchstart"in i || i.DocumentTouch && e instanceof i.DocumentTouch)
    }
}
function p0() {
    return nc || (nc = $P()),
    nc
}
let ac;
function HP(i) {
    let {userAgent: e} = i === void 0 ? {} : i;
    const r = p0()
      , a = st()
      , o = a.navigator.platform
      , l = e || a.navigator.userAgent
      , u = {
        ios: !1,
        android: !1
    }
      , d = a.screen.width
      , p = a.screen.height
      , h = l.match(/(Android);?[\s\/]+([\d.]+)?/);
    let g = l.match(/(iPad).*OS\s([\d_]+)/);
    const v = l.match(/(iPod)(.*OS\s([\d_]+))?/)
      , y = !g && l.match(/(iPhone\sOS|iOS)\s([\d_]+)/)
      , P = o === "Win32";
    let w = o === "MacIntel";
    const S = ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"];
    return !g && w && r.touch && S.indexOf(`${d}x${p}`) >= 0 && (g = l.match(/(Version)\/([\d.]+)/),
    g || (g = [0, 1, "13_0_0"]),
    w = !1),
    h && !P && (u.os = "android",
    u.android = !0),
    (g || y || v) && (u.os = "ios",
    u.ios = !0),
    u
}
function m0(i) {
    return i === void 0 && (i = {}),
    ac || (ac = HP(i)),
    ac
}
let sc;
function GP() {
    const i = st()
      , e = m0();
    let r = !1;
    function a() {
        const d = i.navigator.userAgent.toLowerCase();
        return d.indexOf("safari") >= 0 && d.indexOf("chrome") < 0 && d.indexOf("android") < 0
    }
    if (a()) {
        const d = String(i.navigator.userAgent);
        if (d.includes("Version/")) {
            const [p,h] = d.split("Version/")[1].split(" ")[0].split(".").map(g => Number(g));
            r = p < 16 || p === 16 && h < 2
        }
    }
    const o = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(i.navigator.userAgent)
      , l = a()
      , u = l || o && e.ios;
    return {
        isSafari: r || l,
        needPerspectiveFix: r,
        need3dFix: u,
        isWebView: o
    }
}
function h0() {
    return sc || (sc = GP()),
    sc
}
function qP(i) {
    let {swiper: e, on: r, emit: a} = i;
    const o = st();
    let l = null
      , u = null;
    const d = () => {
        !e || e.destroyed || !e.initialized || (a("beforeResize"),
        a("resize"))
    }
      , p = () => {
        !e || e.destroyed || !e.initialized || (l = new ResizeObserver(v => {
            u = o.requestAnimationFrame( () => {
                const {width: y, height: P} = e;
                let w = y
                  , S = P;
                v.forEach(z => {
                    let {contentBoxSize: C, contentRect: b, target: T} = z;
                    T && T !== e.el || (w = b ? b.width : (C[0] || C).inlineSize,
                    S = b ? b.height : (C[0] || C).blockSize)
                }
                ),
                (w !== y || S !== P) && d()
            }
            )
        }
        ),
        l.observe(e.el))
    }
      , h = () => {
        u && o.cancelAnimationFrame(u),
        l && l.unobserve && e.el && (l.unobserve(e.el),
        l = null)
    }
      , g = () => {
        !e || e.destroyed || !e.initialized || a("orientationchange")
    }
    ;
    r("init", () => {
        if (e.params.resizeObserver && typeof o.ResizeObserver < "u") {
            p();
            return
        }
        o.addEventListener("resize", d),
        o.addEventListener("orientationchange", g)
    }
    ),
    r("destroy", () => {
        h(),
        o.removeEventListener("resize", d),
        o.removeEventListener("orientationchange", g)
    }
    )
}
function XP(i) {
    let {swiper: e, extendParams: r, on: a, emit: o} = i;
    const l = []
      , u = st()
      , d = function(g, v) {
        v === void 0 && (v = {});
        const y = u.MutationObserver || u.WebkitMutationObserver
          , P = new y(w => {
            if (e.__preventObserver__)
                return;
            if (w.length === 1) {
                o("observerUpdate", w[0]);
                return
            }
            const S = function() {
                o("observerUpdate", w[0])
            };
            u.requestAnimationFrame ? u.requestAnimationFrame(S) : u.setTimeout(S, 0)
        }
        );
        P.observe(g, {
            attributes: typeof v.attributes > "u" ? !0 : v.attributes,
            childList: e.isElement || (typeof v.childList > "u" ? !0 : v).childList,
            characterData: typeof v.characterData > "u" ? !0 : v.characterData
        }),
        l.push(P)
    }
      , p = () => {
        if (e.params.observer) {
            if (e.params.observeParents) {
                const g = d0(e.hostEl);
                for (let v = 0; v < g.length; v += 1)
                    d(g[v])
            }
            d(e.hostEl, {
                childList: e.params.observeSlideChildren
            }),
            d(e.wrapperEl, {
                attributes: !1
            })
        }
    }
      , h = () => {
        l.forEach(g => {
            g.disconnect()
        }
        ),
        l.splice(0, l.length)
    }
    ;
    r({
        observer: !1,
        observeParents: !1,
        observeSlideChildren: !1
    }),
    a("init", p),
    a("destroy", h)
}
var ZP = {
    on(i, e, r) {
        const a = this;
        if (!a.eventsListeners || a.destroyed || typeof e != "function")
            return a;
        const o = r ? "unshift" : "push";
        return i.split(" ").forEach(l => {
            a.eventsListeners[l] || (a.eventsListeners[l] = []),
            a.eventsListeners[l][o](e)
        }
        ),
        a
    },
    once(i, e, r) {
        const a = this;
        if (!a.eventsListeners || a.destroyed || typeof e != "function")
            return a;
        function o() {
            a.off(i, o),
            o.__emitterProxy && delete o.__emitterProxy;
            for (var l = arguments.length, u = new Array(l), d = 0; d < l; d++)
                u[d] = arguments[d];
            e.apply(a, u)
        }
        return o.__emitterProxy = e,
        a.on(i, o, r)
    },
    onAny(i, e) {
        const r = this;
        if (!r.eventsListeners || r.destroyed || typeof i != "function")
            return r;
        const a = e ? "unshift" : "push";
        return r.eventsAnyListeners.indexOf(i) < 0 && r.eventsAnyListeners[a](i),
        r
    },
    offAny(i) {
        const e = this;
        if (!e.eventsListeners || e.destroyed || !e.eventsAnyListeners)
            return e;
        const r = e.eventsAnyListeners.indexOf(i);
        return r >= 0 && e.eventsAnyListeners.splice(r, 1),
        e
    },
    off(i, e) {
        const r = this;
        return !r.eventsListeners || r.destroyed || !r.eventsListeners || i.split(" ").forEach(a => {
            typeof e > "u" ? r.eventsListeners[a] = [] : r.eventsListeners[a] && r.eventsListeners[a].forEach( (o, l) => {
                (o === e || o.__emitterProxy && o.__emitterProxy === e) && r.eventsListeners[a].splice(l, 1)
            }
            )
        }
        ),
        r
    },
    emit() {
        const i = this;
        if (!i.eventsListeners || i.destroyed || !i.eventsListeners)
            return i;
        let e, r, a;
        for (var o = arguments.length, l = new Array(o), u = 0; u < o; u++)
            l[u] = arguments[u];
        return typeof l[0] == "string" || Array.isArray(l[0]) ? (e = l[0],
        r = l.slice(1, l.length),
        a = i) : (e = l[0].events,
        r = l[0].data,
        a = l[0].context || i),
        r.unshift(a),
        (Array.isArray(e) ? e : e.split(" ")).forEach(p => {
            i.eventsAnyListeners && i.eventsAnyListeners.length && i.eventsAnyListeners.forEach(h => {
                h.apply(a, [p, ...r])
            }
            ),
            i.eventsListeners && i.eventsListeners[p] && i.eventsListeners[p].forEach(h => {
                h.apply(a, r)
            }
            )
        }
        ),
        i
    }
};
function YP() {
    const i = this;
    let e, r;
    const a = i.el;
    typeof i.params.width < "u" && i.params.width !== null ? e = i.params.width : e = a.clientWidth,
    typeof i.params.height < "u" && i.params.height !== null ? r = i.params.height : r = a.clientHeight,
    !(e === 0 && i.isHorizontal() || r === 0 && i.isVertical()) && (e = e - parseInt(Ci(a, "padding-left") || 0, 10) - parseInt(Ci(a, "padding-right") || 0, 10),
    r = r - parseInt(Ci(a, "padding-top") || 0, 10) - parseInt(Ci(a, "padding-bottom") || 0, 10),
    Number.isNaN(e) && (e = 0),
    Number.isNaN(r) && (r = 0),
    Object.assign(i, {
        width: e,
        height: r,
        size: i.isHorizontal() ? e : r
    }))
}
function QP() {
    const i = this;
    function e(W, K) {
        return parseFloat(W.getPropertyValue(i.getDirectionLabel(K)) || 0)
    }
    const r = i.params
      , {wrapperEl: a, slidesEl: o, size: l, rtlTranslate: u, wrongRTL: d} = i
      , p = i.virtual && r.virtual.enabled
      , h = p ? i.virtual.slides.length : i.slides.length
      , g = _t(o, `.${i.params.slideClass}, swiper-slide`)
      , v = p ? i.virtual.slides.length : g.length;
    let y = [];
    const P = []
      , w = [];
    let S = r.slidesOffsetBefore;
    typeof S == "function" && (S = r.slidesOffsetBefore.call(i));
    let z = r.slidesOffsetAfter;
    typeof z == "function" && (z = r.slidesOffsetAfter.call(i));
    const C = i.snapGrid.length
      , b = i.slidesGrid.length;
    let T = r.spaceBetween
      , D = -S
      , M = 0
      , B = 0;
    if (typeof l > "u")
        return;
    typeof T == "string" && T.indexOf("%") >= 0 ? T = parseFloat(T.replace("%", "")) / 100 * l : typeof T == "string" && (T = parseFloat(T)),
    i.virtualSize = -T,
    g.forEach(W => {
        u ? W.style.marginLeft = "" : W.style.marginRight = "",
        W.style.marginBottom = "",
        W.style.marginTop = ""
    }
    ),
    r.centeredSlides && r.cssMode && (hs(a, "--swiper-centered-offset-before", ""),
    hs(a, "--swiper-centered-offset-after", ""));
    const _ = r.grid && r.grid.rows > 1 && i.grid;
    _ ? i.grid.initSlides(g) : i.grid && i.grid.unsetSlides();
    let F;
    const R = r.slidesPerView === "auto" && r.breakpoints && Object.keys(r.breakpoints).filter(W => typeof r.breakpoints[W].slidesPerView < "u").length > 0;
    for (let W = 0; W < v; W += 1) {
        F = 0;
        let K;
        if (g[W] && (K = g[W]),
        _ && i.grid.updateSlide(W, K, g),
        !(g[W] && Ci(K, "display") === "none")) {
            if (r.slidesPerView === "auto") {
                R && (g[W].style[i.getDirectionLabel("width")] = "");
                const Q = getComputedStyle(K)
                  , se = K.style.transform
                  , le = K.style.webkitTransform;
                if (se && (K.style.transform = "none"),
                le && (K.style.webkitTransform = "none"),
                r.roundLengths)
                    F = i.isHorizontal() ? Ic(K, "width") : Ic(K, "height");
                else {
                    const pe = e(Q, "width")
                      , ie = e(Q, "padding-left")
                      , ne = e(Q, "padding-right")
                      , H = e(Q, "margin-left")
                      , X = e(Q, "margin-right")
                      , Z = Q.getPropertyValue("box-sizing");
                    if (Z && Z === "border-box")
                        F = pe + H + X;
                    else {
                        const {clientWidth: I, offsetWidth: U} = K;
                        F = pe + ie + ne + H + X + (U - I)
                    }
                }
                se && (K.style.transform = se),
                le && (K.style.webkitTransform = le),
                r.roundLengths && (F = Math.floor(F))
            } else
                F = (l - (r.slidesPerView - 1) * T) / r.slidesPerView,
                r.roundLengths && (F = Math.floor(F)),
                g[W] && (g[W].style[i.getDirectionLabel("width")] = `${F}px`);
            g[W] && (g[W].swiperSlideSize = F),
            w.push(F),
            r.centeredSlides ? (D = D + F / 2 + M / 2 + T,
            M === 0 && W !== 0 && (D = D - l / 2 - T),
            W === 0 && (D = D - l / 2 - T),
            Math.abs(D) < 1 / 1e3 && (D = 0),
            r.roundLengths && (D = Math.floor(D)),
            B % r.slidesPerGroup === 0 && y.push(D),
            P.push(D)) : (r.roundLengths && (D = Math.floor(D)),
            (B - Math.min(i.params.slidesPerGroupSkip, B)) % i.params.slidesPerGroup === 0 && y.push(D),
            P.push(D),
            D = D + F + T),
            i.virtualSize += F + T,
            M = F,
            B += 1
        }
    }
    if (i.virtualSize = Math.max(i.virtualSize, l) + z,
    u && d && (r.effect === "slide" || r.effect === "coverflow") && (a.style.width = `${i.virtualSize + T}px`),
    r.setWrapperSize && (a.style[i.getDirectionLabel("width")] = `${i.virtualSize + T}px`),
    _ && i.grid.updateWrapperSize(F, y),
    !r.centeredSlides) {
        const W = [];
        for (let K = 0; K < y.length; K += 1) {
            let Q = y[K];
            r.roundLengths && (Q = Math.floor(Q)),
            y[K] <= i.virtualSize - l && W.push(Q)
        }
        y = W,
        Math.floor(i.virtualSize - l) - Math.floor(y[y.length - 1]) > 1 && y.push(i.virtualSize - l)
    }
    if (p && r.loop) {
        const W = w[0] + T;
        if (r.slidesPerGroup > 1) {
            const K = Math.ceil((i.virtual.slidesBefore + i.virtual.slidesAfter) / r.slidesPerGroup)
              , Q = W * r.slidesPerGroup;
            for (let se = 0; se < K; se += 1)
                y.push(y[y.length - 1] + Q)
        }
        for (let K = 0; K < i.virtual.slidesBefore + i.virtual.slidesAfter; K += 1)
            r.slidesPerGroup === 1 && y.push(y[y.length - 1] + W),
            P.push(P[P.length - 1] + W),
            i.virtualSize += W
    }
    if (y.length === 0 && (y = [0]),
    T !== 0) {
        const W = i.isHorizontal() && u ? "marginLeft" : i.getDirectionLabel("marginRight");
        g.filter( (K, Q) => !r.cssMode || r.loop ? !0 : Q !== g.length - 1).forEach(K => {
            K.style[W] = `${T}px`
        }
        )
    }
    if (r.centeredSlides && r.centeredSlidesBounds) {
        let W = 0;
        w.forEach(Q => {
            W += Q + (T || 0)
        }
        ),
        W -= T;
        const K = W > l ? W - l : 0;
        y = y.map(Q => Q <= 0 ? -S : Q > K ? K + z : Q)
    }
    if (r.centerInsufficientSlides) {
        let W = 0;
        w.forEach(Q => {
            W += Q + (T || 0)
        }
        ),
        W -= T;
        const K = (r.slidesOffsetBefore || 0) + (r.slidesOffsetAfter || 0);
        if (W + K < l) {
            const Q = (l - W - K) / 2;
            y.forEach( (se, le) => {
                y[le] = se - Q
            }
            ),
            P.forEach( (se, le) => {
                P[le] = se + Q
            }
            )
        }
    }
    if (Object.assign(i, {
        slides: g,
        snapGrid: y,
        slidesGrid: P,
        slidesSizesGrid: w
    }),
    r.centeredSlides && r.cssMode && !r.centeredSlidesBounds) {
        hs(a, "--swiper-centered-offset-before", `${-y[0]}px`),
        hs(a, "--swiper-centered-offset-after", `${i.size / 2 - w[w.length - 1] / 2}px`);
        const W = -i.snapGrid[0]
          , K = -i.slidesGrid[0];
        i.snapGrid = i.snapGrid.map(Q => Q + W),
        i.slidesGrid = i.slidesGrid.map(Q => Q + K)
    }
    if (v !== h && i.emit("slidesLengthChange"),
    y.length !== C && (i.params.watchOverflow && i.checkOverflow(),
    i.emit("snapGridLengthChange")),
    P.length !== b && i.emit("slidesGridLengthChange"),
    r.watchSlidesProgress && i.updateSlidesOffset(),
    i.emit("slidesUpdated"),
    !p && !r.cssMode && (r.effect === "slide" || r.effect === "fade")) {
        const W = `${r.containerModifierClass}backface-hidden`
          , K = i.el.classList.contains(W);
        v <= r.maxBackfaceHiddenSlides ? K || i.el.classList.add(W) : K && i.el.classList.remove(W)
    }
}
function JP(i) {
    const e = this
      , r = []
      , a = e.virtual && e.params.virtual.enabled;
    let o = 0, l;
    typeof i == "number" ? e.setTransition(i) : i === !0 && e.setTransition(e.params.speed);
    const u = d => a ? e.slides[e.getSlideIndexByData(d)] : e.slides[d];
    if (e.params.slidesPerView !== "auto" && e.params.slidesPerView > 1)
        if (e.params.centeredSlides)
            (e.visibleSlides || []).forEach(d => {
                r.push(d)
            }
            );
        else
            for (l = 0; l < Math.ceil(e.params.slidesPerView); l += 1) {
                const d = e.activeIndex + l;
                if (d > e.slides.length && !a)
                    break;
                r.push(u(d))
            }
    else
        r.push(u(e.activeIndex));
    for (l = 0; l < r.length; l += 1)
        if (typeof r[l] < "u") {
            const d = r[l].offsetHeight;
            o = d > o ? d : o
        }
    (o || o === 0) && (e.wrapperEl.style.height = `${o}px`)
}
function eb() {
    const i = this
      , e = i.slides
      , r = i.isElement ? i.isHorizontal() ? i.wrapperEl.offsetLeft : i.wrapperEl.offsetTop : 0;
    for (let a = 0; a < e.length; a += 1)
        e[a].swiperSlideOffset = (i.isHorizontal() ? e[a].offsetLeft : e[a].offsetTop) - r - i.cssOverflowAdjustment()
}
const Qh = (i, e, r) => {
    e && !i.classList.contains(r) ? i.classList.add(r) : !e && i.classList.contains(r) && i.classList.remove(r)
}
;
function tb(i) {
    i === void 0 && (i = this && this.translate || 0);
    const e = this
      , r = e.params
      , {slides: a, rtlTranslate: o, snapGrid: l} = e;
    if (a.length === 0)
        return;
    typeof a[0].swiperSlideOffset > "u" && e.updateSlidesOffset();
    let u = -i;
    o && (u = i),
    e.visibleSlidesIndexes = [],
    e.visibleSlides = [];
    let d = r.spaceBetween;
    typeof d == "string" && d.indexOf("%") >= 0 ? d = parseFloat(d.replace("%", "")) / 100 * e.size : typeof d == "string" && (d = parseFloat(d));
    for (let p = 0; p < a.length; p += 1) {
        const h = a[p];
        let g = h.swiperSlideOffset;
        r.cssMode && r.centeredSlides && (g -= a[0].swiperSlideOffset);
        const v = (u + (r.centeredSlides ? e.minTranslate() : 0) - g) / (h.swiperSlideSize + d)
          , y = (u - l[0] + (r.centeredSlides ? e.minTranslate() : 0) - g) / (h.swiperSlideSize + d)
          , P = -(u - g)
          , w = P + e.slidesSizesGrid[p]
          , S = P >= 0 && P <= e.size - e.slidesSizesGrid[p]
          , z = P >= 0 && P < e.size - 1 || w > 1 && w <= e.size || P <= 0 && w >= e.size;
        z && (e.visibleSlides.push(h),
        e.visibleSlidesIndexes.push(p)),
        Qh(h, z, r.slideVisibleClass),
        Qh(h, S, r.slideFullyVisibleClass),
        h.progress = o ? -v : v,
        h.originalProgress = o ? -y : y
    }
}
function ib(i) {
    const e = this;
    if (typeof i > "u") {
        const g = e.rtlTranslate ? -1 : 1;
        i = e && e.translate && e.translate * g || 0
    }
    const r = e.params
      , a = e.maxTranslate() - e.minTranslate();
    let {progress: o, isBeginning: l, isEnd: u, progressLoop: d} = e;
    const p = l
      , h = u;
    if (a === 0)
        o = 0,
        l = !0,
        u = !0;
    else {
        o = (i - e.minTranslate()) / a;
        const g = Math.abs(i - e.minTranslate()) < 1
          , v = Math.abs(i - e.maxTranslate()) < 1;
        l = g || o <= 0,
        u = v || o >= 1,
        g && (o = 0),
        v && (o = 1)
    }
    if (r.loop) {
        const g = e.getSlideIndexByData(0)
          , v = e.getSlideIndexByData(e.slides.length - 1)
          , y = e.slidesGrid[g]
          , P = e.slidesGrid[v]
          , w = e.slidesGrid[e.slidesGrid.length - 1]
          , S = Math.abs(i);
        S >= y ? d = (S - y) / w : d = (S + w - P) / w,
        d > 1 && (d -= 1)
    }
    Object.assign(e, {
        progress: o,
        progressLoop: d,
        isBeginning: l,
        isEnd: u
    }),
    (r.watchSlidesProgress || r.centeredSlides && r.autoHeight) && e.updateSlidesProgress(i),
    l && !p && e.emit("reachBeginning toEdge"),
    u && !h && e.emit("reachEnd toEdge"),
    (p && !l || h && !u) && e.emit("fromEdge"),
    e.emit("progress", o)
}
const oc = (i, e, r) => {
    e && !i.classList.contains(r) ? i.classList.add(r) : !e && i.classList.contains(r) && i.classList.remove(r)
}
;
function rb() {
    const i = this
      , {slides: e, params: r, slidesEl: a, activeIndex: o} = i
      , l = i.virtual && r.virtual.enabled
      , u = i.grid && r.grid && r.grid.rows > 1
      , d = v => _t(a, `.${r.slideClass}${v}, swiper-slide${v}`)[0];
    let p, h, g;
    if (l)
        if (r.loop) {
            let v = o - i.virtual.slidesBefore;
            v < 0 && (v = i.virtual.slides.length + v),
            v >= i.virtual.slides.length && (v -= i.virtual.slides.length),
            p = d(`[data-swiper-slide-index="${v}"]`)
        } else
            p = d(`[data-swiper-slide-index="${o}"]`);
    else
        u ? (p = e.find(v => v.column === o),
        g = e.find(v => v.column === o + 1),
        h = e.find(v => v.column === o - 1)) : p = e[o];
    p && (u || (g = KP(p, `.${r.slideClass}, swiper-slide`)[0],
    r.loop && !g && (g = e[0]),
    h = UP(p, `.${r.slideClass}, swiper-slide`)[0],
    r.loop && !h === 0 && (h = e[e.length - 1]))),
    e.forEach(v => {
        oc(v, v === p, r.slideActiveClass),
        oc(v, v === g, r.slideNextClass),
        oc(v, v === h, r.slidePrevClass)
    }
    ),
    i.emitSlidesClasses()
}
const xs = (i, e) => {
    if (!i || i.destroyed || !i.params)
        return;
    const r = () => i.isElement ? "swiper-slide" : `.${i.params.slideClass}`
      , a = e.closest(r());
    if (a) {
        let o = a.querySelector(`.${i.params.lazyPreloaderClass}`);
        !o && i.isElement && (a.shadowRoot ? o = a.shadowRoot.querySelector(`.${i.params.lazyPreloaderClass}`) : requestAnimationFrame( () => {
            a.shadowRoot && (o = a.shadowRoot.querySelector(`.${i.params.lazyPreloaderClass}`),
            o && o.remove())
        }
        )),
        o && o.remove()
    }
}
  , lc = (i, e) => {
    if (!i.slides[e])
        return;
    const r = i.slides[e].querySelector('[loading="lazy"]');
    r && r.removeAttribute("loading")
}
  , Mc = i => {
    if (!i || i.destroyed || !i.params)
        return;
    let e = i.params.lazyPreloadPrevNext;
    const r = i.slides.length;
    if (!r || !e || e < 0)
        return;
    e = Math.min(e, r);
    const a = i.params.slidesPerView === "auto" ? i.slidesPerViewDynamic() : Math.ceil(i.params.slidesPerView)
      , o = i.activeIndex;
    if (i.params.grid && i.params.grid.rows > 1) {
        const u = o
          , d = [u - e];
        d.push(...Array.from({
            length: e
        }).map( (p, h) => u + a + h)),
        i.slides.forEach( (p, h) => {
            d.includes(p.column) && lc(i, h)
        }
        );
        return
    }
    const l = o + a - 1;
    if (i.params.rewind || i.params.loop)
        for (let u = o - e; u <= l + e; u += 1) {
            const d = (u % r + r) % r;
            (d < o || d > l) && lc(i, d)
        }
    else
        for (let u = Math.max(o - e, 0); u <= Math.min(l + e, r - 1); u += 1)
            u !== o && (u > l || u < o) && lc(i, u)
}
;
function nb(i) {
    const {slidesGrid: e, params: r} = i
      , a = i.rtlTranslate ? i.translate : -i.translate;
    let o;
    for (let l = 0; l < e.length; l += 1)
        typeof e[l + 1] < "u" ? a >= e[l] && a < e[l + 1] - (e[l + 1] - e[l]) / 2 ? o = l : a >= e[l] && a < e[l + 1] && (o = l + 1) : a >= e[l] && (o = l);
    return r.normalizeSlideIndex && (o < 0 || typeof o > "u") && (o = 0),
    o
}
function ab(i) {
    const e = this
      , r = e.rtlTranslate ? e.translate : -e.translate
      , {snapGrid: a, params: o, activeIndex: l, realIndex: u, snapIndex: d} = e;
    let p = i, h;
    const g = P => {
        let w = P - e.virtual.slidesBefore;
        return w < 0 && (w = e.virtual.slides.length + w),
        w >= e.virtual.slides.length && (w -= e.virtual.slides.length),
        w
    }
    ;
    if (typeof p > "u" && (p = nb(e)),
    a.indexOf(r) >= 0)
        h = a.indexOf(r);
    else {
        const P = Math.min(o.slidesPerGroupSkip, p);
        h = P + Math.floor((p - P) / o.slidesPerGroup)
    }
    if (h >= a.length && (h = a.length - 1),
    p === l && !e.params.loop) {
        h !== d && (e.snapIndex = h,
        e.emit("snapIndexChange"));
        return
    }
    if (p === l && e.params.loop && e.virtual && e.params.virtual.enabled) {
        e.realIndex = g(p);
        return
    }
    const v = e.grid && o.grid && o.grid.rows > 1;
    let y;
    if (e.virtual && o.virtual.enabled && o.loop)
        y = g(p);
    else if (v) {
        const P = e.slides.find(S => S.column === p);
        let w = parseInt(P.getAttribute("data-swiper-slide-index"), 10);
        Number.isNaN(w) && (w = Math.max(e.slides.indexOf(P), 0)),
        y = Math.floor(w / o.grid.rows)
    } else if (e.slides[p]) {
        const P = e.slides[p].getAttribute("data-swiper-slide-index");
        P ? y = parseInt(P, 10) : y = p
    } else
        y = p;
    Object.assign(e, {
        previousSnapIndex: d,
        snapIndex: h,
        previousRealIndex: u,
        realIndex: y,
        previousIndex: l,
        activeIndex: p
    }),
    e.initialized && Mc(e),
    e.emit("activeIndexChange"),
    e.emit("snapIndexChange"),
    (e.initialized || e.params.runCallbacksOnInit) && (u !== y && e.emit("realIndexChange"),
    e.emit("slideChange"))
}
function sb(i, e) {
    const r = this
      , a = r.params;
    let o = i.closest(`.${a.slideClass}, swiper-slide`);
    !o && r.isElement && e && e.length > 1 && e.includes(i) && [...e.slice(e.indexOf(i) + 1, e.length)].forEach(d => {
        !o && d.matches && d.matches(`.${a.slideClass}, swiper-slide`) && (o = d)
    }
    );
    let l = !1, u;
    if (o) {
        for (let d = 0; d < r.slides.length; d += 1)
            if (r.slides[d] === o) {
                l = !0,
                u = d;
                break
            }
    }
    if (o && l)
        r.clickedSlide = o,
        r.virtual && r.params.virtual.enabled ? r.clickedIndex = parseInt(o.getAttribute("data-swiper-slide-index"), 10) : r.clickedIndex = u;
    else {
        r.clickedSlide = void 0,
        r.clickedIndex = void 0;
        return
    }
    a.slideToClickedSlide && r.clickedIndex !== void 0 && r.clickedIndex !== r.activeIndex && r.slideToClickedSlide()
}
var ob = {
    updateSize: YP,
    updateSlides: QP,
    updateAutoHeight: JP,
    updateSlidesOffset: eb,
    updateSlidesProgress: tb,
    updateProgress: ib,
    updateSlidesClasses: rb,
    updateActiveIndex: ab,
    updateClickedSlide: sb
};
function lb(i) {
    i === void 0 && (i = this.isHorizontal() ? "x" : "y");
    const e = this
      , {params: r, rtlTranslate: a, translate: o, wrapperEl: l} = e;
    if (r.virtualTranslate)
        return a ? -o : o;
    if (r.cssMode)
        return o;
    let u = RP(l, i);
    return u += e.cssOverflowAdjustment(),
    a && (u = -u),
    u || 0
}
function cb(i, e) {
    const r = this
      , {rtlTranslate: a, params: o, wrapperEl: l, progress: u} = r;
    let d = 0
      , p = 0;
    const h = 0;
    r.isHorizontal() ? d = a ? -i : i : p = i,
    o.roundLengths && (d = Math.floor(d),
    p = Math.floor(p)),
    r.previousTranslate = r.translate,
    r.translate = r.isHorizontal() ? d : p,
    o.cssMode ? l[r.isHorizontal() ? "scrollLeft" : "scrollTop"] = r.isHorizontal() ? -d : -p : o.virtualTranslate || (r.isHorizontal() ? d -= r.cssOverflowAdjustment() : p -= r.cssOverflowAdjustment(),
    l.style.transform = `translate3d(${d}px, ${p}px, ${h}px)`);
    let g;
    const v = r.maxTranslate() - r.minTranslate();
    v === 0 ? g = 0 : g = (i - r.minTranslate()) / v,
    g !== u && r.updateProgress(i),
    r.emit("setTranslate", r.translate, e)
}
function ub() {
    return -this.snapGrid[0]
}
function db() {
    return -this.snapGrid[this.snapGrid.length - 1]
}
function pb(i, e, r, a, o) {
    i === void 0 && (i = 0),
    e === void 0 && (e = this.params.speed),
    r === void 0 && (r = !0),
    a === void 0 && (a = !0);
    const l = this
      , {params: u, wrapperEl: d} = l;
    if (l.animating && u.preventInteractionOnTransition)
        return !1;
    const p = l.minTranslate()
      , h = l.maxTranslate();
    let g;
    if (a && i > p ? g = p : a && i < h ? g = h : g = i,
    l.updateProgress(g),
    u.cssMode) {
        const v = l.isHorizontal();
        if (e === 0)
            d[v ? "scrollLeft" : "scrollTop"] = -g;
        else {
            if (!l.support.smoothScroll)
                return u0({
                    swiper: l,
                    targetPosition: -g,
                    side: v ? "left" : "top"
                }),
                !0;
            d.scrollTo({
                [v ? "left" : "top"]: -g,
                behavior: "smooth"
            })
        }
        return !0
    }
    return e === 0 ? (l.setTransition(0),
    l.setTranslate(g),
    r && (l.emit("beforeTransitionStart", e, o),
    l.emit("transitionEnd"))) : (l.setTransition(e),
    l.setTranslate(g),
    r && (l.emit("beforeTransitionStart", e, o),
    l.emit("transitionStart")),
    l.animating || (l.animating = !0,
    l.onTranslateToWrapperTransitionEnd || (l.onTranslateToWrapperTransitionEnd = function(y) {
        !l || l.destroyed || y.target === this && (l.wrapperEl.removeEventListener("transitionend", l.onTranslateToWrapperTransitionEnd),
        l.onTranslateToWrapperTransitionEnd = null,
        delete l.onTranslateToWrapperTransitionEnd,
        l.animating = !1,
        r && l.emit("transitionEnd"))
    }
    ),
    l.wrapperEl.addEventListener("transitionend", l.onTranslateToWrapperTransitionEnd))),
    !0
}
var mb = {
    getTranslate: lb,
    setTranslate: cb,
    minTranslate: ub,
    maxTranslate: db,
    translateTo: pb
};
function hb(i, e) {
    const r = this;
    r.params.cssMode || (r.wrapperEl.style.transitionDuration = `${i}ms`,
    r.wrapperEl.style.transitionDelay = i === 0 ? "0ms" : ""),
    r.emit("setTransition", i, e)
}
function f0(i) {
    let {swiper: e, runCallbacks: r, direction: a, step: o} = i;
    const {activeIndex: l, previousIndex: u} = e;
    let d = a;
    d || (l > u ? d = "next" : l < u ? d = "prev" : d = "reset"),
    e.emit(`transition${o}`),
    r && d === "reset" ? e.emit(`slideResetTransition${o}`) : r && l !== u && (e.emit(`slideChangeTransition${o}`),
    d === "next" ? e.emit(`slideNextTransition${o}`) : e.emit(`slidePrevTransition${o}`))
}
function fb(i, e) {
    i === void 0 && (i = !0);
    const r = this
      , {params: a} = r;
    a.cssMode || (a.autoHeight && r.updateAutoHeight(),
    f0({
        swiper: r,
        runCallbacks: i,
        direction: e,
        step: "Start"
    }))
}
function gb(i, e) {
    i === void 0 && (i = !0);
    const r = this
      , {params: a} = r;
    r.animating = !1,
    !a.cssMode && (r.setTransition(0),
    f0({
        swiper: r,
        runCallbacks: i,
        direction: e,
        step: "End"
    }))
}
var vb = {
    setTransition: hb,
    transitionStart: fb,
    transitionEnd: gb
};
function yb(i, e, r, a, o) {
    i === void 0 && (i = 0),
    r === void 0 && (r = !0),
    typeof i == "string" && (i = parseInt(i, 10));
    const l = this;
    let u = i;
    u < 0 && (u = 0);
    const {params: d, snapGrid: p, slidesGrid: h, previousIndex: g, activeIndex: v, rtlTranslate: y, wrapperEl: P, enabled: w} = l;
    if (!w && !a && !o || l.destroyed || l.animating && d.preventInteractionOnTransition)
        return !1;
    typeof e > "u" && (e = l.params.speed);
    const S = Math.min(l.params.slidesPerGroupSkip, u);
    let z = S + Math.floor((u - S) / l.params.slidesPerGroup);
    z >= p.length && (z = p.length - 1);
    const C = -p[z];
    if (d.normalizeSlideIndex)
        for (let _ = 0; _ < h.length; _ += 1) {
            const F = -Math.floor(C * 100)
              , R = Math.floor(h[_] * 100)
              , W = Math.floor(h[_ + 1] * 100);
            typeof h[_ + 1] < "u" ? F >= R && F < W - (W - R) / 2 ? u = _ : F >= R && F < W && (u = _ + 1) : F >= R && (u = _)
        }
    if (l.initialized && u !== v && (!l.allowSlideNext && (y ? C > l.translate && C > l.minTranslate() : C < l.translate && C < l.minTranslate()) || !l.allowSlidePrev && C > l.translate && C > l.maxTranslate() && (v || 0) !== u))
        return !1;
    u !== (g || 0) && r && l.emit("beforeSlideChangeStart"),
    l.updateProgress(C);
    let b;
    u > v ? b = "next" : u < v ? b = "prev" : b = "reset";
    const T = l.virtual && l.params.virtual.enabled;
    if (!(T && o) && (y && -C === l.translate || !y && C === l.translate))
        return l.updateActiveIndex(u),
        d.autoHeight && l.updateAutoHeight(),
        l.updateSlidesClasses(),
        d.effect !== "slide" && l.setTranslate(C),
        b !== "reset" && (l.transitionStart(r, b),
        l.transitionEnd(r, b)),
        !1;
    if (d.cssMode) {
        const _ = l.isHorizontal()
          , F = y ? C : -C;
        if (e === 0)
            T && (l.wrapperEl.style.scrollSnapType = "none",
            l._immediateVirtual = !0),
            T && !l._cssModeVirtualInitialSet && l.params.initialSlide > 0 ? (l._cssModeVirtualInitialSet = !0,
            requestAnimationFrame( () => {
                P[_ ? "scrollLeft" : "scrollTop"] = F
            }
            )) : P[_ ? "scrollLeft" : "scrollTop"] = F,
            T && requestAnimationFrame( () => {
                l.wrapperEl.style.scrollSnapType = "",
                l._immediateVirtual = !1
            }
            );
        else {
            if (!l.support.smoothScroll)
                return u0({
                    swiper: l,
                    targetPosition: F,
                    side: _ ? "left" : "top"
                }),
                !0;
            P.scrollTo({
                [_ ? "left" : "top"]: F,
                behavior: "smooth"
            })
        }
        return !0
    }
    const B = h0().isSafari;
    return T && !o && B && l.isElement && l.virtual.update(!1, !1, u),
    l.setTransition(e),
    l.setTranslate(C),
    l.updateActiveIndex(u),
    l.updateSlidesClasses(),
    l.emit("beforeTransitionStart", e, a),
    l.transitionStart(r, b),
    e === 0 ? l.transitionEnd(r, b) : l.animating || (l.animating = !0,
    l.onSlideToWrapperTransitionEnd || (l.onSlideToWrapperTransitionEnd = function(F) {
        !l || l.destroyed || F.target === this && (l.wrapperEl.removeEventListener("transitionend", l.onSlideToWrapperTransitionEnd),
        l.onSlideToWrapperTransitionEnd = null,
        delete l.onSlideToWrapperTransitionEnd,
        l.transitionEnd(r, b))
    }
    ),
    l.wrapperEl.addEventListener("transitionend", l.onSlideToWrapperTransitionEnd)),
    !0
}
function kb(i, e, r, a) {
    i === void 0 && (i = 0),
    r === void 0 && (r = !0),
    typeof i == "string" && (i = parseInt(i, 10));
    const o = this;
    if (o.destroyed)
        return;
    typeof e > "u" && (e = o.params.speed);
    const l = o.grid && o.params.grid && o.params.grid.rows > 1;
    let u = i;
    if (o.params.loop)
        if (o.virtual && o.params.virtual.enabled)
            u = u + o.virtual.slidesBefore;
        else {
            let d;
            if (l) {
                const y = u * o.params.grid.rows;
                d = o.slides.find(P => P.getAttribute("data-swiper-slide-index") * 1 === y).column
            } else
                d = o.getSlideIndexByData(u);
            const p = l ? Math.ceil(o.slides.length / o.params.grid.rows) : o.slides.length
              , {centeredSlides: h} = o.params;
            let g = o.params.slidesPerView;
            g === "auto" ? g = o.slidesPerViewDynamic() : (g = Math.ceil(parseFloat(o.params.slidesPerView, 10)),
            h && g % 2 === 0 && (g = g + 1));
            let v = p - d < g;
            if (h && (v = v || d < Math.ceil(g / 2)),
            a && h && o.params.slidesPerView !== "auto" && !l && (v = !1),
            v) {
                const y = h ? d < o.activeIndex ? "prev" : "next" : d - o.activeIndex - 1 < o.params.slidesPerView ? "next" : "prev";
                o.loopFix({
                    direction: y,
                    slideTo: !0,
                    activeSlideIndex: y === "next" ? d + 1 : d - p + 1,
                    slideRealIndex: y === "next" ? o.realIndex : void 0
                })
            }
            if (l) {
                const y = u * o.params.grid.rows;
                u = o.slides.find(P => P.getAttribute("data-swiper-slide-index") * 1 === y).column
            } else
                u = o.getSlideIndexByData(u)
        }
    return requestAnimationFrame( () => {
        o.slideTo(u, e, r, a)
    }
    ),
    o
}
function xb(i, e, r) {
    e === void 0 && (e = !0);
    const a = this
      , {enabled: o, params: l, animating: u} = a;
    if (!o || a.destroyed)
        return a;
    typeof i > "u" && (i = a.params.speed);
    let d = l.slidesPerGroup;
    l.slidesPerView === "auto" && l.slidesPerGroup === 1 && l.slidesPerGroupAuto && (d = Math.max(a.slidesPerViewDynamic("current", !0), 1));
    const p = a.activeIndex < l.slidesPerGroupSkip ? 1 : d
      , h = a.virtual && l.virtual.enabled;
    if (l.loop) {
        if (u && !h && l.loopPreventsSliding)
            return !1;
        if (a.loopFix({
            direction: "next"
        }),
        a._clientLeft = a.wrapperEl.clientLeft,
        a.activeIndex === a.slides.length - 1 && l.cssMode)
            return requestAnimationFrame( () => {
                a.slideTo(a.activeIndex + p, i, e, r)
            }
            ),
            !0
    }
    return l.rewind && a.isEnd ? a.slideTo(0, i, e, r) : a.slideTo(a.activeIndex + p, i, e, r)
}
function wb(i, e, r) {
    e === void 0 && (e = !0);
    const a = this
      , {params: o, snapGrid: l, slidesGrid: u, rtlTranslate: d, enabled: p, animating: h} = a;
    if (!p || a.destroyed)
        return a;
    typeof i > "u" && (i = a.params.speed);
    const g = a.virtual && o.virtual.enabled;
    if (o.loop) {
        if (h && !g && o.loopPreventsSliding)
            return !1;
        a.loopFix({
            direction: "prev"
        }),
        a._clientLeft = a.wrapperEl.clientLeft
    }
    const v = d ? a.translate : -a.translate;
    function y(b) {
        return b < 0 ? -Math.floor(Math.abs(b)) : Math.floor(b)
    }
    const P = y(v)
      , w = l.map(b => y(b))
      , S = o.freeMode && o.freeMode.enabled;
    let z = l[w.indexOf(P) - 1];
    if (typeof z > "u" && (o.cssMode || S)) {
        let b;
        l.forEach( (T, D) => {
            P >= T && (b = D)
        }
        ),
        typeof b < "u" && (z = S ? l[b] : l[b > 0 ? b - 1 : b])
    }
    let C = 0;
    if (typeof z < "u" && (C = u.indexOf(z),
    C < 0 && (C = a.activeIndex - 1),
    o.slidesPerView === "auto" && o.slidesPerGroup === 1 && o.slidesPerGroupAuto && (C = C - a.slidesPerViewDynamic("previous", !0) + 1,
    C = Math.max(C, 0))),
    o.rewind && a.isBeginning) {
        const b = a.params.virtual && a.params.virtual.enabled && a.virtual ? a.virtual.slides.length - 1 : a.slides.length - 1;
        return a.slideTo(b, i, e, r)
    } else if (o.loop && a.activeIndex === 0 && o.cssMode)
        return requestAnimationFrame( () => {
            a.slideTo(C, i, e, r)
        }
        ),
        !0;
    return a.slideTo(C, i, e, r)
}
function Pb(i, e, r) {
    e === void 0 && (e = !0);
    const a = this;
    if (!a.destroyed)
        return typeof i > "u" && (i = a.params.speed),
        a.slideTo(a.activeIndex, i, e, r)
}
function bb(i, e, r, a) {
    e === void 0 && (e = !0),
    a === void 0 && (a = .5);
    const o = this;
    if (o.destroyed)
        return;
    typeof i > "u" && (i = o.params.speed);
    let l = o.activeIndex;
    const u = Math.min(o.params.slidesPerGroupSkip, l)
      , d = u + Math.floor((l - u) / o.params.slidesPerGroup)
      , p = o.rtlTranslate ? o.translate : -o.translate;
    if (p >= o.snapGrid[d]) {
        const h = o.snapGrid[d]
          , g = o.snapGrid[d + 1];
        p - h > (g - h) * a && (l += o.params.slidesPerGroup)
    } else {
        const h = o.snapGrid[d - 1]
          , g = o.snapGrid[d];
        p - h <= (g - h) * a && (l -= o.params.slidesPerGroup)
    }
    return l = Math.max(l, 0),
    l = Math.min(l, o.slidesGrid.length - 1),
    o.slideTo(l, i, e, r)
}
function Sb() {
    const i = this;
    if (i.destroyed)
        return;
    const {params: e, slidesEl: r} = i
      , a = e.slidesPerView === "auto" ? i.slidesPerViewDynamic() : e.slidesPerView;
    let o = i.getSlideIndexWhenGrid(i.clickedIndex), l;
    const u = i.isElement ? "swiper-slide" : `.${e.slideClass}`
      , d = i.grid && i.params.grid && i.params.grid.rows > 1;
    if (e.loop) {
        if (i.animating)
            return;
        l = parseInt(i.clickedSlide.getAttribute("data-swiper-slide-index"), 10),
        e.centeredSlides ? i.slideToLoop(l) : o > (d ? (i.slides.length - a) / 2 - (i.params.grid.rows - 1) : i.slides.length - a) ? (i.loopFix(),
        o = i.getSlideIndex(_t(r, `${u}[data-swiper-slide-index="${l}"]`)[0]),
        c0( () => {
            i.slideTo(o)
        }
        )) : i.slideTo(o)
    } else
        i.slideTo(o)
}
var Tb = {
    slideTo: yb,
    slideToLoop: kb,
    slideNext: xb,
    slidePrev: wb,
    slideReset: Pb,
    slideToClosest: bb,
    slideToClickedSlide: Sb
};
function jb(i, e) {
    const r = this
      , {params: a, slidesEl: o} = r;
    if (!a.loop || r.virtual && r.params.virtual.enabled)
        return;
    const l = () => {
        _t(o, `.${a.slideClass}, swiper-slide`).forEach( (P, w) => {
            P.setAttribute("data-swiper-slide-index", w)
        }
        )
    }
      , u = () => {
        const y = _t(o, `.${a.slideBlankClass}`);
        y.forEach(P => {
            P.remove()
        }
        ),
        y.length > 0 && (r.recalcSlides(),
        r.updateSlides())
    }
      , d = r.grid && a.grid && a.grid.rows > 1;
    a.loopAddBlankSlides && (a.slidesPerGroup > 1 || d) && u();
    const p = a.slidesPerGroup * (d ? a.grid.rows : 1)
      , h = r.slides.length % p !== 0
      , g = d && r.slides.length % a.grid.rows !== 0
      , v = y => {
        for (let P = 0; P < y; P += 1) {
            const w = r.isElement ? Es("swiper-slide", [a.slideBlankClass]) : Es("div", [a.slideClass, a.slideBlankClass]);
            r.slidesEl.append(w)
        }
    }
    ;
    if (h) {
        if (a.loopAddBlankSlides) {
            const y = p - r.slides.length % p;
            v(y),
            r.recalcSlides(),
            r.updateSlides()
        } else
            As("Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
        l()
    } else if (g) {
        if (a.loopAddBlankSlides) {
            const y = a.grid.rows - r.slides.length % a.grid.rows;
            v(y),
            r.recalcSlides(),
            r.updateSlides()
        } else
            As("Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
        l()
    } else
        l();
    r.loopFix({
        slideRealIndex: i,
        direction: a.centeredSlides ? void 0 : "next",
        initial: e
    })
}
function Cb(i) {
    let {slideRealIndex: e, slideTo: r=!0, direction: a, setTranslate: o, activeSlideIndex: l, initial: u, byController: d, byMousewheel: p} = i === void 0 ? {} : i;
    const h = this;
    if (!h.params.loop)
        return;
    h.emit("beforeLoopFix");
    const {slides: g, allowSlidePrev: v, allowSlideNext: y, slidesEl: P, params: w} = h
      , {centeredSlides: S, initialSlide: z} = w;
    if (h.allowSlidePrev = !0,
    h.allowSlideNext = !0,
    h.virtual && w.virtual.enabled) {
        r && (!w.centeredSlides && h.snapIndex === 0 ? h.slideTo(h.virtual.slides.length, 0, !1, !0) : w.centeredSlides && h.snapIndex < w.slidesPerView ? h.slideTo(h.virtual.slides.length + h.snapIndex, 0, !1, !0) : h.snapIndex === h.snapGrid.length - 1 && h.slideTo(h.virtual.slidesBefore, 0, !1, !0)),
        h.allowSlidePrev = v,
        h.allowSlideNext = y,
        h.emit("loopFix");
        return
    }
    let C = w.slidesPerView;
    C === "auto" ? C = h.slidesPerViewDynamic() : (C = Math.ceil(parseFloat(w.slidesPerView, 10)),
    S && C % 2 === 0 && (C = C + 1));
    const b = w.slidesPerGroupAuto ? C : w.slidesPerGroup;
    let T = S ? Math.max(b, Math.ceil(C / 2)) : b;
    T % b !== 0 && (T += b - T % b),
    T += w.loopAdditionalSlides,
    h.loopedSlides = T;
    const D = h.grid && w.grid && w.grid.rows > 1;
    g.length < C + T || h.params.effect === "cards" && g.length < C + T * 2 ? As("Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled or not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters") : D && w.grid.fill === "row" && As("Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`");
    const M = []
      , B = []
      , _ = D ? Math.ceil(g.length / w.grid.rows) : g.length
      , F = u && _ - z < C && !S;
    let R = F ? z : h.activeIndex;
    typeof l > "u" ? l = h.getSlideIndex(g.find(ie => ie.classList.contains(w.slideActiveClass))) : R = l;
    const W = a === "next" || !a
      , K = a === "prev" || !a;
    let Q = 0
      , se = 0;
    const pe = (D ? g[l].column : l) + (S && typeof o > "u" ? -C / 2 + .5 : 0);
    if (pe < T) {
        Q = Math.max(T - pe, b);
        for (let ie = 0; ie < T - pe; ie += 1) {
            const ne = ie - Math.floor(ie / _) * _;
            if (D) {
                const H = _ - ne - 1;
                for (let X = g.length - 1; X >= 0; X -= 1)
                    g[X].column === H && M.push(X)
            } else
                M.push(_ - ne - 1)
        }
    } else if (pe + C > _ - T) {
        se = Math.max(pe - (_ - T * 2), b),
        F && (se = Math.max(se, C - _ + z + 1));
        for (let ie = 0; ie < se; ie += 1) {
            const ne = ie - Math.floor(ie / _) * _;
            D ? g.forEach( (H, X) => {
                H.column === ne && B.push(X)
            }
            ) : B.push(ne)
        }
    }
    if (h.__preventObserver__ = !0,
    requestAnimationFrame( () => {
        h.__preventObserver__ = !1
    }
    ),
    h.params.effect === "cards" && g.length < C + T * 2 && (B.includes(l) && B.splice(B.indexOf(l), 1),
    M.includes(l) && M.splice(M.indexOf(l), 1)),
    K && M.forEach(ie => {
        g[ie].swiperLoopMoveDOM = !0,
        P.prepend(g[ie]),
        g[ie].swiperLoopMoveDOM = !1
    }
    ),
    W && B.forEach(ie => {
        g[ie].swiperLoopMoveDOM = !0,
        P.append(g[ie]),
        g[ie].swiperLoopMoveDOM = !1
    }
    ),
    h.recalcSlides(),
    w.slidesPerView === "auto" ? h.updateSlides() : D && (M.length > 0 && K || B.length > 0 && W) && h.slides.forEach( (ie, ne) => {
        h.grid.updateSlide(ne, ie, h.slides)
    }
    ),
    w.watchSlidesProgress && h.updateSlidesOffset(),
    r) {
        if (M.length > 0 && K) {
            if (typeof e > "u") {
                const ie = h.slidesGrid[R]
                  , H = h.slidesGrid[R + Q] - ie;
                p ? h.setTranslate(h.translate - H) : (h.slideTo(R + Math.ceil(Q), 0, !1, !0),
                o && (h.touchEventsData.startTranslate = h.touchEventsData.startTranslate - H,
                h.touchEventsData.currentTranslate = h.touchEventsData.currentTranslate - H))
            } else if (o) {
                const ie = D ? M.length / w.grid.rows : M.length;
                h.slideTo(h.activeIndex + ie, 0, !1, !0),
                h.touchEventsData.currentTranslate = h.translate
            }
        } else if (B.length > 0 && W)
            if (typeof e > "u") {
                const ie = h.slidesGrid[R]
                  , H = h.slidesGrid[R - se] - ie;
                p ? h.setTranslate(h.translate - H) : (h.slideTo(R - se, 0, !1, !0),
                o && (h.touchEventsData.startTranslate = h.touchEventsData.startTranslate - H,
                h.touchEventsData.currentTranslate = h.touchEventsData.currentTranslate - H))
            } else {
                const ie = D ? B.length / w.grid.rows : B.length;
                h.slideTo(h.activeIndex - ie, 0, !1, !0)
            }
    }
    if (h.allowSlidePrev = v,
    h.allowSlideNext = y,
    h.controller && h.controller.control && !d) {
        const ie = {
            slideRealIndex: e,
            direction: a,
            setTranslate: o,
            activeSlideIndex: l,
            byController: !0
        };
        Array.isArray(h.controller.control) ? h.controller.control.forEach(ne => {
            !ne.destroyed && ne.params.loop && ne.loopFix({
                ...ie,
                slideTo: ne.params.slidesPerView === w.slidesPerView ? r : !1
            })
        }
        ) : h.controller.control instanceof h.constructor && h.controller.control.params.loop && h.controller.control.loopFix({
            ...ie,
            slideTo: h.controller.control.params.slidesPerView === w.slidesPerView ? r : !1
        })
    }
    h.emit("loopFix")
}
function zb() {
    const i = this
      , {params: e, slidesEl: r} = i;
    if (!e.loop || !r || i.virtual && i.params.virtual.enabled)
        return;
    i.recalcSlides();
    const a = [];
    i.slides.forEach(o => {
        const l = typeof o.swiperSlideIndex > "u" ? o.getAttribute("data-swiper-slide-index") * 1 : o.swiperSlideIndex;
        a[l] = o
    }
    ),
    i.slides.forEach(o => {
        o.removeAttribute("data-swiper-slide-index")
    }
    ),
    a.forEach(o => {
        r.append(o)
    }
    ),
    i.recalcSlides(),
    i.slideTo(i.realIndex, 0)
}
var Ab = {
    loopCreate: jb,
    loopFix: Cb,
    loopDestroy: zb
};
function Eb(i) {
    const e = this;
    if (!e.params.simulateTouch || e.params.watchOverflow && e.isLocked || e.params.cssMode)
        return;
    const r = e.params.touchEventsTarget === "container" ? e.el : e.wrapperEl;
    e.isElement && (e.__preventObserver__ = !0),
    r.style.cursor = "move",
    r.style.cursor = i ? "grabbing" : "grab",
    e.isElement && requestAnimationFrame( () => {
        e.__preventObserver__ = !1
    }
    )
}
function Db() {
    const i = this;
    i.params.watchOverflow && i.isLocked || i.params.cssMode || (i.isElement && (i.__preventObserver__ = !0),
    i[i.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "",
    i.isElement && requestAnimationFrame( () => {
        i.__preventObserver__ = !1
    }
    ))
}
var Ib = {
    setGrabCursor: Eb,
    unsetGrabCursor: Db
};
function Mb(i, e) {
    e === void 0 && (e = this);
    function r(a) {
        if (!a || a === Qi() || a === st())
            return null;
        a.assignedSlot && (a = a.assignedSlot);
        const o = a.closest(i);
        return !o && !a.getRootNode ? null : o || r(a.getRootNode().host)
    }
    return r(e)
}
function Jh(i, e, r) {
    const a = st()
      , {params: o} = i
      , l = o.edgeSwipeDetection
      , u = o.edgeSwipeThreshold;
    return l && (r <= u || r >= a.innerWidth - u) ? l === "prevent" ? (e.preventDefault(),
    !0) : !1 : !0
}
function Vb(i) {
    const e = this
      , r = Qi();
    let a = i;
    a.originalEvent && (a = a.originalEvent);
    const o = e.touchEventsData;
    if (a.type === "pointerdown") {
        if (o.pointerId !== null && o.pointerId !== a.pointerId)
            return;
        o.pointerId = a.pointerId
    } else
        a.type === "touchstart" && a.targetTouches.length === 1 && (o.touchId = a.targetTouches[0].identifier);
    if (a.type === "touchstart") {
        Jh(e, a, a.targetTouches[0].pageX);
        return
    }
    const {params: l, touches: u, enabled: d} = e;
    if (!d || !l.simulateTouch && a.pointerType === "mouse" || e.animating && l.preventInteractionOnTransition)
        return;
    !e.animating && l.cssMode && l.loop && e.loopFix();
    let p = a.target;
    if (l.touchEventsTarget === "wrapper" && !_P(p, e.wrapperEl) || "which"in a && a.which === 3 || "button"in a && a.button > 0 || o.isTouched && o.isMoved)
        return;
    const h = !!l.noSwipingClass && l.noSwipingClass !== ""
      , g = a.composedPath ? a.composedPath() : a.path;
    h && a.target && a.target.shadowRoot && g && (p = g[0]);
    const v = l.noSwipingSelector ? l.noSwipingSelector : `.${l.noSwipingClass}`
      , y = !!(a.target && a.target.shadowRoot);
    if (l.noSwiping && (y ? Mb(v, p) : p.closest(v))) {
        e.allowClick = !0;
        return
    }
    if (l.swipeHandler && !p.closest(l.swipeHandler))
        return;
    u.currentX = a.pageX,
    u.currentY = a.pageY;
    const P = u.currentX
      , w = u.currentY;
    if (!Jh(e, a, P))
        return;
    Object.assign(o, {
        isTouched: !0,
        isMoved: !1,
        allowTouchCallbacks: !0,
        isScrolling: void 0,
        startMoving: void 0
    }),
    u.startX = P,
    u.startY = w,
    o.touchStartTime = zs(),
    e.allowClick = !0,
    e.updateSize(),
    e.swipeDirection = void 0,
    l.threshold > 0 && (o.allowThresholdMove = !1);
    let S = !0;
    p.matches(o.focusableElements) && (S = !1,
    p.nodeName === "SELECT" && (o.isTouched = !1)),
    r.activeElement && r.activeElement.matches(o.focusableElements) && r.activeElement !== p && (a.pointerType === "mouse" || a.pointerType !== "mouse" && !p.matches(o.focusableElements)) && r.activeElement.blur();
    const z = S && e.allowTouchMove && l.touchStartPreventDefault;
    (l.touchStartForcePreventDefault || z) && !p.isContentEditable && a.preventDefault(),
    l.freeMode && l.freeMode.enabled && e.freeMode && e.animating && !l.cssMode && e.freeMode.onTouchStart(),
    e.emit("touchStart", a)
}
function Lb(i) {
    const e = Qi()
      , r = this
      , a = r.touchEventsData
      , {params: o, touches: l, rtlTranslate: u, enabled: d} = r;
    if (!d || !o.simulateTouch && i.pointerType === "mouse")
        return;
    let p = i;
    if (p.originalEvent && (p = p.originalEvent),
    p.type === "pointermove" && (a.touchId !== null || p.pointerId !== a.pointerId))
        return;
    let h;
    if (p.type === "touchmove") {
        if (h = [...p.changedTouches].find(M => M.identifier === a.touchId),
        !h || h.identifier !== a.touchId)
            return
    } else
        h = p;
    if (!a.isTouched) {
        a.startMoving && a.isScrolling && r.emit("touchMoveOpposite", p);
        return
    }
    const g = h.pageX
      , v = h.pageY;
    if (p.preventedByNestedSwiper) {
        l.startX = g,
        l.startY = v;
        return
    }
    if (!r.allowTouchMove) {
        p.target.matches(a.focusableElements) || (r.allowClick = !1),
        a.isTouched && (Object.assign(l, {
            startX: g,
            startY: v,
            currentX: g,
            currentY: v
        }),
        a.touchStartTime = zs());
        return
    }
    if (o.touchReleaseOnEdges && !o.loop)
        if (r.isVertical()) {
            if (v < l.startY && r.translate <= r.maxTranslate() || v > l.startY && r.translate >= r.minTranslate()) {
                a.isTouched = !1,
                a.isMoved = !1;
                return
            }
        } else {
            if (u && (g > l.startX && -r.translate <= r.maxTranslate() || g < l.startX && -r.translate >= r.minTranslate()))
                return;
            if (!u && (g < l.startX && r.translate <= r.maxTranslate() || g > l.startX && r.translate >= r.minTranslate()))
                return
        }
    if (e.activeElement && e.activeElement.matches(a.focusableElements) && e.activeElement !== p.target && p.pointerType !== "mouse" && e.activeElement.blur(),
    e.activeElement && p.target === e.activeElement && p.target.matches(a.focusableElements)) {
        a.isMoved = !0,
        r.allowClick = !1;
        return
    }
    a.allowTouchCallbacks && r.emit("touchMove", p),
    l.previousX = l.currentX,
    l.previousY = l.currentY,
    l.currentX = g,
    l.currentY = v;
    const y = l.currentX - l.startX
      , P = l.currentY - l.startY;
    if (r.params.threshold && Math.sqrt(y ** 2 + P ** 2) < r.params.threshold)
        return;
    if (typeof a.isScrolling > "u") {
        let M;
        r.isHorizontal() && l.currentY === l.startY || r.isVertical() && l.currentX === l.startX ? a.isScrolling = !1 : y * y + P * P >= 25 && (M = Math.atan2(Math.abs(P), Math.abs(y)) * 180 / Math.PI,
        a.isScrolling = r.isHorizontal() ? M > o.touchAngle : 90 - M > o.touchAngle)
    }
    if (a.isScrolling && r.emit("touchMoveOpposite", p),
    typeof a.startMoving > "u" && (l.currentX !== l.startX || l.currentY !== l.startY) && (a.startMoving = !0),
    a.isScrolling || p.type === "touchmove" && a.preventTouchMoveFromPointerMove) {
        a.isTouched = !1;
        return
    }
    if (!a.startMoving)
        return;
    r.allowClick = !1,
    !o.cssMode && p.cancelable && p.preventDefault(),
    o.touchMoveStopPropagation && !o.nested && p.stopPropagation();
    let w = r.isHorizontal() ? y : P
      , S = r.isHorizontal() ? l.currentX - l.previousX : l.currentY - l.previousY;
    o.oneWayMovement && (w = Math.abs(w) * (u ? 1 : -1),
    S = Math.abs(S) * (u ? 1 : -1)),
    l.diff = w,
    w *= o.touchRatio,
    u && (w = -w,
    S = -S);
    const z = r.touchesDirection;
    r.swipeDirection = w > 0 ? "prev" : "next",
    r.touchesDirection = S > 0 ? "prev" : "next";
    const C = r.params.loop && !o.cssMode
      , b = r.touchesDirection === "next" && r.allowSlideNext || r.touchesDirection === "prev" && r.allowSlidePrev;
    if (!a.isMoved) {
        if (C && b && r.loopFix({
            direction: r.swipeDirection
        }),
        a.startTranslate = r.getTranslate(),
        r.setTransition(0),
        r.animating) {
            const M = new window.CustomEvent("transitionend",{
                bubbles: !0,
                cancelable: !0,
                detail: {
                    bySwiperTouchMove: !0
                }
            });
            r.wrapperEl.dispatchEvent(M)
        }
        a.allowMomentumBounce = !1,
        o.grabCursor && (r.allowSlideNext === !0 || r.allowSlidePrev === !0) && r.setGrabCursor(!0),
        r.emit("sliderFirstMove", p)
    }
    if (new Date().getTime(),
    o._loopSwapReset !== !1 && a.isMoved && a.allowThresholdMove && z !== r.touchesDirection && C && b && Math.abs(w) >= 1) {
        Object.assign(l, {
            startX: g,
            startY: v,
            currentX: g,
            currentY: v,
            startTranslate: a.currentTranslate
        }),
        a.loopSwapReset = !0,
        a.startTranslate = a.currentTranslate;
        return
    }
    r.emit("sliderMove", p),
    a.isMoved = !0,
    a.currentTranslate = w + a.startTranslate;
    let T = !0
      , D = o.resistanceRatio;
    if (o.touchReleaseOnEdges && (D = 0),
    w > 0 ? (C && b && a.allowThresholdMove && a.currentTranslate > (o.centeredSlides ? r.minTranslate() - r.slidesSizesGrid[r.activeIndex + 1] - (o.slidesPerView !== "auto" && r.slides.length - o.slidesPerView >= 2 ? r.slidesSizesGrid[r.activeIndex + 1] + r.params.spaceBetween : 0) - r.params.spaceBetween : r.minTranslate()) && r.loopFix({
        direction: "prev",
        setTranslate: !0,
        activeSlideIndex: 0
    }),
    a.currentTranslate > r.minTranslate() && (T = !1,
    o.resistance && (a.currentTranslate = r.minTranslate() - 1 + (-r.minTranslate() + a.startTranslate + w) ** D))) : w < 0 && (C && b && a.allowThresholdMove && a.currentTranslate < (o.centeredSlides ? r.maxTranslate() + r.slidesSizesGrid[r.slidesSizesGrid.length - 1] + r.params.spaceBetween + (o.slidesPerView !== "auto" && r.slides.length - o.slidesPerView >= 2 ? r.slidesSizesGrid[r.slidesSizesGrid.length - 1] + r.params.spaceBetween : 0) : r.maxTranslate()) && r.loopFix({
        direction: "next",
        setTranslate: !0,
        activeSlideIndex: r.slides.length - (o.slidesPerView === "auto" ? r.slidesPerViewDynamic() : Math.ceil(parseFloat(o.slidesPerView, 10)))
    }),
    a.currentTranslate < r.maxTranslate() && (T = !1,
    o.resistance && (a.currentTranslate = r.maxTranslate() + 1 - (r.maxTranslate() - a.startTranslate - w) ** D))),
    T && (p.preventedByNestedSwiper = !0),
    !r.allowSlideNext && r.swipeDirection === "next" && a.currentTranslate < a.startTranslate && (a.currentTranslate = a.startTranslate),
    !r.allowSlidePrev && r.swipeDirection === "prev" && a.currentTranslate > a.startTranslate && (a.currentTranslate = a.startTranslate),
    !r.allowSlidePrev && !r.allowSlideNext && (a.currentTranslate = a.startTranslate),
    o.threshold > 0)
        if (Math.abs(w) > o.threshold || a.allowThresholdMove) {
            if (!a.allowThresholdMove) {
                a.allowThresholdMove = !0,
                l.startX = l.currentX,
                l.startY = l.currentY,
                a.currentTranslate = a.startTranslate,
                l.diff = r.isHorizontal() ? l.currentX - l.startX : l.currentY - l.startY;
                return
            }
        } else {
            a.currentTranslate = a.startTranslate;
            return
        }
    !o.followFinger || o.cssMode || ((o.freeMode && o.freeMode.enabled && r.freeMode || o.watchSlidesProgress) && (r.updateActiveIndex(),
    r.updateSlidesClasses()),
    o.freeMode && o.freeMode.enabled && r.freeMode && r.freeMode.onTouchMove(),
    r.updateProgress(a.currentTranslate),
    r.setTranslate(a.currentTranslate))
}
function Ob(i) {
    const e = this
      , r = e.touchEventsData;
    let a = i;
    a.originalEvent && (a = a.originalEvent);
    let o;
    if (a.type === "touchend" || a.type === "touchcancel") {
        if (o = [...a.changedTouches].find(M => M.identifier === r.touchId),
        !o || o.identifier !== r.touchId)
            return
    } else {
        if (r.touchId !== null || a.pointerId !== r.pointerId)
            return;
        o = a
    }
    if (["pointercancel", "pointerout", "pointerleave", "contextmenu"].includes(a.type) && !(["pointercancel", "contextmenu"].includes(a.type) && (e.browser.isSafari || e.browser.isWebView)))
        return;
    r.pointerId = null,
    r.touchId = null;
    const {params: u, touches: d, rtlTranslate: p, slidesGrid: h, enabled: g} = e;
    if (!g || !u.simulateTouch && a.pointerType === "mouse")
        return;
    if (r.allowTouchCallbacks && e.emit("touchEnd", a),
    r.allowTouchCallbacks = !1,
    !r.isTouched) {
        r.isMoved && u.grabCursor && e.setGrabCursor(!1),
        r.isMoved = !1,
        r.startMoving = !1;
        return
    }
    u.grabCursor && r.isMoved && r.isTouched && (e.allowSlideNext === !0 || e.allowSlidePrev === !0) && e.setGrabCursor(!1);
    const v = zs()
      , y = v - r.touchStartTime;
    if (e.allowClick) {
        const M = a.path || a.composedPath && a.composedPath();
        e.updateClickedSlide(M && M[0] || a.target, M),
        e.emit("tap click", a),
        y < 300 && v - r.lastClickTime < 300 && e.emit("doubleTap doubleClick", a)
    }
    if (r.lastClickTime = zs(),
    c0( () => {
        e.destroyed || (e.allowClick = !0)
    }
    ),
    !r.isTouched || !r.isMoved || !e.swipeDirection || d.diff === 0 && !r.loopSwapReset || r.currentTranslate === r.startTranslate && !r.loopSwapReset) {
        r.isTouched = !1,
        r.isMoved = !1,
        r.startMoving = !1;
        return
    }
    r.isTouched = !1,
    r.isMoved = !1,
    r.startMoving = !1;
    let P;
    if (u.followFinger ? P = p ? e.translate : -e.translate : P = -r.currentTranslate,
    u.cssMode)
        return;
    if (u.freeMode && u.freeMode.enabled) {
        e.freeMode.onTouchEnd({
            currentPos: P
        });
        return
    }
    const w = P >= -e.maxTranslate() && !e.params.loop;
    let S = 0
      , z = e.slidesSizesGrid[0];
    for (let M = 0; M < h.length; M += M < u.slidesPerGroupSkip ? 1 : u.slidesPerGroup) {
        const B = M < u.slidesPerGroupSkip - 1 ? 1 : u.slidesPerGroup;
        typeof h[M + B] < "u" ? (w || P >= h[M] && P < h[M + B]) && (S = M,
        z = h[M + B] - h[M]) : (w || P >= h[M]) && (S = M,
        z = h[h.length - 1] - h[h.length - 2])
    }
    let C = null
      , b = null;
    u.rewind && (e.isBeginning ? b = u.virtual && u.virtual.enabled && e.virtual ? e.virtual.slides.length - 1 : e.slides.length - 1 : e.isEnd && (C = 0));
    const T = (P - h[S]) / z
      , D = S < u.slidesPerGroupSkip - 1 ? 1 : u.slidesPerGroup;
    if (y > u.longSwipesMs) {
        if (!u.longSwipes) {
            e.slideTo(e.activeIndex);
            return
        }
        e.swipeDirection === "next" && (T >= u.longSwipesRatio ? e.slideTo(u.rewind && e.isEnd ? C : S + D) : e.slideTo(S)),
        e.swipeDirection === "prev" && (T > 1 - u.longSwipesRatio ? e.slideTo(S + D) : b !== null && T < 0 && Math.abs(T) > u.longSwipesRatio ? e.slideTo(b) : e.slideTo(S))
    } else {
        if (!u.shortSwipes) {
            e.slideTo(e.activeIndex);
            return
        }
        e.navigation && (a.target === e.navigation.nextEl || a.target === e.navigation.prevEl) ? a.target === e.navigation.nextEl ? e.slideTo(S + D) : e.slideTo(S) : (e.swipeDirection === "next" && e.slideTo(C !== null ? C : S + D),
        e.swipeDirection === "prev" && e.slideTo(b !== null ? b : S))
    }
}
function ef() {
    const i = this
      , {params: e, el: r} = i;
    if (r && r.offsetWidth === 0)
        return;
    e.breakpoints && i.setBreakpoint();
    const {allowSlideNext: a, allowSlidePrev: o, snapGrid: l} = i
      , u = i.virtual && i.params.virtual.enabled;
    i.allowSlideNext = !0,
    i.allowSlidePrev = !0,
    i.updateSize(),
    i.updateSlides(),
    i.updateSlidesClasses();
    const d = u && e.loop;
    (e.slidesPerView === "auto" || e.slidesPerView > 1) && i.isEnd && !i.isBeginning && !i.params.centeredSlides && !d ? i.slideTo(i.slides.length - 1, 0, !1, !0) : i.params.loop && !u ? i.slideToLoop(i.realIndex, 0, !1, !0) : i.slideTo(i.activeIndex, 0, !1, !0),
    i.autoplay && i.autoplay.running && i.autoplay.paused && (clearTimeout(i.autoplay.resizeTimeout),
    i.autoplay.resizeTimeout = setTimeout( () => {
        i.autoplay && i.autoplay.running && i.autoplay.paused && i.autoplay.resume()
    }
    , 500)),
    i.allowSlidePrev = o,
    i.allowSlideNext = a,
    i.params.watchOverflow && l !== i.snapGrid && i.checkOverflow()
}
function Nb(i) {
    const e = this;
    e.enabled && (e.allowClick || (e.params.preventClicks && i.preventDefault(),
    e.params.preventClicksPropagation && e.animating && (i.stopPropagation(),
    i.stopImmediatePropagation())))
}
function Fb() {
    const i = this
      , {wrapperEl: e, rtlTranslate: r, enabled: a} = i;
    if (!a)
        return;
    i.previousTranslate = i.translate,
    i.isHorizontal() ? i.translate = -e.scrollLeft : i.translate = -e.scrollTop,
    i.translate === 0 && (i.translate = 0),
    i.updateActiveIndex(),
    i.updateSlidesClasses();
    let o;
    const l = i.maxTranslate() - i.minTranslate();
    l === 0 ? o = 0 : o = (i.translate - i.minTranslate()) / l,
    o !== i.progress && i.updateProgress(r ? -i.translate : i.translate),
    i.emit("setTranslate", i.translate, !1)
}
function Rb(i) {
    const e = this;
    xs(e, i.target),
    !(e.params.cssMode || e.params.slidesPerView !== "auto" && !e.params.autoHeight) && e.update()
}
function Bb() {
    const i = this;
    i.documentTouchHandlerProceeded || (i.documentTouchHandlerProceeded = !0,
    i.params.touchReleaseOnEdges && (i.el.style.touchAction = "auto"))
}
const g0 = (i, e) => {
    const r = Qi()
      , {params: a, el: o, wrapperEl: l, device: u} = i
      , d = !!a.nested
      , p = e === "on" ? "addEventListener" : "removeEventListener"
      , h = e;
    !o || typeof o == "string" || (r[p]("touchstart", i.onDocumentTouchStart, {
        passive: !1,
        capture: d
    }),
    o[p]("touchstart", i.onTouchStart, {
        passive: !1
    }),
    o[p]("pointerdown", i.onTouchStart, {
        passive: !1
    }),
    r[p]("touchmove", i.onTouchMove, {
        passive: !1,
        capture: d
    }),
    r[p]("pointermove", i.onTouchMove, {
        passive: !1,
        capture: d
    }),
    r[p]("touchend", i.onTouchEnd, {
        passive: !0
    }),
    r[p]("pointerup", i.onTouchEnd, {
        passive: !0
    }),
    r[p]("pointercancel", i.onTouchEnd, {
        passive: !0
    }),
    r[p]("touchcancel", i.onTouchEnd, {
        passive: !0
    }),
    r[p]("pointerout", i.onTouchEnd, {
        passive: !0
    }),
    r[p]("pointerleave", i.onTouchEnd, {
        passive: !0
    }),
    r[p]("contextmenu", i.onTouchEnd, {
        passive: !0
    }),
    (a.preventClicks || a.preventClicksPropagation) && o[p]("click", i.onClick, !0),
    a.cssMode && l[p]("scroll", i.onScroll),
    a.updateOnWindowResize ? i[h](u.ios || u.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", ef, !0) : i[h]("observerUpdate", ef, !0),
    o[p]("load", i.onLoad, {
        capture: !0
    }))
}
;
function Wb() {
    const i = this
      , {params: e} = i;
    i.onTouchStart = Vb.bind(i),
    i.onTouchMove = Lb.bind(i),
    i.onTouchEnd = Ob.bind(i),
    i.onDocumentTouchStart = Bb.bind(i),
    e.cssMode && (i.onScroll = Fb.bind(i)),
    i.onClick = Nb.bind(i),
    i.onLoad = Rb.bind(i),
    g0(i, "on")
}
function _b() {
    g0(this, "off")
}
var Ub = {
    attachEvents: Wb,
    detachEvents: _b
};
const tf = (i, e) => i.grid && e.grid && e.grid.rows > 1;
function Kb() {
    const i = this
      , {realIndex: e, initialized: r, params: a, el: o} = i
      , l = a.breakpoints;
    if (!l || l && Object.keys(l).length === 0)
        return;
    const u = Qi()
      , d = a.breakpointsBase === "window" || !a.breakpointsBase ? a.breakpointsBase : "container"
      , p = ["window", "container"].includes(a.breakpointsBase) || !a.breakpointsBase ? i.el : u.querySelector(a.breakpointsBase)
      , h = i.getBreakpoint(l, d, p);
    if (!h || i.currentBreakpoint === h)
        return;
    const v = (h in l ? l[h] : void 0) || i.originalParams
      , y = tf(i, a)
      , P = tf(i, v)
      , w = i.params.grabCursor
      , S = v.grabCursor
      , z = a.enabled;
    y && !P ? (o.classList.remove(`${a.containerModifierClass}grid`, `${a.containerModifierClass}grid-column`),
    i.emitContainerClasses()) : !y && P && (o.classList.add(`${a.containerModifierClass}grid`),
    (v.grid.fill && v.grid.fill === "column" || !v.grid.fill && a.grid.fill === "column") && o.classList.add(`${a.containerModifierClass}grid-column`),
    i.emitContainerClasses()),
    w && !S ? i.unsetGrabCursor() : !w && S && i.setGrabCursor(),
    ["navigation", "pagination", "scrollbar"].forEach(B => {
        if (typeof v[B] > "u")
            return;
        const _ = a[B] && a[B].enabled
          , F = v[B] && v[B].enabled;
        _ && !F && i[B].disable(),
        !_ && F && i[B].enable()
    }
    );
    const C = v.direction && v.direction !== a.direction
      , b = a.loop && (v.slidesPerView !== a.slidesPerView || C)
      , T = a.loop;
    C && r && i.changeDirection(),
    yt(i.params, v);
    const D = i.params.enabled
      , M = i.params.loop;
    Object.assign(i, {
        allowTouchMove: i.params.allowTouchMove,
        allowSlideNext: i.params.allowSlideNext,
        allowSlidePrev: i.params.allowSlidePrev
    }),
    z && !D ? i.disable() : !z && D && i.enable(),
    i.currentBreakpoint = h,
    i.emit("_beforeBreakpoint", v),
    r && (b ? (i.loopDestroy(),
    i.loopCreate(e),
    i.updateSlides()) : !T && M ? (i.loopCreate(e),
    i.updateSlides()) : T && !M && i.loopDestroy()),
    i.emit("breakpoint", v)
}
function $b(i, e, r) {
    if (e === void 0 && (e = "window"),
    !i || e === "container" && !r)
        return;
    let a = !1;
    const o = st()
      , l = e === "window" ? o.innerHeight : r.clientHeight
      , u = Object.keys(i).map(d => {
        if (typeof d == "string" && d.indexOf("@") === 0) {
            const p = parseFloat(d.substr(1));
            return {
                value: l * p,
                point: d
            }
        }
        return {
            value: d,
            point: d
        }
    }
    );
    u.sort( (d, p) => parseInt(d.value, 10) - parseInt(p.value, 10));
    for (let d = 0; d < u.length; d += 1) {
        const {point: p, value: h} = u[d];
        e === "window" ? o.matchMedia(`(min-width: ${h}px)`).matches && (a = p) : h <= r.clientWidth && (a = p)
    }
    return a || "max"
}
var Hb = {
    setBreakpoint: Kb,
    getBreakpoint: $b
};
function Gb(i, e) {
    const r = [];
    return i.forEach(a => {
        typeof a == "object" ? Object.keys(a).forEach(o => {
            a[o] && r.push(e + o)
        }
        ) : typeof a == "string" && r.push(e + a)
    }
    ),
    r
}
function qb() {
    const i = this
      , {classNames: e, params: r, rtl: a, el: o, device: l} = i
      , u = Gb(["initialized", r.direction, {
        "free-mode": i.params.freeMode && r.freeMode.enabled
    }, {
        autoheight: r.autoHeight
    }, {
        rtl: a
    }, {
        grid: r.grid && r.grid.rows > 1
    }, {
        "grid-column": r.grid && r.grid.rows > 1 && r.grid.fill === "column"
    }, {
        android: l.android
    }, {
        ios: l.ios
    }, {
        "css-mode": r.cssMode
    }, {
        centered: r.cssMode && r.centeredSlides
    }, {
        "watch-progress": r.watchSlidesProgress
    }], r.containerModifierClass);
    e.push(...u),
    o.classList.add(...e),
    i.emitContainerClasses()
}
function Xb() {
    const i = this
      , {el: e, classNames: r} = i;
    !e || typeof e == "string" || (e.classList.remove(...r),
    i.emitContainerClasses())
}
var Zb = {
    addClasses: qb,
    removeClasses: Xb
};
function Yb() {
    const i = this
      , {isLocked: e, params: r} = i
      , {slidesOffsetBefore: a} = r;
    if (a) {
        const o = i.slides.length - 1
          , l = i.slidesGrid[o] + i.slidesSizesGrid[o] + a * 2;
        i.isLocked = i.size > l
    } else
        i.isLocked = i.snapGrid.length === 1;
    r.allowSlideNext === !0 && (i.allowSlideNext = !i.isLocked),
    r.allowSlidePrev === !0 && (i.allowSlidePrev = !i.isLocked),
    e && e !== i.isLocked && (i.isEnd = !1),
    e !== i.isLocked && i.emit(i.isLocked ? "lock" : "unlock")
}
var Qb = {
    checkOverflow: Yb
}
  , Vc = {
    init: !0,
    direction: "horizontal",
    oneWayMovement: !1,
    swiperElementNodeName: "SWIPER-CONTAINER",
    touchEventsTarget: "wrapper",
    initialSlide: 0,
    speed: 300,
    cssMode: !1,
    updateOnWindowResize: !0,
    resizeObserver: !0,
    nested: !1,
    createElements: !1,
    eventsPrefix: "swiper",
    enabled: !0,
    focusableElements: "input, select, option, textarea, button, video, label",
    width: null,
    height: null,
    preventInteractionOnTransition: !1,
    userAgent: null,
    url: null,
    edgeSwipeDetection: !1,
    edgeSwipeThreshold: 20,
    autoHeight: !1,
    setWrapperSize: !1,
    virtualTranslate: !1,
    effect: "slide",
    breakpoints: void 0,
    breakpointsBase: "window",
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: !1,
    centeredSlides: !1,
    centeredSlidesBounds: !1,
    slidesOffsetBefore: 0,
    slidesOffsetAfter: 0,
    normalizeSlideIndex: !0,
    centerInsufficientSlides: !1,
    watchOverflow: !0,
    roundLengths: !1,
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: !0,
    shortSwipes: !0,
    longSwipes: !0,
    longSwipesRatio: .5,
    longSwipesMs: 300,
    followFinger: !0,
    allowTouchMove: !0,
    threshold: 5,
    touchMoveStopPropagation: !1,
    touchStartPreventDefault: !0,
    touchStartForcePreventDefault: !1,
    touchReleaseOnEdges: !1,
    uniqueNavElements: !0,
    resistance: !0,
    resistanceRatio: .85,
    watchSlidesProgress: !1,
    grabCursor: !1,
    preventClicks: !0,
    preventClicksPropagation: !0,
    slideToClickedSlide: !1,
    loop: !1,
    loopAddBlankSlides: !0,
    loopAdditionalSlides: 0,
    loopPreventsSliding: !0,
    rewind: !1,
    allowSlidePrev: !0,
    allowSlideNext: !0,
    swipeHandler: null,
    noSwiping: !0,
    noSwipingClass: "swiper-no-swiping",
    noSwipingSelector: null,
    passiveListeners: !0,
    maxBackfaceHiddenSlides: 10,
    containerModifierClass: "swiper-",
    slideClass: "swiper-slide",
    slideBlankClass: "swiper-slide-blank",
    slideActiveClass: "swiper-slide-active",
    slideVisibleClass: "swiper-slide-visible",
    slideFullyVisibleClass: "swiper-slide-fully-visible",
    slideNextClass: "swiper-slide-next",
    slidePrevClass: "swiper-slide-prev",
    wrapperClass: "swiper-wrapper",
    lazyPreloaderClass: "swiper-lazy-preloader",
    lazyPreloadPrevNext: 0,
    runCallbacksOnInit: !0,
    _emitClasses: !1
};
function Jb(i, e) {
    return function(a) {
        a === void 0 && (a = {});
        const o = Object.keys(a)[0]
          , l = a[o];
        if (typeof l != "object" || l === null) {
            yt(e, a);
            return
        }
        if (i[o] === !0 && (i[o] = {
            enabled: !0
        }),
        o === "navigation" && i[o] && i[o].enabled && !i[o].prevEl && !i[o].nextEl && (i[o].auto = !0),
        ["pagination", "scrollbar"].indexOf(o) >= 0 && i[o] && i[o].enabled && !i[o].el && (i[o].auto = !0),
        !(o in i && "enabled"in l)) {
            yt(e, a);
            return
        }
        typeof i[o] == "object" && !("enabled"in i[o]) && (i[o].enabled = !0),
        i[o] || (i[o] = {
            enabled: !1
        }),
        yt(e, a)
    }
}
const cc = {
    eventsEmitter: ZP,
    update: ob,
    translate: mb,
    transition: vb,
    slide: Tb,
    loop: Ab,
    grabCursor: Ib,
    events: Ub,
    breakpoints: Hb,
    checkOverflow: Qb,
    classes: Zb
}
  , uc = {};
let xu = class ti {
    constructor() {
        let e, r;
        for (var a = arguments.length, o = new Array(a), l = 0; l < a; l++)
            o[l] = arguments[l];
        o.length === 1 && o[0].constructor && Object.prototype.toString.call(o[0]).slice(8, -1) === "Object" ? r = o[0] : [e,r] = o,
        r || (r = {}),
        r = yt({}, r),
        e && !r.el && (r.el = e);
        const u = Qi();
        if (r.el && typeof r.el == "string" && u.querySelectorAll(r.el).length > 1) {
            const g = [];
            return u.querySelectorAll(r.el).forEach(v => {
                const y = yt({}, r, {
                    el: v
                });
                g.push(new ti(y))
            }
            ),
            g
        }
        const d = this;
        d.__swiper__ = !0,
        d.support = p0(),
        d.device = m0({
            userAgent: r.userAgent
        }),
        d.browser = h0(),
        d.eventsListeners = {},
        d.eventsAnyListeners = [],
        d.modules = [...d.__modules__],
        r.modules && Array.isArray(r.modules) && d.modules.push(...r.modules);
        const p = {};
        d.modules.forEach(g => {
            g({
                params: r,
                swiper: d,
                extendParams: Jb(r, p),
                on: d.on.bind(d),
                once: d.once.bind(d),
                off: d.off.bind(d),
                emit: d.emit.bind(d)
            })
        }
        );
        const h = yt({}, Vc, p);
        return d.params = yt({}, h, uc, r),
        d.originalParams = yt({}, d.params),
        d.passedParams = yt({}, r),
        d.params && d.params.on && Object.keys(d.params.on).forEach(g => {
            d.on(g, d.params.on[g])
        }
        ),
        d.params && d.params.onAny && d.onAny(d.params.onAny),
        Object.assign(d, {
            enabled: d.params.enabled,
            el: e,
            classNames: [],
            slides: [],
            slidesGrid: [],
            snapGrid: [],
            slidesSizesGrid: [],
            isHorizontal() {
                return d.params.direction === "horizontal"
            },
            isVertical() {
                return d.params.direction === "vertical"
            },
            activeIndex: 0,
            realIndex: 0,
            isBeginning: !0,
            isEnd: !1,
            translate: 0,
            previousTranslate: 0,
            progress: 0,
            velocity: 0,
            animating: !1,
            cssOverflowAdjustment() {
                return Math.trunc(this.translate / 2 ** 23) * 2 ** 23
            },
            allowSlideNext: d.params.allowSlideNext,
            allowSlidePrev: d.params.allowSlidePrev,
            touchEventsData: {
                isTouched: void 0,
                isMoved: void 0,
                allowTouchCallbacks: void 0,
                touchStartTime: void 0,
                isScrolling: void 0,
                currentTranslate: void 0,
                startTranslate: void 0,
                allowThresholdMove: void 0,
                focusableElements: d.params.focusableElements,
                lastClickTime: 0,
                clickTimeout: void 0,
                velocities: [],
                allowMomentumBounce: void 0,
                startMoving: void 0,
                pointerId: null,
                touchId: null
            },
            allowClick: !0,
            allowTouchMove: d.params.allowTouchMove,
            touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0
            },
            imagesToLoad: [],
            imagesLoaded: 0
        }),
        d.emit("_swiper"),
        d.params.init && d.init(),
        d
    }
    getDirectionLabel(e) {
        return this.isHorizontal() ? e : {
            width: "height",
            "margin-top": "margin-left",
            "margin-bottom ": "margin-right",
            "margin-left": "margin-top",
            "margin-right": "margin-bottom",
            "padding-left": "padding-top",
            "padding-right": "padding-bottom",
            marginRight: "marginBottom"
        }[e]
    }
    getSlideIndex(e) {
        const {slidesEl: r, params: a} = this
          , o = _t(r, `.${a.slideClass}, swiper-slide`)
          , l = Ds(o[0]);
        return Ds(e) - l
    }
    getSlideIndexByData(e) {
        return this.getSlideIndex(this.slides.find(r => r.getAttribute("data-swiper-slide-index") * 1 === e))
    }
    getSlideIndexWhenGrid(e) {
        return this.grid && this.params.grid && this.params.grid.rows > 1 && (this.params.grid.fill === "column" ? e = Math.floor(e / this.params.grid.rows) : this.params.grid.fill === "row" && (e = e % Math.ceil(this.slides.length / this.params.grid.rows))),
        e
    }
    recalcSlides() {
        const e = this
          , {slidesEl: r, params: a} = e;
        e.slides = _t(r, `.${a.slideClass}, swiper-slide`)
    }
    enable() {
        const e = this;
        e.enabled || (e.enabled = !0,
        e.params.grabCursor && e.setGrabCursor(),
        e.emit("enable"))
    }
    disable() {
        const e = this;
        e.enabled && (e.enabled = !1,
        e.params.grabCursor && e.unsetGrabCursor(),
        e.emit("disable"))
    }
    setProgress(e, r) {
        const a = this;
        e = Math.min(Math.max(e, 0), 1);
        const o = a.minTranslate()
          , u = (a.maxTranslate() - o) * e + o;
        a.translateTo(u, typeof r > "u" ? 0 : r),
        a.updateActiveIndex(),
        a.updateSlidesClasses()
    }
    emitContainerClasses() {
        const e = this;
        if (!e.params._emitClasses || !e.el)
            return;
        const r = e.el.className.split(" ").filter(a => a.indexOf("swiper") === 0 || a.indexOf(e.params.containerModifierClass) === 0);
        e.emit("_containerClasses", r.join(" "))
    }
    getSlideClasses(e) {
        const r = this;
        return r.destroyed ? "" : e.className.split(" ").filter(a => a.indexOf("swiper-slide") === 0 || a.indexOf(r.params.slideClass) === 0).join(" ")
    }
    emitSlidesClasses() {
        const e = this;
        if (!e.params._emitClasses || !e.el)
            return;
        const r = [];
        e.slides.forEach(a => {
            const o = e.getSlideClasses(a);
            r.push({
                slideEl: a,
                classNames: o
            }),
            e.emit("_slideClass", a, o)
        }
        ),
        e.emit("_slideClasses", r)
    }
    slidesPerViewDynamic(e, r) {
        e === void 0 && (e = "current"),
        r === void 0 && (r = !1);
        const a = this
          , {params: o, slides: l, slidesGrid: u, slidesSizesGrid: d, size: p, activeIndex: h} = a;
        let g = 1;
        if (typeof o.slidesPerView == "number")
            return o.slidesPerView;
        if (o.centeredSlides) {
            let v = l[h] ? Math.ceil(l[h].swiperSlideSize) : 0, y;
            for (let P = h + 1; P < l.length; P += 1)
                l[P] && !y && (v += Math.ceil(l[P].swiperSlideSize),
                g += 1,
                v > p && (y = !0));
            for (let P = h - 1; P >= 0; P -= 1)
                l[P] && !y && (v += l[P].swiperSlideSize,
                g += 1,
                v > p && (y = !0))
        } else if (e === "current")
            for (let v = h + 1; v < l.length; v += 1)
                (r ? u[v] + d[v] - u[h] < p : u[v] - u[h] < p) && (g += 1);
        else
            for (let v = h - 1; v >= 0; v -= 1)
                u[h] - u[v] < p && (g += 1);
        return g
    }
    update() {
        const e = this;
        if (!e || e.destroyed)
            return;
        const {snapGrid: r, params: a} = e;
        a.breakpoints && e.setBreakpoint(),
        [...e.el.querySelectorAll('[loading="lazy"]')].forEach(u => {
            u.complete && xs(e, u)
        }
        ),
        e.updateSize(),
        e.updateSlides(),
        e.updateProgress(),
        e.updateSlidesClasses();
        function o() {
            const u = e.rtlTranslate ? e.translate * -1 : e.translate
              , d = Math.min(Math.max(u, e.maxTranslate()), e.minTranslate());
            e.setTranslate(d),
            e.updateActiveIndex(),
            e.updateSlidesClasses()
        }
        let l;
        if (a.freeMode && a.freeMode.enabled && !a.cssMode)
            o(),
            a.autoHeight && e.updateAutoHeight();
        else {
            if ((a.slidesPerView === "auto" || a.slidesPerView > 1) && e.isEnd && !a.centeredSlides) {
                const u = e.virtual && a.virtual.enabled ? e.virtual.slides : e.slides;
                l = e.slideTo(u.length - 1, 0, !1, !0)
            } else
                l = e.slideTo(e.activeIndex, 0, !1, !0);
            l || o()
        }
        a.watchOverflow && r !== e.snapGrid && e.checkOverflow(),
        e.emit("update")
    }
    changeDirection(e, r) {
        r === void 0 && (r = !0);
        const a = this
          , o = a.params.direction;
        return e || (e = o === "horizontal" ? "vertical" : "horizontal"),
        e === o || e !== "horizontal" && e !== "vertical" || (a.el.classList.remove(`${a.params.containerModifierClass}${o}`),
        a.el.classList.add(`${a.params.containerModifierClass}${e}`),
        a.emitContainerClasses(),
        a.params.direction = e,
        a.slides.forEach(l => {
            e === "vertical" ? l.style.width = "" : l.style.height = ""
        }
        ),
        a.emit("changeDirection"),
        r && a.update()),
        a
    }
    changeLanguageDirection(e) {
        const r = this;
        r.rtl && e === "rtl" || !r.rtl && e === "ltr" || (r.rtl = e === "rtl",
        r.rtlTranslate = r.params.direction === "horizontal" && r.rtl,
        r.rtl ? (r.el.classList.add(`${r.params.containerModifierClass}rtl`),
        r.el.dir = "rtl") : (r.el.classList.remove(`${r.params.containerModifierClass}rtl`),
        r.el.dir = "ltr"),
        r.update())
    }
    mount(e) {
        const r = this;
        if (r.mounted)
            return !0;
        let a = e || r.params.el;
        if (typeof a == "string" && (a = document.querySelector(a)),
        !a)
            return !1;
        a.swiper = r,
        a.parentNode && a.parentNode.host && a.parentNode.host.nodeName === r.params.swiperElementNodeName.toUpperCase() && (r.isElement = !0);
        const o = () => `.${(r.params.wrapperClass || "").trim().split(" ").join(".")}`;
        let u = a && a.shadowRoot && a.shadowRoot.querySelector ? a.shadowRoot.querySelector(o()) : _t(a, o())[0];
        return !u && r.params.createElements && (u = Es("div", r.params.wrapperClass),
        a.append(u),
        _t(a, `.${r.params.slideClass}`).forEach(d => {
            u.append(d)
        }
        )),
        Object.assign(r, {
            el: a,
            wrapperEl: u,
            slidesEl: r.isElement && !a.parentNode.host.slideSlots ? a.parentNode.host : u,
            hostEl: r.isElement ? a.parentNode.host : a,
            mounted: !0,
            rtl: a.dir.toLowerCase() === "rtl" || Ci(a, "direction") === "rtl",
            rtlTranslate: r.params.direction === "horizontal" && (a.dir.toLowerCase() === "rtl" || Ci(a, "direction") === "rtl"),
            wrongRTL: Ci(u, "display") === "-webkit-box"
        }),
        !0
    }
    init(e) {
        const r = this;
        if (r.initialized || r.mount(e) === !1)
            return r;
        r.emit("beforeInit"),
        r.params.breakpoints && r.setBreakpoint(),
        r.addClasses(),
        r.updateSize(),
        r.updateSlides(),
        r.params.watchOverflow && r.checkOverflow(),
        r.params.grabCursor && r.enabled && r.setGrabCursor(),
        r.params.loop && r.virtual && r.params.virtual.enabled ? r.slideTo(r.params.initialSlide + r.virtual.slidesBefore, 0, r.params.runCallbacksOnInit, !1, !0) : r.slideTo(r.params.initialSlide, 0, r.params.runCallbacksOnInit, !1, !0),
        r.params.loop && r.loopCreate(void 0, !0),
        r.attachEvents();
        const o = [...r.el.querySelectorAll('[loading="lazy"]')];
        return r.isElement && o.push(...r.hostEl.querySelectorAll('[loading="lazy"]')),
        o.forEach(l => {
            l.complete ? xs(r, l) : l.addEventListener("load", u => {
                xs(r, u.target)
            }
            )
        }
        ),
        Mc(r),
        r.initialized = !0,
        Mc(r),
        r.emit("init"),
        r.emit("afterInit"),
        r
    }
    destroy(e, r) {
        e === void 0 && (e = !0),
        r === void 0 && (r = !0);
        const a = this
          , {params: o, el: l, wrapperEl: u, slides: d} = a;
        return typeof a.params > "u" || a.destroyed || (a.emit("beforeDestroy"),
        a.initialized = !1,
        a.detachEvents(),
        o.loop && a.loopDestroy(),
        r && (a.removeClasses(),
        l && typeof l != "string" && l.removeAttribute("style"),
        u && u.removeAttribute("style"),
        d && d.length && d.forEach(p => {
            p.classList.remove(o.slideVisibleClass, o.slideFullyVisibleClass, o.slideActiveClass, o.slideNextClass, o.slidePrevClass),
            p.removeAttribute("style"),
            p.removeAttribute("data-swiper-slide-index")
        }
        )),
        a.emit("destroy"),
        Object.keys(a.eventsListeners).forEach(p => {
            a.off(p)
        }
        ),
        e !== !1 && (a.el && typeof a.el != "string" && (a.el.swiper = null),
        NP(a)),
        a.destroyed = !0),
        null
    }
    static extendDefaults(e) {
        yt(uc, e)
    }
    static get extendedDefaults() {
        return uc
    }
    static get defaults() {
        return Vc
    }
    static installModule(e) {
        ti.prototype.__modules__ || (ti.prototype.__modules__ = []);
        const r = ti.prototype.__modules__;
        typeof e == "function" && r.indexOf(e) < 0 && r.push(e)
    }
    static use(e) {
        return Array.isArray(e) ? (e.forEach(r => ti.installModule(r)),
        ti) : (ti.installModule(e),
        ti)
    }
}
;
Object.keys(cc).forEach(i => {
    Object.keys(cc[i]).forEach(e => {
        xu.prototype[e] = cc[i][e]
    }
    )
}
);
xu.use([qP, XP]);
const v0 = ["eventsPrefix", "injectStyles", "injectStylesUrls", "modules", "init", "_direction", "oneWayMovement", "swiperElementNodeName", "touchEventsTarget", "initialSlide", "_speed", "cssMode", "updateOnWindowResize", "resizeObserver", "nested", "focusableElements", "_enabled", "_width", "_height", "preventInteractionOnTransition", "userAgent", "url", "_edgeSwipeDetection", "_edgeSwipeThreshold", "_freeMode", "_autoHeight", "setWrapperSize", "virtualTranslate", "_effect", "breakpoints", "breakpointsBase", "_spaceBetween", "_slidesPerView", "maxBackfaceHiddenSlides", "_grid", "_slidesPerGroup", "_slidesPerGroupSkip", "_slidesPerGroupAuto", "_centeredSlides", "_centeredSlidesBounds", "_slidesOffsetBefore", "_slidesOffsetAfter", "normalizeSlideIndex", "_centerInsufficientSlides", "_watchOverflow", "roundLengths", "touchRatio", "touchAngle", "simulateTouch", "_shortSwipes", "_longSwipes", "longSwipesRatio", "longSwipesMs", "_followFinger", "allowTouchMove", "_threshold", "touchMoveStopPropagation", "touchStartPreventDefault", "touchStartForcePreventDefault", "touchReleaseOnEdges", "uniqueNavElements", "_resistance", "_resistanceRatio", "_watchSlidesProgress", "_grabCursor", "preventClicks", "preventClicksPropagation", "_slideToClickedSlide", "_loop", "loopAdditionalSlides", "loopAddBlankSlides", "loopPreventsSliding", "_rewind", "_allowSlidePrev", "_allowSlideNext", "_swipeHandler", "_noSwiping", "noSwipingClass", "noSwipingSelector", "passiveListeners", "containerModifierClass", "slideClass", "slideActiveClass", "slideVisibleClass", "slideFullyVisibleClass", "slideNextClass", "slidePrevClass", "slideBlankClass", "wrapperClass", "lazyPreloaderClass", "lazyPreloadPrevNext", "runCallbacksOnInit", "observer", "observeParents", "observeSlideChildren", "a11y", "_autoplay", "_controller", "coverflowEffect", "cubeEffect", "fadeEffect", "flipEffect", "creativeEffect", "cardsEffect", "hashNavigation", "history", "keyboard", "mousewheel", "_navigation", "_pagination", "parallax", "_scrollbar", "_thumbs", "virtual", "zoom", "control"];
function Zi(i) {
    return typeof i == "object" && i !== null && i.constructor && Object.prototype.toString.call(i).slice(8, -1) === "Object" && !i.__swiper__
}
function Mr(i, e) {
    const r = ["__proto__", "constructor", "prototype"];
    Object.keys(e).filter(a => r.indexOf(a) < 0).forEach(a => {
        typeof i[a] > "u" ? i[a] = e[a] : Zi(e[a]) && Zi(i[a]) && Object.keys(e[a]).length > 0 ? e[a].__swiper__ ? i[a] = e[a] : Mr(i[a], e[a]) : i[a] = e[a]
    }
    )
}
function y0(i) {
    return i === void 0 && (i = {}),
    i.navigation && typeof i.navigation.nextEl > "u" && typeof i.navigation.prevEl > "u"
}
function k0(i) {
    return i === void 0 && (i = {}),
    i.pagination && typeof i.pagination.el > "u"
}
function x0(i) {
    return i === void 0 && (i = {}),
    i.scrollbar && typeof i.scrollbar.el > "u"
}
function w0(i) {
    i === void 0 && (i = "");
    const e = i.split(" ").map(a => a.trim()).filter(a => !!a)
      , r = [];
    return e.forEach(a => {
        r.indexOf(a) < 0 && r.push(a)
    }
    ),
    r.join(" ")
}
function eS(i) {
    return i === void 0 && (i = ""),
    i ? i.includes("swiper-wrapper") ? i : `swiper-wrapper ${i}` : "swiper-wrapper"
}
function tS(i) {
    let {swiper: e, slides: r, passedParams: a, changedParams: o, nextEl: l, prevEl: u, scrollbarEl: d, paginationEl: p} = i;
    const h = o.filter(R => R !== "children" && R !== "direction" && R !== "wrapperClass")
      , {params: g, pagination: v, navigation: y, scrollbar: P, virtual: w, thumbs: S} = e;
    let z, C, b, T, D, M, B, _;
    o.includes("thumbs") && a.thumbs && a.thumbs.swiper && !a.thumbs.swiper.destroyed && g.thumbs && (!g.thumbs.swiper || g.thumbs.swiper.destroyed) && (z = !0),
    o.includes("controller") && a.controller && a.controller.control && g.controller && !g.controller.control && (C = !0),
    o.includes("pagination") && a.pagination && (a.pagination.el || p) && (g.pagination || g.pagination === !1) && v && !v.el && (b = !0),
    o.includes("scrollbar") && a.scrollbar && (a.scrollbar.el || d) && (g.scrollbar || g.scrollbar === !1) && P && !P.el && (T = !0),
    o.includes("navigation") && a.navigation && (a.navigation.prevEl || u) && (a.navigation.nextEl || l) && (g.navigation || g.navigation === !1) && y && !y.prevEl && !y.nextEl && (D = !0);
    const F = R => {
        e[R] && (e[R].destroy(),
        R === "navigation" ? (e.isElement && (e[R].prevEl.remove(),
        e[R].nextEl.remove()),
        g[R].prevEl = void 0,
        g[R].nextEl = void 0,
        e[R].prevEl = void 0,
        e[R].nextEl = void 0) : (e.isElement && e[R].el.remove(),
        g[R].el = void 0,
        e[R].el = void 0))
    }
    ;
    o.includes("loop") && e.isElement && (g.loop && !a.loop ? M = !0 : !g.loop && a.loop ? B = !0 : _ = !0),
    h.forEach(R => {
        if (Zi(g[R]) && Zi(a[R]))
            Object.assign(g[R], a[R]),
            (R === "navigation" || R === "pagination" || R === "scrollbar") && "enabled"in a[R] && !a[R].enabled && F(R);
        else {
            const W = a[R];
            (W === !0 || W === !1) && (R === "navigation" || R === "pagination" || R === "scrollbar") ? W === !1 && F(R) : g[R] = a[R]
        }
    }
    ),
    h.includes("controller") && !C && e.controller && e.controller.control && g.controller && g.controller.control && (e.controller.control = g.controller.control),
    o.includes("children") && r && w && g.virtual.enabled ? (w.slides = r,
    w.update(!0)) : o.includes("virtual") && w && g.virtual.enabled && (r && (w.slides = r),
    w.update(!0)),
    o.includes("children") && r && g.loop && (_ = !0),
    z && S.init() && S.update(!0),
    C && (e.controller.control = g.controller.control),
    b && (e.isElement && (!p || typeof p == "string") && (p = document.createElement("div"),
    p.classList.add("swiper-pagination"),
    p.part.add("pagination"),
    e.el.appendChild(p)),
    p && (g.pagination.el = p),
    v.init(),
    v.render(),
    v.update()),
    T && (e.isElement && (!d || typeof d == "string") && (d = document.createElement("div"),
    d.classList.add("swiper-scrollbar"),
    d.part.add("scrollbar"),
    e.el.appendChild(d)),
    d && (g.scrollbar.el = d),
    P.init(),
    P.updateSize(),
    P.setTranslate()),
    D && (e.isElement && ((!l || typeof l == "string") && (l = document.createElement("div"),
    l.classList.add("swiper-button-next"),
    Is(l, e.hostEl.constructor.nextButtonSvg),
    l.part.add("button-next"),
    e.el.appendChild(l)),
    (!u || typeof u == "string") && (u = document.createElement("div"),
    u.classList.add("swiper-button-prev"),
    Is(u, e.hostEl.constructor.prevButtonSvg),
    u.part.add("button-prev"),
    e.el.appendChild(u))),
    l && (g.navigation.nextEl = l),
    u && (g.navigation.prevEl = u),
    y.init(),
    y.update()),
    o.includes("allowSlideNext") && (e.allowSlideNext = a.allowSlideNext),
    o.includes("allowSlidePrev") && (e.allowSlidePrev = a.allowSlidePrev),
    o.includes("direction") && e.changeDirection(a.direction, !1),
    (M || _) && e.loopDestroy(),
    (B || _) && e.loopCreate(),
    e.update()
}
function iS(i, e) {
    i === void 0 && (i = {}),
    e === void 0 && (e = !0);
    const r = {
        on: {}
    }
      , a = {}
      , o = {};
    Mr(r, Vc),
    r._emitClasses = !0,
    r.init = !1;
    const l = {}
      , u = v0.map(p => p.replace(/_/, ""))
      , d = Object.assign({}, i);
    return Object.keys(d).forEach(p => {
        typeof i[p] > "u" || (u.indexOf(p) >= 0 ? Zi(i[p]) ? (r[p] = {},
        o[p] = {},
        Mr(r[p], i[p]),
        Mr(o[p], i[p])) : (r[p] = i[p],
        o[p] = i[p]) : p.search(/on[A-Z]/) === 0 && typeof i[p] == "function" ? e ? a[`${p[2].toLowerCase()}${p.substr(3)}`] = i[p] : r.on[`${p[2].toLowerCase()}${p.substr(3)}`] = i[p] : l[p] = i[p])
    }
    ),
    ["navigation", "pagination", "scrollbar"].forEach(p => {
        r[p] === !0 && (r[p] = {}),
        r[p] === !1 && delete r[p]
    }
    ),
    {
        params: r,
        passedParams: o,
        rest: l,
        events: a
    }
}
function rS(i, e) {
    let {el: r, nextEl: a, prevEl: o, paginationEl: l, scrollbarEl: u, swiper: d} = i;
    y0(e) && a && o && (d.params.navigation.nextEl = a,
    d.originalParams.navigation.nextEl = a,
    d.params.navigation.prevEl = o,
    d.originalParams.navigation.prevEl = o),
    k0(e) && l && (d.params.pagination.el = l,
    d.originalParams.pagination.el = l),
    x0(e) && u && (d.params.scrollbar.el = u,
    d.originalParams.scrollbar.el = u),
    d.init(r)
}
function nS(i, e, r, a, o) {
    const l = [];
    if (!e)
        return l;
    const u = p => {
        l.indexOf(p) < 0 && l.push(p)
    }
    ;
    if (r && a) {
        const p = a.map(o)
          , h = r.map(o);
        p.join("") !== h.join("") && u("children"),
        a.length !== r.length && u("children")
    }
    return v0.filter(p => p[0] === "_").map(p => p.replace(/_/, "")).forEach(p => {
        if (p in i && p in e)
            if (Zi(i[p]) && Zi(e[p])) {
                const h = Object.keys(i[p])
                  , g = Object.keys(e[p]);
                h.length !== g.length ? u(p) : (h.forEach(v => {
                    i[p][v] !== e[p][v] && u(p)
                }
                ),
                g.forEach(v => {
                    i[p][v] !== e[p][v] && u(p)
                }
                ))
            } else
                i[p] !== e[p] && u(p)
    }
    ),
    l
}
const aS = i => {
    !i || i.destroyed || !i.params.virtual || i.params.virtual && !i.params.virtual.enabled || (i.updateSlides(),
    i.updateProgress(),
    i.updateSlidesClasses(),
    i.emit("_virtualUpdated"),
    i.parallax && i.params.parallax && i.params.parallax.enabled && i.parallax.setTranslate())
}
;
function Ms() {
    return Ms = Object.assign ? Object.assign.bind() : function(i) {
        for (var e = 1; e < arguments.length; e++) {
            var r = arguments[e];
            for (var a in r)
                Object.prototype.hasOwnProperty.call(r, a) && (i[a] = r[a])
        }
        return i
    }
    ,
    Ms.apply(this, arguments)
}
function P0(i) {
    return i.type && i.type.displayName && i.type.displayName.includes("SwiperSlide")
}
function b0(i) {
    const e = [];
    return Me.Children.toArray(i).forEach(r => {
        P0(r) ? e.push(r) : r.props && r.props.children && b0(r.props.children).forEach(a => e.push(a))
    }
    ),
    e
}
function sS(i) {
    const e = []
      , r = {
        "container-start": [],
        "container-end": [],
        "wrapper-start": [],
        "wrapper-end": []
    };
    return Me.Children.toArray(i).forEach(a => {
        if (P0(a))
            e.push(a);
        else if (a.props && a.props.slot && r[a.props.slot])
            r[a.props.slot].push(a);
        else if (a.props && a.props.children) {
            const o = b0(a.props.children);
            o.length > 0 ? o.forEach(l => e.push(l)) : r["container-end"].push(a)
        } else
            r["container-end"].push(a)
    }
    ),
    {
        slides: e,
        slots: r
    }
}
function oS(i, e, r) {
    if (!r)
        return null;
    const a = g => {
        let v = g;
        return g < 0 ? v = e.length + g : v >= e.length && (v = v - e.length),
        v
    }
      , o = i.isHorizontal() ? {
        [i.rtlTranslate ? "right" : "left"]: `${r.offset}px`
    } : {
        top: `${r.offset}px`
    }
      , {from: l, to: u} = r
      , d = i.params.loop ? -e.length : 0
      , p = i.params.loop ? e.length * 2 : e.length
      , h = [];
    for (let g = d; g < p; g += 1)
        g >= l && g <= u && h.push(e[a(g)]);
    return h.map( (g, v) => Me.cloneElement(g, {
        swiper: i,
        style: o,
        key: g.props.virtualIndex || g.key || `slide-${v}`
    }))
}
function On(i, e) {
    return typeof window > "u" ? N.useEffect(i, e) : N.useLayoutEffect(i, e)
}
const rf = N.createContext(null)
  , lS = N.createContext(null)
  , S0 = N.forwardRef(function(i, e) {
    let {className: r, tag: a="div", wrapperTag: o="div", children: l, onSwiper: u, ...d} = i === void 0 ? {} : i
      , p = !1;
    const [h,g] = N.useState("swiper")
      , [v,y] = N.useState(null)
      , [P,w] = N.useState(!1)
      , S = N.useRef(!1)
      , z = N.useRef(null)
      , C = N.useRef(null)
      , b = N.useRef(null)
      , T = N.useRef(null)
      , D = N.useRef(null)
      , M = N.useRef(null)
      , B = N.useRef(null)
      , _ = N.useRef(null)
      , {params: F, passedParams: R, rest: W, events: K} = iS(d)
      , {slides: Q, slots: se} = sS(l)
      , le = () => {
        w(!P)
    }
    ;
    Object.assign(F.on, {
        _containerClasses(X, Z) {
            g(Z)
        }
    });
    const pe = () => {
        Object.assign(F.on, K),
        p = !0;
        const X = {
            ...F
        };
        if (delete X.wrapperClass,
        C.current = new xu(X),
        C.current.virtual && C.current.params.virtual.enabled) {
            C.current.virtual.slides = Q;
            const Z = {
                cache: !1,
                slides: Q,
                renderExternal: y,
                renderExternalUpdate: !1
            };
            Mr(C.current.params.virtual, Z),
            Mr(C.current.originalParams.virtual, Z)
        }
    }
    ;
    z.current || pe(),
    C.current && C.current.on("_beforeBreakpoint", le);
    const ie = () => {
        p || !K || !C.current || Object.keys(K).forEach(X => {
            C.current.on(X, K[X])
        }
        )
    }
      , ne = () => {
        !K || !C.current || Object.keys(K).forEach(X => {
            C.current.off(X, K[X])
        }
        )
    }
    ;
    N.useEffect( () => () => {
        C.current && C.current.off("_beforeBreakpoint", le)
    }
    ),
    N.useEffect( () => {
        !S.current && C.current && (C.current.emitSlidesClasses(),
        S.current = !0)
    }
    ),
    On( () => {
        if (e && (e.current = z.current),
        !!z.current)
            return C.current.destroyed && pe(),
            rS({
                el: z.current,
                nextEl: D.current,
                prevEl: M.current,
                paginationEl: B.current,
                scrollbarEl: _.current,
                swiper: C.current
            }, F),
            u && !C.current.destroyed && u(C.current),
            () => {
                C.current && !C.current.destroyed && C.current.destroy(!0, !1)
            }
    }
    , []),
    On( () => {
        ie();
        const X = nS(R, b.current, Q, T.current, Z => Z.key);
        return b.current = R,
        T.current = Q,
        X.length && C.current && !C.current.destroyed && tS({
            swiper: C.current,
            slides: Q,
            passedParams: R,
            changedParams: X,
            nextEl: D.current,
            prevEl: M.current,
            scrollbarEl: _.current,
            paginationEl: B.current
        }),
        () => {
            ne()
        }
    }
    ),
    On( () => {
        aS(C.current)
    }
    , [v]);
    function H() {
        return F.virtual ? oS(C.current, Q, v) : Q.map( (X, Z) => Me.cloneElement(X, {
            swiper: C.current,
            swiperSlideIndex: Z
        }))
    }
    return Me.createElement(a, Ms({
        ref: z,
        className: w0(`${h}${r ? ` ${r}` : ""}`)
    }, W), Me.createElement(lS.Provider, {
        value: C.current
    }, se["container-start"], Me.createElement(o, {
        className: eS(F.wrapperClass)
    }, se["wrapper-start"], H(), se["wrapper-end"]), y0(F) && Me.createElement(Me.Fragment, null, Me.createElement("div", {
        ref: M,
        className: "swiper-button-prev"
    }), Me.createElement("div", {
        ref: D,
        className: "swiper-button-next"
    })), x0(F) && Me.createElement("div", {
        ref: _,
        className: "swiper-scrollbar"
    }), k0(F) && Me.createElement("div", {
        ref: B,
        className: "swiper-pagination"
    }), se["container-end"]))
});
S0.displayName = "Swiper";
const T0 = N.forwardRef(function(i, e) {
    let {tag: r="div", children: a, className: o="", swiper: l, zoom: u, lazy: d, virtualIndex: p, swiperSlideIndex: h, ...g} = i === void 0 ? {} : i;
    const v = N.useRef(null)
      , [y,P] = N.useState("swiper-slide")
      , [w,S] = N.useState(!1);
    function z(D, M, B) {
        M === v.current && P(B)
    }
    On( () => {
        if (typeof h < "u" && (v.current.swiperSlideIndex = h),
        e && (e.current = v.current),
        !(!v.current || !l)) {
            if (l.destroyed) {
                y !== "swiper-slide" && P("swiper-slide");
                return
            }
            return l.on("_slideClass", z),
            () => {
                l && l.off("_slideClass", z)
            }
        }
    }
    ),
    On( () => {
        l && v.current && !l.destroyed && P(l.getSlideClasses(v.current))
    }
    , [l]);
    const C = {
        isActive: y.indexOf("swiper-slide-active") >= 0,
        isVisible: y.indexOf("swiper-slide-visible") >= 0,
        isPrev: y.indexOf("swiper-slide-prev") >= 0,
        isNext: y.indexOf("swiper-slide-next") >= 0
    }
      , b = () => typeof a == "function" ? a(C) : a
      , T = () => {
        S(!0)
    }
    ;
    return Me.createElement(r, Ms({
        ref: v,
        className: w0(`${y}${o ? ` ${o}` : ""}`),
        "data-swiper-slide-index": p,
        onLoad: T
    }, g), u && Me.createElement(rf.Provider, {
        value: C
    }, Me.createElement("div", {
        className: "swiper-zoom-container",
        "data-swiper-zoom": typeof u == "number" ? u : void 0
    }, b(), d && !w && Me.createElement("div", {
        className: "swiper-lazy-preloader"
    }))), !u && Me.createElement(rf.Provider, {
        value: C
    }, b(), d && !w && Me.createElement("div", {
        className: "swiper-lazy-preloader"
    })))
});
T0.displayName = "SwiperSlide";
function j0(i, e, r, a) {
    return i.params.createElements && Object.keys(a).forEach(o => {
        if (!r[o] && r.auto === !0) {
            let l = _t(i.el, `.${a[o]}`)[0];
            l || (l = Es("div", a[o]),
            l.className = a[o],
            i.el.append(l)),
            r[o] = l,
            e[o] = l
        }
    }
    ),
    r
}
function cS(i) {
    let {swiper: e, extendParams: r, on: a, emit: o} = i;
    r({
        navigation: {
            nextEl: null,
            prevEl: null,
            hideOnClick: !1,
            disabledClass: "swiper-button-disabled",
            hiddenClass: "swiper-button-hidden",
            lockClass: "swiper-button-lock",
            navigationDisabledClass: "swiper-navigation-disabled"
        }
    }),
    e.navigation = {
        nextEl: null,
        prevEl: null
    };
    function l(w) {
        let S;
        return w && typeof w == "string" && e.isElement && (S = e.el.querySelector(w) || e.hostEl.querySelector(w),
        S) ? S : (w && (typeof w == "string" && (S = [...document.querySelectorAll(w)]),
        e.params.uniqueNavElements && typeof w == "string" && S && S.length > 1 && e.el.querySelectorAll(w).length === 1 ? S = e.el.querySelector(w) : S && S.length === 1 && (S = S[0])),
        w && !S ? w : S)
    }
    function u(w, S) {
        const z = e.params.navigation;
        w = Ge(w),
        w.forEach(C => {
            C && (C.classList[S ? "add" : "remove"](...z.disabledClass.split(" ")),
            C.tagName === "BUTTON" && (C.disabled = S),
            e.params.watchOverflow && e.enabled && C.classList[e.isLocked ? "add" : "remove"](z.lockClass))
        }
        )
    }
    function d() {
        const {nextEl: w, prevEl: S} = e.navigation;
        if (e.params.loop) {
            u(S, !1),
            u(w, !1);
            return
        }
        u(S, e.isBeginning && !e.params.rewind),
        u(w, e.isEnd && !e.params.rewind)
    }
    function p(w) {
        w.preventDefault(),
        !(e.isBeginning && !e.params.loop && !e.params.rewind) && (e.slidePrev(),
        o("navigationPrev"))
    }
    function h(w) {
        w.preventDefault(),
        !(e.isEnd && !e.params.loop && !e.params.rewind) && (e.slideNext(),
        o("navigationNext"))
    }
    function g() {
        const w = e.params.navigation;
        if (e.params.navigation = j0(e, e.originalParams.navigation, e.params.navigation, {
            nextEl: "swiper-button-next",
            prevEl: "swiper-button-prev"
        }),
        !(w.nextEl || w.prevEl))
            return;
        let S = l(w.nextEl)
          , z = l(w.prevEl);
        Object.assign(e.navigation, {
            nextEl: S,
            prevEl: z
        }),
        S = Ge(S),
        z = Ge(z);
        const C = (b, T) => {
            b && b.addEventListener("click", T === "next" ? h : p),
            !e.enabled && b && b.classList.add(...w.lockClass.split(" "))
        }
        ;
        S.forEach(b => C(b, "next")),
        z.forEach(b => C(b, "prev"))
    }
    function v() {
        let {nextEl: w, prevEl: S} = e.navigation;
        w = Ge(w),
        S = Ge(S);
        const z = (C, b) => {
            C.removeEventListener("click", b === "next" ? h : p),
            C.classList.remove(...e.params.navigation.disabledClass.split(" "))
        }
        ;
        w.forEach(C => z(C, "next")),
        S.forEach(C => z(C, "prev"))
    }
    a("init", () => {
        e.params.navigation.enabled === !1 ? P() : (g(),
        d())
    }
    ),
    a("toEdge fromEdge lock unlock", () => {
        d()
    }
    ),
    a("destroy", () => {
        v()
    }
    ),
    a("enable disable", () => {
        let {nextEl: w, prevEl: S} = e.navigation;
        if (w = Ge(w),
        S = Ge(S),
        e.enabled) {
            d();
            return
        }
        [...w, ...S].filter(z => !!z).forEach(z => z.classList.add(e.params.navigation.lockClass))
    }
    ),
    a("click", (w, S) => {
        let {nextEl: z, prevEl: C} = e.navigation;
        z = Ge(z),
        C = Ge(C);
        const b = S.target;
        let T = C.includes(b) || z.includes(b);
        if (e.isElement && !T) {
            const D = S.path || S.composedPath && S.composedPath();
            D && (T = D.find(M => z.includes(M) || C.includes(M)))
        }
        if (e.params.navigation.hideOnClick && !T) {
            if (e.pagination && e.params.pagination && e.params.pagination.clickable && (e.pagination.el === b || e.pagination.el.contains(b)))
                return;
            let D;
            z.length ? D = z[0].classList.contains(e.params.navigation.hiddenClass) : C.length && (D = C[0].classList.contains(e.params.navigation.hiddenClass)),
            o(D === !0 ? "navigationShow" : "navigationHide"),
            [...z, ...C].filter(M => !!M).forEach(M => M.classList.toggle(e.params.navigation.hiddenClass))
        }
    }
    );
    const y = () => {
        e.el.classList.remove(...e.params.navigation.navigationDisabledClass.split(" ")),
        g(),
        d()
    }
      , P = () => {
        e.el.classList.add(...e.params.navigation.navigationDisabledClass.split(" ")),
        v()
    }
    ;
    Object.assign(e.navigation, {
        enable: y,
        disable: P,
        update: d,
        init: g,
        destroy: v
    })
}
function Cn(i) {
    return i === void 0 && (i = ""),
    `.${i.trim().replace(/([\.:!+\/()[\]])/g, "\\$1").replace(/ /g, ".")}`
}
function uS(i) {
    let {swiper: e, extendParams: r, on: a, emit: o} = i;
    const l = "swiper-pagination";
    r({
        pagination: {
            el: null,
            bulletElement: "span",
            clickable: !1,
            hideOnClick: !1,
            renderBullet: null,
            renderProgressbar: null,
            renderFraction: null,
            renderCustom: null,
            progressbarOpposite: !1,
            type: "bullets",
            dynamicBullets: !1,
            dynamicMainBullets: 1,
            formatFractionCurrent: b => b,
            formatFractionTotal: b => b,
            bulletClass: `${l}-bullet`,
            bulletActiveClass: `${l}-bullet-active`,
            modifierClass: `${l}-`,
            currentClass: `${l}-current`,
            totalClass: `${l}-total`,
            hiddenClass: `${l}-hidden`,
            progressbarFillClass: `${l}-progressbar-fill`,
            progressbarOppositeClass: `${l}-progressbar-opposite`,
            clickableClass: `${l}-clickable`,
            lockClass: `${l}-lock`,
            horizontalClass: `${l}-horizontal`,
            verticalClass: `${l}-vertical`,
            paginationDisabledClass: `${l}-disabled`
        }
    }),
    e.pagination = {
        el: null,
        bullets: []
    };
    let u, d = 0;
    function p() {
        return !e.params.pagination.el || !e.pagination.el || Array.isArray(e.pagination.el) && e.pagination.el.length === 0
    }
    function h(b, T) {
        const {bulletActiveClass: D} = e.params.pagination;
        b && (b = b[`${T === "prev" ? "previous" : "next"}ElementSibling`],
        b && (b.classList.add(`${D}-${T}`),
        b = b[`${T === "prev" ? "previous" : "next"}ElementSibling`],
        b && b.classList.add(`${D}-${T}-${T}`)))
    }
    function g(b, T, D) {
        if (b = b % D,
        T = T % D,
        T === b + 1)
            return "next";
        if (T === b - 1)
            return "previous"
    }
    function v(b) {
        const T = b.target.closest(Cn(e.params.pagination.bulletClass));
        if (!T)
            return;
        b.preventDefault();
        const D = Ds(T) * e.params.slidesPerGroup;
        if (e.params.loop) {
            if (e.realIndex === D)
                return;
            const M = g(e.realIndex, D, e.slides.length);
            M === "next" ? e.slideNext() : M === "previous" ? e.slidePrev() : e.slideToLoop(D)
        } else
            e.slideTo(D)
    }
    function y() {
        const b = e.rtl
          , T = e.params.pagination;
        if (p())
            return;
        let D = e.pagination.el;
        D = Ge(D);
        let M, B;
        const _ = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length
          , F = e.params.loop ? Math.ceil(_ / e.params.slidesPerGroup) : e.snapGrid.length;
        if (e.params.loop ? (B = e.previousRealIndex || 0,
        M = e.params.slidesPerGroup > 1 ? Math.floor(e.realIndex / e.params.slidesPerGroup) : e.realIndex) : typeof e.snapIndex < "u" ? (M = e.snapIndex,
        B = e.previousSnapIndex) : (B = e.previousIndex || 0,
        M = e.activeIndex || 0),
        T.type === "bullets" && e.pagination.bullets && e.pagination.bullets.length > 0) {
            const R = e.pagination.bullets;
            let W, K, Q;
            if (T.dynamicBullets && (u = Ic(R[0], e.isHorizontal() ? "width" : "height"),
            D.forEach(se => {
                se.style[e.isHorizontal() ? "width" : "height"] = `${u * (T.dynamicMainBullets + 4)}px`
            }
            ),
            T.dynamicMainBullets > 1 && B !== void 0 && (d += M - (B || 0),
            d > T.dynamicMainBullets - 1 ? d = T.dynamicMainBullets - 1 : d < 0 && (d = 0)),
            W = Math.max(M - d, 0),
            K = W + (Math.min(R.length, T.dynamicMainBullets) - 1),
            Q = (K + W) / 2),
            R.forEach(se => {
                const le = [...["", "-next", "-next-next", "-prev", "-prev-prev", "-main"].map(pe => `${T.bulletActiveClass}${pe}`)].map(pe => typeof pe == "string" && pe.includes(" ") ? pe.split(" ") : pe).flat();
                se.classList.remove(...le)
            }
            ),
            D.length > 1)
                R.forEach(se => {
                    const le = Ds(se);
                    le === M ? se.classList.add(...T.bulletActiveClass.split(" ")) : e.isElement && se.setAttribute("part", "bullet"),
                    T.dynamicBullets && (le >= W && le <= K && se.classList.add(...`${T.bulletActiveClass}-main`.split(" ")),
                    le === W && h(se, "prev"),
                    le === K && h(se, "next"))
                }
                );
            else {
                const se = R[M];
                if (se && se.classList.add(...T.bulletActiveClass.split(" ")),
                e.isElement && R.forEach( (le, pe) => {
                    le.setAttribute("part", pe === M ? "bullet-active" : "bullet")
                }
                ),
                T.dynamicBullets) {
                    const le = R[W]
                      , pe = R[K];
                    for (let ie = W; ie <= K; ie += 1)
                        R[ie] && R[ie].classList.add(...`${T.bulletActiveClass}-main`.split(" "));
                    h(le, "prev"),
                    h(pe, "next")
                }
            }
            if (T.dynamicBullets) {
                const se = Math.min(R.length, T.dynamicMainBullets + 4)
                  , le = (u * se - u) / 2 - Q * u
                  , pe = b ? "right" : "left";
                R.forEach(ie => {
                    ie.style[e.isHorizontal() ? pe : "top"] = `${le}px`
                }
                )
            }
        }
        D.forEach( (R, W) => {
            if (T.type === "fraction" && (R.querySelectorAll(Cn(T.currentClass)).forEach(K => {
                K.textContent = T.formatFractionCurrent(M + 1)
            }
            ),
            R.querySelectorAll(Cn(T.totalClass)).forEach(K => {
                K.textContent = T.formatFractionTotal(F)
            }
            )),
            T.type === "progressbar") {
                let K;
                T.progressbarOpposite ? K = e.isHorizontal() ? "vertical" : "horizontal" : K = e.isHorizontal() ? "horizontal" : "vertical";
                const Q = (M + 1) / F;
                let se = 1
                  , le = 1;
                K === "horizontal" ? se = Q : le = Q,
                R.querySelectorAll(Cn(T.progressbarFillClass)).forEach(pe => {
                    pe.style.transform = `translate3d(0,0,0) scaleX(${se}) scaleY(${le})`,
                    pe.style.transitionDuration = `${e.params.speed}ms`
                }
                )
            }
            T.type === "custom" && T.renderCustom ? (Is(R, T.renderCustom(e, M + 1, F)),
            W === 0 && o("paginationRender", R)) : (W === 0 && o("paginationRender", R),
            o("paginationUpdate", R)),
            e.params.watchOverflow && e.enabled && R.classList[e.isLocked ? "add" : "remove"](T.lockClass)
        }
        )
    }
    function P() {
        const b = e.params.pagination;
        if (p())
            return;
        const T = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.grid && e.params.grid.rows > 1 ? e.slides.length / Math.ceil(e.params.grid.rows) : e.slides.length;
        let D = e.pagination.el;
        D = Ge(D);
        let M = "";
        if (b.type === "bullets") {
            let B = e.params.loop ? Math.ceil(T / e.params.slidesPerGroup) : e.snapGrid.length;
            e.params.freeMode && e.params.freeMode.enabled && B > T && (B = T);
            for (let _ = 0; _ < B; _ += 1)
                b.renderBullet ? M += b.renderBullet.call(e, _, b.bulletClass) : M += `<${b.bulletElement} ${e.isElement ? 'part="bullet"' : ""} class="${b.bulletClass}"></${b.bulletElement}>`
        }
        b.type === "fraction" && (b.renderFraction ? M = b.renderFraction.call(e, b.currentClass, b.totalClass) : M = `<span class="${b.currentClass}"></span> / <span class="${b.totalClass}"></span>`),
        b.type === "progressbar" && (b.renderProgressbar ? M = b.renderProgressbar.call(e, b.progressbarFillClass) : M = `<span class="${b.progressbarFillClass}"></span>`),
        e.pagination.bullets = [],
        D.forEach(B => {
            b.type !== "custom" && Is(B, M || ""),
            b.type === "bullets" && e.pagination.bullets.push(...B.querySelectorAll(Cn(b.bulletClass)))
        }
        ),
        b.type !== "custom" && o("paginationRender", D[0])
    }
    function w() {
        e.params.pagination = j0(e, e.originalParams.pagination, e.params.pagination, {
            el: "swiper-pagination"
        });
        const b = e.params.pagination;
        if (!b.el)
            return;
        let T;
        typeof b.el == "string" && e.isElement && (T = e.el.querySelector(b.el)),
        !T && typeof b.el == "string" && (T = [...document.querySelectorAll(b.el)]),
        T || (T = b.el),
        !(!T || T.length === 0) && (e.params.uniqueNavElements && typeof b.el == "string" && Array.isArray(T) && T.length > 1 && (T = [...e.el.querySelectorAll(b.el)],
        T.length > 1 && (T = T.find(D => d0(D, ".swiper")[0] === e.el))),
        Array.isArray(T) && T.length === 1 && (T = T[0]),
        Object.assign(e.pagination, {
            el: T
        }),
        T = Ge(T),
        T.forEach(D => {
            b.type === "bullets" && b.clickable && D.classList.add(...(b.clickableClass || "").split(" ")),
            D.classList.add(b.modifierClass + b.type),
            D.classList.add(e.isHorizontal() ? b.horizontalClass : b.verticalClass),
            b.type === "bullets" && b.dynamicBullets && (D.classList.add(`${b.modifierClass}${b.type}-dynamic`),
            d = 0,
            b.dynamicMainBullets < 1 && (b.dynamicMainBullets = 1)),
            b.type === "progressbar" && b.progressbarOpposite && D.classList.add(b.progressbarOppositeClass),
            b.clickable && D.addEventListener("click", v),
            e.enabled || D.classList.add(b.lockClass)
        }
        ))
    }
    function S() {
        const b = e.params.pagination;
        if (p())
            return;
        let T = e.pagination.el;
        T && (T = Ge(T),
        T.forEach(D => {
            D.classList.remove(b.hiddenClass),
            D.classList.remove(b.modifierClass + b.type),
            D.classList.remove(e.isHorizontal() ? b.horizontalClass : b.verticalClass),
            b.clickable && (D.classList.remove(...(b.clickableClass || "").split(" ")),
            D.removeEventListener("click", v))
        }
        )),
        e.pagination.bullets && e.pagination.bullets.forEach(D => D.classList.remove(...b.bulletActiveClass.split(" ")))
    }
    a("changeDirection", () => {
        if (!e.pagination || !e.pagination.el)
            return;
        const b = e.params.pagination;
        let {el: T} = e.pagination;
        T = Ge(T),
        T.forEach(D => {
            D.classList.remove(b.horizontalClass, b.verticalClass),
            D.classList.add(e.isHorizontal() ? b.horizontalClass : b.verticalClass)
        }
        )
    }
    ),
    a("init", () => {
        e.params.pagination.enabled === !1 ? C() : (w(),
        P(),
        y())
    }
    ),
    a("activeIndexChange", () => {
        typeof e.snapIndex > "u" && y()
    }
    ),
    a("snapIndexChange", () => {
        y()
    }
    ),
    a("snapGridLengthChange", () => {
        P(),
        y()
    }
    ),
    a("destroy", () => {
        S()
    }
    ),
    a("enable disable", () => {
        let {el: b} = e.pagination;
        b && (b = Ge(b),
        b.forEach(T => T.classList[e.enabled ? "remove" : "add"](e.params.pagination.lockClass)))
    }
    ),
    a("lock unlock", () => {
        y()
    }
    ),
    a("click", (b, T) => {
        const D = T.target
          , M = Ge(e.pagination.el);
        if (e.params.pagination.el && e.params.pagination.hideOnClick && M && M.length > 0 && !D.classList.contains(e.params.pagination.bulletClass)) {
            if (e.navigation && (e.navigation.nextEl && D === e.navigation.nextEl || e.navigation.prevEl && D === e.navigation.prevEl))
                return;
            const B = M[0].classList.contains(e.params.pagination.hiddenClass);
            o(B === !0 ? "paginationShow" : "paginationHide"),
            M.forEach(_ => _.classList.toggle(e.params.pagination.hiddenClass))
        }
    }
    );
    const z = () => {
        e.el.classList.remove(e.params.pagination.paginationDisabledClass);
        let {el: b} = e.pagination;
        b && (b = Ge(b),
        b.forEach(T => T.classList.remove(e.params.pagination.paginationDisabledClass))),
        w(),
        P(),
        y()
    }
      , C = () => {
        e.el.classList.add(e.params.pagination.paginationDisabledClass);
        let {el: b} = e.pagination;
        b && (b = Ge(b),
        b.forEach(T => T.classList.add(e.params.pagination.paginationDisabledClass))),
        S()
    }
    ;
    Object.assign(e.pagination, {
        enable: z,
        disable: C,
        render: P,
        update: y,
        init: w,
        destroy: S
    })
}
const Lc = [{
    image: bP,
    username: "@mytradingsetup",
    text: "The desktop app is lightning fast! No more browser lag—just smooth charting and trading."
}, {
    image: SP,
    username: "@chrisianrodriguezdr",
    text: "TradingView makes analyzing charts a pleasure! I actually enjoy analyzing charts."
}, {
    image: TP,
    username: "@ejacobsfx",
    text: "The split-screen feature is a game-changer! I track multiple assets at once without switching tabs."
}, {
    image: jP,
    username: "@joey_vittorelli",
    text: "Finally, a trading app that doesn’t drain my computer’s resources!"
}, {
    image: CP,
    username: "@carly_summerz",
    text: "TradingView Desktop has completely changed my workflow! I trade faster and analyze better!"
}, {
    image: zP,
    username: "@tradingView",
    text: "My trading lifestyle is smoother than ever. No distractions, just clean, professional charts."
}, {
    image: AP,
    username: "@johndollery",
    text: "Real-time updates and no browser crashes! TradingView Desktop is a must-have!"
}, {
    image: EP,
    username: "@ftmcomx",
    text: "I can customize my setup exactly how I want. TradingView Desktop makes my life easier!"
}, {
    image: DP,
    username: "@most_luxurious_lifestyle",
    text: "It’s like a professional trading terminal, but with TradingView’s ease of use. Perfect combo!"
}, {
    image: IP,
    username: "@TheJaslan",
    text: "With TradingView Desktop, I execute trades faster and stay ahead of the market!"
}, {
    image: MP,
    username: "@Market Mentor Network",
    text: "The performance boost is insane! No more slow-loading charts or missed opportunities."
}, {
    image: VP,
    username: "@noxonfx",
    text: "I trade from anywhere, and the desktop app keeps my workflow seamless across devices!"
}]
  , nf = ({direction: i, onClick: e, disabled: r}) => x.jsx("button", {
    onClick: e,
    disabled: r,
    className: `hidden md:flex size-8 bg-[#eaeaea] rounded-full items-center justify-center
                transition-all duration-300 hover:bg-[#eaeaea]/50
                disabled:opacity-50 disabled:cursor-not-allowed
                absolute top-1/2 -translate-y-1/2 z-10
                ${i === "prev" ? "left-0 md:-left-12" : "right-0 md:-right-12"}`,
    children: x.jsx("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: i === "prev" ? "rotate-180" : "",
        children: x.jsx("path", {
            d: "M6.61204 1L13 8L6.61204 15L5 13.7344L10.2323 8L5 2.2656L6.61204 1Z",
            fill: "#000"
        })
    })
})
  , dS = ({totalSlides: i, activeIndex: e, onSelect: r}) => x.jsx("div", {
    className: "flex md:hidden justify-center items-center gap-2 mt-4",
    children: Array.from({
        length: i
    }).map( (a, o) => x.jsx("button", {
        onClick: () => r(o),
        className: `w-2 h-2 rounded-full transition-all duration-300 
                   ${e === o ? "bg-[#D23197] w-4" : "bg-[#858C93]"}`
    }, o))
})
  , pS = ({image: i, username: e, text: r}) => x.jsxs("div", {
    className: "w-full flex flex-col gap-2 px-2 sm:px-0",
    children: [x.jsx("img", {
        src: i,
        className: "rounded-[8px] w-full aspect-video object-cover",
        alt: ""
    }), x.jsx("span", {
        className: "text-[#0D1013] font-bold text-[14px] sm:text-[16px] lg:text-[18px] leading-tight",
        children: e
    }), x.jsx("p", {
        className: "text-[#5F656C] text-[14px] sm:text-[16px] lg:text-[18px] leading-tight",
        children: r
    })]
})
  , mS = i => {
    const e = {
        en: {
            "loveInEvery.title1": "Love in every",
            "loveInEvery.title2": "#TradingView",
            "loveInEvery.testimonials": JSON.stringify(Lc)
        },
        es: {
            "loveInEvery.title1": "Amor en cada",
            "loveInEvery.title2": "#TradingView",
            "loveInEvery.testimonials": JSON.stringify([{
                username: "@mytradingsetup",
                text: "¡La aplicación de escritorio es ultrarrápida! No más retrasos del navegador, solo gráficos y trading fluidos."
            }, {
                username: "@chrisianrodriguezdr",
                text: "¡TradingView hace que analizar gráficos sea un placer! Realmente disfruto analizando gráficos."
            }, {
                username: "@ejacobsfx",
                text: "¡La función de pantalla dividida es revolucionaria! Puedo rastrear múltiples activos a la vez sin cambiar de pestañas."
            }, {
                username: "@joey_vittorelli",
                text: "¡Por fin! Una aplicación de trading que no agota los recursos de mi computadora."
            }, {
                username: "@carly_summerz",
                text: "¡TradingView Desktop ha transformado completamente mi flujo de trabajo! Comercio más rápido y analizo mejor."
            }, {
                username: "@tradingView",
                text: "Mi estilo de vida de trading es más suave que nunca. Sin distracciones, solo gráficos limpios y profesionales."
            }, {
                username: "@johndollery",
                text: "¡Actualizaciones en tiempo real y sin fallos del navegador! TradingView Desktop es imprescindible."
            }, {
                username: "@ftmcomx",
                text: "Puedo personalizar mi configuración exactamente como quiero. TradingView Desktop hace mi vida más fácil."
            }, {
                username: "@most_luxurious_lifestyle",
                text: "Es como un terminal de trading profesional, pero con la facilidad de uso de TradingView. ¡Combinación perfecta!"
            }, {
                username: "@TheJaslan",
                text: "Con TradingView Desktop, ejecuto operaciones más rápido y me mantengo por delante del mercado."
            }, {
                username: "@Market Mentor Network",
                text: "¡El aumento de rendimiento es increíble! No más gráficos de carga lenta ni oportunidades perdidas."
            }, {
                username: "@noxonfx",
                text: "Comercio desde cualquier lugar, y la aplicación de escritorio mantiene mi flujo de trabajo sin problemas en todos los dispositivos."
            }])
        },
        vi: {
            "loveInEvery.title1": "Tình yêu trong mọi",
            "loveInEvery.title2": "#TradingView",
            "loveInEvery.testimonials": JSON.stringify([{
                username: "@mytradingsetup",
                text: "Ứng dụng trên máy tính cực kỳ nhanh! Không còn độ trễ trình duyệt—chỉ có biểu đồ và giao dịch mượt mà."
            }, {
                username: "@chrisianrodriguezdr",
                text: "TradingView làm việc phân tích biểu đồ trở nên thú vị! Tôi thực sự thích phân tích biểu đồ."
            }, {
                username: "@ejacobsfx",
                text: "Tính năng màn hình chia đôi là một bước đột phá! Tôi có thể theo dõi nhiều tài sản cùng lúc mà không cần chuyển tab."
            }, {
                username: "@joey_vittorelli",
                text: "Cuối cùng! Một ứng dụng giao dịch không làm cạn kiệt tài nguyên máy tính của tôi."
            }, {
                username: "@carly_summerz",
                text: "TradingView Desktop đã hoàn toàn thay đổi quy trình làm việc của tôi! Tôi giao dịch nhanh hơn và phân tích tốt hơn."
            }, {
                username: "@tradingView",
                text: "Phong cách giao dịch của tôi mượt mà hơn bao giờ hết. Không có sự phân tâm, chỉ có biểu đồ sạch sẽ và chuyên nghiệp."
            }, {
                username: "@johndollery",
                text: "Cập nhật thời gian thực và không bị sập trình duyệt! TradingView Desktop là thứ phải có."
            }, {
                username: "@ftmcomx",
                text: "Tôi có thể tùy chỉnh thiết lập của mình chính xác như muốn. TradingView Desktop làm cuộc sống của tôi dễ dàng hơn."
            }, {
                username: "@most_luxurious_lifestyle",
                text: "Như một terminal giao dịch chuyên nghiệp, nhưng với sự dễ sử dụng của TradingView. Kết hợp hoàn hảo!"
            }, {
                username: "@TheJaslan",
                text: "Với TradingView Desktop, tôi thực hiện giao dịch nhanh hơn và luôn dẫn đầu thị trường."
            }, {
                username: "@Market Mentor Network",
                text: "Sự tăng cường hiệu suất thật điên rồ! Không còn biểu đồ tải chậm hay cơ hội bị bỏ lỡ."
            }, {
                username: "@noxonfx",
                text: "Tôi giao dịch từ bất kỳ đâu, và ứng dụng desktop giữ quy trình làm việc của tôi liền mạch trên mọi thiết bị."
            }])
        },
        th: {
            "loveInEvery.title1": "ความรักในทุก",
            "loveInEvery.title2": "#TradingView",
            "loveInEvery.testimonials": JSON.stringify([{
                username: "@mytradingsetup",
                text: "แอปเดสก์ท็อปเร็วมาก! ไม่มีอาการหน่วงของเบราว์เซอร์—แค่กราฟและการเทรดที่ลื่นไหล"
            }, {
                username: "@chrisianrodriguezdr",
                text: "TradingView ทำให้การวิเคราะห์กราฟสนุก! ฉันสนุกกับการวิเคราะห์กราฟจริงๆ"
            }, {
                username: "@ejacobsfx",
                text: "ฟีเจอร์หน้าจอแยกเป็นตัวเปลี่ยนเกม! ฉันติดตามสินทรัพย์หลายรายการพร้อมกันโดยไม่ต้องสลับแท็บ"
            }, {
                username: "@joey_vittorelli",
                text: "สุดท้าย! แอปเทรดที่ไม่กินทรัพยากรคอมพิวเตอร์ของฉัน"
            }, {
                username: "@carly_summerz",
                text: "TradingView Desktop เปลี่ยนกระบวนการทำงานของฉันไปเลย! ฉันเทรดเร็วขึ้นและวิเคราะห์ดีขึ้น"
            }, {
                username: "@tradingView",
                text: "วิถีชีวิตการเทรดของฉันลื่นไหลกว่าที่เคย ไม่มีสิ่งรบกวน—just กราฟที่สะอาดและมืออาชีพ"
            }, {
                username: "@johndollery",
                text: "อัปเดตแบบเรียลไทม์และไม่คราสเบราว์เซอร์! TradingView Desktop เป็นสิ่งที่ต้องมี"
            }, {
                username: "@ftmcomx",
                text: "ฉันสามารถปรับแต่งการตั้งค่าของตัวเองได้ตามที่ต้องการ TradingView Desktop ทำให้ชีวิตฉันง่ายขึ้น"
            }, {
                username: "@most_luxurious_lifestyle",
                text: "เหมือนเทอร์มินัลเทรดมืออาชีพ แต่มีความง่ายของ TradingView 组合 ที่สมบูรณ์แบบ!"
            }, {
                username: "@TheJaslan",
                text: "ด้วย TradingView Desktop ฉันทำการเทรดเร็วขึ้นและอยู่เหนือตลาด!"
            }, {
                username: "@Market Mentor Network",
                text: "การเพิ่มประสิทธิภาพน่าทึ่งมาก! ไม่มีกราฟโหลดช้าและโอกาสที่พลาดไป"
            }, {
                username: "@noxonfx",
                text: "ฉันเทรดจากที่ไหนก็ได้ และแอปเดสก์ท็อปทำให้กระบวนการทำงานของฉันลื่นไหลข้ามอุปกรณ์"
            }])
        },
        ja: {
            "loveInEvery.title1": "愛はすべての",
            "loveInEvery.title2": "#TradingView",
            "loveInEvery.testimonials": JSON.stringify([{
                username: "@mytradingsetup",
                text: "デスクトップアプリが超高速！ブラウザの遅延がなく、滑らかなチャートと取引だけです。"
            }, {
                username: "@chrisianrodriguezdr",
                text: "TradingViewはチャートの分析を楽しいものにします！本当にチャートの分析を楽しんでいます。"
            }, {
                username: "@ejacobsfx",
                text: "分割画面機能はゲームチェンジャーです！タブを切り替えずに複数の資産を一度に追跡できます。"
            }, {
                username: "@joey_vittorelli",
                text: "ついに！コンピュータのリソースを消耗しないトレーディングアプリです！"
            }, {
                username: "@carly_summerz",
                text: "TradingView Desktopは私のワークフローを完全に変えました！より速く取引し、分析が向上しました！"
            }, {
                username: "@tradingView",
                text: "私のトレーディングライフスタイルは今までで最もスムーズです。 distractionがなく、クリーンでプロフェッショナルなチャートだけです。"
            }, {
                username: "@johndollery",
                text: "リアルタイム更新とブラウザクラッシュなし！TradingView Desktopは必須です！"
            }, {
                username: "@ftmcomx",
                text: "設定を自分の思い通りにカスタマイズできます。TradingView Desktopは私の生活を簡単にしてくれます！"
            }, {
                username: "@most_luxurious_lifestyle",
                text: "プロのトレーディング端末のようですが、TradingViewの使いやすさが特徴。完璧な組み合わせです！"
            }, {
                username: "@TheJaslan",
                text: "TradingView Desktopを使えば、取引をより速く実行し、市場をリードできます！"
            }, {
                username: "@Market Mentor Network",
                text: "パフォーマンスの向上が驚異的です！遅い読み込みチャートや見逃した機会がもうありません。"
            }, {
                username: "@noxonfx",
                text: "どこからでも取引でき、デスクトップアプリがデバイス間でのワークフローをシームレスに保ちます！"
            }])
        },
        ko: {
            "loveInEvery.title1": "사랑은 모든",
            "loveInEvery.title2": "#TradingView",
            "loveInEvery.testimonials": JSON.stringify([{
                username: "@mytradingsetup",
                text: "데스크톱 앱이 매우 빠릅니다! 브라우저 지연이 없고, 매끄러운 차트와 거래만 있습니다."
            }, {
                username: "@chrisianrodriguezdr",
                text: "TradingView는 차트 분석을 즐거운 일로 만듭니다! 실제로 차트 분석을 즐기고 있습니다."
            }, {
                username: "@ejacobsfx",
                text: "분할 화면 기능은 게임 체인저입니다! 탭을 전환하지 않고 여러 자산을 한 번에 추적할 수 있습니다."
            }, {
                username: "@joey_vittorelli",
                text: "드디어! 제 컴퓨터 리소스를 소모하지 않는 트레이딩 앱입니다!"
            }, {
                username: "@carly_summerz",
                text: "TradingView Desktop은 제 워크플로우를 완전히 바꿨습니다! 더 빠르게 거래하고 분석이 향상되었습니다!"
            }, {
                username: "@tradingView",
                text: "제 트레이딩 라이프스타일이 이제까지 가장 부드럽습니다. 방해 요소가 없고, 깨끗하고 전문적인 차트만 있습니다."
            }, {
                username: "@johndollery",
                text: "실시간 업데이트와 브라우저 충돌 없음! TradingView Desktop은 필수입니다!"
            }, {
                username: "@ftmcomx",
                text: "설정을 원하는 대로 정확히 커스터마이즈할 수 있습니다. TradingView Desktop은 제 삶을 더 쉽게 만듭니다!"
            }, {
                username: "@most_luxurious_lifestyle",
                text: "전문 트레이딩 터미널 같지만 TradingView의 사용 편의성이 있습니다. 완벽한 조합입니다!"
            }, {
                username: "@TheJaslan",
                text: "TradingView Desktop으로 거래를 더 빠르게 실행하고 시장을 앞서갈 수 있습니다!"
            }, {
                username: "@Market Mentor Network",
                text: "성능 향상이 엄청납니다! 더 이상 느린 로딩 차트나 놓친 기회가 없습니다."
            }, {
                username: "@noxonfx",
                text: "어디서나 거래할 수 있고, 데스크톱 앱이 모든 장치 간 워크플로우를 매끄럽게 유지합니다!"
            }])
        },
        "zh-TW": {
            "loveInEvery.title1": "愛在每筆",
            "loveInEvery.title2": "#TradingView",
            "loveInEvery.testimonials": JSON.stringify([{
                username: "@mytradingsetup",
                text: "桌面應用程式快如閃電！不再有瀏覽器延遲—只有流暢的圖表和交易。"
            }, {
                username: "@chrisianrodriguezdr",
                text: "TradingView 讓分析圖表成為一種樂趣！我真的很喜歡分析圖表。"
            }, {
                username: "@ejacobsfx",
                text: "分屏功能是遊戲規則改變者！無需切換標籤即可同時跟踪多個資產。"
            }, {
                username: "@joey_vittorelli",
                text: "終於！一個不會耗盡我電腦資源的交易應用程式！"
            }, {
                username: "@carly_summerz",
                text: "TradingView Desktop 完全改變了我的工作流程！我交易更快，分析更好！"
            }, {
                username: "@tradingView",
                text: "我的交易生活方式比以往任何時候都更順暢。沒有分心，只有乾淨專業的圖表。"
            }, {
                username: "@johndollery",
                text: "即時更新且無瀏覽器崩潰！TradingView Desktop 是必備品！"
            }, {
                username: "@ftmcomx",
                text: "我可以完全按自己的意願自訂設置。TradingView Desktop 讓我的生活更輕鬆！"
            }, {
                username: "@most_luxurious_lifestyle",
                text: "就像專業交易終端機，但帶有 TradingView 的易用性。完美的組合！"
            }, {
                username: "@TheJaslan",
                text: "使用 TradingView Desktop，我能更快執行交易並領先市場！"
            }, {
                username: "@Market Mentor Network",
                text: "性能提升令人震驚！不再有緩慢加載的圖表或錯失的機會。"
            }, {
                username: "@noxonfx",
                text: "我可以從任何地方交易，桌面應用程式讓我的工作流程在所有設備間無縫運行！"
            }])
        },
        ar: {
            "loveInEvery.title1": "الحب في كل",
            "loveInEvery.title2": "#TradingView",
            "loveInEvery.testimonials": JSON.stringify([{
                username: "@mytradingsetup",
                text: "التطبيق على سطح المكتب سريع كالبرق! لا مزيد من تأخير المتصفح—فقط رسوم بيانية وتداول سلس."
            }, {
                username: "@chrisianrodriguezdr",
                text: "TradingView يجعل تحليل الرسوم البيانية متعة! أستمتع حقًا بتحليل الرسوم البيانية."
            }, {
                username: "@ejacobsfx",
                text: "ميزة الشاشة المقسمة تغير قواعد اللعبة! أتتبع أصولاً متعددة دفعة واحدة دون تبديل التبويب."
            }, {
                username: "@joey_vittorelli",
                text: "أخيرًا! تطبيق تداول لا ينهك موارد جهاز الكمبيوتر الخاص بي!"
            }, {
                username: "@carly_summerz",
                text: "TradingView Desktop غير سير عملي تمامًا! أتداول بشكل أسرع وأحلل بشكل أفضل!"
            }, {
                username: "@tradingView",
                text: "أسلوب حياتي في التداول أكثر سلاسة من أي وقت مضى. لا تشتيت، فقط رسوم بيانية نظيفة ومهنية."
            }, {
                username: "@johndollery",
                text: "تحديثات في الوقت الفعلي ولا انهيارات للمتصفح! TradingView Desktop أمر لا غنى عنه!"
            }, {
                username: "@ftmcomx",
                text: "يمكنني تخصيص إعداداتي تمامًا كما أريد. TradingView Desktop يجعل حياتي أسهل!"
            }, {
                username: "@most_luxurious_lifestyle",
                text: "مثل terminal تداول احترافي، لكن مع سهولة استخدام TradingView. مزيج مثالي!"
            }, {
                username: "@TheJaslan",
                text: "مع TradingView Desktop، أنفذ الصفقات بشكل أسرع وأبقى في صدارة السوق!"
            }, {
                username: "@Market Mentor Network",
                text: "زيادة الأداء مذهلة! لا مزيد من الرسوم البيانية المتأخرة أو الفرص الضائعة."
            }, {
                username: "@noxonfx",
                text: "أتداول من أي مكان، وتطبيق سطح المكتب يحافظ على سير عملي سلس عبر الأجهزة!"
            }])
        },
        bn: {
            "loveInEvery.title1": "ভালোবাসা প্রতিটি",
            "loveInEvery.title2": "#TradingView",
            "loveInEvery.testimonials": JSON.stringify([{
                username: "@mytradingsetup",
                text: "ডেস্কটপ অ্যাপটি অত্যন্ত দ্রুত! আর কোনো ব্রাউজার ল্যাগ নেই—শুধুমাত্র মসৃণ চার্টিং এবং ট্রেডিং।"
            }, {
                username: "@chrisianrodriguezdr",
                text: "TradingView চার্ট বিশ্লেষণকে আনন্দদায়ক করে তুলেছে! আমি আসলেই চার্ট বিশ্লেষণের আনন্দ পাই।"
            }, {
                username: "@ejacobsfx",
                text: "স্প্লিট-স্ক্রিন ফিচারটি গেম চেঞ্জার! আমি ট্যাব সুইচ না করে একসঙ্গে একাধিক এসেট ট্র্যাক করতে পারি।"
            }, {
                username: "@joey_vittorelli",
                text: "আরও! একটি ট্রেডিং অ্যাপ যা আমার কম্পিউটারের রিসোর্স খরচ করে না!"
            }, {
                username: "@carly_summerz",
                text: "TradingView Desktop আমার কর্মপ্রবাহ পুরোপুরি বদলে দিয়েছে! আমি দ্রুত ট্রেড করি এবং ভালোরকমে বিশ্লেষণ করি!"
            }, {
                username: "@tradingView",
                text: "আমার ট্রেডিং জীবনধারা এখন পর্যন্ত সবচেয়ে মসৃণ। কোনো বিরক্তি নেই, শুধুমাত্র পরিষ্কার, পেশাদার চার্ট।"
            }, {
                username: "@johndollery",
                text: "রিয়েল-টাইম আপডেট এবং ব্রাউজার ক্র্যাশ নেই! TradingView Desktop অত্যন্ত প্রয়োজনীয়!"
            }, {
                username: "@ftmcomx",
                text: "আমি আমার সেটআপটি ঠিক যেমন চাই তেমনি কাস্টমাইজ করতে পারি। TradingView Desktop আমার জীবন সহজ করে তোলে!"
            }, {
                username: "@most_luxurious_lifestyle",
                text: "এটি যেন একটি পেশাদার ট্রেডিং টার্মিনাল, কিন্তু TradingView-এর সহজ ব্যবহারের সাথে। পূর্ণাঙ্গ মিল!"
            }, {
                username: "@TheJaslan",
                text: "TradingView Desktop-এর সাহায্যে আমি দ্রুত ট্রেড সম্পন্ন করি এবং বাজারের আগে থাকি!"
            }, {
                username: "@Market Mentor Network",
                text: "পারফরম্যান্স বৃদ্ধি অসাধারণ! আর কোনো ধীর লোডিং চার্ট বা হারানো সুযোগ নেই।"
            }, {
                username: "@noxonfx",
                text: "আমি যেকোনো জায়গা থেকে ট্রেড করি, এবং ডেস্কটপ অ্যাপটি আমার কর্মপ্রবাহ সব ডিভাইসে সামঞ্জস্যপূর্ণ রাখে!"
            }])
        },
        id: {
            "loveInEvery.title1": "Cinta dalam setiap",
            "loveInEvery.title2": "#TradingView",
            "loveInEvery.testimonials": JSON.stringify([{
                username: "@mytradingsetup",
                text: "Aplikasi desktop sangat cepat! Tidak ada lagi lag browser—hanya charting dan perdagangan yang mulus."
            }, {
                username: "@chrisianrodriguezdr",
                text: "TradingView membuat analisis grafik menjadi kesenangan! Saya benar-benar menikmati menganalisis grafik."
            }, {
                username: "@ejacobsfx",
                text: "Fitur layar terpisah adalah pengubah permainan! Saya melacak beberapa aset sekaligus tanpa beralih tab."
            }, {
                username: "@joey_vittorelli",
                text: "Akhirnya! Aplikasi perdagangan yang tidak menguras sumber daya komputer saya!"
            }, {
                username: "@carly_summerz",
                text: "TradingView Desktop telah sepenuhnya mengubah alur kerja saya! Saya berdagang lebih cepat dan menganalisis lebih baik!"
            }, {
                username: "@tradingView",
                text: "Gaya hidup perdagangan saya lebih mulus dari sebelumnya. Tanpa gangguan, hanya grafik bersih dan profesional."
            }, {
                username: "@johndollery",
                text: "Pembaruan waktu nyata dan tidak ada crash browser! TradingView Desktop adalah keharusan!"
            }, {
                username: "@ftmcomx",
                text: "Saya bisa menyesuaikan pengaturan saya persis seperti yang diinginkan. TradingView Desktop membuat hidup saya lebih mudah!"
            }, {
                username: "@most_luxurious_lifestyle",
                text: "Seperti terminal perdagangan profesional, tetapi dengan kemudahan penggunaan TradingView. Kombinasi sempurna!"
            }, {
                username: "@TheJaslan",
                text: "Dengan TradingView Desktop, saya mengeksekusi perdagangan lebih cepat dan tetap unggul di pasar!"
            }, {
                username: "@Market Mentor Network",
                text: "Peningkatan performa luar biasa! Tidak ada lagi grafik loading lambat atau peluang yang terlewat."
            }, {
                username: "@noxonfx",
                text: "Saya berdagang dari mana saja, dan aplikasi desktop menjaga alur kerja saya mulus di semua perangkat!"
            }])
        },
        ka: {
            "loveInEvery.title1": "სიყვარული ყოველ",
            "loveInEvery.title2": "#TradingView",
            "loveInEvery.testimonials": JSON.stringify([{
                username: "@mytradingsetup",
                text: "დესკტოპის აპლიკაცია განსაკუთრებით სწრაფია! აღარ არის ბრაუზერის გადადება—მხოლოდ გლუვი ჩარტები და ვაჭრობა."
            }, {
                username: "@chrisianrodriguezdr",
                text: "TradingView ჩარტების ანალიზს სიამოვნებად აქცევს! მე ჭეშმარიტად ვგრძნობ ჩარტების ანალიზის სიამოვნებას."
            }, {
                username: "@ejacobsfx",
                text: "გაყოფილი ეკრანის ფუნქცია თამაშის შემცვლელია! მე ერთდროულად ვაკვირდები მრავალ აქტივს, ტაბების გადართვის გარეშე."
            }, {
                username: "@joey_vittorelli",
                text: "და ბოლოს! ვაჭრობის აპლიკაცია, რომელიც არ ხარჯავს ჩემი კომპიუტერის რესურსებს!"
            }, {
                username: "@carly_summerz",
                text: "TradingView Desktop-მა სრულად შეცვალა ჩემი სამუშაო ნაკადი! ვაჭრობ ძალიან სწრაფად და უკეთ ვანალიზებ!"
            }, {
                username: "@tradingView",
                text: "ჩემი ვაჭრობის ცხოვრების სტილი ყოველთვის ყველაზე გლუვია. არ არის გადახრა, მხოლოდ სუფთა, პროფესიონალური ჩარტები."
            }, {
                username: "@johndollery",
                text: "რეალური დროის განახლებები და ბრაუზერის გადატვირთვა არაა! TradingView Desktop აუცილებელია!"
            }, {
                username: "@ftmcomx",
                text: "შემიძლია ჩემი კონფიგურაცია სრულყოფილად მორგო, როგორც მინდა. TradingView Desktop ჩემს ცხოვრებას ამარტივებს!"
            }, {
                username: "@most_luxurious_lifestyle",
                text: "იგი ჰგავს პროფესიონალურ ვაჭრობის ტერმინალს, მაგრამ TradingView-ის გამოყენების სიმარტივით. პასუხობს ყველა მოლოდინს!"
            }, {
                username: "@TheJaslan",
                text: "TradingView Desktop-ით მე ვაჭრობ ძალიან სწრაფად და ბაზარზე წინ ვარ!"
            }, {
                username: "@Market Mentor Network",
                text: "პროდუქტიულობის ზრდა შთამბეჭდავია! აღარ არის ნელი ჩატვირთვის ჩარტები ან გამოტოვებული შანსები."
            }, {
                username: "@noxonfx",
                text: "მე ვაჭრობ ნებისმიერ ადგილას, და დესკტოპის აპლიკაცია ჩემს სამუშაო ნაკადს ყველა მოწყობილობაზე უწყვეტად ინარჩუნებს!"
            }])
        },
        mn: {
            "loveInEvery.title1": "Хайр бүх",
            "loveInEvery.title2": "#TradingView",
            "loveInEvery.testimonials": JSON.stringify([{
                username: "@mytradingsetup",
                text: "Дэсктоп аппын хурд гайхалтай! Браузерийн хойшилолгүй—зөвхөн тэгш график ба худалдаа."
            }, {
                username: "@chrisianrodriguezdr",
                text: "TradingView нь график шинжилгээг тааламжтай болгодог! Би үнэхээр график шинжилгээг эдэлдэг."
            }, {
                username: "@ejacobsfx",
                text: "Тусгаарлагдсан дэлгэцийн онцлог нь тоглоомын өөрчлөгч юм! Би табыг солихгүйгээр олон активыг нэгэн зэрэг хянах боломжтой."
            }, {
                username: "@joey_vittorelli",
                text: "Эцэст нь! Миний компьютерийн нөөцийг барахгүй трейдинг апп!"
            }, {
                username: "@carly_summerz",
                text: "TradingView Desktop нь миний ажлын урсгалыг бүрэн өөрчилсөн! Би илүү хурдан худалдаа хийж, дээр шинжилгээ хийдэг!"
            }, {
                username: "@tradingView",
                text: "Миний трейдинг амьдралын хэв маяг одоо хамгийн тэгш байна. Тархалтгүй, зөвхөн цэвэр, мэргэжлийн график."
            }, {
                username: "@johndollery",
                text: "Жижиглэн төлөвлөх шинэчлэлт ба браузерийн уналтгүй! TradingView Desktop нь зайлшгүй шаардлагатай!"
            }, {
                username: "@ftmcomx",
                text: "Би өөрийн тохиргоог яг хүссэнээрээ тохируулж чадна. TradingView Desktop нь миний амьдралыг хялбар болгодог!"
            }, {
                username: "@most_luxurious_lifestyle",
                text: "Энэ нь мэргэжлийн трейдинг терминал шиг ч TradingView-ийн хялбар байдлыг агуулдаг. Төгс хослол!"
            }, {
                username: "@TheJaslan",
                text: "TradingView Desktop-аар би худалдааг илүү хурдан гүйцэтгэж, зах зээлийн өмнө байна!"
            }, {
                username: "@Market Mentor Network",
                text: "Гүйцэтгэлийн өсөлт гайхалтай! Хэтрүүлж ачаалсан график эсвэл алдсан боломж байхгүй."
            }, {
                username: "@noxonfx",
                text: "Би хаанаас ч худалдаа хийж чадна, дэсктоп апп нь миний ажлын урсгалыг бүх төхөөрөмж дээр тасралтгүй байлгадаг!"
            }])
        },
        tr: {
            "loveInEvery.title1": "Aşk her",
            "loveInEvery.title2": "#TradingView",
            "loveInEvery.testimonials": JSON.stringify([{
                username: "@mytradingsetup",
                text: "Masaüstü uygulama şimşek gibi hızlı! Artık tarayıcı gecikmesi yok—sadece akıcı grafik ve ticaret."
            }, {
                username: "@chrisianrodriguezdr",
                text: "TradingView, grafik analizini keyifli hale getiriyor! Gerçekten grafik analizini seviyorum."
            }, {
                username: "@ejacobsfx",
                text: "Bölünmüş ekran özelliği oyun değiştirici! Sekme değiştirmeden birden fazla varlığı aynı anda takip edebilirim."
            }, {
                username: "@joey_vittorelli",
                text: "Sonunda! Bilgisayarımın kaynaklarını tüketmeyen bir ticaret uygulaması!"
            }, {
                username: "@carly_summerz",
                text: "TradingView Desktop, iş akışımı tamamen değiştirdi! Daha hızlı işlem yapıyorum ve analizim daha iyi!"
            }, {
                username: "@tradingView",
                text: "Ticaret yaşam tarzım şimdiye kadarki en akıcı. Dikkat dağıtıcı şeyler yok, sadece temiz, profesyonel grafikler."
            }, {
                username: "@johndollery",
                text: "Gerçek zamanlı güncellemeler ve tarayıcı çökmesi yok! TradingView Desktop bir zorunluluk!"
            }, {
                username: "@ftmcomx",
                text: "Ayarlarımı tam istediğim gibi özelleştirebilirim. TradingView Desktop hayatımı kolaylaştırıyor!"
            }, {
                username: "@most_luxurious_lifestyle",
                text: "Profesyonel bir ticaret terminali gibi, ama TradingView’in kullanım kolaylığıyla. Mükemmel kombinasyon!"
            }, {
                username: "@TheJaslan",
                text: "TradingView Desktop ile işlemleri daha hızlı gerçekleştiriyorum ve piyasanın önünde kalıyorum!"
            }, {
                username: "@Market Mentor Network",
                text: "Performans artışı çıldırmış durumda! Artık yavaş yüklenen grafikler veya kaçırılan fırsatlar yok."
            }, {
                username: "@noxonfx",
                text: "Her yerden ticaret yapabiliyorum ve masaüstü uygulama iş akışımı tüm cihazlarda sorunsuz tutuyor!"
            }])
        },
        ru: {
            "loveInEvery.title1": "Любовь в каждом",
            "loveInEvery.title2": "#TradingView",
            "loveInEvery.testimonials": JSON.stringify([{
                username: "@mytradingsetup",
                text: "Настольное приложение работает молниеносно! Больше никаких задержек в браузере — только плавные графики и торговля."
            }, {
                username: "@chrisianrodriguezdr",
                text: "TradingView делает анализ графиков настоящим удовольствием! Мне действительно нравится анализировать графики."
            }, {
                username: "@ejacobsfx",
                text: "Функция разделения экрана — это революция! Я могу отслеживать несколько активов одновременно, не переключая вкладки."
            }, {
                username: "@joey_vittorelli",
                text: "Наконец-то! Торговая приложение, которое не перегружает ресурсы моего компьютера."
            }, {
                username: "@carly_summerz",
                text: "TradingView Desktop полностью изменил мой рабочий процесс! Торгуйте быстрее и анализируйте лучше."
            }, {
                username: "@tradingView",
                text: "Мой торговый стиль жизни стал плавнее, чем когда-либо. Никаких отвлечений, только чистые профессиональные графики."
            }, {
                username: "@johndollery",
                text: "Обновления в реальном времени и никаких сбоев браузера! TradingView Desktop — must-have!"
            }, {
                username: "@ftmcomx",
                text: "Я могу настроить интерфейс так, как хочу. TradingView Desktop делает мою жизнь проще!"
            }, {
                username: "@most_luxurious_lifestyle",
                text: "Это как профессиональный торговый терминал, но с удобством TradingView. Идеальное сочетание!"
            }, {
                username: "@TheJaslan",
                text: "С TradingView Desktop я выполняю сделки быстрее и опережаю рынок!"
            }, {
                username: "@Market Mentor Network",
                text: "Увеличение производительности невероятное! Больше никаких медленно загружающихся графиков или упущенных возможностей."
            }, {
                username: "@noxonfx",
                text: "Торгуйте откуда угодно, а настольное приложение обеспечивает плавный рабочий процесс на всех устройствах."
            }])
        },
        sq: {
            "loveInEvery.title1": "Dashuria në çdo",
            "loveInEvery.title2": "#TradingView",
            "loveInEvery.testimonials": JSON.stringify([{
                username: "@mytradingsetup",
                text: "Aplikacioni i desktop është rrufeshkak! Nuk ka më vonesë të shfletuesit—vetëm grafik dhe tregtim të qetë."
            }, {
                username: "@chrisianrodriguezdr",
                text: "TradingView e bën analizën e grafikëve një kënaqësi! Më pëlqen vërtet të analizoj grafikët."
            }, {
                username: "@ejacobsfx",
                text: "Veçoria e ekranit të ndarë është një ndryshues loje! Mund të ndjek shumë aktive njëkohësisht pa ndryshuar tab."
            }, {
                username: "@joey_vittorelli",
                text: "Së fundi! Një aplikacion tregtie që nuk e konsumon burimet e kompjuterit tim!"
            }, {
                username: "@carly_summerz",
                text: "TradingView Desktop ka ndryshuar plotësisht rrjedhën time të punës! Tregtoj më shpejt dhe analizoj më mirë!"
            }, {
                username: "@tradingView",
                text: "Stili im i jetës së tregtimit është më i qetë se kurrë. Pa shpërqendrime, vetëm grafik të pastër dhe profesionalë."
            }, {
                username: "@johndollery",
                text: "Përditësimet në kohë reale dhe pa rrëzime të shfletuesit! TradingView Desktop është i domosdoshëm!"
            }, {
                username: "@ftmcomx",
                text: "Mund ta personalizoj konfigurimin tim saktësisht siç dua. TradingView Desktop e bën jetën time më të lehtë!"
            }, {
                username: "@most_luxurious_lifestyle",
                text: "Është si një terminal tregtie profesional, por me lehtësinë e përdorimit të TradingView. Kombinim i përsosur!"
            }, {
                username: "@TheJaslan",
                text: "Me TradingView Desktop, ekzekutoj tregti më shpejt dhe qëndroj përpara tregut!"
            }, {
                username: "@Market Mentor Network",
                text: "Rritja e performancës është e çmendur! Nuk ka më grafik me ngarkesë të ngadaltë ose mundësi të humbura."
            }, {
                username: "@noxonfx",
                text: "Tregtoj nga kudo, dhe aplikacioni desktop e mban rrjedhën time të punës të qetë në të gjitha pajisjet!"
            }])
        },
        bs: {
            "loveInEvery.title1": "Ljubav u svakom",
            "loveInEvery.title2": "#TradingView",
            "loveInEvery.testimonials": JSON.stringify([{
                username: "@mytradingsetup",
                text: "Desktop aplikacija je munjevito brza! Nema više kašnjenja preglednika—samo gladko crtanje grafika i trgovanje."
            }, {
                username: "@chrisianrodriguezdr",
                text: "TradingView čini analiziranje grafika zadovoljstvom! Stvarno uživam u analiziranju grafika."
            }, {
                username: "@ejacobsfx",
                text: "Funkcija podijeljenog ekrana je revolucionarna! Mogu pratiti više sredstava odjednom bez prebacivanja tabova."
            }, {
                username: "@joey_vittorelli",
                text: "Konačno! Aplikacija za trgovanje koja ne troši resurse mog računala!"
            }, {
                username: "@carly_summerz",
                text: "TradingView Desktop je potpuno promijenio moj tijek rada! Trgovam brže i analiziram bolje!"
            }, {
                username: "@tradingView",
                text: "Moj stil života trgovanja je glađi nego ikad. Bez smetnji, samo čisti, profesionalni grafici."
            }, {
                username: "@johndollery",
                text: "Ažuriranja u realnom vremenu i bez rušenja preglednika! TradingView Desktop je nužan!"
            }, {
                username: "@ftmcomx",
                text: "Mogu prilagoditi svoju postavku točno kako želim. TradingView Desktop čini moj život lakšim!"
            }, {
                username: "@most_luxurious_lifestyle",
                text: "To je kao profesionalni trgovinski terminal, ali s lakoćom korištenja TradingView-a. Savršena kombinacija!"
            }, {
                username: "@TheJaslan",
                text: "S TradingView Desktop-om, izvršavam trgovine brže i ostajem ispred tržišta!"
            }, {
                username: "@Market Mentor Network",
                text: "Povećanje performansi je ludo! Nema više sporih grafika ili propuštenih prilika."
            }, {
                username: "@noxonfx",
                text: "Trgovam odakle god, a desktop aplikacija drži moj tijek rada glatkim na svim uređajima!"
            }])
        },
        bg: {
            "loveInEvery.title1": "Любов във всеки",
            "loveInEvery.title2": "#TradingView",
            "loveInEvery.testimonials": JSON.stringify([{
                username: "@mytradingsetup",
                text: "Настолното приложение е светкавично бърzo! Няма повече забавяне на браузъра—само гладки графики и търговия."
            }, {
                username: "@chrisianrodriguezdr",
                text: "TradingView прави анализирането на графиките удоволствие! Наистина обичам да анализирам графики."
            }, {
                username: "@ejacobsfx",
                text: "Функцията на разделен екран е революционна! Мога да проследявам множество активи едновременно без да сменям табове."
            }, {
                username: "@joey_vittorelli",
                text: "Най-накрая! Приложение за търговия, което не изчерпва ресурсите на компютъра ми!"
            }, {
                username: "@carly_summerz",
                text: "TradingView Desktop напълно промени работния ми процес! Търгувам по-бързо и анализирам по-добре!"
            }, {
                username: "@tradingView",
                text: "Моят стил на живот в търговията е по-гладък от всякога. Без разсейване, само чисти, професионални графики."
            }, {
                username: "@johndollery",
                text: "Актуализации в реално време и без срив на браузъра! TradingView Desktop е задължителен!"
            }, {
                username: "@ftmcomx",
                text: "Мога да персонализирам настройката си точно както искам. TradingView Desktop прави живота ми по-лесен!"
            }, {
                username: "@most_luxurious_lifestyle",
                text: "Като професионален търговски терминал, но с лекотата на използване на TradingView. Перфектна комбинация!"
            }, {
                username: "@TheJaslan",
                text: "С TradingView Desktop изпълнявам сделки по-бързо и остават напред пред пазара!"
            }, {
                username: "@Market Mentor Network",
                text: "Увеличението на производителността е невероятно! Няма повече бавни графики или пропуснати възможности."
            }, {
                username: "@noxonfx",
                text: "Търгувам отвсякъде, а настолното приложение поддържа работния ми процес гладко на всички устройства!"
            }])
        },
        hr: {
            "loveInEvery.title1": "Ljubav u svakom",
            "loveInEvery.title2": "#TradingView",
            "loveInEvery.testimonials": JSON.stringify([{
                username: "@mytradingsetup",
                text: "Desktop aplikacija je munjevito brza! Nema više kašnjenja preglednika—samo glatko crtanje grafikona i trgovanje."
            }, {
                username: "@chrisianrodriguezdr",
                text: "TradingView čini analiziranje grafikona zadovoljstvom! Stvarno uživam u analiziranju grafikona."
            }, {
                username: "@ejacobsfx",
                text: "Funkcija podijeljenog ekrana je revolucionarna! Mogu pratiti više imovine odjednom bez prebacivanja kartica."
            }, {
                username: "@joey_vittorelli",
                text: "Konačno! Aplikacija za trgovanje koja ne troši resurse mog računala!"
            }, {
                username: "@carly_summerz",
                text: "TradingView Desktop je potpuno promijenio moj tijek rada! Trgovam brže i analiziram bolje!"
            }, {
                username: "@tradingView",
                text: "Moj stil života trgovanja je glađi nego ikad. Bez smetnji, samo čisti, profesionalni grafikoni."
            }, {
                username: "@johndollery",
                text: "Ažuriranja u stvarnom vremenu i bez rušenja preglednika! TradingView Desktop je neophodan!"
            }, {
                username: "@ftmcomx",
                text: "Mogu prilagoditi svoju postavku točno kako želim. TradingView Desktop čini moj život lakšim!"
            }, {
                username: "@most_luxurious_lifestyle",
                text: "Kao profesionalni trgovinski terminal, ali s lakoćom korištenja TradingView-a. Savršena kombinacija!"
            }, {
                username: "@TheJaslan",
                text: "S TradingView Desktop-om, izvršavam trgovine brže i ostajem ispred tržišta!"
            }, {
                username: "@Market Mentor Network",
                text: "Povećanje performansi je nevjerojatno! Nema više sporih grafikona ili propuštenih prilika."
            }, {
                username: "@noxonfx",
                text: "Trgovam odakle god, a desktop aplikacija drži moj tijek rada glatkim na svim uređajima!"
            }])
        },
        xk: {
            "loveInEvery.title1": "Dashuria në çdo / Ljubav u svakom",
            "loveInEvery.title2": "#TradingView",
            "loveInEvery.testimonials": JSON.stringify([{
                username: "@mytradingsetup",
                text: "Aplikacioni desktop është rrufeshkak! Nuk ka më vonesë shfletuesi—vetëm grafik të qetë dhe tregtim. / Desktop aplikacija je munjevito brza! Nema kašnjenja preglednika."
            }, {
                username: "@chrisianrodriguezdr",
                text: "TradingView e bën analizën e grafikëve kënaqësi! Më pëlqen vërtet analizimi i grafikëve. / TradingView čini analizu grafikona zadovoljstvom!"
            }, {
                username: "@ejacobsfx",
                text: "Ekrani i ndarë është ndryshues loje! Mund të ndjek shumë aktive njëkohësisht. / Podijeljen ekran je revolucionaran! Mogu pratiti više sredstava odjednom."
            }, {
                username: "@joey_vittorelli",
                text: "Së fundi! Aplikacion tregtie që nuk konsumon resurset e kompjuterit! / Konačno! Aplikacija koja ne troši resurse računala!"
            }, {
                username: "@carly_summerz",
                text: "TradingView Desktop ndryshoi plotësisht rrjedhën time të punës! / TradingView Desktop je potpuno promijenio moj tijek rada!"
            }, {
                username: "@tradingView",
                text: "Stili im i jetës tregtare është më i qetë se kurrë. / Moj stil života trgovanja je glađi nego ikad."
            }, {
                username: "@johndollery",
                text: "Përditësime në kohë reale dhe pa rrëzime shfletuesi! / Ažuriranja u realnom vremenu i bez rušenja preglednika!"
            }, {
                username: "@ftmcomx",
                text: "Mund ta personalizoj siç dua. TradingView Desktop bën jetën më të lehtë! / Mogu prilagoditi kako želim. Čini život lakšim!"
            }, {
                username: "@most_luxurious_lifestyle",
                text: "Si terminal tregtie profesional, por me lehtësinë e TradingView. / Kao profesionalni trgovinski terminal s lakoćom TradingView-a."
            }, {
                username: "@TheJaslan",
                text: "Me TradingView Desktop ekzekutoj tregti më shpejt! / S TradingView Desktop izvršavam trgovine brže!"
            }, {
                username: "@Market Mentor Network",
                text: "Rritja e performancës është e çmendur! / Povećanje performansi je nevjerojatno!"
            }, {
                username: "@noxonfx",
                text: "Tregtoj nga kudo dhe aplikacioni desktop mban rrjedhën e punës të qetë! / Trgovam odakle god, aplikacija drži tijek rada glatkim!"
            }])
        },
        me: {
            "loveInEvery.title1": "Љубав у сваком",
            "loveInEvery.title2": "#TradingView",
            "loveInEvery.testimonials": JSON.stringify([{
                username: "@mytradingsetup",
                text: "Десктоп апликација је муњевито брза! Нема више кашњења прегледника—само глатко цртање графика и трговање."
            }, {
                username: "@chrisianrodriguezdr",
                text: "TradingView чини анализирање графика задовољством! Стварно уживам у анализирању графика."
            }, {
                username: "@ejacobsfx",
                text: "Функција подијељеног екрана је револуционарна! Могу пратити више средстава одједном без пребацивања табова."
            }, {
                username: "@joey_vittorelli",
                text: "Коначно! Апликација за трговање која не троши ресурсе мог рачунара!"
            }, {
                username: "@carly_summerz",
                text: "TradingView Desktop је потпуно промијенио мој ток рада! Трговам брже и анализирам боље!"
            }, {
                username: "@tradingView",
                text: "Мој стил живота трговања је глађи него икад. Без сметњи, само чисти, професионални графици."
            }, {
                username: "@johndollery",
                text: "Ажурирања у реалном времену и без рушења прегледника! TradingView Desktop је неопходан!"
            }, {
                username: "@ftmcomx",
                text: "Могу прилагодити своју поставку тачно како желим. TradingView Desktop чини мој живот лакшим!"
            }, {
                username: "@most_luxurious_lifestyle",
                text: "Као професионални трговински терминал, али с лакоћом коришћења TradingView-а. Савршена комбинација!"
            }, {
                username: "@TheJaslan",
                text: "С TradingView Desktop-ом, извршавам трговине брже и остајем испред тржишта!"
            }, {
                username: "@Market Mentor Network",
                text: "Повећање перформанси је невјероватно! Нема више спорих графика или пропуштених прилика."
            }, {
                username: "@noxonfx",
                text: "Трговам одакле год, а десктоп апликација држи мој ток рада глатким на свим уређајима!"
            }])
        },
        mk: {
            "loveInEvery.title1": "Љубов во секој",
            "loveInEvery.title2": "#TradingView",
            "loveInEvery.testimonials": JSON.stringify([{
                username: "@mytradingsetup",
                text: "Десктоп апликацијата е молњевито брза! Нема повеќе задоцнување на прелистувачот—само мазни графикони и тргување."
            }, {
                username: "@chrisianrodriguezdr",
                text: "TradingView го прави анализирањето на графиконите задоволство! Навистина уживам во анализирањето на графикони."
            }, {
                username: "@ejacobsfx",
                text: "Функцијата на поделен екран е револуционерна! Можам да следам повеќе средства одеднаш без менување табови."
            }, {
                username: "@joey_vittorelli",
                text: "Конечно! Апликација за тргување која не ги троши ресурсите на мојот компјутер!"
            }, {
                username: "@carly_summerz",
                text: "TradingView Desktop целосно го промени мојот работен тек! Тргувам побрзо и анализирам подобро!"
            }, {
                username: "@tradingView",
                text: "Мојот стил на живот на тргување е помазен од кога и да било. Без одвраќање, само чисти, професионални графикони."
            }, {
                username: "@johndollery",
                text: "Ажурирања во реално време и без урнување на прелистувачот! TradingView Desktop е задолжителен!"
            }, {
                username: "@ftmcomx",
                text: "Можам да ги приспособам поставките токму како што сакам. TradingView Desktop го прави мојот живот полесен!"
            }, {
                username: "@most_luxurious_lifestyle",
                text: "Како професионален трговски терминал, но со лесноста на користење на TradingView. Совршена комбинација!"
            }, {
                username: "@TheJaslan",
                text: "Со TradingView Desktop, ги извршувам трговите побрзо и останувам пред пазарот!"
            }, {
                username: "@Market Mentor Network",
                text: "Зголемувањето на перформансите е невероятно! Нема повеќе бавни графикони или пропуштени можности."
            }, {
                username: "@noxonfx",
                text: "Тргувам од каде било, а десктоп апликацијата го одржува мојот работен тек мазно на сите уреди!"
            }])
        },
        ro: {
            "loveInEvery.title1": "Dragoste în fiecare",
            "loveInEvery.title2": "#TradingView",
            "loveInEvery.testimonials": JSON.stringify([{
                username: "@mytradingsetup",
                text: "Aplicația desktop este fulgerătoare! Nu mai sunt întârzieri de browser—doar grafice și tranzacționare fluide."
            }, {
                username: "@chrisianrodriguezdr",
                text: "TradingView face analizarea graficelor o plăcere! Îmi place cu adevărat să analizez graficele."
            }, {
                username: "@ejacobsfx",
                text: "Funcția ecran împărțit schimbă totul! Pot urmări mai multe active simultan fără să schimb file."
            }, {
                username: "@joey_vittorelli",
                text: "În sfârșit! O aplicație de tranzacționare care nu consumă resursele computerului meu!"
            }, {
                username: "@carly_summerz",
                text: "TradingView Desktop mi-a schimbat complet fluxul de lucru! Tranzacționez mai rapid și analizez mai bine!"
            }, {
                username: "@tradingView",
                text: "Stilul meu de viață de tranzacționare este mai fluid ca niciodată. Fără distrageri, doar grafice curate și profesionale."
            }, {
                username: "@johndollery",
                text: "Actualizări în timp real și fără căderi de browser! TradingView Desktop este indispensabil!"
            }, {
                username: "@ftmcomx",
                text: "Pot personaliza configurația exact cum doresc. TradingView Desktop îmi face viața mai ușoară!"
            }, {
                username: "@most_luxurious_lifestyle",
                text: "Ca un terminal de tranzacționare profesional, dar cu ușurința de utilizare TradingView. Combinație perfectă!"
            }, {
                username: "@TheJaslan",
                text: "Cu TradingView Desktop, execut tranzacții mai rapid și rămân înaintea pieței!"
            }, {
                username: "@Market Mentor Network",
                text: "Creșterea performanței este incredibilă! Nu mai sunt grafice cu încărcare lentă sau oportunități ratate."
            }, {
                username: "@noxonfx",
                text: "Tranzacționez de oriunde, iar aplicația desktop îmi menține fluxul de lucru fluid pe toate dispozitivele!"
            }])
        },
        sr: {
            "loveInEvery.title1": "Љубав у сваком",
            "loveInEvery.title2": "#TradingView",
            "loveInEvery.testimonials": JSON.stringify([{
                username: "@mytradingsetup",
                text: "Десктоп апликација је муњевито брза! Нема више кашњења прегледника—само глатко цртање графикона и трговање."
            }, {
                username: "@chrisianrodriguezdr",
                text: "TradingView чини анализирање графикона задовољством! Стварно уживам у анализирању графикона."
            }, {
                username: "@ejacobsfx",
                text: "Функција подељеног екрана је револуционарна! Могу пратити више средстава одједном без пребацивања табова."
            }, {
                username: "@joey_vittorelli",
                text: "Коначно! Апликација за трговање која не троши ресурсе мог рачунара!"
            }, {
                username: "@carly_summerz",
                text: "TradingView Desktop је потпуно променио мој ток рада! Трговам брже и анализирам боље!"
            }, {
                username: "@tradingView",
                text: "Мој стил живота трговања је глађи него икад. Без сметњи, само чисти, професионални графикони."
            }, {
                username: "@johndollery",
                text: "Ажурирања у реалном времену и без рушења прегледника! TradingView Desktop је неопходан!"
            }, {
                username: "@ftmcomx",
                text: "Могу прилагодити своју поставку тачно како желим. TradingView Desktop чини мој живот лакшим!"
            }, {
                username: "@most_luxurious_lifestyle",
                text: "Као професионални трговински терминал, али с лакоћом коришћења TradingView-а. Савршена комбинација!"
            }, {
                username: "@TheJaslan",
                text: "Са TradingView Desktop-ом, извршавам трговине брже и остајем испред тржишта!"
            }, {
                username: "@Market Mentor Network",
                text: "Повећање перформанси је невероватно! Нема више спорих графикона или пропуштених прилика."
            }, {
                username: "@noxonfx",
                text: "Трговам одакле год, а десктоп апликација држи мој ток рада глатким на свим уређајима!"
            }])
        },
        sl: {
            "loveInEvery.title1": "Ljubezen v vsakem",
            "loveInEvery.title2": "#TradingView",
            "loveInEvery.testimonials": JSON.stringify([{
                username: "@mytradingsetup",
                text: "Namizna aplikacija je bliskovito hitra! Ni več zaostajanja brskalnika—samo gladko risanje grafov in trgovanje."
            }, {
                username: "@chrisianrodriguezdr",
                text: "TradingView dela analiziranje grafov v užitek! Resnično uživam v analiziranju grafov."
            }, {
                username: "@ejacobsfx",
                text: "Funkcija razdeljenega zaslona spreminja igro! Lahko sledim več sredstvom hkrati brez preklapljanja zavihkov."
            }, {
                username: "@joey_vittorelli",
                text: "Končno! Aplikacija za trgovanje, ki ne porablja virov mojega računalnika!"
            }, {
                username: "@carly_summerz",
                text: "TradingView Desktop je popolnoma spremenil moj delovni proces! Trgovam hitreje in analiziram bolje!"
            }, {
                username: "@tradingView",
                text: "Moj trgovalni življenjski slog je bolj tekoč kot kadarkoli. Brez motenj, samo čisti, profesionalni grafi."
            }, {
                username: "@johndollery",
                text: "Posodobitve v realnem času in brez sesutja brskalnika! TradingView Desktop je nujen!"
            }, {
                username: "@ftmcomx",
                text: "Lahko prilagodim svojo nastavitev točno tako, kot želim. TradingView Desktop mi olajša življenje!"
            }, {
                username: "@most_luxurious_lifestyle",
                text: "Kot profesionalni trgovalni terminal, vendar z lahkoto uporabe TradingView. Popolna kombinacija!"
            }, {
                username: "@TheJaslan",
                text: "Z TradingView Desktop izvršujem posle hitreje in ostanem pred trgom!"
            }, {
                username: "@Market Mentor Network",
                text: "Povečanje zmogljivosti je neverjetno! Ni več počasnih grafov ali zamujenih priložnosti."
            }, {
                username: "@noxonfx",
                text: "Trgovam od kjerkoli, namizna aplikacija pa ohranja moj delovni proces tekoč na vseh napravah!"
            }])
        },
        sk: {
            "loveInEvery.title1": "Láska v každom",
            "loveInEvery.title2": "#TradingView",
            "loveInEvery.testimonials": JSON.stringify([{
                username: "@mytradingsetup",
                text: "Desktopová aplikácia je blesky rýchla! Žiadne oneskorenia prehliadača—len hladké grafy a obchodovanie."
            }, {
                username: "@chrisianrodriguezdr",
                text: "TradingView robí analýzu grafov potešením! Skutočne si užívam analýzu grafov."
            }, {
                username: "@ejacobsfx",
                text: "Funkcia rozdelenej obrazovky mení hru! Môžem sledovať viac aktív naraz bez prepínania kariet."
            }, {
                username: "@joey_vittorelli",
                text: "Konečne! Obchodná aplikácia, ktorá nevyčerpáva zdroje môjho počítača!"
            }, {
                username: "@carly_summerz",
                text: "TradingView Desktop úplne zmenil môj pracovný tok! Obchodujem rýchlejšie a analyzujem lepšie!"
            }, {
                username: "@tradingView",
                text: "Môj obchodný životný štýl je plynulejší ako kedykoľvek. Bez rozptyľovania, len čisté, profesionálne grafy."
            }, {
                username: "@johndollery",
                text: "Aktualizácie v reálnom čase a bez pádov prehliadača! TradingView Desktop je nevyhnutný!"
            }, {
                username: "@ftmcomx",
                text: "Môžem si prispôsobiť nastavenie presne podľa svojich predstáv. TradingView Desktop mi uľahčuje život!"
            }, {
                username: "@most_luxurious_lifestyle",
                text: "Ako profesionálny obchodný terminál, ale s ľahkosťou používania TradingView. Dokonalá kombinácia!"
            }, {
                username: "@TheJaslan",
                text: "S TradingView Desktop vykonávam obchody rýchlejšie a zostávam pred trhom!"
            }, {
                username: "@Market Mentor Network",
                text: "Zvýšenie výkonu je šialené! Žiadne pomalé grafy ani zmeškaných príležitostí."
            }, {
                username: "@noxonfx",
                text: "Obchodujem odkiaľkoľvek a desktopová aplikácia udržuje môj pracovný tok plynulý na všetkých zariadeniach!"
            }])
        },
        md: {
            "loveInEvery.title1": "Dragoste în fiecare",
            "loveInEvery.title2": "#TradingView",
            "loveInEvery.testimonials": JSON.stringify([{
                username: "@mytradingsetup",
                text: "Aplicația desktop este fulgerătoare! Nu mai sunt întârzieri de browser—doar grafice și tranzacționare fluide."
            }, {
                username: "@chrisianrodriguezdr",
                text: "TradingView face analizarea graficelor o plăcere! Îmi place cu adevărat să analizez graficele."
            }, {
                username: "@ejacobsfx",
                text: "Funcția ecran împărțit schimbă totul! Pot urmări mai multe active simultan fără să schimb file."
            }, {
                username: "@joey_vittorelli",
                text: "În sfârșit! O aplicație de tranzacționare care nu consumă resursele computerului meu!"
            }, {
                username: "@carly_summerz",
                text: "TradingView Desktop mi-a schimbat complet fluxul de lucru! Tranzacționez mai rapid și analizez mai bine!"
            }, {
                username: "@tradingView",
                text: "Stilul meu de viață de tranzacționare este mai fluid ca niciodată. Fără distrageri, doar grafice curate și profesionale."
            }, {
                username: "@johndollery",
                text: "Actualizări în timp real și fără căderi de browser! TradingView Desktop este indispensabil!"
            }, {
                username: "@ftmcomx",
                text: "Pot personaliza configurația exact cum doresc. TradingView Desktop îmi face viața mai ușoară!"
            }, {
                username: "@most_luxurious_lifestyle",
                text: "Ca un terminal de tranzacționare profesional, dar cu ușurința de utilizare TradingView. Combinație perfectă!"
            }, {
                username: "@TheJaslan",
                text: "Cu TradingView Desktop, execut tranzacții mai rapid și rămân înaintea pieței!"
            }, {
                username: "@Market Mentor Network",
                text: "Creșterea performanței este incredibilă! Nu mai sunt grafice cu încărcare lentă sau oportunități ratate."
            }, {
                username: "@noxonfx",
                text: "Tranzacționez de oriunde, iar aplicația desktop îmi menține fluxul de lucru fluid pe toate dispozitivele!"
            }])
        },
        ge: {
            "loveInEvery.title1": "სიყვარული ყოველ",
            "loveInEvery.title2": "#TradingView",
            "loveInEvery.testimonials": JSON.stringify([{
                username: "@mytradingsetup",
                text: "დესკტოპის აპლიკაცია განსაკუთრებით სწრაფია! აღარ არის ბრაუზერის გაყოვნება—მხოლოდ გლუვი ჩარტები და ვაჭრობა."
            }, {
                username: "@chrisianrodriguezdr",
                text: "TradingView ჩარტების ანალიზს სიამოვნებად აქცევს! მე ჭეშმარიტად ვსიამოვნებ ჩარტების ანალიზით."
            }, {
                username: "@ejacobsfx",
                text: "გაყოფილი ეკრანის ფუნქცია თამაშის შემცვლელია! შემიძლია ერთდროულად რამდენიმე აქტივის თვალყური ვადევნო ტაბების გადართვის გარეშე."
            }, {
                username: "@joey_vittorelli",
                text: "და ბოლოს! ვაჭრობის აპლიკაცია, რომელიც არ ანაწილებს ჩემი კომპიუტერის რესურსებს!"
            }, {
                username: "@carly_summerz",
                text: "TradingView Desktop-მა სრულად შეცვალა ჩემი სამუშაო ნაკადი! მე ვვაჭრობ უფრო სწრაფად და ვანალიზებ უკეთ!"
            }, {
                username: "@tradingView",
                text: "ჩემი ვაჭრობის ცხოვრების სტილი ყველაზე გლუვია ვიდრე ოდესმე. გადახრების გარეშე, მხოლოდ სუფთა, პროფესიონალური ჩარტები."
            }, {
                username: "@johndollery",
                text: "რეალური დროის განახლებები და ბრაუზერის ჩამოვარდნის გარეშე! TradingView Desktop აუცილებელია!"
            }, {
                username: "@ftmcomx",
                text: "შემიძლია ჩემი კონფიგურაცია ისე მოვარგო, როგორც მინდა. TradingView Desktop ჩემს ცხოვრებას ამარტივებს!"
            }, {
                username: "@most_luxurious_lifestyle",
                text: "როგორც პროფესიონალური ვაჭრობის ტერმინალი, მაგრამ TradingView-ის გამოყენების სიმარტივით. შესანიშნავი კომბინაცია!"
            }, {
                username: "@TheJaslan",
                text: "TradingView Desktop-ით, მე ვაჭრობს უფრო სწრაფად ვასრულებ და ბაზარზე წინ ვრჩები!"
            }, {
                username: "@Market Mentor Network",
                text: "წარმადობის ზრდა უკვდავია! აღარ არის ნელი ჩატვირთვის ჩარტები ან გამოტოვებული შანსები."
            }, {
                username: "@noxonfx",
                text: "მე ვვაჭრობ ყველგან, ხოლო დესკტოპის აპლიკაცია ჩემს სამუშაო ნაკადს ყველა მოწყობილობაზე გლუვად ინარჩუნებს!"
            }])
        },
        by: {
            "loveInEvery.title1": "Кахання ў кожным",
            "loveInEvery.title2": "#TradingView",
            "loveInEvery.testimonials": JSON.stringify([{
                username: "@mytradingsetup",
                text: "Настольная праграма працуе маланкава! Больш ніякіх затрымак браўзера—толькі плаўныя дыяграмы і гандаль."
            }, {
                username: "@chrisianrodriguezdr",
                text: "TradingView робіць аналіз дыяграм сапраўдным задавальненнем! Мне сапраўды падабаецца аналізаваць дыяграмы."
            }, {
                username: "@ejacobsfx",
                text: "Функцыя падзеленага экрана—гэта рэвалюцыя! Я магу адсочваць некалькі актываў адначасова, не пераключаючы ўкладкі."
            }, {
                username: "@joey_vittorelli",
                text: "Нарэшце! Гандлёвая праграма, якая не вычэрпвае рэсурсы майго кампутара!"
            }, {
                username: "@carly_summerz",
                text: "TradingView Desktop цалкам змяніў мой працоўны працэс! Я гандлюю хутчэй і аналізую лепш!"
            }, {
                username: "@tradingView",
                text: "Мой гандлёвы лад жыцця стаў больш плаўным, чым калі-небудзь. Без адцягненняў, толькі чыстыя, прафесійныя дыяграмы."
            }, {
                username: "@johndollery",
                text: "Абнаўленні ў рэальным часе і без збояў браўзера! TradingView Desktop абавязковы!"
            }, {
                username: "@ftmcomx",
                text: "Я магу наладзіць сваю канфігурацыю дакладна так, як хачу. TradingView Desktop робіць маё жыццё прасцейшым!"
            }, {
                username: "@most_luxurious_lifestyle",
                text: "Як прафесійны гандлёвы тэрмінал, але з лёгкасцю выкарыстання TradingView. Ідэальнае спалучэнне!"
            }, {
                username: "@TheJaslan",
                text: "З TradingView Desktop я выконваю здзелкі хутчэй і застаюся наперадзе рынку!"
            }, {
                username: "@Market Mentor Network",
                text: "Павелічэнне прадукцыйнасці неверагодна! Больш няма павольных дыяграм або прапушчаных магчымасцей."
            }, {
                username: "@noxonfx",
                text: "Я гандлюю адусюль, а настольная праграма падтрымлівае мой працоўны працэс плаўным на ўсіх прыладах!"
            }])
        },
        pt: {
            "loveInEvery.title1": "Amor em cada",
            "loveInEvery.title2": "#TradingView",
            "loveInEvery.testimonials": JSON.stringify([{
                username: "@mytradingsetup",
                text: "O aplicativo desktop é super rápido! Sem mais atrasos do navegador—apenas gráficos e negociação suaves."
            }, {
                username: "@chrisianrodriguezdr",
                text: "TradingView torna a análise de gráficos um prazer! Eu realmente gosto de analisar gráficos."
            }, {
                username: "@ejacobsfx",
                text: "O recurso de tela dividida é revolucionário! Eu acompanho múltiplos ativos ao mesmo tempo sem trocar de abas."
            }, {
                username: "@joey_vittorelli",
                text: "Finalmente, um aplicativo de negociação que não consome os recursos do meu computador!"
            }, {
                username: "@carly_summerz",
                text: "TradingView Desktop mudou completamente meu fluxo de trabalho! Eu negocia mais rápido e analiso melhor!"
            }, {
                username: "@tradingView",
                text: "Meu estilo de vida de negociação está mais suave do que nunca. Sem distrações, apenas gráficos limpos e profissionais."
            }, {
                username: "@johndollery",
                text: "Atualizações em tempo real e sem travamentos do navegador! TradingView Desktop é essencial!"
            }, {
                username: "@ftmcomx",
                text: "Posso personalizar minha configuração exatamente como quero. TradingView Desktop torna minha vida mais fácil!"
            }, {
                username: "@most_luxurious_lifestyle",
                text: "É como um terminal de negociação profissional, mas com a facilidade de uso do TradingView. Combinação perfeita!"
            }, {
                username: "@TheJaslan",
                text: "Com TradingView Desktop, executo negociações mais rápido e fico à frente do mercado!"
            }, {
                username: "@Market Mentor Network",
                text: "O aumento de desempenho é incrível! Não há mais gráficos de carregamento lento ou oportunidades perdidas."
            }, {
                username: "@noxonfx",
                text: "Eu negocia de qualquer lugar, e o aplicativo desktop mantém meu fluxo de trabalho perfeito em todos os dispositivos!"
            }])
        }
    };
    return e[i] || e.en
}
  , hS = () => {
    const {i18n: i} = We()
      , e = i.language
      , r = mS(e)
      , a = N.useRef(null)
      , [o,l] = N.useState(0)
      , [u,d] = N.useState(!0)
      , [p,h] = N.useState(!1);
    console.log(r["loveInEvery.title1"]);
    const g = () => {
        var z;
        (z = a.current) == null || z.slidePrev()
    }
      , v = () => {
        var z;
        (z = a.current) == null || z.slideNext()
    }
      , y = () => {
        if (a.current) {
            const z = a.current;
            l(z.realIndex),
            d(z.isBeginning),
            h(z.isEnd)
        }
    }
      , P = z => {
        var C;
        (C = a.current) == null || C.slideTo(z)
    }
      , w = () => typeof window > "u" || window.innerWidth < 640 ? 1 : window.innerWidth < 768 ? 2 : window.innerWidth < 1024 ? 3 : 4
      , S = () => JSON.parse(r["loveInEvery.testimonials"]).map( (C, b) => ({
        ...C,
        image: Lc[b].image
    }));
    return x.jsxs("section", {
        id: "reviews",
        className: "max-w-[1376px] w-full mx-auto flex flex-col py-4 sm:py-6 md:py-8 gap-4 sm:gap-6 md:gap-8 px-4 lg:px-0",
        children: [x.jsx("div", {
            className: "flex flex-col items-center justify-center text-center",
            children: x.jsxs("h2", {
                className: "text-[#0D1013] font-semibold text-[36px] sm:text-[48px] md:text-[64px] leading-tight md:leading-[64px] capitalize",
                children: [r["loveInEvery.title1"], x.jsx("br", {}), r["loveInEvery.title2"]]
            })
        }), x.jsxs("div", {
            className: "w-full relative px-4 md:px-0",
            children: [x.jsx(S0, {
                onBeforeInit: z => {
                    a.current = z
                }
                ,
                slidesPerView: 1,
                spaceBetween: 16,
                modules: [cS, uS],
                onSlideChange: y,
                className: "w-full",
                watchSlidesProgress: !0,
                watchOverflow: !0,
                breakpoints: {
                    320: {
                        slidesPerView: 1,
                        spaceBetween: 16
                    },
                    640: {
                        slidesPerView: 2,
                        spaceBetween: 20
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 24
                    },
                    1024: {
                        slidesPerView: 3,
                        spaceBetween: 28
                    },
                    1280: {
                        slidesPerView: 4,
                        spaceBetween: 32
                    }
                },
                children: S().map( (z, C) => x.jsx(T0, {
                    children: x.jsx(pS, {
                        image: z.image,
                        username: z.username,
                        text: z.text
                    })
                }, C))
            }), x.jsx(nf, {
                direction: "prev",
                onClick: g,
                disabled: u
            }), x.jsx(nf, {
                direction: "next",
                onClick: v,
                disabled: p
            }), x.jsx(dS, {
                totalSlides: Lc.length - (w() - 1),
                activeIndex: o,
                onSelect: P
            })]
        })]
    })
}
  , fS = "/cdn/shop/t/1/assets/unmis1-Cr_kny8d.webp"
  , af = {
    en: {
        title: "UNMISSABLE ALERTS",
        description: "Trading Alerts Were Never This Powerful, Flexible And Easy To Use. Cloud-Based, They Are Available On Any Device And Can Be Powered By Pine Script®."
    },
    es: {
        title: "ALERTAS IMPERDIBLES",
        description: "Las Alertas de Trading Nunca Fueron Tan Potentes, Flexibles y Fáciles de Usar. Basadas en la Nube, Están Disponibles en Cualquier Dispositivo y Pueden Ser Impulsadas por Pine Script®."
    },
    vi: {
        title: "CẢNH BÁO KHÔNG THỂ BỎ LỠ",
        description: "Cảnh Báo Giao Dịch Chưa Bao Giờ Mạnh Mẽ, Linh Hoạt Và Dễ Sử Dụng Đến Thế. Dựa Trên Đám Mây, Chúng Có Sẵn Trên Mọi Thiết Bị Và Có Thể Được Hỗ Trợ Bởi Pine Script®."
    },
    th: {
        title: "การแจ้งเตือนที่พลาดไม่ได้",
        description: "การแจ้งเตือนการเทรดไม่เคยทรงพลัง ยืดหยุ่น และใช้งานง่ายขนาดนี้มาก่อน ทำงานบนคลาวด์ สามารถใช้งานได้บนทุกอุปกรณ์ และสามารถขับเคลื่อนด้วย Pine Script®"
    },
    ja: {
        title: "見逃せないアラート",
        description: "トレーディングアラートがこれほど強力で柔軟、使いやすくなったことはありません。クラウドベースで、あらゆるデバイスで利用可能、Pine Script®で動作します。"
    },
    ko: {
        title: "놓칠 수 없는 알림",
        description: "이렇게 강력하고 유연하며 사용하기 쉬운 트레이딩 알림은 없었습니다. 클라우드 기반으로, 모든 기기에서 사용 가능하며 Pine Script®로 구동됩니다."
    },
    "zh-TW": {
        title: "不容錯過的警報",
        description: "交易警報從未如此強大、靈活且易於使用。基於雲端，可在任何裝置上使用，並可由 Pine Script® 驅動。"
    },
    ar: {
        title: "تنبيهات لا يمكن تفويتها",
        description: "لم تكن تنبيهات التداول بهذه القوة والمرونة وسهولة الاستخدام من قبل. قائمة على السحابة، متوفرة على أي جهاز ويمكن تشغيلها بواسطة Pine Script®."
    },
    bn: {
        title: "অপরিহার্য সতর্কতা",
        description: "ট্রেডিং সতর্কতা কখনও এত শক্তিশালী, নমনীয় এবং ব্যবহার করা সহজ ছিল না। ক্লাউড-ভিত্তিক, এগুলি যেকোনো ডিভাইসে উপলব্ধ এবং Pine Script® দ্বারা চালিত হতে পারে।"
    },
    id: {
        title: "PERINGATAN YANG TAK TERLEWATKAN",
        description: "Peringatan Trading Tidak Pernah Sekuat, Sefleksibel, dan Semudah Ini Digunakan. Berbasis Cloud, Tersedia di Semua Perangkat dan Dapat Dijalankan dengan Pine Script®."
    },
    ka: {
        title: "გამორჩეული გაფრთხილებები",
        description: "სავაჭრო გაფრთხილებები არასდროს ყოფილა ასეთი ძლიერი, მოქნილი და მარტივი გამოსაყენებლად. ღრუბლოვანი, ხელმისაწვდომია ნებისმიერ მოწყობილობაზე და შეიძლება იმუშაოს Pine Script®-ით."
    },
    mn: {
        title: "АЛДАЖ БОЛОХГҮЙ СЭРЭМЖЛҮҮЛЭГ",
        description: "Арилжааны Сэрэмжлүүлэг Өмнө Нь Ийм Хүчирхэг, Уян Хатан Бөгөөд Хэрэглэхэд Хялбар Байгаагүй. Үүлэн Технологид Суурилсан, Аль ч Төхөөрөмж дээр Ашиглах Боломжтой Бөгөөд Pine Script®-ээр Ажиллуулах Боломжтой."
    },
    tr: {
        title: "KAÇIRILMAYACAK UYARILAR",
        description: "İşlem Uyarıları Hiç Bu Kadar Güçlü, Esnek ve Kullanımı Kolay Olmamıştı. Bulut Tabanlı, Herhangi Bir Cihazda Kullanılabilir ve Pine Script® ile Çalıştırılabilir."
    },
    ru: {
        title: "Непревзойденные оповещения",
        description: "Торговые оповещения никогда не были такими мощными, гибкими и простыми в использовании. Они основаны на облаке, доступны на любом устройстве и могут быть настроены с помощью Pine Script®."
    },
    sq: {
        title: "ALARME TË PAKAPSHME",
        description: "Alarmet e Tregtimit Nuk Kanë Qenë Kurrë Kaq të Fuqishme, Fleksibile dhe të Lehta për t'u Përdorur. Të Bazuara në Re, Janë të Disponueshme në Çdo Pajisje dhe Mund të Aktivizohen nga Pine Script®."
    },
    bs: {
        title: "NEPREĆERNE OBAVIJESTI",
        description: "Trgovinske Obavijesti Nikad Nisu Bile Ovako Moćne, Fleksibilne i Lake za Korištenje. Bazirane na Oblaku, Dostupne su na Svim Uređajima i Mogu Biti Pokretane Pine Script®."
    },
    bg: {
        title: "НЕПОДРАЖАЕМИ СИГНАЛИ",
        description: "Търговските Сигнали Никога Не Са Били Толкова Мощни, Гъвкави и Лесни за Използване. Базирани на Облака, Те Са Достъпни на Всяко Устройство и Могат да Бъдат Задвижвани от Pine Script®."
    },
    hr: {
        title: "NEZAMJENJIVE OBAVIJESTI",
        description: "Trgovinski Signali Nikad Nisu Bili Ovako Moćni, Fleksibilni i Laki za Korištenje. Bazirani na Oblaku, Dostupni su na Svim Uređajima i Mogu Biti Pokretani Pine Script®."
    },
    xk: {
        title: "ALARME TË PAKAPSHME / NEPREĆERNE OBAVIJESTI",
        description: "Alarmet e Tregtimit Nuk Kanë Qenë Kurrë Kaq të Fuqishme dhe të Lehta për t'u Përdorur. Të Bazuara në Re, Janë të Disponueshme në Çdo Pajisje. / Trgovinske Obavijesti Nikad Nisu Bile Ovako Moćne i Lake za Korištenje. Bazirane na Oblaku, Dostupne su na Svim Uređajima."
    },
    me: {
        title: "НЕПРЕВАЗИЂЕНИ СИГНАЛИ",
        description: "Трговински Сигнали Никад Нису Били Овако Моћни, Флексибилни и Лаки за Коришћење. Базирани на Облаку, Доступни су на Свим Уређајима и Могу Бити Покретани Pine Script®."
    },
    mk: {
        title: "НЕИЗБЕЖНИ СИГНАЛИ",
        description: "Трговските Сигнали Никогаш Не Биле Толку Моќни, Флексибилни и Лесни за Користење. Базирани на Облак, Достапни се на Секој Уред и Можат да Бидат Активирани со Pine Script®."
    },
    ro: {
        title: "ALERTE INDISPENSABILE",
        description: "Alertele de Tranzacționare Nu Au Fost Niciodată Atât de Puternice, Flexibile și Ușor de Folosit. Bazate pe Cloud, Sunt Disponibile pe Orice Dispozitiv și Pot Fi Alimentate de Pine Script®."
    },
    sr: {
        title: "НЕПРЕВАЗИЂЕНИ СИГНАЛИ",
        description: "Трговински Сигнали Никад Нису Били Овако Моћни, Флексибилни и Лаки за Коришћење. Базирани на Облаку, Доступни су на Свим Уређајима и Могу Бити Покретани Pine Script®."
    },
    sl: {
        title: "NEPOGREŠLJIVA OPOZORILA",
        description: "Trgovinska Opozorila Nikoli Niso Bila Tako Močna, Prilagodljiva in Enostavna za Uporabo. Oblačno Osnovana, so na Voljo na Kateri Koli Napravi in Lahko Delujejo s Pine Script®."
    },
    sk: {
        title: "NEZMEŠKATEĽNÉ UPOZORNENIA",
        description: "Obchodné Upozornenia Nikdy Neboli Tak Výkonné, Flexibilné a Ľahko Použiteľné. Cloudové, sú Dostupné na Akomkoľvek Zariadení a Môžu Byť Poháňané Pine Script®."
    },
    md: {
        title: "ALERTE INDISPENSABILE",
        description: "Alertele de Tranzacționare Nu Au Fost Niciodată Atât de Puternice, Flexibile și Ușor de Folosit. Bazate pe Cloud, Sunt Disponibile pe Orice Dispozitiv și Pot Fi Alimentate de Pine Script®."
    },
    ge: {
        title: "გამორჩეული გაფრთხილებები",
        description: "სავაჭრო გაფრთხილებები არასდროს ყოფილა ასეთი ძლიერი, მოქნილი და მარტივი გამოსაყენებლად. ღრუბლოვანი, ხელმისაწვდომია ნებისმიერ მოწყობილობაზე და შეიძლება იმუშაოს Pine Script®-ით."
    },
    by: {
        title: "НЕАБХОДНЫЯ ПАПЯРЭДЖАННІ",
        description: "Гандлёвыя Папярэджанні Ніколі Не Былі Такімі Моцнымі, Гібкімі і Лёгкімі ў Выкарыстанні. Аблочныя, Яны Даступныя на Любой Прыладзе і Могуць Працаваць з Pine Script®."
    },
    pt: {
        title: "ALERTAS IMPERDÍVEIS",
        description: "Os Alertas de Trading Nunca Foram Tão Poderosos, Flexíveis e Fáceis de Usar. Baseados na Nuvem, Estão Disponíveis em Qualquer Dispositivo e Podem Ser Alimentados por Pine Script®."
    }
}
  , gS = () => {
    const {i18n: i} = We()
      , e = i.language
      , r = af[e] || af.en
      , a = N.useRef(null)
      , o = Ht(a, {
        once: !0,
        margin: "-100px"
    });
    return x.jsxs("section", {
        ref: a,
        id: "alert",
        className: "max-w-[1376px] w-full mx-auto flex flex-col gap-4 sm:gap-6 md:gap-8 py-4 sm:py-6 md:py-8 px-4 sm:px-6 md:px-8 lg:px-4",
        children: [x.jsxs(ee.div, {
            className: "flex flex-col gap-3 sm:gap-4 items-center justify-center text-center",
            initial: {
                opacity: 0,
                y: 20
            },
            animate: o ? {
                opacity: 1,
                y: 0
            } : {
                opacity: 0,
                y: 20
            },
            transition: {
                duration: .6
            },
            children: [x.jsx(ee.h2, {
                className: "text-[#0D1013] font-semibold text-[36px] sm:text-[48px] md:text-[64px] leading-tight md:leading-[64px] uppercase",
                initial: {
                    opacity: 0,
                    y: 20
                },
                animate: o ? {
                    opacity: 1,
                    y: 0
                } : {
                    opacity: 0,
                    y: 20
                },
                transition: {
                    duration: .6,
                    delay: .2
                },
                children: r.title
            }), x.jsx(ee.p, {
                className: "text-[#3B4046] text-[18px] sm:text-[22px] md:text-[28px] leading-snug sm:leading-normal md:leading-[40px] capitalize max-w-[90%] md:max-w-[80%]",
                initial: {
                    opacity: 0,
                    y: 20
                },
                animate: o ? {
                    opacity: 1,
                    y: 0
                } : {
                    opacity: 0,
                    y: 20
                },
                transition: {
                    duration: .6,
                    delay: .3
                },
                children: r.description
            })]
        }), x.jsx("img", {
            src: fS,
            alt: r.title,
            className: "w-full h-auto  hover:scale-[1.02] transition-transform duration-500"
        })]
    })
}
  , he = i => typeof i == "string"
  , zn = () => {
    let i, e;
    const r = new Promise( (a, o) => {
        i = a,
        e = o
    }
    );
    return r.resolve = i,
    r.reject = e,
    r
}
  , sf = i => i == null ? "" : "" + i
  , vS = (i, e, r) => {
    i.forEach(a => {
        e[a] && (r[a] = e[a])
    }
    )
}
  , yS = /###/g
  , of = i => i && i.indexOf("###") > -1 ? i.replace(yS, ".") : i
  , lf = i => !i || he(i)
  , Nn = (i, e, r) => {
    const a = he(e) ? e.split(".") : e;
    let o = 0;
    for (; o < a.length - 1; ) {
        if (lf(i))
            return {};
        const l = of(a[o]);
        !i[l] && r && (i[l] = new r),
        Object.prototype.hasOwnProperty.call(i, l) ? i = i[l] : i = {},
        ++o
    }
    return lf(i) ? {} : {
        obj: i,
        k: of(a[o])
    }
}
  , cf = (i, e, r) => {
    const {obj: a, k: o} = Nn(i, e, Object);
    if (a !== void 0 || e.length === 1) {
        a[o] = r;
        return
    }
    let l = e[e.length - 1]
      , u = e.slice(0, e.length - 1)
      , d = Nn(i, u, Object);
    for (; d.obj === void 0 && u.length; )
        l = `${u[u.length - 1]}.${l}`,
        u = u.slice(0, u.length - 1),
        d = Nn(i, u, Object),
        d != null && d.obj && typeof d.obj[`${d.k}.${l}`] < "u" && (d.obj = void 0);
    d.obj[`${d.k}.${l}`] = r
}
  , kS = (i, e, r, a) => {
    const {obj: o, k: l} = Nn(i, e, Object);
    o[l] = o[l] || [],
    o[l].push(r)
}
  , Vs = (i, e) => {
    const {obj: r, k: a} = Nn(i, e);
    if (r && Object.prototype.hasOwnProperty.call(r, a))
        return r[a]
}
  , xS = (i, e, r) => {
    const a = Vs(i, r);
    return a !== void 0 ? a : Vs(e, r)
}
  , C0 = (i, e, r) => {
    for (const a in e)
        a !== "__proto__" && a !== "constructor" && (a in i ? he(i[a]) || i[a]instanceof String || he(e[a]) || e[a]instanceof String ? r && (i[a] = e[a]) : C0(i[a], e[a], r) : i[a] = e[a]);
    return i
}
  , Sr = i => i.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
var wS = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;",
    "/": "&#x2F;"
};
const PS = i => he(i) ? i.replace(/[&<>"'\/]/g, e => wS[e]) : i;
class bS {
    constructor(e) {
        this.capacity = e,
        this.regExpMap = new Map,
        this.regExpQueue = []
    }
    getRegExp(e) {
        const r = this.regExpMap.get(e);
        if (r !== void 0)
            return r;
        const a = new RegExp(e);
        return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()),
        this.regExpMap.set(e, a),
        this.regExpQueue.push(e),
        a
    }
}
const SS = [" ", ",", "?", "!", ";"]
  , TS = new bS(20)
  , jS = (i, e, r) => {
    e = e || "",
    r = r || "";
    const a = SS.filter(u => e.indexOf(u) < 0 && r.indexOf(u) < 0);
    if (a.length === 0)
        return !0;
    const o = TS.getRegExp(`(${a.map(u => u === "?" ? "\\?" : u).join("|")})`);
    let l = !o.test(i);
    if (!l) {
        const u = i.indexOf(r);
        u > 0 && !o.test(i.substring(0, u)) && (l = !0)
    }
    return l
}
  , Oc = function(i, e) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".";
    if (!i)
        return;
    if (i[e])
        return Object.prototype.hasOwnProperty.call(i, e) ? i[e] : void 0;
    const a = e.split(r);
    let o = i;
    for (let l = 0; l < a.length; ) {
        if (!o || typeof o != "object")
            return;
        let u, d = "";
        for (let p = l; p < a.length; ++p)
            if (p !== l && (d += r),
            d += a[p],
            u = o[d],
            u !== void 0) {
                if (["string", "number", "boolean"].indexOf(typeof u) > -1 && p < a.length - 1)
                    continue;
                l += p - l + 1;
                break
            }
        o = u
    }
    return o
}
  , Ls = i => i == null ? void 0 : i.replace("_", "-")
  , CS = {
    type: "logger",
    log(i) {
        this.output("log", i)
    },
    warn(i) {
        this.output("warn", i)
    },
    error(i) {
        this.output("error", i)
    },
    output(i, e) {
        var r, a;
        (a = (r = console == null ? void 0 : console[i]) == null ? void 0 : r.apply) == null || a.call(r, console, e)
    }
};
class Os {
    constructor(e) {
        let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        this.init(e, r)
    }
    init(e) {
        let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        this.prefix = r.prefix || "i18next:",
        this.logger = e || CS,
        this.options = r,
        this.debug = r.debug
    }
    log() {
        for (var e = arguments.length, r = new Array(e), a = 0; a < e; a++)
            r[a] = arguments[a];
        return this.forward(r, "log", "", !0)
    }
    warn() {
        for (var e = arguments.length, r = new Array(e), a = 0; a < e; a++)
            r[a] = arguments[a];
        return this.forward(r, "warn", "", !0)
    }
    error() {
        for (var e = arguments.length, r = new Array(e), a = 0; a < e; a++)
            r[a] = arguments[a];
        return this.forward(r, "error", "")
    }
    deprecate() {
        for (var e = arguments.length, r = new Array(e), a = 0; a < e; a++)
            r[a] = arguments[a];
        return this.forward(r, "warn", "WARNING DEPRECATED: ", !0)
    }
    forward(e, r, a, o) {
        return o && !this.debug ? null : (he(e[0]) && (e[0] = `${a}${this.prefix} ${e[0]}`),
        this.logger[r](e))
    }
    create(e) {
        return new Os(this.logger,{
            prefix: `${this.prefix}:${e}:`,
            ...this.options
        })
    }
    clone(e) {
        return e = e || this.options,
        e.prefix = e.prefix || this.prefix,
        new Os(this.logger,e)
    }
}
var Ut = new Os;
class Ks {
    constructor() {
        this.observers = {}
    }
    on(e, r) {
        return e.split(" ").forEach(a => {
            this.observers[a] || (this.observers[a] = new Map);
            const o = this.observers[a].get(r) || 0;
            this.observers[a].set(r, o + 1)
        }
        ),
        this
    }
    off(e, r) {
        if (this.observers[e]) {
            if (!r) {
                delete this.observers[e];
                return
            }
            this.observers[e].delete(r)
        }
    }
    emit(e) {
        for (var r = arguments.length, a = new Array(r > 1 ? r - 1 : 0), o = 1; o < r; o++)
            a[o - 1] = arguments[o];
        this.observers[e] && Array.from(this.observers[e].entries()).forEach(u => {
            let[d,p] = u;
            for (let h = 0; h < p; h++)
                d(...a)
        }
        ),
        this.observers["*"] && Array.from(this.observers["*"].entries()).forEach(u => {
            let[d,p] = u;
            for (let h = 0; h < p; h++)
                d.apply(d, [e, ...a])
        }
        )
    }
}
class uf extends Ks {
    constructor(e) {
        let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
            ns: ["translation"],
            defaultNS: "translation"
        };
        super(),
        this.data = e || {},
        this.options = r,
        this.options.keySeparator === void 0 && (this.options.keySeparator = "."),
        this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0)
    }
    addNamespaces(e) {
        this.options.ns.indexOf(e) < 0 && this.options.ns.push(e)
    }
    removeNamespaces(e) {
        const r = this.options.ns.indexOf(e);
        r > -1 && this.options.ns.splice(r, 1)
    }
    getResource(e, r, a) {
        var h, g;
        let o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
        const l = o.keySeparator !== void 0 ? o.keySeparator : this.options.keySeparator
          , u = o.ignoreJSONStructure !== void 0 ? o.ignoreJSONStructure : this.options.ignoreJSONStructure;
        let d;
        e.indexOf(".") > -1 ? d = e.split(".") : (d = [e, r],
        a && (Array.isArray(a) ? d.push(...a) : he(a) && l ? d.push(...a.split(l)) : d.push(a)));
        const p = Vs(this.data, d);
        return !p && !r && !a && e.indexOf(".") > -1 && (e = d[0],
        r = d[1],
        a = d.slice(2).join(".")),
        p || !u || !he(a) ? p : Oc((g = (h = this.data) == null ? void 0 : h[e]) == null ? void 0 : g[r], a, l)
    }
    addResource(e, r, a, o) {
        let l = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
            silent: !1
        };
        const u = l.keySeparator !== void 0 ? l.keySeparator : this.options.keySeparator;
        let d = [e, r];
        a && (d = d.concat(u ? a.split(u) : a)),
        e.indexOf(".") > -1 && (d = e.split("."),
        o = r,
        r = d[1]),
        this.addNamespaces(r),
        cf(this.data, d, o),
        l.silent || this.emit("added", e, r, a, o)
    }
    addResources(e, r, a) {
        let o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
            silent: !1
        };
        for (const l in a)
            (he(a[l]) || Array.isArray(a[l])) && this.addResource(e, r, l, a[l], {
                silent: !0
            });
        o.silent || this.emit("added", e, r, a)
    }
    addResourceBundle(e, r, a, o, l) {
        let u = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {
            silent: !1,
            skipCopy: !1
        }
          , d = [e, r];
        e.indexOf(".") > -1 && (d = e.split("."),
        o = a,
        a = r,
        r = d[1]),
        this.addNamespaces(r);
        let p = Vs(this.data, d) || {};
        u.skipCopy || (a = JSON.parse(JSON.stringify(a))),
        o ? C0(p, a, l) : p = {
            ...p,
            ...a
        },
        cf(this.data, d, p),
        u.silent || this.emit("added", e, r, a)
    }
    removeResourceBundle(e, r) {
        this.hasResourceBundle(e, r) && delete this.data[e][r],
        this.removeNamespaces(r),
        this.emit("removed", e, r)
    }
    hasResourceBundle(e, r) {
        return this.getResource(e, r) !== void 0
    }
    getResourceBundle(e, r) {
        return r || (r = this.options.defaultNS),
        this.getResource(e, r)
    }
    getDataByLanguage(e) {
        return this.data[e]
    }
    hasLanguageSomeTranslations(e) {
        const r = this.getDataByLanguage(e);
        return !!(r && Object.keys(r) || []).find(o => r[o] && Object.keys(r[o]).length > 0)
    }
    toJSON() {
        return this.data
    }
}
var z0 = {
    processors: {},
    addPostProcessor(i) {
        this.processors[i.name] = i
    },
    handle(i, e, r, a, o) {
        return i.forEach(l => {
            var u;
            e = ((u = this.processors[l]) == null ? void 0 : u.process(e, r, a, o)) ?? e
        }
        ),
        e
    }
};
const df = {}
  , pf = i => !he(i) && typeof i != "boolean" && typeof i != "number";
class Ns extends Ks {
    constructor(e) {
        let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        super(),
        vS(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], e, this),
        this.options = r,
        this.options.keySeparator === void 0 && (this.options.keySeparator = "."),
        this.logger = Ut.create("translator")
    }
    changeLanguage(e) {
        e && (this.language = e)
    }
    exists(e) {
        let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
            interpolation: {}
        };
        if (e == null)
            return !1;
        const a = this.resolve(e, r);
        return (a == null ? void 0 : a.res) !== void 0
    }
    extractFromKey(e, r) {
        let a = r.nsSeparator !== void 0 ? r.nsSeparator : this.options.nsSeparator;
        a === void 0 && (a = ":");
        const o = r.keySeparator !== void 0 ? r.keySeparator : this.options.keySeparator;
        let l = r.ns || this.options.defaultNS || [];
        const u = a && e.indexOf(a) > -1
          , d = !this.options.userDefinedKeySeparator && !r.keySeparator && !this.options.userDefinedNsSeparator && !r.nsSeparator && !jS(e, a, o);
        if (u && !d) {
            const p = e.match(this.interpolator.nestingRegexp);
            if (p && p.length > 0)
                return {
                    key: e,
                    namespaces: he(l) ? [l] : l
                };
            const h = e.split(a);
            (a !== o || a === o && this.options.ns.indexOf(h[0]) > -1) && (l = h.shift()),
            e = h.join(o)
        }
        return {
            key: e,
            namespaces: he(l) ? [l] : l
        }
    }
    translate(e, r, a) {
        if (typeof r != "object" && this.options.overloadTranslationOptionHandler && (r = this.options.overloadTranslationOptionHandler(arguments)),
        typeof r == "object" && (r = {
            ...r
        }),
        r || (r = {}),
        e == null)
            return "";
        Array.isArray(e) || (e = [String(e)]);
        const o = r.returnDetails !== void 0 ? r.returnDetails : this.options.returnDetails
          , l = r.keySeparator !== void 0 ? r.keySeparator : this.options.keySeparator
          , {key: u, namespaces: d} = this.extractFromKey(e[e.length - 1], r)
          , p = d[d.length - 1]
          , h = r.lng || this.language
          , g = r.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
        if ((h == null ? void 0 : h.toLowerCase()) === "cimode") {
            if (g) {
                const K = r.nsSeparator || this.options.nsSeparator;
                return o ? {
                    res: `${p}${K}${u}`,
                    usedKey: u,
                    exactUsedKey: u,
                    usedLng: h,
                    usedNS: p,
                    usedParams: this.getUsedParamsDetails(r)
                } : `${p}${K}${u}`
            }
            return o ? {
                res: u,
                usedKey: u,
                exactUsedKey: u,
                usedLng: h,
                usedNS: p,
                usedParams: this.getUsedParamsDetails(r)
            } : u
        }
        const v = this.resolve(e, r);
        let y = v == null ? void 0 : v.res;
        const P = (v == null ? void 0 : v.usedKey) || u
          , w = (v == null ? void 0 : v.exactUsedKey) || u
          , S = ["[object Number]", "[object Function]", "[object RegExp]"]
          , z = r.joinArrays !== void 0 ? r.joinArrays : this.options.joinArrays
          , C = !this.i18nFormat || this.i18nFormat.handleAsObject
          , b = r.count !== void 0 && !he(r.count)
          , T = Ns.hasDefaultValue(r)
          , D = b ? this.pluralResolver.getSuffix(h, r.count, r) : ""
          , M = r.ordinal && b ? this.pluralResolver.getSuffix(h, r.count, {
            ordinal: !1
        }) : ""
          , B = b && !r.ordinal && r.count === 0
          , _ = B && r[`defaultValue${this.options.pluralSeparator}zero`] || r[`defaultValue${D}`] || r[`defaultValue${M}`] || r.defaultValue;
        let F = y;
        C && !y && T && (F = _);
        const R = pf(F)
          , W = Object.prototype.toString.apply(F);
        if (C && F && R && S.indexOf(W) < 0 && !(he(z) && Array.isArray(F))) {
            if (!r.returnObjects && !this.options.returnObjects) {
                this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
                const K = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(P, F, {
                    ...r,
                    ns: d
                }) : `key '${u} (${this.language})' returned an object instead of string.`;
                return o ? (v.res = K,
                v.usedParams = this.getUsedParamsDetails(r),
                v) : K
            }
            if (l) {
                const K = Array.isArray(F)
                  , Q = K ? [] : {}
                  , se = K ? w : P;
                for (const le in F)
                    if (Object.prototype.hasOwnProperty.call(F, le)) {
                        const pe = `${se}${l}${le}`;
                        T && !y ? Q[le] = this.translate(pe, {
                            ...r,
                            defaultValue: pf(_) ? _[le] : void 0,
                            joinArrays: !1,
                            ns: d
                        }) : Q[le] = this.translate(pe, {
                            ...r,
                            joinArrays: !1,
                            ns: d
                        }),
                        Q[le] === pe && (Q[le] = F[le])
                    }
                y = Q
            }
        } else if (C && he(z) && Array.isArray(y))
            y = y.join(z),
            y && (y = this.extendTranslation(y, e, r, a));
        else {
            let K = !1
              , Q = !1;
            !this.isValidLookup(y) && T && (K = !0,
            y = _),
            this.isValidLookup(y) || (Q = !0,
            y = u);
            const le = (r.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && Q ? void 0 : y
              , pe = T && _ !== y && this.options.updateMissing;
            if (Q || K || pe) {
                if (this.logger.log(pe ? "updateKey" : "missingKey", h, p, u, pe ? _ : y),
                l) {
                    const X = this.resolve(u, {
                        ...r,
                        keySeparator: !1
                    });
                    X && X.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.")
                }
                let ie = [];
                const ne = this.languageUtils.getFallbackCodes(this.options.fallbackLng, r.lng || this.language);
                if (this.options.saveMissingTo === "fallback" && ne && ne[0])
                    for (let X = 0; X < ne.length; X++)
                        ie.push(ne[X]);
                else
                    this.options.saveMissingTo === "all" ? ie = this.languageUtils.toResolveHierarchy(r.lng || this.language) : ie.push(r.lng || this.language);
                const H = (X, Z, I) => {
                    var fe;
                    const U = T && I !== y ? I : le;
                    this.options.missingKeyHandler ? this.options.missingKeyHandler(X, p, Z, U, pe, r) : (fe = this.backendConnector) != null && fe.saveMissing && this.backendConnector.saveMissing(X, p, Z, U, pe, r),
                    this.emit("missingKey", X, p, Z, y)
                }
                ;
                this.options.saveMissing && (this.options.saveMissingPlurals && b ? ie.forEach(X => {
                    const Z = this.pluralResolver.getSuffixes(X, r);
                    B && r[`defaultValue${this.options.pluralSeparator}zero`] && Z.indexOf(`${this.options.pluralSeparator}zero`) < 0 && Z.push(`${this.options.pluralSeparator}zero`),
                    Z.forEach(I => {
                        H([X], u + I, r[`defaultValue${I}`] || _)
                    }
                    )
                }
                ) : H(ie, u, _))
            }
            y = this.extendTranslation(y, e, r, v, a),
            Q && y === u && this.options.appendNamespaceToMissingKey && (y = `${p}:${u}`),
            (Q || K) && this.options.parseMissingKeyHandler && (y = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${p}:${u}` : u, K ? y : void 0))
        }
        return o ? (v.res = y,
        v.usedParams = this.getUsedParamsDetails(r),
        v) : y
    }
    extendTranslation(e, r, a, o, l) {
        var h, g;
        var u = this;
        if ((h = this.i18nFormat) != null && h.parse)
            e = this.i18nFormat.parse(e, {
                ...this.options.interpolation.defaultVariables,
                ...a
            }, a.lng || this.language || o.usedLng, o.usedNS, o.usedKey, {
                resolved: o
            });
        else if (!a.skipInterpolation) {
            a.interpolation && this.interpolator.init({
                ...a,
                interpolation: {
                    ...this.options.interpolation,
                    ...a.interpolation
                }
            });
            const v = he(e) && (((g = a == null ? void 0 : a.interpolation) == null ? void 0 : g.skipOnVariables) !== void 0 ? a.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
            let y;
            if (v) {
                const w = e.match(this.interpolator.nestingRegexp);
                y = w && w.length
            }
            let P = a.replace && !he(a.replace) ? a.replace : a;
            if (this.options.interpolation.defaultVariables && (P = {
                ...this.options.interpolation.defaultVariables,
                ...P
            }),
            e = this.interpolator.interpolate(e, P, a.lng || this.language || o.usedLng, a),
            v) {
                const w = e.match(this.interpolator.nestingRegexp)
                  , S = w && w.length;
                y < S && (a.nest = !1)
            }
            !a.lng && o && o.res && (a.lng = this.language || o.usedLng),
            a.nest !== !1 && (e = this.interpolator.nest(e, function() {
                for (var w = arguments.length, S = new Array(w), z = 0; z < w; z++)
                    S[z] = arguments[z];
                return (l == null ? void 0 : l[0]) === S[0] && !a.context ? (u.logger.warn(`It seems you are nesting recursively key: ${S[0]} in key: ${r[0]}`),
                null) : u.translate(...S, r)
            }, a)),
            a.interpolation && this.interpolator.reset()
        }
        const d = a.postProcess || this.options.postProcess
          , p = he(d) ? [d] : d;
        return e != null && (p != null && p.length) && a.applyPostProcessor !== !1 && (e = z0.handle(p, e, r, this.options && this.options.postProcessPassResolved ? {
            i18nResolved: {
                ...o,
                usedParams: this.getUsedParamsDetails(a)
            },
            ...a
        } : a, this)),
        e
    }
    resolve(e) {
        let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a, o, l, u, d;
        return he(e) && (e = [e]),
        e.forEach(p => {
            if (this.isValidLookup(a))
                return;
            const h = this.extractFromKey(p, r)
              , g = h.key;
            o = g;
            let v = h.namespaces;
            this.options.fallbackNS && (v = v.concat(this.options.fallbackNS));
            const y = r.count !== void 0 && !he(r.count)
              , P = y && !r.ordinal && r.count === 0
              , w = r.context !== void 0 && (he(r.context) || typeof r.context == "number") && r.context !== ""
              , S = r.lngs ? r.lngs : this.languageUtils.toResolveHierarchy(r.lng || this.language, r.fallbackLng);
            v.forEach(z => {
                var C, b;
                this.isValidLookup(a) || (d = z,
                !df[`${S[0]}-${z}`] && ((C = this.utils) != null && C.hasLoadedNamespace) && !((b = this.utils) != null && b.hasLoadedNamespace(d)) && (df[`${S[0]}-${z}`] = !0,
                this.logger.warn(`key "${o}" for languages "${S.join(", ")}" won't get resolved as namespace "${d}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")),
                S.forEach(T => {
                    var B;
                    if (this.isValidLookup(a))
                        return;
                    u = T;
                    const D = [g];
                    if ((B = this.i18nFormat) != null && B.addLookupKeys)
                        this.i18nFormat.addLookupKeys(D, g, T, z, r);
                    else {
                        let _;
                        y && (_ = this.pluralResolver.getSuffix(T, r.count, r));
                        const F = `${this.options.pluralSeparator}zero`
                          , R = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
                        if (y && (D.push(g + _),
                        r.ordinal && _.indexOf(R) === 0 && D.push(g + _.replace(R, this.options.pluralSeparator)),
                        P && D.push(g + F)),
                        w) {
                            const W = `${g}${this.options.contextSeparator}${r.context}`;
                            D.push(W),
                            y && (D.push(W + _),
                            r.ordinal && _.indexOf(R) === 0 && D.push(W + _.replace(R, this.options.pluralSeparator)),
                            P && D.push(W + F))
                        }
                    }
                    let M;
                    for (; M = D.pop(); )
                        this.isValidLookup(a) || (l = M,
                        a = this.getResource(T, z, M, r))
                }
                ))
            }
            )
        }
        ),
        {
            res: a,
            usedKey: o,
            exactUsedKey: l,
            usedLng: u,
            usedNS: d
        }
    }
    isValidLookup(e) {
        return e !== void 0 && !(!this.options.returnNull && e === null) && !(!this.options.returnEmptyString && e === "")
    }
    getResource(e, r, a) {
        var l;
        let o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
        return (l = this.i18nFormat) != null && l.getResource ? this.i18nFormat.getResource(e, r, a, o) : this.resourceStore.getResource(e, r, a, o)
    }
    getUsedParamsDetails() {
        let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        const r = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"]
          , a = e.replace && !he(e.replace);
        let o = a ? e.replace : e;
        if (a && typeof e.count < "u" && (o.count = e.count),
        this.options.interpolation.defaultVariables && (o = {
            ...this.options.interpolation.defaultVariables,
            ...o
        }),
        !a) {
            o = {
                ...o
            };
            for (const l of r)
                delete o[l]
        }
        return o
    }
    static hasDefaultValue(e) {
        const r = "defaultValue";
        for (const a in e)
            if (Object.prototype.hasOwnProperty.call(e, a) && r === a.substring(0, r.length) && e[a] !== void 0)
                return !0;
        return !1
    }
}
class mf {
    constructor(e) {
        this.options = e,
        this.supportedLngs = this.options.supportedLngs || !1,
        this.logger = Ut.create("languageUtils")
    }
    getScriptPartFromCode(e) {
        if (e = Ls(e),
        !e || e.indexOf("-") < 0)
            return null;
        const r = e.split("-");
        return r.length === 2 || (r.pop(),
        r[r.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(r.join("-"))
    }
    getLanguagePartFromCode(e) {
        if (e = Ls(e),
        !e || e.indexOf("-") < 0)
            return e;
        const r = e.split("-");
        return this.formatLanguageCode(r[0])
    }
    formatLanguageCode(e) {
        if (he(e) && e.indexOf("-") > -1) {
            let r;
            try {
                r = Intl.getCanonicalLocales(e)[0]
            } catch {}
            return r && this.options.lowerCaseLng && (r = r.toLowerCase()),
            r || (this.options.lowerCaseLng ? e.toLowerCase() : e)
        }
        return this.options.cleanCode || this.options.lowerCaseLng ? e.toLowerCase() : e
    }
    isSupportedCode(e) {
        return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (e = this.getLanguagePartFromCode(e)),
        !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(e) > -1
    }
    getBestMatchFromCodes(e) {
        if (!e)
            return null;
        let r;
        return e.forEach(a => {
            if (r)
                return;
            const o = this.formatLanguageCode(a);
            (!this.options.supportedLngs || this.isSupportedCode(o)) && (r = o)
        }
        ),
        !r && this.options.supportedLngs && e.forEach(a => {
            if (r)
                return;
            const o = this.getLanguagePartFromCode(a);
            if (this.isSupportedCode(o))
                return r = o;
            r = this.options.supportedLngs.find(l => {
                if (l === o)
                    return l;
                if (!(l.indexOf("-") < 0 && o.indexOf("-") < 0) && (l.indexOf("-") > 0 && o.indexOf("-") < 0 && l.substring(0, l.indexOf("-")) === o || l.indexOf(o) === 0 && o.length > 1))
                    return l
            }
            )
        }
        ),
        r || (r = this.getFallbackCodes(this.options.fallbackLng)[0]),
        r
    }
    getFallbackCodes(e, r) {
        if (!e)
            return [];
        if (typeof e == "function" && (e = e(r)),
        he(e) && (e = [e]),
        Array.isArray(e))
            return e;
        if (!r)
            return e.default || [];
        let a = e[r];
        return a || (a = e[this.getScriptPartFromCode(r)]),
        a || (a = e[this.formatLanguageCode(r)]),
        a || (a = e[this.getLanguagePartFromCode(r)]),
        a || (a = e.default),
        a || []
    }
    toResolveHierarchy(e, r) {
        const a = this.getFallbackCodes(r || this.options.fallbackLng || [], e)
          , o = []
          , l = u => {
            u && (this.isSupportedCode(u) ? o.push(u) : this.logger.warn(`rejecting language code not found in supportedLngs: ${u}`))
        }
        ;
        return he(e) && (e.indexOf("-") > -1 || e.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && l(this.formatLanguageCode(e)),
        this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && l(this.getScriptPartFromCode(e)),
        this.options.load !== "currentOnly" && l(this.getLanguagePartFromCode(e))) : he(e) && l(this.formatLanguageCode(e)),
        a.forEach(u => {
            o.indexOf(u) < 0 && l(this.formatLanguageCode(u))
        }
        ),
        o
    }
}
const hf = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
}
  , ff = {
    select: i => i === 1 ? "one" : "other",
    resolvedOptions: () => ({
        pluralCategories: ["one", "other"]
    })
};
class zS {
    constructor(e) {
        let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        this.languageUtils = e,
        this.options = r,
        this.logger = Ut.create("pluralResolver"),
        this.pluralRulesCache = {}
    }
    addRule(e, r) {
        this.rules[e] = r
    }
    clearCache() {
        this.pluralRulesCache = {}
    }
    getRule(e) {
        let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const a = Ls(e === "dev" ? "en" : e)
          , o = r.ordinal ? "ordinal" : "cardinal"
          , l = JSON.stringify({
            cleanedCode: a,
            type: o
        });
        if (l in this.pluralRulesCache)
            return this.pluralRulesCache[l];
        let u;
        try {
            u = new Intl.PluralRules(a,{
                type: o
            })
        } catch {
            if (!Intl)
                return this.logger.error("No Intl support, please use an Intl polyfill!"),
                ff;
            if (!e.match(/-|_/))
                return ff;
            const p = this.languageUtils.getLanguagePartFromCode(e);
            u = this.getRule(p, r)
        }
        return this.pluralRulesCache[l] = u,
        u
    }
    needsPlural(e) {
        let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}
          , a = this.getRule(e, r);
        return a || (a = this.getRule("dev", r)),
        (a == null ? void 0 : a.resolvedOptions().pluralCategories.length) > 1
    }
    getPluralFormsOfKey(e, r) {
        let a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        return this.getSuffixes(e, a).map(o => `${r}${o}`)
    }
    getSuffixes(e) {
        let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}
          , a = this.getRule(e, r);
        return a || (a = this.getRule("dev", r)),
        a ? a.resolvedOptions().pluralCategories.sort( (o, l) => hf[o] - hf[l]).map(o => `${this.options.prepend}${r.ordinal ? `ordinal${this.options.prepend}` : ""}${o}`) : []
    }
    getSuffix(e, r) {
        let a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        const o = this.getRule(e, a);
        return o ? `${this.options.prepend}${a.ordinal ? `ordinal${this.options.prepend}` : ""}${o.select(r)}` : (this.logger.warn(`no plural rule found for: ${e}`),
        this.getSuffix("dev", r, a))
    }
}
const gf = function(i, e, r) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "."
      , o = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0
      , l = xS(i, e, r);
    return !l && o && he(r) && (l = Oc(i, r, a),
    l === void 0 && (l = Oc(e, r, a))),
    l
}
  , dc = i => i.replace(/\$/g, "$$$$");
class AS {
    constructor() {
        var r;
        let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        this.logger = Ut.create("interpolator"),
        this.options = e,
        this.format = ((r = e == null ? void 0 : e.interpolation) == null ? void 0 : r.format) || (a => a),
        this.init(e)
    }
    init() {
        let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        e.interpolation || (e.interpolation = {
            escapeValue: !0
        });
        const {escape: r, escapeValue: a, useRawValueToEscape: o, prefix: l, prefixEscaped: u, suffix: d, suffixEscaped: p, formatSeparator: h, unescapeSuffix: g, unescapePrefix: v, nestingPrefix: y, nestingPrefixEscaped: P, nestingSuffix: w, nestingSuffixEscaped: S, nestingOptionsSeparator: z, maxReplaces: C, alwaysFormat: b} = e.interpolation;
        this.escape = r !== void 0 ? r : PS,
        this.escapeValue = a !== void 0 ? a : !0,
        this.useRawValueToEscape = o !== void 0 ? o : !1,
        this.prefix = l ? Sr(l) : u || "{{",
        this.suffix = d ? Sr(d) : p || "}}",
        this.formatSeparator = h || ",",
        this.unescapePrefix = g ? "" : v || "-",
        this.unescapeSuffix = this.unescapePrefix ? "" : g || "",
        this.nestingPrefix = y ? Sr(y) : P || Sr("$t("),
        this.nestingSuffix = w ? Sr(w) : S || Sr(")"),
        this.nestingOptionsSeparator = z || ",",
        this.maxReplaces = C || 1e3,
        this.alwaysFormat = b !== void 0 ? b : !1,
        this.resetRegExp()
    }
    reset() {
        this.options && this.init(this.options)
    }
    resetRegExp() {
        const e = (r, a) => (r == null ? void 0 : r.source) === a ? (r.lastIndex = 0,
        r) : new RegExp(a,"g");
        this.regexp = e(this.regexp, `${this.prefix}(.+?)${this.suffix}`),
        this.regexpUnescape = e(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`),
        this.nestingRegexp = e(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`)
    }
    interpolate(e, r, a, o) {
        var P;
        let l, u, d;
        const p = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {}
          , h = w => {
            if (w.indexOf(this.formatSeparator) < 0) {
                const b = gf(r, p, w, this.options.keySeparator, this.options.ignoreJSONStructure);
                return this.alwaysFormat ? this.format(b, void 0, a, {
                    ...o,
                    ...r,
                    interpolationkey: w
                }) : b
            }
            const S = w.split(this.formatSeparator)
              , z = S.shift().trim()
              , C = S.join(this.formatSeparator).trim();
            return this.format(gf(r, p, z, this.options.keySeparator, this.options.ignoreJSONStructure), C, a, {
                ...o,
                ...r,
                interpolationkey: z
            })
        }
        ;
        this.resetRegExp();
        const g = (o == null ? void 0 : o.missingInterpolationHandler) || this.options.missingInterpolationHandler
          , v = ((P = o == null ? void 0 : o.interpolation) == null ? void 0 : P.skipOnVariables) !== void 0 ? o.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
        return [{
            regex: this.regexpUnescape,
            safeValue: w => dc(w)
        }, {
            regex: this.regexp,
            safeValue: w => this.escapeValue ? dc(this.escape(w)) : dc(w)
        }].forEach(w => {
            for (d = 0; l = w.regex.exec(e); ) {
                const S = l[1].trim();
                if (u = h(S),
                u === void 0)
                    if (typeof g == "function") {
                        const C = g(e, l, o);
                        u = he(C) ? C : ""
                    } else if (o && Object.prototype.hasOwnProperty.call(o, S))
                        u = "";
                    else if (v) {
                        u = l[0];
                        continue
                    } else
                        this.logger.warn(`missed to pass in variable ${S} for interpolating ${e}`),
                        u = "";
                else
                    !he(u) && !this.useRawValueToEscape && (u = sf(u));
                const z = w.safeValue(u);
                if (e = e.replace(l[0], z),
                v ? (w.regex.lastIndex += u.length,
                w.regex.lastIndex -= l[0].length) : w.regex.lastIndex = 0,
                d++,
                d >= this.maxReplaces)
                    break
            }
        }
        ),
        e
    }
    nest(e, r) {
        let a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, o, l, u;
        const d = (p, h) => {
            const g = this.nestingOptionsSeparator;
            if (p.indexOf(g) < 0)
                return p;
            const v = p.split(new RegExp(`${g}[ ]*{`));
            let y = `{${v[1]}`;
            p = v[0],
            y = this.interpolate(y, u);
            const P = y.match(/'/g)
              , w = y.match(/"/g);
            (((P == null ? void 0 : P.length) ?? 0) % 2 === 0 && !w || w.length % 2 !== 0) && (y = y.replace(/'/g, '"'));
            try {
                u = JSON.parse(y),
                h && (u = {
                    ...h,
                    ...u
                })
            } catch (S) {
                return this.logger.warn(`failed parsing options string in nesting for key ${p}`, S),
                `${p}${g}${y}`
            }
            return u.defaultValue && u.defaultValue.indexOf(this.prefix) > -1 && delete u.defaultValue,
            p
        }
        ;
        for (; o = this.nestingRegexp.exec(e); ) {
            let p = [];
            u = {
                ...a
            },
            u = u.replace && !he(u.replace) ? u.replace : u,
            u.applyPostProcessor = !1,
            delete u.defaultValue;
            let h = !1;
            if (o[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(o[1])) {
                const g = o[1].split(this.formatSeparator).map(v => v.trim());
                o[1] = g.shift(),
                p = g,
                h = !0
            }
            if (l = r(d.call(this, o[1].trim(), u), u),
            l && o[0] === e && !he(l))
                return l;
            he(l) || (l = sf(l)),
            l || (this.logger.warn(`missed to resolve ${o[1]} for nesting ${e}`),
            l = ""),
            h && (l = p.reduce( (g, v) => this.format(g, v, a.lng, {
                ...a,
                interpolationkey: o[1].trim()
            }), l.trim())),
            e = e.replace(o[0], l),
            this.regexp.lastIndex = 0
        }
        return e
    }
}
const ES = i => {
    let e = i.toLowerCase().trim();
    const r = {};
    if (i.indexOf("(") > -1) {
        const a = i.split("(");
        e = a[0].toLowerCase().trim();
        const o = a[1].substring(0, a[1].length - 1);
        e === "currency" && o.indexOf(":") < 0 ? r.currency || (r.currency = o.trim()) : e === "relativetime" && o.indexOf(":") < 0 ? r.range || (r.range = o.trim()) : o.split(";").forEach(u => {
            if (u) {
                const [d,...p] = u.split(":")
                  , h = p.join(":").trim().replace(/^'+|'+$/g, "")
                  , g = d.trim();
                r[g] || (r[g] = h),
                h === "false" && (r[g] = !1),
                h === "true" && (r[g] = !0),
                isNaN(h) || (r[g] = parseInt(h, 10))
            }
        }
        )
    }
    return {
        formatName: e,
        formatOptions: r
    }
}
  , Tr = i => {
    const e = {};
    return (r, a, o) => {
        let l = o;
        o && o.interpolationkey && o.formatParams && o.formatParams[o.interpolationkey] && o[o.interpolationkey] && (l = {
            ...l,
            [o.interpolationkey]: void 0
        });
        const u = a + JSON.stringify(l);
        let d = e[u];
        return d || (d = i(Ls(a), o),
        e[u] = d),
        d(r)
    }
}
;
class DS {
    constructor() {
        let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        this.logger = Ut.create("formatter"),
        this.options = e,
        this.formats = {
            number: Tr( (r, a) => {
                const o = new Intl.NumberFormat(r,{
                    ...a
                });
                return l => o.format(l)
            }
            ),
            currency: Tr( (r, a) => {
                const o = new Intl.NumberFormat(r,{
                    ...a,
                    style: "currency"
                });
                return l => o.format(l)
            }
            ),
            datetime: Tr( (r, a) => {
                const o = new Intl.DateTimeFormat(r,{
                    ...a
                });
                return l => o.format(l)
            }
            ),
            relativetime: Tr( (r, a) => {
                const o = new Intl.RelativeTimeFormat(r,{
                    ...a
                });
                return l => o.format(l, a.range || "day")
            }
            ),
            list: Tr( (r, a) => {
                const o = new Intl.ListFormat(r,{
                    ...a
                });
                return l => o.format(l)
            }
            )
        },
        this.init(e)
    }
    init(e) {
        let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
            interpolation: {}
        };
        this.formatSeparator = r.interpolation.formatSeparator || ","
    }
    add(e, r) {
        this.formats[e.toLowerCase().trim()] = r
    }
    addCached(e, r) {
        this.formats[e.toLowerCase().trim()] = Tr(r)
    }
    format(e, r, a) {
        let o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
        const l = r.split(this.formatSeparator);
        if (l.length > 1 && l[0].indexOf("(") > 1 && l[0].indexOf(")") < 0 && l.find(d => d.indexOf(")") > -1)) {
            const d = l.findIndex(p => p.indexOf(")") > -1);
            l[0] = [l[0], ...l.splice(1, d)].join(this.formatSeparator)
        }
        return l.reduce( (d, p) => {
            var v;
            const {formatName: h, formatOptions: g} = ES(p);
            if (this.formats[h]) {
                let y = d;
                try {
                    const P = ((v = o == null ? void 0 : o.formatParams) == null ? void 0 : v[o.interpolationkey]) || {}
                      , w = P.locale || P.lng || o.locale || o.lng || a;
                    y = this.formats[h](d, w, {
                        ...g,
                        ...o,
                        ...P
                    })
                } catch (P) {
                    this.logger.warn(P)
                }
                return y
            } else
                this.logger.warn(`there was no format function for ${h}`);
            return d
        }
        , e)
    }
}
const IS = (i, e) => {
    i.pending[e] !== void 0 && (delete i.pending[e],
    i.pendingCount--)
}
;
class MS extends Ks {
    constructor(e, r, a) {
        var l, u;
        let o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
        super(),
        this.backend = e,
        this.store = r,
        this.services = a,
        this.languageUtils = a.languageUtils,
        this.options = o,
        this.logger = Ut.create("backendConnector"),
        this.waitingReads = [],
        this.maxParallelReads = o.maxParallelReads || 10,
        this.readingCalls = 0,
        this.maxRetries = o.maxRetries >= 0 ? o.maxRetries : 5,
        this.retryTimeout = o.retryTimeout >= 1 ? o.retryTimeout : 350,
        this.state = {},
        this.queue = [],
        (u = (l = this.backend) == null ? void 0 : l.init) == null || u.call(l, a, o.backend, o)
    }
    queueLoad(e, r, a, o) {
        const l = {}
          , u = {}
          , d = {}
          , p = {};
        return e.forEach(h => {
            let g = !0;
            r.forEach(v => {
                const y = `${h}|${v}`;
                !a.reload && this.store.hasResourceBundle(h, v) ? this.state[y] = 2 : this.state[y] < 0 || (this.state[y] === 1 ? u[y] === void 0 && (u[y] = !0) : (this.state[y] = 1,
                g = !1,
                u[y] === void 0 && (u[y] = !0),
                l[y] === void 0 && (l[y] = !0),
                p[v] === void 0 && (p[v] = !0)))
            }
            ),
            g || (d[h] = !0)
        }
        ),
        (Object.keys(l).length || Object.keys(u).length) && this.queue.push({
            pending: u,
            pendingCount: Object.keys(u).length,
            loaded: {},
            errors: [],
            callback: o
        }),
        {
            toLoad: Object.keys(l),
            pending: Object.keys(u),
            toLoadLanguages: Object.keys(d),
            toLoadNamespaces: Object.keys(p)
        }
    }
    loaded(e, r, a) {
        const o = e.split("|")
          , l = o[0]
          , u = o[1];
        r && this.emit("failedLoading", l, u, r),
        !r && a && this.store.addResourceBundle(l, u, a, void 0, void 0, {
            skipCopy: !0
        }),
        this.state[e] = r ? -1 : 2,
        r && a && (this.state[e] = 0);
        const d = {};
        this.queue.forEach(p => {
            kS(p.loaded, [l], u),
            IS(p, e),
            r && p.errors.push(r),
            p.pendingCount === 0 && !p.done && (Object.keys(p.loaded).forEach(h => {
                d[h] || (d[h] = {});
                const g = p.loaded[h];
                g.length && g.forEach(v => {
                    d[h][v] === void 0 && (d[h][v] = !0)
                }
                )
            }
            ),
            p.done = !0,
            p.errors.length ? p.callback(p.errors) : p.callback())
        }
        ),
        this.emit("loaded", d),
        this.queue = this.queue.filter(p => !p.done)
    }
    read(e, r, a) {
        let o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0
          , l = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.retryTimeout
          , u = arguments.length > 5 ? arguments[5] : void 0;
        if (!e.length)
            return u(null, {});
        if (this.readingCalls >= this.maxParallelReads) {
            this.waitingReads.push({
                lng: e,
                ns: r,
                fcName: a,
                tried: o,
                wait: l,
                callback: u
            });
            return
        }
        this.readingCalls++;
        const d = (h, g) => {
            if (this.readingCalls--,
            this.waitingReads.length > 0) {
                const v = this.waitingReads.shift();
                this.read(v.lng, v.ns, v.fcName, v.tried, v.wait, v.callback)
            }
            if (h && g && o < this.maxRetries) {
                setTimeout( () => {
                    this.read.call(this, e, r, a, o + 1, l * 2, u)
                }
                , l);
                return
            }
            u(h, g)
        }
          , p = this.backend[a].bind(this.backend);
        if (p.length === 2) {
            try {
                const h = p(e, r);
                h && typeof h.then == "function" ? h.then(g => d(null, g)).catch(d) : d(null, h)
            } catch (h) {
                d(h)
            }
            return
        }
        return p(e, r, d)
    }
    prepareLoading(e, r) {
        let a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}
          , o = arguments.length > 3 ? arguments[3] : void 0;
        if (!this.backend)
            return this.logger.warn("No backend was added via i18next.use. Will not load resources."),
            o && o();
        he(e) && (e = this.languageUtils.toResolveHierarchy(e)),
        he(r) && (r = [r]);
        const l = this.queueLoad(e, r, a, o);
        if (!l.toLoad.length)
            return l.pending.length || o(),
            null;
        l.toLoad.forEach(u => {
            this.loadOne(u)
        }
        )
    }
    load(e, r, a) {
        this.prepareLoading(e, r, {}, a)
    }
    reload(e, r, a) {
        this.prepareLoading(e, r, {
            reload: !0
        }, a)
    }
    loadOne(e) {
        let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
        const a = e.split("|")
          , o = a[0]
          , l = a[1];
        this.read(o, l, "read", void 0, void 0, (u, d) => {
            u && this.logger.warn(`${r}loading namespace ${l} for language ${o} failed`, u),
            !u && d && this.logger.log(`${r}loaded namespace ${l} for language ${o}`, d),
            this.loaded(e, u, d)
        }
        )
    }
    saveMissing(e, r, a, o, l) {
        var p, h, g, v, y;
        let u = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {}
          , d = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : () => {}
        ;
        if ((h = (p = this.services) == null ? void 0 : p.utils) != null && h.hasLoadedNamespace && !((v = (g = this.services) == null ? void 0 : g.utils) != null && v.hasLoadedNamespace(r))) {
            this.logger.warn(`did not save key "${a}" as the namespace "${r}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
            return
        }
        if (!(a == null || a === "")) {
            if ((y = this.backend) != null && y.create) {
                const P = {
                    ...u,
                    isUpdate: l
                }
                  , w = this.backend.create.bind(this.backend);
                if (w.length < 6)
                    try {
                        let S;
                        w.length === 5 ? S = w(e, r, a, o, P) : S = w(e, r, a, o),
                        S && typeof S.then == "function" ? S.then(z => d(null, z)).catch(d) : d(null, S)
                    } catch (S) {
                        d(S)
                    }
                else
                    w(e, r, a, o, d, P)
            }
            !e || !e[0] || this.store.addResource(e[0], r, a, o)
        }
    }
}
const vf = () => ({
    debug: !1,
    initAsync: !0,
    ns: ["translation"],
    defaultNS: ["translation"],
    fallbackLng: ["dev"],
    fallbackNS: !1,
    supportedLngs: !1,
    nonExplicitSupportedLngs: !1,
    load: "all",
    preload: !1,
    simplifyPluralSuffix: !0,
    keySeparator: ".",
    nsSeparator: ":",
    pluralSeparator: "_",
    contextSeparator: "_",
    partialBundledLanguages: !1,
    saveMissing: !1,
    updateMissing: !1,
    saveMissingTo: "fallback",
    saveMissingPlurals: !0,
    missingKeyHandler: !1,
    missingInterpolationHandler: !1,
    postProcess: !1,
    postProcessPassResolved: !1,
    returnNull: !1,
    returnEmptyString: !0,
    returnObjects: !1,
    joinArrays: !1,
    returnedObjectHandler: !1,
    parseMissingKeyHandler: !1,
    appendNamespaceToMissingKey: !1,
    appendNamespaceToCIMode: !1,
    overloadTranslationOptionHandler: i => {
        let e = {};
        if (typeof i[1] == "object" && (e = i[1]),
        he(i[1]) && (e.defaultValue = i[1]),
        he(i[2]) && (e.tDescription = i[2]),
        typeof i[2] == "object" || typeof i[3] == "object") {
            const r = i[3] || i[2];
            Object.keys(r).forEach(a => {
                e[a] = r[a]
            }
            )
        }
        return e
    }
    ,
    interpolation: {
        escapeValue: !0,
        format: i => i,
        prefix: "{{",
        suffix: "}}",
        formatSeparator: ",",
        unescapePrefix: "-",
        nestingPrefix: "$t(",
        nestingSuffix: ")",
        nestingOptionsSeparator: ",",
        maxReplaces: 1e3,
        skipOnVariables: !0
    }
})
  , yf = i => {
    var e, r;
    return he(i.ns) && (i.ns = [i.ns]),
    he(i.fallbackLng) && (i.fallbackLng = [i.fallbackLng]),
    he(i.fallbackNS) && (i.fallbackNS = [i.fallbackNS]),
    ((r = (e = i.supportedLngs) == null ? void 0 : e.indexOf) == null ? void 0 : r.call(e, "cimode")) < 0 && (i.supportedLngs = i.supportedLngs.concat(["cimode"])),
    typeof i.initImmediate == "boolean" && (i.initAsync = i.initImmediate),
    i
}
  , fs = () => {}
  , VS = i => {
    Object.getOwnPropertyNames(Object.getPrototypeOf(i)).forEach(r => {
        typeof i[r] == "function" && (i[r] = i[r].bind(i))
    }
    )
}
;
class Kn extends Ks {
    constructor() {
        let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}
          , r = arguments.length > 1 ? arguments[1] : void 0;
        if (super(),
        this.options = yf(e),
        this.services = {},
        this.logger = Ut,
        this.modules = {
            external: []
        },
        VS(this),
        r && !this.isInitialized && !e.isClone) {
            if (!this.options.initAsync)
                return this.init(e, r),
                this;
            setTimeout( () => {
                this.init(e, r)
            }
            , 0)
        }
    }
    init() {
        var e = this;
        let r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}
          , a = arguments.length > 1 ? arguments[1] : void 0;
        this.isInitializing = !0,
        typeof r == "function" && (a = r,
        r = {}),
        r.defaultNS == null && r.ns && (he(r.ns) ? r.defaultNS = r.ns : r.ns.indexOf("translation") < 0 && (r.defaultNS = r.ns[0]));
        const o = vf();
        this.options = {
            ...o,
            ...this.options,
            ...yf(r)
        },
        this.options.interpolation = {
            ...o.interpolation,
            ...this.options.interpolation
        },
        r.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = r.keySeparator),
        r.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = r.nsSeparator);
        const l = g => g ? typeof g == "function" ? new g : g : null;
        if (!this.options.isClone) {
            this.modules.logger ? Ut.init(l(this.modules.logger), this.options) : Ut.init(null, this.options);
            let g;
            this.modules.formatter ? g = this.modules.formatter : g = DS;
            const v = new mf(this.options);
            this.store = new uf(this.options.resources,this.options);
            const y = this.services;
            y.logger = Ut,
            y.resourceStore = this.store,
            y.languageUtils = v,
            y.pluralResolver = new zS(v,{
                prepend: this.options.pluralSeparator,
                simplifyPluralSuffix: this.options.simplifyPluralSuffix
            }),
            g && (!this.options.interpolation.format || this.options.interpolation.format === o.interpolation.format) && (y.formatter = l(g),
            y.formatter.init(y, this.options),
            this.options.interpolation.format = y.formatter.format.bind(y.formatter)),
            y.interpolator = new AS(this.options),
            y.utils = {
                hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
            },
            y.backendConnector = new MS(l(this.modules.backend),y.resourceStore,y,this.options),
            y.backendConnector.on("*", function(P) {
                for (var w = arguments.length, S = new Array(w > 1 ? w - 1 : 0), z = 1; z < w; z++)
                    S[z - 1] = arguments[z];
                e.emit(P, ...S)
            }),
            this.modules.languageDetector && (y.languageDetector = l(this.modules.languageDetector),
            y.languageDetector.init && y.languageDetector.init(y, this.options.detection, this.options)),
            this.modules.i18nFormat && (y.i18nFormat = l(this.modules.i18nFormat),
            y.i18nFormat.init && y.i18nFormat.init(this)),
            this.translator = new Ns(this.services,this.options),
            this.translator.on("*", function(P) {
                for (var w = arguments.length, S = new Array(w > 1 ? w - 1 : 0), z = 1; z < w; z++)
                    S[z - 1] = arguments[z];
                e.emit(P, ...S)
            }),
            this.modules.external.forEach(P => {
                P.init && P.init(this)
            }
            )
        }
        if (this.format = this.options.interpolation.format,
        a || (a = fs),
        this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
            const g = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
            g.length > 0 && g[0] !== "dev" && (this.options.lng = g[0])
        }
        !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"),
        ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach(g => {
            this[g] = function() {
                return e.store[g](...arguments)
            }
        }
        ),
        ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach(g => {
            this[g] = function() {
                return e.store[g](...arguments),
                e
            }
        }
        );
        const p = zn()
          , h = () => {
            const g = (v, y) => {
                this.isInitializing = !1,
                this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"),
                this.isInitialized = !0,
                this.options.isClone || this.logger.log("initialized", this.options),
                this.emit("initialized", this.options),
                p.resolve(y),
                a(v, y)
            }
            ;
            if (this.languages && !this.isInitialized)
                return g(null, this.t.bind(this));
            this.changeLanguage(this.options.lng, g)
        }
        ;
        return this.options.resources || !this.options.initAsync ? h() : setTimeout(h, 0),
        p
    }
    loadResources(e) {
        var l, u;
        let a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : fs;
        const o = he(e) ? e : this.language;
        if (typeof e == "function" && (a = e),
        !this.options.resources || this.options.partialBundledLanguages) {
            if ((o == null ? void 0 : o.toLowerCase()) === "cimode" && (!this.options.preload || this.options.preload.length === 0))
                return a();
            const d = []
              , p = h => {
                if (!h || h === "cimode")
                    return;
                this.services.languageUtils.toResolveHierarchy(h).forEach(v => {
                    v !== "cimode" && d.indexOf(v) < 0 && d.push(v)
                }
                )
            }
            ;
            o ? p(o) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach(g => p(g)),
            (u = (l = this.options.preload) == null ? void 0 : l.forEach) == null || u.call(l, h => p(h)),
            this.services.backendConnector.load(d, this.options.ns, h => {
                !h && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language),
                a(h)
            }
            )
        } else
            a(null)
    }
    reloadResources(e, r, a) {
        const o = zn();
        return typeof e == "function" && (a = e,
        e = void 0),
        typeof r == "function" && (a = r,
        r = void 0),
        e || (e = this.languages),
        r || (r = this.options.ns),
        a || (a = fs),
        this.services.backendConnector.reload(e, r, l => {
            o.resolve(),
            a(l)
        }
        ),
        o
    }
    use(e) {
        if (!e)
            throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
        if (!e.type)
            throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
        return e.type === "backend" && (this.modules.backend = e),
        (e.type === "logger" || e.log && e.warn && e.error) && (this.modules.logger = e),
        e.type === "languageDetector" && (this.modules.languageDetector = e),
        e.type === "i18nFormat" && (this.modules.i18nFormat = e),
        e.type === "postProcessor" && z0.addPostProcessor(e),
        e.type === "formatter" && (this.modules.formatter = e),
        e.type === "3rdParty" && this.modules.external.push(e),
        this
    }
    setResolvedLanguage(e) {
        if (!(!e || !this.languages) && !(["cimode", "dev"].indexOf(e) > -1))
            for (let r = 0; r < this.languages.length; r++) {
                const a = this.languages[r];
                if (!(["cimode", "dev"].indexOf(a) > -1) && this.store.hasLanguageSomeTranslations(a)) {
                    this.resolvedLanguage = a;
                    break
                }
            }
    }
    changeLanguage(e, r) {
        var a = this;
        this.isLanguageChangingTo = e;
        const o = zn();
        this.emit("languageChanging", e);
        const l = p => {
            this.language = p,
            this.languages = this.services.languageUtils.toResolveHierarchy(p),
            this.resolvedLanguage = void 0,
            this.setResolvedLanguage(p)
        }
          , u = (p, h) => {
            h ? (l(h),
            this.translator.changeLanguage(h),
            this.isLanguageChangingTo = void 0,
            this.emit("languageChanged", h),
            this.logger.log("languageChanged", h)) : this.isLanguageChangingTo = void 0,
            o.resolve(function() {
                return a.t(...arguments)
            }),
            r && r(p, function() {
                return a.t(...arguments)
            })
        }
          , d = p => {
            var g, v;
            !e && !p && this.services.languageDetector && (p = []);
            const h = he(p) ? p : this.services.languageUtils.getBestMatchFromCodes(p);
            h && (this.language || l(h),
            this.translator.language || this.translator.changeLanguage(h),
            (v = (g = this.services.languageDetector) == null ? void 0 : g.cacheUserLanguage) == null || v.call(g, h)),
            this.loadResources(h, y => {
                u(y, h)
            }
            )
        }
        ;
        return !e && this.services.languageDetector && !this.services.languageDetector.async ? d(this.services.languageDetector.detect()) : !e && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(d) : this.services.languageDetector.detect(d) : d(e),
        o
    }
    getFixedT(e, r, a) {
        var o = this;
        const l = function(u, d) {
            let p;
            if (typeof d != "object") {
                for (var h = arguments.length, g = new Array(h > 2 ? h - 2 : 0), v = 2; v < h; v++)
                    g[v - 2] = arguments[v];
                p = o.options.overloadTranslationOptionHandler([u, d].concat(g))
            } else
                p = {
                    ...d
                };
            p.lng = p.lng || l.lng,
            p.lngs = p.lngs || l.lngs,
            p.ns = p.ns || l.ns,
            p.keyPrefix !== "" && (p.keyPrefix = p.keyPrefix || a || l.keyPrefix);
            const y = o.options.keySeparator || ".";
            let P;
            return p.keyPrefix && Array.isArray(u) ? P = u.map(w => `${p.keyPrefix}${y}${w}`) : P = p.keyPrefix ? `${p.keyPrefix}${y}${u}` : u,
            o.t(P, p)
        };
        return he(e) ? l.lng = e : l.lngs = e,
        l.ns = r,
        l.keyPrefix = a,
        l
    }
    t() {
        var o;
        for (var e = arguments.length, r = new Array(e), a = 0; a < e; a++)
            r[a] = arguments[a];
        return (o = this.translator) == null ? void 0 : o.translate(...r)
    }
    exists() {
        var o;
        for (var e = arguments.length, r = new Array(e), a = 0; a < e; a++)
            r[a] = arguments[a];
        return (o = this.translator) == null ? void 0 : o.exists(...r)
    }
    setDefaultNamespace(e) {
        this.options.defaultNS = e
    }
    hasLoadedNamespace(e) {
        let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (!this.isInitialized)
            return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages),
            !1;
        if (!this.languages || !this.languages.length)
            return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages),
            !1;
        const a = r.lng || this.resolvedLanguage || this.languages[0]
          , o = this.options ? this.options.fallbackLng : !1
          , l = this.languages[this.languages.length - 1];
        if (a.toLowerCase() === "cimode")
            return !0;
        const u = (d, p) => {
            const h = this.services.backendConnector.state[`${d}|${p}`];
            return h === -1 || h === 0 || h === 2
        }
        ;
        if (r.precheck) {
            const d = r.precheck(this, u);
            if (d !== void 0)
                return d
        }
        return !!(this.hasResourceBundle(a, e) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || u(a, e) && (!o || u(l, e)))
    }
    loadNamespaces(e, r) {
        const a = zn();
        return this.options.ns ? (he(e) && (e = [e]),
        e.forEach(o => {
            this.options.ns.indexOf(o) < 0 && this.options.ns.push(o)
        }
        ),
        this.loadResources(o => {
            a.resolve(),
            r && r(o)
        }
        ),
        a) : (r && r(),
        Promise.resolve())
    }
    loadLanguages(e, r) {
        const a = zn();
        he(e) && (e = [e]);
        const o = this.options.preload || []
          , l = e.filter(u => o.indexOf(u) < 0 && this.services.languageUtils.isSupportedCode(u));
        return l.length ? (this.options.preload = o.concat(l),
        this.loadResources(u => {
            a.resolve(),
            r && r(u)
        }
        ),
        a) : (r && r(),
        Promise.resolve())
    }
    dir(e) {
        var o, l;
        if (e || (e = this.resolvedLanguage || (((o = this.languages) == null ? void 0 : o.length) > 0 ? this.languages[0] : this.language)),
        !e)
            return "rtl";
        const r = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"]
          , a = ((l = this.services) == null ? void 0 : l.languageUtils) || new mf(vf());
        return r.indexOf(a.getLanguagePartFromCode(e)) > -1 || e.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr"
    }
    static createInstance() {
        let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}
          , r = arguments.length > 1 ? arguments[1] : void 0;
        return new Kn(e,r)
    }
    cloneInstance() {
        let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}
          , r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : fs;
        const a = e.forkResourceStore;
        a && delete e.forkResourceStore;
        const o = {
            ...this.options,
            ...e,
            isClone: !0
        }
          , l = new Kn(o);
        if ((e.debug !== void 0 || e.prefix !== void 0) && (l.logger = l.logger.clone(e)),
        ["store", "services", "language"].forEach(d => {
            l[d] = this[d]
        }
        ),
        l.services = {
            ...this.services
        },
        l.services.utils = {
            hasLoadedNamespace: l.hasLoadedNamespace.bind(l)
        },
        a) {
            const d = Object.keys(this.store.data).reduce( (p, h) => (p[h] = {
                ...this.store.data[h]
            },
            Object.keys(p[h]).reduce( (g, v) => (g[v] = {
                ...p[h][v]
            },
            g), {})), {});
            l.store = new uf(d,o),
            l.services.resourceStore = l.store
        }
        return l.translator = new Ns(l.services,o),
        l.translator.on("*", function(d) {
            for (var p = arguments.length, h = new Array(p > 1 ? p - 1 : 0), g = 1; g < p; g++)
                h[g - 1] = arguments[g];
            l.emit(d, ...h)
        }),
        l.init(o, r),
        l.translator.options = o,
        l.translator.backendConnector.services.utils = {
            hasLoadedNamespace: l.hasLoadedNamespace.bind(l)
        },
        l
    }
    toJSON() {
        return {
            options: this.options,
            store: this.store,
            language: this.language,
            languages: this.languages,
            resolvedLanguage: this.resolvedLanguage
        }
    }
}
const rt = Kn.createInstance();
rt.createInstance = Kn.createInstance;
rt.createInstance;
rt.dir;
rt.init;
rt.loadResources;
rt.reloadResources;
rt.use;
rt.changeLanguage;
rt.getFixedT;
rt.t;
rt.exists;
rt.setDefaultNamespace;
rt.hasLoadedNamespace;
rt.loadNamespaces;
rt.loadLanguages;
const {slice: LS, forEach: OS} = [];
function NS(i) {
    return OS.call(LS.call(arguments, 1), e => {
        if (e)
            for (const r in e)
                i[r] === void 0 && (i[r] = e[r])
    }
    ),
    i
}
function FS(i) {
    return typeof i != "string" ? !1 : [/<\s*script.*?>/i, /<\s*\/\s*script\s*>/i, /<\s*img.*?on\w+\s*=/i, /<\s*\w+\s*on\w+\s*=.*?>/i, /javascript\s*:/i, /vbscript\s*:/i, /expression\s*\(/i, /eval\s*\(/i, /alert\s*\(/i, /document\.cookie/i, /document\.write\s*\(/i, /window\.location/i, /innerHTML/i].some(r => r.test(i))
}
const kf = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/
  , RS = function(i, e) {
    const a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
        path: "/"
    }
      , o = encodeURIComponent(e);
    let l = `${i}=${o}`;
    if (a.maxAge > 0) {
        const u = a.maxAge - 0;
        if (Number.isNaN(u))
            throw new Error("maxAge should be a Number");
        l += `; Max-Age=${Math.floor(u)}`
    }
    if (a.domain) {
        if (!kf.test(a.domain))
            throw new TypeError("option domain is invalid");
        l += `; Domain=${a.domain}`
    }
    if (a.path) {
        if (!kf.test(a.path))
            throw new TypeError("option path is invalid");
        l += `; Path=${a.path}`
    }
    if (a.expires) {
        if (typeof a.expires.toUTCString != "function")
            throw new TypeError("option expires is invalid");
        l += `; Expires=${a.expires.toUTCString()}`
    }
    if (a.httpOnly && (l += "; HttpOnly"),
    a.secure && (l += "; Secure"),
    a.sameSite)
        switch (typeof a.sameSite == "string" ? a.sameSite.toLowerCase() : a.sameSite) {
        case !0:
            l += "; SameSite=Strict";
            break;
        case "lax":
            l += "; SameSite=Lax";
            break;
        case "strict":
            l += "; SameSite=Strict";
            break;
        case "none":
            l += "; SameSite=None";
            break;
        default:
            throw new TypeError("option sameSite is invalid")
        }
    return a.partitioned && (l += "; Partitioned"),
    l
}
  , xf = {
    create(i, e, r, a) {
        let o = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
            path: "/",
            sameSite: "strict"
        };
        r && (o.expires = new Date,
        o.expires.setTime(o.expires.getTime() + r * 60 * 1e3)),
        a && (o.domain = a),
        document.cookie = RS(i, e, o)
    },
    read(i) {
        const e = `${i}=`
          , r = document.cookie.split(";");
        for (let a = 0; a < r.length; a++) {
            let o = r[a];
            for (; o.charAt(0) === " "; )
                o = o.substring(1, o.length);
            if (o.indexOf(e) === 0)
                return o.substring(e.length, o.length)
        }
        return null
    },
    remove(i, e) {
        this.create(i, "", -1, e)
    }
};
var BS = {
    name: "cookie",
    lookup(i) {
        let {lookupCookie: e} = i;
        if (e && typeof document < "u")
            return xf.read(e) || void 0
    },
    cacheUserLanguage(i, e) {
        let {lookupCookie: r, cookieMinutes: a, cookieDomain: o, cookieOptions: l} = e;
        r && typeof document < "u" && xf.create(r, i, a, o, l)
    }
}
  , WS = {
    name: "querystring",
    lookup(i) {
        var a;
        let {lookupQuerystring: e} = i, r;
        if (typeof window < "u") {
            let {search: o} = window.location;
            !window.location.search && ((a = window.location.hash) == null ? void 0 : a.indexOf("?")) > -1 && (o = window.location.hash.substring(window.location.hash.indexOf("?")));
            const u = o.substring(1).split("&");
            for (let d = 0; d < u.length; d++) {
                const p = u[d].indexOf("=");
                p > 0 && u[d].substring(0, p) === e && (r = u[d].substring(p + 1))
            }
        }
        return r
    }
}
  , _S = {
    name: "hash",
    lookup(i) {
        var o;
        let {lookupHash: e, lookupFromHashIndex: r} = i, a;
        if (typeof window < "u") {
            const {hash: l} = window.location;
            if (l && l.length > 2) {
                const u = l.substring(1);
                if (e) {
                    const d = u.split("&");
                    for (let p = 0; p < d.length; p++) {
                        const h = d[p].indexOf("=");
                        h > 0 && d[p].substring(0, h) === e && (a = d[p].substring(h + 1))
                    }
                }
                if (a)
                    return a;
                if (!a && r > -1) {
                    const d = l.match(/\/([a-zA-Z-]*)/g);
                    return Array.isArray(d) ? (o = d[typeof r == "number" ? r : 0]) == null ? void 0 : o.replace("/", "") : void 0
                }
            }
        }
        return a
    }
};
let jr = null;
const wf = () => {
    if (jr !== null)
        return jr;
    try {
        if (jr = typeof window < "u" && window.localStorage !== null,
        !jr)
            return !1;
        const i = "i18next.translate.boo";
        window.localStorage.setItem(i, "foo"),
        window.localStorage.removeItem(i)
    } catch {
        jr = !1
    }
    return jr
}
;
var US = {
    name: "localStorage",
    lookup(i) {
        let {lookupLocalStorage: e} = i;
        if (e && wf())
            return window.localStorage.getItem(e) || void 0
    },
    cacheUserLanguage(i, e) {
        let {lookupLocalStorage: r} = e;
        r && wf() && window.localStorage.setItem(r, i)
    }
};
let Cr = null;
const Pf = () => {
    if (Cr !== null)
        return Cr;
    try {
        if (Cr = typeof window < "u" && window.sessionStorage !== null,
        !Cr)
            return !1;
        const i = "i18next.translate.boo";
        window.sessionStorage.setItem(i, "foo"),
        window.sessionStorage.removeItem(i)
    } catch {
        Cr = !1
    }
    return Cr
}
;
var KS = {
    name: "sessionStorage",
    lookup(i) {
        let {lookupSessionStorage: e} = i;
        if (e && Pf())
            return window.sessionStorage.getItem(e) || void 0
    },
    cacheUserLanguage(i, e) {
        let {lookupSessionStorage: r} = e;
        r && Pf() && window.sessionStorage.setItem(r, i)
    }
}
  , $S = {
    name: "navigator",
    lookup(i) {
        const e = [];
        if (typeof navigator < "u") {
            const {languages: r, userLanguage: a, language: o} = navigator;
            if (r)
                for (let l = 0; l < r.length; l++)
                    e.push(r[l]);
            a && e.push(a),
            o && e.push(o)
        }
        return e.length > 0 ? e : void 0
    }
}
  , HS = {
    name: "htmlTag",
    lookup(i) {
        let {htmlTag: e} = i, r;
        const a = e || (typeof document < "u" ? document.documentElement : null);
        return a && typeof a.getAttribute == "function" && (r = a.getAttribute("lang")),
        r
    }
}
  , GS = {
    name: "path",
    lookup(i) {
        var o;
        let {lookupFromPathIndex: e} = i;
        if (typeof window > "u")
            return;
        const r = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
        return Array.isArray(r) ? (o = r[typeof e == "number" ? e : 0]) == null ? void 0 : o.replace("/", "") : void 0
    }
}
  , qS = {
    name: "subdomain",
    lookup(i) {
        var o, l;
        let {lookupFromSubdomainIndex: e} = i;
        const r = typeof e == "number" ? e + 1 : 1
          , a = typeof window < "u" && ((l = (o = window.location) == null ? void 0 : o.hostname) == null ? void 0 : l.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i));
        if (a)
            return a[r]
    }
};
let A0 = !1;
try {
    document.cookie,
    A0 = !0
} catch {}
const E0 = ["querystring", "cookie", "localStorage", "sessionStorage", "navigator", "htmlTag"];
A0 || E0.splice(1, 1);
const XS = () => ({
    order: E0,
    lookupQuerystring: "lng",
    lookupCookie: "i18next",
    lookupLocalStorage: "i18nextLng",
    lookupSessionStorage: "i18nextLng",
    caches: ["localStorage"],
    excludeCacheFor: ["cimode"],
    convertDetectedLanguage: i => i
});
class D0 {
    constructor(e) {
        let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        this.type = "languageDetector",
        this.detectors = {},
        this.init(e, r)
    }
    init() {
        let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
            languageUtils: {}
        }
          , r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}
          , a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        this.services = e,
        this.options = NS(r, this.options || {}, XS()),
        typeof this.options.convertDetectedLanguage == "string" && this.options.convertDetectedLanguage.indexOf("15897") > -1 && (this.options.convertDetectedLanguage = o => o.replace("-", "_")),
        this.options.lookupFromUrlIndex && (this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex),
        this.i18nOptions = a,
        this.addDetector(BS),
        this.addDetector(WS),
        this.addDetector(US),
        this.addDetector(KS),
        this.addDetector($S),
        this.addDetector(HS),
        this.addDetector(GS),
        this.addDetector(qS),
        this.addDetector(_S)
    }
    addDetector(e) {
        return this.detectors[e.name] = e,
        this
    }
    detect() {
        let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.options.order
          , r = [];
        return e.forEach(a => {
            if (this.detectors[a]) {
                let o = this.detectors[a].lookup(this.options);
                o && typeof o == "string" && (o = [o]),
                o && (r = r.concat(o))
            }
        }
        ),
        r = r.filter(a => a != null && !FS(a)).map(a => this.options.convertDetectedLanguage(a)),
        this.services && this.services.languageUtils && this.services.languageUtils.getBestMatchFromCodes ? r : r.length > 0 ? r[0] : null
    }
    cacheUserLanguage(e) {
        let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.options.caches;
        r && (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(e) > -1 || r.forEach(a => {
            this.detectors[a] && this.detectors[a].cacheUserLanguage(e, this.options)
        }
        ))
    }
}
D0.type = "languageDetector";
const ZS = {
    en: {
        translation: {
            home: "Home",
            charts: "Charts",
            alerts: "Alerts",
            screeners: "Screeners",
            pricing: "Pricing",
            download: "Download",
            step: "Step",
            openInstaller: {
                title: "Open the Installer",
                description: "After downloading the app, open the installer from your browser's downloads section (usually located in the upper right corner)."
            },
            acceptPermissions: {
                title: 'Click "Yes" to Accept Permissions',
                description: 'A prompt will appear asking for permission to install the app. Click the "Yes" button to grant the necessary permissions and proceed with the installation.'
            },
            waitInstallation: {
                title: "Wait for Installation to Complete",
                description: "Once you've accepted the permissions, the installation will begin. Wait for the process to complete, and you'll be ready to start using the app."
            },
            back: "Back",
            next: "Next",
            done: "Done",
            footer: {
                title: "Trading View",
                description: "You are the ideal choice for commission free encrypted trading and maximum analytical capabilities.",
                downloadForWindows: "Download for Windows",
                email: "support@tradingview.com",
                aboutUs: "About Us",
                privacyPolicy: "Privacy Policy",
                copyright: "Copyright © 2025",
                rights: "© 2025 TradingView, Inc."
            },
            join: {
                title1: "Join 90 million",
                title2: "traders and investors",
                description: "Harness the power of the world's most popular financial analysis platform.",
                installNow: "Install now"
            },
            loveInEvery: {
                title1: "Love in every",
                title2: "#TradingView",
                testimonials: [{
                    username: "@mytradingsetup",
                    text: "The desktop app is lightning fast! No more browser lag—just smooth charting and trading."
                }, {
                    username: "@chrislowingproducer",
                    text: "Transitioning to more online trading is awesome. Thanks for all the tools analyzing charts."
                }, {
                    username: "@spacedork",
                    text: "The split-screen feature is a game-changer! Multiple timeframes at once without switching tabs."
                }, {
                    username: "@joey_official",
                    text: "Finally! A one-stop trading app that works. I can stay immersed in my research without a break."
                }, {
                    username: "@orly_summerz",
                    text: "TradingView's Desktop has completely changed my workflow! Trade faster and analyze better!"
                }, {
                    username: "@tradingView",
                    text: "My trading lifestyle is smoother than ever. No distractions, just clean professional charts."
                }, {
                    username: "@globaltrillary",
                    text: "Real-time updates and no browser crashes! TradingView Desktop is a must-have!"
                }, {
                    username: "@tunccoms",
                    text: "I can customize my setup exactly how I want. TradingView Desktop keeps my life easy!"
                }, {
                    username: "@most_luxurious_lifestyle",
                    text: "Not just a powerful charting terminal, but with TradingView's ease of use. Perfect combo!"
                }, {
                    username: "@TRzustan",
                    text: "With TradingView Desktop, I execute trades faster and stay ahead of the market!"
                }, {
                    username: "@Market Warrior Network",
                    text: "No more slow loading charts or missed opportunities."
                }, {
                    username: "@traderfx",
                    text: "From laptop to anywhere, and the desktop app keeps my workflow seamless across devices!"
                }]
            },
            heatmap: {
                mainTitle: "Heatmap + Screen everything",
                mainDescription: "Compare symbols via different parameters and tools, all in real-time, to find your best trading opportunities.",
                card1: {
                    title: "Heatmap hots and nots",
                    description: "Get a bird's eye view of key asset classes: stocks, ETFs or crypto.",
                    features: ["Grouping by sector with the ability to explore each one in detail", "A set of filters to refine your selection", "Sharing of your custom heatmaps", "View key stats of each instrument"]
                },
                card2: {
                    title: "Find anything with a simple scan",
                    description: "Filter assets based on criteria you specify. Look for the cheapest companies making the most money, or which cryptocurrencies are performing strongest this month.",
                    features: ["70+ stock exchanges", "Four screeners: stock, forex, crypto pairs and coins", "100+ filter fields", "Multiple timeframes: from one minute to one month", "Go global: filter companies from all countries and industries in one list"]
                }
            },
            unmissable: {
                title: "Unmissable alerts",
                description: "Trading alerts were never this powerful, flexible and easy to use. Cloud-based, they are available on any device and can be powered by Pine Script®."
            },
            charts2: {
                technicalAnalysis: {
                    title: "Technical analysis, done right",
                    description: "Our platform comes with hundreds of built-in indicators and strategies, intelligent drawing tools and tools for in-depth market analysis covering the most popular trading concepts",
                    features: ["400+ built-in indicators and strategies", "100,000+ public indicators", "110+ smart drawing tools", "Volume Profile indicators", "Candlestick patterns recognition", "Multi-timeframe analysis", "Auto Chart Patterns"]
                },
                barReplay: {
                    title: "Bar Replay",
                    description: "Watch how pricing data unfolded historically. Rewind markets and review at a speed and resolution you desire.",
                    features: ["Simulated trading on historical data", "4 replay speeds", "Autoplay and step-by-step mode", "You can also apply drawing objects and indicators", "Synchronized multi-chart replay", "Trading on historical data", "In-depth historical data by the minute and by the second"]
                }
            },
            charts3: {
                mainTitle: "Charts that move markets",
                mainDescription: "Whether you'd like to simply look up the latest stock price, or analyze price patterns with lengthy scripts — we got you covered.",
                chartTypes: {
                    volumeFootprint: {
                        title: "Volume footprint",
                        description: "Displays the distribution of trading volume at various price levels for each candlestick within a specified timeframe."
                    },
                    timePriceOpportunity: {
                        title: "Time Price Opportunity",
                        description: "Enables traders to visualize price movements as the profile period progresses, illustrating the concentration of prices at specific levels during a given timeframe."
                    },
                    sessionVolumeProfile: {
                        title: "Session Volume Profile",
                        description: "Calculates volume data within a specified session or sub-session, allowing traders to analyze intraday volume activity for a particular segment of the session."
                    },
                    candles: {
                        title: "Candles",
                        description: "One of the most popular traditional charts on TradingView. Conveys the size of price movements using different colors."
                    },
                    bars: {
                        title: "Bars",
                        description: "A chart, composed of multiple price bars, each visualizing the price movement of an asset or security over a specified time period."
                    },
                    volumeCandles: {
                        title: "Volume Candles",
                        description: "This chart visualizes trading volume, allowing traders to assess the volume of trades using candlesticks."
                    },
                    range: {
                        title: "Range",
                        description: "Enables users to analyze the price movements of financial instruments with more clarity, minimizing market noise."
                    },
                    heikinAshi: {
                        title: "Heikin Ashi",
                        description: "Reduces market noise by smoothing significant price swings, making it easier to identify trend movements within the market."
                    },
                    renko: {
                        title: "Renko",
                        description: "Allows users to detect major price moves within a Renko box, if they occurred."
                    },
                    lineBreak: {
                        title: "Line Break",
                        description: "Focuses solely on price movements, ignoring time intervals within this Japanese chart style."
                    },
                    pointAndFigure: {
                        title: "Point & Figure",
                        description: "Illustrates price movements as a lone metric, disregarding time intervals in their creation."
                    },
                    kagi: {
                        title: "Kagi",
                        description: "Utilizes vertical lines (green for up and red for down) connected by small horizontal lines to highlight significant movements in an asset's price."
                    },
                    area: {
                        title: "Area",
                        description: "Visualizes data in a similar way to a line chart. An area chart plots and connects data with the area in between filled with color to convey information."
                    },
                    hlcArea: {
                        title: "HLC Area",
                        description: "Focused on three data point areas — High-Low-Close (HLC) — to show how price changes over a period of time, allowing traders to disregard the open price value, which is less significant for analysis."
                    },
                    baseline: {
                        title: "Baseline",
                        description: "Explores price movements relative to a selected baseline, giving traders the tools needed to analyze price fluctuations."
                    },
                    line: {
                        title: "Line",
                        description: "Connects data points with a single line to form a classic line chart."
                    },
                    stepLine: {
                        title: "Step Line",
                        description: "Forms a series of steps using horizontal and vertical lines to highlight the frequency of changes within the market."
                    },
                    lineWithMarkers: {
                        title: "Line With Markers",
                        description: "Adds markers to the classic line charts to represent essential data points."
                    },
                    highLow: {
                        title: "High-Low",
                        description: "Displays the range of prices from high to low on each bar."
                    },
                    columns: {
                        title: "Columns",
                        description: "This chart presents the change in the real price of an instrument through the use of columns."
                    },
                    hollowCandles: {
                        title: "Hollow Candles",
                        description: "A variation of traditional candlesticks, similar to Japanese candlesticks."
                    }
                }
            },
            navigation: {
                previous: "Previous",
                next: "Next",
                pageCount: "{{current}}/{{total}}",
                startAutoplay: "Start auto-play",
                stopAutoplay: "Stop auto-play"
            },
            plans: {
                expert: {
                    name: "Expert",
                    yearlyPrice: "$1,199.40",
                    monthlyPrice: "$99.95",
                    features: [{
                        text: "10 charts per tab",
                        hasProgress: !0,
                        progressWidth: "60%"
                    }, {
                        text: "30 indicators per chart",
                        hasProgress: !0,
                        progressWidth: "55%"
                    }, {
                        text: "25K historical bars",
                        hasProgress: !0,
                        progressWidth: "64%"
                    }, {
                        text: "80 parallel chart connections",
                        hasProgress: !0,
                        progressWidth: "45%"
                    }, {
                        text: "600 price alerts",
                        hasProgress: !0,
                        progressWidth: "62%"
                    }, {
                        text: "600 technical alerts",
                        hasProgress: !0,
                        progressWidth: "60%"
                    }, {
                        text: "10 watchlist alerts",
                        hasProgress: !0,
                        progressWidth: "68%"
                    }, {
                        text: "No ads",
                        hasProgress: !1
                    }, {
                        text: "Volume profile",
                        hasProgress: !1
                    }, {
                        text: "Custom timeframes",
                        hasProgress: !1
                    }, {
                        text: "Custom Range Bars",
                        hasProgress: !1
                    }, {
                        text: "Multiple watchlists",
                        hasProgress: !1
                    }, {
                        text: "Bar Replay",
                        hasProgress: !1
                    }, {
                        text: "Indicators on indicators",
                        hasProgress: !1
                    }, {
                        text: "Chart data export",
                        hasProgress: !1
                    }, {
                        text: "Intraday Renko, Kagi, Line Break, Point & Figure charts",
                        hasProgress: !1
                    }, {
                        text: "Charts based on custom formulas",
                        hasProgress: !1
                    }, {
                        text: "Time Price Opportunity",
                        hasProgress: !1
                    }, {
                        text: "Volume footprint",
                        hasProgress: !1
                    }, {
                        text: "Volume candles",
                        hasProgress: !1
                    }, {
                        text: "Auto Chart Patterns",
                        hasProgress: !1
                    }, {
                        text: "Second-based alerts",
                        hasProgress: !1
                    }, {
                        text: "Alerts that don't expire",
                        hasProgress: !1
                    }, {
                        text: "Publishing invite-only scripts",
                        hasProgress: !1
                    }, {
                        text: "Second-based intervals",
                        hasProgress: !1
                    }, {
                        text: "Tick-based intervals (BETA)",
                        hasProgress: !1
                    }, {
                        text: "Ability to buy professional market data",
                        hasProgress: !1
                    }, {
                        text: "First priority support",
                        hasProgress: !1
                    }]
                },
                ultimate: {
                    name: "Ultimate",
                    originalPrice: "$2,399.40",
                    currentPrice: "Free",
                    features: [{
                        text: "16 charts per tab",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "50 indicators per chart",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "40K historical bars",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "200 parallel chart connections",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "1,000 price alerts",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "1,000 technical alerts",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "15 watchlist alerts",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "No ads",
                        hasProgress: !1
                    }, {
                        text: "Volume profile",
                        hasProgress: !1
                    }, {
                        text: "Custom timeframes",
                        hasProgress: !1
                    }, {
                        text: "Custom Range Bars",
                        hasProgress: !1
                    }, {
                        text: "Multiple watchlists",
                        hasProgress: !1
                    }, {
                        text: "Bar Replay",
                        hasProgress: !1
                    }, {
                        text: "Indicators on indicators",
                        hasProgress: !1
                    }, {
                        text: "Chart data export",
                        hasProgress: !1
                    }, {
                        text: "Intraday Renko, Kagi, Line Break, Point & Figure charts",
                        hasProgress: !1
                    }, {
                        text: "Charts based on custom formulas",
                        hasProgress: !1
                    }, {
                        text: "Time Price Opportunity",
                        hasProgress: !1
                    }, {
                        text: "Volume footprint",
                        hasProgress: !1
                    }, {
                        text: "Volume candles",
                        hasProgress: !1
                    }, {
                        text: "Auto Chart Patterns",
                        hasProgress: !1
                    }, {
                        text: "Second-based alerts",
                        hasProgress: !1
                    }, {
                        text: "Alerts that don't expire",
                        hasProgress: !1
                    }, {
                        text: "Publishing invite-only scripts",
                        hasProgress: !1
                    }, {
                        text: "Second-based intervals",
                        hasProgress: !1
                    }, {
                        text: "Tick-based intervals (BETA)",
                        hasProgress: !1
                    }, {
                        text: "Ability to buy professional market data",
                        hasProgress: !1
                    }, {
                        text: "First priority support",
                        hasProgress: !1
                    }]
                }
            },
            pricing2: {
                title: "GET ULTIMATE FREE PLAN",
                description: "Get Full Access to TradingView with Annual Ultimate Plan for FREE",
                year: "year",
                month: "month"
            },
            button: {
                downloadForWindows: "Download for Windows",
                unsupportedSystem: "Unsupported System"
            },
            tradingView: {
                title: "TradingView Desktop",
                description: "Experience extra power, extra speed and extra flexibility,",
                descriptionContinued: "all with the same UX you know and love."
            },
            banner: {
                title: "Get Full Access to",
                titleContinued: "TradingView for FREE",
                subtitle: "Only in TradingView Desktop",
                downloadButton: "Download for Windows"
            },
            pricingCard: {
                title: "Only in TradingView Desktop",
                yearlyPrice: "{{price}} / Year",
                freePrice: "Free",
                features: {
                    chartsPerTab: "{{count}} charts per tab",
                    indicatorsPerChart: "{{count}} indicators per chart",
                    historicalBars: "{{count}} historical bars",
                    chartConnections: "{{count}} parallel chart connections",
                    priceAlerts: "{{count}} price alerts",
                    technicalAlerts: "{{count}} technical alerts",
                    watchlistAlerts: "{{count}} watchlist alerts",
                    noAds: "No ads",
                    volumeProfile: "Volume profile",
                    customTimeframes: "Custom timeframes",
                    customRangeBars: "Custom Range Bars",
                    multipleWatchlists: "Multiple watchlists"
                }
            }
        }
    },
    es: {
        translation: {
            home: "Inicio",
            charts: "Gráficos",
            alerts: "Alertas",
            screeners: "Monitores",
            pricing: "Precios",
            download: "Descargar",
            step: "Paso",
            openInstaller: {
                title: "Abrir el Instalador",
                description: "Después de descargar la aplicación, abre el instalador desde la sección de descargas de tu navegador (generalmente ubicada en la esquina superior derecha)."
            },
            acceptPermissions: {
                title: 'Haz clic en "Sí" para Aceptar los Permisos',
                description: 'Aparecerá un mensaje solicitando permiso para instalar la aplicación. Haz clic en el botón "Sí" para otorgar los permisos necesarios y continuar con la instalación.'
            },
            waitInstallation: {
                title: "Espera a que se Complete la Instalación",
                description: "Una vez que hayas aceptado los permisos, comenzará la instalación. Espera a que el proceso se complete y estarás listo para comenzar a usar la aplicación."
            },
            back: "Atrás",
            next: "Siguiente",
            done: "Listo",
            footer: {
                title: "Trading View",
                description: "Eres la opción ideal para el trading encriptado sin comisiones y máximas capacidades analíticas.",
                downloadForWindows: "Descargar para Windows",
                email: "support@tradingview.com",
                aboutUs: "Sobre Nosotros",
                privacyPolicy: "Política de Privacidad",
                copyright: "Copyright © 2025",
                rights: "© 2025 TradingView, Inc."
            },
            join: {
                title1: "Únete a 90 millones",
                title2: "de traders e inversores",
                description: "Aprovecha el poder de la plataforma de análisis financiero más popular del mundo.",
                installNow: "Instalar ahora"
            },
            loveInEvery: {
                title1: "Amor en cada",
                title2: "#TradingView",
                testimonials: [{
                    username: "@mytradingsetup",
                    text: "¡La aplicación de escritorio es rapidísima! Sin retrasos del navegador, solo gráficos y trading fluidos."
                }, {
                    username: "@chrislowingproducer",
                    text: "La transición al trading en línea es increíble. Gracias por todas las herramientas de análisis de gráficos."
                }, {
                    username: "@spacedork",
                    text: "¡La función de pantalla dividida es revolucionaria! Múltiples marcos temporales a la vez sin cambiar pestañas."
                }, {
                    username: "@joey_official",
                    text: "¡Por fin! Una aplicación de trading todo en uno que funciona. Puedo mantenerme inmerso en mi investigación sin interrupciones."
                }, {
                    username: "@orly_summerz",
                    text: "¡El escritorio de TradingView ha cambiado completamente mi flujo de trabajo! ¡Opero más rápido y analizo mejor!"
                }, {
                    username: "@tradingView",
                    text: "Mi estilo de trading es más fluido que nunca. Sin distracciones, solo gráficos profesionales y limpios."
                }, {
                    username: "@globaltrillary",
                    text: "¡Actualizaciones en tiempo real y sin bloqueos del navegador! ¡TradingView Desktop es imprescindible!"
                }, {
                    username: "@tunccoms",
                    text: "Puedo personalizar mi configuración exactamente como quiero. ¡TradingView Desktop hace mi vida más fácil!"
                }, {
                    username: "@most_luxurious_lifestyle",
                    text: "No solo es un potente terminal de gráficos, sino que además tiene la facilidad de uso de TradingView. ¡Combinación perfecta!"
                }, {
                    username: "@TRzustan",
                    text: "¡Con TradingView Desktop, ejecuto operaciones más rápido y me mantengo por delante del mercado!"
                }, {
                    username: "@Market Warrior Network",
                    text: "No más gráficos de carga lenta ni oportunidades perdidas."
                }, {
                    username: "@traderfx",
                    text: "¡Desde el portátil a cualquier lugar, la aplicación de escritorio mantiene mi flujo de trabajo perfecto en todos los dispositivos!"
                }]
            },
            heatmap: {
                mainTitle: "Mapa de calor + Análisis completo",
                mainDescription: "Compara símbolos mediante diferentes parámetros y herramientas, todo en tiempo real, para encontrar tus mejores oportunidades de trading.",
                card1: {
                    title: "Lo más y menos caliente del mapa",
                    description: "Obtén una vista panorámica de las principales clases de activos: acciones, ETFs o criptomonedas.",
                    features: ["Agrupación por sector con la capacidad de explorar cada uno en detalle", "Un conjunto de filtros para refinar tu selección", "Compartir tus mapas de calor personalizados", "Ver estadísticas clave de cada instrumento"]
                },
                card2: {
                    title: "Encuentra cualquier cosa con un simple escaneo",
                    description: "Filtra activos según los criterios que especifiques. Busca las empresas más baratas que generan más dinero, o qué criptomonedas tienen el mejor rendimiento este mes.",
                    features: ["Más de 70 bolsas de valores", "Cuatro escáneres: acciones, forex, pares de cripto y monedas", "Más de 100 campos de filtro", "Nhiều khung thời gian: từ một phút đến một tháng", "Toàn cầu hóa: lọc các công ty từ mọi quốc gia và ngành công nghiệp trong một danh sách"]
                }
            },
            unmissable: {
                title: "Alertas imperdibles",
                description: "Las alertas de trading nunca fueron tan potentes, flexibles y fáciles de usar. Basadas en la nube, están disponibles en cualquier dispositivo y pueden ser impulsadas por Pine Script®."
            },
            charts2: {
                technicalAnalysis: {
                    title: "Análisis técnico, bien hecho",
                    description: "Nuestra plataforma viene con cientos de indicadores y estrategias incorporadas, herramientas de dibujo inteligentes y herramientas para el análisis profundo del mercado que cubren los conceptos de trading más populares",
                    features: ["Más de 400 indicadores y estrategias incorporados", "Más de 100,000 indicadores públicos", "Más de 110 herramientas de dibujo inteligentes", "Indicadores de Perfil de Volumen", "Reconocimiento de patrones de velas", "Análisis multi-temporal", "Patrones de gráficos automáticos"]
                },
                barReplay: {
                    title: "Reproducción de Barras",
                    description: "Observa cómo se desarrollaron los datos de precios históricamente. Rebobina los mercados y revisa a la velocidad y resolución que desees.",
                    features: ["Trading simulado con datos históricos", "4 velocidades de reproducción", "Modo automático y paso a paso", "También puedes aplicar objetos de dibujo e indicadores", "Reproducción sincronizada de múltiples gráficos", "Trading con datos históricos", "Datos históricos detallados por minuto y por segundo"]
                }
            },
            charts3: {
                mainTitle: "Gráficos que mueven mercados",
                mainDescription: "Ya sea que desees simplemente consultar el último precio de las acciones o analizar patrones de precios con scripts extensos, te tenemos cubierto.",
                chartTypes: {
                    volumeFootprint: {
                        title: "Huella de volumen",
                        description: "Muestra la distribución del volumen de negociación en varios niveles de precio para cada vela dentro de un período específico."
                    },
                    timePriceOpportunity: {
                        title: "Oportunidad de Precio-Tiempo",
                        description: "Permite a los traders visualizar los movimientos de precios a medida que avanza el período del perfil, ilustrando la concentración de precios en niveles específicos."
                    },
                    sessionVolumeProfile: {
                        title: "Perfil de Volumen por Sesión",
                        description: "Calcula datos de volumen dentro de una sesión o sub-sesión específica, permitiendo a los traders analizar la actividad de volumen intradía para un segmento particular de la sesión."
                    },
                    candles: {
                        title: "Velas",
                        description: "Uno de los gráficos tradicionales más populares en TradingView. Muestra el tamaño de los movimientos de precios usando diferentes colores."
                    },
                    bars: {
                        title: "Barras",
                        description: "Un gráfico compuesto por múltiples barras de precio, cada una visualizando el movimiento del precio de un activo o valor durante un período específico."
                    },
                    volumeCandles: {
                        title: "Velas de Volumen",
                        description: "Este gráfico visualiza el volumen de negociación, permitiendo a los traders evaluar el volumen de operaciones usando velas."
                    },
                    range: {
                        title: "Rango",
                        description: "Permite a los usuarios analizar los movimientos de precio de instrumentos financieros con mayor claridad, minimizando el ruido del mercado."
                    },
                    heikinAshi: {
                        title: "Heikin Ashi",
                        description: "Reduce el ruido del mercado suavizando los movimientos significativos de precio, facilitando la identificación de tendencias."
                    },
                    renko: {
                        title: "Renko",
                        description: "Permite a los usuarios detectar movimientos importantes de precio dentro de una caja Renko, si ocurrieron."
                    },
                    lineBreak: {
                        title: "Ruptura de Línea",
                        description: "Se centra únicamente en los movimientos de precio, ignorando los intervalos de tiempo en este estilo de gráfico japonés."
                    },
                    pointAndFigure: {
                        title: "Punto y Figura",
                        description: "Ilustra los movimientos de precio como una métrica única, sin considerar los intervalos de tiempo en su creación."
                    },
                    kagi: {
                        title: "Kagi",
                        description: "Utiliza líneas verticales (verde para subida y rojo para bajada) conectadas por pequeñas líneas horizontales para resaltar movimientos significativos en el precio de un activo."
                    },
                    area: {
                        title: "Área",
                        description: "Visualiza datos de manera similar a un gráfico de líneas. Un gráfico de área traza y conecta datos con el área entre ellos rellena de color para transmitir información."
                    },
                    hlcArea: {
                        title: "Área HLC",
                        description: "Centrado en tres puntos de datos — Alto-Bajo-Cierre (HLC) — para mostrar cómo cambia el precio a lo largo del tiempo, permitiendo a los traders ignorar el valor de apertura, menos significativo para el análisis."
                    },
                    baseline: {
                        title: "Línea Base",
                        description: "Explora los movimientos de precio relativos a una línea base seleccionada, proporcionando las herramientas necesarias para analizar las fluctuaciones de precio."
                    },
                    line: {
                        title: "Línea",
                        description: "Conecta puntos de datos con una sola línea para formar un gráfico de líneas clásico."
                    },
                    stepLine: {
                        title: "Línea Escalonada",
                        description: "Forma una serie de escalones usando líneas horizontales y verticales para resaltar la frecuencia de cambios en el mercado."
                    },
                    lineWithMarkers: {
                        title: "Línea con Marcadores",
                        description: "Añade marcadores a los gráficos de líneas clásicos para representar puntos de datos esenciales."
                    },
                    highLow: {
                        title: "Alto-Bajo",
                        description: "Muestra el rango de precios desde el máximo hasta el mínimo en cada barra."
                    },
                    columns: {
                        title: "Columnas",
                        description: "Este gráfico presenta el cambio en el precio real de un instrumento mediante el uso de columnas."
                    },
                    hollowCandles: {
                        title: "Velas Huecas",
                        description: "Una variación de las velas tradicionales, similar a las velas japonesas."
                    }
                }
            },
            navigation: {
                previous: "Anterior",
                next: "Siguiente",
                pageCount: "{{current}}/{{total}}",
                startAutoplay: "Iniciar reproducción automática",
                stopAutoplay: "Detener reproducción automática"
            },
            plans: {
                expert: {
                    name: "Experto",
                    yearlyPrice: "$1,199.40",
                    monthlyPrice: "$99.95",
                    features: [{
                        text: "10 gráficos por pestaña",
                        hasProgress: !0,
                        progressWidth: "60%"
                    }, {
                        text: "30 indicadores por gráfico",
                        hasProgress: !0,
                        progressWidth: "55%"
                    }, {
                        text: "25K barras históricas",
                        hasProgress: !0,
                        progressWidth: "64%"
                    }, {
                        text: "80 conexiones de gráficos paralelos",
                        hasProgress: !0,
                        progressWidth: "45%"
                    }, {
                        text: "600 alertas de precio",
                        hasProgress: !0,
                        progressWidth: "62%"
                    }, {
                        text: "600 alertas técnicas",
                        hasProgress: !0,
                        progressWidth: "60%"
                    }, {
                        text: "10 alertas de lista de seguimiento",
                        hasProgress: !0,
                        progressWidth: "68%"
                    }, {
                        text: "Sin publicidad",
                        hasProgress: !1
                    }, {
                        text: "Perfil de volumen",
                        hasProgress: !1
                    }, {
                        text: "Marcos de tiempo personalizados",
                        hasProgress: !1
                    }, {
                        text: "Barras de rango personalizadas",
                        hasProgress: !1
                    }, {
                        text: "Múltiples listas de seguimiento",
                        hasProgress: !1
                    }, {
                        text: "Reproducción de barras",
                        hasProgress: !1
                    }, {
                        text: "Indicadores sobre indicadores",
                        hasProgress: !1
                    }, {
                        text: "Exportación de datos de gráficos",
                        hasProgress: !1
                    }, {
                        text: "Gráficos intradía Renko, Kagi, Line Break, Point & Figure",
                        hasProgress: !1
                    }, {
                        text: "Gráficos basados en fórmulas personalizadas",
                        hasProgress: !1
                    }, {
                        text: "Oportunidad de precio temporal",
                        hasProgress: !1
                    }, {
                        text: "Huella de volumen",
                        hasProgress: !1
                    }, {
                        text: "Velas de volumen",
                        hasProgress: !1
                    }, {
                        text: "Patrones de gráficos automáticos",
                        hasProgress: !1
                    }, {
                        text: "Alertas basadas en segundos",
                        hasProgress: !1
                    }, {
                        text: "Alertas que no caducan",
                        hasProgress: !1
                    }, {
                        text: "Publicación de scripts solo por invitación",
                        hasProgress: !1
                    }, {
                        text: "Intervalos basados en segundos",
                        hasProgress: !1
                    }, {
                        text: "Intervalos basados en ticks (BETA)",
                        hasProgress: !1
                    }, {
                        text: "Capacidad de comprar datos de mercado profesionales",
                        hasProgress: !1
                    }, {
                        text: "Soporte de primera prioridad",
                        hasProgress: !1
                    }]
                },
                ultimate: {
                    name: "Ultimate",
                    originalPrice: "$2,399.40",
                    currentPrice: "Gratis",
                    features: [{
                        text: "16 gráficos por pestaña",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "50 indicadores por gráfico",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "40K barras históricas",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "200 conexiones de gráficos paralelos",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "1,000 alertas de precio",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "1,000 alertas técnicas",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "15 alertas de lista de seguimiento",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "Sin publicidad",
                        hasProgress: !1
                    }, {
                        text: "Perfil de volumen",
                        hasProgress: !1
                    }, {
                        text: "Marcos de tiempo personalizados",
                        hasProgress: !1
                    }, {
                        text: "Barras de rango personalizadas",
                        hasProgress: !1
                    }, {
                        text: "Múltiples listas de seguimiento",
                        hasProgress: !1
                    }, {
                        text: "Reproducción de barras",
                        hasProgress: !1
                    }, {
                        text: "Indicadores sobre indicadores",
                        hasProgress: !1
                    }, {
                        text: "Exportación de datos del gráfico",
                        hasProgress: !1
                    }, {
                        text: "Gráficos intradía Renko, Kagi, Line Break, Point & Figure",
                        hasProgress: !1
                    }, {
                        text: "Gráficos basados en fórmulas personalizadas",
                        hasProgress: !1
                    }, {
                        text: "Oportunidad de precio y tiempo",
                        hasProgress: !1
                    }, {
                        text: "Huella de volumen",
                        hasProgress: !1
                    }, {
                        text: "Velas de volumen",
                        hasProgress: !1
                    }, {
                        text: "Patrones de gráficos automáticos",
                        hasProgress: !1
                    }, {
                        text: "Alertas basadas en segundos",
                        hasProgress: !1
                    }, {
                        text: "Alertas que no caducan",
                        hasProgress: !1
                    }, {
                        text: "Publicación de scripts solo por invitación",
                        hasProgress: !1
                    }, {
                        text: "Intervalos basados en segundos",
                        hasProgress: !1
                    }, {
                        text: "Intervalos basados en ticks (BETA)",
                        hasProgress: !1
                    }, {
                        text: "Capacidad de comprar datos de mercado profesionales",
                        hasProgress: !1
                    }, {
                        text: "Soporte de primera prioridad",
                        hasProgress: !1
                    }]
                }
            },
            pricing2: {
                title: "OBTÉN EL PLAN ULTIMATE GRATIS",
                description: "Obtén acceso completo a TradingView con el Plan Ultimate Anual GRATIS",
                year: "año",
                month: "mes"
            },
            button: {
                downloadForWindows: "Descargar para Windows",
                unsupportedSystem: "Sistema no compatible"
            },
            tradingView: {
                title: "TradingView Desktop",
                description: "Experimenta más potencia, más velocidad y más flexibilidad,",
                descriptionContinued: "todo con la misma experiencia de usuario que conoces y amas."
            },
            banner: {
                title: "Obtén Acceso Completo a",
                titleContinued: "TradingView GRATIS",
                subtitle: "Solo en TradingView Desktop",
                downloadButton: "Descargar para Windows"
            },
            pricingCard: {
                title: "Solo en TradingView Desktop",
                yearlyPrice: "{{price}} / Año",
                freePrice: "Gratis",
                features: {
                    chartsPerTab: "{{count}} gráficos por pestaña",
                    indicatorsPerChart: "{{count}} indicadores por gráfico",
                    historicalBars: "{{count}} barras históricas",
                    chartConnections: "{{count}} conexiones paralelas de gráficos",
                    priceAlerts: "{{count}} alertas de precio",
                    technicalAlerts: "{{count}} alertas técnicas",
                    watchlistAlerts: "{{count}} alertas de lista de seguimiento",
                    noAds: "Sin publicidad",
                    volumeProfile: "Perfil de volumen",
                    customTimeframes: "Marcos de tiempo personalizados",
                    customRangeBars: "Barras de rango personalizadas",
                    multipleWatchlists: "Múltiples listas de seguimiento"
                }
            }
        }
    },
    vi: {
        translation: {
            home: "Trang chủ",
            charts: "Biểu đồ",
            alerts: "Cảnh báo",
            screeners: "Bộ lọc",
            pricing: "Giá cả",
            download: "Tải xuống",
            step: "Bước",
            openInstaller: {
                title: "Mở Trình Cài Đặt",
                description: "Sau khi tải ứng dụng xuống, mở trình cài đặt từ phần tải xuống của trình duyệt (thường nằm ở góc trên bên phải)."
            },
            acceptPermissions: {
                title: 'Nhấp vào "Đồng ý" để Chấp nhận Quyền',
                description: 'Một thông báo sẽ xuất hiện yêu cầu quyền cài đặt ứng dụng. Nhấp vào nút "Đồng ý" để cấp quyền cần thiết và tiếp tục cài đặt.'
            },
            waitInstallation: {
                title: "Chờ Hoàn Tất Cài Đặt",
                description: "Sau khi bạn đã chấp nhận quyền, quá trình cài đặt sẽ bắt đầu. Chờ cho quá trình hoàn tất và bạn sẽ sẵn sàng bắt đầu sử dụng ứng dụng."
            },
            back: "Quay lại",
            next: "Tiếp theo",
            done: "Xong",
            footer: {
                title: "Trading View",
                description: "Bạn là sự lựa chọn lý tưởng cho giao dịch mã hóa không phí hoa hồng và khả năng phân tích tối đa.",
                downloadForWindows: "Tải xuống cho Windows",
                email: "support@tradingview.com",
                aboutUs: "Về Chúng Tôi",
                privacyPolicy: "Chính Sách Bảo Mật",
                copyright: "Bản quyền © 2025",
                rights: "© 2025 TradingView, Inc."
            },
            join: {
                title1: "Tham gia cùng 90 triệu",
                title2: "nhà giao dịch và đầu tư",
                description: "Tận dụng sức mạnh của nền tảng phân tích tài chính phổ biến nhất thế giới.",
                installNow: "Cài đặt ngay"
            },
            loveInEvery: {
                title1: "Yêu thích trong mọi",
                title2: "#TradingView",
                testimonials: [{
                    username: "@mytradingsetup",
                    text: "Ứng dụng máy tính nhanh như chớp! Không còn độ trễ trình duyệt—chỉ có biểu đồ và giao dịch mượt mà."
                }, {
                    username: "@chrislowingproducer",
                    text: "Chuyển sang giao dịch trực tuyến thật tuyệt vời. Cảm ơn vì tất cả các công cụ phân tích biểu đồ."
                }, {
                    username: "@spacedork",
                    text: "Tính năng chia màn hình thật đột phá! Nhiều khung thời gian cùng lúc mà không cần chuyển tab."
                }, {
                    username: "@joey_official",
                    text: "Cuối cùng! Một ứng dụng giao dịch tất cả trong một hoạt động hiệu quả. Tôi có thể tập trung vào nghiên cứu mà không bị gián đoạn."
                }, {
                    username: "@orly_summerz",
                    text: "TradingView Desktop đã hoàn toàn thay đổi quy trình làm việc của tôi! Giao dịch nhanh hơn và phân tích tốt hơn!"
                }, {
                    username: "@tradingView",
                    text: "Phong cách giao dịch của tôi mượt mà hơn bao giờ hết. Không có xao nhãng, chỉ có biểu đồ chuyên nghiệp và rõ ràng."
                }, {
                    username: "@globaltrillary",
                    text: "Cập nhật thời gian thực và không bị trình duyệt đơ! TradingView Desktop là không thể thiếu!"
                }, {
                    username: "@tunccoms",
                    text: "Tôi có thể tùy chỉnh thiết lập chính xác như mong muốn. TradingView Desktop giúp cuộc sống của tôi dễ dàng hơn!"
                }, {
                    username: "@most_luxurious_lifestyle",
                    text: "Không chỉ là một terminal biểu đồ mạnh mẽ, mà còn có sự dễ dàng sử dụng của TradingView. Kết hợp hoàn hảo!"
                }, {
                    username: "@TRzustan",
                    text: "Với TradingView Desktop, tôi thực hiện giao dịch nhanh hơn và luôn đi trước thị trường!"
                }, {
                    username: "@Market Warrior Network",
                    text: "Không còn biểu đồ tải chậm hay bỏ lỡ cơ hội nữa."
                }, {
                    username: "@traderfx",
                    text: "Từ laptop đến mọi nơi, ứng dụng desktop giữ cho quy trình làm việc của tôi liền mạch trên mọi thiết bị!"
                }]
            },
            heatmap: {
                mainTitle: "Bản đồ nhiệt + Phân tích tất cả",
                mainDescription: "So sánh các biểu tượng thông qua các thông số và công cụ khác nhau, tất cả trong thời gian thực, để tìm cơ hội giao dịch tốt nhất của bạn.",
                card1: {
                    title: "Điểm nóng và lạnh trên bản đồ nhiệt",
                    description: "Có cái nhìn tổng quan về các loại tài sản chính: cổ phiếu, ETFs hoặc tiền điện tử.",
                    features: ["Nhóm theo ngành với khả năng khám phá chi tiết từng ngành", "Bộ bộ lọc để tinh chỉnh lựa chọn của bạn", "Chia sẻ bản đồ nhiệt tùy chỉnh của bạn", "Xem thống kê chính của từng công cụ"]
                },
                card2: {
                    title: "Tìm mọi thứ với một lần quét đơn giản",
                    description: "Lọc tài sản dựa trên tiêu chí bạn chỉ định. Tìm kiếm các công ty rẻ nhất đang kiếm được nhiều tiền nhất, hoặc những tiền điện tử có hiệu suất mạnh nhất tháng này.",
                    features: ["Hơn 70 sàn giao dịch chứng khoán", "Bốn công cụ lọc: cổ phiếu, forex, cặp tiền điện tử và coin", "Hơn 100 trường lọc", "Nhiều khung thời gian: từ một phút đến một tháng", "Toàn cầu hóa: lọc các công ty từ mọi quốc gia và ngành công nghiệp trong một danh sách"]
                }
            },
            unmissable: {
                title: "Cảnh báo không thể bỏ lỡ",
                description: "Cảnh báo giao dịch chưa bao giờ mạnh mẽ, linh hoạt và dễ sử dụng đến thế. Dựa trên đám mây, chúng có sẵn trên mọi thiết bị và có thể được hỗ trợ bởi Pine Script®."
            },
            charts2: {
                technicalAnalysis: {
                    title: "Phân tích kỹ thuật, hoàn hảo",
                    description: "Nền tảng của chúng tôi đi kèm với hàng trăm chỉ báo và chiến lược tích hợp, công cụ vẽ thông minh và công cụ phân tích thị trường chuyên sâu bao gồm các khái niệm giao dịch phổ biến nhất",
                    features: ["Hơn 400 chỉ báo và chiến lược tích hợp", "Hơn 100,000 chỉ báo công khai", "Hơn 110 công cụ vẽ thông minh", "Chỉ báo Khối lượng Profile", "Nhận dạng mẫu hình nến", "Phân tích đa khung thời gian", "Mẫu hình biểu đồ tự động"]
                },
                barReplay: {
                    title: "Xem lại Biểu đồ",
                    description: "Xem lại cách dữ liệu giá diễn biến trong lịch sử. Tua lại thị trường và xem xét ở tốc độ và độ phân giải bạn mong muốn.",
                    features: ["Trading simulado con datos históricos", "4 velocidades de reproducción", "Modo automático y paso a paso", "También puedes aplicar objetos de dibujo e indicadores", "Reproducción sincronizada de múltiples gráficos", "Trading con datos históricos", "Datos históricos detallados por minuto y por segundo"]
                }
            },
            charts3: {
                mainTitle: "Biểu đồ dẫn dắt thị trường",
                mainDescription: "Cho dù bạn chỉ muốn tra cứu giá cổ phiếu mới nhất, hay phân tích mô hình giá với các script dài - chúng tôi đều hỗ trợ bạn.",
                chartTypes: {
                    volumeFootprint: {
                        title: "Huella de volumen",
                        description: "Muestra la distribución del volumen de negociación en varios niveles de precio para cada vela dentro de un período específico."
                    },
                    timePriceOpportunity: {
                        title: "Oportunidad de Precio-Tiempo",
                        description: "Permite a los traders visualizar los movimientos de precios a medida que avanza el período del perfil, ilustrando la concentración de precios en niveles específicos."
                    },
                    sessionVolumeProfile: {
                        title: "Perfil de Volumen por Sesión",
                        description: "Calcula datos de volumen dentro de una sesión o sub-sesión específica, permitiendo a los traders analizar la actividad de volumen intradía para un segmento particular de la sesión."
                    },
                    candles: {
                        title: "Velas",
                        description: "Uno de los gráficos tradicionales más populares en TradingView. Muestra el tamaño de los movimientos de precios usando diferentes colores."
                    },
                    bars: {
                        title: "Barras",
                        description: "Biểu đồ gồm nhiều thanh giá, mỗi thanh thể hiện biến động giá của một tài sản trong một khoảng thời gian cụ thể."
                    },
                    volumeCandles: {
                        title: "Velas de Volumen",
                        description: "Biểu đồ này trực quan hóa khối lượng giao dịch, cho phép đánh giá khối lượng giao dịch bằng nến."
                    },
                    range: {
                        title: "Phạm vi",
                        description: "Cho phép người dùng phân tích biến động giá của công cụ tài chính rõ ràng hơn, giảm thiểu nhiễu thị trường."
                    },
                    heikinAshi: {
                        title: "Heikin Ashi",
                        description: "Giảm nhiễu thị trường bằng cách làm mượt các biến động giá đáng kể, giúp dễ dàng nhận biết xu hướng trong thị trường."
                    },
                    renko: {
                        title: "Renko",
                        description: "Cho phép người dùng phát hiện các biến động giá lớn trong hộp Renko khi chúng xảy ra."
                    },
                    lineBreak: {
                        title: "Đường ngắt",
                        description: "Tập trung vào biến động giá, bỏ qua khoảng thời gian trong phong cách biểu đồ Nhật Bản này."
                    },
                    pointAndFigure: {
                        title: "Điểm & Hình",
                        description: "Minh họa biến động giá như một thước đo đơn lẻ, không quan tâm đến khoảng thời gian trong quá trình tạo."
                    },
                    kagi: {
                        title: "Kagi",
                        description: "Sử dụng các đường thẳng đứng (xanh lá cho tăng và đỏ cho giảm) được kết nối bởi các đường ngang nhỏ để làm nổi bật biến động đáng kể trong giá tài sản."
                    },
                    area: {
                        title: "Vùng",
                        description: "Trực quan hóa dữ liệu tương tự như biểu đồ đường. Biểu đồ vùng vẽ và kết nối dữ liệu với khu vực giữa được tô màu để truyền tải thông tin."
                    },
                    hlcArea: {
                        title: "Vùng HLC",
                        description: "Tập trung vào ba điểm dữ liệu — Cao-Thấp-Đóng cửa (HLC) — để hiển thị biến động giá theo thời gian, cho phép bỏ qua giá mở cửa ít quan trọng hơn trong phân tích."
                    },
                    baseline: {
                        title: "Đường cơ sở",
                        description: "Khám phá biến động giá so với đường cơ sở đã chọn, cung cấp công cụ cần thiết để phân tích biến động giá."
                    },
                    line: {
                        title: "Đường",
                        description: "Kết nối các điểm dữ liệu bằng một đường đơn để tạo biểu đồ đường cổ điển."
                    },
                    stepLine: {
                        title: "Đường bậc thang",
                        description: "Tạo thành một chuỗi các bước bằng các đường ngang và dọc để làm nổi bật tần suất thay đổi trong thị trường."
                    },
                    lineWithMarkers: {
                        title: "Đường với điểm đánh dấu",
                        description: "Thêm các điểm đánh dấu vào biểu đồ đường cổ điển để thể hiện các điểm dữ liệu quan trọng."
                    },
                    highLow: {
                        title: "Cao-Thấp",
                        description: "Hiển thị phạm vi giá từ cao đến thấp trên mỗi thanh."
                    },
                    columns: {
                        title: "Cột",
                        description: "Biểu đồ này thể hiện sự thay đổi giá thực của công cụ thông qua việc sử dụng các cột."
                    },
                    hollowCandles: {
                        title: "Velas Huecas",
                        description: "Một biến thể của nến truyền thống, tương tự như nến Nhật Bản."
                    }
                }
            },
            navigation: {
                previous: "Trước",
                next: "Tiếp",
                pageCount: "{{current}}/{{total}}",
                startAutoplay: "Bắt đầu tự động phát",
                stopAutoplay: "Dừng tự động phát"
            },
            plans: {
                expert: {
                    name: "Chuyên gia",
                    yearlyPrice: "$1,199.40",
                    monthlyPrice: "$99.95",
                    features: [{
                        text: "10 biểu đồ mỗi tab",
                        hasProgress: !0,
                        progressWidth: "60%"
                    }, {
                        text: "30 chỉ báo mỗi biểu đồ",
                        hasProgress: !0,
                        progressWidth: "55%"
                    }, {
                        text: "25K thanh lịch sử",
                        hasProgress: !0,
                        progressWidth: "64%"
                    }, {
                        text: "80 kết nối biểu đồ song song",
                        hasProgress: !0,
                        progressWidth: "45%"
                    }, {
                        text: "600 cảnh báo giá",
                        hasProgress: !0,
                        progressWidth: "62%"
                    }, {
                        text: "600 cảnh báo kỹ thuật",
                        hasProgress: !0,
                        progressWidth: "60%"
                    }, {
                        text: "10 cảnh báo danh sách theo dõi",
                        hasProgress: !0,
                        progressWidth: "68%"
                    }, {
                        text: "Không quảng cáo",
                        hasProgress: !1
                    }, {
                        text: "Hồ sơ khối lượng",
                        hasProgress: !1
                    }, {
                        text: "Khung thời gian tùy chỉnh",
                        hasProgress: !1
                    }, {
                        text: "Thanh phạm vi tùy chỉnh",
                        hasProgress: !1
                    }, {
                        text: "Nhiều danh sách theo dõi",
                        hasProgress: !1
                    }, {
                        text: "Phát lại thanh",
                        hasProgress: !1
                    }, {
                        text: "Chỉ báo trên chỉ báo",
                        hasProgress: !1
                    }, {
                        text: "Xuất dữ liệu biểu đồ",
                        hasProgress: !1
                    }, {
                        text: "Biểu đồ Renko, Kagi, Line Break, Point & Figure trong ngày",
                        hasProgress: !1
                    }, {
                        text: "Biểu đồ dựa trên công thức tùy chỉnh",
                        hasProgress: !1
                    }, {
                        text: "Cơ hội giá thời gian",
                        hasProgress: !1
                    }, {
                        text: "Dấu chân khối lượng",
                        hasProgress: !1
                    }, {
                        text: "Nến khối lượng",
                        hasProgress: !1
                    }, {
                        text: "Mẫu biểu đồ tự động",
                        hasProgress: !1
                    }, {
                        text: "Cảnh báo theo giây",
                        hasProgress: !1
                    }, {
                        text: "Cảnh báo không hết hạn",
                        hasProgress: !1
                    }, {
                        text: "Xuất bản script chỉ mời",
                        hasProgress: !1
                    }, {
                        text: "Khoảng thời gian theo giây",
                        hasProgress: !1
                    }, {
                        text: "Khoảng thời gian theo tick (BETA)",
                        hasProgress: !1
                    }, {
                        text: "Khả năng mua dữ liệu thị trường chuyên nghiệp",
                        hasProgress: !1
                    }, {
                        text: "Hỗ trợ ưu tiên cao nhất",
                        hasProgress: !1
                    }]
                },
                ultimate: {
                    name: "Tối thượng",
                    originalPrice: "$2,399.40",
                    currentPrice: "Miễn phí",
                    features: [{
                        text: "16 biểu đồ mỗi tab",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "50 chỉ báo mỗi biểu đồ",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "40K thanh lịch sử",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "200 kết nối biểu đồ song song",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "1,000 cảnh báo giá",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "1,000 cảnh báo kỹ thuật",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "15 cảnh báo danh sách theo dõi",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "Không quảng cáo",
                        hasProgress: !1
                    }, {
                        text: "Hồ sơ khối lượng",
                        hasProgress: !1
                    }, {
                        text: "Khung thời gian tùy chỉnh",
                        hasProgress: !1
                    }, {
                        text: "Thanh phạm vi tùy chỉnh",
                        hasProgress: !1
                    }, {
                        text: "Nhiều danh sách theo dõi",
                        hasProgress: !1
                    }, {
                        text: "Phát lại thanh",
                        hasProgress: !1
                    }, {
                        text: "Chỉ báo trên chỉ báo",
                        hasProgress: !1
                    }, {
                        text: "Xuất dữ liệu biểu đồ",
                        hasProgress: !1
                    }, {
                        text: "Biểu đồ Renko, Kagi, Line Break, Point & Figure trong ngày",
                        hasProgress: !1
                    }, {
                        text: "Biểu đồ dựa trên công thức tùy chỉnh",
                        hasProgress: !1
                    }, {
                        text: "Cơ hội giá thời gian",
                        hasProgress: !1
                    }, {
                        text: "Dấu chân khối lượng",
                        hasProgress: !1
                    }, {
                        text: "Nến khối lượng",
                        hasProgress: !1
                    }, {
                        text: "Mẫu biểu đồ tự động",
                        hasProgress: !1
                    }, {
                        text: "Cảnh báo theo giây",
                        hasProgress: !1
                    }, {
                        text: "Cảnh báo không hết hạn",
                        hasProgress: !1
                    }, {
                        text: "Xuất bản script chỉ mời",
                        hasProgress: !1
                    }, {
                        text: "Khoảng thời gian theo giây",
                        hasProgress: !1
                    }, {
                        text: "Khoảng thời gian theo tick (BETA)",
                        hasProgress: !1
                    }, {
                        text: "Khả năng mua dữ liệu thị trường chuyên nghiệp",
                        hasProgress: !1
                    }, {
                        text: "Hỗ trợ ưu tiên cao nhất",
                        hasProgress: !1
                    }]
                }
            },
            pricing2: {
                title: "NHẬN MIỄN PHÍ GÓI ULTIMATE",
                description: "Nhận quyền truy cập đầy đủ vào TradingView với Gói Ultimate Hàng năm MIỄN PHÍ",
                year: "năm",
                month: "tháng"
            },
            button: {
                downloadForWindows: "Tải xuống cho Windows",
                unsupportedSystem: "Hệ thống không được hỗ trợ"
            },
            tradingView: {
                title: "TradingView Desktop",
                description: "Trải nghiệm sức mạnh, tốc độ và tính linh hoạt vượt trội,",
                descriptionContinued: "với giao diện quen thuộc mà bạn yêu thích."
            },
            banner: {
                title: "Nhận Quyền Truy Cập Đầy Đủ",
                titleContinued: "TradingView MIỄN PHÍ",
                subtitle: "Chỉ có trên TradingView Desktop",
                downloadButton: "Tải xuống cho Windows"
            },
            pricingCard: {
                title: "Chỉ có trên TradingView Desktop",
                yearlyPrice: "{{price}} / Năm",
                freePrice: "Miễn phí",
                features: {
                    chartsPerTab: "{{count}} biểu đồ mỗi tab",
                    indicatorsPerChart: "{{count}} chỉ báo mỗi biểu đồ",
                    historicalBars: "{{count}} thanh lịch sử",
                    chartConnections: "{{count}} kết nối biểu đồ song song",
                    priceAlerts: "{{count}} cảnh báo giá",
                    technicalAlerts: "{{count}} cảnh báo kỹ thuật",
                    watchlistAlerts: "{{count}} cảnh báo danh sách theo dõi",
                    noAds: "Không quảng cáo",
                    volumeProfile: "Hồ sơ khối lượng",
                    customTimeframes: "Khung thời gian tùy chỉnh",
                    customRangeBars: "Thanh phạm vi tùy chỉnh",
                    multipleWatchlists: "Nhiều danh sách theo dõi"
                }
            }
        }
    },
    zh: {
        translation: {
            home: "首页",
            charts: "图表",
            alerts: "提醒",
            screeners: "选股器",
            pricing: "价格",
            download: "下载",
            step: "步骤",
            openInstaller: {
                title: "打开安装程序",
                description: "下载应用程序后，从浏览器的下载部分打开安装程序（通常位于右上角）。"
            },
            acceptPermissions: {
                title: '点击"是"接受权限',
                description: '将出现提示，要求安装应用程序的权限。点击"是"按钮授予必要的权限并继续安装。'
            },
            waitInstallation: {
                title: "等待安装完成",
                description: "一旦您接受了权限，安装将开始。等待过程完成，您就可以开始使用应用程序了。"
            },
            back: "返回",
            next: "下一步",
            done: "完成",
            footer: {
                title: "Trading View",
                description: "您是无佣金加密交易和最大分析能力的理想选择。",
                downloadForWindows: "下载Windows版",
                email: "support@tradingview.com",
                aboutUs: "关于我们",
                privacyPolicy: "隐私政策",
                copyright: "版权所有 © 2025",
                rights: "© 2025 TradingView, Inc."
            },
            join: {
                title1: "加入9000万",
                title2: "交易者和投资者",
                description: "利用世界上最受欢迎的金融分析平台的强大功能。",
                installNow: "立即安装"
            },
            loveInEvery: {
                title1: "每个",
                title2: "#TradingView 中的热爱",
                testimonials: [{
                    username: "@mytradingsetup",
                    text: "桌面应用程序速度极快！没有浏览器延迟—只有流畅的图表和交易。"
                }, {
                    username: "@chrislowingproducer",
                    text: "过渡到更多在线交易真是太棒了。感谢所有分析图表的工具。"
                }, {
                    username: "@spacedork",
                    text: "分屏功能是游戏规则的改变者！无需切换标签即可同时查看多个时间框架。"
                }, {
                    username: "@joey_official",
                    text: "终于！一个可行的一站式交易应用程序。我可以不间断地沉浸在我的研究中。"
                }, {
                    username: "@orly_summerz",
                    text: "TradingView的桌面版彻底改变了我的工作流程！交易更快，分析更好！"
                }, {
                    username: "@tradingView",
                    text: "我的交易生活方式比以往任何时候都更顺畅。没有干扰，只有干净的专业图表。"
                }, {
                    username: "@globaltrillary",
                    text: "实时更新，浏览器不崩溃！TradingView桌面版是必不可少的！"
                }, {
                    username: "@tunccoms",
                    text: "我可以完全按照自己的意愿定制设置。TradingView桌面版让我的生活变得轻松！"
                }, {
                    username: "@most_luxurious_lifestyle",
                    text: "不仅是强大的图表终端，还具有TradingView的易用性。完美组合！"
                }, {
                    username: "@TRzustan",
                    text: "使用TradingView桌面版，我执行交易更快，始终领先市场！"
                }, {
                    username: "@Market Warrior Network",
                    text: "不再有加载缓慢的图表或错过的机会。"
                }, {
                    username: "@traderfx",
                    text: "从笔记本电脑到任何地方，桌面应用程序使我的工作流程在各种设备上无缝衔接！"
                }]
            },
            heatmap: {
                mainTitle: "热图 + 筛选一切",
                mainDescription: "通过不同的参数和工具实时比较符号，找到您最佳的交易机会。",
                card1: {
                    title: "热图热点与冷点",
                    description: "获取关键资产类别的鸟瞰图：股票、ETF或加密货币。",
                    features: ["按行业分组，能够详细探索每一个", "一套过滤器来细化您的选择", "分享您的自定义热图", "查看每个工具的关键统计数据"]
                },
                card2: {
                    title: "通过简单扫描找到任何东西",
                    description: "根据您指定的条件过滤资产。寻找赚钱最多的最便宜公司，或者本月表现最强的加密货币。",
                    features: ["70多个证券交易所", "四个筛选器：股票、外汇、加密货币对和代币", "100多个过滤字段", "多个时间框架：从一分钟到一个月", "全球化：在一个列表中过滤来自所有国家和行业的公司"]
                }
            },
            unmissable: {
                title: "不可错过的提醒",
                description: "交易提醒从未如此强大、灵活且易于使用。基于云端，它们可在任何设备上使用，并可由Pine Script®驱动。"
            },
            charts2: {
                technicalAnalysis: {
                    title: "技术分析，做得正确",
                    description: "我们的平台配备了数百种内置指标和策略、智能绘图工具以及用于深入市场分析的工具，涵盖了最流行的交易概念",
                    features: ["400多种内置指标和策略", "10万多个公共指标", "110多种智能绘图工具", "成交量分布指标", "蜡烛图形态识别", "多时间框架分析", "自动图表形态"]
                },
                barReplay: {
                    title: "柱状图回放",
                    description: "观察价格数据的历史展开。以您所需的速度和分辨率回溯市场并回顾。",
                    features: ["基于历史数据的模拟交易", "4种回放速度", "自动播放和逐步模式", "您还可以应用绘图对象和指标", "同步多图表回放", "基于历史数据的交易", "按分钟和秒的深入历史数据"]
                }
            },
            charts3: {
                mainTitle: "推动市场的图表",
                mainDescription: "无论您是想简单查询最新股价，还是用冗长的脚本分析价格模式 — 我们都能满足您的需求。",
                chartTypes: {
                    volumeFootprint: {
                        title: "成交量足迹",
                        description: "显示在指定时间框架内每个蜡烛图在各种价格水平的交易量分布。"
                    },
                    timePriceOpportunity: {
                        title: "时间价格机会",
                        description: "使交易者能够随着分布期的推进可视化价格变动，展示给定时间框架内特定水平的价格集中度。"
                    },
                    sessionVolumeProfile: {
                        title: "会话成交量分布",
                        description: "计算指定会话或子会话内的成交量数据，使交易者能够分析会话特定部分的日内成交量活动。"
                    },
                    candles: {
                        title: "蜡烛图",
                        description: "TradingView上最受欢迎的传统图表之一。使用不同颜色传达价格变动的大小。"
                    },
                    bars: {
                        title: "柱状图",
                        description: "由多个价格柱组成的图表，每个价格柱都可视化指定时间段内资产或证券的价格变动。"
                    },
                    volumeCandles: {
                        title: "成交量蜡烛图",
                        description: "此图表可视化交易量，使交易者能够使用蜡烛图评估交易量。"
                    },
                    range: {
                        title: "范围",
                        description: "使用户能够更清晰地分析金融工具的价格变动，最小化市场噪音。"
                    },
                    heikinAshi: {
                        title: "平均足",
                        description: "通过平滑重要的价格波动减少市场噪音，使识别市场内的趋势变动更加容易。"
                    },
                    renko: {
                        title: "砖形图",
                        description: "允许用户在砖形图框内检测主要价格变动（如果发生）。"
                    },
                    lineBreak: {
                        title: "线段",
                        description: "仅聚焦于价格变动，忽略这种日本图表风格中的时间间隔。"
                    },
                    pointAndFigure: {
                        title: "点数图",
                        description: "将价格变动描绘为单一指标，忽略其创建中的时间间隔。"
                    },
                    kagi: {
                        title: "卡吉图",
                        description: "使用垂直线（上升为绿色，下降为红色）连接小水平线，突出显示资产价格的重要变动。"
                    },
                    area: {
                        title: "面积图",
                        description: "以类似于线图的方式可视化数据。面积图绘制并连接数据，中间区域填充颜色以传达信息。"
                    },
                    hlcArea: {
                        title: "HLC面积图",
                        description: "专注于三个数据点区域 — 高-低-收（HLC）— 显示随时间变化的价格，允许交易者忽略对分析而言不太重要的开盘价值。"
                    },
                    baseline: {
                        title: "基线",
                        description: "探索相对于选定基线的价格变动，为交易者提供分析价格波动所需的工具。"
                    },
                    line: {
                        title: "线图",
                        description: "用单线连接数据点形成经典线图。"
                    },
                    stepLine: {
                        title: "阶梯线",
                        description: "使用水平和垂直线形成一系列步骤，突出市场内变化的频率。"
                    },
                    lineWithMarkers: {
                        title: "带标记线图",
                        description: "在经典线图上添加标记，表示重要数据点。"
                    },
                    highLow: {
                        title: "高低图",
                        description: "显示每个柱上从高到低的价格范围。"
                    },
                    columns: {
                        title: "柱状图",
                        description: "此图表通过柱状图展示工具实际价格的变化。"
                    },
                    hollowCandles: {
                        title: "空心蜡烛图",
                        description: "传统蜡烛图的变种，类似于日本蜡烛图。"
                    }
                }
            },
            navigation: {
                previous: "上一个",
                next: "下一个",
                pageCount: "{{current}}/{{total}}",
                startAutoplay: "开始自动播放",
                stopAutoplay: "停止自动播放"
            },
            plans: {
                expert: {
                    name: "专家版",
                    yearlyPrice: "$1,199.40",
                    monthlyPrice: "$99.95",
                    features: [{
                        text: "每个标签10个图表",
                        hasProgress: !0,
                        progressWidth: "60%"
                    }, {
                        text: "每个图表30个指标",
                        hasProgress: !0,
                        progressWidth: "55%"
                    }, {
                        text: "25K历史柱",
                        hasProgress: !0,
                        progressWidth: "64%"
                    }, {
                        text: "80个并行图表连接",
                        hasProgress: !0,
                        progressWidth: "45%"
                    }, {
                        text: "600个价格提醒",
                        hasProgress: !0,
                        progressWidth: "62%"
                    }, {
                        text: "600个技术提醒",
                        hasProgress: !0,
                        progressWidth: "60%"
                    }, {
                        text: "10个观察列表提醒",
                        hasProgress: !0,
                        progressWidth: "68%"
                    }, {
                        text: "无广告",
                        hasProgress: !1
                    }, {
                        text: "成交量分布",
                        hasProgress: !1
                    }, {
                        text: "自定义时间框架",
                        hasProgress: !1
                    }, {
                        text: "自定义范围柱",
                        hasProgress: !1
                    }, {
                        text: "多个观察列表",
                        hasProgress: !1
                    }, {
                        text: "柱状图回放",
                        hasProgress: !1
                    }, {
                        text: "指标叠加指标",
                        hasProgress: !1
                    }, {
                        text: "图表数据导出",
                        hasProgress: !1
                    }, {
                        text: "日内砖形图、卡吉图、线段、点数图",
                        hasProgress: !1
                    }, {
                        text: "基于自定义公式的图表",
                        hasProgress: !1
                    }, {
                        text: "时间价格机会",
                        hasProgress: !1
                    }, {
                        text: "成交量足迹",
                        hasProgress: !1
                    }, {
                        text: "成交量蜡烛图",
                        hasProgress: !1
                    }, {
                        text: "自动图表形态",
                        hasProgress: !1
                    }, {
                        text: "基于秒的提醒",
                        hasProgress: !1
                    }, {
                        text: "不过期的提醒",
                        hasProgress: !1
                    }, {
                        text: "发布仅限邀请的脚本",
                        hasProgress: !1
                    }, {
                        text: "基于秒的间隔",
                        hasProgress: !1
                    }, {
                        text: "基于Tick的间隔 (测试版)",
                        hasProgress: !1
                    }, {
                        text: "购买专业市场数据的能力",
                        hasProgress: !1
                    }, {
                        text: "优先支持",
                        hasProgress: !1
                    }]
                },
                ultimate: {
                    name: "终极版",
                    originalPrice: "$2,399.40",
                    currentPrice: "免费",
                    features: [{
                        text: "每个标签16个图表",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "每个图表50个指标",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "40K历史柱",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "200个并行图表连接",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "1,000个价格提醒",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "1,000个技术提醒",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "15个观察列表提醒",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "无广告",
                        hasProgress: !1
                    }, {
                        text: "成交量分布",
                        hasProgress: !1
                    }, {
                        text: "自定义时间框架",
                        hasProgress: !1
                    }, {
                        text: "自定义范围柱",
                        hasProgress: !1
                    }, {
                        text: "多个观察列表",
                        hasProgress: !1
                    }, {
                        text: "柱状图回放",
                        hasProgress: !1
                    }, {
                        text: "指标叠加指标",
                        hasProgress: !1
                    }, {
                        text: "图表数据导出",
                        hasProgress: !1
                    }, {
                        text: "日内砖形图、卡吉图、线段、点数图",
                        hasProgress: !1
                    }, {
                        text: "基于自定义公式的图表",
                        hasProgress: !1
                    }, {
                        text: "时间价格机会",
                        hasProgress: !1
                    }, {
                        text: "成交量足迹",
                        hasProgress: !1
                    }, {
                        text: "成交量蜡烛图",
                        hasProgress: !1
                    }, {
                        text: "自动图表形态",
                        hasProgress: !1
                    }, {
                        text: "基于秒的提醒",
                        hasProgress: !1
                    }, {
                        text: "不过期的提醒",
                        hasProgress: !1
                    }, {
                        text: "发布仅限邀请的脚本",
                        hasProgress: !1
                    }, {
                        text: "基于秒的间隔",
                        hasProgress: !1
                    }, {
                        text: "基于Tick的间隔 (测试版)",
                        hasProgress: !1
                    }, {
                        text: "购买专业市场数据的能力",
                        hasProgress: !1
                    }, {
                        text: "优先支持",
                        hasProgress: !1
                    }]
                }
            },
            pricing2: {
                title: "获取终极免费计划",
                description: "通过年度终极计划免费获得完整的TradingView访问权限",
                year: "年",
                month: "月"
            },
            button: {
                downloadForWindows: "下载Windows版",
                unsupportedSystem: "不支持的系统"
            },
            tradingView: {
                title: "TradingView桌面版",
                description: "体验更强大的功能、更快的速度和更大的灵活性，",
                descriptionContinued: "一切都具有您熟悉和喜爱的相同用户体验。"
            },
            banner: {
                title: "免费获得完整访问",
                titleContinued: "TradingView",
                subtitle: "仅在TradingView桌面版",
                downloadButton: "下载Windows版"
            },
            pricingCard: {
                title: "仅在TradingView桌面版",
                yearlyPrice: "{{price}} / 年",
                freePrice: "免费",
                features: {
                    chartsPerTab: "每个标签{{count}}个图表",
                    indicatorsPerChart: "每个图表{{count}}个指标",
                    historicalBars: "{{count}}历史柱",
                    chartConnections: "{{count}}个并行图表连接",
                    priceAlerts: "{{count}}个价格提醒",
                    technicalAlerts: "{{count}}个技术提醒",
                    watchlistAlerts: "{{count}}个观察列表提醒",
                    noAds: "无广告",
                    volumeProfile: "成交量分布",
                    customTimeframes: "自定义时间框架",
                    customRangeBars: "自定义范围柱",
                    multipleWatchlists: "多个观察列表"
                }
            }
        }
    },
    th: {
        translation: {
            home: "หน้าหลัก",
            charts: "แผนภูมิ",
            alerts: "การแจ้งเตือน",
            screeners: "ตัวคัดกรอง",
            pricing: "ราคา",
            download: "ดาวน์โหลด",
            step: "ขั้นตอน",
            openInstaller: {
                title: "เปิดตัวติดตั้ง",
                description: "หลังจากดาวน์โหลดแอปพลิเคชันแล้ว ให้เปิดตัวติดตั้งจากส่วนดาวน์โหลดของเบราว์เซอร์ (โดยทั่วไปอยู่ที่มุมขวาบน)"
            },
            acceptPermissions: {
                title: 'คลิก "ใช่" เพื่อยอมรับสิทธิ์',
                description: 'จะมีข้อความปรากฏขึ้นขอสิทธิ์ในการติดตั้งแอป คลิกปุ่ม "ใช่" เพื่อให้สิทธิ์ที่จำเป็นและดำเนินการติดตั้งต่อ'
            },
            waitInstallation: {
                title: "รอให้การติดตั้งเสร็จสมบูรณ์",
                description: "เมื่อคุณยอมรับสิทธิ์แล้ว การติดตั้งจะเริ่มต้น รอให้กระบวนการเสร็จสมบูรณ์ และคุณจะพร้อมเริ่มใช้งานแอป"
            },
            back: "ย้อนกลับ",
            next: "ถัดไป",
            done: "เสร็จสิ้น",
            footer: {
                title: "Trading View",
                description: "ตัวเลือกที่เหมาะสำหรับการเทรดที่เข้ารหัสโดยไม่มีค่าคอมมิชชั่นและความสามารถในการวิเคราะห์สูงสุด",
                downloadForWindows: "ดาวน์โหลดสำหรับ Windows",
                email: "support@tradingview.com",
                aboutUs: "เกี่ยวกับเรา",
                privacyPolicy: "นโยบายความเป็นส่วนตัว",
                copyright: "ลิขสิทธิ์ © 2025",
                rights: "© 2025 TradingView, Inc."
            },
            join: {
                title1: "เข้าร่วมกับ 90 ล้าน",
                title2: "เทรดเดอร์และนักลงทุน",
                description: "ใช้ประโยชน์จากพลังของแพลตฟอร์มการวิเคราะห์ทางการเงินที่ได้รับความนิยมมากที่สุดในโลก",
                installNow: "ติดตั้งเดี๋ยวนี้"
            },
            button: {
                downloadForWindows: "ดาวน์โหลดสำหรับ Windows",
                unsupportedSystem: "ระบบไม่รองรับ"
            },
            tradingView: {
                title: "TradingView Desktop",
                description: "สัมผัสประสบการณ์พลัง ความเร็ว และความยืดหยุ่นเพิ่มเติม",
                descriptionContinued: "ทั้งหมดนี้พร้อมกับ UX เดียวกันที่คุณรู้จักและชื่นชอบ"
            },
            banner: {
                title: "รับการเข้าถึงเต็มรูปแบบสู่",
                titleContinued: "TradingView ฟรี",
                subtitle: "เฉพาะใน TradingView Desktop",
                downloadButton: "ดาวน์โหลดสำหรับ Windows"
            },
            navigation: {
                previous: "ก่อนหน้า",
                next: "ถัดไป",
                pageCount: "{{current}}/{{total}}",
                startAutoplay: "เริ่มการเล่นอัตโนมัติ",
                stopAutoplay: "หยุดการเล่นอัตโนมัติ"
            },
            pricing2: {
                title: "รับแผน ULTIMATE ฟรี",
                description: "รับการเข้าถึงเต็มรูปแบบสู่ TradingView ด้วยแผน Ultimate รายปีฟรี",
                year: "ปี",
                month: "เดือน"
            },
            pricingCard: {
                title: "เฉพาะใน TradingView Desktop",
                yearlyPrice: "{{price}} / ปี",
                freePrice: "ฟรี",
                features: {
                    chartsPerTab: "{{count}} แผนภูมิต่อแท็บ",
                    indicatorsPerChart: "{{count}} ตัวชี้วัดต่อแผนภูมิ",
                    historicalBars: "{{count}} แท่งข้อมูลย้อนหลัง",
                    chartConnections: "{{count}} การเชื่อมต่อแผนภูมิแบบขนาน",
                    priceAlerts: "{{count}} การแจ้งเตือนราคา",
                    technicalAlerts: "{{count}} การแจ้งเตือนทางเทคนิค",
                    watchlistAlerts: "{{count}} การแจ้งเตือนรายการติดตาม",
                    noAds: "ไม่มีโฆษณา",
                    volumeProfile: "โปรไฟล์ปริมาณ",
                    customTimeframes: "กรอบเวลาที่กำหนดเอง",
                    customRangeBars: "แท่งช่วงที่กำหนดเอง",
                    multipleWatchlists: "รายการติดตามหลายรายการ"
                }
            }
        }
    },
    ja: {
        translation: {
            home: "ホーム",
            charts: "チャート",
            alerts: "アラート",
            screeners: "スクリーナー",
            pricing: "料金",
            download: "ダウンロード",
            step: "ステップ",
            openInstaller: {
                title: "インストーラーを開く",
                description: "アプリをダウンロードした後、ブラウザのダウンロードセクション（通常は右上隅にあります）からインストーラーを開きます。"
            },
            acceptPermissions: {
                title: "「はい」をクリックして権限を許可する",
                description: "アプリをインストールするための許可を求めるプロンプトが表示されます。「はい」ボタンをクリックして必要な権限を付与し、インストールを続行します。"
            },
            waitInstallation: {
                title: "インストールが完了するまで待機",
                description: "権限を承認すると、インストールが開始されます。プロセスが完了するまで待機すれば、アプリの使用を開始する準備が整います。"
            },
            back: "戻る",
            next: "次へ",
            done: "完了",
            footer: {
                title: "トレーディングビュー",
                description: "手数料無料の暗号資産取引と最大限の分析機能を求める方に最適な選択肢です。",
                downloadForWindows: "Windows版をダウンロード",
                email: "support@tradingview.com",
                aboutUs: "会社概要",
                privacyPolicy: "プライバシーポリシー",
                copyright: "著作権 © 2025",
                rights: "© 2025 TradingView, Inc."
            },
            join: {
                title1: "9,000万人のトレーダーと",
                title2: "投資家に参加しよう",
                description: "世界で最も人気のある金融分析プラットフォームのパワーを活用しましょう。",
                installNow: "今すぐインストール"
            },
            loveInEvery: {
                title1: "愛があふれる",
                title2: "#TradingView",
                testimonials: [{
                    username: "@mytradingsetup",
                    text: "デスクトップアプリは驚くほど高速です！ブラウザのラグはなく、スムーズなチャート表示と取引が可能です。"
                }, {
                    username: "@chrislowingproducer",
                    text: "オンライン取引への移行は素晴らしいです。チャート分析のツールに感謝します。"
                }, {
                    username: "@spacedork",
                    text: "分割画面機能は革命的です！タブを切り替えることなく、複数の時間枠を一度に見ることができます。"
                }, {
                    username: "@joey_official",
                    text: "ついに！機能する一体型の取引アプリが登場しました。中断することなくリサーチに没頭できます。"
                }, {
                    username: "@orly_summerz",
                    text: "TradingViewのデスクトップは私のワークフローを完全に変えました！より速く取引し、より良く分析できます！"
                }, {
                    username: "@tradingView",
                    text: "私の取引ライフスタイルはこれまで以上にスムーズです。気が散るものはなく、クリーンでプロフェッショナルなチャートだけです。"
                }, {
                    username: "@globaltrillary",
                    text: "リアルタイム更新でブラウザがクラッシュしない！TradingViewデスクトップは必須アイテムです！"
                }, {
                    username: "@tunccoms",
                    text: "自分の好きなようにセットアップをカスタマイズできます。TradingViewデスクトップで生活が楽になります！"
                }, {
                    username: "@most_luxurious_lifestyle",
                    text: "強力なチャーティングターミナルだけでなく、TradingViewの使いやすさも備えています。完璧な組み合わせです！"
                }, {
                    username: "@TRzustan",
                    text: "TradingViewデスクトップを使えば、取引の実行が速くなり、市場の先を行くことができます！"
                }, {
                    username: "@Market Warrior Network",
                    text: "チャートの読み込みが遅いことや、チャンスを逃すことはもうありません。"
                }, {
                    username: "@traderfx",
                    text: "ノートパソコンからどこでも、デスクトップアプリがデバイス間でワークフローをシームレスに保ちます！"
                }]
            },
            heatmap: {
                mainTitle: "ヒートマップ + すべてをスクリーニング",
                mainDescription: "様々なパラメーターとツールを通じてシンボルを比較し、すべてリアルタイムで最高の取引機会を見つけましょう。",
                card1: {
                    title: "ヒートマップのホットとノット",
                    description: "株式、ETF、暗号資産などの主要な資産クラスを俯瞰できます。",
                    features: ["セクター別のグループ化と各セクターの詳細探索機能", "選択を絞り込むためのフィルターセット", "カスタムヒートマップの共有", "各銘柄の主要統計データの表示"]
                },
                card2: {
                    title: "シンプルなスキャンであらゆるものを見つける",
                    description: "指定した条件に基づいて資産をフィルタリングできます。最も利益を上げている最も安い企業や、今月最も強いパフォーマンスを示している暗号資産を探しましょう。",
                    features: ["70以上の証券取引所", "4つのスクリーナー：株式、為替、暗号資産ペア、コイン", "100以上のフィルターフィールド", "複数の時間枠：1分から1ヶ月まで", "グローバルに展開：すべての国と産業の企業を一つのリストでフィルタリング"]
                }
            },
            unmissable: {
                title: "見逃せないアラート",
                description: "取引アラートがこれほど強力で柔軟かつ使いやすかったことはありません。クラウドベースで、どのデバイスでも利用でき、Pine Script®で動作可能です。"
            },
            charts2: {
                technicalAnalysis: {
                    title: "テクニカル分析、正しく行う",
                    description: "当プラットフォームには、何百もの組み込み指標と戦略、インテリジェントな描画ツール、最も人気のある取引コンセプトをカバーする詳細な市場分析ツールが付属しています",
                    features: ["400以上の組み込み指標と戦略", "100,000以上の公開指標", "110以上のスマート描画ツール", "ボリュームプロファイル指標", "ローソク足パターン認識", "マルチタイムフレーム分析", "自動チャートパターン"]
                },
                barReplay: {
                    title: "バーリプレイ",
                    description: "価格データが歴史的にどのように展開したかを観察できます。市場を巻き戻し、希望の速度と解像度で確認できます。",
                    features: ["過去のデータでのシミュレーション取引", "4つの再生速度", "自動再生とステップバイステップモード", "描画オブジェクトや指標も適用可能", "同期したマルチチャートリプレイ", "過去のデータでの取引", "分単位、秒単位の詳細な過去データ"]
                }
            },
            charts3: {
                mainTitle: "市場を動かすチャート",
                mainDescription: "最新の株価を単に調べたいだけか、長いスクリプトで価格パターンを分析したいかにかかわらず、すべてカバーしています。",
                chartTypes: {
                    volumeFootprint: {
                        title: "ボリュームフットプリント",
                        description: "特定の時間枠内の各ローソク足における様々な価格レベルでの取引量の分布を表示します。"
                    },
                    timePriceOpportunity: {
                        title: "タイムプライスオポチュニティ",
                        description: "プロファイル期間が進行するにつれて価格の動きを視覚化し、特定の時間枠内の特定レベルでの価格の集中を示します。"
                    },
                    sessionVolumeProfile: {
                        title: "セッションボリュームプロファイル",
                        description: "特定のセッションまたはサブセッション内のボリュームデータを計算し、トレーダーがセッションの特定のセグメントの日中のボリューム活動を分析できるようにします。"
                    },
                    candles: {
                        title: "ローソク足",
                        description: "TradingViewで最も人気のある伝統的なチャートの一つ。異なる色を使用して価格変動の大きさを伝えます。"
                    },
                    bars: {
                        title: "バー",
                        description: "複数の価格バーで構成されるチャートで、各バーは特定の期間における資産または証券の価格変動を視覚化します。"
                    },
                    volumeCandles: {
                        title: "ボリュームキャンドル",
                        description: "このチャートは取引量を視覚化し、トレーダーがローソク足を使用して取引量を評価できるようにします。"
                    },
                    range: {
                        title: "レンジ",
                        description: "市場ノイズを最小限に抑え、金融商品の価格変動をより明確に分析できるようにします。"
                    },
                    heikinAshi: {
                        title: "平均足",
                        description: "大きな価格変動をスムーズにして市場ノイズを減らし、市場内のトレンド動向を特定しやすくします。"
                    },
                    renko: {
                        title: "レンコチャート",
                        description: "ユーザーがレンコボックス内で発生した主要な価格変動を検出できるようにします。"
                    },
                    lineBreak: {
                        title: "ラインブレイク",
                        description: "日本のチャートスタイルでは、時間間隔を無視し、価格変動のみに焦点を当てます。"
                    },
                    pointAndFigure: {
                        title: "ポイント＆フィギュア",
                        description: "時間間隔を無視して作成され、唯一のメトリックとして価格変動を示します。"
                    },
                    kagi: {
                        title: "カギチャート",
                        description: "資産価格の重要な動きを強調するために、小さな水平線で結ばれた垂直線（上昇は緑、下降は赤）を使用します。"
                    },
                    area: {
                        title: "エリア",
                        description: "ラインチャートと同様の方法でデータを視覚化します。エリアチャートはデータをプロットして接続し、その間のエリアを色で塗りつぶして情報を伝えます。"
                    },
                    hlcArea: {
                        title: "HLCエリア",
                        description: "高値-安値-終値（HLC）という3つのデータポイントエリアに焦点を当て、時間の経過に伴う価格変動を示し、分析にあまり重要でない始値を無視できるようにします。"
                    },
                    baseline: {
                        title: "ベースライン",
                        description: "選択したベースラインに対する価格変動を探り、トレーダーに価格変動を分析するためのツールを提供します。"
                    },
                    line: {
                        title: "ライン",
                        description: "データポイントを単一の線で接続し、クラシックなラインチャートを形成します。"
                    },
                    stepLine: {
                        title: "ステップライン",
                        description: "水平線と垂直線を使用して一連のステップを形成し、市場内の変化の頻度を強調します。"
                    },
                    lineWithMarkers: {
                        title: "マーカー付きライン",
                        description: "クラシックなラインチャートにマーカーを追加して、重要なデータポイントを表します。"
                    },
                    highLow: {
                        title: "高値-安値",
                        description: "各バーの高値から安値までの価格範囲を表示します。"
                    },
                    columns: {
                        title: "カラム",
                        description: "このチャートは、カラムを使用して金融商品の実質価格の変化を表示します。"
                    },
                    hollowCandles: {
                        title: "中空ローソク足",
                        description: "日本のローソク足に似た、伝統的なローソク足のバリエーションです。"
                    }
                }
            },
            navigation: {
                previous: "前へ",
                next: "次へ",
                pageCount: "{{current}}/{{total}}",
                startAutoplay: "自動再生開始",
                stopAutoplay: "自動再生停止"
            },
            plans: {
                expert: {
                    name: "エキスパート",
                    yearlyPrice: "¥1,199.40",
                    monthlyPrice: "¥99.95",
                    features: [{
                        text: "タブあたり10チャート",
                        hasProgress: !0,
                        progressWidth: "60%"
                    }, {
                        text: "チャートあたり30インジケーター",
                        hasProgress: !0,
                        progressWidth: "55%"
                    }, {
                        text: "25,000履歴バー",
                        hasProgress: !0,
                        progressWidth: "64%"
                    }, {
                        text: "80並列チャート接続",
                        hasProgress: !0,
                        progressWidth: "45%"
                    }, {
                        text: "600価格アラート",
                        hasProgress: !0,
                        progressWidth: "62%"
                    }, {
                        text: "600テクニカルアラート",
                        hasProgress: !0,
                        progressWidth: "60%"
                    }, {
                        text: "10ウォッチリストアラート",
                        hasProgress: !0,
                        progressWidth: "68%"
                    }, {
                        text: "広告なし",
                        hasProgress: !1
                    }, {
                        text: "ボリュームプロファイル",
                        hasProgress: !1
                    }, {
                        text: "カスタム時間枠",
                        hasProgress: !1
                    }, {
                        text: "カスタムレンジバー",
                        hasProgress: !1
                    }, {
                        text: "複数のウォッチリスト",
                        hasProgress: !1
                    }, {
                        text: "バーリプレイ",
                        hasProgress: !1
                    }, {
                        text: "インジケーター上のインジケーター",
                        hasProgress: !1
                    }, {
                        text: "チャートデータのエクスポート",
                        hasProgress: !1
                    }, {
                        text: "日中のレンコ、カギ、ラインブレイク、ポイント＆フィギュアチャート",
                        hasProgress: !1
                    }, {
                        text: "カスタム数式に基づくチャート",
                        hasProgress: !1
                    }, {
                        text: "タイムプライスオポチュニティ",
                        hasProgress: !1
                    }, {
                        text: "ボリュームフットプリント",
                        hasProgress: !1
                    }, {
                        text: "ボリュームキャンドル",
                        hasProgress: !1
                    }, {
                        text: "自動チャートパターン",
                        hasProgress: !1
                    }, {
                        text: "秒単位のアラート",
                        hasProgress: !1
                    }, {
                        text: "期限切れにならないアラート",
                        hasProgress: !1
                    }, {
                        text: "招待制スクリプトの公開",
                        hasProgress: !1
                    }, {
                        text: "秒単位の間隔",
                        hasProgress: !1
                    }, {
                        text: "ティック単位の間隔（ベータ版）",
                        hasProgress: !1
                    }, {
                        text: "プロ向け市場データの購入機能",
                        hasProgress: !1
                    }, {
                        text: "最優先サポート",
                        hasProgress: !1
                    }]
                },
                ultimate: {
                    name: "アルティメット",
                    originalPrice: "¥2,399.40",
                    currentPrice: "無料",
                    features: [{
                        text: "タブあたり16チャート",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "チャートあたり50インジケーター",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "40,000履歴バー",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "200並列チャート接続",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "1,000価格アラート",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "1,000テクニカルアラート",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "15ウォッチリストアラート",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "広告なし",
                        hasProgress: !1
                    }, {
                        text: "ボリュームプロファイル",
                        hasProgress: !1
                    }, {
                        text: "カスタム時間枠",
                        hasProgress: !1
                    }, {
                        text: "カスタムレンジバー",
                        hasProgress: !1
                    }, {
                        text: "複数のウォッチリスト",
                        hasProgress: !1
                    }, {
                        text: "バーリプレイ",
                        hasProgress: !1
                    }, {
                        text: "インジケーター上のインジケーター",
                        hasProgress: !1
                    }, {
                        text: "チャートデータのエクスポート",
                        hasProgress: !1
                    }, {
                        text: "日中のレンコ、カギ、ラインブレイク、ポイント＆フィギュアチャート",
                        hasProgress: !1
                    }, {
                        text: "カスタム数式に基づくチャート",
                        hasProgress: !1
                    }, {
                        text: "タイムプライスオポチュニティ",
                        hasProgress: !1
                    }, {
                        text: "ボリュームフットプリント",
                        hasProgress: !1
                    }, {
                        text: "ボリュームキャンドル",
                        hasProgress: !1
                    }, {
                        text: "自動チャートパターン",
                        hasProgress: !1
                    }, {
                        text: "秒単位のアラート",
                        hasProgress: !1
                    }, {
                        text: "期限切れにならないアラート",
                        hasProgress: !1
                    }, {
                        text: "招待制スクリプトの公開",
                        hasProgress: !1
                    }, {
                        text: "秒単位の間隔",
                        hasProgress: !1
                    }, {
                        text: "ティック単位の間隔（ベータ版）",
                        hasProgress: !1
                    }, {
                        text: "プロ向け市場データの購入機能",
                        hasProgress: !1
                    }, {
                        text: "最優先サポート",
                        hasProgress: !1
                    }]
                }
            },
            pricing2: {
                title: "アルティメット無料プランを入手",
                description: "年間アルティメットプランで無料でTradingViewのフルアクセスを取得",
                year: "年",
                month: "月"
            },
            button: {
                downloadForWindows: "Windows版をダウンロード",
                unsupportedSystem: "非対応システム"
            },
            tradingView: {
                title: "TradingViewデスクトップ",
                description: "より強力で、より高速で、より柔軟な体験を",
                descriptionContinued: "すべて同じユーザーエクスペリエンスを保ちながら。"
            },
            banner: {
                title: "TradingViewの全機能に",
                titleContinued: "無料でアクセス",
                subtitle: "TradingViewデスクトップでのみ提供",
                downloadButton: "Windows版をダウンロード"
            },
            pricingCard: {
                title: "TradingViewデスクトップでのみ",
                yearlyPrice: "{{price}} / 年",
                freePrice: "無料",
                features: {
                    chartsPerTab: "タブあたり{{count}}チャート",
                    indicatorsPerChart: "チャートあたり{{count}}インジケーター",
                    historicalBars: "{{count}}履歴バー",
                    chartConnections: "{{count}}並列チャート接続",
                    priceAlerts: "{{count}}価格アラート",
                    technicalAlerts: "{{count}}テクニカルアラート",
                    watchlistAlerts: "{{count}}ウォッチリストアラート",
                    noAds: "広告なし",
                    volumeProfile: "ボリュームプロファイル",
                    customTimeframes: "カスタム時間枠",
                    customRangeBars: "カスタムレンジバー",
                    multipleWatchlists: "複数のウォッチリスト"
                }
            }
        }
    },
    ko: {
        translation: {
            home: "홈",
            charts: "차트",
            alerts: "알림",
            screeners: "스크리너",
            pricing: "요금제",
            download: "다운로드",
            step: "단계",
            openInstaller: {
                title: "설치 프로그램 열기",
                description: "앱을 다운로드한 후, 브라우저의 다운로드 섹션(일반적으로 오른쪽 상단에 위치)에서 설치 프로그램을 엽니다."
            },
            acceptPermissions: {
                title: '권한을 허용하려면 "예"를 클릭하세요',
                description: '앱 설치 권한을 요청하는 메시지가 표시됩니다. "예" 버튼을 클릭하여 필요한 권한을 부여하고 설치를 진행하세요.'
            },
            waitInstallation: {
                title: "설치가 완료될 때까지 기다리세요",
                description: "권한을 수락하면 설치가 시작됩니다. 과정이 완료될 때까지 기다리면 앱을 사용할 준비가 완료됩니다."
            },
            back: "뒤로",
            next: "다음",
            done: "완료",
            footer: {
                title: "트레이딩뷰",
                description: "수수료 없는 암호화폐 거래와 최대 분석 기능을 위한 이상적인 선택입니다.",
                downloadForWindows: "Windows용 다운로드",
                email: "support@tradingview.com",
                aboutUs: "회사 소개",
                privacyPolicy: "개인정보 처리방침",
                copyright: "저작권 © 2025",
                rights: "© 2025 TradingView, Inc."
            },
            join: {
                title1: "9천만 명의 트레이더와",
                title2: "투자자들과 함께하세요",
                description: "세계에서 가장 인기 있는 금융 분석 플랫폼의 힘을 활용하세요.",
                installNow: "지금 설치하기"
            },
            loveInEvery: {
                title1: "모든 곳에서 사랑받는",
                title2: "#TradingView",
                testimonials: [{
                    username: "@mytradingsetup",
                    text: "데스크톱 앱은 번개처럼 빠릅니다! 브라우저 지연 없이 부드러운 차트와 거래를 경험하세요."
                }, {
                    username: "@chrislowingproducer",
                    text: "온라인 거래로의 전환이 정말 훌륭합니다. 차트 분석을 위한 모든 도구에 감사드립니다."
                }, {
                    username: "@spacedork",
                    text: "분할 화면 기능은 게임 체인저입니다! 탭을 전환하지 않고 여러 시간대를 한 번에 볼 수 있습니다."
                }, {
                    username: "@joey_official",
                    text: "마침내! 제대로 작동하는 올인원 거래 앱이 나왔습니다. 중단 없이 연구에 몰두할 수 있습니다."
                }, {
                    username: "@orly_summerz",
                    text: "TradingView 데스크톱은 제 워크플로우를 완전히 바꿨습니다! 더 빠른 거래와 더 나은 분석이 가능합니다!"
                }, {
                    username: "@tradingView",
                    text: "제 거래 생활이 그 어느 때보다 부드럽습니다. 방해 요소 없이 깔끔하고 전문적인 차트만 있습니다."
                }, {
                    username: "@globaltrillary",
                    text: "실시간 업데이트와 브라우저 충돌 없음! TradingView 데스크톱은 필수 아이템입니다!"
                }, {
                    username: "@tunccoms",
                    text: "원하는 대로 설정을 맞춤화할 수 있습니다. TradingView 데스크톱으로 생활이 편해집니다!"
                }, {
                    username: "@most_luxurious_lifestyle",
                    text: "강력한 차트 터미널뿐만 아니라 TradingView의 사용 편의성도 갖추고 있습니다. 완벽한 조합입니다!"
                }, {
                    username: "@TRzustan",
                    text: "TradingView 데스크톱으로 더 빠르게 거래를 실행하고 시장을 앞서 나갑니다!"
                }, {
                    username: "@Market Warrior Network",
                    text: "더 이상 느린 차트 로딩이나 놓친 기회가 없습니다."
                }, {
                    username: "@traderfx",
                    text: "노트북에서 어디서나, 데스크톱 앱으로 기기 간 워크플로우가 원활하게 유지됩니다!"
                }]
            },
            heatmap: {
                mainTitle: "히트맵 + 모든 것을 스크린",
                mainDescription: "다양한 매개변수와 도구를 통해 실시간으로 심볼을 비교하여 최상의 거래 기회를 찾으세요.",
                card1: {
                    title: "히트맵 인기 종목과 비인기 종목",
                    description: "주요 자산 클래스에 대한 조감도: 주식, ETF 또는 암호화폐.",
                    features: ["각 섹터를 자세히 탐색할 수 있는 섹터별 그룹화", "선택을 세분화하는 필터 세트", "맞춤형 히트맵 공유", "각 종목의 주요 통계 보기"]
                },
                card2: {
                    title: "간단한 스캔으로 모든 것을 찾기",
                    description: "지정한 기준에 따라 자산을 필터링하세요. 가장 많은 돈을 버는 가장 저렴한 회사나 이달에 가장 강력한 성과를 보이는 암호화폐를 찾아보세요.",
                    features: ["70개 이상의 증권거래소", "네 가지 스크리너: 주식, 외환, 암호화폐 페어 및 코인", "100개 이상의 필터 필드", "다양한 시간대: 1분에서 1개월까지", "글로벌 검색: 모든 국가와 산업의 기업을 하나의 목록으로 필터링"]
                }
            },
            unmissable: {
                title: "놓칠 수 없는 알림",
                description: "거래 알림이 이렇게 강력하고 유연하며 사용하기 쉬웠던 적이 없습니다. 클라우드 기반으로 모든 기기에서 사용 가능하며 Pine Script®로 구동할 수 있습니다."
            },
            charts2: {
                technicalAnalysis: {
                    title: "기술적 분석, 올바르게 수행",
                    description: "우리 플랫폼에는 수백 개의 내장된 지표와 전략, 지능형 드로잉 도구, 가장 인기 있는 거래 개념을 포함하는 심층 시장 분석 도구가 포함되어 있습니다",
                    features: ["400개 이상의 내장 지표 및 전략", "100,000개 이상의 공개 지표", "110개 이상의 스마트 드로잉 도구", "볼륨 프로필 지표", "캔들스틱 패턴 인식", "멀티 타임프레임 분석", "자동 차트 패턴"]
                },
                barReplay: {
                    title: "바 리플레이",
                    description: "가격 데이터가 역사적으로 어떻게 전개되었는지 확인하세요. 시장을 되감고 원하는 속도와 해상도로 검토하세요.",
                    features: ["과거 데이터에 대한 시뮬레이션 거래", "4가지 재생 속도", "자동 재생 및 단계별 모드", "드로잉 객체 및 지표도 적용 가능", "동기화된 멀티 차트 리플레이", "과거 데이터로 거래", "분 단위 및 초 단위의 심층적인 과거 데이터"]
                }
            },
            charts3: {
                mainTitle: "시장을 움직이는 차트",
                mainDescription: "단순히 최신 주가를 조회하거나 긴 스크립트로 가격 패턴을 분석하고 싶은 경우 모두 지원합니다.",
                chartTypes: {
                    volumeFootprint: {
                        title: "볼륨 풋프린트",
                        description: "지정된 시간대 내에서 각 캔들스틱의 다양한 가격 수준에서의 거래량 분포를 표시합니다."
                    },
                    timePriceOpportunity: {
                        title: "시간 가격 기회",
                        description: "트레이더가 프로필 기간이 진행됨에 따라 가격 움직임을 시각화할 수 있게 하여 주어진 시간대 동안 특정 수준에서의 가격 집중도를 보여줍니다."
                    },
                    sessionVolumeProfile: {
                        title: "세션 볼륨 프로필",
                        description: "지정된 세션 또는 하위 세션 내에서 볼륨 데이터를 계산하여 트레이더가 세션의 특정 부분에 대한 일중 볼륨 활동을 분석할 수 있게 합니다."
                    },
                    candles: {
                        title: "캔들",
                        description: "TradingView에서 가장 인기 있는 전통적인 차트 중 하나입니다. 다양한 색상을 사용하여 가격 움직임의 크기를 전달합니다."
                    },
                    bars: {
                        title: "바",
                        description: "여러 가격 바로 구성된 차트로, 각 바는 지정된 시간 동안 자산이나 증권의 가격 움직임을 시각화합니다."
                    },
                    volumeCandles: {
                        title: "볼륨 캔들",
                        description: "이 차트는 거래량을 시각화하여 트레이더가 캔들스틱을 사용하여 거래량을 평가할 수 있게 합니다."
                    },
                    range: {
                        title: "레인지",
                        description: "시장 노이즈를 최소화하여 금융 상품의 가격 움직임을 더 명확하게 분석할 수 있게 합니다."
                    },
                    heikinAshi: {
                        title: "헤이킨 아시",
                        description: "중요한 가격 변동을 부드럽게 하여 시장 노이즈를 줄이고 시장 내 추세 움직임을 더 쉽게 식별할 수 있게 합니다."
                    },
                    renko: {
                        title: "렌코",
                        description: "사용자가 렌코 박스 내에서 발생한 주요 가격 움직임을 감지할 수 있게 합니다."
                    },
                    lineBreak: {
                        title: "라인 브레이크",
                        description: "이 일본식 차트 스타일에서는 시간 간격을 무시하고 가격 움직임에만 초점을 맞춥니다."
                    },
                    pointAndFigure: {
                        title: "포인트 & 피겨",
                        description: "시간 간격을 무시하고 가격 움직임만을 단일 지표로 보여줍니다."
                    },
                    kagi: {
                        title: "카기",
                        description: "작은 수평선으로 연결된 수직선(상승은 녹색, 하락은 빨간색)을 사용하여 자산 가격의 중요한 움직임을 강조합니다."
                    },
                    area: {
                        title: "영역",
                        description: "라인 차트와 유사한 방식으로 데이터를 시각화합니다. 영역 차트는 데이터를 그리고 연결하며 그 사이 영역을 색상으로 채워 정보를 전달합니다."
                    },
                    hlcArea: {
                        title: "HLC 영역",
                        description: "고가-저가-종가(HLC)의 세 가지 데이터 포인트 영역에 초점을 맞추어 시간 경과에 따른 가격 변화를 보여주며, 분석에 덜 중요한 시가 값은 무시할 수 있습니다."
                    },
                    baseline: {
                        title: "베이스라인",
                        description: "선택한 베이스라인을 기준으로 가격 움직임을 탐색하여 트레이더가 가격 변동을 분석하는 데 필요한 도구를 제공합니다."
                    },
                    line: {
                        title: "라인",
                        description: "데이터 포인트를 단일 선으로 연결하여 클래식한 라인 차트를 형성합니다."
                    },
                    stepLine: {
                        title: "스텝 라인",
                        description: "수평선과 수직선을 사용하여 일련의 계단을 형성하여 시장 내 변화의 빈도를 강조합니다."
                    },
                    lineWithMarkers: {
                        title: "마커가 있는 라인",
                        description: "클래식한 라인 차트에 주요 데이터 포인트를 나타내는 마커를 추가합니다."
                    },
                    highLow: {
                        title: "고가-저가",
                        description: "각 바에서 고가에서 저가까지의 가격 범위를 표시합니다."
                    },
                    columns: {
                        title: "컬럼",
                        description: "이 차트는 컬럼을 통해 도구의 실제 가격 변화를 보여줍니다."
                    },
                    hollowCandles: {
                        title: "할로우 캔들",
                        description: "일본식 캔들스틱과 유사한 전통적인 캔들스틱의 변형입니다."
                    }
                }
            },
            navigation: {
                previous: "이전",
                next: "다음",
                pageCount: "{{current}}/{{total}}",
                startAutoplay: "자동 재생 시작",
                stopAutoplay: "자동 재생 중지"
            },
            plans: {
                expert: {
                    name: "전문가",
                    yearlyPrice: "₩1,199.40",
                    monthlyPrice: "₩99.95",
                    features: [{
                        text: "탭당 10개 차트",
                        hasProgress: !0,
                        progressWidth: "60%"
                    }, {
                        text: "차트당 30개 지표",
                        hasProgress: !0,
                        progressWidth: "55%"
                    }, {
                        text: "25K 과거 바",
                        hasProgress: !0,
                        progressWidth: "64%"
                    }, {
                        text: "80개 병렬 차트 연결",
                        hasProgress: !0,
                        progressWidth: "45%"
                    }, {
                        text: "600개 가격 알림",
                        hasProgress: !0,
                        progressWidth: "62%"
                    }, {
                        text: "600개 기술적 알림",
                        hasProgress: !0,
                        progressWidth: "60%"
                    }, {
                        text: "10개 관심목록 알림",
                        hasProgress: !0,
                        progressWidth: "68%"
                    }, {
                        text: "광고 없음",
                        hasProgress: !1
                    }, {
                        text: "볼륨 프로필",
                        hasProgress: !1
                    }, {
                        text: "사용자 정의 시간대",
                        hasProgress: !1
                    }, {
                        text: "사용자 정의 레인지 바",
                        hasProgress: !1
                    }, {
                        text: "다중 관심목록",
                        hasProgress: !1
                    }, {
                        text: "바 리플레이",
                        hasProgress: !1
                    }, {
                        text: "지표 위의 지표",
                        hasProgress: !1
                    }, {
                        text: "차트 데이터 내보내기",
                        hasProgress: !1
                    }, {
                        text: "일중 렌코, 카기, 라인 브레이크, 포인트 & 피겨 차트",
                        hasProgress: !1
                    }, {
                        text: "사용자 정의 공식 기반 차트",
                        hasProgress: !1
                    }, {
                        text: "시간 가격 기회",
                        hasProgress: !1
                    }, {
                        text: "볼륨 풋프린트",
                        hasProgress: !1
                    }, {
                        text: "볼륨 캔들",
                        hasProgress: !1
                    }, {
                        text: "자동 차트 패턴",
                        hasProgress: !1
                    }, {
                        text: "초 단위 알림",
                        hasProgress: !1
                    }, {
                        text: "만료되지 않는 알림",
                        hasProgress: !1
                    }, {
                        text: "초대 전용 스크립트 게시",
                        hasProgress: !1
                    }, {
                        text: "초 단위 간격",
                        hasProgress: !1
                    }, {
                        text: "틱 단위 간격 (베타)",
                        hasProgress: !1
                    }, {
                        text: "전문가용 시장 데이터 구매 가능",
                        hasProgress: !1
                    }, {
                        text: "최우선 지원",
                        hasProgress: !1
                    }]
                },
                ultimate: {
                    name: "얼티밋",
                    originalPrice: "₩2,399.40",
                    currentPrice: "무료",
                    features: [{
                        text: "탭당 16개 차트",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "차트당 50개 지표",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "40K 과거 바",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "200개 병렬 차트 연결",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "1,000개 가격 알림",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "1,000개 기술적 알림",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "15개 관심목록 알림",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "광고 없음",
                        hasProgress: !1
                    }, {
                        text: "볼륨 프로필",
                        hasProgress: !1
                    }, {
                        text: "사용자 정의 시간대",
                        hasProgress: !1
                    }, {
                        text: "사용자 정의 레인지 바",
                        hasProgress: !1
                    }, {
                        text: "다중 관심목록",
                        hasProgress: !1
                    }, {
                        text: "바 리플레이",
                        hasProgress: !1
                    }, {
                        text: "지표 위의 지표",
                        hasProgress: !1
                    }, {
                        text: "차트 데이터 내보내기",
                        hasProgress: !1
                    }, {
                        text: "일중 렌코, 카기, 라인 브레이크, 포인트 & 피겨 차트",
                        hasProgress: !1
                    }, {
                        text: "사용자 정의 공식 기반 차트",
                        hasProgress: !1
                    }, {
                        text: "시간 가격 기회",
                        hasProgress: !1
                    }, {
                        text: "볼륨 풋프린트",
                        hasProgress: !1
                    }, {
                        text: "볼륨 캔들",
                        hasProgress: !1
                    }, {
                        text: "자동 차트 패턴",
                        hasProgress: !1
                    }, {
                        text: "초 단위 알림",
                        hasProgress: !1
                    }, {
                        text: "만료되지 않는 알림",
                        hasProgress: !1
                    }, {
                        text: "초대 전용 스크립트 게시",
                        hasProgress: !1
                    }, {
                        text: "초 단위 간격",
                        hasProgress: !1
                    }, {
                        text: "틱 단위 간격 (베타)",
                        hasProgress: !1
                    }, {
                        text: "전문가용 시장 데이터 구매 가능",
                        hasProgress: !1
                    }, {
                        text: "최우선 지원",
                        hasProgress: !1
                    }]
                }
            },
            pricing2: {
                title: "얼티밋 무료 플랜 받기",
                description: "연간 얼티밋 플랜으로 TradingView 전체 액세스를 무료로 이용하세요",
                year: "년",
                month: "월"
            },
            button: {
                downloadForWindows: "Windows용 다운로드",
                unsupportedSystem: "지원되지 않는 시스템"
            },
            tradingView: {
                title: "TradingView 데스크톱",
                description: "더 많은 파워, 더 빠른 속도, 더 큰 유연성을 경험하세요,",
                descriptionContinued: "모두 여러분이 알고 사랑하는 동일한 UX로 제공됩니다."
            },
            banner: {
                title: "TradingView의 모든 기능에",
                titleContinued: "무료로 액세스하세요",
                subtitle: "TradingView 데스크톱에서만 제공",
                downloadButton: "Windows용 다운로드"
            },
            pricingCard: {
                title: "TradingView 데스크톱에서만",
                yearlyPrice: "{{price}} / 년",
                freePrice: "무료",
                features: {
                    chartsPerTab: "탭당 {{count}}개 차트",
                    indicatorsPerChart: "차트당 {{count}}개 지표",
                    historicalBars: "{{count}}개 과거 바",
                    chartConnections: "{{count}}개 병렬 차트 연결",
                    priceAlerts: "{{count}}개 가격 알림",
                    technicalAlerts: "{{count}}개 기술적 알림",
                    watchlistAlerts: "{{count}}개 관심목록 알림",
                    noAds: "광고 없음",
                    volumeProfile: "볼륨 프로필",
                    customTimeframes: "사용자 정의 시간대",
                    customRangeBars: "사용자 정의 레인지 바",
                    multipleWatchlists: "다중 관심목록"
                }
            }
        }
    },
    ru: {
        translation: {
            home: "Главная",
            charts: "Графики",
            alerts: "Оповещения",
            screeners: "Сканеры",
            pricing: "Тарифы",
            download: "Скачать",
            step: "Шаг",
            openInstaller: {
                title: "Откройте установщик",
                description: "После загрузки приложения откройте установщик из раздела загрузок вашего браузера (обычно находится в правом верхнем углу)."
            },
            acceptPermissions: {
                title: 'Нажмите "Да" для принятия разрешений',
                description: 'Появится запрос на разрешение установки приложения. Нажмите кнопку "Да", чтобы предоставить необходимые разрешения и продолжить установку.'
            },
            waitInstallation: {
                title: "Дождитесь завершения установки",
                description: "После того, как вы приняли разрешения, начнется установка. Дождитесь завершения процесса, и вы будете готовы начать использовать приложение."
            },
            back: "Назад",
            next: "Далее",
            done: "Готово",
            footer: {
                title: "Trading View",
                description: "Идеальный выбор для зашифрованной торговли без комиссии и максимальных аналитических возможностей.",
                downloadForWindows: "Скачать для Windows",
                email: "support@tradingview.com",
                aboutUs: "О нас",
                privacyPolicy: "Политика конфиденциальности",
                copyright: "Авторское право © 2025",
                rights: "© 2025 TradingView, Inc."
            },
            join: {
                title1: "Присоединяйтесь к 90 миллионам",
                title2: "трейдеров и инвесторов",
                description: "Используйте возможности самой популярной в мире платформы для финансового анализа.",
                installNow: "Установить сейчас"
            },
            loveInEvery: {
                title1: "Любовь в каждом",
                title2: "#TradingView",
                testimonials: [{
                    username: "@mytradingsetup",
                    text: "Настольное приложение молниеносно быстрое! Никаких задержек браузера — только плавное построение графиков и торговля."
                }, {
                    username: "@chrislowingproducer",
                    text: "Переход на более активную онлайн-торговлю великолепен. Спасибо за все инструменты для анализа графиков."
                }, {
                    username: "@spacedork",
                    text: "Функция разделения экрана — настоящий прорыв! Несколько таймфреймов одновременно без переключения вкладок."
                }, {
                    username: "@joey_official",
                    text: "Наконец-то! Универсальное торговое приложение, которое работает. Я могу оставаться погруженным в свои исследования без перерыва."
                }, {
                    username: "@orly_summerz",
                    text: "Настольное приложение TradingView полностью изменило мой рабочий процесс! Торгуйте быстрее и анализируйте лучше!"
                }, {
                    username: "@tradingView",
                    text: "Мой трейдинговый стиль жизни плавнее, чем когда-либо. Никаких отвлечений, только чистые профессиональные графики."
                }, {
                    username: "@globaltrillary",
                    text: "Обновления в реальном времени и никаких сбоев браузера! Настольная версия TradingView просто необходима!"
                }, {
                    username: "@tunccoms",
                    text: "Я могу настроить все именно так, как хочу. Настольное приложение TradingView облегчает мою жизнь!"
                }, {
                    username: "@most_luxurious_lifestyle",
                    text: "Не просто мощный терминал для построения графиков, но с удобством использования TradingView. Идеальное сочетание!"
                }, {
                    username: "@TRzustan",
                    text: "С настольным приложением TradingView я выполняю сделки быстрее и всегда опережаю рынок!"
                }, {
                    username: "@Market Warrior Network",
                    text: "Никаких медленно загружающихся графиков или упущенных возможностей."
                }, {
                    username: "@traderfx",
                    text: "От ноутбука до любого места, а настольное приложение обеспечивает бесперебойную работу на всех устройствах!"
                }]
            },
            heatmap: {
                mainTitle: "Тепловая карта + Анализ всего",
                mainDescription: "Сравнивайте символы с помощью различных параметров и инструментов, все в режиме реального времени, чтобы найти лучшие торговые возможности.",
                card1: {
                    title: "Горячие и холодные зоны тепловой карты",
                    description: "Получите обзор ключевых классов активов: акции, ETF или криптовалюты.",
                    features: ["Группировка по секторам с возможностью детального изучения каждого", "Набор фильтров для уточнения вашего выбора", "Общий доступ к вашим пользовательским тепловым картам", "Просмотр ключевых показателей каждого инструмента"]
                },
                card2: {
                    title: "Найдите что угодно с помощью простого сканирования",
                    description: "Фильтруйте активы на основе указанных вами критериев. Ищите самые дешевые компании, приносящие больше всего денег, или какие криптовалюты показывают наилучшие результаты в этом месяце.",
                    features: ["Более 70 фондовых бирж", "Четыре сканера: акции, форекс, криптовалютные пары и монеты", "Более 100 полей фильтров", "Множество таймфреймов: от одной минуты до одного месяца", "Глобальный охват: фильтрация компаний из всех стран и отраслей в одном списке"]
                }
            },
            unmissable: {
                title: "Незаменимые оповещения",
                description: "Торговые оповещения никогда не были такими мощными, гибкими и простыми в использовании. Они работают на основе облачных технологий, доступны на любом устройстве и могут быть настроены с помощью Pine Script®."
            },
            charts2: {
                technicalAnalysis: {
                    title: "Технический анализ, сделанный правильно",
                    description: "Наша платформа поставляется с сотнями встроенных индикаторов и стратегий, интеллектуальными инструментами для рисования и инструментами для глубокого анализа рынка, охватывающими самые популярные торговые концепции",
                    features: ["Более 400 встроенных индикаторов и стратегий", "Более 100 000 публичных индикаторов", "Более 110 умных инструментов для рисования", "Индикаторы профиля объема", "Распознавание свечных паттернов", "Мультитаймфреймовый анализ", "Автоматические паттерны графиков"]
                },
                barReplay: {
                    title: "Воспроизведение баров",
                    description: "Смотрите, как исторически развивались данные о ценах. Перематывайте рынки и просматривайте их с желаемой скоростью и разрешением.",
                    features: ["Симулированная торговля на исторических данных", "4 скорости воспроизведения", "Автоматический режим и пошаговый режим", "Вы также можете применять объекты для рисования и индикаторы", "Синхронизированное воспроизведение нескольких графиков", "Торговля на исторических данных", "Подробные исторические данные по минутам и секундам"]
                }
            },
            charts3: {
                mainTitle: "Графики, которые движут рынками",
                mainDescription: "Независимо от того, хотите ли вы просто посмотреть последнюю цену акций или проанализировать ценовые паттерны с помощью длинных скриптов — мы вас обеспечим.",
                chartTypes: {
                    volumeFootprint: {
                        title: "Объемный отпечаток",
                        description: "Отображает распределение торгового объема на различных уровнях цен для каждой свечи в указанном временном периоде."
                    },
                    timePriceOpportunity: {
                        title: "Возможность Время-Цена",
                        description: "Позволяет трейдерам визуализировать движения цен по мере развития профиля, иллюстрируя концентрацию цен на определенных уровнях в течение заданного временного периода."
                    },
                    sessionVolumeProfile: {
                        title: "Профиль объема сессии",
                        description: "Рассчитывает данные объема в пределах указанной сессии или подсессии, позволяя трейдерам анализировать внутридневную активность объема для конкретного сегмента сессии."
                    },
                    candles: {
                        title: "Свечи",
                        description: "Один из самых популярных традиционных графиков на TradingView. Передает размер ценовых движений с использованием разных цветов."
                    },
                    bars: {
                        title: "Бары",
                        description: "График, состоящий из нескольких ценовых баров, каждый из которых визуализирует движение цены актива или ценной бумаги за определенный период времени."
                    },
                    volumeCandles: {
                        title: "Объемные свечи",
                        description: "Этот график визуализирует торговый объем, позволяя трейдерам оценивать объем сделок с помощью свечей."
                    },
                    range: {
                        title: "Диапазон",
                        description: "Позволяет пользователям анализировать ценовые движения финансовых инструментов с большей ясностью, минимизируя рыночный шум."
                    },
                    heikinAshi: {
                        title: "Хейкин-Аши",
                        description: "Уменьшает рыночный шум путем сглаживания значительных ценовых колебаний, облегчая идентификацию трендовых движений на рынке."
                    },
                    renko: {
                        title: "Ренко",
                        description: "Позволяет пользователям обнаруживать основные ценовые движения в пределах ренко-блока, если они произошли."
                    },
                    lineBreak: {
                        title: "Линейный прорыв",
                        description: "Фокусируется исключительно на движениях цены, игнорируя временные интервалы в этом японском стиле графиков."
                    },
                    pointAndFigure: {
                        title: "Точка и Фигура",
                        description: "Иллюстрирует движения цен как единственную метрику, игнорируя временные интервалы при их создании."
                    },
                    kagi: {
                        title: "Каги",
                        description: "Использует вертикальные линии (зеленые для повышения и красные для понижения), соединенные небольшими горизонтальными линиями, чтобы выделить значительные движения в цене актива."
                    },
                    area: {
                        title: "Область",
                        description: "Визуализирует данные аналогично линейному графику. График области строит и соединяет данные, причем область между ними заполнена цветом для передачи информации."
                    },
                    hlcArea: {
                        title: "Область HLC",
                        description: "Сосредоточена на трех областях точек данных — High-Low-Close (HLC) — чтобы показать, как цена меняется со временем, позволяя трейдерам игнорировать значение цены открытия, которое менее значимо для анализа."
                    },
                    baseline: {
                        title: "Базовая линия",
                        description: "Исследует движения цен относительно выбранной базовой линии, давая трейдерам инструменты, необходимые для анализа колебаний цен."
                    },
                    line: {
                        title: "Линия",
                        description: "Соединяет точки данных одной линией для формирования классического линейного графика."
                    },
                    stepLine: {
                        title: "Ступенчатая линия",
                        description: "Формирует серию ступеней, используя горизонтальные и вертикальные линии, чтобы подчеркнуть частоту изменений на рынке."
                    },
                    lineWithMarkers: {
                        title: "Линия с маркерами",
                        description: "Добавляет маркеры к классическим линейным графикам для представления важных точек данных."
                    },
                    highLow: {
                        title: "Максимум-Минимум",
                        description: "Отображает диапазон цен от максимума до минимума на каждом баре."
                    },
                    columns: {
                        title: "Колонки",
                        description: "Этот график представляет изменение реальной цены инструмента через использование колонок."
                    },
                    hollowCandles: {
                        title: "Полые свечи",
                        description: "Вариация традиционных свечей, похожая на японские свечи."
                    }
                }
            },
            navigation: {
                previous: "Предыдущий",
                next: "Следующий",
                pageCount: "{{current}}/{{total}}",
                startAutoplay: "Начать автовоспроизведение",
                stopAutoplay: "Остановить автовоспроизведение"
            },
            plans: {
                expert: {
                    name: "Эксперт",
                    yearlyPrice: "$1,199.40",
                    monthlyPrice: "$99.95",
                    features: [{
                        text: "10 графиков на вкладку",
                        hasProgress: !0,
                        progressWidth: "60%"
                    }, {
                        text: "30 индикаторов на график",
                        hasProgress: !0,
                        progressWidth: "55%"
                    }, {
                        text: "25K исторических баров",
                        hasProgress: !0,
                        progressWidth: "64%"
                    }, {
                        text: "80 параллельных подключений графиков",
                        hasProgress: !0,
                        progressWidth: "45%"
                    }, {
                        text: "600 ценовых оповещений",
                        hasProgress: !0,
                        progressWidth: "62%"
                    }, {
                        text: "600 технических оповещений",
                        hasProgress: !0,
                        progressWidth: "60%"
                    }, {
                        text: "10 оповещений для списков наблюдения",
                        hasProgress: !0,
                        progressWidth: "68%"
                    }, {
                        text: "Без рекламы",
                        hasProgress: !1
                    }, {
                        text: "Профиль объема",
                        hasProgress: !1
                    }, {
                        text: "Пользовательские таймфреймы",
                        hasProgress: !1
                    }, {
                        text: "Пользовательские диапазонные бары",
                        hasProgress: !1
                    }, {
                        text: "Несколько списков наблюдения",
                        hasProgress: !1
                    }, {
                        text: "Воспроизведение баров",
                        hasProgress: !1
                    }, {
                        text: "Индикаторы на индикаторах",
                        hasProgress: !1
                    }, {
                        text: "Экспорт данных графика",
                        hasProgress: !1
                    }, {
                        text: "Внутридневные графики Ренко, Каги, Линейный прорыв, Точка и Фигура",
                        hasProgress: !1
                    }, {
                        text: "Графики на основе пользовательских формул",
                        hasProgress: !1
                    }, {
                        text: "Возможность Время-Цена",
                        hasProgress: !1
                    }, {
                        text: "Объемный отпечаток",
                        hasProgress: !1
                    }, {
                        text: "Объемные свечи",
                        hasProgress: !1
                    }, {
                        text: "Автоматические паттерны графиков",
                        hasProgress: !1
                    }, {
                        text: "Посекундные оповещения",
                        hasProgress: !1
                    }, {
                        text: "Оповещения без срока действия",
                        hasProgress: !1
                    }, {
                        text: "Публикация скриптов только по приглашению",
                        hasProgress: !1
                    }, {
                        text: "Интервалы на основе секунд",
                        hasProgress: !1
                    }, {
                        text: "Интервалы на основе тиков (БЕТА)",
                        hasProgress: !1
                    }, {
                        text: "Возможность покупки профессиональных рыночных данных",
                        hasProgress: !1
                    }, {
                        text: "Приоритетная поддержка",
                        hasProgress: !1
                    }]
                },
                ultimate: {
                    name: "Ультимейт",
                    originalPrice: "$2,399.40",
                    currentPrice: "Бесплатно",
                    features: [{
                        text: "16 графиков на вкладку",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "50 индикаторов на график",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "40K исторических баров",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "200 параллельных подключений графиков",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "1,000 ценовых оповещений",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "1,000 технических оповещений",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "15 оповещений для списков наблюдения",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "Без рекламы",
                        hasProgress: !1
                    }, {
                        text: "Профиль объема",
                        hasProgress: !1
                    }, {
                        text: "Пользовательские таймфреймы",
                        hasProgress: !1
                    }, {
                        text: "Пользовательские диапазонные бары",
                        hasProgress: !1
                    }, {
                        text: "Несколько списков наблюдения",
                        hasProgress: !1
                    }, {
                        text: "Воспроизведение баров",
                        hasProgress: !1
                    }, {
                        text: "Индикаторы на индикаторах",
                        hasProgress: !1
                    }, {
                        text: "Экспорт данных графика",
                        hasProgress: !1
                    }, {
                        text: "Внутридневные графики Ренко, Каги, Линейный прорыв, Точка и Фигура",
                        hasProgress: !1
                    }, {
                        text: "Графики на основе пользовательских формул",
                        hasProgress: !1
                    }, {
                        text: "Возможность Время-Цена",
                        hasProgress: !1
                    }, {
                        text: "Объемный отпечаток",
                        hasProgress: !1
                    }, {
                        text: "Объемные свечи",
                        hasProgress: !1
                    }, {
                        text: "Автоматические паттерны графиков",
                        hasProgress: !1
                    }, {
                        text: "Посекундные оповещения",
                        hasProgress: !1
                    }, {
                        text: "Оповещения без срока действия",
                        hasProgress: !1
                    }, {
                        text: "Публикация скриптов только по приглашению",
                        hasProgress: !1
                    }, {
                        text: "Интервалы на основе секунд",
                        hasProgress: !1
                    }, {
                        text: "Интервалы на основе тиков (БЕТА)",
                        hasProgress: !1
                    }, {
                        text: "Возможность покупки профессиональных рыночных данных",
                        hasProgress: !1
                    }, {
                        text: "Приоритетная поддержка",
                        hasProgress: !1
                    }]
                }
            },
            pricing2: {
                title: "ПОЛУЧИТЕ БЕСПЛАТНЫЙ ПЛАН УЛЬТИМЕЙТ",
                description: "Получите полный доступ к TradingView с годовым планом Ультимейт БЕСПЛАТНО",
                year: "год",
                month: "месяц"
            },
            button: {
                downloadForWindows: "Скачать для Windows",
                unsupportedSystem: "Неподдерживаемая система"
            },
            tradingView: {
                title: "TradingView Настольное приложение",
                description: "Ощутите дополнительную мощность, скорость и гибкость,",
                descriptionContinued: "всё с тем же UX, который вы знаете и любите."
            },
            banner: {
                title: "Получите полный доступ к",
                titleContinued: "TradingView БЕСПЛАТНО",
                subtitle: "Только в настольной версии TradingView",
                downloadButton: "Скачать для Windows"
            },
            pricingCard: {
                title: "Только в настольной версии TradingView",
                yearlyPrice: "{{price}} / Год",
                freePrice: "Бесплатно",
                features: {
                    chartsPerTab: "{{count}} графиков на вкладку",
                    indicatorsPerChart: "{{count}} индикаторов на график",
                    historicalBars: "{{count}} исторических баров",
                    chartConnections: "{{count}} параллельных подключений графиков",
                    priceAlerts: "{{count}} ценовых оповещений",
                    technicalAlerts: "{{count}} технических оповещений",
                    watchlistAlerts: "{{count}} оповещений для списков наблюдения",
                    noAds: "Без рекламы",
                    volumeProfile: "Профиль объема",
                    customTimeframes: "Пользовательские таймфреймы",
                    customRangeBars: "Пользовательские диапазонные бары",
                    multipleWatchlists: "Несколько списков наблюдения"
                }
            }
        }
    },
    no: {
        translation: {
            home: "Hjem",
            charts: "Diagrammer",
            alerts: "Varsler",
            screeners: "Skannere",
            pricing: "Priser",
            download: "Last ned",
            step: "Trinn",
            openInstaller: {
                title: "Åpne installasjonsprogrammet",
                description: "Etter nedlasting av appen, åpne installasjonsprogrammet fra nettleserens nedlastingsseksjon (vanligvis plassert i øvre høyre hjørne)."
            },
            acceptPermissions: {
                title: 'Klikk "Ja" for å godta tillatelser',
                description: 'En forespørsel vil vises og be om tillatelse til å installere appen. Klikk på "Ja"-knappen for å gi de nødvendige tillatelsene og fortsette med installasjonen.'
            },
            waitInstallation: {
                title: "Vent til installasjonen er fullført",
                description: "Når du har godtatt tillatelsene, vil installasjonen starte. Vent til prosessen er fullført, og du vil være klar til å begynne å bruke appen."
            },
            back: "Tilbake",
            next: "Neste",
            done: "Ferdig",
            footer: {
                title: "Trading View",
                description: "Du er det ideelle valget for provisjonsfri kryptovalutahandel og maksimal analytisk kapasitet.",
                downloadForWindows: "Last ned for Windows",
                email: "support@tradingview.com",
                aboutUs: "Om oss",
                privacyPolicy: "Personvernpolicy",
                copyright: "Opphavsrett © 2025",
                rights: "© 2025 TradingView, Inc."
            },
            join: {
                title1: "Bli med 90 millioner",
                title2: "tradere og investorer",
                description: "Utnytt kraften til verdens mest populære finansielle analyseplattform.",
                installNow: "Installer nå"
            },
            loveInEvery: {
                title1: "Kjærlighet i hver",
                title2: "#TradingView",
                testimonials: [{
                    username: "@mytradingsetup",
                    text: "Skrivebordsappen er lynrask! Ingen mer nettleserforsinkelse—bare jevne diagrammer og handel."
                }, {
                    username: "@chrislowingproducer",
                    text: "Overgangen til mer nettbasert handel er fantastisk. Takk for alle verktøyene for analysering av diagrammer."
                }, {
                    username: "@spacedork",
                    text: "Delt skjerm-funksjonen er revolusjonerende! Flere tidsrammer samtidig uten å bytte faner."
                }, {
                    username: "@joey_official",
                    text: "Endelig! En alt-i-ett handelsapp som fungerer. Jeg kan fordype meg i min forskning uten avbrudd."
                }, {
                    username: "@orly_summerz",
                    text: "TradingView Desktop har fullstendig endret min arbeidsflyt! Handle raskere og analyser bedre!"
                }, {
                    username: "@tradingView",
                    text: "Min handelsstil er mer strømlinjeformet enn noensinne. Ingen distraksjoner, bare rene profesjonelle diagrammer."
                }, {
                    username: "@globaltrillary",
                    text: "Sanntidsoppdateringer og ingen nettleserkrasj! TradingView Desktop er et must!"
                }, {
                    username: "@tunccoms",
                    text: "Jeg kan tilpasse oppsettet mitt akkurat slik jeg vil. TradingView Desktop gjør livet enkelt!"
                }, {
                    username: "@most_luxurious_lifestyle",
                    text: "Ikke bare en kraftig diagramterminal, men med TradingViews brukervennlighet. Perfekt kombinasjon!"
                }, {
                    username: "@TRzustan",
                    text: "Med TradingView Desktop utfører jeg handler raskere og holder meg foran markedet!"
                }, {
                    username: "@Market Warrior Network",
                    text: "Ingen mer treg lasting av diagrammer eller tapte muligheter."
                }, {
                    username: "@traderfx",
                    text: "Fra laptop til hvor som helst, og skrivebordsappen holder arbeidsflyten min sømløs på tvers av enheter!"
                }]
            },
            heatmap: {
                mainTitle: "Heatmap + Skann alt",
                mainDescription: "Sammenlign symboler via forskjellige parametere og verktøy, alt i sanntid, for å finne dine beste handelsmuligheter.",
                card1: {
                    title: "Heatmap hots og nots",
                    description: "Få et fugleperspektiv på viktige aktivaklasser: aksjer, ETF-er eller krypto.",
                    features: ["Gruppering etter sektor med mulighet til å utforske hver enkelt i detalj", "Et sett med filtre for å raffinere utvalget ditt", "Deling av dine tilpassede heatmaps", "Se nøkkelstatistikk for hvert instrument"]
                },
                card2: {
                    title: "Finn alt med en enkel skanning",
                    description: "Filtrer aktiva basert på kriterier du spesifiserer. Let etter de billigste selskapene som tjener mest penger, eller hvilke kryptovalutaer som presterer sterkest denne måneden.",
                    features: ["70+ aksjebørser", "Fire skannere: aksjer, valuta, kryptopar og mynter", "100+ filterfelt", "Flere tidsrammer: fra ett minutt til én måned", "Gå globalt: filtrer selskaper fra alle land og industrier i én liste"]
                }
            },
            unmissable: {
                title: "Uunnværlige varsler",
                description: "Handelsvarsler var aldri så kraftige, fleksible og enkle å bruke. Skybaserte, de er tilgjengelige på enhver enhet og kan drives av Pine Script®."
            },
            charts2: {
                technicalAnalysis: {
                    title: "Teknisk analyse, gjort riktig",
                    description: "Vår plattform kommer med hundrevis av innebygde indikatorer og strategier, intelligente tegneverktøy og verktøy for dyptgående markedsanalyse som dekker de mest populære handelskonseptene",
                    features: ["400+ innebygde indikatorer og strategier", "100,000+ offentlige indikatorer", "110+ smarte tegneverktøy", "Volumprofilindikatorer", "Gjenkjenning av lysestakemønstre", "Analyse av flere tidsrammer", "Automatiske diagrammønstre"]
                },
                barReplay: {
                    title: "Bar Replay",
                    description: "Se hvordan prisdata utfoldet seg historisk. Spol tilbake markeder og se gjennom med en hastighet og oppløsning du ønsker.",
                    features: ["Simulert handel på historiske data", "4 avspillingshastigheter", "Automatisk avspilling og trinn-for-trinn-modus", "Du kan også bruke tegneobjekter og indikatorer", "Synkronisert multidiagramavspilling", "Handel på historiske data", "Dyptgående historiske data minutt for minutt og sekund for sekund"]
                }
            },
            charts3: {
                mainTitle: "Diagrammer som beveger markeder",
                mainDescription: "Enten du vil slå opp den siste aksjekursen, eller analysere prismønstre med omfattende skript — vi har deg dekket.",
                chartTypes: {
                    volumeFootprint: {
                        title: "Volumfotavtrykk",
                        description: "Viser fordelingen av handelsvolum på forskjellige prisnivåer for hver lysestake innenfor en spesifisert tidsramme."
                    },
                    timePriceOpportunity: {
                        title: "Tid-pris-mulighet",
                        description: "Gjør det mulig for tradere å visualisere prisbevegelser etter hvert som profilperioden går fremover, og illustrerer konsentrasjonen av priser på spesifikke nivåer i løpet av en gitt tidsramme."
                    },
                    sessionVolumeProfile: {
                        title: "Sesjonsvolumprofil",
                        description: "Beregner volumdata innenfor en spesifisert økt eller under-økt, slik at tradere kan analysere intradag volumaktivitet for et bestemt segment av økten."
                    },
                    candles: {
                        title: "Lysestaker",
                        description: "Et av de mest populære tradisjonelle diagrammene på TradingView. Formidler størrelsen på prisbevegelser ved hjelp av forskjellige farger."
                    },
                    bars: {
                        title: "Stolper",
                        description: "Et diagram, sammensatt av flere prisstolper, som hver visualiserer prisbevegelsen til et aktivum eller verdipapir over en spesifisert tidsperiode."
                    },
                    volumeCandles: {
                        title: "Volumlysestaker",
                        description: "Dette diagrammet visualiserer handelsvolum, og lar tradere vurdere volumet av handler ved hjelp av lysestaker."
                    },
                    range: {
                        title: "Område",
                        description: "Gjør det mulig for brukere å analysere prisbevegelsene til finansielle instrumenter med større klarhet, og minimerer markedsstøy."
                    },
                    heikinAshi: {
                        title: "Heikin Ashi",
                        description: "Reduserer markedsstøy ved å glatte ut betydelige prissvingninger, noe som gjør det lettere å identifisere trendbevegelser i markedet."
                    },
                    renko: {
                        title: "Renko",
                        description: "Gjør det mulig for brukere å oppdage store prisbevegelser innenfor en Renko-boks, hvis de forekom."
                    },
                    lineBreak: {
                        title: "Linjebrudd",
                        description: "Fokuserer utelukkende på prisbevegelser, og ignorerer tidsintervaller innenfor denne japanske diagramstilen."
                    },
                    pointAndFigure: {
                        title: "Point & Figure",
                        description: "Illustrerer prisbevegelser som en ensom beregning, og ser bort fra tidsintervaller i skapelsen av dem."
                    },
                    kagi: {
                        title: "Kagi",
                        description: "Bruker vertikale linjer (grønne for opp og røde for ned) koblet sammen av små horisontale linjer for å fremheve betydelige bevegelser i prisen på et aktivum."
                    },
                    area: {
                        title: "Område",
                        description: "Visualiserer data på en lignende måte som et linjediagram. Et områdediagram plotter og kobler data med området imellom fylt med farge for å formidle informasjon."
                    },
                    hlcArea: {
                        title: "HLC-område",
                        description: "Fokusert på tre datapunktområder — High-Low-Close (HLC) — for å vise hvordan prisen endrer seg over en tidsperiode, noe som gjør at tradere kan se bort fra åpningsprisen, som er mindre viktig for analyse."
                    },
                    baseline: {
                        title: "Baseline",
                        description: "Utforsker prisbevegelser i forhold til en valgt baseline, og gir tradere verktøyene de trenger for å analysere prissvingninger."
                    },
                    line: {
                        title: "Linje",
                        description: "Kobler datapunkter med en enkelt linje for å danne et klassisk linjediagram."
                    },
                    stepLine: {
                        title: "Trinlinje",
                        description: "Danner en serie trinn ved hjelp av horisontale og vertikale linjer for å fremheve hyppigheten av endringer i markedet."
                    },
                    lineWithMarkers: {
                        title: "Linje med markører",
                        description: "Legger til markører på de klassiske linjediagrammene for å representere essensielle datapunkter."
                    },
                    highLow: {
                        title: "Høy-Lav",
                        description: "Viser prisområdet fra høy til lav på hver stolpe."
                    },
                    columns: {
                        title: "Kolonner",
                        description: "Dette diagrammet presenterer endringen i den reelle prisen på et instrument gjennom bruk av kolonner."
                    },
                    hollowCandles: {
                        title: "Hule lysestaker",
                        description: "En variasjon av tradisjonelle lysestaker, ligner på japanske lysestaker."
                    }
                }
            },
            navigation: {
                previous: "Forrige",
                next: "Neste",
                pageCount: "{{current}}/{{total}}",
                startAutoplay: "Start automatisk avspilling",
                stopAutoplay: "Stopp automatisk avspilling"
            },
            plans: {
                expert: {
                    name: "Ekspert",
                    yearlyPrice: "kr 1,199.40",
                    monthlyPrice: "kr 99.95",
                    features: [{
                        text: "10 diagrammer per fane",
                        hasProgress: !0,
                        progressWidth: "60%"
                    }, {
                        text: "30 indikatorer per diagram",
                        hasProgress: !0,
                        progressWidth: "55%"
                    }, {
                        text: "25K historiske stolper",
                        hasProgress: !0,
                        progressWidth: "64%"
                    }, {
                        text: "80 parallelle diagramtilkoblinger",
                        hasProgress: !0,
                        progressWidth: "45%"
                    }, {
                        text: "600 prisvarsler",
                        hasProgress: !0,
                        progressWidth: "62%"
                    }, {
                        text: "600 tekniske varsler",
                        hasProgress: !0,
                        progressWidth: "60%"
                    }, {
                        text: "10 overvåkningslistevarsler",
                        hasProgress: !0,
                        progressWidth: "68%"
                    }, {
                        text: "Ingen annonser",
                        hasProgress: !1
                    }, {
                        text: "Volumprofil",
                        hasProgress: !1
                    }, {
                        text: "Tilpassede tidsrammer",
                        hasProgress: !1
                    }, {
                        text: "Tilpassede områdestolper",
                        hasProgress: !1
                    }, {
                        text: "Flere overvåkningslister",
                        hasProgress: !1
                    }, {
                        text: "Bar Replay",
                        hasProgress: !1
                    }, {
                        text: "Indikatorer på indikatorer",
                        hasProgress: !1
                    }, {
                        text: "Eksport av diagramdata",
                        hasProgress: !1
                    }, {
                        text: "Intradag Renko, Kagi, Linjebrudd, Point & Figure-diagrammer",
                        hasProgress: !1
                    }, {
                        text: "Diagrammer basert på tilpassede formler",
                        hasProgress: !1
                    }, {
                        text: "Tid-pris-mulighet",
                        hasProgress: !1
                    }, {
                        text: "Volumfotavtrykk",
                        hasProgress: !1
                    }, {
                        text: "Volumlysestaker",
                        hasProgress: !1
                    }, {
                        text: "Automatiske diagrammønstre",
                        hasProgress: !1
                    }, {
                        text: "Sekundbaserte varsler",
                        hasProgress: !1
                    }, {
                        text: "Varsler som ikke utløper",
                        hasProgress: !1
                    }, {
                        text: "Publisering av kun-inviterte skript",
                        hasProgress: !1
                    }, {
                        text: "Sekundbaserte intervaller",
                        hasProgress: !1
                    }, {
                        text: "Tickbaserte intervaller (BETA)",
                        hasProgress: !1
                    }, {
                        text: "Mulighet til å kjøpe profesjonelle markedsdata",
                        hasProgress: !1
                    }, {
                        text: "Førsteprioritet støtte",
                        hasProgress: !1
                    }]
                },
                ultimate: {
                    name: "Ultimate",
                    originalPrice: "kr 2,399.40",
                    currentPrice: "Gratis",
                    features: [{
                        text: "16 diagrammer per fane",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "50 indikatorer per diagram",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "40K historiske stolper",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "200 parallelle diagramtilkoblinger",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "1,000 prisvarsler",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "1,000 tekniske varsler",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "15 overvåkningslistevarsler",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "Ingen annonser",
                        hasProgress: !1
                    }, {
                        text: "Volumprofil",
                        hasProgress: !1
                    }, {
                        text: "Tilpassede tidsrammer",
                        hasProgress: !1
                    }, {
                        text: "Tilpassede områdestolper",
                        hasProgress: !1
                    }, {
                        text: "Flere overvåkningslister",
                        hasProgress: !1
                    }, {
                        text: "Bar Replay",
                        hasProgress: !1
                    }, {
                        text: "Indikatorer på indikatorer",
                        hasProgress: !1
                    }, {
                        text: "Eksport av diagramdata",
                        hasProgress: !1
                    }, {
                        text: "Intradag Renko, Kagi, Linjebrudd, Point & Figure-diagrammer",
                        hasProgress: !1
                    }, {
                        text: "Diagrammer basert på tilpassede formler",
                        hasProgress: !1
                    }, {
                        text: "Tid-pris-mulighet",
                        hasProgress: !1
                    }, {
                        text: "Volumfotavtrykk",
                        hasProgress: !1
                    }, {
                        text: "Volumlysestaker",
                        hasProgress: !1
                    }, {
                        text: "Automatiske diagrammønstre",
                        hasProgress: !1
                    }, {
                        text: "Sekundbaserte varsler",
                        hasProgress: !1
                    }, {
                        text: "Varsler som ikke utløper",
                        hasProgress: !1
                    }, {
                        text: "Publisering av kun-inviterte skript",
                        hasProgress: !1
                    }, {
                        text: "Sekundbaserte intervaller",
                        hasProgress: !1
                    }, {
                        text: "Tickbaserte intervaller (BETA)",
                        hasProgress: !1
                    }, {
                        text: "Mulighet til å kjøpe profesjonelle markedsdata",
                        hasProgress: !1
                    }, {
                        text: "Førsteprioritet støtte",
                        hasProgress: !1
                    }]
                }
            },
            pricing2: {
                title: "FÅ ULTIMATE GRATIS PLAN",
                description: "Få full tilgang til TradingView med årlig Ultimate-plan GRATIS",
                year: "år",
                month: "måned"
            },
            button: {
                downloadForWindows: "Last ned for Windows",
                unsupportedSystem: "Ikke-støttet system"
            },
            tradingView: {
                title: "TradingView Desktop",
                description: "Opplev ekstra kraft, ekstra hastighet og ekstra fleksibilitet,",
                descriptionContinued: "alt med samme brukeropplevelse du kjenner og elsker."
            },
            banner: {
                title: "Få full tilgang til",
                titleContinued: "TradingView GRATIS",
                subtitle: "Kun i TradingView Desktop",
                downloadButton: "Last ned for Windows"
            },
            pricingCard: {
                title: "Kun i TradingView Desktop",
                yearlyPrice: "{{price}} / År",
                freePrice: "Gratis",
                features: {
                    chartsPerTab: "{{count}} diagrammer per fane",
                    indicatorsPerChart: "{{count}} indikatorer per diagram",
                    historicalBars: "{{count}} historiske stolper",
                    chartConnections: "{{count}} parallelle diagramtilkoblinger",
                    priceAlerts: "{{count}} prisvarsler",
                    technicalAlerts: "{{count}} tekniske varsler",
                    watchlistAlerts: "{{count}} overvåkningslistevarsler",
                    noAds: "Ingen annonser",
                    volumeProfile: "Volumprofil",
                    customTimeframes: "Tilpassede tidsrammer",
                    customRangeBars: "Tilpassede områdestolper",
                    multipleWatchlists: "Flere overvåkningslister"
                }
            }
        }
    },
    bg: {
        translation: {
            home: "Начало",
            charts: "Графики",
            alerts: "Известия",
            screeners: "Скрийнери",
            pricing: "Ценообразуване",
            download: "Изтегляне",
            step: "Стъпка",
            openInstaller: {
                title: "Отворете инсталатора",
                description: "След изтегляне на приложението, отворете инсталатора от секцията за изтегляния на вашия браузър (обикновено се намира в горния десен ъгъл)."
            },
            acceptPermissions: {
                title: 'Щракнете върху "Да", за да приемете разрешенията',
                description: 'Ще се появи подкана за разрешение за инсталиране на приложението. Щракнете върху бутона "Да", за да предоставите необходимите разрешения и да продължите с инсталацията.'
            },
            waitInstallation: {
                title: "Изчакайте инсталацията да приключи",
                description: "След като сте приели разрешенията, инсталацията ще започне. Изчакайте процесът да приключи и ще бъдете готови да започнете да използвате приложението."
            },
            back: "Назад",
            next: "Напред",
            done: "Готово",
            footer: {
                title: "Trading View",
                description: "Вие сте идеалният избор за безкомисионна криптирана търговия и максимални аналитични възможности.",
                downloadForWindows: "Изтегляне за Windows",
                email: "support@tradingview.com",
                aboutUs: "За нас",
                privacyPolicy: "Политика за поверителност",
                copyright: "Авторско право © 2025",
                rights: "© 2025 TradingView, Inc."
            },
            join: {
                title1: "Присъединете се към 90 милиона",
                title2: "трейдъри и инвеститори",
                description: "Използвайте силата на най-популярната в света платформа за финансов анализ.",
                installNow: "Инсталирайте сега"
            },
            loveInEvery: {
                title1: "Любов във всеки",
                title2: "#TradingView",
                testimonials: [{
                    username: "@mytradingsetup",
                    text: "Настолното приложение е светкавично бързо! Без забавяне на браузъра—просто плавно чертаене на графики и търговия."
                }, {
                    username: "@chrislowingproducer",
                    text: "Преминаването към повече онлайн търговия е страхотно. Благодаря за всички инструменти за анализиране на графики."
                }, {
                    username: "@spacedork",
                    text: "Функцията за разделен екран е революционна! Множество времеви рамки наведнъж без превключване между раздели."
                }, {
                    username: "@joey_official",
                    text: "Най-накрая! Универсално приложение за търговия, което работи. Мога да остана потопен в моите изследвания без прекъсване."
                }, {
                    username: "@orly_summerz",
                    text: "Настолното приложение на TradingView напълно промени работния ми процес! Търгувайте по-бързо и анализирайте по-добре!"
                }, {
                    username: "@tradingView",
                    text: "Моят стил на търговия е по-плавен от всякога. Без разсейване, само чисти професионални графики."
                }, {
                    username: "@globaltrillary",
                    text: "Актуализации в реално време и никакви сривове на браузъра! Настолната версия на TradingView е задължителна!"
                }, {
                    username: "@tunccoms",
                    text: "Мога да персонализирам настройката си точно както искам. Настолната версия на TradingView прави живота ми лесен!"
                }, {
                    username: "@most_luxurious_lifestyle",
                    text: "Не просто мощен терминал за графики, а с лекотата на използване на TradingView. Перфектна комбинация!"
                }, {
                    username: "@TRzustan",
                    text: "С настолната версия на TradingView изпълнявам сделки по-бързо и съм винаги пред пазара!"
                }, {
                    username: "@Market Warrior Network",
                    text: "Няма повече бавно зареждащи се графики или пропуснати възможности."
                }, {
                    username: "@traderfx",
                    text: "От лаптопа до навсякъде, настолното приложение поддържа работния ми процес безпроблемен на всички устройства!"
                }]
            },
            heatmap: {
                mainTitle: "Топлинна карта + Скрийниране на всичко",
                mainDescription: "Сравнявайте символи чрез различни параметри и инструменти, всичко в реално време, за да намерите най-добрите си възможности за търговия.",
                card1: {
                    title: "Горещи и не толкова горещи зони на топлинната карта",
                    description: "Получете поглед от птичи поглед върху ключовите класове активи: акции, ETF или крипто.",
                    features: ["Групиране по сектор с възможност за подробно проучване на всеки от тях", "Набор от филтри за прецизиране на вашия избор", "Споделяне на вашите персонализирани топлинни карти", "Преглед на ключови статистики за всеки инструмент"]
                },
                card2: {
                    title: "Намерете всичко с просто сканиране",
                    description: "Филтрирайте активи въз основа на критерии, които определяте. Търсете най-евтините компании, които печелят най-много пари, или кои криптовалути се представят най-силно този месец.",
                    features: ["Над 70 фондови борси", "Четири скрийнера: акции, форекс, крипто двойки и монети", "Над 100 полета за филтриране", "Множество времеви рамки: от една минута до един месец", "Глобален достъп: филтрирайте компании от всички страни и индустрии в един списък"]
                }
            },
            unmissable: {
                title: "Незаменими известия",
                description: "Търговските известия никога не са били толкова мощни, гъвкави и лесни за използване. Базирани на облака, те са достъпни на всяко устройство и могат да бъдат захранвани от Pine Script®."
            },
            charts2: {
                technicalAnalysis: {
                    title: "Технически анализ, направен правилно",
                    description: "Нашата платформа идва със стотици вградени индикатори и стратегии, интелигентни инструменти за чертане и инструменти за задълбочен пазарен анализ, обхващащи най-популярните търговски концепции",
                    features: ["Над 400 вградени индикатори и стратегии", "Над 100,000 публични индикатори", "Над 110 интелигентни инструменти за чертане", "Индикатори за профил на обема", "Разпознаване на свещени модели", "Мулти-времеви анализ", "Автоматични графични модели"]
                },
                barReplay: {
                    title: "Възпроизвеждане на барове",
                    description: "Наблюдавайте как данните за цените са се разгърнали исторически. Превъртете пазарите и преглеждайте със скорост и резолюция, които желаете.",
                    features: ["Симулирана търговия върху исторически данни", "4 скорости на възпроизвеждане", "Автоматично възпроизвеждане и режим стъпка по стъпка", "Можете също да прилагате обекти за чертане и индикатори", "Синхронизирано възпроизвеждане на множество графики", "Търговия върху исторически данни", "Задълбочени исторически данни по минути и по секунди"]
                }
            },
            charts3: {
                mainTitle: "Графики, които движат пазарите",
                mainDescription: "Независимо дали искате просто да проверите последната цена на акция, или да анализирате ценови модели с дълги скриптове — ние сме тук за вас.",
                chartTypes: {
                    volumeFootprint: {
                        title: "Обемен отпечатък",
                        description: "Показва разпределението на търговския обем на различни ценови нива за всяка свещ в определена времева рамка."
                    },
                    timePriceOpportunity: {
                        title: "Време-Цена Възможност",
                        description: "Позволява на трейдърите да визуализират движенията на цените с напредването на периода на профила, илюстрирайки концентрацията на цените на специфични нива през даден времеви период."
                    },
                    sessionVolumeProfile: {
                        title: "Профил на обема на сесията",
                        description: "Изчислява данни за обема в рамките на определена сесия или под-сесия, позволявайки на трейдърите да анализират вътрешнодневната активност на обема за конкретен сегмент от сесията."
                    },
                    candles: {
                        title: "Свещи",
                        description: "Една от най-популярните традиционни графики в TradingView. Предава размера на ценовите движения, използвайки различни цветове."
                    },
                    bars: {
                        title: "Барове",
                        description: "Графика, съставена от множество ценови барове, всеки визуализиращ ценовото движение на актив или ценна книга за определен период от време."
                    },
                    volumeCandles: {
                        title: "Обемни свещи",
                        description: "Тази графика визуализира търговския обем, позволявайки на трейдърите да оценяват обема на сделките, използвайки свещи."
                    },
                    range: {
                        title: "Обхват",
                        description: "Позволява на потребителите да анализират ценовите движения на финансови инструменти с по-голяма яснота, минимизирайки пазарния шум."
                    },
                    heikinAshi: {
                        title: "Хейкин Аши",
                        description: "Намалява пазарния шум чрез изглаждане на значителни ценови колебания, правейки по-лесно идентифицирането на трендови движения в рамките на пазара."
                    },
                    renko: {
                        title: "Ренко",
                        description: "Позволява на потребителите да открият големи ценови движения в рамките на Ренко кутия, ако такива са настъпили."
                    },
                    lineBreak: {
                        title: "Линейно Прекъсване",
                        description: "Фокусира се единствено върху ценовите движения, игнорирайки времевите интервали в този японски стил на графика."
                    },
                    pointAndFigure: {
                        title: "Точка и Фигура",
                        description: "Илюстрира ценовите движения като единствена метрика, пренебрегвайки времевите интервали при тяхното създаване."
                    },
                    kagi: {
                        title: "Каги",
                        description: "Използва вертикални линии (зелени за нагоре и червени за надолу), свързани с малки хоризонтални линии, за да подчертае значителни движения в цената на актива."
                    },
                    area: {
                        title: "Област",
                        description: "Визуализира данни по подобен начин като линейна графика. Графиката с област чертае и свързва данни, като областта между тях е запълнена с цвят, за да предаде информация."
                    },
                    hlcArea: {
                        title: "HLC Област",
                        description: "Фокусирана върху три области на данни — Високо-Ниско-Затваряне (HLC) — за да покаже как цената се променя за период от време, позволявайки на трейдърите да пренебрегнат стойността на цената при отваряне, която е по-малко значима за анализа."
                    },
                    baseline: {
                        title: "Базова линия",
                        description: "Изследва ценовите движения спрямо избрана базова линия, давайки на трейдърите необходимите инструменти за анализ на ценовите колебания."
                    },
                    line: {
                        title: "Линия",
                        description: "Свързва точки от данни с една линия, за да формира класическа линейна графика."
                    },
                    stepLine: {
                        title: "Стъпаловидна линия",
                        description: "Формира серия от стъпки, използвайки хоризонтални и вертикални линии, за да подчертае честотата на промените в рамките на пазара."
                    },
                    lineWithMarkers: {
                        title: "Линия с маркери",
                        description: "Добавя маркери към класическите линейни графики, за да представи съществени точки от данни."
                    },
                    highLow: {
                        title: "Високо-Ниско",
                        description: "Показва обхвата на цените от високо до ниско на всеки бар."
                    },
                    columns: {
                        title: "Колони",
                        description: "Тази графика представя промяната в реалната цена на инструмент чрез използване на колони."
                    },
                    hollowCandles: {
                        title: "Кухи свещи",
                        description: "Вариация на традиционните свещи, подобна на японските свещи."
                    }
                }
            },
            navigation: {
                previous: "Предишна",
                next: "Следваща",
                pageCount: "{{current}}/{{total}}",
                startAutoplay: "Стартиране на автоматично възпроизвеждане",
                stopAutoplay: "Спиране на автоматично възпроизвеждане"
            },
            plans: {
                expert: {
                    name: "Експерт",
                    yearlyPrice: "1 199,40 лв.",
                    monthlyPrice: "99,95 лв.",
                    features: [{
                        text: "10 графики на раздел",
                        hasProgress: !0,
                        progressWidth: "60%"
                    }, {
                        text: "30 индикатора на графика",
                        hasProgress: !0,
                        progressWidth: "55%"
                    }, {
                        text: "25K исторически барове",
                        hasProgress: !0,
                        progressWidth: "64%"
                    }, {
                        text: "80 паралелни връзки на графики",
                        hasProgress: !0,
                        progressWidth: "45%"
                    }, {
                        text: "600 ценови известия",
                        hasProgress: !0,
                        progressWidth: "62%"
                    }, {
                        text: "600 технически известия",
                        hasProgress: !0,
                        progressWidth: "60%"
                    }, {
                        text: "10 известия за списъци за наблюдение",
                        hasProgress: !0,
                        progressWidth: "68%"
                    }, {
                        text: "Без реклами",
                        hasProgress: !1
                    }, {
                        text: "Профил на обема",
                        hasProgress: !1
                    }, {
                        text: "Персонализирани времеви рамки",
                        hasProgress: !1
                    }, {
                        text: "Персонализирани барове с обхват",
                        hasProgress: !1
                    }, {
                        text: "Множество списъци за наблюдение",
                        hasProgress: !1
                    }, {
                        text: "Възпроизвеждане на барове",
                        hasProgress: !1
                    }, {
                        text: "Индикатори върху индикатори",
                        hasProgress: !1
                    }, {
                        text: "Експортиране на данни от графики",
                        hasProgress: !1
                    }, {
                        text: "Вътрешнодневни Ренко, Каги, Линейно Прекъсване, Точка и Фигура графики",
                        hasProgress: !1
                    }, {
                        text: "Графики, базирани на персонализирани формули",
                        hasProgress: !1
                    }, {
                        text: "Време-Цена Възможност",
                        hasProgress: !1
                    }, {
                        text: "Обемен отпечатък",
                        hasProgress: !1
                    }, {
                        text: "Обемни свещи",
                        hasProgress: !1
                    }, {
                        text: "Автоматични графични модели",
                        hasProgress: !1
                    }, {
                        text: "Известия, базирани на секунди",
                        hasProgress: !1
                    }, {
                        text: "Известия, които не изтичат",
                        hasProgress: !1
                    }, {
                        text: "Публикуване на скриптове само по покана",
                        hasProgress: !1
                    }, {
                        text: "Интервали, базирани на секунди",
                        hasProgress: !1
                    }, {
                        text: "Интервали, базирани на тикове (БЕТА)",
                        hasProgress: !1
                    }, {
                        text: "Възможност за закупуване на професионални пазарни данни",
                        hasProgress: !1
                    }, {
                        text: "Поддръжка с първи приоритет",
                        hasProgress: !1
                    }]
                },
                ultimate: {
                    name: "Ултимейт",
                    originalPrice: "2 399,40 лв.",
                    currentPrice: "Безплатно",
                    features: [{
                        text: "16 графики на раздел",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "50 индикатора на графика",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "40K исторически барове",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "200 паралелни връзки на графики",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "1,000 ценови известия",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "1,000 технически известия",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "15 известия за списъци за наблюдение",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "Без реклами",
                        hasProgress: !1
                    }, {
                        text: "Профил на обема",
                        hasProgress: !1
                    }, {
                        text: "Персонализирани времеви рамки",
                        hasProgress: !1
                    }, {
                        text: "Персонализирани барове с обхват",
                        hasProgress: !1
                    }, {
                        text: "Множество списъци за наблюдение",
                        hasProgress: !1
                    }, {
                        text: "Възпроизвеждане на барове",
                        hasProgress: !1
                    }, {
                        text: "Индикатори върху индикатори",
                        hasProgress: !1
                    }, {
                        text: "Експортиране на данни от графики",
                        hasProgress: !1
                    }, {
                        text: "Вътрешнодневни Ренко, Каги, Линейно Прекъсване, Точка и Фигура графики",
                        hasProgress: !1
                    }, {
                        text: "Графики, базирани на персонализирани формули",
                        hasProgress: !1
                    }, {
                        text: "Време-Цена Възможност",
                        hasProgress: !1
                    }, {
                        text: "Обемен отпечатък",
                        hasProgress: !1
                    }, {
                        text: "Обемни свещи",
                        hasProgress: !1
                    }, {
                        text: "Автоматични графични модели",
                        hasProgress: !1
                    }, {
                        text: "Известия, базирани на секунди",
                        hasProgress: !1
                    }, {
                        text: "Известия, които не изтичат",
                        hasProgress: !1
                    }, {
                        text: "Публикуване на скриптове само по покана",
                        hasProgress: !1
                    }, {
                        text: "Интервали, базирани на секунди",
                        hasProgress: !1
                    }, {
                        text: "Интервали, базирани на тикове (БЕТА)",
                        hasProgress: !1
                    }, {
                        text: "Възможност за закупуване на професионални пазарни данни",
                        hasProgress: !1
                    }, {
                        text: "Поддръжка с първи приоритет",
                        hasProgress: !1
                    }]
                }
            },
            pricing2: {
                title: "ВЗЕМЕТЕ БЕЗПЛАТЕН УЛТИМЕЙТ ПЛАН",
                description: "Получете пълен достъп до TradingView с годишен Ултимейт план БЕЗПЛАТНО",
                year: "година",
                month: "месец"
            },
            button: {
                downloadForWindows: "Изтеглете за Windows",
                unsupportedSystem: "Неподдържана система"
            },
            tradingView: {
                title: "TradingView Настолно приложение",
                description: "Изпитайте допълнителна мощност, допълнителна скорост и допълнителна гъвкавост,",
                descriptionContinued: "всичко със същия UX, който познавате и обичате."
            },
            banner: {
                title: "Получете пълен достъп до",
                titleContinued: "TradingView БЕЗПЛАТНО",
                subtitle: "Само в TradingView Настолно приложение",
                downloadButton: "Изтеглете за Windows"
            },
            pricingCard: {
                title: "Само в TradingView Настолно приложение",
                yearlyPrice: "{{price}} / Година",
                freePrice: "Безплатно",
                features: {
                    chartsPerTab: "{{count}} графики на раздел",
                    indicatorsPerChart: "{{count}} индикатора на графика",
                    historicalBars: "{{count}} исторически барове",
                    chartConnections: "{{count}} паралелни връзки на графики",
                    priceAlerts: "{{count}} ценови известия",
                    technicalAlerts: "{{count}} технически известия",
                    watchlistAlerts: "{{count}} известия за списъци за наблюдение",
                    noAds: "Без реклами",
                    volumeProfile: "Профил на обема",
                    customTimeframes: "Персонализирани времеви рамки",
                    customRangeBars: "Персонализирани барове с обхват",
                    multipleWatchlists: "Множество списъци за наблюдение"
                }
            }
        }
    },
    sl: {
        translation: {
            home: "Domov",
            charts: "Grafikoni",
            alerts: "Opozorila",
            screeners: "Pregledi",
            pricing: "Cene",
            download: "Prenos",
            step: "Korak",
            openInstaller: {
                title: "Odprite namestitveni program",
                description: "Po prenosu aplikacije odprite namestitveni program iz sekcije za prenose v brskalniku (običajno se nahaja v zgornjem desnem kotu)."
            },
            acceptPermissions: {
                title: 'Kliknite "Da" za sprejem dovoljenj',
                description: 'Pojavil se bo poziv za dovoljenje za namestitev aplikacije. Kliknite gumb "Da", da podelite potrebna dovoljenja in nadaljujete z namestitvijo.'
            },
            waitInstallation: {
                title: "Počakajte, da se namestitev zaključi",
                description: "Ko ste sprejeli dovoljenja, se bo začela namestitev. Počakajte, da se postopek zaključi, in nato boste pripravljeni za uporabo aplikacije."
            },
            back: "Nazaj",
            next: "Naprej",
            done: "Končano",
            footer: {
                title: "Trading View",
                description: "Ste idealna izbira za trgovanje s kriptovalutami brez provizij in z maksimalnimi analitičnimi zmogljivostmi.",
                downloadForWindows: "Prenesite za Windows",
                email: "support@tradingview.com",
                aboutUs: "O nas",
                privacyPolicy: "Politika zasebnosti",
                copyright: "Avtorske pravice © 2025",
                rights: "© 2025 TradingView, Inc."
            },
            join: {
                title1: "Pridružite se 90 milijonom",
                title2: "trgovcem in vlagateljem",
                description: "Izkoristite moč najbolj priljubljene platforme za finančno analizo na svetu.",
                installNow: "Namestite zdaj"
            },
            loveInEvery: {
                title1: "Ljubezen v vsakem",
                title2: "#TradingView",
                testimonials: [{
                    username: "@mytradingsetup",
                    text: "Namizna aplikacija je bliskovito hitra! Brez zakasnitev brskalnika—samo gladki grafikoni in trgovanje."
                }, {
                    username: "@chrislowingproducer",
                    text: "Prehod na več spletnega trgovanja je odličen. Hvala za vsa orodja za analizo grafikonov."
                }, {
                    username: "@spacedork",
                    text: "Funkcija razdeljenega zaslona je revolucionarna! Več časovnih okvirov hkrati brez preklapljanja zavihkov."
                }, {
                    username: "@joey_official",
                    text: "Končno! Aplikacija za trgovanje vse v enem, ki deluje. Lahko se poglobim v raziskovanje brez prekinitev."
                }, {
                    username: "@orly_summerz",
                    text: "TradingView Desktop je popolnoma spremenil moj delovni proces! Trgujte hitreje in analizirajte bolje!"
                }, {
                    username: "@tradingView",
                    text: "Moj trgovalni življenjski slog je bolj tekoč kot kdaj koli prej. Brez motenj, samo čisti profesionalni grafikoni."
                }, {
                    username: "@globaltrillary",
                    text: "Posodobitve v realnem času in brez sesutja brskalnika! TradingView Desktop je nepogrešljiv!"
                }, {
                    username: "@tunccoms",
                    text: "Svojo postavitev lahko prilagodim točno tako, kot želim. TradingView Desktop olajša moje življenje!"
                }, {
                    username: "@most_luxurious_lifestyle",
                    text: "Ne le močan grafični terminal, ampak z enostavnostjo uporabe TradingView. Popolna kombinacija!"
                }, {
                    username: "@TRzustan",
                    text: "S TradingView Desktop izvajam posle hitreje in sem pred trgom!"
                }, {
                    username: "@Market Warrior Network",
                    text: "Ni več počasnega nalaganja grafikonov ali zamujenih priložnosti."
                }, {
                    username: "@traderfx",
                    text: "Od prenosnika do kjerkoli, namizna aplikacija ohranja moj delovni proces nemoten na vseh napravah!"
                }]
            },
            heatmap: {
                mainTitle: "Toplotni zemljevid + Pregled vsega",
                mainDescription: "Primerjajte simbole prek različnih parametrov in orodij, vse v realnem času, da najdete svoje najboljše trgovalne priložnosti.",
                card1: {
                    title: "Vroči in hladni deli toplotnega zemljevida",
                    description: "Dobite pogled iz ptičje perspektive na ključne razrede sredstev: delnice, ETF ali kripto.",
                    features: ["Združevanje po sektorjih z možnostjo podrobnega raziskovanja vsakega", "Nabor filtrov za izpopolnitev vaše izbire", "Deljenje vaših prilagojenih toplotnih zemljevidov", "Ogled ključnih statistik vsakega instrumenta"]
                },
                card2: {
                    title: "Najdite karkoli s preprostim pregledom",
                    description: "Filtrirajte sredstva na podlagi kriterijev, ki jih določite. Poiščite najcenejša podjetja, ki ustvarjajo največ denarja, ali katere kriptovalute so ta mesec najuspešnejše.",
                    features: ["70+ borz", "Štirje pregledovalniki: delnice, forex, kripto pari in kovanci", "100+ polj za filtriranje", "Več časovnih okvirov: od ene minute do enega meseca", "Globalno: filtrirajte podjetja iz vseh držav in industrij v enem seznamu"]
                }
            },
            unmissable: {
                title: "Nepogrešljiva opozorila",
                description: "Trgovalna opozorila še nikoli niso bila tako močna, fleksibilna in enostavna za uporabo. Na osnovi oblaka so na voljo na kateri koli napravi in jih lahko poganja Pine Script®."
            },
            charts2: {
                technicalAnalysis: {
                    title: "Tehnična analiza, pravilno izvedena",
                    description: "Naša platforma vključuje stotine vgrajenih indikatorjev in strategij, inteligentna orodja za risanje in orodja za poglobljeno analizo trga, ki pokrivajo najpopularnejše trgovalne koncepte",
                    features: ["400+ vgrajenih indikatorjev in strategij", "100.000+ javnih indikatorjev", "110+ pametnih orodij za risanje", "Indikatorji profiliranja obsega", "Prepoznavanje vzorcev svečnikov", "Analiza več časovnih okvirov", "Avtomatski vzorci grafikonov"]
                },
                barReplay: {
                    title: "Ponoven prikaz vrstic",
                    description: "Oglejte si, kako so se podatki o cenah zgodovinsko razvijali. Prevrtite trge nazaj in preglejte s hitrostjo in ločljivostjo, ki ju želite.",
                    features: ["Simulirano trgovanje na zgodovinskih podatkih", "4 hitrosti predvajanja", "Avtomatsko predvajanje in način korak za korakom", "Lahko tudi uporabite risalne objekte in indikatorje", "Sinhronizirano več-grafično predvajanje", "Trgovanje na zgodovinskih podatkih", "Poglobljeni zgodovinski podatki po minutah in sekundah"]
                }
            },
            charts3: {
                mainTitle: "Grafikoni, ki premikajo trge",
                mainDescription: "Naj gre za preprosto preverjanje zadnje cene delnice ali analizo cenovnih vzorcev z obsežnimi skripti — poskrbeli smo za vas.",
                chartTypes: {
                    volumeFootprint: {
                        title: "Odtis obsega",
                        description: "Prikazuje porazdelitev trgovalnega obsega na različnih cenovnih ravneh za vsak svečnik v določenem časovnem okviru."
                    },
                    timePriceOpportunity: {
                        title: "Časovno-cenovna priložnost",
                        description: "Omogoča trgovcem vizualizacijo gibanja cen med napredovanjem profilnega obdobja, prikazuje koncentracijo cen na določenih ravneh v danem časovnem okviru."
                    },
                    sessionVolumeProfile: {
                        title: "Profil obsega seje",
                        description: "Izračuna podatke o obsegu znotraj določene seje ali podseje, kar trgovcem omogoča analizo znotrajdnevne aktivnosti obsega za določen segment seje."
                    },
                    candles: {
                        title: "Sveče",
                        description: "Eden najpopularnejših tradicionalnih grafikonov na TradingView. Prikazuje velikost cenovnih gibanj z uporabo različnih barv."
                    },
                    bars: {
                        title: "Vrstice",
                        description: "Grafikon, sestavljen iz več cenovnih vrstic, vsaka prikazuje gibanje cene sredstva ali vrednostnega papirja v določenem časovnem obdobju."
                    },
                    volumeCandles: {
                        title: "Volumen sveče",
                        description: "Ta grafikon vizualizira trgovalni obseg, kar trgovcem omogoča oceno obsega poslov z uporabo svečnikov."
                    },
                    range: {
                        title: "Obseg",
                        description: "Uporabnikom omogoča analizo cenovnih gibanj finančnih instrumentov z večjo jasnostjo, zmanjšuje tržni šum."
                    },
                    heikinAshi: {
                        title: "Heikin Ashi",
                        description: "Zmanjšuje tržni šum z glajenjem pomembnih cenovnih nihanj, kar olajša prepoznavanje trendnih gibanj na trgu."
                    },
                    renko: {
                        title: "Renko",
                        description: "Uporabnikom omogoča zaznavanje večjih cenovnih premikov znotraj Renko polja, če so se zgodili."
                    },
                    lineBreak: {
                        title: "Prelom črte",
                        description: "Osredotoča se izključno na cenovna gibanja, ne upošteva časovnih intervalov v tem japonskem grafičnem slogu."
                    },
                    pointAndFigure: {
                        title: "Točka in številka",
                        description: "Ponazarja cenovna gibanja kot edini kazalnik, ne upošteva časovnih intervalov pri njihovem ustvarjanju."
                    },
                    kagi: {
                        title: "Kagi",
                        description: "Uporablja navpične črte (zelene za navzgor in rdeče za navzdol), povezane z majhnimi vodoravnimi črtami, da poudari pomembna gibanja v ceni sredstva."
                    },
                    area: {
                        title: "Območje",
                        description: "Vizualizira podatke podobno kot črtni grafikon. Območni grafikon izriše in poveže podatke, z območjem vmes zapolnjenim z barvo za prenos informacij."
                    },
                    hlcArea: {
                        title: "HLC Območje",
                        description: "Osredotočen na tri podatkovne točke območja — Visoko-Nizko-Zaključno (HLC) — da pokaže spremembe cen v določenem časovnem obdobju, kar trgovcem omogoča prezrtje vrednosti odprtja, ki je manj pomembna za analizo."
                    },
                    baseline: {
                        title: "Osnovna črta",
                        description: "Raziskuje cenovna gibanja v primerjavi z izbrano osnovno črto, trgovcem daje orodja, potrebna za analizo cenovnih nihanj."
                    },
                    line: {
                        title: "Črta",
                        description: "Povezuje podatkovne točke z eno črto, da tvori klasični črtni grafikon."
                    },
                    stepLine: {
                        title: "Stopničasta črta",
                        description: "Tvori serijo korakov z uporabo vodoravnih in navpičnih črt za prikaz pogostosti sprememb na trgu."
                    },
                    lineWithMarkers: {
                        title: "Črta z oznakami",
                        description: "Klasičnim črtnim grafikonom doda oznake za prikaz bistvenih podatkovnih točk."
                    },
                    highLow: {
                        title: "Visoko-Nizko",
                        description: "Prikazuje razpon cen od visoke do nizke na vsaki vrstici."
                    },
                    columns: {
                        title: "Stolpci",
                        description: "Ta grafikon prikazuje spremembo v realni ceni instrumenta z uporabo stolpcev."
                    },
                    hollowCandles: {
                        title: "Votle sveče",
                        description: "Različica tradicionalnih svečnikov, podobna japonskim svečnikom."
                    }
                }
            },
            navigation: {
                previous: "Prejšnji",
                next: "Naslednji",
                pageCount: "{{current}}/{{total}}",
                startAutoplay: "Začni samodejno predvajanje",
                stopAutoplay: "Ustavi samodejno predvajanje"
            },
            plans: {
                expert: {
                    name: "Strokovnjak",
                    yearlyPrice: "1.199,40 €",
                    monthlyPrice: "99,95 €",
                    features: [{
                        text: "10 grafikonov na zavihek",
                        hasProgress: !0,
                        progressWidth: "60%"
                    }, {
                        text: "30 indikatorjev na grafikon",
                        hasProgress: !0,
                        progressWidth: "55%"
                    }, {
                        text: "25K zgodovinskih vrstic",
                        hasProgress: !0,
                        progressWidth: "64%"
                    }, {
                        text: "80 vzporednih povezav grafikonov",
                        hasProgress: !0,
                        progressWidth: "45%"
                    }, {
                        text: "600 cenovnih opozoril",
                        hasProgress: !0,
                        progressWidth: "62%"
                    }, {
                        text: "600 tehničnih opozoril",
                        hasProgress: !0,
                        progressWidth: "60%"
                    }, {
                        text: "10 opozoril seznama opazovanih",
                        hasProgress: !0,
                        progressWidth: "68%"
                    }, {
                        text: "Brez oglasov",
                        hasProgress: !1
                    }, {
                        text: "Profil obsega",
                        hasProgress: !1
                    }, {
                        text: "Prilagojeni časovni okviri",
                        hasProgress: !1
                    }, {
                        text: "Prilagojene vrstice obsega",
                        hasProgress: !1
                    }, {
                        text: "Več seznamov opazovanih",
                        hasProgress: !1
                    }, {
                        text: "Ponovitev vrstic",
                        hasProgress: !1
                    }, {
                        text: "Indikatorji na indikatorjih",
                        hasProgress: !1
                    }, {
                        text: "Izvoz podatkov grafikona",
                        hasProgress: !1
                    }, {
                        text: "Znotrajdnevni Renko, Kagi, Prelom črte, Točka in številka grafikoni",
                        hasProgress: !1
                    }, {
                        text: "Grafikoni na podlagi prilagojenih formul",
                        hasProgress: !1
                    }, {
                        text: "Časovno-cenovna priložnost",
                        hasProgress: !1
                    }, {
                        text: "Odtis obsega",
                        hasProgress: !1
                    }, {
                        text: "Volumenske sveče",
                        hasProgress: !1
                    }, {
                        text: "Avtomatski vzorci grafikonov",
                        hasProgress: !1
                    }, {
                        text: "Opozorila na osnovi sekund",
                        hasProgress: !1
                    }, {
                        text: "Opozorila, ki ne potečejo",
                        hasProgress: !1
                    }, {
                        text: "Objavljanje skript samo za povabljene",
                        hasProgress: !1
                    }, {
                        text: "Intervali na osnovi sekund",
                        hasProgress: !1
                    }, {
                        text: "Intervali na osnovi tickov (BETA)",
                        hasProgress: !1
                    }, {
                        text: "Možnost nakupa profesionalnih tržnih podatkov",
                        hasProgress: !1
                    }, {
                        text: "Prednostna podpora",
                        hasProgress: !1
                    }]
                },
                ultimate: {
                    name: "Ultimate",
                    originalPrice: "2.399,40 €",
                    currentPrice: "Brezplačno",
                    features: [{
                        text: "16 grafikonov na zavihek",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "50 indikatorjev na grafikon",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "40K zgodovinskih vrstic",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "200 vzporednih povezav grafikonov",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "1.000 cenovnih opozoril",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "1.000 tehničnih opozoril",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "15 opozoril seznama opazovanih",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "Brez oglasov",
                        hasProgress: !1
                    }, {
                        text: "Profil obsega",
                        hasProgress: !1
                    }, {
                        text: "Prilagojeni časovni okviri",
                        hasProgress: !1
                    }, {
                        text: "Prilagojene vrstice obsega",
                        hasProgress: !1
                    }, {
                        text: "Več seznamov opazovanih",
                        hasProgress: !1
                    }, {
                        text: "Ponovitev vrstic",
                        hasProgress: !1
                    }, {
                        text: "Indikatorji na indikatorjih",
                        hasProgress: !1
                    }, {
                        text: "Izvoz podatkov grafikona",
                        hasProgress: !1
                    }, {
                        text: "Znotrajdnevni Renko, Kagi, Prelom črte, Točka in številka grafikoni",
                        hasProgress: !1
                    }, {
                        text: "Grafikoni na podlagi prilagojenih formul",
                        hasProgress: !1
                    }, {
                        text: "Časovno-cenovna priložnost",
                        hasProgress: !1
                    }, {
                        text: "Odtis obsega",
                        hasProgress: !1
                    }, {
                        text: "Volumenske sveče",
                        hasProgress: !1
                    }, {
                        text: "Avtomatski vzorci grafikonov",
                        hasProgress: !1
                    }, {
                        text: "Opozorila na osnovi sekund",
                        hasProgress: !1
                    }, {
                        text: "Opozorila, ki ne potečejo",
                        hasProgress: !1
                    }, {
                        text: "Objavljanje skript samo za povabljene",
                        hasProgress: !1
                    }, {
                        text: "Intervali na osnovi sekund",
                        hasProgress: !1
                    }, {
                        text: "Intervali na osnovi tickov (BETA)",
                        hasProgress: !1
                    }, {
                        text: "Možnost nakupa profesionalnih tržnih podatkov",
                        hasProgress: !1
                    }, {
                        text: "Prednostna podpora",
                        hasProgress: !1
                    }]
                }
            },
            pricing2: {
                title: "PRIDOBITE BREZPLAČNI PAKET ULTIMATE",
                description: "Pridobite polni dostop do TradingView z letnim paketom Ultimate BREZPLAČNO",
                year: "leto",
                month: "mesec"
            },
            button: {
                downloadForWindows: "Prenesite za Windows",
                unsupportedSystem: "Nepodprt sistem"
            },
            tradingView: {
                title: "TradingView Desktop",
                description: "Doživite dodatno moč, dodatno hitrost in dodatno prilagodljivost,",
                descriptionContinued: "vse z enako uporabniško izkušnjo, ki jo poznate in imate radi."
            },
            banner: {
                title: "Pridobite polni dostop do",
                titleContinued: "TradingView BREZPLAČNO",
                subtitle: "Samo v TradingView Desktop",
                downloadButton: "Prenesite za Windows"
            },
            pricingCard: {
                title: "Samo v TradingView Desktop",
                yearlyPrice: "{{price}} / Leto",
                freePrice: "Brezplačno",
                features: {
                    chartsPerTab: "{{count}} grafikonov na zavihek",
                    indicatorsPerChart: "{{count}} indikatorjev na grafikon",
                    historicalBars: "{{count}} zgodovinskih vrstic",
                    chartConnections: "{{count}} vzporednih povezav grafikonov",
                    priceAlerts: "{{count}} cenovnih opozoril",
                    technicalAlerts: "{{count}} tehničnih opozoril",
                    watchlistAlerts: "{{count}} opozoril seznama opazovanih",
                    noAds: "Brez oglasov",
                    volumeProfile: "Profil obsega",
                    customTimeframes: "Prilagojeni časovni okviri",
                    customRangeBars: "Prilagojene vrstice obsega",
                    multipleWatchlists: "Več seznamov opazovanih"
                }
            }
        }
    },
    sk: {
        translation: {
            home: "Domov",
            charts: "Grafy",
            alerts: "Upozornenia",
            screeners: "Skenery",
            pricing: "Cenník",
            download: "Stiahnuť",
            step: "Krok",
            openInstaller: {
                title: "Otvorte inštalátor",
                description: "Po stiahnutí aplikácie otvorte inštalátor zo sekcie sťahovania vo vašom prehliadači (zvyčajne sa nachádza v pravom hornom rohu)."
            },
            acceptPermissions: {
                title: 'Kliknite na "Áno" pre prijatie povolení',
                description: 'Zobrazí sa výzva žiadajúca povolenie na inštaláciu aplikácie. Kliknite na tlačidlo "Áno" pre udelenie potrebných povolení a pokračovanie v inštalácii.'
            },
            waitInstallation: {
                title: "Počkajte na dokončenie inštalácie",
                description: "Po prijatí povolení sa spustí inštalácia. Počkajte na dokončenie procesu a budete pripravení začať používať aplikáciu."
            },
            back: "Späť",
            next: "Ďalej",
            done: "Hotovo",
            footer: {
                title: "Trading View",
                description: "Ste ideálnou voľbou pre obchodovanie s kryptomenami bez poplatkov a s maximálnymi analytickými schopnosťami.",
                downloadForWindows: "Stiahnuť pre Windows",
                email: "support@tradingview.com",
                aboutUs: "O nás",
                privacyPolicy: "Zásady ochrany súkromia",
                copyright: "Autorské práva © 2025",
                rights: "© 2025 TradingView, Inc."
            },
            join: {
                title1: "Pripojte sa k 90 miliónom",
                title2: "obchodníkov a investorov",
                description: "Využite silu najobľúbenejšej platformy pre finančnú analýzu na svete.",
                installNow: "Inštalujte teraz"
            },
            loveInEvery: {
                title1: "Láska v každom",
                title2: "#TradingView",
                testimonials: [{
                    username: "@mytradingsetup",
                    text: "Desktopová aplikácia je blesková! Žiadne oneskorenie prehliadača—len plynulé grafy a obchodovanie."
                }, {
                    username: "@chrislowingproducer",
                    text: "Prechod na viac online obchodovania je skvelý. Ďakujem za všetky nástroje na analýzu grafov."
                }, {
                    username: "@spacedork",
                    text: "Funkcia rozdelenej obrazovky je prelomová! Viac časových rámcov naraz bez prepínania záložiek."
                }, {
                    username: "@joey_official",
                    text: "Konečne! Obchodná aplikácia typu všetko v jednom, ktorá funguje. Môžem zostať ponorený do svojho výskumu bez prerušenia."
                }, {
                    username: "@orly_summerz",
                    text: "TradingView Desktop úplne zmenil môj pracovný postup! Obchodujte rýchlejšie a analyzujte lepšie!"
                }, {
                    username: "@tradingView",
                    text: "Môj obchodný životný štýl je plynulejší ako kedykoľvek predtým. Žiadne rozptýlenia, len čisté profesionálne grafy."
                }, {
                    username: "@globaltrillary",
                    text: "Aktualizácie v reálnom čase a žiadne pády prehliadača! TradingView Desktop je nevyhnutnosťou!"
                }, {
                    username: "@tunccoms",
                    text: "Môžem si prispôsobiť nastavenie presne podľa svojich predstáv. TradingView Desktop uľahčuje môj život!"
                }, {
                    username: "@most_luxurious_lifestyle",
                    text: "Nielen výkonný grafický terminál, ale s jednoduchosťou používania TradingView. Dokonalá kombinácia!"
                }, {
                    username: "@TRzustan",
                    text: "S TradingView Desktop vykonávam obchody rýchlejšie a som vždy o krok pred trhom!"
                }, {
                    username: "@Market Warrior Network",
                    text: "Už žiadne pomalé načítavanie grafov alebo zmeškané príležitosti."
                }, {
                    username: "@traderfx",
                    text: "Z notebooku kamkoľvek, a desktopová aplikácia udržuje môj pracovný postup plynulý naprieč zariadeniami!"
                }]
            },
            heatmap: {
                mainTitle: "Teplotná mapa + Prehľad všetkého",
                mainDescription: "Porovnávajte symboly pomocou rôznych parametrov a nástrojov, všetko v reálnom čase, aby ste našli svoje najlepšie obchodné príležitosti.",
                card1: {
                    title: "Horúce a studené miesta na teplotnej mape",
                    description: "Získajte vtáčí pohľad na kľúčové triedy aktív: akcie, ETF alebo kryptomeny.",
                    features: ["Zoskupovanie podľa sektora s možnosťou preskúmať každý z nich podrobne", "Súbor filtrov na upresnenie vášho výberu", "Zdieľanie vašich prispôsobených teplotných máp", "Zobrazenie kľúčových štatistík každého nástroja"]
                },
                card2: {
                    title: "Nájdite čokoľvek pomocou jednoduchého skenovania",
                    description: "Filtrujte aktíva na základe kritérií, ktoré určíte. Hľadajte najlacnejšie spoločnosti, ktoré zarábajú najviac peňazí, alebo ktoré kryptomeny dosahujú tento mesiac najlepšie výsledky.",
                    features: ["70+ búrz", "Štyri skenery: akcie, forex, krypto páry a mince", "100+ filtračných polí", "Viaceré časové rámce: od jednej minúty až po jeden mesiac", "Globálne vyhľadávanie: filtrujte spoločnosti zo všetkých krajín a odvetví v jednom zozname"]
                }
            },
            unmissable: {
                title: "Neprehliadnuteľné upozornenia",
                description: "Obchodné upozornenia nikdy neboli také výkonné, flexibilné a ľahko použiteľné. Založené na cloudových technológiách, sú dostupné na akomkoľvek zariadení a môžu byť poháňané skriptom Pine Script®."
            },
            charts2: {
                technicalAnalysis: {
                    title: "Technická analýza, urobená správne",
                    description: "Naša platforma prichádza so stovkami zabudovaných indikátorov a stratégií, inteligentnými nástrojmi na kreslenie a nástrojmi pre hĺbkovú analýzu trhu pokrývajúcimi najpopulárnejšie obchodné koncepty",
                    features: ["400+ zabudovaných indikátorov a stratégií", "100 000+ verejných indikátorov", "110+ inteligentných nástrojov na kreslenie", "Indikátory objemového profilu", "Rozpoznávanie sviečkových vzorov", "Analýza viacerých časových rámcov", "Automatické vzory grafov"]
                },
                barReplay: {
                    title: "Prehrávanie stĺpcov",
                    description: "Sledujte, ako sa historicky vyvíjali cenové údaje. Pretočte trhy a prezrite si ich rýchlosťou a rozlíšením, ktoré si želáte.",
                    features: ["Simulované obchodovanie na historických údajoch", "4 rýchlosti prehrávania", "Automatické prehrávanie a režim krok za krokom", "Môžete tiež aplikovať kresliace objekty a indikátory", "Synchronizované prehrávanie viacerých grafov", "Obchodovanie na historických údajoch", "Hĺbkové historické údaje po minútach a sekundách"]
                }
            },
            charts3: {
                mainTitle: "Grafy, ktoré hýbu trhmi",
                mainDescription: "Či už by ste chceli jednoducho vyhľadať najnovšiu cenu akcií, alebo analyzovať cenové vzory pomocou dlhých skriptov — máme všetko, čo potrebujete.",
                chartTypes: {
                    volumeFootprint: {
                        title: "Objemový odtlačok",
                        description: "Zobrazuje distribúciu obchodného objemu na rôznych cenových úrovniach pre každú sviečku v rámci špecifikovaného časového rámca."
                    },
                    timePriceOpportunity: {
                        title: "Príležitosť času a ceny",
                        description: "Umožňuje obchodníkom vizualizovať cenové pohyby s postupom profilového obdobia, ilustrujúc koncentráciu cien na špecifických úrovniach počas daného časového rámca."
                    },
                    sessionVolumeProfile: {
                        title: "Objemový profil relácie",
                        description: "Vypočítava údaje o objeme v rámci špecifikovanej relácie alebo pod-relácie, čo obchodníkom umožňuje analyzovať vnútrodenné objemové aktivity pre konkrétny segment relácie."
                    },
                    candles: {
                        title: "Sviečky",
                        description: "Jeden z najpopulárnejších tradičných grafov na TradingView. Sprostredkúva veľkosť cenových pohybov pomocou rôznych farieb."
                    },
                    bars: {
                        title: "Stĺpce",
                        description: "Graf, zložený z viacerých cenových stĺpcov, z ktorých každý vizualizuje cenový pohyb aktíva alebo cenného papiera počas špecifikovaného časového obdobia."
                    },
                    volumeCandles: {
                        title: "Objemové sviečky",
                        description: "Tento graf vizualizuje obchodný objem, čo obchodníkom umožňuje posúdiť objem obchodov pomocou sviečok."
                    },
                    range: {
                        title: "Rozsah",
                        description: "Umožňuje používateľom analyzovať cenové pohyby finančných nástrojov s väčšou jasnosťou, minimalizuje trhový šum."
                    },
                    heikinAshi: {
                        title: "Heikin Ashi",
                        description: "Znižuje trhový šum vyhladzovaním významných cenových výkyvov, čo uľahčuje identifikáciu trendových pohybov na trhu."
                    },
                    renko: {
                        title: "Renko",
                        description: "Umožňuje používateľom detekovať hlavné cenové pohyby v rámci Renko boxu, ak sa vyskytli."
                    },
                    lineBreak: {
                        title: "Prerušenie línie",
                        description: "Zameriava sa výhradne na cenové pohyby, ignoruje časové intervaly v tomto japonskom štýle grafov."
                    },
                    pointAndFigure: {
                        title: "Bod a číslo",
                        description: "Znázorňuje cenové pohyby ako jedinú metriku, ignorujúc časové intervaly pri ich vytváraní."
                    },
                    kagi: {
                        title: "Kagi",
                        description: "Využíva vertikálne línie (zelené pre rast a červené pre pokles) spojené malými horizontálnymi líniami na zvýraznenie významných pohybov v cene aktíva."
                    },
                    area: {
                        title: "Plocha",
                        description: "Vizualizuje dáta podobným spôsobom ako líniový graf. Plošný graf vykresľuje a spája dáta, pričom plocha medzi nimi je vyplnená farbou na prenesenie informácií."
                    },
                    hlcArea: {
                        title: "HLC plocha",
                        description: "Zameraný na tri dátové body oblasti — Vysoké-Nízke-Zatvárenie (HLC) — na ukázanie zmien ceny v priebehu času, čo obchodníkom umožňuje ignorovať hodnotu otvorenia, ktorá je pre analýzu menej významná."
                    },
                    baseline: {
                        title: "Základná línia",
                        description: "Skúma cenové pohyby vzhľadom na zvolenú základnú líniu, poskytujúc obchodníkom nástroje potrebné na analýzu cenových výkyvov."
                    },
                    line: {
                        title: "Línia",
                        description: "Spája dátové body jednou líniou na vytvorenie klasického líniového grafu."
                    },
                    stepLine: {
                        title: "Kroková línia",
                        description: "Vytvára sériu krokov pomocou horizontálnych a vertikálnych línií na zvýraznenie frekvencie zmien na trhu."
                    },
                    lineWithMarkers: {
                        title: "Línia s označeniami",
                        description: "Pridáva označenia do klasických líniových grafov na reprezentáciu dôležitých dátových bodov."
                    },
                    highLow: {
                        title: "Vysoká-Nízka",
                        description: "Zobrazuje rozsah cien od vysokej po nízku na každom stĺpci."
                    },
                    columns: {
                        title: "Stĺpce",
                        description: "Tento graf prezentuje zmenu v reálnej cene nástroja prostredníctvom použitia stĺpcov."
                    },
                    hollowCandles: {
                        title: "Duté sviečky",
                        description: "Variant tradičných sviečkových grafov, podobný japonským sviečkam."
                    }
                }
            },
            navigation: {
                previous: "Predchádzajúci",
                next: "Nasledujúci",
                pageCount: "{{current}}/{{total}}",
                startAutoplay: "Spustiť automatické prehrávanie",
                stopAutoplay: "Zastaviť automatické prehrávanie"
            },
            plans: {
                expert: {
                    name: "Expert",
                    yearlyPrice: "1 199,40 €",
                    monthlyPrice: "99,95 €",
                    features: [{
                        text: "10 grafov na záložku",
                        hasProgress: !0,
                        progressWidth: "60%"
                    }, {
                        text: "30 indikátorov na graf",
                        hasProgress: !0,
                        progressWidth: "55%"
                    }, {
                        text: "25K historických stĺpcov",
                        hasProgress: !0,
                        progressWidth: "64%"
                    }, {
                        text: "80 paralelných grafových spojení",
                        hasProgress: !0,
                        progressWidth: "45%"
                    }, {
                        text: "600 cenových upozornení",
                        hasProgress: !0,
                        progressWidth: "62%"
                    }, {
                        text: "600 technických upozornení",
                        hasProgress: !0,
                        progressWidth: "60%"
                    }, {
                        text: "10 upozornení sledovacieho zoznamu",
                        hasProgress: !0,
                        progressWidth: "68%"
                    }, {
                        text: "Bez reklám",
                        hasProgress: !1
                    }, {
                        text: "Objemový profil",
                        hasProgress: !1
                    }, {
                        text: "Vlastné časové rámce",
                        hasProgress: !1
                    }, {
                        text: "Vlastné rozsahové stĺpce",
                        hasProgress: !1
                    }, {
                        text: "Viacnásobné sledovacie zoznamy",
                        hasProgress: !1
                    }, {
                        text: "Prehrávanie stĺpcov",
                        hasProgress: !1
                    }, {
                        text: "Indikátory na indikátoroch",
                        hasProgress: !1
                    }, {
                        text: "Export dát grafov",
                        hasProgress: !1
                    }, {
                        text: "Vnútrodenné Renko, Kagi, Prerušenie línie, Bod a číslo grafy",
                        hasProgress: !1
                    }, {
                        text: "Grafy založené na vlastných formulách",
                        hasProgress: !1
                    }, {
                        text: "Príležitosť času a ceny",
                        hasProgress: !1
                    }, {
                        text: "Objemový odtlačok",
                        hasProgress: !1
                    }, {
                        text: "Objemové sviečky",
                        hasProgress: !1
                    }, {
                        text: "Automatické vzory grafov",
                        hasProgress: !1
                    }, {
                        text: "Upozornenia založené na sekundách",
                        hasProgress: !1
                    }, {
                        text: "Upozornenia, ktoré neexpirujú",
                        hasProgress: !1
                    }, {
                        text: "Publikovanie skriptov len na pozvánku",
                        hasProgress: !1
                    }, {
                        text: "Intervaly založené na sekundách",
                        hasProgress: !1
                    }, {
                        text: "Intervaly založené na tickoch (BETA)",
                        hasProgress: !1
                    }, {
                        text: "Možnosť zakúpiť profesionálne trhové údaje",
                        hasProgress: !1
                    }, {
                        text: "Prvá priorita podpory",
                        hasProgress: !1
                    }]
                },
                ultimate: {
                    name: "Ultimate",
                    originalPrice: "2 399,40 €",
                    currentPrice: "Zadarmo",
                    features: [{
                        text: "16 grafov na záložku",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "50 indikátorov na graf",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "40K historických stĺpcov",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "200 paralelných grafových spojení",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "1 000 cenových upozornení",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "1 000 technických upozornení",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "15 upozornení sledovacieho zoznamu",
                        hasProgress: !0,
                        progressWidth: "100%"
                    }, {
                        text: "Bez reklám",
                        hasProgress: !1
                    }, {
                        text: "Objemový profil",
                        hasProgress: !1
                    }, {
                        text: "Vlastné časové rámce",
                        hasProgress: !1
                    }, {
                        text: "Vlastné rozsahové stĺpce",
                        hasProgress: !1
                    }, {
                        text: "Viacnásobné sledovacie zoznamy",
                        hasProgress: !1
                    }, {
                        text: "Prehrávanie stĺpcov",
                        hasProgress: !1
                    }, {
                        text: "Indikátory na indikátoroch",
                        hasProgress: !1
                    }, {
                        text: "Export dát grafov",
                        hasProgress: !1
                    }, {
                        text: "Vnútrodenné Renko, Kagi, Prerušenie línie, Bod a číslo grafy",
                        hasProgress: !1
                    }, {
                        text: "Grafy založené na vlastných formulách",
                        hasProgress: !1
                    }, {
                        text: "Príležitosť času a ceny",
                        hasProgress: !1
                    }, {
                        text: "Objemový odtlačok",
                        hasProgress: !1
                    }, {
                        text: "Objemové sviečky",
                        hasProgress: !1
                    }, {
                        text: "Automatické vzory grafov",
                        hasProgress: !1
                    }, {
                        text: "Upozornenia založené na sekundách",
                        hasProgress: !1
                    }, {
                        text: "Upozornenia, ktoré neexpirujú",
                        hasProgress: !1
                    }, {
                        text: "Publikovanie skriptov len na pozvánku",
                        hasProgress: !1
                    }, {
                        text: "Intervaly založené na sekundách",
                        hasProgress: !1
                    }, {
                        text: "Intervaly založené na tickoch (BETA)",
                        hasProgress: !1
                    }, {
                        text: "Možnosť zakúpiť profesionálne trhové údaje",
                        hasProgress: !1
                    }, {
                        text: "Prvá priorita podpory",
                        hasProgress: !1
                    }]
                }
            },
            pricing2: {
                title: "ZÍSKAJTE BEZPLATNÝ PLÁN ULTIMATE",
                description: "Získajte úplný prístup k TradingView s ročným plánom Ultimate ZADARMO",
                year: "rok",
                month: "mesiac"
            },
            button: {
                downloadForWindows: "Stiahnuť pre Windows",
                unsupportedSystem: "Nepodporovaný systém"
            },
            tradingView: {
                title: "TradingView Desktop",
                description: "Zažite extra výkon, extra rýchlosť a extra flexibilitu,",
                descriptionContinued: "všetko s rovnakým UX, ktoré poznáte a máte radi."
            },
            banner: {
                title: "Získajte úplný prístup k",
                titleContinued: "TradingView ZADARMO",
                subtitle: "Len v TradingView Desktop",
                downloadButton: "Stiahnuť pre Windows"
            },
            pricingCard: {
                title: "Len v TradingView Desktop",
                yearlyPrice: "{{price}} / Rok",
                freePrice: "Zadarmo",
                features: {
                    chartsPerTab: "{{count}} grafov na záložku",
                    indicatorsPerChart: "{{count}} indikátorov na graf",
                    historicalBars: "{{count}} historických stĺpcov",
                    chartConnections: "{{count}} paralelných grafových spojení",
                    priceAlerts: "{{count}} cenových upozornení",
                    technicalAlerts: "{{count}} technických upozornení",
                    watchlistAlerts: "{{count}} upozornení sledovacieho zoznamu",
                    noAds: "Bez reklám",
                    volumeProfile: "Objemový profil",
                    customTimeframes: "Vlastné časové rámce",
                    customRangeBars: "Vlastné rozsahové stĺpce",
                    multipleWatchlists: "Viacnásobné sledovacie zoznamy"
                }
            }
        }
    }
};
rt.use(D0).use(Yy).init({
    resources: ZS,
    fallbackLng: "en",
    supportedLngs: ["en", "pt", "zh-TW", "es", "ar", "th", "vi", "bn", "mn", "ja", "tr", "ko", "ka", "ru", "id", "sq", "bs", "bg", "hr", "xk", "me", "mk", "ro", "sr", "sl", "sk", "md", "by"],
    interpolation: {
        escapeValue: !1
    },
    detection: {
        order: ["localStorage", "navigator"],
        caches: ["localStorage"]
    }
});
const YS = "/cdn/shop/t/1/assets/bg-Cz7YdOCM.webp"
  , QS = i => {
    const e = {
        en: {
            title: "TradingView celebrates 15 years",
            description: "Claim your personal gift: a 1-year Premium plan. Only for the desktop version.",
            buttonText: "Download App",
            price: "0.00$",
            originalPrice: "2399.40$",
            timeLeft: "3 days left"
        },
        "zh-TW": {
            title: "TradingView 慶祝成立 15 週年",
            description: "領取您的個人禮物：1 年高級會員計劃。僅限桌面版。",
            buttonText: "下載應用程式",
            price: "0.00$",
            originalPrice: "2399.40$",
            timeLeft: "剩餘 3 天"
        },
        es: {
            title: "TradingView celebra 15 años",
            description: "Reclama tu regalo personal: un plan Premium de 1 año. Solo para la versión de escritorio.",
            buttonText: "Descargar App",
            price: "0.00$",
            originalPrice: "2399.40$",
            timeLeft: "3 días restantes"
        },
        ar: {
            title: "TradingView تحتفل بمرور 15 عامًا",
            description: "احصل على هديتك الشخصية: خطة بريميوم لمدة عام واحد. فقط لإصدار سطح المكتب.",
            buttonText: "تحميل التطبيق",
            price: "0.00$",
            originalPrice: "2399.40$",
            timeLeft: "3 أيام متبقية"
        },
        th: {
            title: "TradingView ฉลอง 15 ปี",
            description: "รับของขวัญส่วนตัวของคุณ: แผน Premium 1 ปี เฉพาะสำหรับเวอร์ชันเดสก์ท็อปเท่านั้น",
            buttonText: "ดาวน์โหลดแอป",
            price: "0.00$",
            originalPrice: "2399.40$",
            timeLeft: "เหลือ 3 วัน"
        },
        vi: {
            title: "TradingView kỷ niệm 15 năm",
            description: "Nhận món quà cá nhân của bạn: gói Premium 1 năm. Chỉ dành cho phiên bản máy tính để bàn.",
            buttonText: "Tải ứng dụng",
            price: "0.00$",
            originalPrice: "2399.40$",
            timeLeft: "Còn lại 3 ngày"
        },
        bn: {
            title: "TradingView ১৫ বছর উদযাপন করছে",
            description: "আপনার ব্যক্তিগত উপহার দাবি করুন: ১ বছরের প্রিমিয়াম প্ল্যান। শুধুমাত্র ডেস্কটপ সংস্করণের জন্য।",
            buttonText: "অ্যাপ ডাউনলোড করুন",
            price: "০.০০$",
            originalPrice: "২৩৯৯.৪০$",
            timeLeft: "৩ দিন বাকি"
        },
        mn: {
            title: "TradingView 15 жилийн ойг тэмдэглэж байна",
            description: "Хувийн бэлгээ авах: 1 жилийн Премиум төлөвлөгөө. Зөвхөн десктоп хувилбарт.",
            buttonText: "Апп татах",
            price: "0.00$",
            originalPrice: "2399.40$",
            timeLeft: "3 өдөр үлдлээ"
        },
        ja: {
            title: "TradingView 15周年記念",
            description: "あなた専用のギフトを受け取ろう：1年間のプレミアムプラン。デスクトップ版限定。",
            buttonText: "アプリをダウンロード",
            price: "0.00$",
            originalPrice: "2399.40$",
            timeLeft: "残り3日"
        },
        tr: {
            title: "TradingView 15. yılını kutluyor",
            description: "Kişisel hediyenizi talep edin: 1 yıllık Premium plan. Sadece masaüstü sürümü için.",
            buttonText: "Uygulamayı İndir",
            price: "0.00$",
            originalPrice: "2399.40$",
            timeLeft: "3 gün kaldı"
        },
        ko: {
            title: "TradingView 15주년 기념",
            description: "개인 선물을 받으세요: 1년 프리미엄 플랜. 데스크톱 버전 전용.",
            buttonText: "앱 다운로드",
            price: "0.00$",
            originalPrice: "2399.40$",
            timeLeft: "3일 남음"
        },
        ka: {
            title: "TradingView 15 წლის იუბილეს აღნიშნავს",
            description: "მიიღეთ თქვენი პერსონალური საჩუქარი: 1 წლიანი Premium გეგმა. მხოლოდ დესკტოპ ვერსიისთვის.",
            buttonText: "აპლიკაციის ჩამოტვირთვა",
            price: "0.00$",
            originalPrice: "2399.40$",
            timeLeft: "დარჩენილია 3 დღე"
        },
        ru: {
            title: "TradingView отмечает 15 лет",
            description: "Получите свой персональный подарок: план Premium на 1 год. Только для настольной версии.",
            buttonText: "Скачать приложение",
            price: "0.00$",
            originalPrice: "2399.40$",
            timeLeft: "Осталось 3 дня"
        },
        id: {
            title: "TradingView merayakan 15 tahun",
            description: "Klaim hadiah pribadi Anda: paket Premium 1 tahun. Hanya untuk versi desktop.",
            buttonText: "Unduh Aplikasi",
            price: "0.00$",
            originalPrice: "2399.40$",
            timeLeft: "3 hari tersisa"
        },
        sq: {
            title: "TradingView feston 15 vjet",
            description: "Merrni dhuratën tuaj personale: një plan Premium 1-vjeçar. Vetëm për versionin desktop.",
            buttonText: "Shkarkoni Aplikacionin",
            price: "0.00$",
            originalPrice: "2399.40$",
            timeLeft: "3 ditë të mbetura"
        },
        bs: {
            title: "TradingView slavi 15 godina",
            description: "Zatražite svoj lični poklon: Premium plan od 1 godine. Samo za desktop verziju.",
            buttonText: "Preuzmite Aplikaciju",
            price: "0.00$",
            originalPrice: "2399.40$",
            timeLeft: "Preostala 3 dana"
        },
        bg: {
            title: "TradingView празнува 15 години",
            description: "Вземете личния си подарък: 1-годишен Premium план. Само за desktop версията.",
            buttonText: "Изтеглете Приложението",
            price: "0.00$",
            originalPrice: "2399.40$",
            timeLeft: "Остават 3 дни"
        },
        hr: {
            title: "TradingView slavi 15 godina",
            description: "Zatražite svoj osobni poklon: Premium plan od 1 godine. Samo za desktop verziju.",
            buttonText: "Preuzmite Aplikaciju",
            price: "0.00$",
            originalPrice: "2399.40$",
            timeLeft: "Preostala 3 dana"
        },
        xk: {
            title: "TradingView feston 15 vjet / TradingView слави 15 година",
            description: "Merrni dhuratën tuaj personale: një plan Premium 1-vjeçar. Vetëm për versionin desktop. / Затражите свој лични поклон: Premium план од 1 године. Само за desktop верзију.",
            buttonText: "Shkarkoni Aplikacionin / Преузмите Апликацију",
            price: "0.00$",
            originalPrice: "2399.40$",
            timeLeft: "3 ditë të mbetura / Преостала 3 дана"
        },
        me: {
            title: "TradingView слави 15 година",
            description: "Затражите свој лични поклон: Premium план од 1 године. Само за desktop верзију.",
            buttonText: "Преузмите Апликацију",
            price: "0.00$",
            originalPrice: "2399.40$",
            timeLeft: "Преостала 3 дана"
        },
        mk: {
            title: "TradingView слави 15 години",
            description: "Земете го вашиот личен подарок: 1-годишен Premium план. Само за desktop верзијата.",
            buttonText: "Преземете ја Апликацијата",
            price: "0.00$",
            originalPrice: "2399.40$",
            timeLeft: "Преостануваат 3 дена"
        },
        ro: {
            title: "TradingView sărbătorește 15 ani",
            description: "Revendicați cadoul dvs. personal: un plan Premium de 1 an. Doar pentru versiunea desktop.",
            buttonText: "Descărcați Aplicația",
            price: "0.00$",
            originalPrice: "2399.40$",
            timeLeft: "3 zile rămase"
        },
        sr: {
            title: "TradingView слави 15 година",
            description: "Затражите свој лични поклон: Premium план од 1 године. Само за desktop верзију.",
            buttonText: "Преузмите Апликацију",
            price: "0.00$",
            originalPrice: "2399.40$",
            timeLeft: "Преостала 3 дана"
        },
        sl: {
            title: "TradingView praznuje 15 let",
            description: "Prevzemite svojo osebno darilo: 1-letni Premium načrt. Samo za namizno različico.",
            buttonText: "Prenesite Aplikacijo",
            price: "0.00$",
            originalPrice: "2399.40$",
            timeLeft: "Preostali 3 dnevi"
        },
        sk: {
            title: "TradingView oslavuje 15 rokov",
            description: "Získajte svoj osobný darček: 1-ročný Premium plán. Len pre desktop verziu.",
            buttonText: "Stiahnite Aplikáciu",
            price: "0.00$",
            originalPrice: "2399.40$",
            timeLeft: "Zostávajú 3 dni"
        },
        md: {
            title: "TradingView sărbătorește 15 ani",
            description: "Revendicați cadoul dvs. personal: un plan Premium de 1 an. Doar pentru versiunea desktop.",
            buttonText: "Descărcați Aplicația",
            price: "0.00$",
            originalPrice: "2399.40$",
            timeLeft: "3 zile rămase"
        },
        by: {
            title: "TradingView святкуе 15 гадоў",
            description: "Атрымайце свой персанальны падарунак: 1-гадовы Premium план. Толькі для настольнай версіі.",
            buttonText: "Спампуйце Дадатак",
            price: "0.00$",
            originalPrice: "2399.40$",
            timeLeft: "Засталося 3 дні"
        },
        ms: {
            title: "TradingView meraikan 15 tahun",
            description: "Tuntut hadiah peribadi anda: pelan Premium 1 tahun. Hanya untuk versi desktop.",
            buttonText: "Muat turun Aplikasi",
            price: "0.00$",
            originalPrice: "2399.40$",
            timeLeft: "3 hari lagi"
        },
        pt: {
            title: "TradingView celebra 15 anos",
            description: "Reivindique seu presente pessoal: um plano Premium de 1 ano. Apenas para a versão desktop.",
            buttonText: "Baixar App",
            price: "0.00$",
            originalPrice: "2399.40$",
            timeLeft: "3 dias restantes"
        }
    };
    return e[i] || e.en
}
  , JS = () => {
    const {i18n: i} = We()
      , e = i.language
      , r = QS(e)
      , a = {
        hidden: {
            opacity: 0
        },
        visible: {
            opacity: 1,
            transition: {
                duration: .6,
                staggerChildren: .2
            }
        }
    }
      , o = {
        hidden: {
            opacity: 0,
            y: 30
        },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: .8,
                ease: "easeOut"
            }
        }
    }
      , l = {
        hidden: {
            opacity: 0,
            x: 20
        },
        visible: {
            opacity: 1,
            x: 0,
            transition: {
                duration: .6,
                ease: "easeOut"
            }
        }
    }
      , u = {
        hidden: {
            opacity: 0,
            y: 10
        },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: .6,
                ease: "easeOut",
                delay: .1
            }
        }
    };
    return x.jsxs("section", {
        className: "min-h-[400px] sm:min-h-[500px] md:min-h-[600px] lg:min-h-[724px] w-full flex items-center justify-center relative overflow-hidden",
        children: [x.jsx(ee.img, {
            src: YS,
            className: "absolute z-[-2] top-0 left-0 w-full h-full object-cover",
            alt: "",
            initial: {
                scale: 1.1,
                opacity: 0
            },
            animate: {
                scale: 1,
                opacity: 1
            },
            transition: {
                duration: 1.2,
                ease: "easeOut"
            }
        }), x.jsx("div", {
            className: "bg-[linear-gradient(180deg,#010101_0%,rgba(0,0,0,0.00)_100%)] absolute z-[-1] bottom-0 w-full h-[40%] scale-y-[-1]"
        }), x.jsxs(ee.div, {
            className: "max-w-[320px] sm:max-w-[500px] md:max-w-[600px] lg:max-w-[784px] w-full mx-auto px-4 sm:px-6 md:px-8 py-6 sm:py-8 flex flex-col gap-4 sm:gap-6 md:gap-8 relative z-10",
            variants: a,
            initial: "hidden",
            animate: "visible",
            children: [x.jsxs(ee.div, {
                className: "flex flex-col gap-3 sm:gap-4 md:gap-6 items-center justify-center text-center",
                variants: o,
                children: [x.jsx(ee.h2, {
                    className: "text-[#F4F4F4] font-bold text-[28px] sm:text-[40px] md:text-[56px] lg:text-[72px] leading-[110%] px-2",
                    variants: o,
                    children: r.title
                }), x.jsx(ee.p, {
                    className: "text-[#F4F4F4] text-[14px] sm:text-[16px] md:text-[18px] lg:text-[20px] leading-[1.4] sm:leading-[1.3] md:leading-[1.2] lg:leading-[1.1] px-2",
                    variants: o,
                    children: r.description
                })]
            }), x.jsxs(ee.div, {
                className: "w-full flex flex-col gap-3 sm:gap-4 items-center sm:items-end justify-center sm:justify-end",
                variants: o,
                children: [x.jsxs("div", {
                    className: "flex flex-col sm:flex-row items-center justify-center sm:justify-end gap-3 sm:gap-4 md:gap-[3.25rem] w-full",
                    children: [x.jsx(Un, {
                        label: r.buttonText,
                        className: "!max-w-[280px] sm:!max-w-[250px] md:!max-w-[280px] lg:!max-w-[308px] !w-full text-sm sm:text-base"
                    }), x.jsxs(ee.div, {
                        className: "flex items-center gap-2 sm:gap-3 order-first sm:order-last",
                        variants: l,
                        children: [x.jsx(ee.span, {
                            className: "text-[#F4F4F4] text-[20px] sm:text-[22px] md:text-[24px] leading-[1.1]",
                            initial: {
                                scale: .8
                            },
                            animate: {
                                scale: 1
                            },
                            transition: {
                                delay: .8,
                                duration: .4,
                                ease: "easeOut"
                            },
                            children: r.price
                        }), x.jsx(ee.span, {
                            className: "text-[#858C93] line-through text-[16px] sm:text-[18px] md:text-[20px] leading-[1.1]",
                            initial: {
                                opacity: 0,
                                x: -10
                            },
                            animate: {
                                opacity: 1,
                                x: 0
                            },
                            transition: {
                                delay: 1,
                                duration: .4
                            },
                            children: r.originalPrice
                        })]
                    })]
                }), x.jsx(ee.span, {
                    className: "text-[#D0D3D7] text-[16px] sm:text-[18px] md:text-[20px] leading-[1.1] self-center",
                    variants: u,
                    children: r.timeLeft
                })]
            })]
        })]
    })
}
;
function I0(i) {
    var e, r, a = "";
    if (typeof i == "string" || typeof i == "number")
        a += i;
    else if (typeof i == "object")
        if (Array.isArray(i)) {
            var o = i.length;
            for (e = 0; e < o; e++)
                i[e] && (r = I0(i[e])) && (a && (a += " "),
                a += r)
        } else
            for (r in i)
                i[r] && (a && (a += " "),
                a += r);
    return a
}
function bf() {
    for (var i, e, r = 0, a = "", o = arguments.length; r < o; r++)
        (i = arguments[r]) && (e = I0(i)) && (a && (a += " "),
        a += e);
    return a
}
const eT = N.memo( ({children: i, delay: e=0, position: r, inView: a, classNameParent: o, classNameChild: l}) => {
    const u = N.useRef(null)
      , d = Ht(u, {
        once: !0,
        amount: .2
    })
      , p = a !== void 0 ? a : d
      , h = () => {
        switch (r) {
        case "left":
            return {
                opacity: 0,
                x: -100,
                filter: "blur(50px)"
            };
        case "right":
            return {
                opacity: 0,
                x: 100,
                filter: "blur(50px)"
            };
        case "top":
            return {
                opacity: 0,
                y: -50,
                filter: "blur(50px)"
            };
        case "bottom":
            return {
                opacity: 0,
                y: 50,
                filter: "blur(50px)"
            };
        default:
            return {
                opacity: 0,
                y: 50,
                filter: "blur(50px)"
            }
        }
    }
      , g = () => ({
        opacity: 1,
        x: 0,
        y: 0,
        filter: "blur(0px)"
    });
    return x.jsx("div", {
        ref: u,
        className: bf("w-full", o),
        children: x.jsx(ee.div, {
            className: bf("w-full flex justify-center", l),
            initial: h(),
            animate: p ? g() : h(),
            transition: {
                duration: .4,
                delay: e
            },
            children: i
        })
    })
}
)
  , tT = "/cdn/shop/t/1/assets/video-C9_KP_Ip.mp4"
  , iT = "/cdn/shop/t/1/assets/aurora-Cvlw07PL.webp"
  , rT = "/cdn/shop/t/1/assets/laptop-D-ccQfn0.webp"
  , nT = i => ({
    __html: i
})
  , aT = i => {
    const e = {
        en: {
            title: "Where The World Does Markets",
            desc: "Join 100 Million Traders And Investors Taking The Future Into Their Own Hands",
            button: "Download App"
        },
        "zh-TW": {
            title: "全世界都在這裡做市場",
            desc: "加入 1 億名交易者和投資者將未來掌握在自己手中",
            button: "下載應用程式"
        },
        es: {
            title: "Donde El Mundo Hace Mercados",
            desc: "Únete a 100 millones de traders e inversores que toman el futuro en sus propias manos",
            button: "Descargar App"
        },
        ar: {
            title: "حيث يصنع العالم الأسواق",
            desc: "انضم إلى 100 مليون متداول ومستثمر يأخذون المستقبل بأيديهم",
            button: "تحميل التطبيق"
        },
        th: {
            title: "ที่โลก ทำการตลาด",
            desc: "ร่วมกับนักเทรดและนักลงทุน 100 ล้านคน ที่นำอนาคตไปสู่มือของตนเอง",
            button: "ดาวน์โหลดแอป"
        },
        vi: {
            title: "Nơi Thế Giới Làm Thị Trường",
            desc: "Tham gia cùng 100 triệu nhà giao dịch và nhà đầu tư nắm lấy tương lai trong tay họ",
            button: "Tải ứng dụng"
        },
        bn: {
            title: "যেখানে বিশ্ব বাজার করে",
            desc: "১০০ মিলিয়ন ট্রেডার এবং বিনিয়োগকারীদের সাথে যোগ দিন যারা ভবিষ্যৎ নিজেদের হাতে নিয়েছেন",
            button: "অ্যাপ ডাউনলোড করুন"
        },
        mn: {
            title: "Дэлхий зах зээлийг хийдэг газар",
            desc: "Ирээдүйг өөрсдийн гарт авч буй 100 сая арилжаачин, хөрөнгө оруулагчидтай нэгдээрэй",
            button: "Апп татах"
        },
        ja: {
            title: "世界が市場を動かす場所",
            desc: "未来を自らの手に握る 1億人のトレーダーと投資家に参加しよう",
            button: "アプリをダウンロード"
        },
        tr: {
            title: "Dünyanın Piyasaları Yaptığı Yer",
            desc: "Geleceği kendi ellerine alan 100 milyon trader ve yatırımcıya katılın",
            button: "Uygulamayı İndir"
        },
        ko: {
            title: "세상이 시장을 만드는 곳",
            desc: "미래를 자신의 손에 쥔 1억 명의 트레이더와 투자자들과 함께하세요",
            button: "앱 다운로드"
        },
        ka: {
            title: "სადაც მსოფლიო ბაზრებს ქმნის",
            desc: "შეუერთდით 100 მილიონ ტრეიდერსა და ინვესტორს რომლებიც მომავალს საკუთარ ხელებში იღებენ",
            button: "აპლიკაციის ჩამოტვირთვა"
        },
        ru: {
            title: "Где мир занимается рынками",
            desc: "Присоединяйтесь к 100 миллионам трейдеров и инвесторов, берущих будущее в свои руки",
            button: "Скачать приложение"
        },
        id: {
            title: "Dimana Dunia Melakukan Pasar",
            desc: "Bergabunglah dengan 100 juta trader dan investor yang mengambil masa depan ke tangan mereka sendiri",
            button: "Unduh Aplikasi"
        },
        sq: {
            title: "Ku Bota Bën Tregjet",
            desc: "Bashkohuni me 100 milion tregtarë dhe investitorë që e marrin të ardhmen në duart e tyre",
            button: "Shkarkoni Aplikacionin"
        },
        bs: {
            title: "Gdje Svijet Radi Tržišta",
            desc: "Pridružite se sa 100 miliona trgovaca i investitora koji uzimaju budućnost u svoje ruke",
            button: "Preuzmite Aplikaciju"
        },
        bg: {
            title: "Където Светът Прави Пазари",
            desc: "Присъединете се към 100 милиона търговци и инвеститори, които взимат бъдещето в свои ръце",
            button: "Изтеглете Приложението"
        },
        hr: {
            title: "Gdje Svijet Radi Tržišta",
            desc: "Pridružite se s 100 milijuna trgovaca i investitora koji uzimaju budućnost u svoje ruke",
            button: "Preuzmite Aplikaciju"
        },
        xk: {
            title: "Ku Bota Bën Tregjet / Где Свет Ради Тржишта",
            desc: "Bashkohuni me 100 milion tregtarë dhe investitorë që e marrin të ardhmen në duart e tyre / Придружите се са 100 милиона трговаца и инвеститора који узимају будућност у своје руке",
            button: "Shkarkoni Aplikacionin / Преузмите Апликацију"
        },
        me: {
            title: "Гдје Свијет Ради Тржишта",
            desc: "Придружите се са 100 милиона трговаца и инвеститора који узимају будућност у своје руке",
            button: "Преузмите Апликацију"
        },
        mk: {
            title: "Каде Светот Ги Прави Пазарите",
            desc: "Придружете се на 100 милиони трговци и инвеститори што ја земаат иднината во свои раце",
            button: "Преземете ја Апликацијата"
        },
        ro: {
            title: "Unde Lumea Face Piețe",
            desc: "Alăturați-vă la 100 de milioane de traderi și investitori care își iau viitorul în propriile mâini",
            button: "Descărcați Aplicația"
        },
        sr: {
            title: "Где Свет Ради Тржишта",
            desc: "Придружите се са 100 милиона трговаца и инвеститора који узимају будућност у своје руке",
            button: "Преузмите Апликацију"
        },
        sl: {
            title: "Kjer Svet Dela Trge",
            desc: "Pridružite se 100 milijonom trgovcem in vlagateljem, ki jemljejo prihodnost v svoje roke",
            button: "Prenesite Aplikacijo"
        },
        sk: {
            title: "Kde Svet Robí Trhy",
            desc: "Pripojte sa k 100 miliónom obchodníkov a investorov, ktorí berú budúcnosť do svojich rúk",
            button: "Stiahnite Aplikáciu"
        },
        md: {
            title: "Unde Lumea Face Piețe",
            desc: "Alăturați-vă la 100 de milioane de traderi și investitori care își iau viitorul în propriile mâini",
            button: "Descărcați Aplicația"
        },
        by: {
            title: "Дзе Свет Робіць Рынкі",
            desc: "Далучайцеся да 100 мільёнаў трэйдэраў і інвестараў, якія бяруць будучыню ў свае рукі",
            button: "Спампуйце Дадатак"
        },
        pt: {
            title: "Onde O Mundo Faz Mercados",
            desc: "Junte-se a 100 milhões de traders e investidores que tomam o futuro em suas próprias mãos",
            button: "Baixar App"
        }
    };
    return e[i] || e.en
}
  , sT = () => {
    const {i18n: i} = We()
      , e = i.language
      , r = aT(e)
      , a = N.useRef(null);
    return x.jsxs("div", {
        className: "relative",
        children: [x.jsx("div", {
            className: "bg-[linear-gradient(180deg,#010101_0%,rgba(0,0,0,0.00)_100%)] absolute z-[-1] top-0 w-full h-[40%]"
        }), x.jsx("div", {
            className: "bg-[linear-gradient(180deg,#010101_0%,rgba(0,0,0,0.00)_100%)] absolute z-[-1] bottom-0 w-full h-[40%] scale-y-[-1]"
        }), x.jsx(ee.img, {
            src: iT,
            className: "absolute z-[-2] top-0 left-0 object-cover w-full h-full",
            alt: "",
            loading: "lazy",
            initial: {
                opacity: 0,
                scale: 1.1
            },
            animate: {
                opacity: 1,
                scale: 1
            },
            transition: {
                duration: 1.5,
                ease: "easeOut"
            }
        }), x.jsx("section", {
            ref: a,
            className: "max-w-[1376px] w-full mx-auto px-4 sm:px-6 relative lg:px-8 py-6 md:py-8 flex flex-col gap-[60px] items-center justify-center",
            children: x.jsx(eT, {
                delay: .2,
                classNameChild: "flex justify-center",
                children: x.jsxs("div", {
                    className: "relative flex justify-center items-center w-full",
                    children: [x.jsx("img", {
                        src: rT,
                        alt: "",
                        loading: "lazy",
                        className: "pointer-events-none w-full h-auto"
                    }), x.jsxs("div", {
                        className: "absolute z-10 bg-[#000]",
                        style: {
                            width: "84.7%",
                            height: "58.2%",
                            top: "15%",
                            left: "8.15%"
                        },
                        children: [x.jsx("video", {
                            src: tT,
                            autoPlay: !0,
                            muted: !0,
                            loop: !0,
                            className: "brightness-[0.2] rounded-[8px] md:rounded-[24px] w-full h-full object-cover"
                        }), x.jsxs("div", {
                            className: "absolute w-full h-full top-0 flex flex-col gap-2 md:gap-4 lg:gap-8 items-center justify-center text-center z-20 px-2 sm:px-4",
                            children: [x.jsx("h2", {
                                className: "text-[#FFF] font-[600] text-[24px] sm:text-[48px] md:text-[56px] lg:text-[64px] leading-[110%] sm:leading-[105%] md:leading-[100%] lg:leading-[64px] capitalize",
                                children: r.title
                            }), x.jsx("p", {
                                dangerouslySetInnerHTML: nT(r.desc),
                                className: " text-[#FFF] font-[300] text-[14px] md:text-[20px] lg:text-[24px] leading-[120%] md:leading-[133%]"
                            }), x.jsx(Un, {
                                label: r.button,
                                className: "max-w-fit md:max-w-[308px] !w-full"
                            })]
                        })]
                    })]
                })
            })
        })]
    })
}
  , oT = i => {
    const e = {
        en: {
            days: "D",
            hours: "H",
            minutes: "M"
        },
        "zh-TW": {
            days: "天",
            hours: "時",
            minutes: "分"
        },
        es: {
            days: "D",
            hours: "H",
            minutes: "M"
        },
        ar: {
            days: "ي",
            hours: "س",
            minutes: "د"
        },
        th: {
            days: "วัน",
            hours: "ชม.",
            minutes: "นาที"
        },
        vi: {
            days: "N",
            hours: "G",
            minutes: "P"
        },
        bn: {
            days: "দিন",
            hours: "ঘন্টা",
            minutes: "মিনিট"
        },
        mn: {
            days: "Ө",
            hours: "Ц",
            minutes: "М"
        },
        ja: {
            days: "日",
            hours: "時",
            minutes: "分"
        },
        tr: {
            days: "G",
            hours: "S",
            minutes: "D"
        },
        ko: {
            days: "일",
            hours: "시",
            minutes: "분"
        },
        ka: {
            days: "დ",
            hours: "ს",
            minutes: "წ"
        },
        id: {
            days: "H",
            hours: "J",
            minutes: "M"
        },
        pt: {
            days: "D",
            hours: "H",
            minutes: "M"
        }
    };
    return e[i] || e.en
}
  , lT = ({days: i=0, hours: e=24, minutes: r=1, storageKey: a="Tradingview123timerEndTime"}) => {
    const {i18n: o} = We()
      , l = o.language
      , u = oT(l)
      , [d,p] = N.useState({
        days: i,
        hours: e,
        minutes: r
    })
      , h = N.useCallback( () => {
        const w = Date.now() + i * 24 * 60 * 60 * 1e3 + e * 60 * 60 * 1e3 + r * 60 * 1e3;
        localStorage.setItem(a, w.toString()),
        p({
            days: i,
            hours: e,
            minutes: r
        })
    }
    , [i, e, r, a]);
    N.useEffect( () => {
        const w = localStorage.getItem(a)
          , S = Date.now();
        if (w) {
            const C = parseInt(w) - S;
            if (C > 0) {
                const b = Math.floor(C / 864e5)
                  , T = Math.floor(C % (1e3 * 60 * 60 * 24) / (1e3 * 60 * 60))
                  , D = Math.floor(C % (1e3 * 60 * 60) / (1e3 * 60));
                p({
                    days: Math.max(0, b),
                    hours: Math.max(0, T),
                    minutes: Math.max(0, D)
                })
            } else
                h()
        } else
            h()
    }
    , [h, a]),
    N.useEffect( () => {
        const w = setInterval( () => {
            const S = localStorage.getItem(a);
            if (S) {
                const z = parseInt(S)
                  , C = Date.now()
                  , b = z - C;
                if (b > 0) {
                    const T = Math.floor(b / 864e5)
                      , D = Math.floor(b % (1e3 * 60 * 60 * 24) / (1e3 * 60 * 60))
                      , M = Math.floor(b % (1e3 * 60 * 60) / (1e3 * 60))
                      , B = Math.floor(b % (1e3 * 60) / 1e3);
                    p({
                        days: Math.max(0, T),
                        hours: Math.max(0, D),
                        minutes: Math.max(0, M)
                    }),
                    T <= 0 && D <= 0 && M <= 0 && B <= 0 && h()
                } else
                    h()
            }
        }
        , 1e3);
        return () => clearInterval(w)
    }
    , [h, a]);
    const g = w => Math.max(0, w).toString().padStart(2, "0")
      , v = {
        hidden: {
            opacity: 0,
            scale: .8
        },
        visible: {
            opacity: 1,
            scale: 1,
            transition: {
                duration: .5,
                staggerChildren: .1,
                ease: "easeOut"
            }
        }
    }
      , y = {
        hidden: {
            opacity: 0,
            y: 20
        },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: .4,
                ease: "easeOut"
            }
        }
    }
      , P = {
        pulse: {
            scale: [1, 1.05, 1],
            transition: {
                duration: 2,
                repeat: 1 / 0,
                ease: "easeInOut"
            }
        }
    };
    return x.jsxs(ee.div, {
        className: "flex items-center gap-1 sm:gap-1.5 md:gap-2 lg:gap-2.5 xl:gap-3",
        initial: "hidden",
        animate: "visible",
        variants: v,
        children: [x.jsx(ee.div, {
            className: "bg-[#FFFFFF] border border-[#D0D3D7] rounded-[2px] sm:rounded-[3px] md:rounded-[4px] lg:rounded-[5px] py-0.5 sm:py-1 md:py-1.5 lg:py-2 px-1 sm:px-1.5 md:px-2 lg:px-3 min-w-[28px] sm:min-w-[32px] md:min-w-[36px] lg:min-w-[40px] xl:min-w-[44px] flex items-center justify-center",
            variants: y,
            whileHover: {
                scale: 1.05
            },
            animate: d.days === 0 && d.hours === 0 && d.minutes <= 5 ? "pulse" : "",
            custom: P,
            children: x.jsx("span", {
                className: "text-[#0D1013] font-semibold text-base sm:text-lg md:text-xl lg:text-2xl xl:text-[28px] 2xl:text-[32px] leading-[120%] tabular-nums",
                children: g(d.days)
            })
        }), x.jsx(ee.span, {
            className: "text-[#707070] font-semibold text-xs sm:text-sm md:text-base lg:text-lg xl:text-xl 2xl:text-[24px] leading-[16px]",
            variants: y,
            children: u.days
        }), x.jsx(ee.div, {
            className: "bg-[#FFFFFF] border border-[#D0D3D7] rounded-[2px] sm:rounded-[3px] md:rounded-[4px] lg:rounded-[5px] py-0.5 sm:py-1 md:py-1.5 lg:py-2 px-1 sm:px-1.5 md:px-2 lg:px-3 min-w-[28px] sm:min-w-[32px] md:min-w-[36px] lg:min-w-[40px] xl:min-w-[44px] flex items-center justify-center",
            variants: y,
            whileHover: {
                scale: 1.05
            },
            animate: d.days === 0 && d.hours === 0 && d.minutes <= 5 ? "pulse" : "",
            custom: P,
            children: x.jsx("span", {
                className: "text-[#0D1013] font-semibold text-base sm:text-lg md:text-xl lg:text-2xl xl:text-[28px] 2xl:text-[32px] leading-[120%] tabular-nums",
                children: g(d.hours)
            })
        }), x.jsx(ee.span, {
            className: "text-[#707070] font-semibold text-xs sm:text-sm md:text-base lg:text-lg xl:text-xl 2xl:text-[24px] leading-[16px]",
            variants: y,
            children: u.hours
        }), x.jsx(ee.div, {
            className: "bg-[#FFFFFF] border border-[#D0D3D7] rounded-[2px] sm:rounded-[3px] md:rounded-[4px] lg:rounded-[5px] py-0.5 sm:py-1 md:py-1.5 lg:py-2 px-1 sm:px-1.5 md:px-2 lg:px-3 min-w-[28px] sm:min-w-[32px] md:min-w-[36px] lg:min-w-[40px] xl:min-w-[44px] flex items-center justify-center",
            variants: y,
            whileHover: {
                scale: 1.05
            },
            animate: d.days === 0 && d.hours === 0 && d.minutes <= 5 ? "pulse" : "",
            custom: P,
            children: x.jsx("span", {
                className: "text-[#0D1013] font-semibold text-base sm:text-lg md:text-xl lg:text-2xl xl:text-[28px] 2xl:text-[32px] leading-[120%] tabular-nums",
                children: g(d.minutes)
            })
        }), x.jsx(ee.span, {
            className: "text-[#707070] font-semibold text-xs sm:text-sm md:text-base lg:text-lg xl:text-xl 2xl:text-[24px] leading-[16px]",
            variants: y,
            children: u.minutes
        })]
    })
}
  , cT = () => {
    try {
        const i = navigator.platform
          , e = navigator.userAgent;
        return i.includes("Win") && !/Windows NT (5|6)\.\d/gi.test(e)
    } catch {
        return !1
    }
}
  , uT = i => {
    const e = {
        en: {
            downloadForWindows: "Download for Windows",
            unsupportedSystem: "Unsupported System"
        },
        es: {
            downloadForWindows: "Descargar para Windows",
            unsupportedSystem: "Sistema no compatible"
        },
        vi: {
            downloadForWindows: "Tải xuống cho Windows",
            unsupportedSystem: "Hệ thống không được hỗ trợ"
        },
        th: {
            downloadForWindows: "ดาวน์โหลดสำหรับ Windows",
            unsupportedSystem: "ระบบไม่ได้รับการสนับสนุน"
        },
        ja: {
            downloadForWindows: "Windows用ダウンロード",
            unsupportedSystem: "サポートされていないシステム"
        },
        ko: {
            downloadForWindows: "Windows용 다운로드",
            unsupportedSystem: "지원되지 않는 시스템"
        },
        "zh-TW": {
            downloadForWindows: "為Windows下載",
            unsupportedSystem: "不受支援的系統"
        },
        ar: {
            downloadForWindows: "تحميل لنظام ويندوز",
            unsupportedSystem: "نظام غير مدعوم"
        },
        bn: {
            downloadForWindows: "Windows-এর জন্য ডাউনলোড",
            unsupportedSystem: "অসমর্থিত সিস্টেম"
        },
        id: {
            downloadForWindows: "Unduh untuk Windows",
            unsupportedSystem: "Sistem Tidak Didukung"
        },
        ka: {
            downloadForWindows: "Windows-ისთვის ჩამოტვირთვა",
            unsupportedSystem: "მხარდაჭერილი სისტემა არაა"
        },
        mn: {
            downloadForWindows: "Windows-д татаж авах",
            unsupportedSystem: "Дэмжихгүй систем"
        },
        tr: {
            downloadForWindows: "Windows için İndir",
            unsupportedSystem: "Desteklenmeyen Sistem"
        },
        pt: {
            downloadForWindows: "Baixar para Windows",
            unsupportedSystem: "Sistema Não Suportado"
        }
    };
    return e[i] || e.en
}
  , dT = ({label: i, className: e=""}) => {
    const {i18n: r} = We()
      , a = r.language
      , o = uT(a)
      , [l,u] = N.useState(null)
      , {openModal: d} = yu()
      , [p,h] = N.useState(!1);
    N.useEffect( () => {
        u(cT())
    }
    , []);
    const g = () => {
        var v;
        l !== !1 && ((v = window.HANDLE_DOWNLOAD) == null || v.call(window),
        d())
    }
    ;
    return x.jsxs("button", {
        onClick: g,
        disabled: l === !1,
        onMouseEnter: () => h(!0),
        onMouseLeave: () => h(!1),
        className: `
        relative w-full flex px-4 items-center justify-center 
        rounded-lg overflow-hidden transition-all duration-300
        py-2 sm:py-3 md:py-4
        text-black font-semibold 
        text-[16px] sm:text-[18px] md:text-[20px] 
        leading-[20px] sm:leading-[22px] md:leading-[24px]
        ${l === !1 ? "cursor-not-allowed opacity-50 !min-w-[220px]" : ""}
        ${p && l !== !1 ? "transform scale-[1.02] shadow-lg" : ""}
        ${e}
      `,
        children: [x.jsx("div", {
            className: `
          absolute inset-0 
          ${l === !1 ? "bg-gray-300" : "bg-white"}
        `
        }), l !== !1 && x.jsx("div", {
            className: `
            absolute inset-0 bg-gray-100
            transition-opacity duration-300 ease-in-out
            ${p ? "opacity-100" : "opacity-0"}
          `
        }), l !== !1 && x.jsx("div", {
            className: `
            absolute inset-0 bg-gradient-to-r from-transparent via-gray-300 to-transparent
            transition-transform duration-500 ease-in-out opacity-30
            ${p ? "translate-x-full" : "-translate-x-full"}
          `,
            style: {
                width: "50%",
                transform: p ? "translateX(200%)" : "translateX(-200%)"
            }
        }), x.jsx("span", {
            className: "relative z-10",
            children: l === !1 ? o.unsupportedSystem : i || o.downloadForWindows
        })]
    })
}
  , gs = i => {
    const e = {
        en: {
            chartsPerTab: "charts per tab",
            indicatorsPerChart: "indicators per chart",
            historicalBars: "historical bars",
            parallelConnections: "parallel chart connections",
            priceAlerts: "price alerts",
            technicalAlerts: "technical alerts",
            watchlistAlerts: "watchlist alerts",
            noAds: "No ads",
            volumeProfile: "Volume profile",
            customTimeframes: "Custom timeframes",
            customRangeBars: "Custom Range Bars",
            multipleWatchlists: "Multiple watchlists",
            barReplay: "Bar Replay",
            indicatorsOnIndicators: "Indicators on indicators",
            chartDataExport: "Chart data export",
            intradayCharts: "Intraday Renko, Kagi, Line Break, Point & Figure charts",
            customFormulas: "Charts based on custom formulas",
            timePriceOpportunity: "Time Price Opportunity",
            volumeFootprint: "Volume footprint",
            volumeCandles: "Volume candles",
            autoChartPatterns: "Auto Chart Patterns",
            secondBasedAlerts: "Second-based alerts",
            nonExpiringAlerts: "Alerts that don't expire",
            inviteOnlyScripts: "Publishing invite-only scripts",
            secondBasedIntervals: "Second-based intervals",
            tickBasedIntervals: "Tick-based intervals (BETA)",
            professionalData: "Ability to buy professional market data",
            prioritySupport: "First priority support"
        },
        pt: {
            chartsPerTab: "gráficos por aba",
            indicatorsPerChart: "indicadores por gráfico",
            historicalBars: "barras históricas",
            parallelConnections: "conexões de gráfico paralelas",
            priceAlerts: "alertas de preço",
            technicalAlerts: "alertas técnicos",
            watchlistAlerts: "alertas de lista de observação",
            noAds: "Sem anúncios",
            volumeProfile: "Perfil de volume",
            customTimeframes: "Intervalos de tempo personalizados",
            customRangeBars: "Barras de intervalo personalizadas",
            multipleWatchlists: "Múltiplas listas de observação",
            barReplay: "Reprodução de barras",
            indicatorsOnIndicators: "Indicadores em indicadores",
            chartDataExport: "Exportação de dados de gráfico",
            intradayCharts: "Gráficos intradiários Renko, Kagi, Line Break, Point & Figure",
            customFormulas: "Gráficos baseados em fórmulas personalizadas",
            timePriceOpportunity: "Oportunidade de Tempo e Preço",
            volumeFootprint: "Rodapé de volume",
            volumeCandles: "Velas de volume",
            autoChartPatterns: "Padrões de Gráfico Automáticos",
            secondBasedAlerts: "Alertas baseados em segundos",
            nonExpiringAlerts: "Alertas que não expiram",
            inviteOnlyScripts: "Publicação de scripts apenas por convite",
            secondBasedIntervals: "Intervalos baseados em segundos",
            tickBasedIntervals: "Intervalos baseados em tick (BETA)",
            professionalData: "Capacidade de comprar dados de mercado profissionais",
            prioritySupport: "Suporte de primeira prioridade"
        },
        ru: {
            chartsPerTab: "графиков на вкладке",
            indicatorsPerChart: "индикаторов на графике",
            historicalBars: "исторических баров",
            parallelConnections: "параллельных подключений графиков",
            priceAlerts: "ценовых оповещений",
            technicalAlerts: "технических оповещений",
            watchlistAlerts: "оповещений для списков наблюдения",
            noAds: "Без рекламы",
            volumeProfile: "Профиль объема",
            customTimeframes: "Пользовательские таймфреймы",
            customRangeBars: "Пользовательские диапазонные бары",
            multipleWatchlists: "Несколько списков наблюдения",
            barReplay: "Воспроизведение баров",
            indicatorsOnIndicators: "Индикаторы на индикаторах",
            chartDataExport: "Экспорт данных графика",
            intradayCharts: "Внутридневные графики Ренко, Каги, Линейный прорыв, Точка и фигура",
            customFormulas: "Графики на основе пользовательских формул",
            timePriceOpportunity: "Временная ценовая возможность",
            volumeFootprint: "Объемный след",
            volumeCandles: "Объемные свечи",
            autoChartPatterns: "Автоматическое распознавание графических моделей",
            secondBasedAlerts: "Секундные оповещения",
            nonExpiringAlerts: "Оповещения без истечения срока действия",
            inviteOnlyScripts: "Публикация скриптов только по приглашению",
            secondBasedIntervals: "Секундные интервалы",
            tickBasedIntervals: "Тиковые интервалы (БЕТА)",
            professionalData: "Возможность покупки профессиональных рыночных данных",
            prioritySupport: "Приоритетная поддержка"
        },
        es: {
            chartsPerTab: "gráficos por pestaña",
            indicatorsPerChart: "indicadores por gráfico",
            historicalBars: "barras históricas",
            parallelConnections: "conexiones de gráficos paralelos",
            priceAlerts: "alertas de precio",
            technicalAlerts: "alertas técnicas",
            watchlistAlerts: "alertas de lista de seguimiento",
            noAds: "Sin anuncios",
            volumeProfile: "Perfil de volumen",
            customTimeframes: "Marcos de tiempo personalizados",
            customRangeBars: "Barras de rango personalizadas",
            multipleWatchlists: "Múltiples listas de seguimiento",
            barReplay: "Reproducción de barras",
            indicatorsOnIndicators: "Indicadores sobre indicadores",
            chartDataExport: "Exportación de datos de gráficos",
            intradayCharts: "Gráficos intradía Renko, Kagi, Line Break, Point & Figure",
            customFormulas: "Gráficos basados en fórmulas personalizadas",
            timePriceOpportunity: "Oportunidad Tiempo-Precio",
            volumeFootprint: "Huella de volumen",
            volumeCandles: "Velas de volumen",
            autoChartPatterns: "Patrones de gráficos automáticos",
            secondBasedAlerts: "Alertas basadas en segundos",
            nonExpiringAlerts: "Alertas que no expiran",
            inviteOnlyScripts: "Publicación de scripts solo por invitación",
            secondBasedIntervals: "Intervalos basados en segundos",
            tickBasedIntervals: "Intervalos basados en ticks (BETA)",
            professionalData: "Capacidad de comprar datos de mercado profesionales",
            prioritySupport: "Soporte de primera prioridad"
        },
        vi: {
            chartsPerTab: "biểu đồ trên mỗi tab",
            indicatorsPerChart: "chỉ báo trên mỗi biểu đồ",
            historicalBars: "thanh lịch sử",
            parallelConnections: "kết nối biểu đồ song song",
            priceAlerts: "cảnh báo giá",
            technicalAlerts: "cảnh báo kỹ thuật",
            watchlistAlerts: "cảnh báo danh sách theo dõi",
            noAds: "Không có quảng cáo",
            volumeProfile: "Hồ sơ khối lượng",
            customTimeframes: "Khung thời gian tùy chỉnh",
            customRangeBars: "Thanh phạm vi tùy chỉnh",
            multipleWatchlists: "Nhiều danh sách theo dõi",
            barReplay: "Phát lại thanh",
            indicatorsOnIndicators: "Chỉ báo trên chỉ báo",
            chartDataExport: "Xuất dữ liệu biểu đồ",
            intradayCharts: "Biểu đồ trong ngày Renko, Kagi, Line Break, Point & Figure",
            customFormulas: "Biểu đồ dựa trên công thức tùy chỉnh",
            timePriceOpportunity: "Cơ hội Thời gian-Giá",
            volumeFootprint: "Dấu chân khối lượng",
            volumeCandles: "Nến khối lượng",
            autoChartPatterns: "Mô hình biểu đồ tự động",
            secondBasedAlerts: "Cảnh báo dựa trên giây",
            nonExpiringAlerts: "Cảnh báo không hết hạn",
            inviteOnlyScripts: "Xuất bản script chỉ dành cho người mời",
            secondBasedIntervals: "Khoảng thời gian dựa trên giây",
            tickBasedIntervals: "Khoảng thời gian dựa trên tick (BETA)",
            professionalData: "Khả năng mua dữ liệu thị trường chuyên nghiệp",
            prioritySupport: "Hỗ trợ ưu tiên hàng đầu"
        },
        th: {
            chartsPerTab: "กราฟต่อแท็บ",
            indicatorsPerChart: "ตัวชี้วัดต่อกราฟ",
            historicalBars: "แถบประวัติ",
            parallelConnections: "การเชื่อมต่อกราฟแบบขนาน",
            priceAlerts: "การแจ้งเตือนราคา",
            technicalAlerts: "การแจ้งเตือนทางเทคนิค",
            watchlistAlerts: "การแจ้งเตือนรายการติดตาม",
            noAds: "ไม่มีโฆษณา",
            volumeProfile: "โปรไฟล์ปริมาณ",
            customTimeframes: "กรอบเวลาแบบกำหนดเอง",
            customRangeBars: "แถบช่วงแบบกำหนดเอง",
            multipleWatchlists: "รายการติดตามหลายรายการ",
            barReplay: "การเล่นแถบซ้ำ",
            indicatorsOnIndicators: "ตัวชี้วัดบนตัวชี้วัด",
            chartDataExport: "การส่งออกข้อมูลกราฟ",
            intradayCharts: "กราฟรายวัน Renko, Kagi, Line Break, Point & Figure",
            customFormulas: "กราฟตามสูตรที่กำหนดเอง",
            timePriceOpportunity: "โอกาสเวลา-ราคา",
            volumeFootprint: "รอยเท้าปริมาณ",
            volumeCandles: "แท่งเทียนปริมาณ",
            autoChartPatterns: "แพทเทิร์นกราฟอัตโนมัติ",
            secondBasedAlerts: "การแจ้งเตือนตามวินาที",
            nonExpiringAlerts: "การแจ้งเตือนที่ไม่หมดอายุ",
            inviteOnlyScripts: "การเผยแพร่สคริปต์เฉพาะผู้ได้รับเชิญ",
            secondBasedIntervals: "ช่วงเวลาแบบวินาที",
            tickBasedIntervals: "ช่วงเวลาแบบติ๊ก (BETA)",
            professionalData: "ความสามารถในการซื้อข้อมูลตลาดมืออาชีพ",
            prioritySupport: "การสนับสนุนที่มีลำดับความสำคัญสูงสุด"
        },
        ja: {
            chartsPerTab: "タブごとのチャート",
            indicatorsPerChart: "チャートごとのインジケーター",
            historicalBars: "履歴バー",
            parallelConnections: "並列チャート接続",
            priceAlerts: "価格アラート",
            technicalAlerts: "テクニカルアラート",
            watchlistAlerts: "ウォッチリストアラート",
            noAds: "広告なし",
            volumeProfile: "出来高プロファイル",
            customTimeframes: "カスタム時間枠",
            customRangeBars: "カスタムレンジバー",
            multipleWatchlists: "複数のウォッチリスト",
            barReplay: "バー再生",
            indicatorsOnIndicators: "インジケーター上のインジケーター",
            chartDataExport: "チャートデータのエクスポート",
            intradayCharts: "日中 Renko、Kagi、Line Break、Point & Figure チャート",
            customFormulas: "カスタムフォーミュラに基づくチャート",
            timePriceOpportunity: "時間価格機会",
            volumeFootprint: "出来高フットプリント",
            volumeCandles: "出来高キャンドル",
            autoChartPatterns: "自動チャートパターン",
            secondBasedAlerts: "秒単位のアラート",
            nonExpiringAlerts: "期限切れしないアラート",
            inviteOnlyScripts: "招待制スクリプトの公開",
            secondBasedIntervals: "秒単位のインターバル",
            tickBasedIntervals: "ティック単位のインターバル (BETA)",
            professionalData: "プロフェッショナル市場データの購入機能",
            prioritySupport: "優先サポート"
        },
        ko: {
            chartsPerTab: "탭당 차트",
            indicatorsPerChart: "차트당 인디케이터",
            historicalBars: "히스토리 바",
            parallelConnections: "병렬 차트 연결",
            priceAlerts: "가격 경고",
            technicalAlerts: "기술적 경고",
            watchlistAlerts: "관심 종목 경고",
            noAds: "광고 없음",
            volumeProfile: "거래량 프로파일",
            customTimeframes: "사용자 지정 시간 프레임",
            customRangeBars: "사용자 지정 범위 바",
            multipleWatchlists: "다중 관심 종목 목록",
            barReplay: "바 재생",
            indicatorsOnIndicators: "인디케이터 상의 인디케이터",
            chartDataExport: "차트 데이터 내보내기",
            intradayCharts: "일중 Renko, Kagi, Line Break, Point & Figure 차트",
            customFormulas: "사용자 지정 수식 기반 차트",
            timePriceOpportunity: "시간-가격 기회",
            volumeFootprint: "거래량 풋프린트",
            volumeCandles: "거래량 캔들",
            autoChartPatterns: "자동 차트 패턴",
            secondBasedAlerts: "초 단위 경고",
            nonExpiringAlerts: "만료되지 않는 경고",
            inviteOnlyScripts: "초대 전용 스크립트 게시",
            secondBasedIntervals: "초 단위 간격",
            tickBasedIntervals: "틱 단위 간격 (BETA)",
            professionalData: "전문 시장 데이터 구매 기능",
            prioritySupport: "우선 지원"
        },
        "zh-TW": {
            chartsPerTab: "每個標籤的圖表",
            indicatorsPerChart: "每個圖表的指標",
            historicalBars: "歷史柱",
            parallelConnections: "平行圖表連接",
            priceAlerts: "價格警報",
            technicalAlerts: "技術警報",
            watchlistAlerts: "觀察列表警報",
            noAds: "無廣告",
            volumeProfile: "成交量剖面",
            customTimeframes: "自訂時間框架",
            customRangeBars: "自訂範圍柱",
            multipleWatchlists: "多個觀察列表",
            barReplay: "柱重播",
            indicatorsOnIndicators: "指標上的指標",
            chartDataExport: "圖表數據導出",
            intradayCharts: "日內 Renko、Kagi、Line Break、Point & Figure 圖表",
            customFormulas: "基於自訂公式的圖表",
            timePriceOpportunity: "時間價格機會",
            volumeFootprint: "成交量足跡",
            volumeCandles: "成交量蠟燭",
            autoChartPatterns: "自動圖表模式",
            secondBasedAlerts: "基於秒的警報",
            nonExpiringAlerts: "永不過期的警報",
            inviteOnlyScripts: "僅限邀請腳本發佈",
            secondBasedIntervals: "基於秒的間隔",
            tickBasedIntervals: "基於tick的間隔 (BETA)",
            professionalData: "購買專業市場數據的能力",
            prioritySupport: "優先支持"
        },
        ar: {
            chartsPerTab: "الرسوم البيانية لكل تبويب",
            indicatorsPerChart: "المؤشرات لكل رسم بياني",
            historicalBars: "الأشرطة التاريخية",
            parallelConnections: "اتصالات الرسوم البيانية المتوازية",
            priceAlerts: "تنبيهات الأسعار",
            technicalAlerts: "تنبيهات فنية",
            watchlistAlerts: "تنبيهات قائمة المراقبة",
            noAds: "بدون إعلانات",
            volumeProfile: "ملف الحجم",
            customTimeframes: "الإطارات الزمنية المخصصة",
            customRangeBars: "أشرطة النطاق المخصصة",
            multipleWatchlists: "قوائم مراقبة متعددة",
            barReplay: "إعادة تشغيل الشريط",
            indicatorsOnIndicators: "مؤشرات على مؤشرات",
            chartDataExport: "تصدير بيانات الرسم البياني",
            intradayCharts: "الرسوم البيانية اليومية Renko، Kagi، Line Break، Point & Figure",
            customFormulas: "الرسوم البيانية بناءً على صيغ مخصصة",
            timePriceOpportunity: "فرصة الوقت والسعر",
            volumeFootprint: "بصمة الحجم",
            volumeCandles: "شموع الحجم",
            autoChartPatterns: "أنماط الرسوم البيانية التلقائية",
            secondBasedAlerts: "تنبيهات بناءً على الثواني",
            nonExpiringAlerts: "تنبيهات لا تنتهي",
            inviteOnlyScripts: "نشر نصوص مدعو فقط",
            secondBasedIntervals: "الفواصل بناءً على الثواني",
            tickBasedIntervals: "الفواصل بناءً على التيك (BETA)",
            professionalData: "القدرة على شراء بيانات السوق المهنية",
            prioritySupport: "دعم الأولوية الأولى"
        },
        bn: {
            chartsPerTab: "প্রতি ট্যাবে চার্ট",
            indicatorsPerChart: "প্রতি চার্টে সূচক",
            historicalBars: "ইতিহাসিক বার",
            parallelConnections: "সমান্তরাল চার্ট সংযোগ",
            priceAlerts: "মূল্য সতর্কতা",
            technicalAlerts: "প্রযুক্তিগত সতর্কতা",
            watchlistAlerts: "অনুসরণ তালিকা সতর্কতা",
            noAds: "কোনো বিজ্ঞাপন নেই",
            volumeProfile: "পরিমাণ প্রোফাইল",
            customTimeframes: "কাস্টম টাইমফ্রেম",
            customRangeBars: "কাস্টম রেঞ্জ বার",
            multipleWatchlists: "একাধিক অনুসরণ তালিকা",
            barReplay: "বার রিপ্লে",
            indicatorsOnIndicators: "সূচকের উপর সূচক",
            chartDataExport: "চার্ট ডেটা রপ্তানি",
            intradayCharts: "ইন্ট্রাডে Renko, Kagi, Line Break, Point & Figure চার্ট",
            customFormulas: "কাস্টম ফর্মুলা ভিত্তিক চার্ট",
            timePriceOpportunity: "সময়-মূল্য সুযোগ",
            volumeFootprint: "পরিমাণ ফুটপ্রিন্ট",
            volumeCandles: "পরিমাণ ক্যান্ডল",
            autoChartPatterns: "স্বয়ংক্রিয় চার্ট প্যাটার্ন",
            secondBasedAlerts: "সেকেন্ড-ভিত্তিক সতর্কতা",
            nonExpiringAlerts: "মেয়াদ উত্তীর্ণ না হওয়া সতর্কতা",
            inviteOnlyScripts: "কেবল আমন্ত্রিত স্ক্রিপ্ট প্রকাশ",
            secondBasedIntervals: "সেকেন্ড-ভিত্তিক ব্যবধান",
            tickBasedIntervals: "টিক-ভিত্তিক ব্যবধান (BETA)",
            professionalData: "পেশাদার বাজার ডেটা কেনার ক্ষমতা",
            prioritySupport: "প্রথম অগ্রাধিকার সমর্থন"
        },
        id: {
            chartsPerTab: "grafik per tab",
            indicatorsPerChart: "indikator per grafik",
            historicalBars: "bar historis",
            parallelConnections: "koneksi grafik paralel",
            priceAlerts: "pemberitahuan harga",
            technicalAlerts: "pemberitahuan teknis",
            watchlistAlerts: "pemberitahuan daftar pantau",
            noAds: "Tanpa iklan",
            volumeProfile: "Profil volume",
            customTimeframes: "Kerangka waktu kustom",
            customRangeBars: "Bar rentang kustom",
            multipleWatchlists: "Beberapa daftar pantau",
            barReplay: "Putar ulang bar",
            indicatorsOnIndicators: "Indikator pada indikator",
            chartDataExport: "Ekspor data grafik",
            intradayCharts: "Grafik intraday Renko, Kagi, Line Break, Point & Figure",
            customFormulas: "Grafik berdasarkan rumus kustom",
            timePriceOpportunity: "Peluang Waktu-Harga",
            volumeFootprint: "Jejak volume",
            volumeCandles: "Lilin volume",
            autoChartPatterns: "Pola grafik otomatis",
            secondBasedAlerts: "Pemberitahuan berbasis detik",
            nonExpiringAlerts: "Pemberitahuan yang tidak kedaluwarsa",
            inviteOnlyScripts: "Penerbitan skrip hanya undangan",
            secondBasedIntervals: "Interval berbasis detik",
            tickBasedIntervals: "Interval berbasis tik (BETA)",
            professionalData: "Kemampuan membeli data pasar profesional",
            prioritySupport: "Dukungan prioritas pertama"
        },
        ka: {
            chartsPerTab: "ტაბზე გრაფიკები",
            indicatorsPerChart: "გრაფიკზე ინდიკატორები",
            historicalBars: "ისტორიული ზოლები",
            parallelConnections: "პარალელური გრაფიკების კავშირები",
            priceAlerts: "ფასის შეტყობინებები",
            technicalAlerts: "ტექნიკური შეტყობინებები",
            watchlistAlerts: "დაკვირვების სიის შეტყობინებები",
            noAds: "რეკლამის გარეშე",
            volumeProfile: "მოცულობის პროფილი",
            customTimeframes: "მორგებული დროის ჩარჩოები",
            customRangeBars: "მორგებული დიაპაზონის ზოლები",
            multipleWatchlists: "მრავალჯერადი დაკვირვების სიები",
            barReplay: "ზოლის გადაღება",
            indicatorsOnIndicators: "ინდიკატორები ინდიკატორებზე",
            chartDataExport: "გრაფიკის მონაცემების ექსპორტი",
            intradayCharts: "დღის განმავლობაში Renko, Kagi, Line Break, Point & Figure გრაფიკები",
            customFormulas: "მორგებული ფორმულებზე დაფუძნებული გრაფიკები",
            timePriceOpportunity: "დროისა და ფასის შესაძლებლობა",
            volumeFootprint: "მოცულობის კვალი",
            volumeCandles: "მოცულობის სანთლები",
            autoChartPatterns: "ავტომატური გრაფიკის ფორმები",
            secondBasedAlerts: "წამებზე დაფუძნებული შეტყობინებები",
            nonExpiringAlerts: "ვადაგასული შეტყობინებები",
            inviteOnlyScripts: "მხოლოდ მოწვეულთათვის სკრიპტების გამოქვეყნება",
            secondBasedIntervals: "წამებზე დაფუძნებული ინტერვალები",
            tickBasedIntervals: "ტიკებზე დაფუძნებული ინტერვალები (BETA)",
            professionalData: "პროფესიონალური ბაზრის მონაცემების შეძენის შესაძლებლობა",
            prioritySupport: "პირველი პრიორიტეტის მხარდაჭერა"
        },
        mn: {
            chartsPerTab: "таб бүр дэх график",
            indicatorsPerChart: "график бүр дэх индикатор",
            historicalBars: "түүхийн багана",
            parallelConnections: "параллел график холболт",
            priceAlerts: "Үнийн мэдээлэл",
            technicalAlerts: "Техникийн мэдээлэл",
            watchlistAlerts: "Хянах жагсаалтын мэдээлэл",
            noAds: "Заалгынгүй",
            volumeProfile: "Бүрэлдэхүүн хэмжээний профайл",
            customTimeframes: "Хэрэглэгчийн цаг хугацааны хүрээ",
            customRangeBars: "Хэрэглэгчийн хүрээний багана",
            multipleWatchlists: "Олон хянах жагсаалт",
            barReplay: "Багана дахин тоглуулах",
            indicatorsOnIndicators: "Индикатор дээрх индикатор",
            chartDataExport: "График мэдээлэл экспортлох",
            intradayCharts: "Өдрийн доторх Renko, Kagi, Line Break, Point & Figure график",
            customFormulas: "Хэрэглэгчийн томъёо дээр суурилсан график",
            timePriceOpportunity: "Цаг хугацаа-Үнийн боломж",
            volumeFootprint: "Бүрэлдэхүүн хэмжээний ул мөр",
            volumeCandles: "Бүрэлдэхүүн хэмжээний тодорхойлолт",
            autoChartPatterns: "Автомат график загвар",
            secondBasedAlerts: "Секунд дээр суурилсан мэдээлэл",
            nonExpiringAlerts: "Хугацаа дуусахгүй мэдээлэл",
            inviteOnlyScripts: "Зөвхөн урилгаар скрипт нийтлэх",
            secondBasedIntervals: "Секунд дээр суурилсан интервал",
            tickBasedIntervals: "Тик дээр суурилсан интервал (BETA)",
            professionalData: "Профессионал зах зээлийн мэдээлэл худалдан авах боломж",
            prioritySupport: "Эхний тэргүүлэх дэмжлэг"
        },
        tr: {
            chartsPerTab: "her sekmedeki grafikler",
            indicatorsPerChart: "her grafikteki göstergeler",
            historicalBars: "tarihsel çubuklar",
            parallelConnections: "paralel grafik bağlantıları",
            priceAlerts: "fiyat uyarıları",
            technicalAlerts: "teknik uyarılar",
            watchlistAlerts: "izleme listesi uyarıları",
            noAds: "Reklamsız",
            volumeProfile: "Hacim profili",
            customTimeframes: "Özel zaman dilimleri",
            customRangeBars: "Özel aralık çubukları",
            multipleWatchlists: "Çoklu izleme listeleri",
            barReplay: "Çubuk tekrar oynatma",
            indicatorsOnIndicators: "Göstergeler üzerinde göstergeler",
            chartDataExport: "Grafik veri dışa aktarma",
            intradayCharts: "Gün içi Renko, Kagi, Line Break, Point & Figure grafikler",
            customFormulas: "Özel formüllere dayalı grafikler",
            timePriceOpportunity: "Zaman-Fiyat Fırsatı",
            volumeFootprint: "Hacim izi",
            volumeCandles: "Hacim mumları",
            autoChartPatterns: "Otomatik grafik kalıpları",
            secondBasedAlerts: "Saniye bazlı uyarılar",
            nonExpiringAlerts: "Süresi dolmayan uyarılar",
            inviteOnlyScripts: "Yalnızca davetli script yayınlama",
            secondBasedIntervals: "Saniye bazlı aralıklar",
            tickBasedIntervals: "Tik bazlı aralıklar (BETA)",
            professionalData: "Profesyonel piyasa verileri satın alma yeteneği",
            prioritySupport: "Birinci öncelik desteği"
        },
        sq: {
            chartsPerTab: "grafikë për skedë",
            indicatorsPerChart: "indikatorë për grafik",
            historicalBars: "shufra historike",
            parallelConnections: "lidhje paralele grafikësh",
            priceAlerts: "alarme çmimi",
            technicalAlerts: "alarme teknike",
            watchlistAlerts: "alarme liste vëzhgimi",
            noAds: "Pa reklama",
            volumeProfile: "Profili i vëllimit",
            customTimeframes: "Kornizat kohore të personalizuara",
            customRangeBars: "Shufrat e diapazonit të personalizuar",
            multipleWatchlists: "Lista të shumta vëzhgimi",
            barReplay: "Përsëritje e shufrave",
            indicatorsOnIndicators: "Indikatorë mbi indikatorë",
            chartDataExport: "Eksport të dhënash grafikësh",
            intradayCharts: "Grafikë ditore Renko, Kagi, Line Break, Point & Figure",
            customFormulas: "Grafikë të bazuar në formula të personalizuara",
            timePriceOpportunity: "Mundësi Kohë-Çmim",
            volumeFootprint: "Gjurmë vëllimi",
            volumeCandles: "Qirinj vëllimi",
            autoChartPatterns: "Modele automatike grafikësh",
            secondBasedAlerts: "Alarme të bazuara në sekonda",
            nonExpiringAlerts: "Alarme që nuk skadojnë",
            inviteOnlyScripts: "Publikim i skripteve vetëm me ftesë",
            secondBasedIntervals: "Intervale të bazuara në sekonda",
            tickBasedIntervals: "Intervale të bazuara në tick (BETA)",
            professionalData: "Aftësia për të blerë të dhëna profesionale tregu",
            prioritySupport: "Mbështetje me prioritet të parë"
        },
        bs: {
            chartsPerTab: "grafikona po kartici",
            indicatorsPerChart: "indikatora po grafikonu",
            historicalBars: "istorijskih traka",
            parallelConnections: "paralelnih veza grafikona",
            priceAlerts: "cenovna upozorenja",
            technicalAlerts: "tehnička upozorenja",
            watchlistAlerts: "upozorenja liste praćenja",
            noAds: "Bez reklama",
            volumeProfile: "Profil volumena",
            customTimeframes: "Prilagođeni vremenski okviri",
            customRangeBars: "Prilagođene trake raspona",
            multipleWatchlists: "Višestruke liste praćenja",
            barReplay: "Ponavljanje traka",
            indicatorsOnIndicators: "Indikatori na indikatorima",
            chartDataExport: "Izvoz podataka grafikona",
            intradayCharts: "Unutardnevni Renko, Kagi, Line Break, Point & Figure grafikoni",
            customFormulas: "Grafikoni bazirani na prilagođenim formulama",
            timePriceOpportunity: "Prilika Vrijeme-Cijena",
            volumeFootprint: "Otisak volumena",
            volumeCandles: "Svijeće volumena",
            autoChartPatterns: "Automatski obrasci grafikona",
            secondBasedAlerts: "Upozorenja bazirana na sekundama",
            nonExpiringAlerts: "Upozorenja koja ne istječu",
            inviteOnlyScripts: "Objavljivanje skripti samo na poziv",
            secondBasedIntervals: "Intervali bazirani na sekundama",
            tickBasedIntervals: "Intervali bazirani na tick-u (BETA)",
            professionalData: "Mogućnost kupovine profesionalnih tržišnih podataka",
            prioritySupport: "Podrška prvog prioriteta"
        },
        bg: {
            chartsPerTab: "графики на раздел",
            indicatorsPerChart: "индикатори на графика",
            historicalBars: "исторически барове",
            parallelConnections: "паралелни връзки на графики",
            priceAlerts: "ценови известия",
            technicalAlerts: "технически известия",
            watchlistAlerts: "известия за списък за наблюдение",
            noAds: "Без реклами",
            volumeProfile: "Профил на обем",
            customTimeframes: "Персонализирани времеви рамки",
            customRangeBars: "Персонализирани барове на обхват",
            multipleWatchlists: "Множество списъци за наблюдение",
            barReplay: "Повторно възпроизвеждане на барове",
            indicatorsOnIndicators: "Индикатори върху индикатори",
            chartDataExport: "Експорт на данни от графики",
            intradayCharts: "Вътредневни Renko, Kagi, Line Break, Point & Figure графики",
            customFormulas: "Графики базирани на персонализирани формули",
            timePriceOpportunity: "Възможност Време-Цена",
            volumeFootprint: "Отпечатък на обем",
            volumeCandles: "Свещи на обем",
            autoChartPatterns: "Автоматични модели на графики",
            secondBasedAlerts: "Известия базирани на секунди",
            nonExpiringAlerts: "Известия които не изтичат",
            inviteOnlyScripts: "Публикуване на скриптове само с покана",
            secondBasedIntervals: "Интервали базирани на секунди",
            tickBasedIntervals: "Интервали базирани на тик (BETA)",
            professionalData: "Възможност за купуване на професионални пазарни данни",
            prioritySupport: "Поддръжка с първи приоритет"
        },
        hr: {
            chartsPerTab: "grafikona po kartici",
            indicatorsPerChart: "indikatora po grafikonu",
            historicalBars: "povijesnih traka",
            parallelConnections: "paralelnih veza grafikona",
            priceAlerts: "cjenovna upozorenja",
            technicalAlerts: "tehnička upozorenja",
            watchlistAlerts: "upozorenja liste praćenja",
            noAds: "Bez reklama",
            volumeProfile: "Profil volumena",
            customTimeframes: "Prilagođeni vremenski okviri",
            customRangeBars: "Prilagođene trake raspona",
            multipleWatchlists: "Višestruke liste praćenja",
            barReplay: "Ponavljanje traka",
            indicatorsOnIndicators: "Indikatori na indikatorima",
            chartDataExport: "Izvoz podataka grafikona",
            intradayCharts: "Unutardnevni Renko, Kagi, Line Break, Point & Figure grafikoni",
            customFormulas: "Grafikoni bazirani na prilagođenim formulama",
            timePriceOpportunity: "Prilika Vrijeme-Cijena",
            volumeFootprint: "Otisak volumena",
            volumeCandles: "Svijeće volumena",
            autoChartPatterns: "Automatski obrasci grafikona",
            secondBasedAlerts: "Upozorenja bazirana na sekundama",
            nonExpiringAlerts: "Upozorenja koja ne istječu",
            inviteOnlyScripts: "Objavljivanje skripti samo na poziv",
            secondBasedIntervals: "Intervali bazirani na sekundama",
            tickBasedIntervals: "Intervali bazirani na tick-u (BETA)",
            professionalData: "Mogućnost kupovine profesionalnih tržišnih podataka",
            prioritySupport: "Podrška prvog prioriteta"
        },
        sr: {
            chartsPerTab: "графикона по картици",
            indicatorsPerChart: "индикатора по графикону",
            historicalBars: "историјских трака",
            parallelConnections: "паралелних веза графикона",
            priceAlerts: "ценовна упозорења",
            technicalAlerts: "техничка упозорења",
            watchlistAlerts: "упозорења листе праћења",
            noAds: "Без реклама",
            volumeProfile: "Профил волумена",
            customTimeframes: "Прилагођени временски оквири",
            customRangeBars: "Прилагођене траке распона",
            multipleWatchlists: "Вишеструке листе праћења",
            barReplay: "Понављање трака",
            indicatorsOnIndicators: "Индикатори на индикаторима",
            chartDataExport: "Извоз података графикона",
            intradayCharts: "Унутардневни Renko, Kagi, Line Break, Point & Figure графикони",
            customFormulas: "Графикони базирани на прилагођеним формулама",
            timePriceOpportunity: "Прилика Време-Цена",
            volumeFootprint: "Отисак волумена",
            volumeCandles: "Свеће волумена",
            autoChartPatterns: "Аутоматски обрасци графикона",
            secondBasedAlerts: "Упозорења базирана на секундама",
            nonExpiringAlerts: "Упозорења која не истичу",
            inviteOnlyScripts: "Објављивање скрипти само на позив",
            secondBasedIntervals: "Интервали базирани на секундама",
            tickBasedIntervals: "Интервали базирани на тик-у (BETA)",
            professionalData: "Могућност куповине професионалних тржишних података",
            prioritySupport: "Подршка првог приоритета"
        },
        sl: {
            chartsPerTab: "grafikonov na zavihek",
            indicatorsPerChart: "indikatorjev na grafikon",
            historicalBars: "zgodovinskih vrstic",
            parallelConnections: "vzporednih povezav grafikonov",
            priceAlerts: "cenovna opozorila",
            technicalAlerts: "tehnična opozorila",
            watchlistAlerts: "opozorila seznama opazovanih",
            noAds: "Brez oglasov",
            volumeProfile: "Profil obsega",
            customTimeframes: "Prilagojeni časovni okviri",
            customRangeBars: "Prilagojene vrstice obsega",
            multipleWatchlists: "Več seznamov opazovanih",
            barReplay: "Predvajanje vrstic",
            indicatorsOnIndicators: "Indikatorji na indikatorjih",
            chartDataExport: "Izvoz podatkov grafikona",
            intradayCharts: "Znotrajdnevni Renko, Kagi, Line Break, Point & Figure grafikoni",
            customFormulas: "Grafikoni na osnovi prilagojenih formul",
            timePriceOpportunity: "Časovno-cenovna priložnost",
            volumeFootprint: "Odtis obsega",
            volumeCandles: "Obsegne sveče",
            autoChartPatterns: "Samodejni vzorci grafikonov",
            secondBasedAlerts: "Opozorila na osnovi sekund",
            nonExpiringAlerts: "Opozorila, ki ne potečejo",
            inviteOnlyScripts: "Objavljanje skriptov samo na povabilo",
            secondBasedIntervals: "Intervali na osnovi sekund",
            tickBasedIntervals: "Intervali na osnovi tikov (BETA)",
            professionalData: "Možnost nakupa profesionalnih tržnih podatkov",
            prioritySupport: "Prednostna podpora"
        },
        sk: {
            chartsPerTab: "grafov na záložku",
            indicatorsPerChart: "indikátorov na graf",
            historicalBars: "historických stĺpcov",
            parallelConnections: "paralelných grafových spojení",
            priceAlerts: "cenových upozornení",
            technicalAlerts: "technických upozornení",
            watchlistAlerts: "upozornení sledovacieho zoznamu",
            noAds: "Bez reklám",
            volumeProfile: "Objemový profil",
            customTimeframes: "Vlastné časové rámce",
            customRangeBars: "Vlastné rozsahové stĺpce",
            multipleWatchlists: "Viacnásobné sledovacie zoznamy",
            barReplay: "Opakovanie stĺpcov",
            indicatorsOnIndicators: "Indikátory na indikátoroch",
            chartDataExport: "Export údajov grafov",
            intradayCharts: "Vnútrodenné Renko, Kagi, Line Break, Point & Figure grafy",
            customFormulas: "Grafy založené na vlastných vzorcoch",
            timePriceOpportunity: "Príležitosť Čas-Cena",
            volumeFootprint: "Otisk objemu",
            volumeCandles: "Sviečky objemu",
            autoChartPatterns: "Automatické vzory grafov",
            secondBasedAlerts: "Upozornenia založené na sekundách",
            nonExpiringAlerts: "Upozornenia ktoré nevypršia",
            inviteOnlyScripts: "Publikovanie skriptov len na pozvanie",
            secondBasedIntervals: "Intervaly založené na sekundách",
            tickBasedIntervals: "Intervaly založené na tick-u (BETA)",
            professionalData: "Možnosť nákupu profesionálnych tržných údajov",
            prioritySupport: "Podpora prvej priority"
        },
        ro: {
            chartsPerTab: "grafice pe filă",
            indicatorsPerChart: "indicatori pe grafic",
            historicalBars: "bare istorice",
            parallelConnections: "conexiuni paralele de grafice",
            priceAlerts: "alerte de preț",
            technicalAlerts: "alerte tehnice",
            watchlistAlerts: "alerte listă de urmărire",
            noAds: "Fără reclame",
            volumeProfile: "Profil volum",
            customTimeframes: "Intervale de timp personalizate",
            customRangeBars: "Bare de interval personalizate",
            multipleWatchlists: "Liste de urmărire multiple",
            barReplay: "Reluarea barelor",
            indicatorsOnIndicators: "Indicatori pe indicatori",
            chartDataExport: "Export date grafice",
            intradayCharts: "Grafice intraday Renko, Kagi, Line Break, Point & Figure",
            customFormulas: "Grafice bazate pe formule personalizate",
            timePriceOpportunity: "Oportunitate Timp-Preț",
            volumeFootprint: "Amprentă volum",
            volumeCandles: "Lumânări volum",
            autoChartPatterns: "Modele automate de grafice",
            secondBasedAlerts: "Alerte bazate pe secunde",
            nonExpiringAlerts: "Alerte care nu expiră",
            inviteOnlyScripts: "Publicarea scripturilor doar prin invitație",
            secondBasedIntervals: "Intervale bazate pe secunde",
            tickBasedIntervals: "Intervale bazate pe tick (BETA)",
            professionalData: "Capacitatea de a cumpăra date profesionale de piață",
            prioritySupport: "Suport de primă prioritate"
        },
        mk: {
            chartsPerTab: "графици по картичка",
            indicatorsPerChart: "индикатори по график",
            historicalBars: "историски ленти",
            parallelConnections: "паралелни врски на графици",
            priceAlerts: "ценовни предупредувања",
            technicalAlerts: "технички предупредувања",
            watchlistAlerts: "предупредувања од листа за следење",
            noAds: "Без реклами",
            volumeProfile: "Профил на волумен",
            customTimeframes: "Приспособени временски рамки",
            customRangeBars: "Приспособени ленти на опсег",
            multipleWatchlists: "Повеќе листи за следење",
            barReplay: "Повторно пуштање на ленти",
            indicatorsOnIndicators: "Индикатори на индикатори",
            chartDataExport: "Извоз на податоци од графици",
            intradayCharts: "Внатредневни Renko, Kagi, Line Break, Point & Figure графици",
            customFormulas: "Графици базирани на приспособени формули",
            timePriceOpportunity: "Можност Време-Цена",
            volumeFootprint: "Отпечаток на волумен",
            volumeCandles: "Свеќи на волумен",
            autoChartPatterns: "Автоматски обрасци на графици",
            secondBasedAlerts: "Предупредувања базирани на секунди",
            nonExpiringAlerts: "Предупредувања што не истекуваат",
            inviteOnlyScripts: "Објавување на скрипти само со покана",
            secondBasedIntervals: "Интервали базирани на секунди",
            tickBasedIntervals: "Интервали базирани на тик (BETA)",
            professionalData: "Можност за купување професионални пазарни податоци",
            prioritySupport: "Поддршка со прв приоритет"
        },
        me: {
            chartsPerTab: "графикона по картици",
            indicatorsPerChart: "индикатора по графикону",
            historicalBars: "историјских трака",
            parallelConnections: "паралелних веза графикона",
            priceAlerts: "ценовна упозорења",
            technicalAlerts: "техничка упозорења",
            watchlistAlerts: "упозорења листе праћења",
            noAds: "Без реклама",
            volumeProfile: "Профил волумена",
            customTimeframes: "Прилагођени временски оквири",
            customRangeBars: "Прилагођене траке распона",
            multipleWatchlists: "Вишеструке листе праћења",
            barReplay: "Понављање трака",
            indicatorsOnIndicators: "Индикатори на индикаторима",
            chartDataExport: "Извоз података графикона",
            intradayCharts: "Унутардневни Renko, Kagi, Line Break, Point & Figure графикони",
            customFormulas: "Графикони базирани на прилагођеним формулама",
            timePriceOpportunity: "Прилика Вријеме-Цијена",
            volumeFootprint: "Отисак волумена",
            volumeCandles: "Свијеће волумена",
            autoChartPatterns: "Аутоматски обрасци графикона",
            secondBasedAlerts: "Упозорења базирана на секундама",
            nonExpiringAlerts: "Упозорења која не истичу",
            inviteOnlyScripts: "Објављивање скрипти само на позив",
            secondBasedIntervals: "Интервали базирани на секундама",
            tickBasedIntervals: "Интервали базирани на тик-у (BETA)",
            professionalData: "Могућност куповине професионалних тржишних података",
            prioritySupport: "Подршка првог приоритета"
        },
        md: {
            chartsPerTab: "grafice pe filă",
            indicatorsPerChart: "indicatori pe grafic",
            historicalBars: "bare istorice",
            parallelConnections: "conexiuni paralele de grafice",
            priceAlerts: "alerte de preț",
            technicalAlerts: "alerte tehnice",
            watchlistAlerts: "alerte listă de urmărire",
            noAds: "Fără reclame",
            volumeProfile: "Profil volum",
            customTimeframes: "Intervale de timp personalizate",
            customRangeBars: "Bare de interval personalizate",
            multipleWatchlists: "Liste de urmărire multiple",
            barReplay: "Reluarea barelor",
            indicatorsOnIndicators: "Indicatori pe indicatori",
            chartDataExport: "Export date grafice",
            intradayCharts: "Grafice intraday Renko, Kagi, Line Break, Point & Figure",
            customFormulas: "Grafice bazate pe formule personalizate",
            timePriceOpportunity: "Oportunitate Timp-Preț",
            volumeFootprint: "Amprentă volum",
            volumeCandles: "Lumânări volum",
            autoChartPatterns: "Modele automate de grafice",
            secondBasedAlerts: "Alerte bazate pe secunde",
            nonExpiringAlerts: "Alerte care nu expiră",
            inviteOnlyScripts: "Publicarea scripturilor doar prin invitație",
            secondBasedIntervals: "Intervale bazate pe secunde",
            tickBasedIntervals: "Intervale bazate pe tick (BETA)",
            professionalData: "Capacitatea de a cumpăra date profesionale de piață",
            prioritySupport: "Suport de primă prioritate"
        },
        by: {
            chartsPerTab: "графікаў на ўкладку",
            indicatorsPerChart: "індыкатараў на графік",
            historicalBars: "гістарычных слупкоў",
            parallelConnections: "паралельных злучэнняў графікаў",
            priceAlerts: "каштоўных абвестак",
            technicalAlerts: "тэхнічных абвестак",
            watchlistAlerts: "абвестак спіса назірання",
            noAds: "Без рэкламы",
            volumeProfile: "Профіль аб'ёму",
            customTimeframes: "Наладжаныя часавыя рамкі",
            customRangeBars: "Наладжаныя слупкі дыяпазону",
            multipleWatchlists: "Некалькі спісаў назірання",
            barReplay: "Паўтор слупкоў",
            indicatorsOnIndicators: "Індыкатары на індыкатарах",
            chartDataExport: "Экспарт даных графікаў",
            intradayCharts: "Унутрыдзённыя Renko, Kagi, Line Break, Point & Figure графікі",
            customFormulas: "Графікі на аснове наладжаных формул",
            timePriceOpportunity: "Магчымасць Час-Цана",
            volumeFootprint: "Адбітак аб'ёму",
            volumeCandles: "Свечкі аб'ёму",
            autoChartPatterns: "Аўтаматычныя ўзоры графікаў",
            secondBasedAlerts: "Абвесткі на аснове секундаў",
            nonExpiringAlerts: "Абвесткі якія не сканчаюцца",
            inviteOnlyScripts: "Публікацыя скрыптоў толькі па запрашэнні",
            secondBasedIntervals: "Інтэрвалы на аснове секундаў",
            tickBasedIntervals: "Інтэрвалы на аснове цікаў (BETA)",
            professionalData: "Магчымасць пакупкі прафесійных рыначных даных",
            prioritySupport: "Падтрымка першага прыярытэту"
        }
    };
    return e[i] || e.en
}
  , pT = i => {
    const e = {
        en: {
            title: "Get Free Ultimate Plan On TradingView Desktop",
            ultimate: "Ultimate",
            yearlyPrice: "2,399.40 / Year",
            free: "Free",
            downloadButton: "Download for Windows",
            showMore: "Show {count} more features",
            showLess: "Show less"
        },
        pt: {
            title: "Obtenha o Plano Ultimate Grátis no TradingView Desktop",
            ultimate: "Ultimate",
            yearlyPrice: "2.399,40 / Ano",
            free: "Grátis",
            downloadButton: "Baixar para Windows",
            showMore: "Mostrar mais {count} recursos",
            showLess: "Mostrar menos"
        },
        es: {
            title: "Obtén el Plan Ultimate Gratis en TradingView Desktop",
            ultimate: "Ultimate",
            yearlyPrice: "2.399,40 / Año",
            free: "Gratis",
            downloadButton: "Descargar para Windows",
            showMore: "Mostrar {count} características más",
            showLess: "Mostrar menos"
        },
        vi: {
            title: "Nhận Gói Ultimate Miễn Phí Trên TradingView Desktop",
            ultimate: "Ultimate",
            yearlyPrice: "2.399,40 / Năm",
            free: "Miễn Phí",
            downloadButton: "Tải về cho Windows",
            showMore: "Hiển thị thêm {count} tính năng",
            showLess: "Ẩn bớt"
        },
        th: {
            title: "รับแผน Ultimate ฟรีบน TradingView Desktop",
            ultimate: "Ultimate",
            yearlyPrice: "2,399.40 / ปี",
            free: "ฟรี",
            downloadButton: "ดาวน์โหลดสำหรับ Windows",
            showMore: "แสดงเพิ่มอีก {count} ฟีเจอร์",
            showLess: "แสดงน้อยลง"
        },
        ja: {
            title: "TradingView デスクトップで Ultimate プランを無料で取得",
            ultimate: "Ultimate",
            yearlyPrice: "2,399.40 / 年",
            free: "無料",
            downloadButton: "Windows版をダウンロード",
            showMore: "さらに{count}個の機能を表示",
            showLess: "表示を減らす"
        },
        ko: {
            title: "TradingView 데스크톱에서 Ultimate 플랜 무료로 받기",
            ultimate: "Ultimate",
            yearlyPrice: "2,399.40 / 년",
            free: "무료",
            downloadButton: "Windows용 다운로드",
            showMore: "{count}개 더 보기",
            showLess: "접기"
        },
        "zh-TW": {
            title: "在 TradingView 桌面版獲取免費 Ultimate 計劃",
            ultimate: "Ultimate",
            yearlyPrice: "2,399.40 / 年",
            free: "免費",
            downloadButton: "下載 Windows 版",
            showMore: "顯示更多 {count} 個功能",
            showLess: "顯示更少"
        },
        ar: {
            title: "احصل على خطة Ultimate مجانًا على TradingView Desktop",
            ultimate: "Ultimate",
            yearlyPrice: "2,399.40 / سنة",
            free: "مجاني",
            downloadButton: "تحميل لنظام Windows",
            showMore: "عرض {count} ميزات إضافية",
            showLess: "عرض أقل"
        },
        bn: {
            title: "TradingView ডেস্কটপে বিনামূল্যে Ultimate প্ল্যান পান",
            ultimate: "Ultimate",
            yearlyPrice: "2,399.40 / বছর",
            free: "বিনামূল্যে",
            downloadButton: "Windows এর জন্য ডাউনলোড করুন",
            showMore: "আরও {count}টি ফিচার দেখুন",
            showLess: "কম দেখুন"
        },
        id: {
            title: "Dapatkan Paket Ultimate Gratis di TradingView Desktop",
            ultimate: "Ultimate",
            yearlyPrice: "2.399,40 / Tahun",
            free: "Gratis",
            downloadButton: "Unduh untuk Windows",
            showMore: "Tampilkan {count} fitur lainnya",
            showLess: "Tampilkan lebih sedikit"
        },
        ka: {
            title: "მიიღეთ Ultimate გეგმა უფასოდ TradingView Desktop-ზე",
            ultimate: "Ultimate",
            yearlyPrice: "2,399.40 / წელი",
            free: "უფასო",
            downloadButton: "Windows-ისთვის ჩამოტვირთვა",
            showMore: "აჩვენეთ კიდევ {count} ფუნქცია",
            showLess: "ნაკლების ჩვენება"
        },
        mn: {
            title: "TradingView Desktop дээр Ultimate төлөвлөгөөг үнэгүй авах",
            ultimate: "Ultimate",
            yearlyPrice: "2,399.40 / Жил",
            free: "Үнэгүй",
            downloadButton: "Windows-д зориулж татах",
            showMore: "Нэмж {count} функц харах",
            showLess: "Багасгаж харах"
        },
        tr: {
            title: "TradingView Masaüstünde Ücretsiz Ultimate Plan Alın",
            ultimate: "Ultimate",
            yearlyPrice: "2.399,40 / Yıl",
            free: "Ücretsiz",
            downloadButton: "Windows için İndir",
            showMore: "{count} özellik daha göster",
            showLess: "Daha az göster"
        },
        ru: {
            title: "Получите Ultimate план бесплатно на TradingView Desktop",
            ultimate: "Ultimate",
            yearlyPrice: "2,399.40 / Год",
            free: "Бесплатно",
            downloadButton: "Скачать для Windows",
            showMore: "Показать еще {count} функций",
            showLess: "Показать меньше"
        },
        sq: {
            title: "Merrni Planin Ultimate Falas në TradingView Desktop",
            ultimate: "Ultimate",
            yearlyPrice: "2,399.40 / Vit",
            free: "Falas",
            downloadButton: "Shkarkoni për Windows",
            showMore: "Shfaq {count} karakteristika të tjera",
            showLess: "Shfaq më pak"
        },
        bs: {
            title: "Nabavite Besplatni Ultimate Plan na TradingView Desktop",
            ultimate: "Ultimate",
            yearlyPrice: "2,399.40 / Godina",
            free: "Besplatno",
            downloadButton: "Preuzmite za Windows",
            showMore: "Prikaži još {count} funkcija",
            showLess: "Prikaži manje"
        },
        bg: {
            title: "Получете Безплатен Ultimate План в TradingView Desktop",
            ultimate: "Ultimate",
            yearlyPrice: "2,399.40 / Година",
            free: "Безплатно",
            downloadButton: "Изтеглете за Windows",
            showMore: "Покажи още {count} функции",
            showLess: "Покажи по-малко"
        },
        hr: {
            title: "Nabavite Besplatni Ultimate Plan na TradingView Desktop",
            ultimate: "Ultimate",
            yearlyPrice: "2,399.40 / Godina",
            free: "Besplatno",
            downloadButton: "Preuzmite za Windows",
            showMore: "Prikaži još {count} funkcija",
            showLess: "Prikaži manje"
        },
        sr: {
            title: "Набавите Бесплатни Ultimate План на TradingView Desktop",
            ultimate: "Ultimate",
            yearlyPrice: "2,399.40 / Година",
            free: "Бесплатно",
            downloadButton: "Преузмите за Windows",
            showMore: "Прикажи још {count} функција",
            showLess: "Прикажи мање"
        },
        sl: {
            title: "Pridobite Brezplačni Ultimate Načrt na TradingView Desktop",
            ultimate: "Ultimate",
            yearlyPrice: "2,399.40 / Leto",
            free: "Brezplačno",
            downloadButton: "Prenesite za Windows",
            showMore: "Prikaži še {count} funkcij",
            showLess: "Prikaži manj"
        },
        sk: {
            title: "Získajte Bezplatný Ultimate Plán na TradingView Desktop",
            ultimate: "Ultimate",
            yearlyPrice: "2,399.40 / Rok",
            free: "Zadarmo",
            downloadButton: "Stiahnite pre Windows",
            showMore: "Zobraziť ďalších {count} funkcií",
            showLess: "Zobraziť menej"
        },
        ro: {
            title: "Obțineți Planul Ultimate Gratuit pe TradingView Desktop",
            ultimate: "Ultimate",
            yearlyPrice: "2,399.40 / An",
            free: "Gratuit",
            downloadButton: "Descărcați pentru Windows",
            showMore: "Afișați încă {count} funcții",
            showLess: "Afișați mai puțin"
        },
        mk: {
            title: "Земете Бесплатен Ultimate План на TradingView Desktop",
            ultimate: "Ultimate",
            yearlyPrice: "2,399.40 / Година",
            free: "Бесплатно",
            downloadButton: "Преземете за Windows",
            showMore: "Прикажи уште {count} функции",
            showLess: "Прикажи помалку"
        },
        me: {
            title: "Набавите Бесплатни Ultimate План на TradingView Desktop",
            ultimate: "Ultimate",
            yearlyPrice: "2,399.40 / Година",
            free: "Бесплатно",
            downloadButton: "Преузмите за Windows",
            showMore: "Прикажи још {count} функција",
            showLess: "Прикажи мање"
        },
        md: {
            title: "Obțineți Planul Ultimate Gratuit pe TradingView Desktop",
            ultimate: "Ultimate",
            yearlyPrice: "2,399.40 / An",
            free: "Gratuit",
            downloadButton: "Descărcați pentru Windows",
            showMore: "Afișați încă {count} funcții",
            showLess: "Afișați mai puțin"
        },
        by: {
            title: "Атрымайце Бясплатны Ultimate План на TradingView Desktop",
            ultimate: "Ultimate",
            yearlyPrice: "2,399.40 / Год",
            free: "Бясплатна",
            downloadButton: "Спампуйце для Windows",
            showMore: "Паказаць яшчэ {count} функцый",
            showLess: "Паказаць менш"
        }
    };
    return e[i] || e.en
}
  , mT = () => x.jsx("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: x.jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6 10L4 12L10 18L20 8L18 6L10 14L6 10Z",
        fill: "#A259FF"
    })
})
  , hT = () => x.jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    children: x.jsx("path", {
        d: "M19.8536 16.8538L14.9999 12L19.8536 7.14624C19.9466 7.05209 19.9988 6.92509 19.9988 6.79276C19.9988 6.66042 19.9466 6.53342 19.8536 6.43927L17.5607 4.14639C17.467 4.05266 17.3398 4 17.2072 4C17.0747 4 16.9475 4.05266 16.8538 4.14639L12 9.00015L7.14624 4.14639C7.05248 4.05266 6.92533 4 6.79276 4C6.66018 4 6.53303 4.05266 6.43927 4.14639L4.14639 6.43927C4.05266 6.53303 4 6.66018 4 6.79276C4 6.92533 4.05266 7.05248 4.14639 7.14624L9.00015 12L4.14639 16.8538C4.05266 16.9475 4 17.0747 4 17.2072C4 17.3398 4.05266 17.467 4.14639 17.5607L6.43927 19.8536C6.53303 19.9473 6.66018 20 6.79276 20C6.92533 20 7.05248 19.9473 7.14624 19.8536L12 14.9999L16.8538 19.8536C16.9475 19.9473 17.0747 20 17.2072 20C17.3398 20 17.467 19.9473 17.5607 19.8536L19.8536 17.5607C19.9473 17.467 20 17.3398 20 17.2072C20 17.0747 19.9473 16.9475 19.8536 16.8538Z",
        fill: "#3B4046"
    })
})
  , fT = ({text: i, hasProgress: e, progressWidth: r, included: a}) => {
    const o = N.useRef(null)
      , l = Ht(o, {
        once: !0
    })
      , u = N.useRef(null)
      , d = Ht(u, {
        once: !0
    });
    return x.jsxs(ee.div, {
        ref: u,
        initial: {
            opacity: 0,
            x: -20
        },
        animate: {
            opacity: d ? 1 : 0,
            x: d ? 0 : -20
        },
        transition: {
            duration: .5
        },
        className: "w-full flex items-start gap-2 sm:gap-4",
        children: [a ? x.jsx(mT, {}) : x.jsx(hT, {}), x.jsxs("div", {
            className: "flex flex-col gap-2 w-full",
            children: [x.jsx("span", {
                className: `text-[14px] sm:text-[16px] xl:text-[18px] leading-tight sm:leading-[24px] ${a ? "text-[#0D1013]" : "text-[#3B4046]"}`,
                children: i
            }), e && x.jsx("div", {
                className: "w-full rounded-[8px] bg-[#D0D3D7] h-1",
                ref: o,
                children: x.jsx(ee.div, {
                    className: "h-1 bg-gradient-to-r from-[#D0D3D7] to-[#D0D3D7] rounded-[8px]",
                    style: {
                        width: r
                    },
                    initial: {
                        width: 0
                    },
                    animate: {
                        width: l ? r : "0%"
                    },
                    transition: {
                        duration: 1,
                        ease: "easeOut"
                    }
                })
            })]
        })]
    })
}
  , gT = () => {
    const [i,e] = N.useState(!1)
      , {i18n: r} = We()
      , a = r.language
      , o = pT(a)
      , l = gs(a)
      , u = [{
        text: `16 ${l.chartsPerTab}`,
        hasProgress: !0,
        progressWidth: "100%",
        included: !0
    }, {
        text: `50 ${l.indicatorsPerChart}`,
        hasProgress: !0,
        progressWidth: "100%",
        included: !0
    }, {
        text: `40K ${l.historicalBars}`,
        hasProgress: !0,
        progressWidth: "100%",
        included: !0
    }, {
        text: `200 ${l.parallelConnections}`,
        hasProgress: !0,
        progressWidth: "100%",
        included: !0
    }, {
        text: `1,000 ${l.priceAlerts}`,
        hasProgress: !0,
        progressWidth: "100%",
        included: !0
    }, {
        text: `1,000 ${l.technicalAlerts}`,
        hasProgress: !0,
        progressWidth: "100%",
        included: !0
    }, {
        text: `15 ${l.watchlistAlerts}`,
        hasProgress: !0,
        progressWidth: "100%",
        included: !0
    }, {
        text: "hr"
    }, {
        text: l.noAds,
        included: !0
    }, {
        text: l.volumeProfile,
        included: !0
    }, {
        text: l.customTimeframes,
        included: !0
    }, {
        text: l.customRangeBars,
        included: !0
    }, {
        text: l.multipleWatchlists,
        included: !0
    }, {
        text: l.barReplay,
        included: !0
    }, {
        text: l.indicatorsOnIndicators,
        included: !0
    }, {
        text: l.chartDataExport,
        included: !0
    }, {
        text: l.intradayCharts,
        included: !0
    }, {
        text: l.customFormulas,
        included: !0
    }, {
        text: l.timePriceOpportunity,
        included: !0
    }, {
        text: l.volumeFootprint,
        included: !0
    }, {
        text: l.volumeCandles,
        included: !0
    }, {
        text: l.autoChartPatterns,
        included: !0
    }, {
        text: l.secondBasedAlerts,
        included: !0
    }, {
        text: l.nonExpiringAlerts,
        included: !0
    }, {
        text: l.inviteOnlyScripts,
        included: !0
    }, {
        text: l.secondBasedIntervals,
        included: !0
    }, {
        text: l.tickBasedIntervals,
        included: !0
    }, {
        text: l.professionalData,
        included: !0
    }, {
        text: l.prioritySupport,
        included: !0
    }]
      , d = i ? u : u.slice(0, 8)
      , p = u.length - 8
      , h = N.useRef(null)
      , g = Ht(h, {
        once: !0,
        margin: "-100px"
    })
      , v = {
        hidden: {
            opacity: 0,
            y: 50
        },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: .6,
                staggerChildren: .1
            }
        }
    }
      , y = {
        hidden: {
            opacity: 0,
            y: 20
        },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: .4
            }
        }
    };
    return N.useEffect( () => {
        Object.keys(gs("en")).forEach(P => {
            Object.keys(gs("en")).forEach(w => {
                const S = gs(w);
                r.addResourceBundle(w, "translation", {
                    features: S
                }, !0, !0)
            }
            )
        }
        )
    }
    , []),
    x.jsx("section", {
        id: "promo",
        className: "py-8 md:py-12 lg:py-16",
        ref: h,
        children: x.jsxs(ee.div, {
            className: "max-w-[1376px] w-full mx-auto flex flex-col gap-4 md:gap-8",
            variants: v,
            initial: "hidden",
            animate: g ? "visible" : "hidden",
            children: [x.jsxs(ee.div, {
                className: "p-4 flex flex-col gap-4 items-center justify-center",
                variants: y,
                children: [x.jsx("h2", {
                    className: "text-[#0D1013] max-w-[994px] w-full text-center font-semibold text-[36px] sm:text-[48px] md:text-[56px] lg:text-[64px] leading-[1.2]",
                    children: o.title
                }), x.jsx(lT, {
                    days: 2,
                    hours: 5,
                    minutes: 31
                })]
            }), x.jsxs(ee.div, {
                className: "max-w-[900px] w-full mx-auto bg-[#fff] card-styles gradient-border-mask rounded-[32px] p-4 sm:p-6 !flex flex-col md:flex-row  gap-4 sm:gap-6 md:gap-8",
                variants: y,
                children: [x.jsxs(ee.div, {
                    className: "max-w-full md:max-w-[348px] relative z-10 rounded-[15px] w-full p-4 sm:p-6 pt-6 sm:pt-10 flex flex-col gap-[40px] sm:gap-[69px]",
                    style: {
                        background: "linear-gradient(180deg, #D23197 0%, #326FF3 100%)"
                    },
                    variants: y,
                    children: [x.jsxs("div", {
                        className: "flex flex-col gap-4 sm:gap-6 items-center justify-center text-center",
                        children: [x.jsx("h3", {
                            className: "text-[#F4F4F4] font-semibold text-[36px] sm:text-[42px] md:text-[48px] lg:text-[56px] leading-[150%]",
                            children: o.ultimate
                        }), x.jsxs("div", {
                            className: "flex flex-col gap-2 items-center justify-center text-center",
                            children: [x.jsx("span", {
                                className: "line-through text-[#D0D3D7] font-medium text-[20px] sm:text-[24px] md:text-[28px] leading-[32px]",
                                children: o.yearlyPrice
                            }), x.jsx("span", {
                                className: "text-[#F4F4F4] font-semibold text-[36px] sm:text-[42px] md:text-[48px] leading-[56px]",
                                children: o.free
                            })]
                        })]
                    }), x.jsx(dT, {
                        label: o.downloadButton,
                        className: "!w-full mt-auto !bg-[#FFFFFF]"
                    })]
                }), x.jsxs(ee.div, {
                    className: "flex-1 flex relative z-10 flex-col gap-4 max-h-[46.5vh] overflow-y-auto scrollbar-thin scrollbar-thumb-gray-600 scrollbar-track-transparent  w-full p-4 sm:p-6 rounded-[16px]",
                    variants: y,
                    children: [d.map( (P, w) => P.text === "hr" ? x.jsx(ee.hr, {
                        className: "border-t border-[#D0D3D7]/40 my-2",
                        variants: y
                    }, w) : x.jsx(fT, {
                        text: P.text,
                        hasProgress: P.hasProgress,
                        progressWidth: P.progressWidth,
                        included: P.included
                    }, w)), !i && x.jsxs(ee.button, {
                        className: "text-left text-[#858C93] w-full justify-between text-[15px] flex items-center gap-2 hover:underline transition-colors duration-200",
                        onClick: () => e(!0),
                        variants: y,
                        whileHover: {
                            scale: 1.02
                        },
                        whileTap: {
                            scale: .98
                        },
                        children: [o.showMore.replace("{count}", p.toString()), x.jsx("svg", {
                            width: "18",
                            height: "18",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            children: x.jsx("path", {
                                d: "M7 10l5 5 5-5",
                                stroke: "#858C93",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round"
                            })
                        })]
                    }), i && x.jsxs(ee.button, {
                        className: "text-left text-[#858C93] text-[15px] flex items-center gap-2 hover:underline transition-colors duration-200",
                        onClick: () => e(!1),
                        variants: y,
                        whileHover: {
                            scale: 1.02
                        },
                        whileTap: {
                            scale: .98
                        },
                        children: [o.showLess, x.jsx("svg", {
                            width: "18",
                            height: "18",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            children: x.jsx("path", {
                                d: "M17 14l-5-5-5 5",
                                stroke: "#858C93",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round"
                            })
                        })]
                    })]
                })]
            })]
        })
    })
}
  , vT = "/cdn/shop/t/1/assets/monitor-CTAeqnBo.webp"
  , yT = i => {
    const e = {
        en: {
            title: "Native multi-monitor support",
            description: "Multiple monitors are important to traders. TradingView Desktop allows you to set up and restore your multi-monitor workspace without any of the limitations browsers traditionally face."
        },
        es: {
            title: "Soporte nativo para múltiples monitores",
            description: "Los múltiples monitores son importantes para los traders. TradingView Desktop te permite configurar y restaurar tu espacio de trabajo con múltiples monitores sin las limitaciones que tradicionalmente enfrentan los navegadores."
        },
        vi: {
            title: "Hỗ trợ đa màn hình tích hợp",
            description: "Nhiều màn hình rất quan trọng đối với các nhà giao dịch. TradingView Desktop cho phép bạn thiết lập và khôi phục không gian làm việc đa màn hình mà không gặp bất kỳ giới hạn nào mà trình duyệt thường gặp phải."
        },
        th: {
            title: "รองรับการใช้งานหลายจอแบบดั้งเดิม",
            description: "หลายจอภาพมีความสำคัญสำหรับเทรดเดอร์ TradingView Desktop ช่วยให้คุณตั้งค่าและกู้คืนพื้นที่ทำงานแบบหลายจอโดยไม่มีข้อจำกัดที่เบราว์เซอร์มักเจอ"
        },
        ja: {
            title: "ネイティブマルチモニターサポート",
            description: "複数のモニターはトレーダーにとって重要です。TradingView Desktopでは、ブラウザが従来直面していた制限なしに、マルチモニターワークスペースを設定および復元できます。"
        },
        ko: {
            title: "기본 멀티 모니터 지원",
            description: "여러 모니터는 트레이더에게 중요합니다. TradingView Desktop을 사용하면 브라우저가 전통적으로 직면하는 제한 없이 멀티 모니터 작업 공간을 설정하고 복원할 수 있습니다."
        },
        "zh-TW": {
            title: "原生多螢幕支援",
            description: "多螢幕對交易者來說很重要。TradingView Desktop 讓您能夠設置和還原多螢幕工作區，不受瀏覽器傳統限制。"
        },
        ar: {
            title: "دعم تعدد الشاشات الأصلي",
            description: "الشاشات المتعددة مهمة للمتداولين. يتيح لك TradingView Desktop إعداد واستعادة مساحة عمل الشاشات المتعددة دون أي من القيود التي تواجهها المتصفحات تقليديًا."
        },
        bn: {
            title: "নেটিভ মাল্টি-মনিটর সাপোর্ট",
            description: "ট্রেডারদের জন্য একাধিক মনিটর গুরুত্বপূর্ণ। TradingView Desktop আপনাকে ব্রাউজারগুলি ঐতিহ্যগতভাবে যে সীমাবদ্ধতার মুখোমুখি হয় তার কোনটি ছাড়াই আপনার মাল্টি-মনিটর ওয়ার্কস্পেস সেট আপ এবং পুনরুদ্ধার করতে দেয়।"
        },
        id: {
            title: "Dukungan multi-monitor asli",
            description: "Monitor ganda penting bagi trader. TradingView Desktop memungkinkan Anda mengatur dan memulihkan ruang kerja multi-monitor tanpa batasan yang biasanya dihadapi browser."
        },
        ka: {
            title: "მრავალი მონიტორის მხარდაჭერა",
            description: "მრავალი მონიტორი მნიშვნელოვანია ტრეიდერებისთვის. TradingView Desktop საშუალებას გაძლევთ დააყენოთ და აღადგინოთ თქვენი მრავალმონიტორიანი სამუშაო სივრცე ბრაუზერების ტრადიციული შეზღუდვების გარეშე."
        },
        mn: {
            title: "Олон дэлгэцийн дэмжлэг",
            description: "Олон дэлгэц арилжаачдад чухал. TradingView Desktop нь таны олон дэлгэцтэй ажлын орчинг хөтөч програмуудын уламжлалт хязгаарлалтгүйгээр тохируулах, сэргээх боломжийг олгодог."
        },
        tr: {
            title: "Yerel çoklu monitör desteği",
            description: "Çoklu monitörler tüccarlar için önemlidir. TradingView Desktop, tarayıcıların geleneksel olarak karşılaştığı sınırlamalar olmadan çoklu monitör çalışma alanınızı kurmanıza ve geri yüklemenize olanak tanır."
        },
        ru: {
            title: "Поддержка нескольких мониторов",
            description: "Несколько мониторов важны для трейдеров. TradingView Desktop позволяет настроить и восстановить рабочую область с несколькими мониторами без ограничений, с которыми традиционно сталкиваются браузеры."
        },
        sq: {
            title: "Mbështetje e integruar për shumë monitorë",
            description: "Monitorët e shumtë janë të rëndësishëm për tregtarët. TradingView Desktop ju lejon të vendosni dhe të riktheni hapësirën tuaj të punës me shumë monitorë pa asnjë nga kufizimet që tradicionalisht përballen shfletuesit."
        },
        bs: {
            title: "Nativna podrška za više monitora",
            description: "Više monitora je važno za trgovce. TradingView Desktop vam omogućava da postavite i vratite vaš radni prostor s više monitora bez ikakvih ograničenja s kojima se tradicionalno suočavaju preglednici."
        },
        bg: {
            title: "Вградена поддръжка за множество монитори",
            description: "Множеството монитори са важни за търговците. TradingView Desktop ви позволява да настроите и възстановите вашето работно пространство с множество монитори без ограниченията, с които традиционно се сблъскват браузърите."
        },
        hr: {
            title: "Nativna podrška za više monitora",
            description: "Više monitora je važno za trgovce. TradingView Desktop omogućuje vam da postavite i vratite svoj radni prostor s više monitora bez ikakvih ograničenja s kojima se tradicionalno suočavaju preglednici."
        },
        xk: {
            title: "Mbështetje e integruar për shumë monitorë / Nativna podrška za više monitora",
            description: "Monitorët e shumtë janë të rëndësishëm për tregtarët. TradingView Desktop ju lejon të vendosni dhe të riktheni hapësirën tuaj të punës me shumë monitorë pa asnjë nga kufizimet që tradicionalisht përballen shfletuesit. / Više monitora je važno za trgovce. TradingView Desktop omogućuje vam da postavite svoj radni prostor s više monitora."
        },
        me: {
            title: "Нативна подршка за више монитора",
            description: "Више монитора је важно за трговце. TradingView Desktop вам омогућава да поставите и вратите ваш радни простор са више монитора без икаквих ограничења са којима се традиционално суочавају прегледници."
        },
        mk: {
            title: "Нативна поддршка за повеќе монитори",
            description: "Повеќе монитори се важни за трговците. TradingView Desktop ви овозможува да поставите и да вратите ваш работен простор со повеќе монитори без никакви ограничувања со кои традиционално се соочуваат прелистувачите."
        },
        ro: {
            title: "Suport nativ pentru mai multe monitoare",
            description: "Monitoarele multiple sunt importante pentru traderi. TradingView Desktop vă permite să configurați și să restaurați spațiul de lucru cu mai multe monitoare fără niciuna dintre limitările cu care se confruntă în mod tradițional browserele."
        },
        sr: {
            title: "Нативна подршка за више монитора",
            description: "Више монитора је важно за трговце. TradingView Desktop вам омогућава да поставите и вратите ваш радни простор са више монитора без икаквих ограничења са којима се традиционално суочавају прегледници."
        },
        sl: {
            title: "Naravna podpora za več monitorjev",
            description: "Več monitorjev je pomembnih za trgovce. TradingView Desktop vam omogoča, da nastavite in obnovite vaš delovni prostor z več monitorji brez vseh omejitev, s katerimi se tradicionalno srečujejo brskalniki."
        },
        sk: {
            title: "Natívna podpora pre viac monitorov",
            description: "Viac monitorov je dôležité pre obchodníkov. TradingView Desktop vám umožňuje nastaviť a obnoviť váš pracovný priestor s viac monitormi bez akýchkoľvek obmedzení, ktorým tradične čelia prehliadače."
        },
        md: {
            title: "Suport nativ pentru mai multe monitoare",
            description: "Monitoarele multiple sunt importante pentru traderi. TradingView Desktop vă permite să configurați și să restaurați spațiul de lucru cu mai multe monitoare fără niciuna dintre limitările cu care se confruntă în mod tradițional browserele."
        },
        ge: {
            title: "მრავალი მონიტორის ბუნებრივი მხარდაჭერა",
            description: "მრავალი მონიტორი მნიშვნელოვანია ტრეიდერებისთვის. TradingView Desktop საშუალებას გაძლევთ დააყენოთ და აღადგინოთ თქვენი მრავალმონიტორიანი სამუშაო სივრცე ბრაუზერების ტრადიციული შეზღუდვების გარეშე."
        },
        by: {
            title: "Родная падтрымка некалькіх манітораў",
            description: "Некалькі маніторы важныя для трэйдэраў. TradingView Desktop дазваляе наладзіць і аднавіць вашу працоўную прастору з некалькімі манітораміі без абмежаванняў, з якімі традыцыйна сутыкаюцца браўзэры."
        },
        pt: {
            title: "Suporte nativo para múltiplos monitores",
            description: "Vários monitores são importantes para traders. O TradingView Desktop permite configurar e restaurar seu espaço de trabalho com múltiplos monitores sem nenhuma das limitações que os navegadores tradicionalmente enfrentam."
        }
    };
    return e[i] || e.en
}
  , kT = () => {
    const {i18n: i} = We()
      , e = N.useRef(null)
      , r = Ht(e, {
        once: !0,
        margin: "-100px"
    })
      , a = yT(i.language)
      , o = {
        hidden: {
            opacity: 0,
            y: 50
        },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: .6,
                staggerChildren: .2
            }
        }
    }
      , l = {
        hidden: {
            opacity: 0,
            y: 20
        },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: .4
            }
        }
    };
    return x.jsx("section", {
        className: "py-8 md:py-12 lg:py-16",
        ref: e,
        children: x.jsxs(ee.div, {
            className: "max-w-[1367px] w-full mx-auto flex flex-col gap-6 md:gap-8 lg:gap-10 px-4 lg:px-0",
            variants: o,
            initial: "hidden",
            animate: r ? "visible" : "hidden",
            children: [x.jsxs(ee.div, {
                className: "flex flex-col gap-4 items-center justify-center text-center",
                variants: l,
                children: [x.jsx("h2", {
                    className: "text-[#0D1013] font-semibold text-[36px] sm:text-[48px] md:text-[56px] lg:text-[64px] leading-[1.2] capitalize",
                    children: a.title
                }), x.jsx("p", {
                    className: "text-[#3B4046] text-[18px] sm:text-[20px] md:text-[24px] lg:text-[28px] leading-[1.4] max-w-[900px]",
                    children: a.description
                })]
            }), x.jsx(ee.div, {
                className: "w-full rounded-[20px] overflow-hidden",
                variants: l,
                whileHover: {
                    scale: 1.02
                },
                transition: {
                    duration: .3
                },
                children: x.jsx("img", {
                    src: vT,
                    alt: a.title,
                    className: "w-full h-auto object-cover"
                })
            })]
        })
    })
}
  , xT = "/cdn/shop/t/1/assets/map-B26Wln6g.svg"
  , wT = i => {
    const e = {
        en: {
            title: "economy",
            subtitle: "Global inflation map",
            seeMore: "See more global trends",
            legendLessThanZero: "Less than 0%",
            legend0to3: "0-3%",
            legend3to7: "3-7%",
            legend7to12: "7-12%",
            legend12to25: "12-25%",
            legendMoreThan25: "More than 25%"
        },
        pt: {
            title: "economia",
            subtitle: "Mapa global de inflação",
            seeMore: "Ver mais tendências globais",
            legendLessThanZero: "Menos de 0%",
            legend0to3: "0-3%",
            legend3to7: "3-7%",
            legend7to12: "7-12%",
            legend12to25: "12-25%",
            legendMoreThan25: "Mais de 25%"
        },
        "zh-TW": {
            title: "經濟",
            subtitle: "全球通脹地圖",
            seeMore: "查看更多全球趨勢",
            legendLessThanZero: "低於0%",
            legend0to3: "0-3%",
            legend3to7: "3-7%",
            legend7to12: "7-12%",
            legend12to25: "12-25%",
            legendMoreThan25: "超過25%"
        },
        es: {
            title: "economía",
            subtitle: "Mapa global de inflación",
            seeMore: "Ver más tendencias globales",
            legendLessThanZero: "Menos del 0%",
            legend0to3: "0-3%",
            legend3to7: "3-7%",
            legend7to12: "7-12%",
            legend12to25: "12-25%",
            legendMoreThan25: "Más del 25%"
        },
        ar: {
            title: "اقتصاد",
            subtitle: "خريطة التضخم العالمية",
            seeMore: "اطلع على المزيد من الاتجاهات العالمية",
            legendLessThanZero: "أقل من 0%",
            legend0to3: "0-3%",
            legend3to7: "3-7%",
            legend7to12: "7-12%",
            legend12to25: "12-25%",
            legendMoreThan25: "أكثر من 25%"
        },
        th: {
            title: "เศรษฐกิจ",
            subtitle: "แผนที่อัตราเงินเฟ้อทั่วโลก",
            seeMore: "ดูแนวโน้มทั่วโลกเพิ่มเติม",
            legendLessThanZero: "น้อยกว่า 0%",
            legend0to3: "0-3%",
            legend3to7: "3-7%",
            legend7to12: "7-12%",
            legend12to25: "12-25%",
            legendMoreThan25: "มากกว่า 25%"
        },
        vi: {
            title: "kinh tế",
            subtitle: "Bản đồ lạm phát toàn cầu",
            seeMore: "Xem thêm xu hướng toàn cầu",
            legendLessThanZero: "Dưới 0%",
            legend0to3: "0-3%",
            legend3to7: "3-7%",
            legend7to12: "7-12%",
            legend12to25: "12-25%",
            legendMoreThan25: "Trên 25%"
        },
        bn: {
            title: "অর্থনীতি",
            subtitle: "বিশ্বব্যাপী মুদ্রাস্ফীতি মানচিত্র",
            seeMore: "আরও বৈশ্বিক প্রবণতা দেখুন",
            legendLessThanZero: "০% এর কম",
            legend0to3: "০-৩%",
            legend3to7: "৩-৭%",
            legend7to12: "৭-১২%",
            legend12to25: "১২-২৫%",
            legendMoreThan25: "২৫% এর বেশি"
        },
        mn: {
            title: "эдийн засаг",
            subtitle: "Дэлхийн инфляцийн газрын зураг",
            seeMore: "Дэлхийн чиг хандлагыг илүү харах",
            legendLessThanZero: "0%-аас бага",
            legend0to3: "0-3%",
            legend3to7: "3-7%",
            legend7to12: "7-12%",
            legend12to25: "12-25%",
            legendMoreThan25: "25%-аас дээш"
        },
        ja: {
            title: "経済",
            subtitle: "世界のインフレーション地図",
            seeMore: "世界のトレンドをもっと見る",
            legendLessThanZero: "0%未満",
            legend0to3: "0-3%",
            legend3to7: "3-7%",
            legend7to12: "7-12%",
            legend12to25: "12-25%",
            legendMoreThan25: "25%超"
        },
        tr: {
            title: "ekonomi",
            subtitle: "Küresel enflasyon haritası",
            seeMore: "Daha fazla küresel trend görün",
            legendLessThanZero: "%0'dan az",
            legend0to3: "%0-3",
            legend3to7: "%3-7",
            legend7to12: "%7-12",
            legend12to25: "%12-25",
            legendMoreThan25: "%25'ten fazla"
        },
        ko: {
            title: "경제",
            subtitle: "글로벌 인플레이션 지도",
            seeMore: "더 많은 글로벌 트렌드 보기",
            legendLessThanZero: "0% 미만",
            legend0to3: "0-3%",
            legend3to7: "3-7%",
            legend7to12: "7-12%",
            legend12to25: "12-25%",
            legendMoreThan25: "25% 초과"
        },
        ka: {
            title: "ეკონომიკა",
            subtitle: "გლობალური ინფლაციის რუკა",
            seeMore: "მეტი გლობალური ტრენდის ნახვა",
            legendLessThanZero: "0%-ზე ნაკლები",
            legend0to3: "0-3%",
            legend3to7: "3-7%",
            legend7to12: "7-12%",
            legend12to25: "12-25%",
            legendMoreThan25: "25%-ზე მეტი"
        },
        ru: {
            title: "экономика",
            subtitle: "Глобальная карта инфляции",
            seeMore: "Смотреть больше глобальных трендов",
            legendLessThanZero: "Менее 0%",
            legend0to3: "0-3%",
            legend3to7: "3-7%",
            legend7to12: "7-12%",
            legend12to25: "12-25%",
            legendMoreThan25: "Более 25%"
        },
        id: {
            title: "ekonomi",
            subtitle: "Peta inflasi global",
            seeMore: "Lihat lebih banyak tren global",
            legendLessThanZero: "Kurang dari 0%",
            legend0to3: "0-3%",
            legend3to7: "3-7%",
            legend7to12: "7-12%",
            legend12to25: "12-25%",
            legendMoreThan25: "Lebih dari 25%"
        },
        sq: {
            title: "ekonomia",
            subtitle: "Harta globale e inflacionit",
            seeMore: "Shiko më shumë tendenca globale",
            legendLessThanZero: "Më pak se 0%",
            legend0to3: "0-3%",
            legend3to7: "3-7%",
            legend7to12: "7-12%",
            legend12to25: "12-25%",
            legendMoreThan25: "Më shumë se 25%"
        },
        bs: {
            title: "ekonomija",
            subtitle: "Globalna mapa inflacije",
            seeMore: "Pogledajte više globalnih trendova",
            legendLessThanZero: "Manje od 0%",
            legend0to3: "0-3%",
            legend3to7: "3-7%",
            legend7to12: "7-12%",
            legend12to25: "12-25%",
            legendMoreThan25: "Više od 25%"
        },
        bg: {
            title: "икономика",
            subtitle: "Глобална карта на инфлацията",
            seeMore: "Вижте повече глобални тенденции",
            legendLessThanZero: "По-малко от 0%",
            legend0to3: "0-3%",
            legend3to7: "3-7%",
            legend7to12: "7-12%",
            legend12to25: "12-25%",
            legendMoreThan25: "Повече от 25%"
        },
        hr: {
            title: "ekonomija",
            subtitle: "Globalna karta inflacije",
            seeMore: "Pogledajte više globalnih trendova",
            legendLessThanZero: "Manje od 0%",
            legend0to3: "0-3%",
            legend3to7: "3-7%",
            legend7to12: "7-12%",
            legend12to25: "12-25%",
            legendMoreThan25: "Više od 25%"
        },
        xk: {
            title: "ekonomia / економија",
            subtitle: "Harta globale e inflacionit / Глобална карта инфлације",
            seeMore: "Shiko më shumë tendenca globale / Погледајте више глобалних трендова",
            legendLessThanZero: "Më pak se 0% / Мање од 0%",
            legend0to3: "0-3%",
            legend3to7: "3-7%",
            legend7to12: "7-12%",
            legend12to25: "12-25%",
            legendMoreThan25: "Më shumë se 25% / Више од 25%"
        },
        me: {
            title: "економија",
            subtitle: "Глобална карта инфлације",
            seeMore: "Погледајте више глобалних трендова",
            legendLessThanZero: "Мање од 0%",
            legend0to3: "0-3%",
            legend3to7: "3-7%",
            legend7to12: "7-12%",
            legend12to25: "12-25%",
            legendMoreThan25: "Више од 25%"
        },
        mk: {
            title: "економија",
            subtitle: "Глобална карта на инфлацијата",
            seeMore: "Видете повеќе глобални трендови",
            legendLessThanZero: "Помалку од 0%",
            legend0to3: "0-3%",
            legend3to7: "3-7%",
            legend7to12: "7-12%",
            legend12to25: "12-25%",
            legendMoreThan25: "Повеќе од 25%"
        },
        ro: {
            title: "economie",
            subtitle: "Harta globală a inflației",
            seeMore: "Vezi mai multe tendințe globale",
            legendLessThanZero: "Mai puțin de 0%",
            legend0to3: "0-3%",
            legend3to7: "3-7%",
            legend7to12: "7-12%",
            legend12to25: "12-25%",
            legendMoreThan25: "Mai mult de 25%"
        },
        sr: {
            title: "економија",
            subtitle: "Глобална карта инфлације",
            seeMore: "Погледајте више глобалних трендова",
            legendLessThanZero: "Мање од 0%",
            legend0to3: "0-3%",
            legend3to7: "3-7%",
            legend7to12: "7-12%",
            legend12to25: "12-25%",
            legendMoreThan25: "Више од 25%"
        },
        sl: {
            title: "gospodarstvo",
            subtitle: "Globalna karta inflacije",
            seeMore: "Oglejte si več globalnih trendov",
            legendLessThanZero: "Manj kot 0%",
            legend0to3: "0-3%",
            legend3to7: "3-7%",
            legend7to12: "7-12%",
            legend12to25: "12-25%",
            legendMoreThan25: "Več kot 25%"
        },
        sk: {
            title: "ekonomika",
            subtitle: "Globálna mapa inflácie",
            seeMore: "Zobraziť viac globálnych trendov",
            legendLessThanZero: "Menej ako 0%",
            legend0to3: "0-3%",
            legend3to7: "3-7%",
            legend7to12: "7-12%",
            legend12to25: "12-25%",
            legendMoreThan25: "Viac ako 25%"
        },
        md: {
            title: "economie",
            subtitle: "Harta globală a inflației",
            seeMore: "Vezi mai multe tendințe globale",
            legendLessThanZero: "Mai puțin de 0%",
            legend0to3: "0-3%",
            legend3to7: "3-7%",
            legend7to12: "7-12%",
            legend12to25: "12-25%",
            legendMoreThan25: "Mai mult de 25%"
        },
        by: {
            title: "эканоміка",
            subtitle: "Глабальная карта інфляцыі",
            seeMore: "Глядзець больш глабальных трэндаў",
            legendLessThanZero: "Менш за 0%",
            legend0to3: "0-3%",
            legend3to7: "3-7%",
            legend7to12: "7-12%",
            legend12to25: "12-25%",
            legendMoreThan25: "Больш за 25%"
        }
    };
    return e[i] || e.en
}
  , PT = () => {
    const {i18n: i} = We()
      , e = i.language
      , r = wT(e);
    return x.jsx("section", {
        className: "py-8 sm:py-12 px-4 sm:px-6 lg:px-8",
        children: x.jsxs("div", {
            className: "max-w-[1200px] w-full mx-auto flex flex-col gap-6 sm:gap-8 lg:gap-10",
            children: [x.jsxs("div", {
                className: "flex flex-col gap-3 sm:gap-4",
                children: [x.jsxs("div", {
                    className: "flex items-center gap-2",
                    children: [x.jsx("a", {
                        href: "https://www.tradingview.com/markets/world-economy/",
                        className: "uppercase text-[#0D1013] font-bold text-[28px] sm:text-[36px] lg:text-[48px] leading-[130%] hover:text-[#2862FF] transition-colors duration-300",
                        children: r.title
                    }), x.jsx(wu, {})]
                }), x.jsx("span", {
                    className: "text-[#3B4046] text-[18px] sm:text-[22px] lg:text-[28px] leading-[130%]",
                    children: r.subtitle
                })]
            }), x.jsxs("div", {
                className: "w-full flex flex-col gap-6 sm:gap-8 items-center justify-center",
                children: [x.jsx("div", {
                    className: "w-full overflow-hidden",
                    children: x.jsx("img", {
                        src: xT,
                        alt: "Global inflation map showing inflation rates across different countries",
                        className: "w-full h-[250px] sm:h-[350px] lg:h-[500px] object-contain transition-transform duration-500"
                    })
                }), x.jsxs("div", {
                    className: "flex flex-wrap gap-3 sm:gap-4 justify-center items-center",
                    children: [x.jsxs("div", {
                        className: "flex items-center gap-1 hover:scale-105 transition-transform duration-200",
                        children: [x.jsx("div", {
                            className: "size-2 sm:size-3 shrink-0 rounded-full bg-[#FFF3E0] border border-gray-200"
                        }), x.jsx("span", {
                            className: "text-[#858C93] text-[10px] sm:text-[12px] leading-[130%] font-medium",
                            children: r.legendLessThanZero
                        })]
                    }), x.jsxs("div", {
                        className: "flex items-center gap-1 hover:scale-105 transition-transform duration-200",
                        children: [x.jsx("div", {
                            className: "size-2 sm:size-3 shrink-0 rounded-full bg-[#FFE0B1] border border-gray-200"
                        }), x.jsx("span", {
                            className: "text-[#858C93] text-[10px] sm:text-[12px] leading-[130%] font-medium",
                            children: r.legend0to3
                        })]
                    }), x.jsxs("div", {
                        className: "flex items-center gap-1 hover:scale-105 transition-transform duration-200",
                        children: [x.jsx("div", {
                            className: "size-2 sm:size-3 shrink-0 rounded-full bg-[#FFCC80] border border-gray-200"
                        }), x.jsx("span", {
                            className: "text-[#858C93] text-[10px] sm:text-[12px] leading-[130%] font-medium",
                            children: r.legend3to7
                        })]
                    }), x.jsxs("div", {
                        className: "flex items-center gap-1 hover:scale-105 transition-transform duration-200",
                        children: [x.jsx("div", {
                            className: "size-2 sm:size-3 shrink-0 rounded-full bg-[#FFB74D] border border-gray-200"
                        }), x.jsx("span", {
                            className: "text-[#858C93] text-[10px] sm:text-[12px] leading-[130%] font-medium",
                            children: r.legend7to12
                        })]
                    }), x.jsxs("div", {
                        className: "flex items-center gap-1 hover:scale-105 transition-transform duration-200",
                        children: [x.jsx("div", {
                            className: "size-2 sm:size-3 shrink-0 rounded-full bg-[#FFA726] border border-gray-200"
                        }), x.jsx("span", {
                            className: "text-[#858C93] text-[10px] sm:text-[12px] leading-[130%] font-medium",
                            children: r.legend12to25
                        })]
                    }), x.jsxs("div", {
                        className: "flex items-center gap-1 hover:scale-105 transition-transform duration-200",
                        children: [x.jsx("div", {
                            className: "size-2 sm:size-3 shrink-0 rounded-full bg-[#FF9800] border border-gray-200"
                        }), x.jsx("span", {
                            className: "text-[#858C93] text-[10px] sm:text-[12px] leading-[130%] font-medium",
                            children: r.legendMoreThan25
                        })]
                    })]
                })]
            }), x.jsxs("a", {
                href: "https://www.tradingview.com/markets/world-economy/charts-global-trends/",
                className: "flex items-center gap-2 group hover:gap-3 transition-all duration-300",
                target: "_blank",
                rel: "noopener noreferrer",
                children: [x.jsx("span", {
                    className: "text-[#2862FF] text-[14px] sm:text-[16px] leading-[130%] group-hover:text-[#1a4bcc] transition-colors duration-300",
                    children: r.seeMore
                }), x.jsx("div", {
                    className: "group-hover:translate-x-1 transition-transform duration-300",
                    children: x.jsx(bT, {})
                })]
            })]
        })
    })
}
  , wu = () => x.jsx("svg", {
    width: "15",
    height: "26",
    viewBox: "0 0 15 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: x.jsx("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M14.142 14.142L2.828 25.456L0 22.628L9.9 12.728L0 2.828L2.828 0L14.142 11.314C14.5169 11.6891 14.7276 12.1977 14.7276 12.728C14.7276 13.2583 14.5169 13.7669 14.142 14.142Z",
        fill: "black"
    })
})
  , bT = () => x.jsx("svg", {
    width: "6",
    height: "9",
    viewBox: "0 0 6 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: x.jsx("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M5.04733 5.214L1.27599 8.98533L0.333328 8.04267L3.63333 4.74267L0.333328 1.44267L1.27599 0.5L5.04733 4.27133C5.17231 4.39635 5.24252 4.56589 5.24252 4.74267C5.24252 4.91944 5.17231 5.08898 5.04733 5.214Z",
        fill: "#2862FF"
    })
})
  , ST = "/cdn/shop/t/1/assets/card1-BiUynsgT.webp"
  , TT = "/cdn/shop/t/1/assets/card2-j0SNdM2Z.webp"
  , jT = "/cdn/shop/t/1/assets/card3-BGEH_YDt.webp"
  , CT = i => {
    const e = {
        en: {
            title: "trade ideas",
            by: "by",
            cards: [{
                title: "Figma Stock Goes Parabolic in Market Debut — Should You Buy?",
                description: "Figma stock NYSE:FIG more than tripled on IPO day. But that's not thanks to the Figma guys — they had agreed...",
                author: "TradingView",
                date: "Aug 4"
            }, {
                title: "Nvidia - This is clearly not the end!",
                description: "Nvidia ( NASDAQ:NVDA ) will simply rally more! 🚀 Analysis summary: Yes, over the past couple of months, Nvidia has been rallying another +100%...",
                author: "tradingmtv",
                date: "17 hours ago"
            }, {
                title: "Small Caps: Rebound or rollover at 200DMA?",
                description: "Near-term price action in U.S. small-cap stocks may be instructive for assessing longer-term directional risks, with the contract trading near the key 200-day simp...",
                author: "FOREX.com",
                date: "Aug 4"
            }]
        },
        pt: {
            title: "ideias de negociação",
            by: "por",
            cards: [{
                title: "Ações da Figma Vão Parabolicamente em Estreia de Mercado — Deve Comprar?",
                description: "Ações da Figma NYSE:FIG mais do que triplicaram no dia do IPO. Mas isso não é graças aos caras da Figma — eles já tinham concordado...",
                author: "TradingView",
                date: "4 de Ago"
            }, {
                title: "Nvidia - Isto claramente não é o fim!",
                description: "Nvidia (NASDAQ:NVDA) simplesmente vai subir mais! 🚀 Resumo da análise: Sim, nos últimos meses, a Nvidia tem subido mais +100%...",
                author: "tradingmtv",
                date: "há 17 horas"
            }, {
                title: "Small Caps: Recuperação ou queda nos 200DMA?",
                description: "A ação de preços de curto prazo em ações de pequena capitalização dos EUA pode ser instrutiva para avaliar riscos direcionais de longo prazo, com o contrato sendo negociado próximo à chave média móvel simples de 200 dias...",
                author: "FOREX.com",
                date: "4 de Ago"
            }]
        },
        "zh-TW": {
            title: "交易想法",
            by: "由",
            cards: [{
                title: "Figma股票在市場首次亮相時拋物線上漲——你應該買嗎？",
                description: "Figma股票NYSE:FIG在IPO當天上漲了三倍多。但這並不歸功於Figma的人——他們已經同意了...",
                author: "TradingView",
                date: "8月4日"
            }, {
                title: "Nvidia - 這顯然不是結束！",
                description: "Nvidia（NASDAQ:NVDA）將簡單地繼續上漲！🚀 分析摘要：是的，在過去的幾個月裡，Nvidia又上漲了+100%...",
                author: "tradingmtv",
                date: "17小時前"
            }, {
                title: "小盤股：在200日均線反彈還是翻轉？",
                description: "美國小盤股的短期價格走勢可能有助於評估長期方向性風險，合約在關鍵的200日簡單移動平均線附近交易...",
                author: "FOREX.com",
                date: "8月4日"
            }]
        },
        es: {
            title: "ideas de trading",
            by: "por",
            cards: [{
                title: "Las acciones de Figma se disparan parabólicamente en su debut en el mercado — ¿Deberías comprar?",
                description: "Las acciones de Figma NYSE:FIG se triplicaron en el día de la OPI. Pero eso no es gracias a los chicos de Figma — habían acordado...",
                author: "TradingView",
                date: "4 de agosto"
            }, {
                title: "Nvidia - ¡Esto claramente no es el final!",
                description: "¡Nvidia (NASDAQ:NVDA) simplemente subirá más! 🚀 Resumen del análisis: Sí, durante los últimos meses, Nvidia ha estado subiendo otro +100%...",
                author: "tradingmtv",
                date: "hace 17 horas"
            }, {
                title: "Pequeñas capitalizaciones: ¿Rebote o caída en la media móvil de 200 días?",
                description: "La acción del precio a corto plazo en las acciones de pequeña capitalización de EE.UU. puede ser instructiva para evaluar los riesgos direccionales a largo plazo, con el contrato operando cerca de la media móvil simple de 200 días clave...",
                author: "FOREX.com",
                date: "4 de agosto"
            }]
        },
        ar: {
            title: "أفكار التداول",
            by: "بواسطة",
            cards: [{
                title: "أسهم Figma ترتفع بشكل مكافئ في ظهورها الأول في السوق — هل يجب أن تشتري؟",
                description: "أسهم Figma NYSE:FIG زادت أكثر من ثلاثة أضعاف في يوم الطرح العام. لكن ذلك ليس بفضل رجال Figma — لقد وافقوا...",
                author: "TradingView",
                date: "4 أغسطس"
            }, {
                title: "Nvidia - هذا ليس النهاية بوضوح!",
                description: "Nvidia (NASDAQ:NVDA) سترتفع ببساطة أكثر! 🚀 ملخص التحليل: نعم، خلال الشهرين الماضيين، كانت Nvidia ترتفع بـ +100% أخرى...",
                author: "tradingmtv",
                date: "منذ 17 ساعة"
            }, {
                title: "الشركات الصغيرة: ارتداد أم انقلاب عند المتوسط المتحرك لـ 200 يوم؟",
                description: "قد يكون العمل السعري قصير المدى في أسهم الشركات الصغيرة الأمريكية مفيداً لتقييم المخاطر الاتجاهية طويلة المدى، مع تداول العقد بالقرب من المتوسط المتحرك البسيط الرئيسي لـ 200 يوم...",
                author: "FOREX.com",
                date: "4 أغسطس"
            }]
        },
        th: {
            title: "ไอเดียการเทรด",
            by: "โดย",
            cards: [{
                title: "หุ้น Figma พุ่งแบบพาราโบลิกในการเปิดตัวตลาด — คุณควรซื้อไหม?",
                description: "หุ้น Figma NYSE:FIG เพิ่มขึ้นมากกว่าสามเท่าในวัน IPO แต่นั่นไม่ใช่เพราะคนของ Figma — พวกเขาได้ตกลงกัน...",
                author: "TradingView",
                date: "4 สิงหาคม"
            }, {
                title: "Nvidia - นี่ไม่ใช่จุดจบอย่างชัดเจน!",
                description: "Nvidia (NASDAQ:NVDA) จะเพิ่มขึ้นอีกอย่างง่ายดาย! 🚀 สรุปการวิเคราะห์: ใช่ ในช่วงสองสามเดือนที่ผ่านมา Nvidia ได้เพิ่มขึ้นอีก +100%...",
                author: "tradingmtv",
                date: "17 ชั่วโมงที่แล้ว"
            }, {
                title: "หุ้นมูลค่าตลาดเล็ก: เด้งกลับหรือพลิกที่ 200DMA?",
                description: "การเคลื่อนไหวของราคาระยะสั้นในหุ้นมูลค่าตลาดเล็กของสหรัฐอาจให้ข้อมูลสำหรับการประเมินความเสี่ยงทิศทางระยะยาว โดยสัญญาซื้อขายใกล้เส้นค่าเฉลี่ยเคลื่อนที่แบบง่าย 200 วันที่สำคัญ...",
                author: "FOREX.com",
                date: "4 สิงหาคม"
            }]
        },
        vi: {
            title: "ý tưởng giao dịch",
            by: "bởi",
            cards: [{
                title: "Cổ phiếu Figma tăng vọt parabol trong lần ra mắt thị trường — Bạn có nên mua?",
                description: "Cổ phiếu Figma NYSE:FIG đã tăng gấp ba lần trong ngày IPO. Nhưng điều đó không phải nhờ những người Figma — họ đã đồng ý...",
                author: "TradingView",
                date: "4 tháng 8"
            }, {
                title: "Nvidia - Đây rõ ràng không phải là kết thúc!",
                description: "Nvidia (NASDAQ:NVDA) sẽ đơn giản là tăng thêm! 🚀 Tóm tắt phân tích: Vâng, trong vài tháng qua, Nvidia đã tăng thêm +100%...",
                author: "tradingmtv",
                date: "17 giờ trước"
            }, {
                title: "Cổ phiếu vốn hóa nhỏ: Phục hồi hay lật ngược tại 200DMA?",
                description: "Hành động giá ngắn hạn trong cổ phiếu vốn hóa nhỏ của Mỹ có thể hữu ích để đánh giá rủi ro định hướng dài hạn, với hợp đồng giao dịch gần đường trung bình động đơn giản 200 ngày quan trọng...",
                author: "FOREX.com",
                date: "4 tháng 8"
            }]
        },
        bn: {
            title: "ট্রেডিং আইডিয়া",
            by: "দ্বারা",
            cards: [{
                title: "Figma স্টক বাজারে প্রথম আবির্ভাবে প্যারাবলিক হয়ে যায় — আপনার কি কিনতে হবে?",
                description: "Figma স্টক NYSE:FIG IPO দিনে তিনগুণেরও বেশি বেড়েছে। কিন্তু এটা Figma গাইদের জন্য নয় — তারা সম্মত হয়েছিল...",
                author: "TradingView",
                date: "৪ আগস্ট"
            }, {
                title: "Nvidia - এটি স্পষ্টভাবে শেষ নয়!",
                description: "Nvidia (NASDAQ:NVDA) কেবল আরও বৃদ্ধি পাবে! 🚀 বিশ্লেষণ সারসংক্ষেপ: হ্যাঁ, গত কয়েক মাসে, Nvidia আরও +100% বৃদ্ধি পেয়েছে...",
                author: "tradingmtv",
                date: "১৭ ঘন্টা আগে"
            }, {
                title: "ছোট ক্যাপ: 200DMA-তে রিবাউন্ড নাকি রোলওভার?",
                description: "মার্কিন ছোট-ক্যাপ স্টকগুলিতে নিকট-মেয়াদী মূল্য ক্রিয়া দীর্ঘমেয়াদী দিকনির্দেশনা ঝুঁকি মূল্যায়নের জন্য নির্দেশনামূলক হতে পারে, চুক্তিটি মূল 200-দিনের সরল গড়ের কাছাকাছি ট্রেড করছে...",
                author: "FOREX.com",
                date: "৪ আগস্ট"
            }]
        },
        mn: {
            title: "арилжааны санаа",
            by: "-аас",
            cards: [{
                title: "Figma хувьцаа зах зээлд анх гарсан өдрөө параболын хэлбэрээр өсчээ — Та худалдаж авах уу?",
                description: "Figma хувьцаа NYSE:FIG IPO өдөр гурав дахин өссөн. Гэхдээ энэ нь Figma-н хүмүүсийн ачаар биш — тэд тохиролцсон байсан...",
                author: "TradingView",
                date: "8-р сарын 4"
            }, {
                title: "Nvidia - Энэ нь тодорхой төгсгөл биш!",
                description: "Nvidia (NASDAQ:NVDA) зүгээр л илүү өснө! 🚀 Шинжилгээний хураангуй: Тийм ээ, сүүлийн хэдэн сарын турш Nvidia дахин +100% өссөн...",
                author: "tradingmtv",
                date: "17 цагийн өмнө"
            }, {
                title: "Жижиг компаниуд: 200DMA дээр сэргэх үү эсвэл унах уу?",
                description: "АНУ-ын жижиг компаниудын хувьцааны богино хугацааны үнийн хөдөлгөөн нь урт хугацааны чиглэлийн эрсдэлийг үнэлэхэд тустай байж болох бөгөөд гэрээ нь 200 хоногийн энгийн хөдлөх дундажийн ойролцоо арилжаалагдаж байна...",
                author: "FOREX.com",
                date: "8-р сарын 4"
            }]
        },
        ja: {
            title: "トレードアイデア",
            by: "投稿者：",
            cards: [{
                title: "Figma株が市場デビューで放物線的に急騰 — 買うべき？",
                description: "Figma株NYSE:FIGはIPO日に3倍以上上昇しました。しかし、これはFigmaの人たちのおかげではありません — 彼らは同意していました...",
                author: "TradingView",
                date: "8月4日"
            }, {
                title: "Nvidia - これは明らかに終わりではない！",
                description: "Nvidia (NASDAQ:NVDA) は単純にさらに上昇するでしょう！🚀 分析要約：はい、過去数ヶ月間、Nvidiaはさらに+100%上昇しています...",
                author: "tradingmtv",
                date: "17時間前"
            }, {
                title: "小型株：200日移動平均でリバウンドか反転か？",
                description: "米国小型株の短期的な価格動向は、長期的な方向性リスクを評価するのに参考になる可能性があり、契約は重要な200日単純移動平均付近で取引されています...",
                author: "FOREX.com",
                date: "8月4日"
            }]
        },
        tr: {
            title: "ticaret fikirleri",
            by: "tarafından",
            cards: [{
                title: "Figma Hissesi Piyasa Çıkışında Parabolik Yükseliyor — Almalı mısınız?",
                description: "Figma hissesi NYSE:FIG halka arz gününde üç katından fazla yükseldi. Ancak bu Figma ekibinin sayesinde değil — onlar anlaşmıştı...",
                author: "TradingView",
                date: "4 Ağustos"
            }, {
                title: "Nvidia - Bu açıkça son değil!",
                description: "Nvidia (NASDAQ:NVDA) basitçe daha da yükselecek! 🚀 Analiz özeti: Evet, son birkaç ay boyunca, Nvidia başka bir +100% yükseliş gösterdi...",
                author: "tradingmtv",
                date: "17 saat önce"
            }, {
                title: "Küçük Sermayeli Hisseler: 200DMA'da Toparlanma mı Tersine Dönüş mü?",
                description: "ABD küçük sermayeli hisse senetlerindeki yakın vadeli fiyat hareketi, uzun vadeli yönlü riskleri değerlendirmek için öğretici olabilir, sözleşme kilit 200 günlük basit hareketli ortalama yakınında işlem görüyor...",
                author: "FOREX.com",
                date: "4 Ağustos"
            }]
        },
        ko: {
            title: "트레이딩 아이디어",
            by: "작성자:",
            cards: [{
                title: "Figma 주식이 시장 데뷔에서 포물선 상승 — 사야 할까요?",
                description: "Figma 주식 NYSE:FIG는 IPO 당일 3배 이상 상승했습니다. 하지만 이는 Figma 팀 덕분이 아닙니다 — 그들은 동의했었습니다...",
                author: "TradingView",
                date: "8월 4일"
            }, {
                title: "Nvidia - 이것은 분명히 끝이 아닙니다!",
                description: "Nvidia (NASDAQ:NVDA)는 단순히 더 상승할 것입니다! 🚀 분석 요약: 네, 지난 몇 달 동안 Nvidia는 또 다른 +100% 상승을 보였습니다...",
                author: "tradingmtv",
                date: "17시간 전"
            }, {
                title: "소형주: 200일 이동평균에서 반등인가 반전인가?",
                description: "미국 소형주의 단기 가격 움직임은 장기 방향성 위험을 평가하는 데 도움이 될 수 있으며, 계약은 핵심 200일 단순 이동평균 근처에서 거래되고 있습니다...",
                author: "FOREX.com",
                date: "8월 4일"
            }]
        },
        ka: {
            title: "ვაჭრობის იდეები",
            by: "ავტორი:",
            cards: [{
                title: "Figma-ს აქციები ბაზარზე პირველი გამოსვლისას პარაბოლურად იზრდება — უნდა იყიდოთ?",
                description: "Figma-ს აქციებმა NYSE:FIG IPO დღეს სამჯერ მეტი გაიზარდა. მაგრამ ეს Figma-ს ხალხის წყალობით არ არის — ისინი შეთანხმდნენ...",
                author: "TradingView",
                date: "4 აგვისტო"
            }, {
                title: "Nvidia - ეს აშკარად არ არის დასასრული!",
                description: "Nvidia (NASDAQ:NVDA) უბრალოდ კიდევ უფრო გაიზრდება! 🚀 ანალიზის რეზიუმე: დიახ, ბოლო რამდენიმე თვის განმავლობაში, Nvidia-მ კიდევ +100% ზრდა აჩვენა...",
                author: "tradingmtv",
                date: "17 საათის წინ"
            }, {
                title: "პატარა კაპიტალიზაცია: აღდგენა თუ გადატრიალება 200DMA-ზე?",
                description: "აშშ-ს პატარა კაპიტალიზაციის აქციების მოკლევადიანი ფასის მოქმედება შეიძლება სასარგებლო იყოს გრძელვადიანი მიმართულების რისკების შეფასებისთვის, კონტრაქტი ვაჭრობს მთავარი 200-დღიანი მარტივი მოძრავი საშუალების მახლობლად...",
                author: "FOREX.com",
                date: "4 აგვისტო"
            }]
        },
        ru: {
            title: "торговые идеи",
            by: "автор:",
            cards: [{
                title: "Акции Figma растут параболически в рыночном дебюте — стоит ли покупать?",
                description: "Акции Figma NYSE:FIG выросли более чем в три раза в день IPO. Но это не благодаря парням из Figma — они договорились...",
                author: "TradingView",
                date: "4 августа"
            }, {
                title: "Nvidia - это явно не конец!",
                description: "Nvidia (NASDAQ:NVDA) просто продолжит расти! 🚀 Резюме анализа: Да, за последние несколько месяцев Nvidia показала еще +100% роста...",
                author: "tradingmtv",
                date: "17 часов назад"
            }, {
                title: "Акции малой капитализации: отскок или разворот на 200DMA?",
                description: "Краткосрочная ценовая динамика американских акций малой капитализации может быть поучительной для оценки долгосрочных направленных рисков, контракт торгуется вблизи ключевой 200-дневной простой скользящей средней...",
                author: "FOREX.com",
                date: "4 августа"
            }]
        },
        id: {
            title: "ide trading",
            by: "oleh",
            cards: [{
                title: "Saham Figma Melambung Parabolik dalam Debut Pasar — Haruskah Anda Beli?",
                description: "Saham Figma NYSE:FIG naik lebih dari tiga kali lipat pada hari IPO. Tapi itu bukan berkat orang-orang Figma — mereka telah setuju...",
                author: "TradingView",
                date: "4 Agustus"
            }, {
                title: "Nvidia - Ini jelas bukan akhir!",
                description: "Nvidia (NASDAQ:NVDA) akan terus naik! 🚀 Ringkasan analisis: Ya, selama beberapa bulan terakhir, Nvidia telah naik lagi +100%...",
                author: "tradingmtv",
                date: "17 jam lalu"
            }, {
                title: "Saham Berkapitalisasi Kecil: Rebound atau rollover di 200DMA?",
                description: "Aksi harga jangka pendek pada saham berkapitalisasi kecil AS mungkin instruktif untuk menilai risiko arah jangka panjang, dengan kontrak diperdagangkan dekat rata-rata bergerak sederhana 200 hari yang kunci...",
                author: "FOREX.com",
                date: "4 Agustus"
            }]
        },
        sq: {
            title: "ide tregtie",
            by: "nga",
            cards: [{
                title: "Aksionet e Figma shkojnë parabolike në debutimin e tregut — A duhet të blini?",
                description: "Aksionet e Figma NYSE:FIG u rritën më shumë se tre herë në ditën e IPO-së. Por kjo nuk është falë njerëzve të Figma — ata kishin rënë dakord...",
                author: "TradingView",
                date: "4 Gusht"
            }, {
                title: "Nvidia - Kjo qartë nuk është fundi!",
                description: "Nvidia (NASDAQ:NVDA) thjesht do të vazhdojë të rritet! 🚀 Përmbledhje e analizës: Po, gjatë disa muajve të fundit, Nvidia ka qenë duke u rritur edhe +100%...",
                author: "tradingmtv",
                date: "17 orë më parë"
            }, {
                title: "Kapitalizimi i Vogël: Rimëkëmbje apo përmbysje në 200DMA?",
                description: "Veprimi i çmimit afatshkurtër në aksionet amerikane me kapitalizim të vogël mund të jetë mësimdhënës për vlerësimin e rreziqeve drejtuese afatgjata, me kontratën që tregtohet pranë mesatares së lëvizshme të thjeshtë 200-ditore kryesore...",
                author: "FOREX.com",
                date: "4 Gusht"
            }]
        },
        bs: {
            title: "trgovinske ideje",
            by: "od",
            cards: [{
                title: "Figma dionice idu parabolično u tržišnom debiju — Da li treba kupiti?",
                description: "Figma dionice NYSE:FIG porasle su više od tri puta na dan IPO-a. Ali to nije zahvaljujući Figma ljudima — oni su se složili...",
                author: "TradingView",
                date: "4. avgust"
            }, {
                title: "Nvidia - Ovo očigledno nije kraj!",
                description: "Nvidia (NASDAQ:NVDA) će jednostavno još više rasti! 🚀 Sažetak analize: Da, tokom poslednjih nekoliko meseci, Nvidia je rasla još +100%...",
                author: "tradingmtv",
                date: "pre 17 sati"
            }, {
                title: "Male kapitalizacije: Oporavak ili preokret na 200DMA?",
                description: "Kratkoročna cenovorna akcija u američkim akcijama male kapitalizacije može biti poučna za procenu dugoročnih usmerenih rizika, sa ugovorom koji se trguje blizu ključnog 200-dnevnog jednostavnog pokretnog proeka...",
                author: "FOREX.com",
                date: "4. avgust"
            }]
        },
        bg: {
            title: "търговски идеи",
            by: "от",
            cards: [{
                title: "Акциите на Figma стават параболични в пазарния дебют — Трябва ли да купувате?",
                description: "Акциите на Figma NYSE:FIG се увеличиха повече от три пъти в деня на IPO. Но това не е благодарение на хората от Figma — те се бяха съгласили...",
                author: "TradingView",
                date: "4 август"
            }, {
                title: "Nvidia - Това очевидно не е краят!",
                description: "Nvidia (NASDAQ:NVDA) просто ще продължи да расте! 🚀 Резюме на анализа: Да, през последните няколко месеца Nvidia показа още +100% растеж...",
                author: "tradingmtv",
                date: "преди 17 часа"
            }, {
                title: "Малки капитализации: Възстановяване или преобръщане при 200DMA?",
                description: "Краткосрочното ценово действие в американските акции с малка капитализация може да бъде поучително за оценката на дългосрочните насочени рискове, като договорът се търгува близо до ключовата 200-дневна проста подвижна средна...",
                author: "FOREX.com",
                date: "4 август"
            }]
        },
        hr: {
            title: "trgovinske ideje",
            by: "od",
            cards: [{
                title: "Figma dionice idu parabolično u tržišnom debiju — Trebate li kupiti?",
                description: "Figma dionice NYSE:FIG porasle su više od tri puta na dan IPO-a. Ali to nije zahvaljujući Figma ljudima — oni su se dogovorili...",
                author: "TradingView",
                date: "4. kolovoza"
            }, {
                title: "Nvidia - Ovo očito nije kraj!",
                description: "Nvidia (NASDAQ:NVDA) jednostavno će još više rasti! 🚀 Sažetak analize: Da, tijekom posljednjih nekoliko mjeseci, Nvidia je rasla još +100%...",
                author: "tradingmtv",
                date: "prije 17 sati"
            }, {
                title: "Male kapitalizacije: Oporavak ili preokret na 200DMA?",
                description: "Kratkoročna cjenovna akcija u američkim dionicama male kapitalizacije može biti poučna za procjenu dugoročnih usmjerenih rizika, s ugovorom koji se trguje blizu ključnog 200-dnevnog jednostavnog pokretnog prosjeka...",
                author: "FOREX.com",
                date: "4. kolovoza"
            }]
        },
        xk: {
            title: "ide tregtie / трговинске идеје",
            by: "nga / од",
            cards: [{
                title: "Aksionet e Figma shkojnë parabolike në debutimin e tregut / Figma акције иду параболично у тржишном дебију — A duhet të blini / Да ли треба купити?",
                description: "Aksionet e Figma NYSE:FIG u rritën më shumë se tre herë në ditën e IPO-së / Figma акције NYSE:FIG порасле су више од три пута на дан IPO-а. Por kjo nuk është falë njerëzve të Figma / Али то није захваљујући Figma људима — ata kishin rënë dakord / они су се сложили...",
                author: "TradingView",
                date: "4 Gusht / 4. август"
            }, {
                title: "Nvidia - Kjo qartë nuk është fundi / Ово очигледно није крај!",
                description: "Nvidia (NASDAQ:NVDA) thjesht do të vazhdojë të rritet / ће једноставно још више расти! 🚀 Përmbledhje e analizës / Сажетак анализе: Po / Да, gjatë disa muajve të fundit / током последњих неколико месеци, Nvidia ka qenë duke u rritur edhe +100% / Nvidia је расла још +100%...",
                author: "tradingmtv",
                date: "17 orë më parë / пре 17 сати"
            }, {
                title: "Kapitalizimi i Vogël / Мале капитализације: Rimëkëmbje apo përmbysje në 200DMA / Опоравак или преокрет на 200DMA?",
                description: "Veprimi i çmimit afatshkurtër në aksionet amerikane me kapitalizim të vogël / Краткорочна ценовна акција у америчким акцијама мале капитализације mund të jetë mësimdhënës për vlerësimin e rreziqeve drejtuese afatgjata / може бити поучна за процену дугорочних усмерених ризика...",
                author: "FOREX.com",
                date: "4 Gusht / 4. август"
            }]
        },
        me: {
            title: "трговинске идеје",
            by: "од",
            cards: [{
                title: "Figma дионице иду параболично у тржишном дебију — Да ли треба купити?",
                description: "Figma дионице NYSE:FIG порасле су више од три пута на дан IPO-а. Али то није захваљујући Figma људима — они су се сложили...",
                author: "TradingView",
                date: "4. август"
            }, {
                title: "Nvidia - Ово очигледно није крај!",
                description: "Nvidia (NASDAQ:NVDA) ће једноставно још више расти! 🚀 Сажетак анализе: Да, током последњих неколико мјесеци, Nvidia је расла још +100%...",
                author: "tradingmtv",
                date: "прије 17 сати"
            }, {
                title: "Мале капитализације: Опоравак или преокрет на 200DMA?",
                description: "Краткорочна цијенска акција у америчким дионицама мале капитализације може бити поучна за процјену дугорочних усмјерених ризика, са уговором који се тргује близу кључног 200-дневног једноставног покретног просјека...",
                author: "FOREX.com",
                date: "4. август"
            }]
        },
        mk: {
            title: "трговски идеи",
            by: "од",
            cards: [{
                title: "Figma акциите стануваат параболични во пазарниот дебит — Треба ли да купувате?",
                description: "Figma акциите NYSE:FIG се зголемија повеќе од три пати во денот на IPO. Но тоа не е благодарение на луѓето од Figma — тие се договорија...",
                author: "TradingView",
                date: "4 август"
            }, {
                title: "Nvidia - Ова очигледно не е крајот!",
                description: "Nvidia (NASDAQ:NVDA) едноставно ќе продолжи да расте! 🚀 Резиме на анализата: Да, во последните неколку месеци, Nvidia покажа уште +100% раст...",
                author: "tradingmtv",
                date: "пред 17 часа"
            }, {
                title: "Мали капитализации: Опоравување или преврт на 200DMA?",
                description: "Краткорочното ценовно дејствување во американските акции со мала капитализација може да биде поучно за проценка на долгорочните насочени ризици, со договорот што се тргува блиску до клучниот 200-дневен едноставен подвижен просек...",
                author: "FOREX.com",
                date: "4 август"
            }]
        },
        ro: {
            title: "idei de trading",
            by: "de",
            cards: [{
                title: "Acțiunile Figma devin parabolice în debutul de piață — Ar trebui să cumpărați?",
                description: "Acțiunile Figma NYSE:FIG au crescut de mai mult de trei ori în ziua IPO. Dar asta nu e datorită oamenilor de la Figma — ei se înțeleseseră...",
                author: "TradingView",
                date: "4 august"
            }, {
                title: "Nvidia - Acesta în mod clar nu este sfârșitul!",
                description: "Nvidia (NASDAQ:NVDA) pur și simplu va continua să crească! 🚀 Rezumatul analizei: Da, în ultimele câteva luni, Nvidia a crescut cu încă +100%...",
                author: "tradingmtv",
                date: "acum 17 ore"
            }, {
                title: "Capitalizări mici: Rebound sau rollover la 200DMA?",
                description: "Acțiunea prețurilor pe termen scurt în acțiunile americane cu capitalizare mică poate fi instructivă pentru evaluarea riscurilor direcționale pe termen lung, cu contractul tranzacționat aproape de media mobilă simplă cheie de 200 de zile...",
                author: "FOREX.com",
                date: "4 august"
            }]
        },
        sr: {
            title: "трговинске идеје",
            by: "од",
            cards: [{
                title: "Figma дионице иду параболично у тржишном дебију — Да ли треба купити?",
                description: "Figma дионице NYSE:FIG порасле су више од три пута на дан IPO-а. Али то није захваљујући Figma људима — они су се сложили...",
                author: "TradingView",
                date: "4. август"
            }, {
                title: "Nvidia - Ово очигледно није крај!",
                description: "Nvidia (NASDAQ:NVDA) ће једноставно још више расти! 🚀 Сажетак анализе: Да, током последњих неколико месеци, Nvidia је расла још +100%...",
                author: "tradingmtv",
                date: "пре 17 сати"
            }, {
                title: "Мале капитализације: Опоравак или преокрет на 200DMA?",
                description: "Краткорочна ценовна акција у америчким акцијама мале капитализације може бити поучна за процену дугорочних усмерених ризика, са уговором који се тргује близу кључног 200-дневног једноставног покретног просека...",
                author: "FOREX.com",
                date: "4. август"
            }]
        },
        sl: {
            title: "trgovinske ideje",
            by: "od",
            cards: [{
                title: "Figma delnice gredo parabolično v tržnem debiju — Ali bi morali kupiti?",
                description: "Figma delnice NYSE:FIG so se povečale za več kot trikrat na dan IPO. Toda to ni zaradi Figma ljudi — dogovorili so se...",
                author: "TradingView",
                date: "4. avgust"
            }, {
                title: "Nvidia - To očitno ni konec!",
                description: "Nvidia (NASDAQ:NVDA) se bo preprosto še naprej povečevala! 🚀 Povzetek analize: Da, v zadnjih nekaj mesecih je Nvidia pokazala še +100% rasti...",
                author: "tradingmtv",
                date: "pred 17 urami"
            }, {
                title: "Majhne kapitalizacije: Odboj ali preobrat pri 200DMA?",
                description: "Kratkoročno cenovno delovanje v ameriških delnicah z majhno kapitalizacijo je lahko poučno za ocenjevanje dolgoročnih usmernih tveganj, s pogodbo, ki se trguje blizu ključnega 200-dnevnega preprostega drseče povprečja...",
                author: "FOREX.com",
                date: "4. avgust"
            }]
        },
        sk: {
            title: "obchodné nápady",
            by: "od",
            cards: [{
                title: "Akcie Figma idú parabolicky v tržnom debute — Mali by ste kúpiť?",
                description: "Akcie Figma NYSE:FIG vzrástli viac ako trojnásobne v deň IPO. Ale to nie je vďaka ľuďom z Figma — dohodli sa...",
                author: "TradingView",
                date: "4. august"
            }, {
                title: "Nvidia - Toto zjavne nie je koniec!",
                description: "Nvidia (NASDAQ:NVDA) jednoducho bude ďalej rásť! 🚀 Zhrnutie analýzy: Áno, počas posledných niekoľkých mesiacov Nvidia rástla ďalších +100%...",
                author: "tradingmtv",
                date: "pred 17 hodinami"
            }, {
                title: "Malé kapitalizácie: Odskok alebo prevrátenie pri 200DMA?",
                description: "Krátkodobé cenové pôsobenie v amerických akciách s malou kapitalizáciou môže byť poučné pre hodnotenie dlhodobých smerových rizík, s kontraktom obchodovaným blízko kľúčového 200-dňového jednoduchého kĺzavého priemeru...",
                author: "FOREX.com",
                date: "4. august"
            }]
        },
        md: {
            title: "idei de trading",
            by: "de",
            cards: [{
                title: "Acțiunile Figma devin parabolice în debutul de piață — Ar trebui să cumpărați?",
                description: "Acțiunile Figma NYSE:FIG au crescut de mai mult de trei ori în ziua IPO. Dar asta nu e datorită oamenilor de la Figma — ei se înțeleseseră...",
                author: "TradingView",
                date: "4 august"
            }, {
                title: "Nvidia - Acesta în mod clar nu este sfârșitul!",
                description: "Nvidia (NASDAQ:NVDA) pur și simplu va continua să crească! 🚀 Rezumatul analizei: Da, în ultimele câteva luni, Nvidia a crescut cu încă +100%...",
                author: "tradingmtv",
                date: "acum 17 ore"
            }, {
                title: "Capitalizări mici: Rebound sau rollover la 200DMA?",
                description: "Acțiunea prețurilor pe termen scurt în acțiunile americane cu capitalizare mică poate fi instructivă pentru evaluarea riscurilor direcționale pe termen lung, cu contractul tranzacționat aproape de media mobilă simplă cheie de 200 de zile...",
                author: "FOREX.com",
                date: "4 august"
            }]
        },
        by: {
            title: "гандлёвыя ідэі",
            by: "ад",
            cards: [{
                title: "Акцыі Figma ідуць парабалічна ў рыначным дэбюце — Ці варта купляць?",
                description: "Акцыі Figma NYSE:FIG узраслі больш чым у тры разы ў дзень IPO. Але гэта не дзякуючы людзям з Figma — яны дамовіліся...",
                author: "TradingView",
                date: "4 жніўня"
            }, {
                title: "Nvidia - Гэта відавочна не канец!",
                description: "Nvidia (NASDAQ:NVDA) проста будзе далей расці! 🚀 Рэзюмэ аналізу: Так, за апошнія некалькі месяцаў Nvidia паказала яшчэ +100% росту...",
                author: "tradingmtv",
                date: "17 гадзін таму"
            }, {
                title: "Малыя капіталізацыі: Адскок або пераварот пры 200DMA?",
                description: "Кароткатэрміновае цэнавое дзеянне ў амерыканскіх акцыях з малой капіталізацыяй можа быць павучальным для ацэнкі доўгатэрміновых накіраваных рызык, з кантрактам, які гандлюецца побач з ключавым 200-дзённым простым рухомым сярэднім...",
                author: "FOREX.com",
                date: "4 жніўня"
            }]
        }
    }
      , r = e[i] || e.en;
    return r.cards || (r.cards = e.en.cards),
    r
}
  , zT = [{
    id: 1,
    image: ST,
    comments: 8,
    boosts: 120
}, {
    id: 2,
    image: TT,
    comments: 3,
    boosts: 28
}, {
    id: 3,
    image: jT,
    comments: 1,
    boosts: 11
}]
  , AT = () => {
    const {i18n: i} = We()
      , e = i.language
      , r = CT(e)
      , a = N.useRef(null)
      , o = Ht(a, {
        once: !0,
        margin: "-100px"
    })
      , l = {
        hidden: {
            opacity: 0
        },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: .2
            }
        }
    }
      , u = {
        hidden: {
            opacity: 0,
            y: 50
        },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: .6,
                ease: "easeOut"
            }
        }
    };
    return x.jsx("section", {
        className: "py-4 sm:py-6 md:py-8 lg:py-12 px-2 sm:px-4 md:px-6 lg:px-8",
        children: x.jsxs("div", {
            className: "flex flex-col gap-4 sm:gap-6 md:gap-8 lg:gap-10 max-w-[1248px] w-full mx-auto",
            children: [x.jsxs(ee.div, {
                className: "flex items-center gap-2",
                initial: {
                    opacity: 0,
                    x: -50
                },
                animate: o ? {
                    opacity: 1,
                    x: 0
                } : {
                    opacity: 0,
                    x: -50
                },
                transition: {
                    duration: .6,
                    ease: "easeOut"
                },
                children: [x.jsx("a", {
                    href: "https://www.tradingview.com/ideas/",
                    className: "uppercase text-[#0D1013] font-bold text-[20px] xs:text-[24px] sm:text-[28px] md:text-[36px] lg:text-[48px] leading-[130%] hover:text-[#2862FF] transition-colors duration-300",
                    children: r.title
                }), x.jsx(wu, {})]
            }), x.jsx(ee.div, {
                ref: a,
                className: "w-full grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4 lg:gap-6",
                variants: l,
                initial: "hidden",
                animate: o ? "visible" : "hidden",
                children: r.cards.map( (d, p) => {
                    const h = zT[p];
                    return x.jsxs(ee.div, {
                        className: "flex flex-col gap-2 sm:gap-3 group",
                        variants: u,
                        children: [x.jsxs("div", {
                            className: "flex flex-col gap-2 sm:gap-2.5",
                            children: [x.jsx("div", {
                                className: "overflow-hidden rounded-lg",
                                children: x.jsx("img", {
                                    src: h.image,
                                    alt: `${d.title} chart`,
                                    className: "w-full h-auto object-cover group-hover:scale-105 transition-transform duration-300"
                                })
                            }), x.jsxs("div", {
                                className: "flex flex-col gap-1.5 sm:gap-2 px-1",
                                children: [x.jsx("h3", {
                                    className: "text-[#0D1013] font-bold text-[14px] xs:text-[15px] sm:text-[16px] md:text-[17px] lg:text-[18px] leading-[130%] group-hover:text-[#2862FF] transition-colors duration-300 line-clamp-2",
                                    children: d.title
                                }), x.jsx("p", {
                                    className: "text-[#3B4046] text-[12px] xs:text-[13px] sm:text-[14px] md:text-[15px] lg:text-[16px] leading-[130%] line-clamp-3",
                                    children: d.description
                                })]
                            })]
                        }), x.jsxs("div", {
                            className: "flex items-center justify-between px-1",
                            children: [x.jsxs("div", {
                                className: "flex flex-col gap-0.5 sm:gap-1",
                                children: [x.jsxs("span", {
                                    className: "text-[#191C1F] text-[10px] xs:text-[11px] sm:text-[12px] md:text-[13px] lg:text-[14px] leading-[130%]",
                                    children: [r.by, " ", d.author]
                                }), x.jsx("span", {
                                    className: "text-[#5F656C] text-[10px] xs:text-[11px] sm:text-[12px] md:text-[13px] lg:text-[14px] leading-[130%]",
                                    children: d.date
                                })]
                            }), x.jsxs("div", {
                                className: "flex gap-1.5 sm:gap-2",
                                children: [x.jsxs("div", {
                                    className: "py-1 sm:py-1.5 px-1.5 sm:px-2 flex items-center gap-0.5 sm:gap-1",
                                    children: [x.jsx(M0, {}), x.jsx("span", {
                                        className: "text-[#0D1013] text-[12px] xs:text-[13px] sm:text-[14px] md:text-[15px] lg:text-[16px] leading-[130%]",
                                        children: h.comments
                                    })]
                                }), x.jsxs("div", {
                                    className: "py-1 sm:py-1.5 px-1.5 sm:px-2 flex items-center gap-0.5 sm:gap-1 border border-[#D0D3D7] rounded-[5px]",
                                    children: [x.jsx(ET, {}), x.jsx("span", {
                                        className: "text-[#0D1013] text-[12px] xs:text-[13px] sm:text-[14px] md:text-[15px] lg:text-[16px] leading-[130%]",
                                        children: h.boosts
                                    })]
                                })]
                            })]
                        })]
                    }, h.id)
                }
                )
            })]
        })
    })
}
  , M0 = () => x.jsx("svg", {
    width: "28",
    height: "28",
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: x.jsx("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M9 22H20C21.0609 22 22.0783 21.5786 22.8284 20.8284C23.5786 20.0783 24 19.0609 24 18V9C24 7.93913 23.5786 6.92172 22.8284 6.17157C22.0783 5.42143 21.0609 5 20 5H7C5.93913 5 4.92172 5.42143 4.17157 6.17157C3.42143 6.92172 3 7.93913 3 9V26L4.5 25L9 22ZM4.5 23.2L8.17 20.75L8.55 20.5H20C20.3283 20.5 20.6534 20.4353 20.9567 20.3097C21.26 20.1841 21.5356 19.9999 21.7678 19.7678C21.9999 19.5356 22.1841 19.26 22.3097 18.9567C22.4353 18.6534 22.5 18.3283 22.5 18V9C22.5 8.33696 22.2366 7.70107 21.7678 7.23223C21.2989 6.76339 20.663 6.5 20 6.5H7C6.33696 6.5 5.70107 6.76339 5.23223 7.23223C4.76339 7.70107 4.5 8.33696 4.5 9V23.2ZM9 11H18V12.5H9V11ZM18 14.5H9V16H18V14.5Z",
        fill: "#0D1013"
    })
})
  , ET = () => x.jsxs("svg", {
    width: "28",
    height: "28",
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [x.jsx("path", {
        d: "M6.94 17.8998L5.88 16.8398L4.28 18.4298L5.35 19.4898L6.94 17.8898V17.8998ZM9.06 20.0198L8 18.9598L5 21.9598L6.06 23.0298L9.06 20.0198ZM10.12 21.0798L11.18 22.1398L9.59 23.7398L8.53 22.6698L10.13 21.0798H10.12Z",
        fill: "#0D1013"
    }), x.jsx("path", {
        d: "M14.72 13.2999C14.9466 13.5535 15.2226 13.7581 15.5311 13.9013C15.8395 14.0445 16.174 14.1233 16.5139 14.1328C16.8539 14.1423 17.1922 14.0824 17.5082 13.9566C17.8241 13.8309 18.1112 13.642 18.3516 13.4016C18.5921 13.1611 18.781 12.8741 18.9067 12.5581C19.0325 12.2421 19.0924 11.9038 19.0829 11.5639C19.0734 11.2239 18.9946 10.8895 18.8514 10.581C18.7082 10.2726 18.5035 9.99657 18.25 9.76992C17.7737 9.34417 17.1525 9.1169 16.5139 9.13477C15.8753 9.15264 15.2678 9.4143 14.8161 9.86602C14.3644 10.3177 14.1027 10.9253 14.0848 11.5639C14.067 12.2024 14.2942 12.8236 14.72 13.2999Z",
        fill: "#0D1013"
    }), x.jsx("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M23.91 4.0999L23.95 4.7699C24.02 5.8599 23.9 7.8099 23.37 9.8899C22.87 11.8799 21.97 14.0599 20.42 15.7299V19.9799L15 25.3999L13.9 20.6299C13.46 20.8499 13.1 20.9999 12.83 21.0899L12.39 21.2299L6.79 15.6299L6.94 15.1899C7.03 14.9199 7.17 14.5599 7.39 14.1199L2.62 13.0199L8.04 7.5999H12.29C13.9625 6.14842 15.9692 5.13479 18.13 4.6499C20.22 4.1199 22.17 4.0099 23.25 4.0699L23.91 4.1099V4.0999ZM15.26 19.8799C16.5584 19.0838 17.7833 18.1736 18.92 17.1599V19.3599L15.85 22.4199L15.26 19.8799ZM10.86 9.0999C9.84638 10.2367 8.93612 11.4615 8.14 12.7599L5.6 12.1599L8.66 9.0999H10.86ZM18.5 6.0999C16.55 6.5999 14.55 7.4599 13.13 8.8799C11.2311 10.7099 9.6734 12.8635 8.52999 15.2399L12.78 19.4999C15.1564 18.3565 17.31 16.7988 19.14 14.8999C20.5247 13.383 21.4838 11.5269 21.92 9.5199C22.31 7.9899 22.45 6.5499 22.47 5.5499C21.47 5.5699 20.03 5.7099 18.5 6.0999Z",
        fill: "#0D1013"
    })]
})
  , DT = "/cdn/shop/t/1/assets/card3-BGEH_YDt.webp"
  , IT = "/cdn/shop/t/1/assets/card22-BN2VgBvI.webp"
  , MT = "/cdn/shop/t/1/assets/card33-CbeechLV.webp"
  , VT = i => {
    const e = {
        en: {
            title: "community ideas",
            by: "by",
            metaTitle: "Meta Platforms (META) Shares Decline",
            metaDesc: "Meta Platforms (META) Shares Decline Shares of the US tech giant Meta Platforms (META) reached high last week, climbing above $780 following the release of ...",
            oilTitle: "USOIL declines for the 3 days in a row. What's next?",
            oilDesc: "USOIL declines for the 3 days in a row. What's next? Since the last post the USOIL has already declined on 2.5%, currently rebounding from $AA50 on chart...",
            capsTitle: "Small Caps: Rebound or rollover at 200DMA?",
            capsDesc: "Near-term price action in U.S. small-cap stocks may be instructive for assessing longer-term directional risks, with the contract trading near the key 200-day simp..."
        },
        pt: {
            title: "ideias da comunidade",
            by: "por",
            metaTitle: "Ações da Meta Platforms (META) Declínio",
            metaDesc: "Ações da Meta Platforms (META) Declínio As ações do gigante de tecnologia dos EUA Meta Platforms (META) atingiram um pico na semana passada, subindo acima de $780 após o lançamento de...",
            oilTitle: "USOIL declina por 3 dias seguidos. O que vem a seguir?",
            oilDesc: "USOIL declina por 3 dias seguidos. O que vem a seguir? Desde a última postagem, o USOIL já declinou 2.5%, atualmente se recuperando de $AA50 no gráfico...",
            capsTitle: "Small Caps: Recuperação ou queda na 200DMA?",
            capsDesc: "A ação de preço de curto prazo em ações de small caps dos EUA pode ser instrutiva para avaliar riscos direcionais de longo prazo, com o contrato negociando próximo à chave média simples de 200 dias..."
        },
        "zh-TW": {
            title: "社群想法",
            by: "由",
            metaTitle: "Meta Platforms (META) 股價下跌",
            metaDesc: "美國科技巨頭 Meta Platforms (META) 股價上周創下新高，在發布...後攀升至 780 美元以上",
            oilTitle: "USOIL連續3天下跌。接下來會怎樣？",
            oilDesc: "USOIL連續3天下跌。接下來會怎樣？自從上次發文以來，USOIL已經下跌了2.5%，目前從圖表上的$AA50反彈...",
            capsTitle: "小型股：在200日均線反彈還是回落？",
            capsDesc: "美國小型股的近期價格走勢可能有助於評估長期方向性風險，合約交易接近關鍵的200日簡單..."
        },
        es: {
            title: "ideas de la comunidad",
            by: "por",
            metaTitle: "Las acciones de Meta Platforms (META) caen",
            metaDesc: "Las acciones del gigante tecnológico estadounidense Meta Platforms (META) alcanzaron un máximo la semana pasada, superando los $780 tras el lanzamiento de ...",
            oilTitle: "USOIL cae por 3 días consecutivos. ¿Qué sigue?",
            oilDesc: "USOIL cae por 3 días consecutivos. ¿Qué sigue? Desde la última publicación, USOIL ya ha caído un 2.5%, actualmente rebotando desde $AA50 en el gráfico...",
            capsTitle: "Small Caps: ¿Rebote o reversión en la media de 200 días?",
            capsDesc: "La acción del precio a corto plazo en acciones de pequeña capitalización de EE.UU. puede ser instructiva para evaluar los riesgos direccionales a más largo plazo, con el contrato operando cerca de la clave media simple de 200 días..."
        },
        ar: {
            title: "أفكار المجتمع",
            by: "بواسطة",
            metaTitle: "انخفاض أسهم Meta Platforms (META)",
            metaDesc: "وصلت أسهم عملاق التكنولوجيا الأمريكي Meta Platforms (META) إلى ارتفاع الأسبوع الماضي، متجاوزة 780 دولارًا بعد إطلاق ...",
            oilTitle: "انخفاض USOIL لمدة 3 أيام متتالية. ما التالي؟",
            oilDesc: "انخفاض USOIL لمدة 3 أيام متتالية. ما التالي؟ منذ آخر منشور، انخفض USOIL بالفعل بنسبة 2.5٪، ويتعافى حاليًا من 50 دولارًا على الرسم البياني...",
            capsTitle: "الأسهم الصغيرة: انتعاش أم انعكاس عند المتوسط المتحرك لـ200 يوم؟",
            capsDesc: "قد يكون تحرك الأسعار على المدى القصير في الأسهم الأمريكية الصغيرة مفيدًا لتقييم المخاطر الاتجاهية على المدى الطويل، مع تداول العقد بالقرب من المتوسط المتحرك البسيط الرئيسي لمدة 200 يوم..."
        },
        th: {
            title: "ไอเดียจากชุมชน",
            by: "โดย",
            metaTitle: "หุ้น Meta Platforms (META) ลดลง",
            metaDesc: "หุ้นของยักษ์ใหญ่ด้านเทคโนโลยีสหรัฐ Meta Platforms (META) แตะระดับสูงสุดเมื่อสัปดาห์ที่แล้ว พุ่งสูงกว่า 780 ดอลลาร์ หลังการเปิดตัว...",
            oilTitle: "USOIL ลดลงต่อเนื่อง 3 วัน แล้วอะไรต่อไป?",
            oilDesc: "USOIL ลดลงต่อเนื่อง 3 วัน แล้วอะไรต่อไป? นับตั้งแต่โพสต์ล่าสุด USOIL ลดลงแล้ว 2.5% ปัจจุบันฟื้นตัวจาก $AA50 บนกราฟ...",
            capsTitle: "หุ้น Small Caps: ฟื้นตัวหรือพลิกตัวที่เส้น 200 วัน?",
            capsDesc: "การเคลื่อนไหวของราคาหุ้น small-cap สหรัฐในระยะสั้นอาจเป็นประโยชน์สำหรับการประเมินความเสี่ยงในระยะยาว โดยสัญญาซื้อขายอยู่ใกล้เส้นค่าเฉลี่ยเคลื่อนที่แบบง่าย 200 วัน..."
        },
        vi: {
            title: "ý tưởng cộng đồng",
            by: "bởi",
            metaTitle: "Cổ phiếu Meta Platforms (META) giảm",
            metaDesc: "Cổ phiếu của gã khổng lồ công nghệ Mỹ Meta Platforms (META) đã đạt mức cao vào tuần trước, vượt trên 780 đô la sau khi phát hành...",
            oilTitle: "USOIL giảm 3 ngày liên tiếp. Điều gì tiếp theo?",
            oilDesc: "USOIL giảm 3 ngày liên tiếp. Điều gì tiếp theo? Kể từ bài đăng cuối cùng, USOIL đã giảm 2.5%, hiện đang phục hồi từ mức $AA50 trên biểu đồ...",
            capsTitle: "Cổ phiếu vốn nhỏ: Phục hồi hay đảo chiều tại đường MA 200 ngày?",
            capsDesc: "Biến động giá ngắn hạn của cổ phiếu vốn nhỏ Mỹ có thể hữu ích để đánh giá rủi ro định hướng dài hạn, với hợp đồng giao dịch gần mức trung bình động đơn giản 200 ngày quan trọng..."
        },
        ja: {
            title: "コミュニティアイデア",
            by: "投稿者：",
            metaTitle: "Meta Platforms (META)株が下落",
            metaDesc: "米国テック大手Meta Platforms (META)の株価は先週、リリース後に780ドルを超え、高値を更新しました...",
            oilTitle: "USOILが3日連続で下落。次はどうなる？",
            oilDesc: "USOILが3日連続で下落。次はどうなる？前回の投稿以降、USOILはすでに2.5%下落しており、現在はチャート上の$AA50から反発しています...",
            capsTitle: "小型株：200日移動平均線で反発か反転か？",
            capsDesc: "米国小型株の短期的な価格変動は、長期的な方向性リスクを評価する上で有益かもしれません。契約は重要な200日単純移動平均線近辺で取引されています..."
        },
        ko: {
            title: "커뮤니티 아이디어",
            by: "작성자:",
            metaTitle: "Meta Platforms (META) 주식 하락",
            metaDesc: "미국 기술 대기업 Meta Platforms (META)의 주가는 지난주 출시 후 780달러를 넘어 사상 최고치를 기록했습니다...",
            oilTitle: "USOIL, 3일 연속 하락. 다음은?",
            oilDesc: "USOIL이 3일 연속 하락했습니다. 다음은 무엇일까요? 지난 게시물 이후 USOIL은 이미 2.5% 하락했으며 현재 차트에서 $AA50에서 반등 중입니다...",
            capsTitle: "소형주: 200일 이동평균에서 반등할까, 반전할까?",
            capsDesc: "미국 소형주의 단기 가격 움직임은 장기적인 방향성 위험을 평가하는 데 도움이 될 수 있으며, 계약은 중요한 200일 단순 이동 평균 근처에서 거래되고 있습니다..."
        },
        ru: {
            title: "идеи сообщества",
            by: "автор:",
            metaTitle: "Акции Meta Platforms (META) снижаются",
            metaDesc: "Акции американского технологического гиганта Meta Platforms (META) достигли максимума на прошлой неделе, поднявшись выше $780 после выпуска...",
            oilTitle: "USOIL падает 3 дня подряд. Что дальше?",
            oilDesc: "USOIL падает 3 дня подряд. Что дальше? С момента последнего поста USOIL уже упал на 2.5%, в настоящее время восстанавливается с уровня $AA50 на графике...",
            capsTitle: "Малые компании: отскок или разворот на 200-дневной скользящей?",
            capsDesc: "Краткосрочное движение цен на акции малых компаний США может быть поучительным для оценки долгосрочных направленных рисков, при этом контракт торгуется рядом с ключевой 200-дневной простой скользящей средней..."
        },
        bn: {
            title: "কমিউনিটি আইডিয়া",
            by: "দ্বারা",
            metaTitle: "Meta Platforms (META) এর শেয়ার হ্রাস পেয়েছে",
            metaDesc: "মার্কিন প্রযুক্তি জায়ান্ট Meta Platforms (META) এর শেয়ার গত সপ্তাহে উচ্চতায় পৌঁছেছে, প্রকাশনার পর $780 এর উপরে উঠেছে ...",
            oilTitle: "USOIL টানা 3 দিন ধরে কমছে। এরপর কি?",
            oilDesc: "USOIL টানা 3 দিন ধরে কমছে। এরপর কি? শেষ পোস্টের পর থেকে USOIL ইতিমধ্যে 2.5% কমেছে, বর্তমানে চার্টে $AA50 থেকে পুনরুদ্ধার হচ্ছে...",
            capsTitle: "ছোট ক্যাপ: 200DMA তে পুনরুদ্ধার নাকি রোলওভার?",
            capsDesc: "মার্কিন ছোট ক্যাপ স্টকের স্বল্পমেয়াদী মূল্য ক্রিয়া দীর্ঘমেয়াদী দিকনির্দেশক ঝুঁকি মূল্যায়নের জন্য নির্দেশিকা হতে পারে, চুক্তিটি মূল 200-দিনের সিম্প কাছাকাছি ট্রেডিং করছে..."
        },
        mn: {
            title: "олон нийтийн санаа",
            by: "-аас",
            metaTitle: "Meta Platforms (META)-ийн хувьцаа буурчээ",
            metaDesc: "АНУ-ын технологийн аварга том компани Meta Platforms (META)-ийн хувьцаа өнгөрсөн долоо хоногт өндөр түвшинд хүрч, гаргасан шинэ бүтээгдэхүүний дараа $780-аас дээш гарлаа...",
            oilTitle: "USOIL 3 өдрийн турш буурсан. Дараа нь юу вэ?",
            oilDesc: "USOIL 3 өдрийн турш буурсан. Дараа нь юу вэ? Сүүлийн нийтлэлээс хойш USOIL аль хэдийн 2.5%-иар буурч, одоо график дээрх $AA50-аас сэргэж байна...",
            capsTitle: "Жижиг капитал: 200 хоногийн дундаж дээр сэргэх үү, эсвэл буурах үү?",
            capsDesc: "АНУ-ын жижиг капиталын хувьцааны богино хугацааны үнийн хөдөлгөөн нь урт хугацааны чиглэлийн эрсдлийг үнэлэхэд тустай байж болох бөгөөд гэрээ нь гол 200 хоногийн энгийн дундаж орчим худалдаалагдаж байна..."
        },
        tr: {
            title: "topluluk fikirleri",
            by: "tarafından",
            metaTitle: "Meta Platforms (META) Hisse Senetleri Düşüşte",
            metaDesc: "ABD teknoloji devi Meta Platforms (META) hisse senetleri geçen hafta yüksek seviyelere ulaşarak, yayınlanan... sonrasında 780 doların üzerine çıktı",
            oilTitle: "USOIL üst üste 3 gündür düşüyor. Sırada ne var?",
            oilDesc: "USOIL üst üste 3 gündür düşüyor. Sırada ne var? Son gönderiden bu yana USOIL zaten %2,5 düştü ve şu anda grafikte $AA50 seviyesinden toparlanıyor...",
            capsTitle: "Küçük Şirketler: 200 Günlük Ortalamada Toparlanma mı Düşüş mü?",
            capsDesc: "ABD küçük şirket hisselerindeki kısa vadeli fiyat hareketleri, uzun vadeli yönlü riskleri değerlendirmek için öğretici olabilir, sözleşme kilit 200 günlük basit ortalamanın yakınında işlem görüyor..."
        },
        ka: {
            title: "საზოგადოების იდეები",
            by: "ავტორი:",
            metaTitle: "Meta Platforms (META) აქციები მცირდება",
            metaDesc: "აშშ-ის ტექნოლოგიური გიგანტის Meta Platforms (META) აქციები გასულ კვირას მაღალ დონეს მიაღწია, გამოშვების შემდეგ $780-ს გადააჭარბა...",
            oilTitle: "USOIL მესამე დღესაც მცირდება. რა იქნება შემდეგ?",
            oilDesc: "USOIL მესამე დღესაც მცირდება. რა იქნება შემდეგ? ბოლო პოსტის შემდეგ USOIL უკვე 2.5%-ით შემცირდა და ამჟამად გრაფიკზე $AA50-დან აღდგება...",
            capsTitle: "მცირე კაპიტალიზაცია: აღდგენა თუ ვარდნა 200DMA-ზე?",
            capsDesc: "აშშ-ის მცირე კაპიტალიზაციის აქციების მოკლევადიანი ფასების მოძრაობა შეიძლება სასარგებლო იყოს გრძელვადიანი მიმართულების რისკების შესაფასებლად, კონტრაქტი ვაჭრობს ძირითად 200-დღიან მარტივ საშუალოსთან..."
        },
        id: {
            title: "ide komunitas",
            by: "oleh",
            metaTitle: "Saham Meta Platforms (META) Menurun",
            metaDesc: "Saham raksasa teknologi AS Meta Platforms (META) mencapai titik tertinggi pekan lalu, melampaui $780 setelah rilis...",
            oilTitle: "USOIL turun selama 3 hari berturut-turut. Apa berikutnya?",
            oilDesc: "USOIL turun selama 3 hari berturut-turut. Apa berikutnya? Sejak posting terakhir, USOIL sudah turun 2.5%, saat ini pulih dari $AA50 pada grafik...",
            capsTitle: "Small Caps: Pemulihan atau penurunan di 200DMA?",
            capsDesc: "Aksi harga jangka pendek di saham small-cap AS mungkin instruktif untuk menilai risiko arah jangka panjang, dengan kontrak diperdagangkan di dekat simple 200-day kunci..."
        },
        sq: {
            title: "ide të komunitetit",
            by: "nga",
            metaTitle: "Aksionet e Meta Platforms (META) bien",
            metaDesc: "Aksionet e gjigantit teknologjik amerikan Meta Platforms (META) arritën lartë javën e kaluar, duke u ngjitur mbi 780$ pas publikimit të...",
            oilTitle: "USOIL bie për 3 ditë me radhë. Ç'pritet më tej?",
            oilDesc: "USOIL bie për 3 ditë me radhë. Ç'pritet më tej? Që nga postimi i fundit, USOIL tashmë ka rënë me 2.5%, aktualisht po rimëkëmbet nga 50$ në grafik...",
            capsTitle: "Small Caps: Rimëkëmbje apo rënie në 200DMA?",
            capsDesc: "Veprimi afatshkurtër i çmimeve në aksionet me kapital të vogël të SHBA mund të jetë udhëzues për vlerësimin e rreziqeve drejtuese afatgjata, me kontratën që tregtohet pranë mesatares së thjeshtë kryesore 200-ditore..."
        },
        bs: {
            title: "ideje zajednice",
            by: "od",
            metaTitle: "Dionice Meta Platforms (META) u padu",
            metaDesc: "Dionice američkog tehnološkog giganta Meta Platforms (META) dosegle su visoke vrijednosti prošle sedmice, popevši se iznad 780$ nakon izdavanja...",
            oilTitle: "USOIL pada već 3 dana zaredom. Šta je sljedeće?",
            oilDesc: "USOIL pada već 3 dana zaredom. Šta je sljedeće? Od posljednjeg posta USOIL je već pao za 2.5%, trenutno se oporavlja od 50$ na grafikonu...",
            capsTitle: "Male kompanije: Oporavak ili pad na 200DMA?",
            capsDesc: "Kratkoročno kretanje cijena dionica malih kompanija u SAD može biti korisno za procjenu dugoročnih rizika, s tim da se ugovor trguje blizu ključnog 200-dnevnog jednostavnog proseka..."
        },
        bg: {
            title: "идеи на общността",
            by: "от",
            metaTitle: "Акциите на Meta Platforms (META) спадат",
            metaDesc: "Акциите на американския технологичен гигант Meta Platforms (META) достигнаха високо миналата седмица, изкачвайки се над 780$ след издаването на...",
            oilTitle: "USOIL спада трети ден поред. Какво следва?",
            oilDesc: "USOIL спада трети ден поред. Какво следва? От последния пост USOIL вече е спаднал с 2.5%, в момента се възстановява от 50$ на графиката...",
            capsTitle: "Малки компании: Възстановяване или срив при 200DMA?",
            capsDesc: "Краткосрочните движения на цените на акциите на малки компании в САЩ могат да бъдат поучителни за оценка на дългосрочните рискове, като договорът се търгува близо до ключовата 200-дневна проста средна..."
        },
        hr: {
            title: "ideje zajednice",
            by: "od",
            metaTitle: "Dionice Meta Platforms (META) u padu",
            metaDesc: "Dionice američkog tehnološkog giganta Meta Platforms (META) dosegle su visoke vrijednosti prošli tjedan, popevši se iznad 780$ nakon izdavanja...",
            oilTitle: "USOIL pada već 3 dana zaredom. Što je sljedeće?",
            oilDesc: "USOIL pada već 3 dana zaredom. Što je sljedeće? Od posljednjeg posta USOIL je već pao za 2.5%, trenutno se oporavlja od 50$ na grafikonu...",
            capsTitle: "Male tvrtke: Oporavak ili pad na 200DMA?",
            capsDesc: "Kratkoročno kretanje cijena dionica malih tvrtki u SAD-u može biti korisno za procjenu dugoročnih rizika, pri čemu se ugovor trguje blizu ključnog 200-dnevnog jednostavnog prosjeka..."
        },
        xk: {
            title: "ide të komunitetit / идеје заједнице",
            by: "nga / од",
            metaTitle: "Aksionet Meta Platforms (META) bien / Акције Meta Platforms (META) падају",
            metaDesc: "Aksionet e gjigantit teknologjik amerikan Meta Platforms (META) arritën lartë javën e kaluar, duke u ngjitur mbi 780$ pas publikimit të... / Акције америчког технолошког гиганта Meta Platforms (META) достигле су високе вредности прошле недеље, попевши се изнад 780$ након издавања...",
            oilTitle: "USOIL bie për 3 ditë me radhë. Ç'pritet më tej? / USOIL пада већ 3 дана заредом. Шта је следеће?",
            oilDesc: "USOIL bie për 3 ditë me radhë. Ç'pritet më tej? Që nga postimi i fundit, USOIL tashmë ka rënë me 2.5%, aktualisht po rimëkëmbet nga 50$ në grafik... / USOIL пада већ 3 дана заредом. Шта је следеће? Од последњег поста USOIL је већ пао за 2.5%, тренутно се опоравља од 50$ на графикону...",
            capsTitle: "Small Caps: Rimëkëmbje apo rënie në 200DMA? / Малe компаније: Oпoрaвaк или пaд нa 200DMA?",
            capsDesc: "Veprimi afatshkurtër i çmimeve në aksionet me kapital të vogël të SHBA mund të jetë udhëzues për vlerësimin e rreziqeve drejtuese afatgjata, me kontratën që tregtohet pranë mesatares së thjeshtë kryesore 200-ditore... / Краткорочно кретање цена акција малих компанија у САД може бити корисно за процену дугорочних ризика, при чему се уговор тргује близу кључног 200-дневног једноставног просека..."
        },
        me: {
            title: "идеје заједнице",
            by: "од",
            metaTitle: "Акције Meta Platforms (META) у паду",
            metaDesc: "Акције америчког технолошког гиганта Meta Platforms (META) достигле су високе вредности прошле недеље, попевши се изнад 780$ након издавања...",
            oilTitle: "USOIL пада већ 3 дана заредом. Шта је следеће?",
            oilDesc: "USOIL пада већ 3 дана заредом. Шта је следеће? Од последњег поста USOIL је већ пао за 2.5%, тренутно се опоравља од 50$ на графикону...",
            capsTitle: "Малe компаније: Oпoрaвaк или пaд нa 200DMA?",
            capsDesc: "Краткорочно кретање цена акција малих компанија у САД може бити корисно за процену дугорочних ризика, при чему се уговор тргује близу кључног 200-дневног једноставног просека..."
        },
        mk: {
            title: "идеи на заедницата",
            by: "од",
            metaTitle: "Акциите на Meta Platforms (META) опаѓаат",
            metaDesc: "Акциите на американскиот технолошки џин Meta Platforms (META) достигнаа високо минатата недела, искачувајќи се над 780$ по издавањето на...",
            oilTitle: "USOIL опаѓа трет ден по ред. Што е следно?",
            oilDesc: "USOIL опаѓа трет ден по ред. Што е следно? Од последниот пост USOIL веќе падна за 2.5%, моментално се опоравува од 50$ на графиконот...",
            capsTitle: "Мали компании: Опоравување или пад на 200DMA?",
            capsDesc: "Краткорочното движење на цените на акциите на мали компании во САД може да биде инструктивно за проценување на долгорочните насочени ризици, со договорот што се тргува блиску до клучниот 200-дневен едноставен просек..."
        },
        ro: {
            title: "idei ale comunității",
            by: "de",
            metaTitle: "Acțiunile Meta Platforms (META) în scădere",
            metaDesc: "Acțiunile gigantului tehnologic american Meta Platforms (META) au atins valori ridicate săptămâna trecută, urcând peste 780$ după lansarea...",
            oilTitle: "USOIL scade de 3 zile la rând. Ce urmează?",
            oilDesc: "USOIL scade de 3 zile la rând. Ce urmează? De la ultimul post, USOIL a scăzut deja cu 2.5%, în prezent revenind de la 50$ pe grafic...",
            capsTitle: "Companii mici: Recuperare sau scădere la media de 200 de zile?",
            capsDesc: "Mișcările de preț pe termen scurt ale acțiunilor companiilor mici din SUA pot fi instructive pentru evaluarea riscurilor direcționale pe termen lung, contractul tranzacționându-se în apropierea mediei mobile simple de 200 de zile..."
        },
        sr: {
            title: "идеје заједнице",
            by: "од",
            metaTitle: "Акције Meta Platforms (META) у паду",
            metaDesc: "Акције америчког технолошког гиганта Meta Platforms (META) достигле су високе вредности прошле недеље, попевши се изнад 780$ након издавања...",
            oilTitle: "USOIL пада већ 3 дана заредом. Шта је следеће?",
            oilDesc: "USOIL пада већ 3 дана заредом. Шта је следеће? Од последњег поста USOIL је већ пао за 2.5%, тренутно се опоравља од 50$ на графикону...",
            capsTitle: "Малe компаније: Oпoрaвaк или пaд нa 200DMA?",
            capsDesc: "Краткорочно кретање цена акција малих компанија у САД може бити корисно за процену дугорочних ризика, при чему се уговор тргује близу кључног 200-дневног једноставног просека..."
        },
        sl: {
            title: "ideje skupnosti",
            by: "od",
            metaTitle: "Delnice Meta Platforms (META) v padu",
            metaDesc: "Delnice ameriškega tehnološkega velikana Meta Platforms (META) so dosegle visoke vrednosti prejšnji teden in se po izdaji povzpele nad 780$...",
            oilTitle: "USOIL pada že 3 dni zapored. Kaj je naslednje?",
            oilDesc: "USOIL pada že 3 dni zapored. Kaj je naslednje? Od zadnje objave je USOIL že padel za 2.5%, trenutno se okrepa od 50$ na grafikonu...",
            capsTitle: "Mala podjetja: Obnovitev ali padec pri 200DMA?",
            capsDesc: "Kratkoročno gibanje cen delnic malih podjetij v ZDA je lahko poučno za oceno dolgoročnih usmerjenih tveganj, pri čemer se pogodba trguje blizu ključnega 200-dnevnega preprostega povprečja..."
        },
        sk: {
            title: "nápady komunity",
            by: "od",
            metaTitle: "Akcie Meta Platforms (META) klesajú",
            metaDesc: "Akcie amerického technologického giganta Meta Platforms (META) dosiahli minulý týždeň vysoké hodnoty, vystúpili nad 780$ po vydaní...",
            oilTitle: "USOIL klesá už 3 dni po sebe. Čo bude ďalej?",
            oilDesc: "USOIL klesá už 3 dni po sebe. Čo bude ďalej? Od posledného príspevku USOIL už klesol o 2.5%, momentálne sa zotavuje z 50$ na grafe...",
            capsTitle: "Malé spoločnosti: Oživenie alebo pokles na 200DMA?",
            capsDesc: "Krátkodobé pohyby cien akcií malých spoločností v USA môžu byť poučné pre hodnotenie dlhodobých smerových rizík, pričom zmluva sa obchoduje v blízkosti kľúčového 200-dňového jednoduchého priemeru..."
        },
        md: {
            title: "idei ale comunității",
            by: "de",
            metaTitle: "Acțiunile Meta Platforms (META) în scădere",
            metaDesc: "Acțiunile gigantului tehnologic american Meta Platforms (META) au atins valori ridicate săptămâna trecută, urcând peste 780$ după lansarea...",
            oilTitle: "USOIL scade de 3 zile la rând. Ce urmează?",
            oilDesc: "USOIL scade de 3 zile la rând. Ce urmează? De la ultimul post, USOIL a scăzut deja cu 2.5%, în prezent revenind de la 50$ pe grafic...",
            capsTitle: "Companii mici: Recuperare sau scădere la media de 200 de zile?",
            capsDesc: "Mișcările de preț pe termen scurt ale acțiunilor companiilor mici din SUA pot fi instructive pentru evaluarea riscurilor direcționale pe termen lung, contractul tranzacționându-se în apropierea mediei mobile simple de 200 de zile..."
        },
        by: {
            title: "ідэі супольнасці",
            by: "ад",
            metaTitle: "Акцыі Meta Platforms (META) зніжаюцца",
            metaDesc: "Акцыі амерыканскага тэхналагічнага гіганта Meta Platforms (META) дасягнулі высокіх значэнняў на мінулым тыдні, падняўшыся вышэй за 780$ пасля выпуску...",
            oilTitle: "USOIL зніжаецца ўжо 3 дні запар. Што далей?",
            oilDesc: "USOIL зніжаецца ўжо 3 дні запар. Што далей? З апошняга паста USOIL ужо знізіўся на 2.5%, у цяперашні час аднаўляецца ад 50$ на графіку...",
            capsTitle: "Малыя кампаніі: Аднаўленне ці зніжэнне на 200DMA?",
            capsDesc: "Кароткатэрміновыя рухі коштаў акцый малых кампаній у ЗША могуць быць павучальнымі для ацэнкі доўгатэрміновых накіраваных рызыкаў, пры гэтым кантракт гандлюецца каля ключавога 200-дзённага простага сярэдняга..."
        }
    };
    return e[i] || e.en
}
  , LT = i => [{
    id: 1,
    image: DT,
    title: i.metaTitle,
    description: i.metaDesc,
    author: "FXOpen",
    date: "Aug 4",
    comments: 4,
    boosts: 32
}, {
    id: 2,
    image: IT,
    title: i.oilTitle,
    description: i.oilDesc,
    author: "ProfessorSingapore",
    date: "Aug 4",
    comments: 5,
    boosts: 23
}, {
    id: 3,
    image: MT,
    title: i.capsTitle,
    description: i.capsDesc,
    author: "FOREX.com",
    date: "Aug 4",
    comments: 1,
    boosts: 11
}]
  , OT = () => {
    const {i18n: i} = We()
      , e = i.language
      , r = VT(e)
      , a = N.useRef(null)
      , o = Ht(a, {
        once: !0,
        margin: "-100px"
    })
      , l = LT(r)
      , u = {
        hidden: {
            opacity: 0
        },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: .2
            }
        }
    }
      , d = {
        hidden: {
            opacity: 0,
            y: 50
        },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: .6,
                ease: "easeOut"
            }
        }
    };
    return x.jsx("section", {
        className: "py-4 sm:py-6 md:py-8 lg:py-12 px-2 sm:px-4 md:px-6 lg:px-8",
        children: x.jsxs("div", {
            className: "flex flex-col gap-4 sm:gap-6 md:gap-8 lg:gap-10 max-w-[1248px] w-full mx-auto",
            children: [x.jsxs(ee.div, {
                className: "flex items-center gap-2",
                initial: {
                    opacity: 0,
                    x: -50
                },
                animate: o ? {
                    opacity: 1,
                    x: 0
                } : {
                    opacity: 0,
                    x: -50
                },
                transition: {
                    duration: .6,
                    ease: "easeOut"
                },
                children: [x.jsx("a", {
                    href: "https://www.tradingview.com/ideas/",
                    className: "uppercase text-[#0D1013] font-bold text-[20px] xs:text-[24px] sm:text-[28px] md:text-[36px] lg:text-[48px] leading-[130%] hover:text-[#2862FF] transition-colors duration-300",
                    children: r.title
                }), x.jsx(wu, {})]
            }), x.jsx(ee.div, {
                ref: a,
                className: "w-full grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4 lg:gap-6",
                variants: u,
                initial: "hidden",
                animate: o ? "visible" : "hidden",
                children: l.map(p => x.jsxs(ee.div, {
                    className: "flex flex-col gap-2 sm:gap-3 group",
                    variants: d,
                    children: [x.jsxs("div", {
                        className: "flex flex-col gap-2 sm:gap-2.5",
                        children: [x.jsx("div", {
                            className: "overflow-hidden rounded-lg",
                            children: x.jsx("img", {
                                src: p.image,
                                alt: `${p.title} chart`,
                                className: "w-full h-auto object-cover group-hover:scale-105 transition-transform duration-300"
                            })
                        }), x.jsxs("div", {
                            className: "flex flex-col gap-1.5 sm:gap-2 px-1",
                            children: [x.jsx("h3", {
                                className: "text-[#0D1013] font-bold text-[14px] xs:text-[15px] sm:text-[16px] md:text-[17px] lg:text-[18px] leading-[130%] group-hover:text-[#2862FF] transition-colors duration-300 line-clamp-2",
                                children: p.title
                            }), x.jsx("p", {
                                className: "text-[#3B4046] text-[12px] xs:text-[13px] sm:text-[14px] md:text-[15px] lg:text-[16px] leading-[130%] line-clamp-3",
                                children: p.description
                            })]
                        })]
                    }), x.jsxs("div", {
                        className: "flex items-center justify-between px-1",
                        children: [x.jsxs("div", {
                            className: "flex flex-col gap-0.5 sm:gap-1",
                            children: [x.jsxs("span", {
                                className: "text-[#191C1F] text-[10px] xs:text-[11px] sm:text-[12px] md:text-[13px] lg:text-[14px] leading-[130%]",
                                children: [r.by, " ", p.author]
                            }), x.jsx("span", {
                                className: "text-[#5F656C] text-[10px] xs:text-[11px] sm:text-[12px] md:text-[13px] lg:text-[14px] leading-[130%]",
                                children: p.date
                            })]
                        }), x.jsxs("div", {
                            className: "flex gap-1.5 sm:gap-2",
                            children: [x.jsxs("div", {
                                className: "py-1 sm:py-1.5 px-1.5 sm:px-2 flex items-center gap-0.5 sm:gap-1",
                                children: [x.jsx(M0, {}), x.jsx("span", {
                                    className: "text-[#0D1013] text-[12px] xs:text-[13px] sm:text-[14px] md:text-[15px] lg:text-[16px] leading-[130%]",
                                    children: p.comments
                                })]
                            }), x.jsxs("div", {
                                className: "py-1 sm:py-1.5 px-1.5 sm:px-2 flex items-center gap-0.5 sm:gap-1 border border-[#D0D3D7] rounded-[5px]",
                                children: [x.jsx(Jw, {}), x.jsx("span", {
                                    className: "text-[#0D1013] text-[12px] xs:text-[13px] sm:text-[14px] md:text-[15px] lg:text-[16px] leading-[130%]",
                                    children: p.boosts
                                })]
                            })]
                        })]
                    })]
                }, p.id))
            })]
        })
    })
}
;
function NT() {
    return x.jsxs(fP, {
        children: [x.jsx(JS, {}), x.jsx(sT, {}), x.jsxs("div", {
            className: "bg-white rounded-t-[50px] px-4",
            children: [x.jsx(kP, {}), x.jsx(gT, {}), x.jsx(kT, {}), x.jsx(OT, {}), x.jsx(gS, {}), x.jsx(AT, {}), x.jsx(hS, {}), x.jsx(PT, {}), x.jsx(PP, {})]
        })]
    })
}
Ry.createRoot(document.getElementById("root")).render(x.jsx(N.StrictMode, {
    children: x.jsx(NT, {})
}));
